/* =====================================================
   AMK ZENTRALE — V4 PRELUDE SAFETY
   Blocks accidental boot ringtone before old modules can play it.
===================================================== */
(function(){
  "use strict";
  const RING_RE = /Ringtone_Sound_Effect|ringtone|call/i;
  window.__AMK_ALLOW_RING = false;
  window.__AMK_RING_GUARD_ACTIVE = true;
  const OriginalAudio = window.Audio;
  if (OriginalAudio && !window.__AMK_AUDIO_GUARD_INSTALLED) {
    window.__AMK_AUDIO_GUARD_INSTALLED = true;
    window.Audio = function(src){
      const audio = new OriginalAudio(src);
      audio.__amkSrc = src || "";
      const originalPlay = audio.play.bind(audio);
      audio.play = function(){
        if (RING_RE.test(String(audio.__amkSrc || audio.currentSrc || audio.src || "")) && window.__AMK_ALLOW_RING !== true) {
          return Promise.resolve();
        }
        return originalPlay();
      };
      return audio;
    };
    window.Audio.prototype = OriginalAudio.prototype;
  }
})();

/* =====================================================
   AMK ZENTRALE — CHART-THEME "DARK LUXE"
   Setzt globale Chart.js-Defaults (Achsen, Gitter, Legende,
   Tooltip) auf das dunkle Gold-Theme. Wird einmalig gesetzt,
   sobald Chart.js verfuegbar ist. Nur Optik, keine Logik.
===================================================== */
(function(){
  "use strict";
  function applyChartTheme(){
    if (!window.Chart) return false;
    var C = window.Chart;
    try {
      C.defaults.color = "#948f81";
      C.defaults.borderColor = "rgba(230,184,92,.10)";
      C.defaults.font = C.defaults.font || {};
      C.defaults.font.family = "Inter, system-ui, -apple-system, 'Segoe UI', sans-serif";
      C.defaults.font.weight = "600";
      if (C.defaults.plugins) {
        if (C.defaults.plugins.legend && C.defaults.plugins.legend.labels) {
          C.defaults.plugins.legend.labels.color = "#d3cdbe";
        }
        if (C.defaults.plugins.tooltip) {
          var tt = C.defaults.plugins.tooltip;
          tt.backgroundColor = "rgba(20,20,26,.96)";
          tt.titleColor = "#f7df97";
          tt.bodyColor = "#f4f1ea";
          tt.borderColor = "rgba(230,184,92,.28)";
          tt.borderWidth = 1;
          tt.padding = 10;
          tt.cornerRadius = 10;
        }
      }
    } catch (e) {}
    return true;
  }
  if (!applyChartTheme()) {
    var tries = 0;
    var iv = setInterval(function(){
      tries++;
      if (applyChartTheme() || tries > 60) clearInterval(iv);
    }, 100);
  }
})();

/* =====================================================
   AMK ZENTRALE — APP-ICON IN DEN <HEAD> ERZWINGEN
   Wichtig: Die Section rendert im <body>. iOS liest das
   App-Icon (apple-touch-icon) aber NUR aus dem <head>.
   Darum hier per JS sicherstellen, dass die Icon-Links
   wirklich im <head> stehen -> sonst zeigt iOS das "Z".
===================================================== */
(function(){
  "use strict";
  if (window.__AMK_ICONS_IN_HEAD) return;
  window.__AMK_ICONS_IN_HEAD = true;

  var FILES = "https://cdn.shopify.com/s/files/1/0965/9813/1028/files/";
  var head = document.head || document.getElementsByTagName("head")[0];
  if (!head) return;

  // Cache-Bust, damit iOS/Safari das neue Icon wirklich frisch zieht
  var V = "?v=amk3";

  var links = [
    { rel: "apple-touch-icon",             sizes: "180x180", href: FILES + "amk-icon-180.png" + V },
    { rel: "apple-touch-icon",             sizes: "192x192", href: FILES + "amk-icon-192.png" + V },
    { rel: "apple-touch-icon",             sizes: "512x512", href: FILES + "amk-icon-512.png" + V },
    { rel: "apple-touch-icon-precomposed", sizes: "180x180", href: FILES + "amk-icon-180.png" + V },
    { rel: "icon", type: "image/png",      sizes: "192x192", href: FILES + "amk-icon-192.png" + V },
    { rel: "shortcut icon",                                  href: FILES + "amk-icon-192.png" + V }
  ];

  // Vorhandene (auch falsch im <body> platzierte) Icon-Links entfernen
  try {
    document.querySelectorAll(
      'link[rel="apple-touch-icon"],link[rel="apple-touch-icon-precomposed"],' +
      'link[rel="icon"],link[rel="shortcut icon"]'
    ).forEach(function(n){ n.parentNode && n.parentNode.removeChild(n); });
  } catch (e) {}

  // Frisch in den <head> setzen
  links.forEach(function(it){
    var l = document.createElement("link");
    l.setAttribute("rel", it.rel);
    if (it.sizes) l.setAttribute("sizes", it.sizes);
    if (it.type)  l.setAttribute("type", it.type);
    l.setAttribute("href", it.href);
    head.appendChild(l);
  });

  // Manifest ebenfalls in den <head> heben, falls es im <body> liegt
  try {
    var mf = document.querySelector('link[rel="manifest"]');
    if (mf && mf.parentNode !== head) head.appendChild(mf);
  } catch (e) {}

  // iOS-Web-App Metas in den <head> sicherstellen
  var metas = [
    { name: "apple-mobile-web-app-capable", content: "yes" },
    { name: "apple-mobile-web-app-title", content: "AMK Zentrale" },
    { name: "apple-mobile-web-app-status-bar-style", content: "black-translucent" },
    { name: "mobile-web-app-capable", content: "yes" }
  ];
  metas.forEach(function(m){
    var existing = document.querySelector('meta[name="' + m.name + '"]');
    if (existing && existing.parentNode !== head) { head.appendChild(existing); return; }
    if (!existing) {
      var el = document.createElement("meta");
      el.setAttribute("name", m.name);
      el.setAttribute("content", m.content);
      head.appendChild(el);
    }
  });
})();

window.AMK_SW_REG = null;

window.AMK_IS_LOCAL = /^(localhost|127\.|0\.0\.0\.0|\[?::1)/.test(location.hostname);
window.AMK_SW_PATH = (function () {
  if (window.AMK_IS_LOCAL) return { url: "assets/amk-sw.js", scope: "/assets/" };
  // 1) Manuelle Übersteuerung möglich: <meta name="amk-sw-url" content="/.../amk-sw.js">
  try {
    var meta = document.querySelector('meta[name="amk-sw-url"]');
    if (meta && meta.content) {
      var u = new URL(meta.content, location.href);
      if (u.origin === location.origin) {
        return { url: u.pathname, scope: u.pathname.replace(/[^/]+$/, "") };
      }
    }
  } catch (e) {}
  // 2) Aus dem geladenen amk-zentrale.js ableiten (korrekte Theme-Version automatisch)
  try {
    var s = document.querySelector('script[src*="amk-zentrale.js"]');
    if (s && s.src) {
      var su = new URL(s.src, location.href);
      if (su.origin === location.origin) {
        var dir = su.pathname.replace(/[^/]+$/, ""); // .../assets/
        return { url: dir + "amk-sw.js", scope: dir };
      }
    }
  } catch (e) {}
  // 3) Fallback
  return { url: "/cdn/shop/t/7/assets/amk-sw.js", scope: "/cdn/shop/t/7/assets/" };
})();

if ("serviceWorker" in navigator && !window.AMK_IS_LOCAL) {
  // Reload genau EINMAL ausloesen, wenn ein neuer SW die Kontrolle uebernimmt
  let amkReloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (amkReloading) return;
    amkReloading = true;
    location.reload();
  });

  // Neuen SW sofort aktivieren lassen, sobald er installiert ist
  function amkActivateUpdate(reg) {
    const sw = reg.waiting || reg.installing;
    if (sw) sw.postMessage("AMK_SKIP_WAITING");
  }

  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register(
        window.AMK_SW_PATH.url,
        { scope: window.AMK_SW_PATH.scope }
      );
      window.AMK_SW_REG = reg;
      console.log("AMK SW REGISTERED", reg);

      // Wenn schon ein Update wartet -> sofort uebernehmen
      if (reg.waiting && navigator.serviceWorker.controller) amkActivateUpdate(reg);

      // Neues Update gefunden -> aktivieren, sobald fertig installiert
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            amkActivateUpdate(reg);
          }
        });
      });

      // Regelmaessig + bei App-Fokus auf Updates pruefen (kein Neuinstallieren noetig)
      const checkUpdate = () => reg.update().catch(() => {});
      setInterval(checkUpdate, 60 * 1000);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") checkUpdate();
      });
    } catch (error) {
      console.warn("AMK SW ERROR", error);
    }
  });
}

/* =====================================================
   AMK ZENTRALE — FINAL JS
   PART 1/4 — CORE / AUTH / NAVIGATION
===================================================== */

(function () {
  "use strict";

  const AMKZ = {
    supabase: null,

    state: {
      member: null,
      permissions: {},
      currentView: "dashboard",
      selectedDate: null,
      rangeFrom: null,
      rangeTo: null,

      partners: [],
      casinos: [],
      deals: [],
      team: [],
      entries: [],
      invoices: [],
      contracts: [],
      expenses: [],
      calendarEvents: [],
      calendarInvites: {},
      myInvites: [],
      chatUsers: [],
      chatRecency: new Map(),

      currentChatUserId: null,
      currentConversationId: null,

      calendarCursor: new Date(),
      calendarSelectedDate: null,

      charts: {},
      timers: {},
      subscriptions: [],
      presence: new Map(),

      booted: false,
      realtimeStarted: false,
    },
  };

  window.AMKZ = AMKZ;

  /* =====================================================
     HELPERS
  ===================================================== */

  const $ = (selector, parent = document) => parent.querySelector(selector);
  const $$ = (selector, parent = document) =>
    Array.from(parent.querySelectorAll(selector));
  const byId = (id) => document.getElementById(id);

  function escapeHtml(value) {
    return String(value ?? "").replace(/[&<>"']/g, (char) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    }[char]));
  }

  function setText(el, value) {
    if (el) el.textContent = value ?? "";
  }

  function setHTML(el, value) {
    if (el) el.innerHTML = value ?? "";
  }

  function value(id) {
    return byId(id)?.value || "";
  }

  function today() {
    return localDateKey(new Date());
  }

  // LOKALES Datum als YYYY-MM-DD (NICHT toISOString -> sonst Verschiebung um einen Tag in UTC+x)
  function localDateKey(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  }
  function toDateKey(date) {
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d)) return String(date).slice(0, 10);
    return localDateKey(d);
  }

  function money(amount) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(Number(amount || 0));
  }

  function formatDate(dateValue) {
    if (!dateValue) return "—";

    return new Date(dateValue).toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  function formatTime(dateValue) {
    if (!dateValue) return "";

    return new Date(dateValue).toLocaleTimeString("de-DE", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  function debounce(key, fn, delay = 350) {
    clearTimeout(AMKZ.state.timers[key]);
    AMKZ.state.timers[key] = setTimeout(fn, delay);
  }

  function safeNumber(input) {
    const number = Number(input || 0);
    return Number.isFinite(number) ? number : 0;
  }

  function isUuid(input) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
      String(input || "")
    );
  }

  AMKZ.utils = {
    $,
    $$,
    byId,
    escapeHtml,
    setText,
    setHTML,
    value,
    today,
    toDateKey,
    money,
    formatDate,
    formatTime,
    debounce,
    safeNumber,
    isUuid,
  };

  /* =====================================================
     VIEW CONFIG
  ===================================================== */

  const VIEW_CONFIG = {
    dashboard: {
      title: "Dashboard",
      subtitle: "Übersicht und Echtzeitdaten",
      permission: "dashboard",
    },
    ftdbilanz: {
      title: "FTD-Bilanz",
      subtitle: "FTDs, ReDepos und Depo-Volumen je Monat — gegen den Deal und gegen das, was wirklich bezahlt wurde",
      permission: "ftdbilanz",
    },
    daily: {
      title: "Tagesanalyse",
      subtitle: "Soll/Ist, Deal-Gewinn und Tageswerte",
      permission: "daily",
    },
    entries: {
      title: "Einträge",
      subtitle: "FTDs, ReDepos, Ausgaben und Einnahmen",
      permission: "entries",
    },
    connect: {
      title: "Connect",
      subtitle: "Interner Chat und Echtzeit-Kommunikation",
      permission: "connect",
    },
    calendar: {
      title: "Kalender",
      subtitle: "Wochenplan, Specials und Ausflüge",
      permission: "calendar",
    },
    partners: {
      title: "Partner & Casinos",
      subtitle: "Je Partnergruppe ihre Casinos und Deals — antippen zum Bearbeiten",
      permission: "partners",
    },
    finance: {
      title: "Finanzen",
      subtitle: "Finanzübersicht, Rechnungen, Verträge und Ausgänge",
      permission: "finance",
    },
    streaming: {
      title: "Streaming",
      subtitle: "Streamingplan, Schichten, Openings & Konten",
      permission: "streaming",
    },
    team: {
      title: "Team",
      subtitle: "Mitarbeiter, Rollen und Freigaben",
      permission: "team",
    },
    dashboards: {
      title: "Affiliate-Dashboards",
      subtitle: "Alle Partnerprogramm-Zugänge auf einen Blick — online oben, nicht online unten, Login direkt hier drin",
      permission: "dashboards",
    },
    giveaway: {
      title: "Giveaway",
      subtitle: "Giveaway-Konten und alle Einzahlungen (300K-Altbestand liegt im Archiv)",
      permission: "giveaway",
    },
    metaspins: {
      title: "Meta Spins Auslosung",
      subtitle: "Neue Ziehung nur mit geprüften MetaSpins-Spielern — Teilnehmer, Tickets, Live-Ziehung und OBS",
      permission: "giveaway",
    },
    halloween: {
      title: "Halloween-Giveaways",
      subtitle: "MetaSpins & Royal-Giveaway — Casinos, Preise, Tickets und Live-Ziehung",
      permission: "giveaway",
    },
    postfach: {
      title: "Support-Postfach",
      subtitle: "Mails an support@ mit Ticketnummer — antworten per Mail, Kunden sehen den Status online",
      permission: "postfach",
    },
    support: {
      title: "Anfragen",
      subtitle: "Live-Chat mit Spielern – nach Land aufgeteilt, mit Echtzeit-Übersetzer für Tschechien",
      permission: "support",
    },
    webseiten: {
      title: "Webseiten",
      subtitle: "Hauptfront und 300K — Casinos anlegen, Reihenfolge, Logos, online/offline",
      permission: "webseiten",
    },
  };

  AMKZ.views = VIEW_CONFIG;

  /* =====================================================
     SUPABASE INIT / API
  ===================================================== */

  function initSupabase() {
    const root = byId("amkzApp");

    if (!root) {
      throw new Error("AMK Root Container #amkzApp nicht gefunden.");
    }

    const url = root.dataset.supabaseUrl;
    const key = root.dataset.supabaseKey;

    if (!url || !key || key === "DEIN_SUPABASE_ANON_KEY_HIER") {
      throw new Error("Supabase URL oder Anon Key fehlt im HTML bei #amkzApp.");
    }

    if (!window.supabase?.createClient) {
      throw new Error("Supabase CDN wurde nicht geladen.");
    }

    AMKZ.supabase = window.supabase.createClient(url, key, {
      realtime: {
        params: {
          eventsPerSecond: 10,
        },
      },
    });
  }

  async function rpc(name, params = {}) {
    if (!AMKZ.supabase) {
      throw new Error("Supabase ist nicht initialisiert.");
    }

    const { data, error } = await AMKZ.supabase.rpc(name, params);

    if (error) {
      console.error("AMK RPC Fehler:", name, error);
      throw error;
    }

    return data;
  }

  /* ---- Sofort-Schutz (supabase-sofortschutz.sql, 28.10.2026) ----
     Gehalt, Zahlungsdaten und Passwörter sind für den öffentlichen anon-Key
     gesperrt. Darum: nie select("*") auf team_members, affiliate_dashboards,
     streaming_accounts, casinos — sondern AMKZ.spalten(tabelle). Die
     Datenbank sagt, welche Spalten offen sind. Ist das SQL noch nicht
     eingespielt, gibt es die Funktion nicht und es bleibt bei "*".
     Die geheimen Felder holt AMKZ.geheim() über Funktionen, die Sitzung und
     Recht prüfen, und mischt sie per id in die Zeilen. */
  const SPALTEN = {};
  AMKZ.spalten = async function (tabelle) {
    const c = SPALTEN[tabelle];
    // Liste 10 Min. merken; fehlt die Funktion noch, "*" nur 1 Min. (danach neu fragen)
    if (c && Date.now() - c.at < (c.liste === "*" ? 60 : 600) * 1000) return c.liste;
    let liste = "*";
    try {
      const { data, error } = await AMKZ.supabase.rpc("amk_offene_spalten", { p_tabelle: tabelle });
      if (!error && typeof data === "string" && data) liste = data;
    } catch (_) {}
    SPALTEN[tabelle] = { liste, at: Date.now() };
    return liste;
  };

  // name = amk_team_privat | amk_dashboards_geheim | amk_streaming_geheim
  // Ergebnis: Map id -> Zeile, oder null (SQL fehlt / keine Sitzung / Fehler)
  AMKZ.geheim = async function (name) {
    const session = AMKZ.state?.member?.session;
    if (!session || !AMKZ.supabase) return null;
    try {
      const { data, error } = await AMKZ.supabase.rpc(name, { p_session: session });
      if (error || !Array.isArray(data)) return null;
      return new Map(data.map((r) => [String(r.id), r]));
    } catch (_) { return null; }
  };

  // Geheime Felder in geladene Zeilen mischen (ohne die Zeilen zu ersetzen)
  AMKZ.mitGeheim = async function (rows, name) {
    if (!Array.isArray(rows) || !rows.length) return rows;
    const map = await AMKZ.geheim(name);
    if (!map) return rows;
    rows.forEach((r) => {
      const g = map.get(String(r.id));
      if (g) Object.keys(g).forEach((k) => { if (k !== "id") r[k] = g[k]; });
    });
    return rows;
  };

  // Was nie im Browser liegen soll (auch nicht im Sitzungsspeicher)
  AMKZ.ohneGeheim = function (m) {
    if (!m || typeof m !== "object") return m;
    const k = Object.assign({}, m);
    delete k.password; delete k.password_hint;
    return k;
  };

  async function selectRows(table, buildQuery) {
    if (!AMKZ.supabase) {
      throw new Error("Supabase ist nicht initialisiert.");
    }

    const query = buildQuery(AMKZ.supabase.from(table));
    const { data, error } = await query;

    if (error) {
      console.error("AMK Select Fehler:", table, error);
      throw error;
    }

    return data || [];
  }

  AMKZ.api = {
    rpc,
    selectRows,
  };

  /* =====================================================
     TOAST
  ===================================================== */

  function toast(title, message = "", type = "success") {
    const box = byId("amkzToastContainer");

    if (!box) {
      console[type === "error" ? "error" : "log"](title, message);
      return;
    }

    const node = document.createElement("div");
    node.className = `amkz-toast ${type}`;
    node.innerHTML = `
      <strong>${escapeHtml(title)}</strong>
      ${message ? `<p>${escapeHtml(message)}</p>` : ""}
    `;

    box.appendChild(node);

    setTimeout(() => {
      node.style.opacity = "0";
      node.style.transform = "translateX(22px)";
      setTimeout(() => node.remove(), 240);
    }, 4200);
  }

  AMKZ.toast = toast;

  /* =====================================================
     MODAL
  ===================================================== */

  function openModal(content) {
    const overlay = byId("amkzModalOverlay");
    if (!overlay) return;

    overlay.innerHTML = content;
    overlay.classList.add("active");

    $$("[data-amkz-close-modal]", overlay).forEach((button) => {
      button.addEventListener("click", closeModal);
    });

    overlay.addEventListener(
      "click",
      (event) => {
        if (event.target === overlay) closeModal();
      },
      { once: true }
    );
  }

  function closeModal() {
    const overlay = byId("amkzModalOverlay");
    if (!overlay) return;

    overlay.classList.remove("active");
    overlay.innerHTML = "";
  }

  AMKZ.modal = {
    open: openModal,
    close: closeModal,
  };

  /* Rechte, Rolle, Freigabe, Passwort, Anlegen, Entfernen: nur über die Edge Function `team`
     (Sitzung + „Team verwalten“). Direkt in team_members schreiben darf der Browser das seit
     26.10.2026 nicht mehr — siehe supabase-team-rechte-absichern.sql. */
  AMKZ.teamApi = async function teamApi(action, daten) {
    const root = byId("amkzApp");
    const url = String(root?.dataset?.supabaseUrl || "https://cbwxgikndyyzdslmfpmo.supabase.co").replace(/\/$/, "") + "/functions/v1/team";
    const anon = root?.dataset?.supabaseKey || "";
    let res;
    try {
      res = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Authorization: "Bearer " + anon, apikey: anon, "x-amk-sitzung": (AMKZ.state.member && AMKZ.state.member.session) || "" },
        body: JSON.stringify(Object.assign({ action }, daten || {})) });
    } catch (_) { throw new Error("Keine Verbindung zum Server. Bitte nochmal versuchen."); }
    const j = await res.json().catch(() => ({}));
    if (!j.ok) throw new Error(j.text || "Das hat nicht geklappt.");
    return j;
  };

  /* =====================================================
     PERMISSIONS
  ===================================================== */

  function buildPermissions(member) {
    const role = String(member?.role || "").toLowerCase();

    // Neu registrierte, NICHT freigegebene Mitarbeiter: keinerlei Rechte -> leeres Portal,
    // bis ein Admin sie im Team-Bereich freigibt (is_approved=true).
    if (member && member.is_approved === false) {
      return {
        isAdmin: false, __pending: true,
        dashboard: false, daily: false, entries: false, connect: false, calendar: false,
        streaming: false, manageStreaming: false, bonushunt: false, manageBonushunt: false,
        casinos: false, partners: false, finance: false, team: false,
        affiliates: false, giveaway: false, seeProfit: false, ftdbilanz: false, postfach: false,
      };
    }

    const isAdmin = [
      "admin",
      "owner",
      "admin_owner",
      "ceo",
      "management",
      "manager",
    ].includes(role);

    return {
      isAdmin,

      dashboard: member.can_view_dashboard !== false || isAdmin,
      daily:
        member.can_view_finance === true ||
        member.can_view_profit === true ||
        isAdmin,
      entries: member.can_view_entries !== false || isAdmin,
      connect: member.can_view_connect !== false || isAdmin,
      calendar: member.can_view_calendar !== false || isAdmin,
      streaming: member.can_view_streaming !== false || isAdmin,
      manageStreaming: member.can_manage_streaming === true || isAdmin,

      bonushunt: member.can_view_bonushunt !== false || isAdmin,
      // Verwaltung an die View gekoppelt: wer Bonushunt SEHEN darf, darf auch
      // verwalten (Streamer-Tool). Die DB-Spalte can_manage_bonushunt ist bei
      // allen default=false und würde sonst jeden blocken -> bewusst ignoriert.
      manageBonushunt: member.can_view_bonushunt !== false || isAdmin,

      casinos: member.can_view_casinos === true || isAdmin,
      // Casino-Hub, Webseiten und Spiele hingen bisher am selben Recht wie
      // "Casinos" — einzeln vergeben ging also nicht. Jetzt eigene Rechte.
      // Fehlt die Spalte in der Datenbank noch (supabase-rechte-einzeln.sql
      // nicht eingespielt), gilt weiterhin das Casino-Recht: niemand verliert
      // dadurch einen Zugang, den er heute hat.
      casinohub: (typeof member.can_view_casinohub === "boolean"
        ? member.can_view_casinohub : member.can_view_casinos === true) || isAdmin,
      webseiten: (typeof member.can_view_webseiten === "boolean"
        ? member.can_view_webseiten : member.can_view_casinos === true) || isAdmin,
      // Partner und Casinos sind seit 22.10.2026 ein Bereich — eins der beiden Rechte reicht.
      partners: member.can_view_partners === true || member.can_view_casinos === true || isAdmin,
      finance: member.can_view_finance === true || isAdmin,
      team: member.can_manage_team === true || isAdmin,
      // FTD-Bilanz: Depo-Volumen, Deal-Werte und erhaltene Zahlungen = Finanzdaten.
      ftdbilanz: member.can_view_finance === true || member.can_view_profit === true || isAdmin,
      // Affiliate-Dashboards: Auflistung, Zugänge und der eingebettete Browser.
      // Recht heißt weiterhin can_view_affiliates — die Spalte gab es schon.
      dashboards: member.can_view_affiliates === true || isAdmin,
      // Giveaway: eigenes Recht ODER Team-Verwalter/Finanz (= Chef-Ebene) ODER Admin.
      // So sieht der Owner es sofort, normale Mitarbeiter (Teilnehmer-Mails!) nicht.
      giveaway: member.can_view_giveaway === true || member.can_manage_team === true || member.can_view_finance === true || isAdmin,
      // Anfragen/Support: pro Land freigebbar. supportCountries = welche Länder der
      // Mitarbeiter sehen/beantworten darf (Admin = alle). Sichtbar wenn irgendein Land.
      support: member.can_view_support === true || member.can_support_cz === true || member.can_support_de === true || isAdmin,
      // Support-Postfach (support@ per Mail, Tickets): eigenes Recht, Admins immer
      postfach: member.can_view_postfach === true || isAdmin,
      supportCountries: isAdmin
        ? ["CZ", "DE"]
        : [member.can_support_cz === true ? "CZ" : null, member.can_support_de === true ? "DE" : null].filter(Boolean),

      seeProfit:
        member.can_view_finance === true ||
        member.can_view_profit === true ||
        isAdmin,
    };
  }

  function applyPermissionClasses() {
    document.body.classList.toggle(
      "amkz-can-see-profit",
      AMKZ.state.permissions?.seeProfit === true
    );

    document.body.classList.toggle(
      "amkz-is-admin",
      AMKZ.state.permissions?.isAdmin === true
    );
  }

  function applyPermissionsToNav() {
    $$(".amkz-nav-item").forEach((item) => {
      const view = item.dataset.view;
      const config = VIEW_CONFIG[view];

      if (!config) return;

      const allowed = AMKZ.state.permissions[config.permission] === true;
      item.style.display = allowed ? "flex" : "none";
    });
    // Gruppen der Seitenleiste messen ihre Höhe nur beim Start — nach einer Rechteänderung nachmessen,
    // sonst bleibt ein neu eingeblendeter Punkt abgeschnitten (overflow hidden).
    if (window.AMKZ_NAV_GRUPPEN && typeof window.AMKZ_NAV_GRUPPEN.hoehen === "function") { try { window.AMKZ_NAV_GRUPPEN.hoehen(); } catch (_) {} }
  }

  function firstAllowedView() {
    return (
      Object.keys(VIEW_CONFIG).find((view) => {
        const config = VIEW_CONFIG[view];
        return AMKZ.state.permissions[config.permission] === true;
      }) || "dashboard"
    );
  }

  /* ---- Rechte LIVE aktualisieren ----
     Admin entzieht einem Mitarbeiter z. B. das Dashboard -> der Mitarbeiter
     verliert den Zugriff automatisch (max. 20s), ohne neu einzuloggen. */
  async function refreshPermissions() {
    const member = AMKZ.state.member;
    if (!member?.id || !AMKZ.supabase) return;

    try {
      const { data, error } = await AMKZ.supabase
        .from("team_members")
        .select(await AMKZ.spalten("team_members"))
        .eq("id", member.id)
        .single();

      if (error || !data) return;

      // Konto deaktiviert -> rauswerfen
      if (data.is_active === false) {
        logout();
        return;
      }

      /* Der Sitzungstoken steht NICHT in team_members — er kommt beim Anmelden
         aus amk_sessions. Ohne diese Zeile wuerde er hier alle 20 Sekunden
         ueberschrieben, und alles, was ihn braucht (Gewinnabholung,
         Tagesplaner), meldete „keine Sitzung", obwohl man angemeldet ist. */
      let token = member.session || null;
      if (!token) {
        try {
          const alt = JSON.parse(localStorage.getItem("amkz_team_session") || "null");
          if (alt && alt.session) token = alt.session;
        } catch (_) {}
      }
      const frisch = AMKZ.ohneGeheim(token ? Object.assign({}, data, { session: token }) : data);

      AMKZ.state.member = frisch;
      localStorage.setItem("amkz_team_session", JSON.stringify(frisch));
      AMKZ.state.permissions = buildPermissions(data);

      applyPermissionClasses();
      applyPermissionsToNav();

      // Aktuelle Ansicht nicht mehr erlaubt -> auf erlaubte Ansicht umleiten
      const cur = AMKZ.state.currentView;
      const cfg = VIEW_CONFIG[cur];
      if (cfg && AMKZ.state.permissions[cfg.permission] !== true) {
        switchView(firstAllowedView());
        toast("Berechtigung geändert", "Dein Zugriff wurde angepasst.");
      }
    } catch (e) {
      console.warn("refreshPermissions failed", e);
    }
  }
  AMKZ.refreshPermissions = refreshPermissions;

  /* =====================================================
     AUTH
  ===================================================== */

  async function login(email, password) {
    const errorBox = byId("amkzLoginError");
    const button = byId("amkzLoginButton");

    setText(errorBox, "");

    if (!email || !password) {
      setText(errorBox, "E-Mail und Passwort erforderlich.");
      return;
    }

    if (button) {
      button.disabled = true;
      button.textContent = "Einloggen...";
    }

    try {
      const result = await rpc("amk_team_login", {
        p_email: email.trim().toLowerCase(),
        p_password: password.trim(),
      });

      if (!result?.success || !result?.member) {
        throw new Error(result?.reason || "LOGIN_FAILED");
      }

      // Sitzungs-Token (amk_sessions) mit ablegen — Tagesplaner und weitere Functions pruefen damit die Anmeldung.
      AMKZ.state.member = AMKZ.ohneGeheim(Object.assign({}, result.member, result.session ? { session: result.session } : {}));
      AMKZ.state.permissions = buildPermissions(result.member);

      localStorage.setItem("amkz_team_session", JSON.stringify(AMKZ.state.member));

      renderLoggedIn();
      toast("Willkommen", "AMK Zentrale ist verbunden.");
    } catch (error) {
      console.error("LOGIN ERROR", error);
      setText(errorBox, "Login fehlgeschlagen: " + (error.message || "Unbekannter Fehler"));
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = "Einloggen";
      }
    }
  }

  function restoreSession() {
    const saved = localStorage.getItem("amkz_team_session");
    if (!saved) return false;

    try {
      // ältere Sitzungen trugen noch password_hint mit — beim Laden verwerfen
      const member = AMKZ.ohneGeheim(JSON.parse(saved));

      if (!member?.id) {
        localStorage.removeItem("amkz_team_session");
        return false;
      }

      AMKZ.state.member = member;
      AMKZ.state.permissions = buildPermissions(member);

      return true;
    } catch (error) {
      console.warn("SESSION RESTORE ERROR", error);
      localStorage.removeItem("amkz_team_session");
      return false;
    }
  }

  function logout() {
    localStorage.removeItem("amkz_team_session");

    AMKZ.state.subscriptions.forEach((channel) => {
      try {
        AMKZ.supabase?.removeChannel(channel);
      } catch (_) {}
    });

    AMKZ.state.subscriptions = [];

    location.reload();
  }

  function renderLoggedOut() {
    byId("amkzBootLoader")?.classList.add("is-hidden");
    byId("amkzLoginScreen")?.classList.remove("is-hidden");
    byId("amkzMainApp")?.classList.add("is-hidden");
  }

  function renderLoggedIn() {
    const member = AMKZ.state.member;
    if (!member) return renderLoggedOut();

    byId("amkzBootLoader")?.classList.add("is-hidden");
    byId("amkzLoginScreen")?.classList.add("is-hidden");
    byId("amkzMainApp")?.classList.remove("is-hidden");

    setText(byId("amkzUserName"), member.name || member.email || "Benutzer");
    setText(byId("amkzUserRole"), member.role || "Mitarbeiter");
    // Avatar: Profilbild wenn vorhanden, sonst Initiale
    const avaEl = byId("amkzUserAvatar");
    if (avaEl) {
      if (member.avatar_url) {
        avaEl.textContent = "";
        avaEl.style.setProperty("background-image", `url("${member.avatar_url}")`, "important");
        avaEl.classList.add("amkz-has-photo");
      } else {
        avaEl.style.backgroundImage = "";
        avaEl.classList.remove("amkz-has-photo");
        avaEl.textContent = String(member.name || member.email || "A").charAt(0).toUpperCase();
      }
    }
    // Verifizierungs-Badge: unten rechts AM Avatar-Bild (wie Instagram-Kamera-Position)
    const applyUserVerify = () => {
      const verified = AMKZ.isVerified && AMKZ.isVerified(member);
      const av = byId("amkzUserAvatar"); if (!av) return;
      let vb = av.querySelector(".amkz-user-verify");
      if (verified) { if (!vb) { vb = document.createElement("span"); vb.className = "amkz-user-verify"; av.appendChild(vb); } vb.innerHTML = AMKZ.verifyBadge; }
      else if (vb) vb.remove();
    };
    try { AMKZ.ensureVerifyStyle?.(); } catch (_) {}
    applyUserVerify();
    AMKZ.loadVerified?.().then(applyUserVerify).catch(() => {});
    // Robust: Avatar-Updates (Avatar-Sync setzt textContent) löschen das Badge -> automatisch wieder anhängen
    const av0 = byId("amkzUserAvatar");
    if (av0 && !av0.dataset.verifyObs) {
      av0.dataset.verifyObs = "1";
      new MutationObserver(() => { if (AMKZ.isVerified && AMKZ.isVerified(AMKZ.state.member) && !av0.querySelector(".amkz-user-verify")) applyUserVerify(); }).observe(av0, { childList: true });
    }

    const dateInput = byId("amkzGlobalDate");

    if (dateInput && !dateInput.value) {
      dateInput.value = today();
    }

    AMKZ.state.selectedDate = dateInput?.value || today();
    AMKZ.state.calendarSelectedDate = AMKZ.state.selectedDate;

    applyPermissionClasses();
    applyPermissionsToNav();

    // Nicht freigegeben -> Wartescreen statt View
    if (AMKZ.state.permissions.__pending) {
      const content = byId("amkzContent") || document.querySelector(".amkz-content");
      if (content) {
        content.innerHTML = `<div class="amkz-pending-screen"><div class="amkz-pending-card">
          <div class="amkz-pending-ic">⏳</div>
          <h2>Konto wartet auf Freigabe</h2>
          <p>Hey ${escapeHtml(member.name || "")}, dein Zugang wurde erstellt und muss noch von einem Admin freigegeben werden. Sobald das erledigt ist, erscheint dein Portal hier automatisch.</p>
          <small>Diese Seite aktualisiert sich selbst.</small>
        </div></div>`;
      }
      document.body.classList.add("amkz-pending-mode");
      return;
    }
    document.body.classList.remove("amkz-pending-mode");

    const targetView = AMKZ.state.permissions.dashboard
      ? "dashboard"
      : firstAllowedView();

    switchView(targetView);

    if (typeof AMKZ.initRealtime === "function") {
      AMKZ.initRealtime();
    }

    // Rechte live aktualisieren (alle 20s + wenn die App wieder in den Vordergrund kommt)
    if (!AMKZ.state.timers.permRefresh) {
      AMKZ.state.timers.permRefresh = setInterval(refreshPermissions, 20000);
    }
    if (!document.body.dataset.amkzPermVisBound) {
      document.body.dataset.amkzPermVisBound = "true";
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") refreshPermissions();
      });
    }
  }

  AMKZ.auth = {
    login,
    logout,
    restoreSession,
    renderLoggedIn,
    renderLoggedOut,
    buildPermissions,
  };

  /* =====================================================
     NAVIGATION
  ===================================================== */

  function switchView(view) {
    if (view === "casinos") view = "partners";   // seit 22.10.2026 ein Bereich
    const config = VIEW_CONFIG[view];
    if (!config) return;

    const allowed = AMKZ.state.permissions[config.permission] === true;

    if (!allowed) {
      toast("Keine Freigabe", "Dieser Bereich ist nicht freigegeben.", "error");
      return;
    }

    AMKZ.state.currentView = view;

    $$(".amkz-nav-item").forEach((item) => {
      item.classList.toggle("active", item.dataset.view === view);
    });

    $$(".amkz-view").forEach((section) => {
      section.classList.add("is-hidden");
    });

    const viewId = `amkz${view.charAt(0).toUpperCase() + view.slice(1)}View`;
    byId(viewId)?.classList.remove("is-hidden");

    setText(byId("amkzViewTitle"), config.title);
    setText(byId("amkzViewSubtitle"), config.subtitle);

    if (typeof AMKZ.loadView === "function") {
      AMKZ.loadView(view, { force: false }).catch((error) => {
        console.error("VIEW LOAD ERROR", view, error);
        toast("Fehler", error.message || "Ansicht konnte nicht geladen werden.", "error");
      });
    }
  }

  AMKZ.switchView = switchView;

  /* =====================================================
     CORE EVENTS
  ===================================================== */

  function bindCoreEvents() {
    const loginForm = byId("amkzLoginForm");

    if (loginForm && !loginForm.dataset.bound) {
      loginForm.dataset.bound = "true";

      loginForm.addEventListener("submit", (event) => {
        event.preventDefault();
        login(value("amkzLoginEmail"), value("amkzLoginPassword"));
      });
    }

    const logoutButton = byId("amkzLogoutButton");

    if (logoutButton && !logoutButton.dataset.bound) {
      logoutButton.dataset.bound = "true";
      logoutButton.addEventListener("click", logout);
    }

    $$(".amkz-nav-item").forEach((item) => {
      if (item.dataset.bound) return;

      item.dataset.bound = "true";
      item.addEventListener("click", () => {
        switchView(item.dataset.view);
      });
    });

    const refreshButton = byId("amkzRefreshButton");

    if (refreshButton && !refreshButton.dataset.bound) {
      refreshButton.dataset.bound = "true";

      refreshButton.addEventListener("click", () => {
        if (typeof AMKZ.loadView === "function") {
          AMKZ.loadView(AMKZ.state.currentView, { force: true }).catch((error) => {
            console.error(error);
            toast("Fehler", "Aktualisierung fehlgeschlagen.", "error");
          });
        }
      });
    }

    const globalDate = byId("amkzGlobalDate");

    if (globalDate && !globalDate.dataset.bound) {
      globalDate.dataset.bound = "true";

      globalDate.addEventListener("change", () => {
        AMKZ.state.selectedDate = value("amkzGlobalDate") || today();
        AMKZ.state.calendarSelectedDate = AMKZ.state.selectedDate;

        if (typeof AMKZ.loadView === "function") {
          AMKZ.loadView(AMKZ.state.currentView, { force: true }).catch((error) => {
            console.error(error);
            toast("Fehler", "Datum konnte nicht geladen werden.", "error");
          });
        }
      });
    }

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeModal();
    });
  }

  /* =====================================================
     MOBILE APP MODE
  ===================================================== */

  function isAmkAppPage() {
    return !!byId("amkzApp");
  }

  function hideShopifyHeaderFooter() {
    if (!isAmkAppPage()) return;

    const selectors = [
      "header",
      "footer",
      ".shopify-section-group-header-group",
      ".shopify-section-group-footer-group",
      "#shopify-section-header",
      "#shopify-section-footer",
      ".header-wrapper",
      ".footer",
      ".announcement-bar-section",
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        if (!element.closest("#amkzApp")) {
          element.style.display = "none";
        }
      });
    });

    document.body.classList.add("amkz-app-mode");
  }

  function ensureMobileBurger() {
    if (!isAmkAppPage()) return;
    if (byId("amkzMobileMenuButton")) return;

    const button = document.createElement("button");
    button.id = "amkzMobileMenuButton";
    button.className = "amkz-mobile-menu-btn";
    button.type = "button";
    button.innerHTML = "☰";

    document.body.appendChild(button);

    button.addEventListener("click", () => {
      document.body.classList.toggle("amkz-mobile-menu-open");
    });

    document.addEventListener("click", (event) => {
      if (
        document.body.classList.contains("amkz-mobile-menu-open") &&
        !event.target.closest(".amkz-sidebar") &&
        !event.target.closest("#amkzMobileMenuButton")
      ) {
        document.body.classList.remove("amkz-mobile-menu-open");
      }
    });

    document.querySelectorAll(".amkz-nav-item").forEach((item) => {
      item.addEventListener("click", () => {
        document.body.classList.remove("amkz-mobile-menu-open");
      });
    });
  }

  function initMobileAppMode() {
    hideShopifyHeaderFooter();
    ensureMobileBurger();
  }

  /* =====================================================
     PLACEHOLDERS
  ===================================================== */

  AMKZ.loadView = async function loadViewPlaceholder() {};
  AMKZ.initRealtime = function initRealtimePlaceholder() {};

  /* =====================================================
     BOOT
  ===================================================== */

  async function boot() {
    try {
      initMobileAppMode();
      initSupabase();
      bindCoreEvents();

      const restored = restoreSession();

      if (restored) {
        renderLoggedIn();
      } else {
        renderLoggedOut();
      }

      AMKZ.state.booted = true;

      setTimeout(initMobileAppMode, 500);
      setTimeout(initMobileAppMode, 1500);
    } catch (error) {
      console.error("AMK BOOT ERROR", error);

      const bootLoader = byId("amkzBootLoader");

      if (bootLoader) {
        bootLoader.innerHTML = `
          <div class="amkz-card" style="max-width:540px;">
            <h3 style="color:#ef4444;margin:0 0 8px;">AMK Fehler</h3>
            <p>${escapeHtml(error.message)}</p>
          </div>
        `;
      }
    }
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot)
    : boot();
})();
/* =====================================================
   AMK ZENTRALE — FINAL JS
   PART 2/4 — DATA / DASHBOARD / STRUCTURE / FINANCE
===================================================== */

(function () {
  "use strict";

  const AMKZ = window.AMKZ;
  if (!AMKZ) return;

  const {
    byId,
    escapeHtml,
    setText,
    setHTML,
    value,
    today,
    money,
    safeNumber,
  } = AMKZ.utils;

  const { rpc, selectRows } = AMKZ.api;

  /* =====================================================
     SHARED HELPERS
  ===================================================== */

  function optionList(rows, placeholder = "Auswählen", nurAktiv = false) {
    /* 02.11.2026: Casino-Auswahlen zeigen nur aktive Casinos (wie auf der Webseite). Inaktive bleiben als
       versteckte Optionen drin, damit alte Einträge beim Bearbeiten ihr Casino behalten. */
    /* Nachtschicht 31.10.: inaktive (Dubletten/Altlasten) nicht mehr mitten in der Auswahl, sondern unten in eigener Gruppe – bleiben für alte Einträge wählbar */
    const opt = (row) => {
      const label = row.name || row.title || row.email || row.label || row.id;
      return `<option value="${escapeHtml(row.id)}">${escapeHtml(label)}</option>`;
    };
    const all = rows || [];
    const aktiv = all.filter((row) => row && row.status !== "inactive");
    const inaktiv = all.filter((row) => row && row.status === "inactive");
    return `
      <option value="">${escapeHtml(placeholder)}</option>
      ${aktiv.map(opt).join("")}
      ${inaktiv.length && !nurAktiv ? `<optgroup label="Inaktiv / alt">${inaktiv.map(opt).join("")}</optgroup>` : ""}
      ${nurAktiv ? inaktiv.map((row) => opt(row).replace("<option ", "<option hidden ")).join("") : ""}
    `;
  }

  function selectedDate() {
    return value("amkzGlobalDate") || AMKZ.state.selectedDate || today();
  }

  function findById(rows, id) {
    return (rows || []).find((row) => row.id === id) || null;
  }

  function getPartnerName(id) {
    return findById(AMKZ.state.partners, id)?.name || "";
  }

  function getCasinoName(id) {
    return findById(AMKZ.state.casinos, id)?.name || "";
  }

  function getDealTitle(id) {
    return findById(AMKZ.state.deals, id)?.title || "";
  }

  function getCasino(casinoId) {
    return findById(AMKZ.state.casinos, casinoId);
  }

  function getDeal(dealId) {
    return findById(AMKZ.state.deals, dealId);
  }

  AMKZ.shared = {
    optionList,
    selectedDate,
    findById,
    getPartnerName,
    getCasinoName,
    getDealTitle,
    getCasino,
    getDeal,
  };

  /* =====================================================
     LOADERS
  ===================================================== */

  async function loadPartners(force = false) {
    if (!force && AMKZ.state.partners.length) return AMKZ.state.partners;

    const rows = await selectRows("partner_groups", (q) =>
      q.select("id,name,status,note,created_at").order("name", { ascending: true })
    ).catch(() => []);

    AMKZ.state.partners = rows;
    return rows;
  }

  async function loadCasinos(force = false) {
    if (!force && AMKZ.state.casinos.length) return AMKZ.state.casinos;

    const spalten = await AMKZ.spalten("casinos");
    const rows = await selectRows("casinos", (q) =>
      q
        // Offene Spaltenliste statt fixer Liste: lädt cpa_min_deposit (Royal-Partners-Baseline)
        // automatisch mit, bricht aber NICHT, falls die Spalte noch nicht per SQL angelegt wurde.
        // (stream_password ist geschützt, siehe AMKZ.spalten.)
        .select(spalten)
        .order("name", { ascending: true })
    ).catch(() => []);

    AMKZ.state.casinos = rows;
    return rows;
  }

  async function loadDeals(force = false) {
    if (!force && AMKZ.state.deals.length) return AMKZ.state.deals;

    const rows = await selectRows("amk_deals", (q) =>
      q
        .select(`
          id,
          title,
          partner_group_id,
          casino_id,
          deal_type,
          revshare_percent,
          cpa_amount,
          fixed_fee,
          start_date,
          end_date,
          status,
          note,
          created_at
        `)
        .order("created_at", { ascending: false })
    ).catch(() => []);

    AMKZ.state.deals = rows;
    return rows;
  }

  async function loadTeam(force = false) {
    if (!force && AMKZ.state.team.length) return AMKZ.state.team;

    const rows = await rpc("amk_get_team_members").catch(() => []);
    AMKZ.state.team = Array.isArray(rows) ? rows : [];
    return AMKZ.state.team;
  }

  async function loadEntries({ date = null, limit = 15 } = {}) {
    const rows = await rpc("amk_get_entries_limited", {
      p_date: date,
      p_limit: Number(limit || 0),
    }).catch(() => []);

    AMKZ.state.entries = Array.isArray(rows) ? rows : [];
    return AMKZ.state.entries;
  }

  /* ---- Zeitraum (von..bis): echte Daten ueber mehrere Tage ---- */
  function activeRange() {
    let f = AMKZ.state.rangeFrom;
    let t = AMKZ.state.rangeTo;
    if (!f || !t) return null;
    if (f > t) { const x = f; f = t; t = x; }   // falls vertauscht
    return { from: f, to: t };
  }

  async function loadEntriesRange(from, to) {
    try {
      const { data, error } = await AMKZ.supabase
        .from("entries")
        .select("*")
        .gte("entry_date", from)
        .lte("entry_date", to)
        .order("entry_date", { ascending: false });
      if (error) throw error;
      AMKZ.state.entries = Array.isArray(data) ? data : [];
    } catch (e) {
      console.warn("loadEntriesRange failed", e);
      AMKZ.state.entries = [];
    }
    return AMKZ.state.entries;
  }

  async function loadActualRange(from, to) {
    try {
      const { data, error } = await AMKZ.supabase
        .from("amk_actual_daily_data")
        .select("*")
        .gte("report_date", from)
        .lte("report_date", to);
      if (error) throw error;
      return Array.isArray(data) ? data : [];
    } catch (e) {
      console.warn("loadActualRange failed", e);
      return [];
    }
  }

  async function loadActualDailyData(date) {
    return rpc("amk_get_actual_daily_data", {
      p_report_date: date,
    }).catch(() => []);
  }

  async function loadFinanceDocuments(type) {
    const rows = await rpc("amk_get_finance_documents", {
      p_document_type: type,
    }).catch(() => []);

    if (type === "invoice") AMKZ.state.invoices = Array.isArray(rows) ? rows : [];
    if (type === "contract") AMKZ.state.contracts = Array.isArray(rows) ? rows : [];

    return Array.isArray(rows) ? rows : [];
  }

  async function loadCalendarEvents({ monthStart, monthEnd } = {}) {
    let rows = [];

    if (monthStart && monthEnd) {
      rows = await selectRows("planning_calendar", (q) =>
        q
          .select("*")
          .gte("event_date", monthStart)
          .lte("event_date", monthEnd)
          .order("starts_at", { ascending: true })
      ).catch(() => []);
    } else {
      rows = await selectRows("planning_calendar", (q) =>
        q.select("*").order("starts_at", { ascending: true }).limit(150)
      ).catch(() => []);
    }

    AMKZ.state.calendarEvents = rows;
    return rows;
  }

  // Einladungen (RSVP) zu den geladenen Events holen -> Map event_id -> [invites]
  async function loadCalendarInvites(eventIds = []) {
    const map = {};
    if (!eventIds.length || !AMKZ.supabase) { AMKZ.state.calendarInvites = map; return map; }
    try {
      const { data } = await AMKZ.supabase
        .from("calendar_event_invites")
        .select("*")
        .in("event_id", eventIds);
      (data || []).forEach((inv) => { (map[inv.event_id] = map[inv.event_id] || []).push(inv); });
    } catch (e) { /* Tabelle evtl. noch nicht angelegt (SQL ausführen) */ }
    AMKZ.state.calendarInvites = map;
    return map;
  }

  // MEINE Einladungen (egal welcher Monat) + die zugehörigen Events laden + in calendarEvents mergen
  async function loadMyInvitesAndEvents() {
    const myId = AMKZ.state.member?.id;
    AMKZ.state.myInvites = [];
    if (!myId || !AMKZ.supabase) return [];
    try {
      const { data: mine } = await AMKZ.supabase
        .from("calendar_event_invites").select("*").eq("user_id", myId);
      AMKZ.state.myInvites = mine || [];
      const ids = [...new Set((mine || []).map((i) => i.event_id).filter(Boolean))];
      if (ids.length) {
        const { data: evs } = await AMKZ.supabase.from("planning_calendar").select("*").in("id", ids);
        const have = new Set((AMKZ.state.calendarEvents || []).map((e) => e.id));
        (evs || []).forEach((e) => { if (e && !have.has(e.id)) AMKZ.state.calendarEvents.push(e); });
      }
    } catch (e) { /* Tabelle evtl. noch nicht angelegt */ }
    return AMKZ.state.myInvites;
  }

  async function loadBaseData(force = false) {
    const [partners, casinos, deals, team] = await Promise.all([
      loadPartners(force),
      loadCasinos(force),
      loadDeals(force),
      loadTeam(force),
    ]);

    hydrateDropdowns();

    return { partners, casinos, deals, team };
  }

  AMKZ.data = {
    loadPartners,
    loadCasinos,
    loadDeals,
    loadTeam,
    loadEntries,
    loadActualDailyData,
    loadFinanceDocuments,
    loadCalendarEvents,
    loadCalendarInvites,
    loadMyInvitesAndEvents,
    loadBaseData,
    hydrateDropdowns,
  };

  /* =====================================================
     DROPDOWNS
  ===================================================== */

  // Inaktive Partner/Casinos dürfen bei NEUEN Eintragungen (FTD/ReDepo etc.) nicht mehr
  // auswählbar sein. Gilt nur für die Eintrags-Dropdowns, nicht für Auswertung/Verwaltung.
  function isEntrySelectable(row) {
    return (row?.status || "active") !== "inactive";
  }
  function activeEntryPartners() {
    return AMKZ.state.partners.filter(isEntrySelectable);
  }
  function activeEntryCasinos() {
    const okPartner = new Set(activeEntryPartners().map((p) => String(p.id)));
    return AMKZ.state.casinos.filter(
      (casino) =>
        isEntrySelectable(casino) &&
        (!casino.partner_group_id || okPartner.has(String(casino.partner_group_id)))
    );
  }

  function hydrateDropdowns() {
    const map = [
      ["amkzQuickEntryPartner", activeEntryPartners(), "Partner wählen"],
      ["amkzQuickEntryCasino", activeEntryCasinos(), "Casino wählen"],
      ["amkzQuickEntryDeal", AMKZ.state.deals, "Deal wählen"],
    ];

    map.forEach(([id, rows, placeholder]) => {
      const el = byId(id);
      if (el) el.innerHTML = optionList(rows, placeholder);
    });
  }

  function filterQuickEntryByPartner() {
    const partnerId = value("amkzQuickEntryPartner");

    const base = activeEntryCasinos();
    const casinos = partnerId
      ? base.filter((casino) => casino.partner_group_id === partnerId)
      : base;

    const deals = partnerId
      ? AMKZ.state.deals.filter((deal) => deal.partner_group_id === partnerId)
      : AMKZ.state.deals;

    const casinoSelect = byId("amkzQuickEntryCasino");
    const dealSelect = byId("amkzQuickEntryDeal");

    if (casinoSelect) casinoSelect.innerHTML = optionList(casinos, "Casino wählen", true);
    if (dealSelect) dealSelect.innerHTML = optionList(deals, "Deal wählen");
  }

  function filterQuickEntryByCasino() {
    const casinoId = value("amkzQuickEntryCasino");
    const casino = getCasino(casinoId);

    const partnerSelect = byId("amkzQuickEntryPartner");
    if (casino?.partner_group_id && partnerSelect) {
      partnerSelect.value = casino.partner_group_id;
    }

    const deals = casinoId
      ? AMKZ.state.deals.filter((deal) => deal.casino_id === casinoId)
      : AMKZ.state.deals;

    const dealSelect = byId("amkzQuickEntryDeal");
    if (dealSelect) dealSelect.innerHTML = optionList(deals, "Deal wählen");
  }

  function bindDropdownEvents() {
    const partner = byId("amkzQuickEntryPartner");
    const casino = byId("amkzQuickEntryCasino");

    if (partner && !partner.dataset.bound) {
      partner.dataset.bound = "true";
      partner.addEventListener("change", filterQuickEntryByPartner);
    }

    if (casino && !casino.dataset.bound) {
      casino.dataset.bound = "true";
      casino.addEventListener("change", filterQuickEntryByCasino);
    }
  }

  /* =====================================================
     SAVE APIS
  ===================================================== */

  async function saveEntry(payload = {}) {
    const member = AMKZ.state.member;
    if (!member?.id) throw new Error("Kein Benutzer angemeldet.");

    let {
      entryDate,
      entryType,
      partnerGroupId,
      casinoId,
      dealId,
      amount,
      note = "",
      paymentStatus = "paid",
      customerName = "",
      customerEmail = "",
      walletAddress = "",
      geo = "",
    } = payload;

    const type = String(entryType || "").toUpperCase();

    if (!entryDate) throw new Error("Datum fehlt.");
    if (!type) throw new Error("Typ fehlt.");

    /* Der Betrag wurde bisher ungeprüft durch safeNumber geschickt: aus einem
       Tippfehler wurde still eine 0, aus einem versehentlichen Minus ein
       negativer FTD. Beides landete in der Datenbank und zog sich durch jede
       Auswertung, ohne dass irgendwo etwas aufgefallen wäre. */
    const betrag = safeNumber(amount);
    if (!Number.isFinite(betrag)) throw new Error("Betrag ist keine Zahl.");
    if (betrag < 0) throw new Error("Ein negativer Betrag ergibt hier keinen Sinn — bitte den Typ ändern statt ein Minus zu setzen.");
    if (betrag === 0 && (type === "FTD" || type === "REDEPO")) {
      throw new Error("Ein FTD oder ReDepo über 0 € wäre keine Buchung — bitte den Betrag eintragen.");
    }

    const deal = getDeal(dealId);

    if (!casinoId && deal?.casino_id) {
      casinoId = deal.casino_id;
    }

    const casino = getCasino(casinoId);

    if (!partnerGroupId && casino?.partner_group_id) {
      partnerGroupId = casino.partner_group_id;
    }

    if ((type === "FTD" || type === "REDEPO") && !casinoId) {
      throw new Error("Für FTD/ReDepo muss ein Casino gewählt werden.");
    }

    const insertPayload = {
      entry_date: entryDate,
      entry_type: type,
      partner_group_id: partnerGroupId || null,
      casino_id: casinoId || null,
      amount: betrag,
      currency: "EUR",
      payment_status: paymentStatus || "paid",
      source: "amk_zentrale",
      note: note || "",
      created_by: member.name || member.email || "AMK",
      created_by_id: member.id,
      created_by_name: member.name || "",
      created_by_email: member.email || "",
      customer_name: customerName || "",
      customer_email: customerEmail || "",
      wallet_address: walletAddress || "",
      metadata: {
        deal_id: dealId || null,
        casino_name: casino?.name || null,
        partner_group_id: partnerGroupId || null,
        deal_type: casino?.deal_type || null,
        cpa_amount: casino?.cpa_amount || 0,
        revshare_percent: casino?.revshare_percent || 0,
        geo: (geo || "").trim() || null,
      },
    };

    const { data, error } = await AMKZ.supabase
      .from("entries")
      .insert(insertPayload)
      .select("*")
      .single();

    if (error) throw error;
    return data;
  }

  async function savePartner({ name, status = "active", note = "" }) {
    if (!name) throw new Error("Partnername fehlt.");

    const result = await rpc("amk_create_partner", {
      p_name: name,
      p_status: status,
      p_note: note || "",
    });

    await loadPartners(true);
    hydrateDropdowns();

    return result;
  }

  async function saveCasino({
    name,
    partnerGroupId,
    status = "active",
    dealType = "revshare",
    revsharePercent = 0,
    cpaAmount = 0,
    baselineAmount = 0,
    baselineFtds = 0,
    note = "",
  }) {
    if (!name) throw new Error("Casino-Name fehlt.");

    const result = await rpc("amk_create_casino", {
      p_name: name,
      p_partner_group_id: partnerGroupId || null,
      p_status: status,
      p_deal_type: dealType,
      p_revshare_percent: safeNumber(revsharePercent),
      p_cpa_amount: safeNumber(cpaAmount),
      p_baseline_amount: safeNumber(baselineAmount),
      p_note: note || "",
    });

    // baseline_ftds nachtragen (die RPC kennt das Feld nicht)
    try {
      const cid = result?.id || (Array.isArray(result) ? result[0]?.id : null);
      if (cid) await AMKZ.supabase.from("casinos").update({ baseline_ftds: Math.round(safeNumber(baselineFtds)) }).eq("id", cid);
    } catch (e) { console.warn("baseline_ftds save", e); }

    await loadCasinos(true);
    hydrateDropdowns();

    return result;
  }

  async function saveDeal({
    partnerGroupId,
    casinoId,
    title,
    dealType = "revshare",
    revsharePercent = 0,
    cpaAmount = 0,
    fixedFee = 0,
    startDate = null,
    endDate = null,
    status = "active",
    note = "",
  }) {
    if (!title) throw new Error("Deal-Titel fehlt.");

    /* Konditionen prüfen, bevor sie in die Datenbank gehen. Ein RevShare von
       500 % oder ein negativer CPA verrechnet sich später durch jede
       Auswertung, ohne dass irgendwo etwas auffällt. */
    const rev = safeNumber(revsharePercent);
    const cpa = safeNumber(cpaAmount);
    const fix = safeNumber(fixedFee);
    if (rev < 0 || rev > 100) throw new Error("RevShare muss zwischen 0 und 100 % liegen.");
    if (cpa < 0) throw new Error("Ein negativer CPA ergibt keinen Sinn.");
    if (fix < 0) throw new Error("Eine negative Fixvergütung ergibt keinen Sinn.");
    if (startDate && endDate && String(endDate) < String(startDate)) {
      throw new Error("Der Deal endet vor seinem Beginn.");
    }

    // amk_deals ist eine (nicht beschreibbare) View über die echte Tabelle "deals".
    // Der RPC amk_create_deal scheitert an created_by -> wir schreiben direkt in "deals"
    // mit genau den Spalten, die es dort gibt. (Hybrid-Konditionen liegen am Casino.)
    const payload = {
      casino_id: casinoId || null,
      deal_type: dealType,
      cpa_amount: cpa,
      revshare_percent: rev,
      fixed_amount: fix,
      start_date: startDate || null,
      end_date: endDate || null,
      notes: title + (note ? " · " + note : ""),
      updated_at: new Date().toISOString(),
    };

    /* Partner und Status standen im Formular zur Auswahl, wurden hier aber nie
       mitgeschrieben — man wählte einen Partner, bekam "Gespeichert" und die
       Zuordnung war weg. Jetzt werden sie mitgeschickt; kennt die Tabelle die
       beiden Spalten nicht, wird ohne sie erneut versucht, damit das Anlegen
       auf keinen Fall daran scheitert. */
    const zusatz = {};
    if (partnerGroupId) zusatz.partner_group_id = partnerGroupId;
    if (status) zusatz.status = status;

    let { data, error } = await AMKZ.supabase
      .from("deals").insert(Object.assign({}, payload, zusatz)).select().maybeSingle();
    if (error && Object.keys(zusatz).length) {
      ({ data, error } = await AMKZ.supabase.from("deals").insert(payload).select().maybeSingle());
    }
    if (error) throw new Error(error.message);

    await loadDeals(true);
    hydrateDropdowns();

    return data;
  }

  async function saveActualDailyData({
    reportDate,
    actualProfit = 0,
    actualRevenue = 0,
    actualCosts = 0,
    note = "",
  }) {
    const member = AMKZ.state.member;
    if (!member?.id) throw new Error("Kein Benutzer angemeldet.");
    if (!reportDate) throw new Error("Datum fehlt.");

    return rpc("amk_save_actual_daily_data", {
      p_report_date: reportDate,
      p_actual_profit: safeNumber(actualProfit),
      p_actual_revenue: safeNumber(actualRevenue),
      p_actual_costs: safeNumber(actualCosts),
      p_note: note || "",
      p_created_by: member.id,
    });
  }

  async function saveFinanceDocument({
    documentType,
    title,
    partnerGroupId,
    casinoId,
    documentDate,
    amount = 0,
    status = "open",
    fileUrl = "",
    fileName = "",
    note = "",
  }) {
    if (!title) throw new Error("Titel fehlt.");

    const member = AMKZ.state.member;

    return rpc("amk_create_finance_document", {
      p_document_type: documentType,
      p_title: title,
      p_partner_group_id: partnerGroupId || null,
      p_casino_id: casinoId || null,
      p_document_date: documentDate || null,
      p_amount: safeNumber(amount),
      p_status: status || "open",
      p_file_url: fileUrl || "",
      p_file_name: fileName || "",
      p_note: note || "",
      p_created_by: member?.id || null,
    });
  }

  async function saveCalendarEvent({
    title,
    description = "",
    eventDate,
    endDate = null,
    startTime = "10:00",
    endTime = "11:00",
    assignedTo = null,
    eventType = "general",
    status = "scheduled",
    relatedEntryId = null,
  }) {
    if (!title) throw new Error("Titel fehlt.");
    if (!eventDate) throw new Error("Datum fehlt.");

    const member = AMKZ.state.member;
    const endD = endDate || eventDate; // Bis-Datum (Events können über mehrere Tage gehen)

    // WICHTIG: Eingabe ist ORTSZEIT (Berlin). Vor dem Speichern in echtes UTC wandeln,
    // sonst stempelt Postgres die nackte Zeit als UTC und die Anzeige rechnet +2h drauf.
    const localToUtc = (d, t) => { try { const iso = new Date(`${d}T${(t || "00:00")}:00`).toISOString(); return isNaN(new Date(iso)) ? `${d}T${t || "00:00"}:00` : iso; } catch (_) { return `${d}T${t || "00:00"}:00`; } };

    return rpc("amk_create_calendar_event", {
      p_title: title,
      p_description: description || "",
      p_event_date: eventDate,
      p_starts_at: localToUtc(eventDate, startTime),
      p_ends_at: localToUtc(endD, endTime),
      p_assigned_to: assignedTo || null,
      p_event_type: eventType || "general",
      p_status: status || "scheduled",
      p_related_entry_id: relatedEntryId || null,
      p_created_by: member?.id || null,
    });
  }

  AMKZ.save = {
    saveEntry,
    savePartner,
    saveCasino,
    saveDeal,
    saveActualDailyData,
    saveFinanceDocument,
    saveCalendarEvent,
  };

  /* =====================================================
     SUMMARY / CALCULATIONS
  ===================================================== */

  function summarizeEntries(entries) {
    const summary = {
      ftdCount: 0,
      redepoCount: 0,
      incomeCount: 0,
      expenseCount: 0,
      ftdAmount: 0,
      redepoAmount: 0,
      incomeAmount: 0,
      expenseAmount: 0,
      netProfit: 0,
    };

    (entries || []).forEach((entry) => {
      const type = String(entry.entry_type || "").toUpperCase();
      const amount = safeNumber(entry.amount);

      if (type === "FTD") {
        summary.ftdCount += 1;
        summary.ftdAmount += amount;
      }

      if (type === "REDEPO") {
        summary.redepoCount += 1;
        summary.redepoAmount += amount;
      }

      if (type === "INCOME") {
        summary.incomeCount += 1;
        summary.incomeAmount += amount;
      }

      if (type === "OPERATING_EXPENSE") {
        summary.expenseCount += 1;
        summary.expenseAmount += amount;
      }
    });

    summary.netProfit =
      summary.incomeAmount -
      summary.ftdAmount -
      summary.redepoAmount -
      summary.expenseAmount;

    return summary;
  }

  function findDealForEntry(entry) {
    const deals = AMKZ.state.deals || [];
    const metaDealId = entry.metadata?.deal_id || entry.metadata?.dealId || null;

    if (metaDealId) {
      const byMeta = deals.find((deal) => deal.id === metaDealId);
      if (byMeta) return byMeta;
    }

    if (entry.casino_id) {
      const byCasino = deals.find((deal) => deal.casino_id === entry.casino_id);
      if (byCasino) return byCasino;
    }

    if (entry.partner_group_id) {
      const byPartner = deals.find((deal) => deal.partner_group_id === entry.partner_group_id);
      if (byPartner) return byPartner;
    }

    return null;
  }

  function calculateExpectedProfit(entries) {
    let total = 0;
    const hybridGroups = {}; // pro Casino: FTD-Zeilen (kumulativ) + Kosten

    const casinoDeal = (entry) => {
      // Konditionen primär vom CASINO (echte Tabelle), sonst vom Deal
      const c = entry.casino_id ? getCasino(entry.casino_id) : null;
      const d = findDealForEntry(entry);
      const dealType = String((c && c.deal_type) || (d && d.deal_type) || "").toLowerCase();
      return { c, d, dealType };
    };

    (entries || []).forEach((entry) => {
      const type = String(entry.entry_type || "").toUpperCase();
      const entryCost = safeNumber(entry.amount);

      if (type === "INCOME") { total += entryCost; return; }
      if (type === "OPERATING_EXPENSE") { total -= entryCost; return; }

      const { c, dealType } = casinoDeal(entry);
      if (!dealType) { total -= entryCost; return; }
      if (dealType === "fixed") return;

      if (dealType === "hybrid") {
        const key = entry.casino_id || "x";
        const g = hybridGroups[key] || (hybridGroups[key] = { casino: c, ftd: [], cost: 0 });
        g.cost += entryCost;
        if (type === "FTD") g.ftd.push(entry);
        return;
      }

      if (dealType === "cpa") {
        const cpa = safeNumber((c && c.cpa_amount));
        total += cpa - entryCost;
        return;
      }

      // revshare & Rest: nur Kosten (RevShare-Einnahmen werden nicht aus FTDs berechnet)
      total -= entryCost;
    });

    // Hybrid kumulativ: erste N FTDs teilen sich die Pauschale, ab N+1 automatisch CPA
    Object.values(hybridGroups).forEach((g) => {
      const c = g.casino || {};
      const baseAmount = safeNumber(c.baseline_amount);
      const baseFtds = Math.round(safeNumber(c.baseline_ftds));
      const cpa = safeNumber(c.cpa_amount);
      const minDep = safeNumber(c.cpa_min_deposit); // Baseline = Mindest-Einzahlung pro FTD (CPA-Qualifikation)
      g.ftd.sort((a, b) => String(a.entry_date || "").localeCompare(String(b.entry_date || "")));
      let income = 0;
      g.ftd.forEach((r, i) => {
        const pos = i + 1;
        if (baseFtds > 0 && pos <= baseFtds) { income += baseAmount / baseFtds; return; }
        if (minDep > 0 && safeNumber(r.amount) < minDep) return; // FTD unter Mindest-Einzahlung -> kein CPA
        income += cpa;
      });
      total += income - g.cost;
    });

    return total;
  }

  function summarizeActualRows(rows) {
    return {
      actualProfit: (rows || []).reduce((sum, row) => sum + safeNumber(row.actual_profit), 0),
      actualRevenue: (rows || []).reduce((sum, row) => sum + safeNumber(row.actual_revenue), 0),
      actualCosts: (rows || []).reduce((sum, row) => sum + safeNumber(row.actual_costs), 0),
    };
  }

  /* =====================================================
     DASHBOARD
  ===================================================== */

  async function loadDashboard() {
    await loadBaseData(false);

    const range = activeRange();
    let entries, actualRows;

    if (range) {
      // Echter Zeitraum: alle Tage von..bis aggregieren
      [entries, actualRows] = await Promise.all([
        loadEntriesRange(range.from, range.to),
        loadActualRange(range.from, range.to),
      ]);
    } else {
      const date = selectedDate();
      [entries, actualRows] = await Promise.all([
        loadEntries({ date, limit: 0 }),
        loadActualDailyData(date),
      ]);
    }

    const [notifications, onlineUsers] = await Promise.all([
      loadNotifications(),
      loadOnlineUsers(),
    ]);

    const summary = summarizeEntries(entries);
    const expectedProfit = calculateExpectedProfit(entries);
    const actual = summarizeActualRows(actualRows);

    renderDashboardKpis(summary, expectedProfit, actual);
    renderDashboardEntries(entries);
    renderDashboardSide(notifications, onlineUsers);
    // EINE saubere Quelle für die KPI-Zahlen (kein Race, Karte == Popup):
    try { AMKZ.modules?.v11?.loadDashboardCleanV11?.(); } catch (_) {}
  }

  function renderDashboardKpis(summary, expectedProfit, actual) {
    // FIX Race/Widerspruch: Die KPI-Zahlen werden AUSSCHLIESSLICH von
    // loadDashboardCleanV11 gesetzt (zeitraum-bezogen; Ist-Gewinn = CPA automatisch
    // + manuell). Hier nicht mehr setzen -> Karte und Popup stimmen immer überein.
    void summary; void expectedProfit; void actual;
  }

  function renderDashboardEntries(entries) {
    const limit = Number(value("amkzDashboardEntriesLimit") || 15);
    const rows = limit > 0 ? entries.slice(0, limit) : entries;

    setHTML(
      byId("amkzDashboardEntriesBody"),
      rows.length
        ? rows.map(renderEntryTableRowDashboard).join("")
        : `<tr><td colspan="6"><div class="amkz-empty">Keine Einträge im gewählten Zeitraum.</div></td></tr>`
    );
  }

  function renderEntryTableRowDashboard(entry) {
    return `
      <tr class="amkz-entry-row" data-entry-id="${escapeHtml(entry.id || "")}" title="Für Details klicken">
        <td>${escapeHtml(entry.entry_date || "—")}</td>
        <td><span class="amkz-status-pill">${escapeHtml(entry.entry_type || "—")}</span></td>
        <td>${escapeHtml(entry.partner_name || getPartnerName(entry.partner_group_id) || "—")}</td>
        <td>${escapeHtml(entry.casino_name || getCasinoName(entry.casino_id) || "—")}</td>
        <td>${money(entry.amount || 0)}</td>
        <td>${escapeHtml(entry.payment_status || entry.status || "open")}</td>
      </tr>
    `;
  }

  async function loadNotifications() {
    const member = AMKZ.state.member;
    if (!member?.id) return [];

    return selectRows("notifications", (q) =>
      q.select("*").eq("target_user_id", member.id).order("created_at", { ascending: false }).limit(8)
    ).catch(() => []);
  }

  async function loadOnlineUsers() {
    return selectRows("user_presence", (q) =>
      q.select("*").eq("is_online", true).order("last_seen", { ascending: false }).limit(20)
    ).catch(() => []);
  }

  function renderDashboardSide(notifications, onlineUsers) {
    setHTML(
      byId("amkzOnlineUsersList"),
      onlineUsers.length
        ? onlineUsers.map((user) => `
            <div class="amkz-table-row-card">
              <strong>${escapeHtml(user.name || user.email || "Mitarbeiter")}</strong><br>
              <small>${escapeHtml(user.current_view || "online")}</small>
            </div>
          `).join("")
        : `<div class="amkz-empty">Niemand online.</div>`
    );

    setHTML(
      byId("amkzNotificationsList"),
      notifications.length
        ? notifications.map((item) => {
            /* Eine ReDepo-Nachfrage ist kein Hinweis zum Lesen, sondern eine
               Aufgabe: ein Klick öffnet die Zahlung mit den beiden Knöpfen.
               Deshalb bekommt sie ein Ziel, alle anderen bleiben wie sie waren. */
            const rid = item.payload && (item.payload.reminder_id || item.payload.reminderId);
            const istRedepo = String(item.type || "") === "redepo" && rid;
            /* Verlosung (11.09.): „X hat seine Daten eingetragen" — ein Tipp öffnet die Akte. */
            const vlMail = String(item.type || "") === "verlosung" && item.payload && item.payload.email;
            return `
            <div class="amkz-table-row-card${istRedepo || vlMail ? " amkz-notif-tap" : ""}"${istRedepo ? ` data-rd-id="${escapeHtml(rid)}" role="button" tabindex="0"` : ""}${vlMail ? ` data-vl-email="${escapeHtml(vlMail)}" role="button" tabindex="0"` : ""}>
              <strong>${escapeHtml(item.title || "Benachrichtigung")}</strong><br>
              <small>${escapeHtml(item.message || "")}</small>
              ${istRedepo ? `<div class="amkz-notif-cta">Zahlung ansehen →</div>` : ""}${vlMail ? `<div class="amkz-notif-cta">Akte öffnen →</div>` : ""}
            </div>`;
          }).join("")
        : `<div class="amkz-empty">Keine Benachrichtigungen.</div>`
    );
  }

  /* =====================================================
     ENTRIES
  ===================================================== */

  async function loadEntriesView() {
    const date = selectedDate();
    const limit = Number(value("amkzEntriesLimit") || 15);

    await loadBaseData(false);

    const range = activeRange();
    const entries = range
      ? await loadEntriesRange(range.from, range.to)
      : await loadEntries({ date, limit });
    renderEntriesTable(range && limit > 0 ? entries.slice(0, limit) : entries); // Nachtschicht 31.10.: Limit galt im Zeitraum nicht
  }

  function renderEntriesTable(entries) {
    setHTML(
      byId("amkzEntriesTableBody"),
      entries.length
        ? entries.map(renderEntryTableRowFull).join("")
        : `<tr><td colspan="8"><div class="amkz-empty">Keine Einträge im gewählten Zeitraum.</div></td></tr>`
    );
  }

  function shortWallet(w) {
    w = String(w || "");
    return w.length > 22 ? w.slice(0, 10) + "…" + w.slice(-6) : w;
  }

  function renderEntryTableRowFull(entry) {
    const dealId = entry.metadata?.deal_id || "";
    const dealTitle = entry.deal_title || getDealTitle(dealId) || "—";
    const cust = entry.customer_name || entry.customer_email;

    return `
      <tr class="amkz-entry-row" data-entry-id="${escapeHtml(entry.id || "")}" title="Für Details klicken">
        <td data-label="Datum">${escapeHtml(entry.entry_date || "—")}</td>
        <td data-label="Typ"><span class="amkz-status-pill">${escapeHtml(entry.entry_type || "—")}</span></td>
        <td data-label="Partner">${escapeHtml(entry.partner_name || getPartnerName(entry.partner_group_id) || "—")}</td>
        <td data-label="Casino">${escapeHtml(entry.casino_name || getCasinoName(entry.casino_id) || "—")}</td>
        <td data-label="Deal">${escapeHtml(dealTitle)}</td>
        <td data-label="Betrag">${money(entry.amount || 0)}</td>
        <td data-label="Status">${escapeHtml(entry.payment_status || entry.status || "open")}</td>
        <td data-label="Erstellt von" class="amkz-cell-creator">
          <strong>${escapeHtml(entry.created_by_name || entry.created_by || "—")}</strong>
          ${entry.created_by_email ? `<small>${escapeHtml(entry.created_by_email)}</small>` : ""}
          ${cust ? `<small class="amkz-cell-sub">Kunde: ${escapeHtml(entry.customer_name || entry.customer_email || "—")}</small>` : ""}
          ${entry.wallet_address ? `<small class="amkz-wallet" title="${escapeHtml(entry.wallet_address)}">${escapeHtml(shortWallet(entry.wallet_address))}</small>` : ""}
        </td>
      </tr>
    `;
  }

  /* =====================================================
     DAILY
  ===================================================== */

  async function loadDailyView() {
    const date = selectedDate();

    await loadBaseData(false);

    const [entries, actualRows] = await Promise.all([
      loadEntries({ date, limit: 0 }),
      loadActualDailyData(date),
    ]);

    const summary = summarizeEntries(entries);
    const expectedProfit = calculateExpectedProfit(entries);
    const actual = summarizeActualRows(actualRows);

    renderDailyAnalysis(summary, expectedProfit, actual);
    renderActualDataList(actualRows);
  }

  function renderDailyAnalysis(summary, expectedProfit, actual) {
    const canSeeProfit = AMKZ.state.permissions.seeProfit === true;
    const difference = actual.actualProfit - expectedProfit;
    const percent = expectedProfit > 0 ? Math.round((actual.actualProfit / expectedProfit) * 100) : 0;

    setText(byId("amkzDailyFtdAmount"), money(summary.ftdAmount));
    setText(byId("amkzDailyRedepoAmount"), money(summary.redepoAmount));
    setText(byId("amkzDailyExpenseAmount"), money(summary.expenseAmount));
    setText(byId("amkzDailyExpectedProfit"), canSeeProfit ? money(expectedProfit) : "—");
    setText(byId("amkzDailyActualProfit"), canSeeProfit ? money(actual.actualProfit) : "—");
    setText(byId("amkzDailyDifference"), canSeeProfit ? money(difference) : "—");
    setText(byId("amkzDailyPercent"), canSeeProfit ? `${percent}%` : "—");

    renderDailyCircle(canSeeProfit ? percent : 0);
  }

  function renderDailyCircle(percent) {
    const canvas = byId("amkzDailyCircleChart");
    if (!canvas || !window.Chart) return;

    const safePercent = Math.max(0, Math.min(safeNumber(percent), 100));

    AMKZ.state.charts.dailyCircle?.destroy?.();

    AMKZ.state.charts.dailyCircle = new Chart(canvas, {
      type: "doughnut",
      data: {
        labels: ["Erreicht", "Offen"],
        datasets: [{
          data: [safePercent, Math.max(100 - safePercent, 0)],
          borderWidth: 0,
          backgroundColor: ["rgba(230,184,92,.95)", "rgba(255,255,255,.05)"],
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "76%",
        plugins: {
          legend: { display: false },
          tooltip: { enabled: true },
        },
      },
    });
  }

  function renderActualDataList(rows) {
    const canSeeProfit = AMKZ.state.permissions.seeProfit === true;

    setHTML(
      byId("amkzActualDataList"),
      rows.length
        ? rows.map((row) => `
            <div class="amkz-table-row-card">
              <strong>${canSeeProfit ? money(row.actual_profit) : "—"}</strong><br>
              <small>
                Umsatz: ${canSeeProfit ? money(row.actual_revenue) : "—"}
                · Kosten: ${canSeeProfit ? money(row.actual_costs) : "—"}
              </small>
              ${row.note ? `<p>${escapeHtml(row.note)}</p>` : ""}
            </div>
          `).join("")
        : `<div class="amkz-empty">Keine Ist-Daten im gewählten Zeitraum.</div>`
    );
  }

  function openActualDataModal() {
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header">
          <div>
            <h3>Ist-Daten eintragen</h3>
            <p>Echte Tageswerte manuell speichern</p>
          </div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button>
        </div>

        <form id="amkzActualDataForm" class="amkz-form-grid">
          <div class="amkz-input-group">
            <label>Datum</label>
            <input id="amkzActualReportDate" type="date" value="${selectedDate()}" required>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Ist Gewinn</label>
              <input id="amkzActualProfitInput" type="number" step="0.01" value="0">
            </div>

            <div class="amkz-input-group">
              <label>Ist Umsatz</label>
              <input id="amkzActualRevenueInput" type="number" step="0.01" value="0">
            </div>
          </div>

          <div class="amkz-input-group">
            <label>Ist Kosten</label>
            <input id="amkzActualCostsInput" type="number" step="0.01" value="0">
          </div>

          <div class="amkz-input-group">
            <label>Notiz</label>
            <textarea id="amkzActualNoteInput" placeholder="Kommentar zum Tag…"></textarea>
          </div>

          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>
    `);

    byId("amkzActualDataForm")?.addEventListener("submit", async (event) => {
      event.preventDefault();

      try {
        await saveActualDailyData({
          reportDate: value("amkzActualReportDate"),
          actualProfit: value("amkzActualProfitInput"),
          actualRevenue: value("amkzActualRevenueInput"),
          actualCosts: value("amkzActualCostsInput"),
          note: value("amkzActualNoteInput"),
        });

        AMKZ.modal.close();
        AMKZ.toast("Gespeichert", "Ist-Daten wurden gespeichert.");
        await loadDailyView();
      } catch (error) {
        console.error(error);
        AMKZ.toast("Fehler", error.message, "error");
      }
    });
  }

  /* =====================================================
     ENTRY / PARTNER / CASINO / DEAL MODALS
  ===================================================== */

  async function openEntryModal(defaultType = "FTD") {
    await loadBaseData(true);

    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header">
          <div>
            <h3>Eintrag erstellen</h3>
            <p>FTD, ReDepo, Einnahme oder Ausgabe erfassen</p>
          </div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button>
        </div>

        <form id="amkzEntryForm" class="amkz-form-grid">
          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Datum</label>
              <input id="amkzEntryDate" type="date" value="${selectedDate()}" required>
            </div>

            <div class="amkz-input-group">
              <label>Typ</label>
              <select id="amkzEntryType">
                <option value="FTD" ${defaultType === "FTD" ? "selected" : ""}>FTD</option>
                <option value="REDEPO" ${defaultType === "REDEPO" ? "selected" : ""}>ReDepo</option>
                <option value="INCOME" ${defaultType === "INCOME" ? "selected" : ""}>Einnahme</option>
                <option value="OPERATING_EXPENSE" ${defaultType === "OPERATING_EXPENSE" ? "selected" : ""}>Ausgabe</option>
              </select>
            </div>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Partner</label>
              <select id="amkzEntryPartner">${optionList(AMKZ.state.partners, "Kein Partner")}</select>
            </div>

            <div class="amkz-input-group">
              <label>Casino</label>
              <select id="amkzEntryCasino">${optionList(AMKZ.state.casinos, "Kein Casino", true)}</select>
            </div>
          </div>

          <div class="amkz-input-group">
            <label>Deal</label>
            <select id="amkzEntryDeal">${optionList(AMKZ.state.deals, "Kein Deal")}</select>
          </div>

          <div class="amkz-input-group">
            <label>Betrag</label>
            <div class="amkz-betrag-zeile">
              <input id="amkzEntryAmount" type="number" step="0.01" min="0" required placeholder="0,00">
              <button type="button" id="amkzEntryZufall" class="amkz-zufall-btn" title="Zufallsbetrag zwischen 10,00 und 60,00 € einsetzen">🎲 Zufall</button>
            </div>
          </div>

          <div class="amkz-input-group">
            <label>Notiz</label>
            <textarea id="amkzEntryNote" placeholder="Optionale Notiz…"></textarea>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Kundenname</label>
              <input id="amkzCustomerName" type="text" placeholder="Max Mustermann">
            </div>

            <div class="amkz-input-group">
              <label>Kunden-E-Mail</label>
              <input id="amkzCustomerEmail" type="email" placeholder="kunde@email.com">
            </div>
          </div>

          <div class="amkz-input-group">
            <label>Wallet-Adresse</label>
            <input id="amkzWalletAddress" type="text" placeholder="TRC20 / BTC / ETH Wallet">
          </div>

          <div class="amkz-input-group">
            <label>🌍 Geo / Land</label>
            <div class="amkz-geo-chips" id="amkzGeoChips">
              <button type="button" class="amkz-geo-chip" data-geo="CZ">🇨🇿 CZ</button>
              <button type="button" class="amkz-geo-chip" data-geo="DE">🇩🇪 DE</button>
              <button type="button" class="amkz-geo-chip" data-geo="AT">🇦🇹 AT</button>
              <button type="button" class="amkz-geo-chip" data-geo="SK">🇸🇰 SK</button>
              <button type="button" class="amkz-geo-chip" data-geo="PL">🇵🇱 PL</button>
              <button type="button" class="amkz-geo-chip" data-geo="HU">🇭🇺 HU</button>
            </div>
            <input id="amkzEntryGeo" type="text" placeholder="Länder, z. B. CZ, DE – anklicken oder tippen">
          </div>

          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>
    `);

    ensureGeoStyle();
    bindEntryModalEvents();
  }

  function ensureGeoStyle() {
    if (byId("amk-geo-style")) return;
    const s = document.createElement("style"); s.id = "amk-geo-style";
    s.textContent = `
      .amkz-geo-chips{display:flex;flex-wrap:wrap;gap:7px;margin-bottom:8px}
      .amkz-geo-chip{background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.16);color:inherit;border-radius:999px;padding:6px 13px;font-weight:700;font-size:.82rem;cursor:pointer;transition:background .13s,border-color .13s}
      .amkz-geo-chip:hover{background:rgba(255,255,255,.1)}
      .amkz-geo-chip.active{background:rgba(200,170,110,.2);border-color:rgba(200,170,110,.6);color:#f4e4b8}
    `;
    document.head.appendChild(s);
  }

  function bindEntryModalEvents() {
    const partnerSelect = byId("amkzEntryPartner");
    const casinoSelect = byId("amkzEntryCasino");
    const dealSelect = byId("amkzEntryDeal");

    partnerSelect?.addEventListener("change", () => {
      const partnerId = partnerSelect.value;

      const filteredCasinos = partnerId
        ? AMKZ.state.casinos.filter((casino) => casino.partner_group_id === partnerId)
        : AMKZ.state.casinos;

      const filteredDeals = partnerId
        ? AMKZ.state.deals.filter((deal) => deal.partner_group_id === partnerId)
        : AMKZ.state.deals;

      casinoSelect.innerHTML = optionList(filteredCasinos, "Kein Casino", true);
      dealSelect.innerHTML = optionList(filteredDeals, "Kein Deal");
    });

    casinoSelect?.addEventListener("change", () => {
      const casinoId = casinoSelect.value;
      const casino = getCasino(casinoId);

      if (casino?.partner_group_id && partnerSelect) {
        partnerSelect.value = casino.partner_group_id;
      }

      const filteredDeals = casinoId
        ? AMKZ.state.deals.filter((deal) => deal.casino_id === casinoId)
        : AMKZ.state.deals;

      dealSelect.innerHTML = optionList(filteredDeals, "Kein Deal");
    });

    // 🌍 Geo-Chips: anklicken toggelt Länder-Code im Textfeld
    document.querySelectorAll("#amkzGeoChips .amkz-geo-chip").forEach((chip) => {
      chip.addEventListener("click", () => {
        const code = chip.dataset.geo;
        chip.classList.toggle("active");
        const inp = byId("amkzEntryGeo");
        let set = String(inp.value || "").split(",").map((s) => s.trim()).filter(Boolean);
        if (chip.classList.contains("active")) { if (!set.includes(code)) set.push(code); }
        else set = set.filter((s) => s.toUpperCase() !== code);
        inp.value = set.join(", ");
      });
    });

    // Zufallsbetrag: 10,00 bis 60,00 € mit Cent (Marcel, 09.09.2026). Feuert input/change,
    // damit Vorschau und Deal-Rechnung den Wert sofort uebernehmen.
    byId("amkzEntryZufall")?.addEventListener("click", () => {
      const feld = byId("amkzEntryAmount"); if (!feld) return;
      const cent = 1000 + Math.floor(Math.random() * 5001);   // 1000 … 6000 Cent
      feld.value = (cent / 100).toFixed(2);
      feld.dispatchEvent(new Event("input", { bubbles: true }));
      feld.dispatchEvent(new Event("change", { bubbles: true }));
      feld.focus();
    });

    byId("amkzEntryForm")?.addEventListener("submit", async (event) => {
      event.preventDefault();

      // Dasselbe Schloss wie beim Schnelleintrag — hier stehen dieselben
      // Beträge dahinter, nur mit mehr Feldern drumherum.
      const formular = event.currentTarget;
      if (formular.dataset.speichert === "1") return;
      formular.dataset.speichert = "1";
      const knopf = formular.querySelector('button[type="submit"]');
      const knopfText = knopf ? knopf.textContent : "";
      if (knopf) { knopf.disabled = true; knopf.textContent = "Speichert …"; }

      try {
        await saveEntry({
          entryDate: value("amkzEntryDate"),
          entryType: value("amkzEntryType"),
          partnerGroupId: value("amkzEntryPartner"),
          casinoId: value("amkzEntryCasino"),
          dealId: value("amkzEntryDeal"),
          amount: value("amkzEntryAmount"),
          note: value("amkzEntryNote"),
          customerName: value("amkzCustomerName"),
          customerEmail: value("amkzCustomerEmail"),
          walletAddress: value("amkzWalletAddress"),
          geo: value("amkzEntryGeo"),
        });

        AMKZ.modal.close();
        AMKZ.toast("Gespeichert", "Eintrag wurde gespeichert.");
        await refreshAfterStructureChange();
      } catch (error) {
        console.error(error);
        AMKZ.toast("Fehler", error.message, "error");
      } finally {
        formular.dataset.speichert = "";
        if (knopf) { knopf.disabled = false; knopf.textContent = knopfText; }
      }
    });
  }

  async function loadPartnersView() {
    await loadPartners(true);
    await loadDeals(false);

    renderPartnersList();
    renderDealsList();
  }

  function renderPartnersList() {
    setHTML(
      byId("amkzPartnersList"),
      AMKZ.state.partners.length
        ? AMKZ.state.partners.map((partner) => `
            <div class="amkz-table-row-card">
              <strong>${escapeHtml(partner.name || "Partner")}</strong><br>
              <small>Status: ${escapeHtml(partner.status || "active")}</small>
              ${partner.note ? `<p>${escapeHtml(partner.note)}</p>` : ""}
            </div>
          `).join("")
        : `<div class="amkz-empty">Keine Partnergruppen vorhanden.</div>`
    );
  }

  function openPartnerModal() {
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header">
          <div>
            <h3>Partner erstellen</h3>
            <p>Partnergruppe für Casinos und Deals</p>
          </div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button>
        </div>

        <form id="amkzPartnerForm" class="amkz-form-grid">
          <div class="amkz-input-group">
            <label>Name</label>
            <input id="amkzPartnerNameInput" required placeholder="Partnergruppe">
          </div>

          <div class="amkz-input-group">
            <label>Status</label>
            <select id="amkzPartnerStatusInput">
              <option value="active">Aktiv</option>
              <option value="paused">Pausiert</option>
              <option value="inactive">Inaktiv</option>
            </select>
          </div>

          <div class="amkz-input-group">
            <label>Notiz</label>
            <textarea id="amkzPartnerNoteInput"></textarea>
          </div>

          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>
    `);

    byId("amkzPartnerForm")?.addEventListener("submit", async (event) => {
      event.preventDefault();

      // Schloss gegen Doppelklick — dieselbe Begründung wie beim Eintrag:
      // ein zweiter Klick legt sonst einen zweiten Datensatz an.
      const formular = event.currentTarget;
      if (formular.dataset.speichert === "1") return;
      formular.dataset.speichert = "1";
      const knopf = formular.querySelector('button[type="submit"]');
      const knopfText = knopf ? knopf.textContent : "";
      if (knopf) { knopf.disabled = true; knopf.textContent = "Speichert …"; }

      try {
        await savePartner({
          name: value("amkzPartnerNameInput"),
          status: value("amkzPartnerStatusInput"),
          note: value("amkzPartnerNoteInput"),
        });

        AMKZ.modal.close();
        AMKZ.toast("Gespeichert", "Partner wurde erstellt.");
        await loadPartnersView();
      } catch (error) {
        console.error(error);
        AMKZ.toast("Fehler", error.message, "error");
      } finally {
        formular.dataset.speichert = "";
        if (knopf) { knopf.disabled = false; knopf.textContent = knopfText; }
      }
    });
  }

  async function loadCasinosView() {
    await loadBaseData(true);
    renderCasinosTable();
  }

  function renderCasinosTable() {
    setHTML(
      byId("amkzCasinosTableBody"),
      AMKZ.state.casinos.length
        ? AMKZ.state.casinos.map((casino) => `
            <tr>
              <td>${escapeHtml(casino.name || "Casino")}</td>
              <td>${escapeHtml(getPartnerName(casino.partner_group_id) || "—")}</td>
              <td>${escapeHtml(casino.deal_type || "—")}</td>
              <td>${money(casino.cpa_amount || 0)}</td>
              <td>${Number(casino.revshare_percent || 0)}%</td>
              <td>${escapeHtml(casino.status || "active")}</td>
            </tr>
          `).join("")
        : `<tr><td colspan="6"><div class="amkz-empty">Keine Casinos vorhanden.</div></td></tr>`
    );
  }

  async function openCasinoModal() {
    await loadPartners(true);

    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header">
          <div>
            <h3>Casino erstellen</h3>
            <p>Casino einem Partner zuordnen</p>
          </div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button>
        </div>

        <form id="amkzCasinoForm" class="amkz-form-grid">
          <div class="amkz-input-group">
            <label>Casino-Name</label>
            <input id="amkzCasinoNameInput" required placeholder="Casino">
          </div>

          <div class="amkz-input-group">
            <label>Partnergruppe</label>
            <select id="amkzCasinoPartnerInput">${optionList(AMKZ.state.partners, "Kein Partner")}</select>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Status</label>
              <select id="amkzCasinoStatusInput">
                <option value="active">Aktiv</option>
                <option value="paused">Pausiert</option>
                <option value="inactive">Inaktiv</option>
              </select>
            </div>

            <div class="amkz-input-group">
              <label>Deal-Basis</label>
              <select id="amkzCasinoDealTypeInput">
                <option value="revshare">RevShare</option>
                <option value="cpa">CPA</option>
                <option value="hybrid">Hybrid</option>
                <option value="fixed">Fixed</option>
              </select>
            </div>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>RevShare %</label>
              <input id="amkzCasinoRevshareInput" type="number" step="0.01" value="0">
            </div>

            <div class="amkz-input-group">
              <label>CPA-Betrag</label>
              <input id="amkzCasinoCpaInput" type="number" step="0.01" value="0">
            </div>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Baseline-Betrag (€)</label>
              <input id="amkzCasinoBaselineInput" type="number" step="0.01" value="0" placeholder="z. B. 30000">
            </div>
            <div class="amkz-input-group">
              <label>Baseline FTDs</label>
              <input id="amkzCasinoBaselineFtdsInput" type="number" step="1" value="0" placeholder="z. B. 120">
            </div>
          </div>
          <p class="amkz-form-hint">Hybrid: Pauschale für die ersten X FTDs – jede weitere FTD läuft über CPA + RevShare.</p>

          <div class="amkz-input-group">
            <label>Notiz</label>
            <textarea id="amkzCasinoNoteInput"></textarea>
          </div>

          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>
    `);

    byId("amkzCasinoForm")?.addEventListener("submit", async (event) => {
      event.preventDefault();

      // Schloss gegen Doppelklick — dieselbe Begründung wie beim Eintrag:
      // ein zweiter Klick legt sonst einen zweiten Datensatz an.
      const formular = event.currentTarget;
      if (formular.dataset.speichert === "1") return;
      formular.dataset.speichert = "1";
      const knopf = formular.querySelector('button[type="submit"]');
      const knopfText = knopf ? knopf.textContent : "";
      if (knopf) { knopf.disabled = true; knopf.textContent = "Speichert …"; }

      try {
        await saveCasino({
          name: value("amkzCasinoNameInput"),
          partnerGroupId: value("amkzCasinoPartnerInput"),
          status: value("amkzCasinoStatusInput"),
          dealType: value("amkzCasinoDealTypeInput"),
          revsharePercent: value("amkzCasinoRevshareInput"),
          cpaAmount: value("amkzCasinoCpaInput"),
          baselineAmount: value("amkzCasinoBaselineInput"),
          baselineFtds: value("amkzCasinoBaselineFtdsInput"),
          note: value("amkzCasinoNoteInput"),
        });

        AMKZ.modal.close();
        AMKZ.toast("Gespeichert", "Casino wurde erstellt.");
        await loadCasinosView();
      } catch (error) {
        console.error(error);
        AMKZ.toast("Fehler", error.message, "error");
      } finally {
        formular.dataset.speichert = "";
        if (knopf) { knopf.disabled = false; knopf.textContent = knopfText; }
      }
    });
  }

  function renderDealsList() {
    setHTML(
      byId("amkzDealsList"),
      AMKZ.state.deals.length
        ? AMKZ.state.deals.map((deal) => `
            <div class="amkz-table-row-card">
              <strong>${escapeHtml(deal.title || "Deal")}</strong><br>
              <small>
                ${escapeHtml(getPartnerName(deal.partner_group_id) || "—")}
                · ${escapeHtml(getCasinoName(deal.casino_id) || "—")}
                · ${escapeHtml(deal.status || "active")}
              </small>
              <p>
                ${escapeHtml(deal.deal_type || "revshare")}
                · CPA ${money(deal.cpa_amount || 0)}
                · RevShare ${Number(deal.revshare_percent || 0)}%
                · Fixed ${money(deal.fixed_fee || 0)}
              </p>
            </div>
          `).join("")
        : `<div class="amkz-empty">Keine Deals vorhanden.</div>`
    );
  }

  async function openDealModal() {
    await loadBaseData(true);

    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header">
          <div>
            <h3>Deal erstellen</h3>
            <p>Deal mit Partner und/oder Casino verbinden</p>
          </div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button>
        </div>

        <form id="amkzDealForm" class="amkz-form-grid">
          <div class="amkz-input-group">
            <label>Titel</label>
            <input id="amkzDealTitleInput" required placeholder="Deal-Titel">
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Partner</label>
              <select id="amkzDealPartnerInput">${optionList(AMKZ.state.partners, "Kein Partner")}</select>
            </div>

            <div class="amkz-input-group">
              <label>Casino</label>
              <select id="amkzDealCasinoInput">${optionList(AMKZ.state.casinos, "Kein Casino", true)}</select>
            </div>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Startdatum</label>
              <input id="amkzDealStartInput" type="date">
            </div>

            <div class="amkz-input-group">
              <label>Enddatum</label>
              <input id="amkzDealEndInput" type="date">
            </div>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Deal-Typ</label>
              <select id="amkzDealTypeInput">
                <option value="revshare">RevShare</option>
                <option value="cpa">CPA</option>
                <option value="hybrid">Hybrid</option>
                <option value="fixed">Fixed</option>
              </select>
            </div>

            <div class="amkz-input-group">
              <label>Status</label>
              <select id="amkzDealStatusInput">
                <option value="active">Aktiv</option>
                <option value="paused">Pausiert</option>
                <option value="ended">Beendet</option>
              </select>
            </div>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>RevShare %</label>
              <input id="amkzDealRevshareInput" type="number" step="0.01" value="0">
            </div>

            <div class="amkz-input-group">
              <label>CPA-Betrag</label>
              <input id="amkzDealCpaInput" type="number" step="0.01" value="0">
            </div>
          </div>

          <div class="amkz-input-group">
            <label>Fixbetrag</label>
            <input id="amkzDealFixedInput" type="number" step="0.01" value="0">
          </div>
          <p class="amkz-form-hint">Hybrid-Pauschale (Betrag + Baseline-FTDs) wird beim <b>Casino</b> gepflegt – sie treibt die Soll-Berechnung.</p>

          <div class="amkz-input-group">
            <label>Notiz</label>
            <textarea id="amkzDealNoteInput"></textarea>
          </div>

          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>
    `);

    const partnerSelect = byId("amkzDealPartnerInput");
    const casinoSelect = byId("amkzDealCasinoInput");

    partnerSelect?.addEventListener("change", () => {
      const partnerId = partnerSelect.value;
      const filteredCasinos = partnerId
        ? AMKZ.state.casinos.filter((casino) => casino.partner_group_id === partnerId)
        : AMKZ.state.casinos;

      casinoSelect.innerHTML = optionList(filteredCasinos, "Kein Casino", true);
    });

    byId("amkzDealForm")?.addEventListener("submit", async (event) => {
      event.preventDefault();

      // Schloss gegen Doppelklick — dieselbe Begründung wie beim Eintrag:
      // ein zweiter Klick legt sonst einen zweiten Datensatz an.
      const formular = event.currentTarget;
      if (formular.dataset.speichert === "1") return;
      formular.dataset.speichert = "1";
      const knopf = formular.querySelector('button[type="submit"]');
      const knopfText = knopf ? knopf.textContent : "";
      if (knopf) { knopf.disabled = true; knopf.textContent = "Speichert …"; }

      try {
        await saveDeal({
          partnerGroupId: value("amkzDealPartnerInput"),
          casinoId: value("amkzDealCasinoInput"),
          title: value("amkzDealTitleInput"),
          dealType: value("amkzDealTypeInput"),
          revsharePercent: value("amkzDealRevshareInput"),
          cpaAmount: value("amkzDealCpaInput"),
          fixedFee: value("amkzDealFixedInput"),
          startDate: value("amkzDealStartInput"),
          endDate: value("amkzDealEndInput"),
          status: value("amkzDealStatusInput"),
          note: value("amkzDealNoteInput"),
        });

        AMKZ.modal.close();
        AMKZ.toast("Gespeichert", "Deal wurde erstellt.");
        await loadPartnersView();
      } catch (error) {
        console.error(error);
        AMKZ.toast("Fehler", error.message, "error");
      } finally {
        formular.dataset.speichert = "";
        if (knopf) { knopf.disabled = false; knopf.textContent = knopfText; }
      }
    });
  }

  async function refreshAfterStructureChange() {
    await loadBaseData(true);

    if (AMKZ.state.currentView === "dashboard") await loadDashboard();
    if (AMKZ.state.currentView === "entries") await loadEntriesView();
    if (AMKZ.state.currentView === "daily") await loadDailyView();
  }

  /* =====================================================
     FINANCE
  ===================================================== */

  const DOC_BUCKET = "amk-documents";

  async function loadFinanceView() {
    await loadBaseData(false);

    const [entries, invoices, contracts] = await Promise.all([
      loadEntries({ date: null, limit: 0 }),
      loadFinanceDocuments("invoice"),
      loadFinanceDocuments("contract"),
    ]);

    const expenses = entries.filter(
      (entry) => String(entry.entry_type || "").toUpperCase() === "OPERATING_EXPENSE"
    );

    AMKZ.state.expenses = expenses;

    renderFinanceDashboard(entries, invoices, contracts, expenses);
    renderInvoicesTable(invoices);
    renderContractsList(contracts);
    renderExpensesTable(expenses);

    // EINE saubere Quelle für die Übersichts-Zahlen + Bewegungen (kein Flackern),
    // auch nach Speichern/Refresh immer frisch berechnet:
    try { AMKZ.modules?.v11?.loadFinanceCleanV11?.(); } catch (_) {}
  }

  function renderFinanceDashboard(entries, invoices, contracts, expenses) {
    /* Hier stand eine vollständige Deckungsbeitragsrechnung: jeder Eintrag
       wurde einem Deal zugeordnet (Suche über alle Deals, also für jeden
       Eintrag einmal durch die ganze Liste) und daraus Einnahmen, Kosten und
       Netto gebildet.

       Nur: die vier Ergebnisse wurden anschliessend mit `void` verworfen —
       die Zahlen auf dem Bildschirm kommen seit dem Flacker-Fix allein aus
       loadFinanceCleanV11. Gerechnet wurde trotzdem, bei jedem Öffnen, über
       sämtliche Einträge des Zeitraums.

       Deshalb raus. Gebraucht wird aus dieser Funktion nur noch der
       Rechnungs- und Vertragsstatus darunter. */
    renderFinanceInvoiceStatus(invoices, contracts);
  }

  function renderFinanceMovements(entries, invoices, expenses) {
    const movements = [
      ...entries.map((entry) => ({
        type: entry.entry_type,
        title: `${entry.entry_type} · ${entry.casino_name || getCasinoName(entry.casino_id) || "—"}`,
        amount: safeNumber(entry.amount),
        date: entry.entry_date,
        status: entry.payment_status || "open",
      })),
      ...invoices.map((invoice) => ({
        type: "INVOICE",
        title: invoice.title || "Rechnung",
        amount: safeNumber(invoice.amount),
        date: invoice.document_date,
        status: invoice.status || "open",
      })),
      ...expenses.map((expense) => ({
        type: "EXPENSE",
        title: expense.note || "Ausgabe",
        amount: -Math.abs(safeNumber(expense.amount)),
        date: expense.entry_date,
        status: expense.payment_status || "open",
      })),
    ]
      .sort((a, b) => String(b.date || "").localeCompare(String(a.date || "")))
      .slice(0, 12);

    setHTML(
      byId("amkzFinanceMovementsList"),
      movements.length
        ? movements.map((item) => `
            <div class="amkz-table-row-card">
              <strong>${escapeHtml(item.title)}</strong><br>
              <small>${escapeHtml(item.date || "—")} · ${escapeHtml(item.status || "open")}</small>
              <p>${money(item.amount)}</p>
            </div>
          `).join("")
        : `<div class="amkz-empty">Keine Finanzbewegungen vorhanden.</div>`
    );
  }

  function renderFinanceInvoiceStatus(invoices, contracts) {
    // Nur Rechnungen des gewählten Finance-Monats zählen (konsistent mit der Monats-Übersicht)
    let m = AMKZ.state.financeMonth;
    if (m === undefined) { const d = new Date(); m = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0"); }
    const inMonth = (m && m !== "all") ? (invoices || []).filter((i) => String(i.document_date || "").slice(0, 7) === m) : (invoices || []);
    const openCount = inMonth.filter((invoice) => String(invoice.status || "open").toLowerCase() !== "paid").length;
    const paidCount = inMonth.filter((invoice) => String(invoice.status || "").toLowerCase() === "paid").length;

    setHTML(
      byId("amkzFinanceInvoiceStatusList"),
      `
        <div class="amkz-table-row-card">
          <strong>${openCount} ${openCount === 1 ? "offene Rechnung" : "offene Rechnungen"}</strong><br>
          <small>müssen noch geprüft/bezahlt werden</small>
        </div>

        <div class="amkz-table-row-card">
          <strong>${paidCount} ${paidCount === 1 ? "bezahlte Rechnung" : "bezahlte Rechnungen"}</strong><br>
          <small>abgeschlossen</small>
        </div>

        <div class="amkz-table-row-card">
          <strong>${contracts.length} ${contracts.length === 1 ? "Vertrag" : "Verträge"}</strong><br>
          <small>hinterlegt im System</small>
        </div>
      `
    );
  }

  function renderInvoicesTable(invoices) {
    setHTML(
      byId("amkzInvoicesTableBody"),
      invoices.length
        ? invoices.map((invoice) => `
            <tr>
              <td>${escapeHtml(invoice.document_date || "—")}</td>
              <td>${escapeHtml(invoice.title || "Rechnung")}</td>
              <td>${escapeHtml(invoice.partner_name || getPartnerName(invoice.partner_group_id) || "—")}</td>
              <td>${escapeHtml(invoice.casino_name || getCasinoName(invoice.casino_id) || "—")}</td>
              <td>${money(invoice.amount || 0)}</td>
              <td><span class="amkz-status-pill">${escapeHtml(invoice.status || "open")}</span></td>
              <td>
                ${
                  invoice.file_url
                    ? `<a class="amkz-doc-link" href="${escapeHtml(invoice.file_url)}" target="_blank" rel="noopener">Öffnen</a>`
                    : "—"
                }
              </td>
            </tr>
          `).join("")
        : `<tr><td colspan="7"><div class="amkz-empty">Keine Rechnungen vorhanden.</div></td></tr>`
    );
  }

  function renderContractsList(contracts) {
    setHTML(
      byId("amkzContractsList"),
      contracts.length
        ? contracts.map((contract) => `
            <div class="amkz-table-row-card">
              <strong>${escapeHtml(contract.title || "Vertrag")}</strong><br>
              <small>
                ${escapeHtml([contract.partner_name, getPartnerName(contract.partner_group_id)].find(function (n) { return n && n !== "—"; }) || "Kein Partner")}
                ${contract.casino_name ? `· ${escapeHtml(contract.casino_name)}` : ""}
                · ${escapeHtml(({ open: "Offen", paid: "Bezahlt", sent: "Gestellt / Gesendet", signed: "Unterschrieben", archived: "Archiviert" })[contract.status || "open"] || contract.status)}
                ${contract.document_date ? `· ${escapeHtml(String(contract.document_date).replace(/^(\d{4})-(\d{2})-(\d{2}).*$/, "$3.$2.$1"))}` : ""}
              </small>
              <p>${money(contract.amount || 0)}</p>
              ${
                contract.file_url
                  ? `<a class="amkz-doc-link" href="${escapeHtml(contract.file_url)}" target="_blank" rel="noopener">Datei öffnen</a>`
                  : `<small>Keine Datei hinterlegt</small>`
              }
              ${contract.note ? `<p>${escapeHtml(contract.note)}</p>` : ""}
            </div>
          `).join("")
        : `<div class="amkz-empty">Keine Verträge vorhanden.</div>`
    );
  }

  function renderExpensesTable(expenses) {
    setHTML(
      byId("amkzExpensesTableBody"),
      expenses.length
        ? expenses.map((expense) => `
            <tr>
              <td>${escapeHtml(expense.entry_date || "—")}</td>
              <td>${escapeHtml(expense.partner_name || getPartnerName(expense.partner_group_id) || "—")}</td>
              <td>${escapeHtml(expense.casino_name || getCasinoName(expense.casino_id) || "—")}</td>
              <td>${money(expense.amount || 0)}</td>
              <td>${escapeHtml(expense.note || "—")}</td>
              <td><span class="amkz-status-pill">${escapeHtml(expense.payment_status || "open")}</span></td>
            </tr>
          `).join("")
        : `<tr><td colspan="6"><div class="amkz-empty">Keine Ausgänge vorhanden.</div></td></tr>`
    );
  }

  async function openFinanceDocumentModal(type = "invoice") {
    await loadBaseData(true);

    const isContract = type === "contract";

    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header">
          <div>
            <h3>${isContract ? "Vertrag eintragen" : "Rechnung eintragen"}</h3>
            <p>Dokument mit Betrag, Partner, Casino und Datei erfassen</p>
          </div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button>
        </div>

        <form id="amkzFinanceDocumentForm" class="amkz-form-grid">
          <div class="amkz-input-group">
            <label>Titel</label>
            <input id="amkzFinanceDocTitle" required placeholder="${isContract ? "Vertragsname" : "Rechnungsname"}">
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Datum</label>
              <input id="amkzFinanceDocDate" type="date" value="${today()}">
            </div>

            <div class="amkz-input-group">
              <label>Betrag</label>
              <input id="amkzFinanceDocAmount" type="number" step="0.01" value="0">
            </div>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Partner</label>
              <select id="amkzFinanceDocPartner">${optionList(AMKZ.state.partners, "Kein Partner")}</select>
            </div>

            <div class="amkz-input-group">
              <label>Casino</label>
              <select id="amkzFinanceDocCasino">${optionList(AMKZ.state.casinos, "Kein Casino", true)}</select>
            </div>
          </div>

          <div class="amkz-input-group">
            <label>Status</label>
            <select id="amkzFinanceDocStatus">
              <option value="open">Offen</option>
              <option value="paid">Bezahlt</option>
              <option value="sent">Gestellt / Gesendet</option>
              <option value="signed">Unterschrieben</option>
              <option value="archived">Archiviert</option>
            </select>
          </div>

          <div class="amkz-input-group">
            <label>Datei hochladen</label>
            <input id="amkzFinanceDocFile" type="file">
          </div>

          <div class="amkz-input-group">
            <label>Oder Datei URL</label>
            <input id="amkzFinanceDocUrl" type="url" placeholder="https://...">
          </div>

          <div class="amkz-input-group">
            <label>Notiz</label>
            <textarea id="amkzFinanceDocNote"></textarea>
          </div>

          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>
    `);

    byId("amkzFinanceDocumentForm")?.addEventListener("submit", async (event) => {
      event.preventDefault();

      try {
        const fileInfo = await resolveDocumentFile(type);

        await saveFinanceDocument({
          documentType: type,
          title: value("amkzFinanceDocTitle"),
          partnerGroupId: value("amkzFinanceDocPartner"),
          casinoId: value("amkzFinanceDocCasino"),
          documentDate: value("amkzFinanceDocDate"),
          amount: value("amkzFinanceDocAmount"),
          status: value("amkzFinanceDocStatus"),
          fileUrl: fileInfo.fileUrl,
          fileName: fileInfo.fileName,
          note: value("amkzFinanceDocNote"),
        });

        AMKZ.modal.close();
        AMKZ.toast("Gespeichert", "Dokument wurde gespeichert.");
        await loadFinanceView();
      } catch (error) {
        console.error(error);
        AMKZ.toast("Fehler", error.message, "error");
      }
    });
  }

  async function resolveDocumentFile(type) {
    const file = byId("amkzFinanceDocFile")?.files?.[0];
    const url = value("amkzFinanceDocUrl");

    if (!file && url) {
      return {
        fileUrl: url,
        fileName: url.split("/").pop() || url,
      };
    }

    if (!file) {
      return {
        fileUrl: "",
        fileName: "",
      };
    }

    const safeName = file.name.replace(/[^\w.\-äöüÄÖÜß]/g, "_");
    const path = `${type}/${Date.now()}_${safeName}`;

    const { error } = await AMKZ.supabase.storage
      .from(DOC_BUCKET)
      .upload(path, file, { upsert: true });

    if (error) throw error;

    const { data } = AMKZ.supabase.storage.from(DOC_BUCKET).getPublicUrl(path);

    return {
      fileUrl: data?.publicUrl || "",
      fileName: file.name,
    };
  }

  function switchFinanceTab(tab) {
    document.querySelectorAll(".amkz-finance-tab").forEach((button) => {
      button.classList.toggle("active", button.dataset.financeTab === tab);
    });

    byId("amkzFinanceOverviewPanel")?.classList.toggle("is-hidden", tab !== "overview");
    byId("amkzFinanceInvoicesPanel")?.classList.toggle("is-hidden", tab !== "invoices");
    byId("amkzFinanceContractsPanel")?.classList.toggle("is-hidden", tab !== "contracts");
    byId("amkzFinanceExpensesPanel")?.classList.toggle("is-hidden", tab !== "expenses");
  }

  /* =====================================================
     EVENTS
  ===================================================== */

  function bindQuickEntryForm() {
    const form = byId("amkzQuickEntryForm");
    if (!form || form.dataset.bound) return;

    form.dataset.bound = "true";

    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      /* Ohne Schloss legt jeder zweite Klick — oder ein zweites Enter, während
         die Leitung hakt — einen zweiten Eintrag an. Bei FTDs sind das doppelt
         gezählte Einzahlungen in jeder Auswertung. */
      if (form.dataset.speichert === "1") return;
      form.dataset.speichert = "1";
      const knopf = form.querySelector('button[type="submit"]');
      const knopfText = knopf ? knopf.textContent : "";
      if (knopf) { knopf.disabled = true; knopf.textContent = "Speichert …"; }

      try {
        await saveEntry({
          entryDate: selectedDate(),
          entryType: value("amkzQuickEntryType"),
          partnerGroupId: value("amkzQuickEntryPartner"),
          casinoId: value("amkzQuickEntryCasino"),
          dealId: value("amkzQuickEntryDeal"),
          amount: value("amkzQuickEntryAmount"),
          note: "Schnelleintrag",
        });

        const amountInput = byId("amkzQuickEntryAmount");
        if (amountInput) amountInput.value = "";

        AMKZ.toast("Gespeichert", "Eintrag wurde gespeichert.");
        await AMKZ.loadView(AMKZ.state.currentView, { force: true });
      } catch (error) {
        console.error(error);
        AMKZ.toast("Fehler", error.message, "error");
      } finally {
        form.dataset.speichert = "";
        if (knopf) { knopf.disabled = false; knopf.textContent = knopfText; }
      }
    });
  }

  function bindMainEvents() {
    const dashLimit = byId("amkzDashboardEntriesLimit");
    if (dashLimit && !dashLimit.dataset.bound) {
      dashLimit.dataset.bound = "true";
      dashLimit.addEventListener("change", loadDashboard);
    }

    const entryLimit = byId("amkzEntriesLimit");
    if (entryLimit && !entryLimit.dataset.bound) {
      entryLimit.dataset.bound = "true";
      entryLimit.addEventListener("change", loadEntriesView);
    }

    const actualButton = byId("amkzCreateActualDataButton");
    if (actualButton && !actualButton.dataset.bound) {
      actualButton.dataset.bound = "true";
      actualButton.addEventListener("click", openActualDataModal);
    }

    const buttons = [
      ["amkzOpenEntryModalButton", () => openEntryModal("FTD")],
      ["amkzCreateEntryButton", () => openEntryModal("FTD")],
      ["amkzCreatePartnerButton", openPartnerModal],
      ["amkzCreateCasinoButton", openCasinoModal],
      ["amkzCreateDealButton", openDealModal],
      ["amkzCreateInvoiceButton", () => openFinanceDocumentModal("invoice")],
      ["amkzCreateContractButton", () => openFinanceDocumentModal("contract")],
      ["amkzCreateExpenseButton", () => openEntryModal("OPERATING_EXPENSE")],
    ];

    buttons.forEach(([id, handler]) => {
      const button = byId(id);
      if (button && !button.dataset.bound) {
        button.dataset.bound = "true";
        button.addEventListener("click", handler);
      }
    });

    document.querySelectorAll("[data-finance-tab]").forEach((button) => {
      if (button.dataset.bound) return;
      button.dataset.bound = "true";
      button.addEventListener("click", () => switchFinanceTab(button.dataset.financeTab));
    });

    if (!document.body.dataset.amkzActionBound) {
      document.body.dataset.amkzActionBound = "true";

      document.addEventListener("click", (event) => {
        const action = event.target.closest("[data-amkz-action]")?.dataset.amkzAction;
        if (!action) return;

        if (action === "ftd") openEntryModal("FTD");
        if (action === "redepo") openEntryModal("REDEPO");
        if (action === "expense") openEntryModal("OPERATING_EXPENSE");
        if (action === "income") openEntryModal("INCOME");
        if (action === "partner") openPartnerModal();
        if (action === "casino") openCasinoModal();
        if (action === "deal") openDealModal();
      });
    }
  }

  /* =====================================================
     VIEW EXTENSION
  ===================================================== */

  const previousLoadView = AMKZ.loadView;

  AMKZ.loadView = async function loadViewPart2(view, options = {}) {
    if (typeof previousLoadView === "function") {
      await previousLoadView(view, options);
    }

    await loadBaseData(options.force === true);
    hydrateDropdowns();
    bindDropdownEvents();
    bindQuickEntryForm();
    bindMainEvents();

    if (view === "dashboard") await loadDashboard();
    if (view === "entries") await loadEntriesView();
    if (view === "daily") await loadDailyView();
    if (view === "partners") await loadPartnersView();
    if (view === "casinos") await loadCasinosView();
    if (view === "finance") await loadFinanceView();
  };

  /* =====================================================
     PUBLIC MODULES
  ===================================================== */

  AMKZ.modules = AMKZ.modules || {};

  AMKZ.modules.dashboard = {
    loadDashboard,
    summarizeEntries,
    calculateExpectedProfit,
    summarizeActualRows,
  };

  AMKZ.modules.entries = {
    loadEntriesView,
    renderEntriesTable,
  };

  AMKZ.modules.daily = {
    loadDailyView,
    openActualDataModal,
    renderDailyAnalysis,
  };

  AMKZ.modules.structure = {
    openEntryModal,
    openPartnerModal,
    openCasinoModal,
    openDealModal,
    loadPartnersView,
    loadCasinosView,
  };

  AMKZ.modules.finance = {
    loadFinanceView,
    openFinanceDocumentModal,
    switchFinanceTab,
  };
})();

/* =====================================================
   AMK ZENTRALE — FINAL JS
   PART 3/4 — CALENDAR / TEAM / CHAT / PRESENCE / ANALYTICS
===================================================== */

(function () {
  "use strict";

  const AMKZ = window.AMKZ;
  if (!AMKZ) return;

  const {
    byId,
    escapeHtml,
    setText,
    setHTML,
    value,
    today,
    toDateKey,
    formatTime,
    formatDate,
    money,
    safeNumber,
    debounce,
  } = AMKZ.utils;

  const { rpc, selectRows } = AMKZ.api;

  /* =====================================================
     CALENDAR
  ===================================================== */

  function getMonthStart(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  function getMonthEnd(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  function getCalendarGridStart(monthStart) {
    const d = new Date(monthStart);
    const day = d.getDay();
    const mondayIndex = day === 0 ? 6 : day - 1;
    d.setDate(d.getDate() - mondayIndex);
    return d;
  }

  function addDays(date, amount) {
    const d = new Date(date);
    d.setDate(d.getDate() + amount);
    return d;
  }

  function getMonthLabel(date) {
    return date.toLocaleDateString("de-DE", {
      month: "long",
      year: "numeric",
    });
  }

  function normalizeDate(dateValue) {
    if (!dateValue) return today();
    return String(dateValue).slice(0, 10);
  }

  function formatDayLabel(dateKey) {
    return new Date(dateKey).toLocaleDateString("de-DE", {
      weekday: "long",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  async function loadCalendarView() {
    const cursor = AMKZ.state.calendarCursor || new Date();
    const monthStart = getMonthStart(cursor);
    const monthEnd = getMonthEnd(cursor);

    await Promise.all([
      AMKZ.data.loadTeam(false),
      AMKZ.data.loadCalendarEvents({
        monthStart: toDateKey(monthStart),
        monthEnd: toDateKey(monthEnd),
      }),
    ]);

    // MEINE Einladungen + deren Events laden (auch monatsübergreifend) -> in calendarEvents mergen
    await AMKZ.data.loadMyInvitesAndEvents();
    // Einladungen zu ALLEN geladenen Events laden (für Status-Chips beim Ersteller)
    await AMKZ.data.loadCalendarInvites((AMKZ.state.calendarEvents || []).map((e) => e.id).filter(Boolean));

    if (!AMKZ.state.calendarSelectedDate) {
      AMKZ.state.calendarSelectedDate = AMKZ.shared.selectedDate();
    }

    renderCalendarMonth();
    renderPendingInvites();
    renderSelectedDayEvents();
  }

  function renderCalendarMonth() {
    const cursor = AMKZ.state.calendarCursor || new Date();
    const monthStart = getMonthStart(cursor);
    const gridStart = getCalendarGridStart(monthStart);

    setText(byId("amkzCalendarMonthLabel"), getMonthLabel(cursor));
    setText(
      byId("amkzCalendarSelectedLabel"),
      `Ausgewählt: ${formatDayLabel(AMKZ.state.calendarSelectedDate || today())}`
    );

    const days = [];

    for (let i = 0; i < 42; i++) {
      days.push(addDays(gridStart, i));
    }

    setHTML(
      byId("amkzCalendarMonthGrid"),
      days.map((date) => renderCalendarDay(date, cursor)).join("")
    );
  }

  function renderCalendarDay(date, cursor) {
    const dateKey = toDateKey(date);
    const selected = dateKey === AMKZ.state.calendarSelectedDate;
    const isToday = dateKey === today();
    const outside = date.getMonth() !== cursor.getMonth();

    const events = getEventsForDate(dateKey);

    return `
      <button
        type="button"
        class="amkz-calendar-day ${outside ? "outside" : ""} ${isToday ? "today" : ""} ${selected ? "active" : ""}"
        data-calendar-date="${dateKey}"
      >
        <div class="amkz-calendar-day-number">
          <span>${date.getDate()}</span>
          ${events.length ? `<small>${events.length}</small>` : ""}
        </div>

        ${events
          .slice(0, 3)
          .map(
            (event) => `
              <span class="amkz-calendar-event-dot">
                ${escapeHtml(event.title || "Termin")}
              </span>
            `
          )
          .join("")}
      </button>
    `;
  }

  function isVacationEvent(ev) { return String((ev && ev.event_type) || "").toLowerCase() === "urlaub"; }
  // Genehmigungs-Status eines Urlaubsantrags (calendar_event_invites = Genehmiger-Zeilen)
  function vacationApprovalState(ev) {
    const invites = (AMKZ.state.calendarInvites || {})[ev && ev.id] || [];
    const total = invites.length;
    const accepted = invites.filter((i) => i.status === "accepted").length;
    const declined = invites.filter((i) => i.status === "declined").length;
    const statusOk = ["approved", "genehmigt"].includes(String((ev && ev.status) || "").toLowerCase());
    return {
      invites, total, accepted, declined,
      pending: Math.max(0, total - accepted - declined),
      approved: statusOk || (total > 0 && accepted === total),
      rejected: declined > 0,
    };
  }

  function getEventsForDate(dateKey) {
    const myId = AMKZ.state.member?.id;
    return (AMKZ.state.calendarEvents || []).filter((event) => {
      const startKey = normalizeDate(event.event_date || event.starts_at);
      const endKey = event.ends_at ? normalizeDate(event.ends_at) : startKey;
      // mehrtägige Events (Von–Bis) erscheinen an JEDEM Tag im Zeitraum
      if (!(dateKey >= startKey && dateKey <= endKey)) return false;
      // Urlaub: für ALLE erst sichtbar, wenn alle Genehmiger zugestimmt haben.
      // Vorher nur für Beteiligte (Antragsteller + Genehmiger), damit sie den Status sehen.
      if (isVacationEvent(event)) {
        const st = vacationApprovalState(event);
        if (st.approved) return true;
        return event.created_by === myId || event.assigned_to === myId ||
               st.invites.some((i) => i.user_id === myId);
      }
      return true;
    });
  }

  function ensureInvitesBox() {
    let box = byId("amkzCalendarInvitesBox");
    if (box) return box;
    const list = byId("amkzCalendarEventList");
    if (!list || !list.parentElement) return null;
    box = document.createElement("div");
    box.id = "amkzCalendarInvitesBox";
    box.className = "amkz-cal-invites-box is-hidden";
    list.parentElement.insertBefore(box, list);
    return box;
  }
  // Offene Einladungen an MICH — immer sichtbar oben im Kalender (mit Bestätigen/Ablehnen)
  function renderPendingInvites() {
    const box = ensureInvitesBox();
    if (!box) return;
    const pending = (AMKZ.state.myInvites || []).filter((i) => i.status === "pending");
    if (!pending.length) { box.innerHTML = ""; box.classList.add("is-hidden"); return; }
    box.classList.remove("is-hidden");
    const rows = pending.map((inv) => {
      const ev = (AMKZ.state.calendarEvents || []).find((e) => e.id === inv.event_id);
      const vac = isVacationEvent(ev) || String(inv.title || "").toLowerCase().startsWith("urlaub");
      const title = ev?.title || inv.title || "Termin";
      const when = ev ? fmtEventWhen(ev) : "";
      const inviter = getAssignedName(inv.inviter_id) || "Jemand";
      const meta = vac ? `Urlaubsantrag von ${escapeHtml(inviter)}` : `von ${escapeHtml(inviter)}`;
      return `<div class="amkz-cal-invite-card${vac ? " amkz-cal-vacation" : ""}">
        <div class="amkz-cal-invite-info"><strong>${vac ? "🏖 " : ""}${escapeHtml(title)}</strong><small>${meta}${when ? " · " + escapeHtml(when) : ""}</small></div>
        <div class="amkz-cal-rsvp">
          <button type="button" class="amkz-cal-accept" data-cal-rsvp="accepted" data-event="${escapeHtml(inv.event_id)}">${vac ? "Genehmigen" : "Bestätigen"}</button>
          <button type="button" class="amkz-cal-decline" data-cal-rsvp="declined" data-event="${escapeHtml(inv.event_id)}">Ablehnen</button>
        </div>
      </div>`;
    }).join("");
    box.innerHTML = `<div class="amkz-cal-invites-head">📩 Deine Anträge & Einladungen (${pending.length})</div>${rows}`;
  }

  function renderSelectedDayEvents() {
    const dateKey = AMKZ.state.calendarSelectedDate || today();
    const events = getEventsForDate(dateKey);

    setText(byId("amkzCalendarDayTitle"), formatDayLabel(dateKey));

    setHTML(
      byId("amkzCalendarEventList"),
      events.length
        ? events.map(renderEventCard).join("")
        : `<div class="amkz-empty">Keine Termine an diesem Tag.</div>`
    );
  }

  function renderEventCard(event) {
    const assignedName = getAssignedName(event.assigned_to);
    const myId = AMKZ.state.member?.id;
    const invites = (AMKZ.state.calendarInvites || {})[event.id] || [];
    const mine = invites.find((i) => i.user_id === myId);
    const isCreator = event.created_by && event.created_by === myId;
    const when = fmtEventWhen(event);
    const vac = isVacationEvent(event);
    const vst = vac ? vacationApprovalState(event) : null;

    // Personen + Status (Chips) — bei Urlaub = Genehmiger
    let inviteeHtml = "";
    if (invites.length) {
      const chips = invites.map((i) => {
        const name = getAssignedName(i.user_id) || (vac ? "Genehmiger" : "Teilnehmer");
        const cls = i.status === "accepted" ? "ok" : i.status === "declined" ? "no" : "pending";
        const ic = i.status === "accepted" ? "✓" : i.status === "declined" ? "✕" : "⏳";
        return `<span class="amkz-cal-invitee ${cls}">${ic} ${escapeHtml(name)}</span>`;
      }).join("");
      inviteeHtml = `<div class="amkz-cal-invitees"><small>${vac ? "Genehmiger:" : "Eingeladen:"}</small>${chips}</div>`;
    }

    // RSVP / Genehmigung (wenn ich eingeladen/Genehmiger bin und nicht selbst der Ersteller)
    let rsvpHtml = "";
    if (mine && !isCreator) {
      const q = vac
        ? `🏖 ${escapeHtml(getAssignedName(event.created_by || event.assigned_to) || "Mitarbeiter")} beantragt Urlaub — genehmigen?`
        : "Du bist eingeladen — kommst du?";
      rsvpHtml = mine.status === "pending"
        ? `<div class="amkz-cal-rsvp">
             <span class="amkz-cal-rsvp-q">${q}</span>
             <button type="button" class="amkz-cal-accept" data-cal-rsvp="accepted" data-event="${escapeHtml(event.id)}">${vac ? "Genehmigen" : "Bestätigen"}</button>
             <button type="button" class="amkz-cal-decline" data-cal-rsvp="declined" data-event="${escapeHtml(event.id)}">Ablehnen</button>
           </div>`
        : `<div class="amkz-cal-rsvp"><span class="amkz-cal-myresp ${mine.status === "accepted" ? "ok" : "no"}">${mine.status === "accepted" ? (vac ? "✓ Von dir genehmigt" : "✓ Du hast zugesagt") : (vac ? "✕ Von dir abgelehnt" : "✕ Du hast abgelehnt")}</span></div>`;
    }

    // Status-Zeile: bei Urlaub Genehmigungs-Fortschritt statt rohem Status
    let statusLine;
    if (vac) {
      const badge = vst.approved ? "✅ Genehmigt" : vst.rejected ? "❌ Abgelehnt" : `⏳ Genehmigung ${vst.accepted}/${vst.total || 3}`;
      statusLine = `🏖 Urlaub · ${badge}${when ? " · " + escapeHtml(when) : ""}`;
    } else {
      statusLine = `${escapeHtml(event.event_type || "general")} · ${escapeHtml(event.status || "scheduled")}${when ? " · " + escapeHtml(when) : ""}`;
    }
    const vacCls = vac ? " amkz-cal-vacation " + (vst.approved ? "is-approved" : vst.rejected ? "is-rejected" : "is-pending") : "";

    return `
      <div class="amkz-table-row-card amkz-cal-event${vacCls}">
        <strong>${escapeHtml(event.title || "Termin")}</strong><br>
        <small>${statusLine}</small>
        ${assignedName ? `<p>Zuständig: ${escapeHtml(assignedName)}</p>` : ""}
        ${event.description ? `<p>${escapeHtml(event.description)}</p>` : ""}
        ${inviteeHtml}
        ${rsvpHtml}
      </div>
    `;
  }

  function getAssignedName(userId) {
    if (!userId) return "";
    const user = (AMKZ.state.team || []).find((member) => member.id === userId);
    return user?.name || user?.email || "";
  }

  // Direkte Nachricht + Mitteilung (Glocke) + Push an einen User (Einladungen/Antworten)
  async function amkNotifyUser(userId, title, text) {
    if (!userId || !AMKZ.supabase) return;
    const myId = AMKZ.state.member?.id;
    try {
      if (myId && userId !== myId) {
        const { data: conv } = await AMKZ.supabase.rpc("amk_get_or_create_conversation", { p_user_a: myId, p_user_b: userId });
        const convId = conv?.id || (Array.isArray(conv) ? conv[0]?.id : null);
        if (convId) {
          await AMKZ.supabase.rpc("amk_send_message", { p_conversation_id: convId, p_sender_id: myId, p_receiver_id: userId, p_message: text, p_client_temp_id: `cal_${Date.now()}_${Math.random().toString(36).slice(2)}` });
        }
      }
    } catch (e) { console.warn("[calendar] notify msg", e); }
    try { await AMKZ.supabase.from("notifications").insert({ target_user_id: userId, created_for: userId, type: "calendar", title, message: text, is_read: false, created_at: new Date().toISOString(), payload: { from: myId, push: "false" } }); } catch (_) {}
    try { window.AMK_SEND_PUSH?.(userId, title, text, { from: myId }); } catch (_) {}
  }
  // Global nutzbar (z. B. Stream-Änderungsantrag -> Connect mit Buttons)
  AMKZ.connectNotify = amkNotifyUser;

  // "Von–Bis" hübsch formatieren (gleicher Tag -> nur Endzeit, sonst volles Enddatum)
  function fmtEventWhen(ev) {
    const s = ev?.starts_at ? new Date(ev.starts_at) : null;
    const e = ev?.ends_at ? new Date(ev.ends_at) : null;
    if (!s || isNaN(s)) return "";
    const optD = { day: "2-digit", month: "short" }, optT = { hour: "2-digit", minute: "2-digit" };
    const sStr = s.toLocaleDateString("de-DE", optD) + " " + s.toLocaleTimeString("de-DE", optT);
    if (!e || isNaN(e)) return sStr;
    const sameDay = s.toDateString() === e.toDateString();
    const eStr = sameDay ? e.toLocaleTimeString("de-DE", optT) : (e.toLocaleDateString("de-DE", optD) + " " + e.toLocaleTimeString("de-DE", optT));
    return sStr + " – " + eStr;
  }

  // Eingeladene Person sagt zu/ab -> Status speichern + Ersteller automatisch benachrichtigen
  async function respondToEvent(eventId, statusVal) {
    const myId = AMKZ.state.member?.id;
    if (!eventId || !myId) return;
    const invites = (AMKZ.state.calendarInvites || {})[eventId] || [];
    const mine = invites.find((i) => i.user_id === myId);
    const ev = (AMKZ.state.calendarEvents || []).find((e) => e.id === eventId);
    const title = mine?.title || ev?.title || "Termin";
    try {
      await AMKZ.supabase.from("calendar_event_invites")
        .update({ status: statusVal, responded_at: new Date().toISOString() })
        .eq("event_id", eventId).eq("user_id", myId);
    } catch (e) { AMKZ.toast?.("Fehler", e.message || "Antwort konnte nicht gespeichert werden (SQL ausgeführt?).", "error"); return; }
    if (mine) mine.status = statusVal;
    const myInv = (AMKZ.state.myInvites || []).find((i) => i.event_id === eventId && i.user_id === myId);
    if (myInv) myInv.status = statusVal;
    const inviterId = mine?.inviter_id || myInv?.inviter_id || ev?.created_by;
    const myName = AMKZ.state.member?.name || AMKZ.state.member?.email || "Jemand";
    const vac = isVacationEvent(ev);
    if (inviterId && inviterId !== myId) {
      const txt = vac
        ? (statusVal === "accepted"
            ? `✅ ${myName} hat deinen Urlaubsantrag „${title}" GENEHMIGT.`
            : `❌ ${myName} hat deinen Urlaubsantrag „${title}" ABGELEHNT.`)
        : (statusVal === "accepted"
            ? `✅ ${myName} hat deine Einladung zu „${title}" ZUGESAGT.`
            : `❌ ${myName} hat deine Einladung zu „${title}" ABGELEHNT.`);
      await amkNotifyUser(inviterId, statusVal === "accepted" ? (vac ? "✅ Genehmigt" : "✅ Zusage") : (vac ? "❌ Abgelehnt" : "❌ Absage"), txt);
    }
    // Urlaub: bei VOLLSTÄNDIGER Genehmigung / Ablehnung den Antragsteller final informieren
    if (vac) {
      const st = vacationApprovalState(ev);
      const requesterId = ev?.created_by || ev?.assigned_to;
      if (requesterId && requesterId !== myId) {
        if (st.approved) {
          await amkNotifyUser(requesterId, "🏖 Urlaub genehmigt", `Dein Urlaub „${title}" wurde von ALLEN Genehmigern bestätigt und ist jetzt im Kalender sichtbar.`);
        } else if (statusVal === "declined") {
          await amkNotifyUser(requesterId, "🏖 Urlaub abgelehnt", `Dein Urlaubsantrag „${title}" wurde von ${myName} abgelehnt.`);
        }
      }
    }
    AMKZ.toast?.(statusVal === "accepted" ? (vac ? "Genehmigt" : "Zugesagt") : "Abgelehnt", "Antwort wurde gesendet.");
    renderPendingInvites();
    renderSelectedDayEvents();
  }

  async function openCalendarModal(dateOverride = null) {
    await AMKZ.data.loadTeam(false);

    const eventDate =
      dateOverride ||
      AMKZ.state.calendarSelectedDate ||
      AMKZ.shared.selectedDate();

    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header">
          <div>
            <h3>Termin erstellen</h3>
            <p>Planung, Meeting, Stream oder Aufgabe eintragen</p>
          </div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button>
        </div>

        <form id="amkzCalendarForm" class="amkz-form-grid">
          <div class="amkz-input-group">
            <label>Titel</label>
            <input id="amkzCalendarTitleInput" required placeholder="z. B. Stream-Planung">
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Von (Datum &amp; Uhrzeit)</label>
              <input id="amkzCalendarStartDT" class="amkz-dt-input" type="datetime-local" value="${eventDate}T10:00" required>
            </div>
            <div class="amkz-input-group">
              <label>Bis (Datum &amp; Uhrzeit)</label>
              <input id="amkzCalendarEndDT" class="amkz-dt-input" type="datetime-local" value="${eventDate}T11:00" required>
            </div>
          </div>

          <div class="amkz-input-group">
            <label>Zuständig</label>
            <select id="amkzCalendarAssignedInput">
              ${AMKZ.shared.optionList(AMKZ.state.team, "Nicht zugeordnet")}
            </select>
          </div>

          <div class="amkz-input-group">
            <label>Personen einladen</label>
            <div id="amkzCalendarInviteList" class="amkz-cal-invite-list">
              ${(AMKZ.state.team || []).filter((m) => m.id !== AMKZ.state.member?.id).length
                ? (AMKZ.state.team || []).filter((m) => m.id !== AMKZ.state.member?.id).map((m) =>
                    `<label class="amkz-cal-invite-pick"><input type="checkbox" class="amkz-cal-invite-cb" value="${escapeHtml(m.id)}"><span>${escapeHtml(m.name || m.email || "Mitarbeiter")}</span></label>`).join("")
                : `<div class="amkz-empty">Keine weiteren Mitarbeiter.</div>`}
            </div>
            <small class="amkz-form-hint">Eingeladene bekommen eine Nachricht zum Bestätigen/Ablehnen.</small>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Typ</label>
              <select id="amkzCalendarTypeInput">
                <option value="general">Allgemein</option>
                <option value="stream">Stream</option>
                <option value="meeting">Meeting</option>
                <option value="finance">Finanzen</option>
                <option value="task">Aufgabe</option>
                <option value="entry">Entry Bezug</option>
              </select>
            </div>

            <div class="amkz-input-group">
              <label>Status</label>
              <select id="amkzCalendarStatusInput">
                <option value="scheduled">Geplant</option>
                <option value="done">Erledigt</option>
                <option value="cancelled">Abgesagt</option>
              </select>
            </div>
          </div>

          <div class="amkz-input-group">
            <label>Beschreibung</label>
            <textarea id="amkzCalendarDescriptionInput" placeholder="Details…"></textarea>
          </div>

          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>
    `);

    byId("amkzCalendarForm")?.addEventListener("submit", async (event) => {
      event.preventDefault();

      try {
        const title = value("amkzCalendarTitleInput");
        const startDT = value("amkzCalendarStartDT") || `${eventDate}T10:00`;
        const endDT = value("amkzCalendarEndDT") || `${eventDate}T11:00`;
        const startDate = startDT.slice(0, 10);
        const startTime = startDT.slice(11, 16) || "10:00";
        const endDate = endDT.slice(0, 10) || startDate;
        const endTime = endDT.slice(11, 16) || "11:00";
        const invitees = Array.from(document.querySelectorAll(".amkz-cal-invite-cb:checked")).map((c) => c.value).filter(Boolean);

        const res = await AMKZ.save.saveCalendarEvent({
          title,
          description: value("amkzCalendarDescriptionInput"),
          eventDate: startDate,
          endDate,
          startTime,
          endTime,
          assignedTo: value("amkzCalendarAssignedInput"),
          eventType: value("amkzCalendarTypeInput"),
          status: value("amkzCalendarStatusInput"),
        });

        // Einladungen anlegen + jede eingeladene Person benachrichtigen
        if (invitees.length) {
          const toUtc = (d, t) => { try { return new Date(`${d}T${t}:00`).toISOString(); } catch (_) { return `${d}T${t}:00`; } };
          const startsAt = toUtc(startDate, startTime);
          let eventId = res?.id || res?.[0]?.id || (typeof res === "string" ? res : null);
          if (!eventId) {
            try {
              const { data } = await AMKZ.supabase.from("planning_calendar").select("id")
                .eq("created_by", AMKZ.state.member?.id).eq("title", title).eq("starts_at", startsAt)
                .order("created_at", { ascending: false }).limit(1);
              eventId = data?.[0]?.id || null;
            } catch (_) {}
          }
          if (eventId) {
            const myId = AMKZ.state.member?.id;
            const rows = invitees.map((uid) => ({ event_id: eventId, user_id: uid, inviter_id: myId, title, status: "pending" }));
            try { await AMKZ.supabase.from("calendar_event_invites").insert(rows); }
            catch (e) { AMKZ.toast?.("Hinweis", "Einladungen konnten nicht gespeichert werden (SQL ausgeführt?).", "error"); }
            const myName = AMKZ.state.member?.name || AMKZ.state.member?.email || "Jemand";
            const when = fmtEventWhen({ starts_at: startsAt, ends_at: toUtc(endDate, endTime) });
            for (const uid of invitees) {
              await amkNotifyUser(uid, "📅 Event-Einladung", `Hey, du wurdest von ${myName} zu „${title}" eingeladen (${when}). Im Kalender bestätigen oder ablehnen.`);
            }
          }
        }

        AMKZ.modal.close();
        AMKZ.toast("Gespeichert", invitees.length ? `Termin erstellt · ${invitees.length} eingeladen.` : "Termin wurde erstellt.");

        AMKZ.state.calendarSelectedDate = startDate;
        AMKZ.state.calendarCursor = new Date(startDate);

        await loadCalendarView();
      } catch (error) {
        console.error(error);
        AMKZ.toast("Fehler", error.message, "error");
      }
    });
  }

  function goPrevMonth() {
    const cursor = AMKZ.state.calendarCursor || new Date();
    AMKZ.state.calendarCursor = new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1);
    loadCalendarView();
  }

  function goNextMonth() {
    const cursor = AMKZ.state.calendarCursor || new Date();
    AMKZ.state.calendarCursor = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1);
    loadCalendarView();
  }

  function selectCalendarDate(dateKey) {
    AMKZ.state.calendarSelectedDate = dateKey;

    const globalDate = byId("amkzGlobalDate");
    if (globalDate) globalDate.value = dateKey;

    AMKZ.state.selectedDate = dateKey;

    renderCalendarMonth();
    renderSelectedDayEvents();
  }

  function bindCalendarEvents() {
    const prev = byId("amkzCalendarPrev");
    const next = byId("amkzCalendarNext");
    const create = byId("amkzCreateCalendarButton");
    const grid = byId("amkzCalendarMonthGrid");

    if (prev && !prev.dataset.bound) {
      prev.dataset.bound = "true";
      prev.addEventListener("click", goPrevMonth);
    }

    if (next && !next.dataset.bound) {
      next.dataset.bound = "true";
      next.addEventListener("click", goNextMonth);
    }

    if (create && !create.dataset.bound) {
      create.dataset.bound = "true";
      create.addEventListener("click", () => openCalendarModal());
    }

    if (grid && !grid.dataset.bound) {
      grid.dataset.bound = "true";

      grid.addEventListener("click", (event) => {
        const day = event.target.closest("[data-calendar-date]");
        if (!day) return;
        selectCalendarDate(day.dataset.calendarDate);
      });

      grid.addEventListener("dblclick", (event) => {
        const day = event.target.closest("[data-calendar-date]");
        if (!day) return;
        openCalendarModal(day.dataset.calendarDate);
      });
    }

    // Bestätigen/Ablehnen (greift in „Deine Einladungen" UND der Tagesliste)
    if (!document.body.dataset.calRsvpBound) {
      document.body.dataset.calRsvpBound = "true";
      document.addEventListener("click", (event) => {
        const btn = event.target.closest("[data-cal-rsvp]");
        if (!btn) return;
        event.preventDefault();
        respondToEvent(btn.getAttribute("data-event"), btn.getAttribute("data-cal-rsvp"));
      });
    }
  }

  /* =====================================================
     TEAM
  ===================================================== */

  const RIGHTS = [
    ["can_view_dashboard", "Dashboard"],
    ["can_view_entries", "Einträge"],
    ["can_view_connect", "Connect"],
    ["can_view_calendar", "Kalender"],
    ["can_view_streaming", "Streaming"],
    ["can_manage_streaming", "Streaming-Verwaltung"],
    ["can_view_casinos", "Casinos"],
    ["can_view_partners", "Partner"],
    ["can_view_affiliates", "Affiliate-Dashboards"],
    ["can_view_finance", "Finanzen"],
    ["can_view_profit", "Gewinn sehen"],
    ["can_manage_team", "Team Admin"],
  ];

  async function loadTeamView() {
    const { data, error } = await AMKZ.supabase
      .from("team_members")
      .select(await AMKZ.spalten("team_members"))
      .order("name", { ascending: true });
    if (!error) await AMKZ.mitGeheim(data, "amk_team_privat");

    if (error) {
      setHTML(byId("amkzTeamTableBody"), `<tr><td colspan="9">Fehler: ${escapeHtml(error.message)}</td></tr>`);
      return;
    }

    AMKZ.state.team = data || [];
    renderTeamRightsEditor(AMKZ.state.team);
  }

  function rightOn(user, field) {
    return (
      user[field] === true ||
      (field === "can_view_dashboard" && user[field] !== false) ||
      (field === "can_view_entries" && user[field] !== false) ||
      (field === "can_view_connect" && user[field] !== false) ||
      (field === "can_view_calendar" && user[field] !== false) ||
      (field === "can_view_streaming" && user[field] !== false) ||
      (field === "can_view_roadtrip" && user[field] !== false)
    );
  }

  function renderTeamRightsEditor(rows) {
    rows = (rows || []).filter(function (x) { return String(x.role || "").toLowerCase() !== "bot"; });   // „Tagesplaner" ist kein Kollege
    setHTML(
      byId("amkzTeamTableBody"),
      rows.length
        ? rows.map((u) => `
          <tr class="amkz-team-row-final" data-team-id="${u.id}">
            <td>
              <div class="amkz-team-user-final">
                <span>${escapeHtml((u.name || u.email || "?").charAt(0).toUpperCase())}</span>
                <div>
                  <strong>${escapeHtml(u.name || "—")}</strong>
                  <small>${escapeHtml(u.email || "")}</small>
                </div>
              </div>
            </td>

            <td>
              <select class="amkz-team-role-final" data-field="role">
                ${["employee","ftd","finance","manager","admin"].map(r => `
                  <option value="${r}" ${String(u.role) === r ? "selected" : ""}>${({ employee: "Mitarbeiter", ftd: "FTD-Mitarbeiter", finance: "Finanzen", manager: "Manager", admin: "Admin" })[r]}</option>
                `).join("")}
              </select>
            </td>

            <td>
              <button class="amkz-team-status-final ${u.is_active !== false ? "active" : ""}" data-field="is_active">
                ${u.is_active !== false ? "Aktiv" : "Inaktiv"}
              </button>
            </td>

            <td colspan="6">
              <div class="amkz-rights-grid-final">
                ${RIGHTS.map(([field, label]) => `
                  <label class="amkz-right-toggle-final ${rightOn(u, field) ? "on" : ""}">
                    <input type="checkbox" data-field="${field}" ${rightOn(u, field) ? "checked" : ""}>
                    <span>${escapeHtml(label)}</span>
                  </label>
                `).join("")}
              </div>

              <button class="amkz-save-rights-final" type="button">
                Rechte speichern
              </button>
            </td>
          </tr>
        `).join("")
        : `<tr><td colspan="9"><div class="amkz-empty">Keine Mitarbeiter vorhanden.</div></td></tr>`
    );
  }

  function permissionCheckbox(name, label, checked) {
    return `
      <label class="amkz-permission-toggle">
        <input type="checkbox" id="amkzPerm_${name}" ${checked ? "checked" : ""}>
        <span>${escapeHtml(label)}</span>
      </label>
    `;
  }

  function getChecked(name) {
    return byId(`amkzPerm_${name}`)?.checked === true;
  }

  function openMemberModal() {
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header">
          <div>
            <h3>Mitarbeiter erstellen</h3>
            <p>Login, Rolle und Bereichsfreigaben anlegen</p>
          </div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button>
        </div>

        <form id="amkzMemberForm" class="amkz-form-grid">
          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Name</label>
              <input id="amkzMemberNameInput" required placeholder="Name">
            </div>

            <div class="amkz-input-group">
              <label>E-Mail</label>
              <input id="amkzMemberEmailInput" type="email" required placeholder="email@amk.com">
            </div>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Passwort</label>
              <input id="amkzMemberPasswordInput" required placeholder="Passwort">
            </div>

            <div class="amkz-input-group">
              <label>Rolle</label>
              <select id="amkzMemberRoleInput">
                <option value="employee">Mitarbeiter</option>
                <option value="ftd">FTD-Mitarbeiter</option>
                <option value="finance">Finanzen</option>
                <option value="manager">Manager</option>
                <option value="admin">Admin</option>
              </select>
            </div>
          </div>

          <div class="amkz-card" style="margin:0;">
            <div class="amkz-card-header">
              <h3>Freigaben</h3>
            </div>

            <div class="amkz-permission-grid">
              ${permissionCheckbox("can_view_dashboard", "Dashboard", true)}
              ${permissionCheckbox("can_view_entries", "Einträge", true)}
              ${permissionCheckbox("can_view_connect", "Connect", true)}
              ${permissionCheckbox("can_view_calendar", "Kalender", true)}
              ${permissionCheckbox("can_view_streaming", "Streaming", true)}
              ${permissionCheckbox("can_manage_streaming", "Streaming-Verwaltung", false)}
              ${permissionCheckbox("can_view_casinos", "Casinos", false)}
              ${permissionCheckbox("can_view_partners", "Partner", false)}
              ${permissionCheckbox("can_view_finance", "Finanzen", false)}
              ${permissionCheckbox("can_view_profit", "Gewinne sehen", false)}
              ${permissionCheckbox("can_manage_team", "Team verwalten", false)}
            </div>
          </div>

          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>
    `);

    byId("amkzMemberForm")?.addEventListener("submit", async (event) => {
      event.preventDefault();

      try {
        await createMember({
          name: value("amkzMemberNameInput"),
          email: value("amkzMemberEmailInput"),
          password: value("amkzMemberPasswordInput"),
          role: value("amkzMemberRoleInput"),
          can_view_dashboard: getChecked("can_view_dashboard"),
          can_view_entries: getChecked("can_view_entries"),
          can_view_connect: getChecked("can_view_connect"),
          can_view_calendar: getChecked("can_view_calendar"),
          can_view_casinos: getChecked("can_view_casinos"),
          can_view_partners: getChecked("can_view_partners"),
          can_view_finance: getChecked("can_view_finance"),
          can_view_profit: getChecked("can_view_profit"),
          can_manage_team: getChecked("can_manage_team"),
        });

        AMKZ.modal.close();
        AMKZ.toast("Gespeichert", "Mitarbeiter wurde angelegt.");
        await loadTeamView();
      } catch (error) {
        console.error(error);
        AMKZ.toast("Fehler", error.message, "error");
      }
    });
  }

  async function createMember(payload) {
    if (!payload.name) throw new Error("Name fehlt.");
    if (!payload.email) throw new Error("E-Mail fehlt.");
    if (!payload.password) throw new Error("Passwort fehlt.");

    const { role, name, email, password, ...rechte } = payload;
    return AMKZ.teamApi("anlegen", { name, email: email.trim().toLowerCase(), passwort: password, role: role || "employee", rechte });
  }

  async function saveTeamRights(row) {
    const userId = row.dataset.teamId;
    const payload = {};

    row.querySelectorAll("[data-field]").forEach((el) => {
      const field = el.dataset.field;

      if (el.type === "checkbox") payload[field] = el.checked;
      else if (field === "is_active") payload[field] = el.classList.contains("active");
      else payload[field] = el.value;
    });

    try {
      await AMKZ.teamApi("speichern", { id: userId, felder: payload });
    } catch (error) {
      AMKZ.toast("Fehler", error.message, "error");
      return;
    }

    AMKZ.toast("Gespeichert", "Rechte wurden aktualisiert.");
    await loadTeamView();
  }

  function bindTeamEvents() {
    const button = byId("amkzCreateMemberButton");

    if (button && !button.dataset.bound) {
      button.dataset.bound = "true";
      button.addEventListener("click", openMemberModal);
    }

    if (!document.body.dataset.amkzTeamRightsBound) {
      document.body.dataset.amkzTeamRightsBound = "true";

      document.addEventListener("click", async (event) => {
        const status = event.target.closest(".amkz-team-status-final");

        if (status) {
          status.classList.toggle("active");
          status.textContent = status.classList.contains("active") ? "Aktiv" : "Inaktiv";
          return;
        }

        const save = event.target.closest(".amkz-save-rights-final");

        if (save) {
          const row = save.closest("[data-team-id]");
          if (row) await saveTeamRights(row);
        }
      });

      document.addEventListener("change", (event) => {
        const toggle = event.target.closest(".amkz-right-toggle-final input");
        if (!toggle) return;
        toggle.closest(".amkz-right-toggle-final")?.classList.toggle("on", toggle.checked);
      });
    }
  }

  /* =====================================================
     CONNECT CHAT
  ===================================================== */

  let chatEventsBound = false;
  let realtimeStarted = false;
  let lastPopupMessageId = localStorage.getItem("amkz_last_popup_message_id") || "";
  let lastSoundMessageId = localStorage.getItem("amkz_last_sound_message_id") || "";

  const NOTIFICATION_URL =
    "https://cdn.shopify.com/s/files/1/0965/9813/1028/files/IPHONE_NOTIFICATION_SOUND_EFFECT_PING_DING.mp3?v=1778573554";
  // Auch ausserhalb dieses Blocks erreichbar: der Anruf-Block weiter unten
  // schaltet denselben Ton frei und ist eine eigene IIFE.
  AMKZ.NOTIFICATION_URL = NOTIFICATION_URL;

  async function loadConnectView() {
    await Promise.all([loadPresence(), loadChatUsers()]);

    if (!AMKZ.state.currentChatUserId) {
      setHTML(
        byId("amkzMessagesContainer"),
        `<div class="amkz-empty">Wähle links einen Mitarbeiter aus.</div>`
      );
    }

    bindChatFiles();
    await refreshAllLiveUi();
  }

  async function loadChatUsers() {
    const rows = await rpc("amk_get_chat_users").catch(async () => {
      const { data } = await AMKZ.supabase
        .from("team_members")
        .select(await AMKZ.spalten("team_members"))
        .order("name", { ascending: true });

      return data || [];
    });

    const currentId = AMKZ.state.member?.id;

    AMKZ.state.chatUsers = Array.isArray(rows)
      ? rows.filter((user) => user.id !== currentId && user.is_active !== false)
      : [];

    try { AMKZ.ensureVerifyStyle?.(); await AMKZ.loadVerified?.(); } catch (_) {}
    await loadChatRecency();
    renderChatUsers();
  }

  // Pro Gegenüber den Zeitstempel der letzten Nachricht (gesendet ODER empfangen)
  // ermitteln -> Chatliste kann "neueste Konversation oben" sortieren.
  async function loadChatRecency() {
    const memberId = AMKZ.state.member?.id;
    if (!memberId) return;
    try {
      const { data } = await AMKZ.supabase
        .from("internal_messages")
        .select("sender_id,receiver_id,created_at")
        .or(`sender_id.eq.${memberId},receiver_id.eq.${memberId}`)
        .order("created_at", { ascending: false })
        .limit(500);
      const map = new Map();
      (data || []).forEach((m) => {
        const other = m.sender_id === memberId ? m.receiver_id : m.sender_id;
        if (!other || other === memberId) return;
        // Zeilen sind absteigend sortiert -> erster Treffer pro User = neuester
        if (!map.has(other)) map.set(other, new Date(m.created_at).getTime());
      });
      AMKZ.state.chatRecency = map;
    } catch (e) {}
  }

  function sortedChatUsers(list) {
    const rec = AMKZ.state.chatRecency || new Map();
    return (list || []).slice().sort((a, b) => {
      const ta = rec.get(a.id) || 0;
      const tb = rec.get(b.id) || 0;
      if (tb !== ta) return tb - ta; // neueste Nachricht zuerst
      return String(a.name || a.email || "").localeCompare(
        String(b.name || b.email || "")
      );
    });
  }

  function renderChatUsers() {
    const target = byId("amkzChatUsers");
    if (!target) return;

    const search = String(value("amkzChatSearch") || "").toLowerCase();

    const filtered = (AMKZ.state.chatUsers || []).filter((user) => {
      return `${user.name || ""} ${user.email || ""} ${user.role || ""}`
        .toLowerCase()
        .includes(search);
    });
    const users = sortedChatUsers(filtered);

    setHTML(
      target,
      users.length
        ? users.map(renderChatUser).join("")
        : `<div class="amkz-empty">Keine Mitarbeiter gefunden.</div>`
    );

    refreshChatBadges();
  }

  function renderChatUser(user) {
    const presence = AMKZ.state.presence.get(user.id);
    const online = isRecentlyOnline(presence);
    const active = AMKZ.state.currentChatUserId === user.id;
    const ava = user.avatar_url || (AMKZ.state.avatarById || {})[user.id] || (AMKZ.state.team || []).find((t) => t.id === user.id)?.avatar_url || "";
    const avatar = ava
      ? `<div class="amkz-chat-avatar amkz-has-photo ${online ? "is-online" : ""}" style="background-image:url('${ava}') !important"></div>`
      : `<div class="amkz-chat-avatar ${online ? "is-online" : ""}">${escapeHtml(String(user.name || user.email || "?").charAt(0).toUpperCase())}</div>`;
    const verified = AMKZ.isVerified && AMKZ.isVerified(user);

    return `
      <button
        class="amkz-chat-user ${active ? "active" : ""}"
        type="button"
        data-chat-user-id="${user.id}"
        data-amkz-force-chat="${user.id}"
      >
        ${avatar}
        <div>
          <strong>${escapeHtml(user.name || user.email || "Mitarbeiter")}${verified ? " " + AMKZ.verifyBadge : ""}</strong>
          <small>${online ? "online" : "offline"} · ${escapeHtml((window.__amkDeName||String)(user.role || "Team"))}</small>
        </div>
      </button>
    `;
  }

  function isRecentlyOnline(presence) {
    if (!presence) return false;
    // explizit offline gesetzt? dann offline
    if (presence.is_online === false || presence.status === "offline") {
      const stamp0 = presence.updated_at || presence.last_seen;
      if (stamp0 && Date.now() - new Date(stamp0).getTime() > 70000) return false;
    }
    const stamp = presence.updated_at || presence.last_seen;
    if (!stamp) return presence.is_online === true;
    // 70s-Fenster (Heartbeat alle ~20s) -> kein Flackern
    return Date.now() - new Date(stamp).getTime() < 70000;
  }

  async function openChat(userId) {
    const user =
      (AMKZ.state.chatUsers || []).find((item) => item.id === userId) ||
      (await findTeamUser(userId));

    if (!user) return;

    AMKZ.state.currentChatUserId = userId;

    const chatNameEl = byId("amkzChatActiveName");
    if (chatNameEl) chatNameEl.innerHTML = escapeHtml(user.name || user.email || "Mitarbeiter") + (AMKZ.isVerified && AMKZ.isVerified(user) ? " " + AMKZ.verifyBadge : "");
    updateActiveChatPresence();
    renderChatUsers();

    const conversation = await rpc("amk_get_or_create_conversation", {
      p_user_a: AMKZ.state.member.id,
      p_user_b: userId,
    });

    AMKZ.state.currentConversationId = conversation.id;

    await loadMessages(conversation.id);
    await markConversationRead(userId).catch(() => null);
    await refreshAllLiveUi();
  }

  async function findTeamUser(userId) {
    const { data } = await AMKZ.supabase
      .from("team_members")
      .select("id,name,email,role,is_active")
      .eq("id", userId)
      .single();

    return data || null;
  }

  async function loadMessages(conversationId) {
    const target = byId("amkzMessagesContainer");
    if (!target) return;

    setHTML(target, `<div class="amkz-empty">Nachrichten werden geladen...</div>`);

    const rows = await rpc("amk_get_messages", {
      p_conversation_id: conversationId,
    }).catch(() => []);

    renderMessages(Array.isArray(rows) ? rows : []);
    loadPinned(conversationId);
  }

  // WhatsApp-Style Tages-Trenner im Chat
  function chatDayKey(dateValue) {
    const d = new Date(dateValue);
    if (isNaN(d)) return "";
    return d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate();
  }
  function chatDayLabel(dateValue) {
    const d = new Date(dateValue);
    if (isNaN(d)) return "";
    const now = new Date();
    const yest = new Date(); yest.setDate(now.getDate() - 1);
    const same = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    if (same(d, now)) return "Heute";
    if (same(d, yest)) return "Gestern";
    const days = (now - d) / 86400000;
    if (days < 7 && days > 0) return d.toLocaleDateString("de-DE", { weekday: "long" });
    return d.toLocaleDateString("de-DE", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  }
  function chatDayDivider(dateValue) {
    return `<div class="amkz-chat-daydivider" data-day="${chatDayKey(dateValue)}"><span>${escapeHtml(chatDayLabel(dateValue))}</span></div>`;
  }

  function renderMessages(messages) {
    const target = byId("amkzMessagesContainer");
    if (!target) return;

    if (!messages.length) {
      setHTML(target, `<div class="amkz-empty">Keine Nachrichten.</div>`);
      return;
    }
    let html = "", lastDay = "";
    messages.forEach((m) => {
      const dk = chatDayKey(m.created_at);
      if (dk && dk !== lastDay) { html += chatDayDivider(m.created_at); lastDay = dk; }
      html += renderMessageBubble(m);
    });
    setHTML(target, html);

    scrollMessagesToBottom();
  }

  // Selbst erzeugte HTML-Inhalte (Bild / Sprachnotiz) roh rendern, sonst escapen
  function isRawChatHtml(m) {
    return typeof m === "string" && (m.startsWith("<img") || m.startsWith("<audio") || m.startsWith('<div class="amkz-voice'));
  }
  function isTempMsgId(id) {
    return !id || /^(local_|img_|tmp_|voice_)/.test(String(id));
  }
  // Kurzvorschau einer Nachricht (für die angepinnte Leiste)
  function messagePreview(m) {
    if (typeof m !== "string") return "";
    if (m.startsWith("<img")) return "📷 Bild";
    if (m.startsWith("<audio") || m.indexOf("amkz-voice") > -1) return "🎤 Sprachnotiz";
    return m.length > 90 ? m.slice(0, 90) + "…" : m;
  }

  function renderMessageBubble(message) {
    const own = message.sender_id === AMKZ.state.member.id;
    const id = String(message.id || "");
    let body;
    const rawMsg = String(message.message || "");
    // Antrags-Marker [[VAC:id]] (Urlaub) / [[SC:id]] (Streamwechsel) -> Genehmigen/Ablehnen direkt in Connect (nur beim Empfänger)
    const req = rawMsg.match(/\[\[(VAC|SC):([a-f0-9-]{6,})\]\]/i);
    if (req) {
      const kind = req[1].toUpperCase(), eid = req[2];
      const txt = rawMsg.replace(/\s*\[\[(?:VAC|SC):[a-f0-9-]{6,}\]\]\s*/i, " ").trim();
      const apAttr = kind === "SC" ? "data-sc-approve" : "data-vac-approve";
      const dcAttr = kind === "SC" ? "data-sc-decline" : "data-vac-decline";
      body = `<p>${escapeHtml(txt)}</p>` + (own ? "" :
        `<div class="amkz-vac-actions">
           <button type="button" class="amkz-vac-ok" ${apAttr}="${escapeHtml(eid)}">✓ Genehmigen</button>
           <button type="button" class="amkz-vac-no" ${dcAttr}="${escapeHtml(eid)}">Ablehnen</button>
         </div>`);
    } else {
      body = isRawChatHtml(message.message) ? message.message : `<p>${escapeHtml(rawMsg)}</p>`;
    }
    const pinBtn = isTempMsgId(id) ? "" : `<button class="amkz-msg-pin" type="button" data-pin-msg="${escapeHtml(id)}" title="Nachricht anpinnen">📌</button>`;

    return `
      <div class="amkz-message-row ${own ? "own" : ""}" data-message-id="${escapeHtml(id)}">
        <div class="amkz-message-bubble">
          ${body}
          <small>${formatTime(message.created_at)}</small>
          ${pinBtn}
        </div>
      </div>
    `;
  }

  function appendMessage(message) {
    const target = byId("amkzMessagesContainer");
    if (!target || !message) return;

    if (message.id && target.querySelector(`[data-message-id="${CSS.escape(message.id)}"]`)) return;

    const empty = target.querySelector(".amkz-empty");
    if (empty) empty.remove();

    const shouldScroll = target.scrollHeight - target.scrollTop - target.clientHeight < 160;

    // Tages-Trenner, falls die neue Nachricht an einem neuen Tag liegt
    const dk = chatDayKey(message.created_at);
    const dividers = target.querySelectorAll(".amkz-chat-daydivider");
    const lastDivider = dividers[dividers.length - 1];
    if (dk && (!lastDivider || lastDivider.getAttribute("data-day") !== dk)) {
      const dwrap = document.createElement("div");
      dwrap.innerHTML = chatDayDivider(message.created_at).trim();
      if (dwrap.firstElementChild) target.appendChild(dwrap.firstElementChild);
    }

    const wrapper = document.createElement("div");
    wrapper.innerHTML = renderMessageBubble(message).trim();

    if (wrapper.firstElementChild) {
      target.appendChild(wrapper.firstElementChild);
    }

    if (shouldScroll) scrollMessagesToBottom();
  }

  function scrollMessagesToBottom() {
    const target = byId("amkzMessagesContainer");
    if (!target) return;

    requestAnimationFrame(() => {
      target.scrollTop = target.scrollHeight;
    });
  }

  /* ---------- Nachricht anpinnen (eine pro Konversation, beide sehen sie) ---------- */
  function ensurePinBar() {
    if (byId("amkzPinnedBar")) return byId("amkzPinnedBar");
    const messages = byId("amkzMessagesContainer");
    if (!messages || !messages.parentElement) return null;
    const bar = document.createElement("div");
    bar.id = "amkzPinnedBar";
    bar.className = "amkz-pinned-bar is-hidden";
    messages.parentElement.insertBefore(bar, messages);
    return bar;
  }
  async function loadPinned(conversationId) {
    const bar = ensurePinBar();
    if (!bar) return;
    if (!conversationId || !AMKZ?.supabase) { bar.classList.add("is-hidden"); bar.innerHTML = ""; return; }
    try {
      const { data } = await AMKZ.supabase
        .from("internal_messages")
        .select("id,message,sender_id,created_at,pinned")
        .eq("conversation_id", conversationId)
        .eq("pinned", true)
        .order("created_at", { ascending: false })
        .limit(1)
        .maybeSingle();
      if (!data) { bar.classList.add("is-hidden"); bar.innerHTML = ""; bar.removeAttribute("data-msg-id"); return; }
      bar.dataset.msgId = data.id;
      bar.classList.remove("is-hidden");
      bar.innerHTML = `
        <span class="amkz-pinned-ic">📌</span>
        <div class="amkz-pinned-text"><strong>Angepinnte Nachricht</strong><span>${escapeHtml(messagePreview(data.message))}</span></div>
        <button class="amkz-pinned-x" type="button" id="amkzUnpinBtn" title="Lösen">✕</button>`;
    } catch (e) {
      // Spalte fehlt evtl. noch (SQL nicht ausgeführt) -> Leiste einfach ausblenden
      bar.classList.add("is-hidden");
    }
  }
  async function pinMessage(messageId) {
    const conv = AMKZ.state.currentConversationId;
    if (!conv || !messageId || isTempMsgId(messageId)) return;
    try {
      await AMKZ.supabase.from("internal_messages").update({ pinned: false }).eq("conversation_id", conv).eq("pinned", true);
      await AMKZ.supabase.from("internal_messages").update({ pinned: true }).eq("id", messageId);
      await loadPinned(conv);
      AMKZ.toast && AMKZ.toast("Angepinnt", "Nachricht oben fixiert.");
    } catch (e) {
      AMKZ.toast && AMKZ.toast("Fehler", e.message || "Konnte nicht anpinnen (SQL ausgeführt?).", "error");
    }
  }
  async function unpinMessage() {
    const conv = AMKZ.state.currentConversationId;
    if (!conv) return;
    try { await AMKZ.supabase.from("internal_messages").update({ pinned: false }).eq("conversation_id", conv).eq("pinned", true); } catch (e) {}
    await loadPinned(conv);
  }
  function scrollToMessage(id) {
    if (!id) return;
    const row = document.querySelector(`#amkzMessagesContainer [data-message-id="${CSS.escape(id)}"]`);
    if (!row) return;
    row.scrollIntoView({ behavior: "smooth", block: "center" });
    row.classList.add("amkz-msg-flash");
    setTimeout(() => row.classList.remove("amkz-msg-flash"), 1300);
  }

  async function sendPushToUser(userId, text) {
    if (!AMKZ?.supabase || !userId || !text) return;

    const anonKey =
      byId("amkzApp")?.dataset?.supabaseKey ||
      AMKZ.supabase.supabaseKey ||
      "";

    if (!anonKey) return;

    await fetch("https://cbwxgikndyyzdslmfpmo.supabase.co/functions/v1/send-push", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + anonKey,
        apikey: anonKey,
      },
      body: JSON.stringify({
        user_id: userId,
        title: "Neue Nachricht",
        body: `${AMKZ.state.member.name || AMKZ.state.member.email}: ${text}`,
        url: "/pages/zentrale",
        type: "chat",
        from: AMKZ.state.member?.id || "",   // Absender -> Chat direkt öffnen
      }),
    }).catch((e) => console.error("PUSH SEND ERROR", e));
  }

  async function createChatNotification(text) {
    if (!AMKZ.state.currentChatUserId) return;
    if (AMKZ.tagesplan && AMKZ.tagesplan.istBot(AMKZ.state.currentChatUserId)) return;   // der Bot braucht keine Mitteilung

    await AMKZ.supabase.from("notifications").insert({
      target_user_id: AMKZ.state.currentChatUserId,
      type: "chat",
      title: "Neue Nachricht",
      message: `${AMKZ.state.member.name || AMKZ.state.member.email}: ${text}`,
      is_read: false,
      created_at: new Date().toISOString(),
      payload: {
        sender_id: AMKZ.state.member.id,
        conversation_id: AMKZ.state.currentConversationId,
        push: "false",   // Push schickt sendPushToUser selbst (Marker fuer supabase-mitteilungen.sql)
      },
    });

    await sendPushToUser(AMKZ.state.currentChatUserId, text);
  }

  async function sendMessage() {
    const input = byId("amkzMessageInput");
    const text = input?.value?.trim();

    if (!text) return;

    if (!AMKZ.state.currentChatUserId || !AMKZ.state.currentConversationId) {
      AMKZ.toast("Chat Fehler", "Bitte zuerst Mitarbeiter auswählen.", "error");
      return;
    }

    input.value = "";
    autoGrowTextarea(input);

    try {
      const message = await rpc("amk_send_message", {
        p_conversation_id: AMKZ.state.currentConversationId,
        p_sender_id: AMKZ.state.member.id,
        p_receiver_id: AMKZ.state.currentChatUserId,
        p_message: text,
        p_client_temp_id: `tmp_${Date.now()}_${Math.random().toString(36).slice(2)}`,
      });

      appendMessage(message || {
        id: `local_${Date.now()}`,
        sender_id: AMKZ.state.member.id,
        message: text,
        created_at: new Date().toISOString(),
      });

      await createChatNotification(text);
      await refreshAllLiveUi();
      // Tagesplaner als Gegenueber: die Nachricht geht zusaetzlich an die Function, die Antwort kommt als Chat-Nachricht zurueck.
      if (AMKZ.tagesplan && AMKZ.tagesplan.istBot(AMKZ.state.currentChatUserId)) AMKZ.tagesplan.ausChat(text);
    } catch (error) {
      console.error(error);
      AMKZ.toast("Chat Fehler", error.message || "Nachricht konnte nicht gesendet werden.", "error");
    }
  }

  async function markConversationRead(senderId) {
    if (!senderId || !AMKZ.state.member?.id) return;

    await AMKZ.supabase
      .from("internal_messages")
      .update({
        is_read: true,
        read_at: new Date().toISOString(),
      })
      .eq("sender_id", senderId)
      .eq("receiver_id", AMKZ.state.member.id)
      .eq("is_read", false);
  }

  async function loadPresence() {
    const rows = await selectRows("user_presence", (q) =>
      q.select("*").order("last_seen", { ascending: false })
    ).catch(() => []);

    AMKZ.state.presence.clear();

    rows.forEach((row) => {
      if (row.user_id) AMKZ.state.presence.set(row.user_id, row);
    });

    renderChatUsers();
    updateActiveChatPresence();
  }

  async function upsertPresence(extra = {}) {
    const member = AMKZ.state.member;
    if (!member?.id) return;

    // nur Spalten, die in user_presence wirklich existieren (KEIN status!)
    const row = {
      name: member.name || member.email || "",
      email: member.email || "",
      role: member.role || "",
      member_id: member.id,
      is_online: true,
      current_view: AMKZ.state.currentView || "dashboard",
      last_seen: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      ...extra,
    };

    try {
      // Robust ohne Unique-Constraint: erst Update, wenn keine Zeile -> Insert
      const { data, error } = await AMKZ.supabase
        .from("user_presence")
        .update(row)
        .eq("user_id", member.id)
        .select("user_id");

      if (error || !data || data.length === 0) {
        await AMKZ.supabase.from("user_presence").insert({ user_id: member.id, ...row });
      }
      // lokalen State sofort aktualisieren -> man sieht sich/andere direkt online
      AMKZ.state.presence.set(member.id, { user_id: member.id, ...row });
    } catch (error) {
      console.warn("Presence Fehler:", error);
    }
  }

  async function setPresenceOffline() {
    const member = AMKZ.state.member;
    if (!member?.id) return;

    try {
      await AMKZ.supabase
        .from("user_presence")
        .update({
          is_online: false,
          last_seen: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        })
        .eq("user_id", member.id);
    } catch (_) {}
  }

  function updateActiveChatPresence() {
    const activeId = AMKZ.state.currentChatUserId;
    if (!activeId) return;

    const presence = AMKZ.state.presence.get(activeId);
    const online = isRecentlyOnline(presence);

    setText(
      byId("amkzChatActiveStatus"),
      online
        ? `online · ${(window.__amkDeName||String)(presence?.current_view || "AMK")}`
        : presence?.last_seen
          ? `offline · ${formatDate(presence.last_seen)}`
          : "offline"
    );
  }

  function autoGrowTextarea(textarea) {
    if (!textarea) return;
    textarea.style.height = "auto";
    textarea.style.height = Math.min(textarea.scrollHeight, 140) + "px";
  }

  function bindChatEvents() {
    if (chatEventsBound) return;
    chatEventsBound = true;

    byId("amkzChatSearch")?.addEventListener("input", renderChatUsers);

    byId("amkzChatUsers")?.addEventListener("click", async (event) => {
      const button = event.target.closest("[data-chat-user-id], [data-amkz-force-chat]");
      if (!button) return;

      try {
        await openChat(button.dataset.chatUserId || button.dataset.amkzForceChat);
      } catch (error) {
        console.error(error);
        AMKZ.toast("Chat Fehler", error.message || "Chat konnte nicht geöffnet werden.", "error");
      }
    });

    document.addEventListener(
      "click",
      function (event) {
        const btn = event.target.closest("#amkzSendMessageButton");
        if (!btn) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        sendMessage();
      },
      true
    );

    document.addEventListener(
      "keydown",
      function (event) {
        const input = event.target.closest("#amkzMessageInput");
        if (!input) return;

        if (event.key === "Enter" && !event.shiftKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          sendMessage();
        }
      },
      true
    );

    byId("amkzMessageInput")?.addEventListener("input", (event) => {
      autoGrowTextarea(event.target);
    });
  }

  function startPresenceHeartbeat() {
    clearInterval(AMKZ.state.timers.presenceHeartbeat);

    upsertPresence();

    AMKZ.state.timers.presenceHeartbeat = setInterval(() => {
      upsertPresence({ current_view: AMKZ.state.currentView });
    }, 15000);

    window.addEventListener("beforeunload", () => {
      setPresenceOffline();
    });
  }

  function initRealtime() {
    if (realtimeStarted || !AMKZ.state.member?.id) return;
    realtimeStarted = true;

    startPresenceHeartbeat();
    subscribeMessages();
    subscribePresence();
    subscribeNotifications();
    initBusinessRealtime();
  }

  function subscribeMessages() {
    const channel = AMKZ.supabase
      .channel("amkz_internal_messages_final")
      .on(
        "postgres_changes",
        { event: "INSERT", schema: "public", table: "internal_messages" },
        async (payload) => {
          const message = payload.new;
          if (!message) return;

          const active = message.conversation_id === AMKZ.state.currentConversationId;
          const isForMe = message.receiver_id === AMKZ.state.member?.id;

          if (active) {
            appendMessage(message);
            if (isForMe) await markConversationRead(message.sender_id).catch(() => null);
            await refreshAllLiveUi();
            return;
          }

          if (isForMe) {
            AMKZ.toast("Neue Nachricht", message.message || "");
            showChatPopupByMessage(message);
            playNotificationSoundOnce(message.id);
            await refreshAllLiveUi();
          }
        }
      )
      .subscribe();

    AMKZ.state.subscriptions.push(channel);
  }

  function subscribePresence() {
    const channel = AMKZ.supabase
      .channel("amkz_user_presence_final")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "user_presence" },
        (payload) => {
          const row = payload.new;
          if (!row?.user_id) return;

          AMKZ.state.presence.set(row.user_id, row);
          renderChatUsers();
          updateActiveChatPresence();
          refreshOnlineTeam();
        }
      )
      .subscribe();

    AMKZ.state.subscriptions.push(channel);
  }

  function subscribeNotifications() {
    const memberId = AMKZ.state.member?.id;
    if (!memberId) return;

    const channel = AMKZ.supabase
      .channel("amkz_notifications_final")
      .on(
        "postgres_changes",
        {
          event: "INSERT",
          schema: "public",
          table: "notifications",
          filter: `target_user_id=eq.${memberId}`,
        },
        (payload) => {
          const notification = payload.new;
          if (!notification) return;
          AMKZ.toast(notification.title || "Benachrichtigung", notification.message || "");
          refreshDashboardNotifications();
          if (String(notification.type || "") === "verlosung" && AMKZ.verlosung && AMKZ.verlosung.badge) AMKZ.verlosung.badge();
          if (AMKZ.mitteilungen && AMKZ.mitteilungen.laden) { try { AMKZ.mitteilungen.laden(false); } catch (_) {} }
          if (window.AMKZ_WARTET && window.AMKZ_WARTET.laden) { try { window.AMKZ_WARTET.laden(); } catch (_) {} }
        }
      )
      .subscribe();

    AMKZ.state.subscriptions.push(channel);
  }

  function playNotificationSoundOnce(messageId) {
    if (!messageId || messageId === lastSoundMessageId) return;

    lastSoundMessageId = messageId;
    localStorage.setItem("amkz_last_sound_message_id", messageId);

    try {
      const audio = new Audio(NOTIFICATION_URL);
      audio.volume = 0.85;
      audio.play().catch(() => {});
    } catch (_) {}
  }

  async function showChatPopupByMessage(message) {
    if (!message?.id || message.id === lastPopupMessageId) return;
    if (AMKZ.state.currentChatUserId === message.sender_id) return;

    const sender =
      (AMKZ.state.chatUsers || []).find((u) => u.id === message.sender_id) ||
      (await findTeamUser(message.sender_id));

    showChatPopup(sender?.name || sender?.email || "Mitarbeiter", message.message || "");

    lastPopupMessageId = message.id;
    localStorage.setItem("amkz_last_popup_message_id", message.id);
  }

  function showChatPopup(name, message) {
    let box = byId("amkzChatPopupBox");

    if (!box) {
      box = document.createElement("div");
      box.id = "amkzChatPopupBox";
      box.style.position = "fixed";
      box.style.right = "24px";
      box.style.bottom = "92px";
      box.style.zIndex = "999999";
      box.style.display = "grid";
      box.style.gap = "12px";
      document.body.appendChild(box);
    }

    const node = document.createElement("div");
    node.className = "amkz-chat-popup";
    node.innerHTML = `
      <strong>Nachricht von ${escapeHtml(name)}</strong>
      <small>${escapeHtml(message)}</small>
    `;

    box.appendChild(node);

    setTimeout(() => {
      node.style.opacity = "0";
      node.style.transform = "translateY(12px)";
      setTimeout(() => node.remove(), 300);
    }, 5000);
  }

  function ensureNavBadge() {
    const nav = document.querySelector('.amkz-nav-item[data-view="connect"]');
    if (!nav) return null;

    let badge = nav.querySelector(".amkz-nav-badge");

    if (!badge) {
      badge = document.createElement("span");
      badge.className = "amkz-nav-badge";
      nav.appendChild(badge);
    }

    return badge;
  }

  async function refreshConnectNavBadge() {
    const memberId = AMKZ.state.member?.id;
    if (!memberId) return;

    const { data } = await AMKZ.supabase
      .from("internal_messages")
      .select("id")
      .eq("receiver_id", memberId)
      .eq("is_read", false);

    const count = data?.length || 0;

    // App-Icon-Badge (rote Zahl am Home-Screen-Icon, wie WhatsApp)
    setAppIconBadge(count);

    const badge = ensureNavBadge();

    if (!badge) return;

    if (count > 0) {
      badge.textContent = count > 9 ? "9+" : String(count);
      badge.style.display = "grid";
    } else {
      badge.style.display = "none";
    }
  }

  // App-Icon-Badge setzen/löschen (App Badging API; iOS 16.4+ installierte PWA + Mitteilungen erlaubt)
  function setAppIconBadge(count) {
    try {
      if (typeof navigator === "undefined") return;
      if (count > 0 && navigator.setAppBadge) navigator.setAppBadge(count);
      else if (navigator.clearAppBadge) navigator.clearAppBadge();
    } catch (e) { /* nicht unterstützt -> ignorieren */ }
  }
  AMKZ.setAppIconBadge = setAppIconBadge;

  async function refreshChatBadges() {
    const memberId = AMKZ.state.member?.id;
    if (!memberId) return;

    const { data } = await AMKZ.supabase
      .from("internal_messages")
      .select("sender_id")
      .eq("receiver_id", memberId)
      .eq("is_read", false);

    const unread = data || [];

    document.querySelectorAll("[data-amkz-force-chat]").forEach((btn) => {
      const userId = btn.dataset.amkzForceChat;
      const count = unread.filter((m) => m.sender_id === userId).length;

      let badge = btn.querySelector(".amkz-chat-badge");

      if (count > 0) {
        if (!badge) {
          badge = document.createElement("span");
          badge.className = "amkz-chat-badge";
          btn.appendChild(badge);
        }

        badge.textContent = count > 9 ? "9+" : String(count);
        badge.style.display = "grid";
      } else if (badge) {
        badge.remove();
      }
    });
  }

  async function refreshDashboardNotifications() {
    const box = byId("amkzNotificationsList");
    const memberId = AMKZ.state.member?.id;
    if (!box || !memberId) return;

    const { data } = await AMKZ.supabase
      .from("internal_messages")
      .select("id,sender_id,message,created_at,is_read")
      .eq("receiver_id", memberId)
      .eq("is_read", false)
      .order("created_at", { ascending: false })
      .limit(8);

    const users = AMKZ.state.chatUsers || [];

    box.innerHTML = data?.length
      ? data.map((m) => {
          const sender = users.find((u) => u.id === m.sender_id);
          const name = sender?.name || sender?.email || "Mitarbeiter";

          return `
            <div class="amkz-table-row-card">
              <strong>Nachricht von ${escapeHtml(name)}</strong><br>
              <small>${escapeHtml(m.message || "")}</small>
            </div>
          `;
        }).join("")
      : `<div class="amkz-empty">Keine Benachrichtigungen.</div>`;
  }

  async function refreshOnlineTeam() {
    const box = byId("amkzOnlineUsersList");
    if (!box) return;

    const [{ data: users }, { data: presence }] = await Promise.all([
      AMKZ.supabase
        .from("team_members")
        .select("id,name,email,role,is_active")
        .eq("is_active", true),
      AMKZ.supabase
        .from("user_presence")
        .select("user_id,last_seen,updated_at,current_view,is_online"),
    ]);

    const map = new Map((presence || []).map((p) => [p.user_id, p]));

    box.innerHTML = (users || []).length
      ? (users || []).map((u) => {
          const p = map.get(u.id);
          const online = isRecentlyOnline(p);

          return `
            <div class="amkz-table-row-card">
              <strong>
                <span class="amkz-online-dot ${online ? "online" : ""}"></span>
                ${escapeHtml(u.name || u.email)}
              </strong><br>
              <small>
                ${online ? "online" : "offline"}
                ${p?.current_view ? " · " + escapeHtml((window.__amkDeName||String)(p.current_view)) : ""}
                · ${escapeHtml((window.__amkDeName||String)(u.role || "employee"))}
              </small>
            </div>
          `;
        }).join("")
      : `<div class="amkz-empty">Keine Mitarbeiter vorhanden.</div>`;
  }

  async function refreshAllLiveUi() {
    await Promise.all([
      refreshConnectNavBadge(),
      refreshChatBadges(),
      refreshDashboardNotifications(),
      refreshOnlineTeam(),
      reorderChatUsersLive(),
    ]);
  }

  // Hält die Chatliste live in "neueste Nachricht oben"-Reihenfolge,
  // rendert aber nur neu, wenn sich die Reihenfolge wirklich geändert hat
  // (kein Flackern / kein Scroll-Reset).
  async function reorderChatUsersLive() {
    const target = byId("amkzChatUsers");
    if (!target || !(AMKZ.state.chatUsers || []).length) return;
    await loadChatRecency();
    const search = String(value("amkzChatSearch") || "").toLowerCase();
    const filtered = (AMKZ.state.chatUsers || []).filter((u) =>
      `${u.name || ""} ${u.email || ""} ${u.role || ""}`.toLowerCase().includes(search)
    );
    const desired = sortedChatUsers(filtered).map((u) => u.id);
    const current = Array.from(target.querySelectorAll("[data-chat-user-id]")).map(
      (el) => el.dataset.chatUserId
    );
    if (desired.length !== current.length || desired.some((id, i) => id !== current[i])) {
      renderChatUsers();
    }
  }

  async function livePoll() {
    if (!AMKZ?.supabase || !AMKZ.state?.member?.id) return;

    await upsertPresence({ current_view: AMKZ.state.currentView });

    const { data } = await AMKZ.supabase
      .from("internal_messages")
      .select("id,sender_id,message,created_at")
      .eq("receiver_id", AMKZ.state.member.id)
      .eq("is_read", false)
      .order("created_at", { ascending: false })
      .limit(1);

    const newest = data?.[0];

    if (newest) {
      await showChatPopupByMessage(newest);
      if (AMKZ.state.currentChatUserId !== newest.sender_id) {
        playNotificationSoundOnce(newest.id);
      }
    }

    await refreshAllLiveUi();
  }

  /* ---------- Sprachnotizen (aufnehmen, hochladen, abhören) ---------- */
  const VOICE = { rec: null, chunks: [], stream: null, timer: null, t0: 0, mime: "", recording: false, cancel: false };
  function voicePickMime() {
    const cands = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", "audio/ogg;codecs=opus"];
    for (const m of cands) { try { if (window.MediaRecorder && MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(m)) return m; } catch (e) {} }
    return "";
  }
  function voiceExt(mime) { mime = mime || ""; if (mime.indexOf("mp4") > -1) return "m4a"; if (mime.indexOf("ogg") > -1) return "ogg"; return "webm"; }
  function showVoiceBar() {
    const footer = document.querySelector(".amkz-chat-footer");
    if (!footer || byId("amkzVoiceBar")) return;
    const bar = document.createElement("div");
    bar.id = "amkzVoiceBar";
    bar.className = "amkz-voice-bar";
    bar.innerHTML = `<span class="amkz-voice-dot"></span><span class="amkz-voice-lbl">Aufnahme läuft</span><b id="amkzVoiceTime">0:00</b>
      <button type="button" id="amkzVoiceCancel" class="amkz-voice-cancel">Abbrechen</button>
      <button type="button" id="amkzVoiceSend" class="amkz-voice-send">➤ Senden</button>`;
    footer.appendChild(bar);
    footer.classList.add("is-recording");
  }
  function hideVoiceBar() {
    byId("amkzVoiceBar")?.remove();
    document.querySelector(".amkz-chat-footer")?.classList.remove("is-recording");
  }
  function updateVoiceTime() {
    const el = byId("amkzVoiceTime"); if (!el) return;
    const s = Math.floor((Date.now() - VOICE.t0) / 1000);
    el.textContent = Math.floor(s / 60) + ":" + String(s % 60).padStart(2, "0");
  }
  async function startVoice() {
    if (VOICE.recording) return;
    if (!AMKZ.state.currentConversationId) { AMKZ.toast("Sprachnotiz", "Bitte zuerst einen Mitarbeiter auswählen.", "error"); return; }
    if (!navigator.mediaDevices?.getUserMedia || !window.MediaRecorder) { AMKZ.toast("Sprachnotiz", "Aufnahme wird auf diesem Gerät nicht unterstützt.", "error"); return; }
    try { VOICE.stream = await navigator.mediaDevices.getUserMedia({ audio: true }); }
    catch (e) { AMKZ.toast("Mikrofon", "Kein Mikrofon-Zugriff erlaubt.", "error"); return; }
    VOICE.mime = voicePickMime();
    try { VOICE.rec = VOICE.mime ? new MediaRecorder(VOICE.stream, { mimeType: VOICE.mime }) : new MediaRecorder(VOICE.stream); }
    catch (e) { try { VOICE.rec = new MediaRecorder(VOICE.stream); } catch (e2) { AMKZ.toast("Sprachnotiz", "Aufnahme nicht möglich.", "error"); return; } }
    VOICE.chunks = []; VOICE.cancel = false;
    VOICE.rec.ondataavailable = (ev) => { if (ev.data && ev.data.size) VOICE.chunks.push(ev.data); };
    VOICE.rec.onstop = () => finishVoice();
    try { VOICE.rec.start(); } catch (e) { AMKZ.toast("Sprachnotiz", "Aufnahme nicht möglich.", "error"); return; }
    VOICE.recording = true; VOICE.t0 = Date.now();
    showVoiceBar();
    VOICE.timer = setInterval(updateVoiceTime, 250);
  }
  function stopVoiceAndSend() { if (!VOICE.recording) return; VOICE.cancel = false; try { VOICE.rec.stop(); } catch (e) {} }
  function cancelVoice() { if (!VOICE.recording) return; VOICE.cancel = true; try { VOICE.rec.stop(); } catch (e) {} }
  function teardownVoice() {
    clearInterval(VOICE.timer); VOICE.timer = null; VOICE.recording = false;
    try { VOICE.stream && VOICE.stream.getTracks().forEach((t) => t.stop()); } catch (e) {}
    VOICE.stream = null; VOICE.rec = null;
    hideVoiceBar();
  }
  async function finishVoice() {
    const cancelled = VOICE.cancel;
    const chunks = VOICE.chunks.slice();
    const mime = VOICE.mime || (VOICE.rec && VOICE.rec.mimeType) || "audio/webm";
    const conv = AMKZ.state.currentConversationId;
    teardownVoice();
    if (cancelled || !chunks.length || !conv) return;
    const blob = new Blob(chunks, { type: mime });
    if (blob.size < 600) { AMKZ.toast("Sprachnotiz", "Zu kurz.", "error"); return; }
    const path = `voice/${conv}/${Date.now()}.${voiceExt(mime)}`;
    const { error } = await AMKZ.supabase.storage.from("amk-chat-files").upload(path, blob, { upsert: true, contentType: mime });
    if (error) { AMKZ.toast("Upload Fehler", error.message, "error"); return; }
    const { data } = AMKZ.supabase.storage.from("amk-chat-files").getPublicUrl(path);
    const html = `<div class="amkz-voice"><span class="amkz-voice-ic">🎤</span><audio controls preload="metadata" src="${data.publicUrl}"></audio></div>`;
    try {
      const message = await rpc("amk_send_message", {
        p_conversation_id: conv,
        p_sender_id: AMKZ.state.member.id,
        p_receiver_id: AMKZ.state.currentChatUserId,
        p_message: html,
        p_client_temp_id: `voice_${Date.now()}`,
      });
      appendMessage(message || { id: `voice_${Date.now()}`, sender_id: AMKZ.state.member.id, message: html, created_at: new Date().toISOString() });
      await createChatNotification("🎤 Sprachnotiz");
      await refreshAllLiveUi();
    } catch (e) { AMKZ.toast("Sprachnotiz", e.message || "Senden fehlgeschlagen.", "error"); }
  }

  function bindChatFiles() {
    const footer = document.querySelector(".amkz-chat-footer");
    if (!footer || byId("amkzChatFileInput")) return;

    footer.insertAdjacentHTML("afterbegin", `
      <input id="amkzChatFileInput" type="file" accept="image/*" hidden>
      <button id="amkzChatFileBtn" class="amkz-secondary-btn" type="button" title="Bild senden">📎</button>
      <button id="amkzVoiceBtn" class="amkz-secondary-btn amkz-voice-btn" type="button" title="Sprachnotiz aufnehmen">🎤</button>
    `);

    document.addEventListener("click", (event) => {
      if (event.target.closest("#amkzChatFileBtn")) { byId("amkzChatFileInput")?.click(); return; }
      // Sprachnotiz
      if (event.target.closest("#amkzVoiceBtn")) { event.preventDefault(); startVoice(); return; }
      if (event.target.closest("#amkzVoiceSend")) { event.preventDefault(); stopVoiceAndSend(); return; }
      if (event.target.closest("#amkzVoiceCancel")) { event.preventDefault(); cancelVoice(); return; }
      // Anpinnen / Lösen / zur angepinnten Nachricht springen
      const pinBtn = event.target.closest("[data-pin-msg]");
      if (pinBtn) { event.preventDefault(); event.stopPropagation(); pinMessage(pinBtn.getAttribute("data-pin-msg")); return; }
      if (event.target.closest("#amkzUnpinBtn")) { event.preventDefault(); event.stopPropagation(); unpinMessage(); return; }
      const bar = event.target.closest("#amkzPinnedBar");
      if (bar && bar.dataset.msgId) { scrollToMessage(bar.dataset.msgId); return; }
    }, true);

    byId("amkzChatFileInput")?.addEventListener("change", async function () {
      const file = this.files?.[0];

      if (!file || !AMKZ?.supabase || !AMKZ.state.currentConversationId) return;

      const path = `chat/${AMKZ.state.currentConversationId}/${Date.now()}_${file.name.replace(/[^\w.\-]/g, "_")}`;

      const { error } = await AMKZ.supabase.storage
        .from("amk-chat-files")
        .upload(path, file, { upsert: true });

      if (error) {
        AMKZ.toast("Upload Fehler", error.message, "error");
        return;
      }

      const { data } = AMKZ.supabase.storage.from("amk-chat-files").getPublicUrl(path);
      const url = data.publicUrl;

      const html = `<img src="${url}" alt="Bild" style="max-width:260px;border-radius:18px;">`;

      const message = await rpc("amk_send_message", {
        p_conversation_id: AMKZ.state.currentConversationId,
        p_sender_id: AMKZ.state.member.id,
        p_receiver_id: AMKZ.state.currentChatUserId,
        p_message: html,
        p_client_temp_id: `img_${Date.now()}`,
      });

      appendMessage(message || {
        id: `img_${Date.now()}`,
        sender_id: AMKZ.state.member.id,
        message: html,
        created_at: new Date().toISOString(),
      });

      await createChatNotification("Bild gesendet");
      AMKZ.toast("Bild gesendet", "Upload abgeschlossen.");
      this.value = "";
    });
  }

  /* =====================================================
     ANALYTICS
  ===================================================== */

  async function loadAnalyticsView() {
    const canvas = byId("amkzAnalyticsChart");
    if (!canvas || !window.Chart) return;

    const days = Number(byId("amkzAnalyticsRange")?.value || 30);

    const start = new Date();
    start.setDate(start.getDate() - (days - 1));
    const startDate = start.toISOString().slice(0, 10);

    const entries = await selectRows("entries", (q) =>
      q
        .select("entry_date,entry_type,amount")
        .gte("entry_date", startDate)
        .order("entry_date", { ascending: true })
    ).catch(() => []);

    const rows = groupAnalyticsRows(entries, days);

    renderAnalyticsKpis(rows);
    renderAnalyticsChart(rows);
  }

  function groupAnalyticsRows(entries, days) {
    const map = new Map();

    for (let i = days - 1; i >= 0; i--) {
      const d = new Date();
      d.setDate(d.getDate() - i);

      const key = d.toISOString().slice(0, 10);

      map.set(key, {
        date: key,
        ftd: 0,
        redepo: 0,
        costs: 0,
      });
    }

    (entries || []).forEach((entry) => {
      const key = entry.entry_date;
      const row = map.get(key);
      if (!row) return;

      const type = String(entry.entry_type || "").toUpperCase();
      const amount = safeNumber(entry.amount);

      if (type === "FTD") row.ftd += 1;
      if (type === "REDEPO") row.redepo += 1;

      row.costs += amount;
    });

    return Array.from(map.values());
  }

  function renderAnalyticsKpis(rows) {
    const totalFtd = rows.reduce((sum, row) => sum + row.ftd, 0);
    const totalRedepo = rows.reduce((sum, row) => sum + row.redepo, 0);
    const totalCosts = rows.reduce((sum, row) => sum + row.costs, 0);

    setText(byId("amkzAnalyticsFtdCount"), totalFtd);
    setText(byId("amkzAnalyticsRedepoCount"), totalRedepo);

    setText(
      byId("amkzAnalyticsProfit"),
      AMKZ.state.permissions?.seeProfit ? money(-totalCosts) : "—"
    );
  }

  function renderAnalyticsChart(rows) {
    const canvas = byId("amkzAnalyticsChart");
    if (!canvas || !window.Chart) return;

    const wrap = canvas.closest(".amkz-analytics-chart-wrap");

    if (wrap) {
      wrap.style.display = "block";
      wrap.style.height = "280px";
      wrap.style.minHeight = "280px";
      wrap.style.maxHeight = "280px";
      wrap.style.overflow = "hidden";
    }

    canvas.style.display = "block";
    canvas.style.width = "100%";
    canvas.style.height = "240px";

    AMKZ.state.charts.analytics?.destroy?.();

    AMKZ.state.charts.analytics = new Chart(canvas, {
      type: "bar",
      data: {
        labels: rows.map((row) => row.date.slice(5)),
        datasets: [
          {
            label: "FTDs",
            data: rows.map((row) => row.ftd),
            backgroundColor: "rgba(247,223,151,.85)",
            borderColor: "rgba(247,223,151,1)",
            borderWidth: 1,
            borderRadius: 6,
            maxBarThickness: 30,
          },
          {
            label: "ReDepos",
            data: rows.map((row) => row.redepo),
            backgroundColor: "rgba(200,144,43,.85)",
            borderColor: "rgba(230,184,92,1)",
            borderWidth: 1,
            borderRadius: 6,
            maxBarThickness: 30,
          },
          {
            label: "Kosten",
            data: rows.map((row) =>
              AMKZ.state.permissions?.seeProfit ? row.costs : 0
            ),
            backgroundColor: "rgba(120,90,40,.7)",
            borderColor: "rgba(169,118,15,1)",
            borderWidth: 1,
            borderRadius: 6,
            maxBarThickness: 30,
            hidden: !AMKZ.state.permissions?.seeProfit,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: {
          legend: {
            display: true,
            labels: {
              color: "#d3cdbe",
              font: {
                weight: "700",
              },
            },
          },
        },
        scales: {
          x: {
            grid: {
              color: "rgba(230,184,92,.06)",
            },
            ticks: {
              color: "#948f81",
              maxRotation: 0,
            },
          },
          y: {
            beginAtZero: true,
            grid: {
              color: "rgba(230,184,92,.07)",
            },
            ticks: {
              color: "#948f81",
              precision: 0,
            },
          },
        },
      },
    });
  }

  function bindAnalyticsEvents() {
    const range = byId("amkzAnalyticsRange");

    if (range && !range.dataset.bound) {
      range.dataset.bound = "true";
      range.addEventListener("change", loadAnalyticsView);
    }
  }

  /* =====================================================
     BUSINESS REALTIME
  ===================================================== */

  let businessRealtimeStarted = false;

  function initBusinessRealtime() {
    if (businessRealtimeStarted || !AMKZ.supabase || !AMKZ.state.member?.id) return;
    businessRealtimeStarted = true;

    [
      "entries",
      "partner_groups",
      "casinos",
      "amk_deals",
      "planning_calendar",
      "amk_actual_daily_data",
      "amk_finance_documents",
    ].forEach((table) => {
      const channel = AMKZ.supabase
        .channel(`amkz_business_${table}_final`)
        .on(
          "postgres_changes",
          {
            event: "*",
            schema: "public",
            table,
          },
          async () => {
            if (["partner_groups", "casinos", "amk_deals"].includes(table)) {
              await AMKZ.data.loadBaseData(true).catch(() => null);
            }

            debounce(`reload_${table}`, () => {
              if (typeof AMKZ.loadView === "function") {
                AMKZ.loadView(AMKZ.state.currentView, { force: true }).catch(() => null);
              }
            }, 550);
          }
        )
        .subscribe();

      AMKZ.state.subscriptions.push(channel);
    });
  }

  /* =====================================================
     DATE RANGE
  ===================================================== */

  function ensureDateRange() {
    const actions = document.querySelector(".amkz-topbar-actions");
    const refresh = byId("amkzRefreshButton");
    const globalDate = byId("amkzGlobalDate");

    if (!actions || !refresh || !globalDate) return;
    if (byId("amkzDateFromFinal") && byId("amkzDateToFinal")) return;

    const current = globalDate.value || today();

    const wrap = document.createElement("div");
    wrap.className = "amkz-final-date-range";
    wrap.innerHTML = `
      <input id="amkzDateFromFinal" type="date" value="${current}" aria-label="Von Datum">
      <input id="amkzDateToFinal" type="date" value="${current}" aria-label="Bis Datum">
      <button id="amkzTodayBtnFinal" type="button" title="Auf heute springen">Heute</button>
      <button id="amkzApplyDateRangeFinal" type="button">Zeitraum laden</button>
    `;

    actions.insertBefore(wrap, refresh);
  }

  function bindDateRangeEvents() {
    if (document.body.dataset.amkzDateRangeBound) return;
    document.body.dataset.amkzDateRangeBound = "true";

    document.addEventListener("click", async (event) => {
      // "Heute" -> Von+Bis+globales Datum auf heute, Einzeltag laden
      if (event.target.closest("#amkzTodayBtnFinal")) {
        const t = today();
        if (byId("amkzDateFromFinal")) byId("amkzDateFromFinal").value = t;
        if (byId("amkzDateToFinal")) byId("amkzDateToFinal").value = t;
        if (byId("amkzGlobalDate")) byId("amkzGlobalDate").value = t;
        AMKZ.state.selectedDate = t;
        AMKZ.state.rangeFrom = null;
        AMKZ.state.rangeTo = null;
        await AMKZ.loadView(AMKZ.state.currentView, { force: true });
        AMKZ.toast("Heute", t);
        return;
      }

      // "Zeitraum laden" -> echten Zeitraum (von..bis) aktivieren
      if (event.target.closest("#amkzApplyDateRangeFinal")) {
        const from = byId("amkzDateFromFinal")?.value;
        const to = byId("amkzDateToFinal")?.value;

        if (!from || !to) {
          AMKZ.toast("Zeitraum", "Bitte Von- und Bis-Datum wählen.", "error");
          return;
        }

        AMKZ.state.rangeFrom = from;
        AMKZ.state.rangeTo = to;

        if (byId("amkzGlobalDate")) {
          byId("amkzGlobalDate").value = to;
          AMKZ.state.selectedDate = to;
        }

        await AMKZ.loadView(AMKZ.state.currentView, { force: true });
        AMKZ.toast("Zeitraum geladen", from + " bis " + to);
        return;
      }

      // Klick auf das Einzeldatum -> zurück auf Einzeltag (Aktualisieren behält den Zeitraum)
      if (event.target.closest("#amkzGlobalDate")) {
        AMKZ.state.rangeFrom = null;
        AMKZ.state.rangeTo = null;
      }
    }, true);

    // Wenn das globale Einzeldatum geändert wird -> Zeitraum verlassen
    document.addEventListener("change", (event) => {
      if (event.target.closest("#amkzGlobalDate")) {
        AMKZ.state.rangeFrom = null;
        AMKZ.state.rangeTo = null;
      }
    }, true);
  }

  /* =====================================================
     VIEW EXTENSION
  ===================================================== */

  const previousLoadView = AMKZ.loadView;

  AMKZ.loadView = async function loadViewPart3(view, options = {}) {
    if (typeof previousLoadView === "function") {
      await previousLoadView(view, options);
    }

    ensureDateRange();
    bindDateRangeEvents();
    bindCalendarEvents();
    bindTeamEvents();
    bindChatEvents();
    bindAnalyticsEvents();

    await upsertPresence({ current_view: view });

    if (view === "calendar") await loadCalendarView();
    if (view === "team") await loadTeamView();
    if (view === "connect") await loadConnectView();
    if (view === "analytics") await loadAnalyticsView();
    if (view === "streaming") {
      // Streamingplan beim Öffnen frisch aus dem Sheet laden
      try { window.__amkStreamingplan && window.__amkStreamingplan.load(); } catch (e) {}
    }

    setTimeout(refreshAllLiveUi, 300);
  };

  const previousRealtime = AMKZ.initRealtime;

  AMKZ.initRealtime = function initRealtimePart3() {
    if (typeof previousRealtime === "function") previousRealtime();
    initRealtime();
  };

  /* =====================================================
     FINAL SAFETY / TIMERS
  ===================================================== */

  function finalSafetyRun() {
    const date = byId("amkzGlobalDate");
    if (date && !date.value) date.value = today();

    document.body.classList.toggle(
      "amkz-can-see-profit",
      AMKZ.state.permissions?.seeProfit === true
    );
  }

  window.addEventListener("error", (event) => {
    console.error("AMKZ UI Fehler:", event.error || event.message);
  });

  window.addEventListener("unhandledrejection", (event) => {
    console.error("AMKZ Promise Fehler:", event.reason);
  });

  clearInterval(window.AMKZ_LIVE_POLL_TIMER);
  window.AMKZ_LIVE_POLL_TIMER = setInterval(livePoll, 2500);

  clearInterval(window.AMKZ_ONLINE_FINAL_TIMER);
  window.AMKZ_ONLINE_FINAL_TIMER = setInterval(refreshOnlineTeam, 3000);

  setTimeout(() => {
    ensureDateRange();
    finalSafetyRun();
    refreshAllLiveUi();
  }, 500);

  window.addEventListener("beforeunload", () => {
    setPresenceOffline();
  });

  /* =====================================================
     PUBLIC MODULES
  ===================================================== */

  AMKZ.modules = AMKZ.modules || {};

  AMKZ.modules.calendar = {
    loadCalendarView,
    openCalendarModal,
    selectCalendarDate,
  };
  AMKZ.calendarRespond = respondToEvent;

  // 🏖 Urlaubsantrag: Genehmigen/Ablehnen direkt aus der Connect-Nachricht
  if (!document.body?.dataset.amkVacBound) {
    if (document.body) document.body.dataset.amkVacBound = "1";
    if (!document.getElementById("amk-vac-style")) {
      const st = document.createElement("style"); st.id = "amk-vac-style";
      st.textContent = `
        .amkz-vac-actions{display:flex;gap:8px;margin-top:8px}
        .amkz-vac-ok{background:rgba(80,200,120,.16);border:1px solid rgba(80,200,120,.5);color:#8fe3b0;border-radius:9px;padding:7px 14px;font-weight:800;font-size:.82rem;cursor:pointer}
        .amkz-vac-ok:hover{background:rgba(80,200,120,.26)}
        .amkz-vac-no{background:rgba(220,90,90,.12);border:1px solid rgba(220,90,90,.45);color:#ff9a9a;border-radius:9px;padding:7px 14px;font-weight:700;font-size:.82rem;cursor:pointer}
        .amkz-vac-done{font-weight:800;font-size:.82rem}.amkz-vac-done.ok{color:#8fe3b0}.amkz-vac-done.no{color:#ff9a9a}`;
      document.head.appendChild(st);
    }
    document.addEventListener("click", async (e) => {
      // Urlaub (VAC) ODER Streamwechsel (SC)
      const vOk = e.target.closest("[data-vac-approve]"), vNo = e.target.closest("[data-vac-decline]");
      const sOk = e.target.closest("[data-sc-approve]"), sNo = e.target.closest("[data-sc-decline]");
      const el = vOk || vNo || sOk || sNo; if (!el) return;
      const approve = !!(vOk || sOk);
      const isSc = !!(sOk || sNo);
      const eid = el.getAttribute(approve ? (isSc ? "data-sc-approve" : "data-vac-approve") : (isSc ? "data-sc-decline" : "data-vac-decline"));
      const box = el.closest(".amkz-vac-actions");
      if (box) box.innerHTML = `<span class="amkz-vac-done ${approve ? "ok" : "no"}">${approve ? "✓ Genehmigt" : "✕ Abgelehnt"}</span>`;
      try {
        if (isSc) { await AMKZ.streamChangeDecide?.(eid, approve); }
        else { await respondToEvent(eid, approve ? "accepted" : "declined"); AMKZ.toast?.(approve ? "Genehmigt" : "Abgelehnt", approve ? "Urlaub genehmigt." : "Antrag abgelehnt.", "success"); }
      } catch (err) { AMKZ.toast?.("Fehler", err.message || "Fehlgeschlagen", "error"); }
    });
  }

  AMKZ.modules.team = {
    loadTeamView,
    openMemberModal,
    createMember,
  };

  AMKZ.modules.connect = {
    loadConnectView,
    loadChatUsers,
    openChat,
    sendMessage,
    loadPresence,
    upsertPresence,
    setPresenceOffline,
    refreshAllLiveUi,
  };

  AMKZ.modules.analytics = {
    loadAnalyticsView,
  };

  AMKZ.modules.final = {
    initBusinessRealtime,
    finalSafetyRun,
  };

  window.AMKZ_FORCE_CHAT = loadConnectView;
  window.AMKZ_REFRESH_CHAT_BADGES = refreshChatBadges;
  window.AMKZ_REFRESH_DASHBOARD_NOTIFICATIONS = refreshDashboardNotifications;
  window.AMKZ_REFRESH_LIVE_UI = refreshAllLiveUi;
  window.AMKZ_LIVE_POLL = livePoll;
})();


/* =====================================================
   AMK ZENTRALE — FINAL JS
   PART 4/4 — MOBILE / PUSH / CALL / TWITCH / FINAL PATCHES
===================================================== */

(function () {
  "use strict";

  const AMKZ = window.AMKZ;
  if (!AMKZ) return;

  const {
    byId,
    escapeHtml,
    setText,
    safeNumber,
  } = AMKZ.utils;

  /* =====================================================
     SERVICE WORKER / PUSH
  ===================================================== */

  const VAPID_PUBLIC_KEY =
    "BJDfW5oq201J3bW1qgJEFZFjhRrlqpj_lZeccWWQvbSy1RJ546SddyW2OKBCqFMKdEyMFa9ibSsNUqhVLQbMkVA";

  async function registerServiceWorker() {
    if (!("serviceWorker" in navigator)) return null;
    if (window.AMK_IS_LOCAL) return null;

    try {
      const swPath = window.AMK_SW_PATH || { url: "/cdn/shop/t/7/assets/amk-sw.js", scope: "/cdn/shop/t/7/assets/" };
      window.AMK_SW_REG =
        window.AMK_SW_REG ||
        (await navigator.serviceWorker.register(swPath.url, { scope: swPath.scope }));

      console.log("AMK SW REGISTERED", window.AMK_SW_REG);
      return window.AMK_SW_REG;
    } catch (error) {
      console.error("SW ERROR", error);
      return null;
    }
  }

  function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
    const rawData = atob(base64);
    return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
  }

  async function enableAMKPush() {
    const notify = (t, m, ty) => (AMKZ.toast ? AMKZ.toast(t, m, ty) : alert(t + "\n" + m));
    const btn = byId("amkzEnablePushButton");
    const setBtn = (txt) => { if (btn) btn.textContent = txt; };

    if (!AMKZ?.supabase || !AMKZ.state?.member?.id) {
      notify("Bitte einloggen", "Melde dich zuerst an, um Mitteilungen zu aktivieren.", "error");
      return;
    }

    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const standalone =
      window.navigator.standalone === true ||
      window.matchMedia("(display-mode: standalone)").matches;

    // iOS erlaubt Web-Push nur in der zum Home-Bildschirm hinzugefügten Web-App
    if (isIOS && !standalone) {
      notify(
        "Zum Home-Bildschirm hinzufügen",
        "Auf dem iPhone: Teilen-Symbol ➜ „Zum Home-Bildschirm“. Danach die App von dort öffnen und hier erneut auf „Mitteilungen aktivieren“ tippen.",
        "error"
      );
      return;
    }

    if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) {
      notify("Nicht unterstützt", "Dieses Gerät/Browser unterstützt keine Web-Push-Mitteilungen.", "error");
      return;
    }

    let permission = Notification.permission;
    if (permission === "denied") {
      notify("Mitteilungen blockiert", "Bitte in den Browser-/App-Einstellungen für diese Seite erlauben.", "error");
      return;
    }

    setBtn("Aktiviere…");

    try {
      if (permission !== "granted") permission = await Notification.requestPermission();
      if (permission !== "granted") {
        setBtn("Mitteilungen aktivieren");
        notify("Abgebrochen", "Mitteilungen wurden nicht erlaubt.", "error");
        return;
      }

      const swPath = window.AMK_SW_PATH || { url: "/cdn/shop/t/7/assets/amk-sw.js", scope: "/cdn/shop/t/7/assets/" };
      // Frisch registrieren -> wir benutzen GENAU diese Registration (nicht navigator.serviceWorker.ready,
      // das auf einen seiten-kontrollierenden SW wartet und sonst ewig hängt)
      let registration = null;
      try {
        registration =
          (await navigator.serviceWorker.register(swPath.url, { scope: swPath.scope })) ||
          window.AMK_SW_REG ||
          (await navigator.serviceWorker.getRegistration(swPath.scope));
        window.AMK_SW_REG = registration;
      } catch (e) {
        setBtn("Mitteilungen aktivieren");
        notify("Service Worker Fehler", "SW unter " + swPath.url + " nicht ladbar: " + (e.message || e), "error");
        return;
      }
      if (!registration) {
        setBtn("Mitteilungen aktivieren");
        notify("Fehler", "Service Worker konnte nicht registriert werden (" + swPath.url + ").", "error");
        return;
      }

      // Warten bis der SW aktiv ist (max 8s) – OHNE navigator.serviceWorker.ready
      if (!registration.active) {
        await new Promise((res) => {
          const t = setTimeout(res, 8000);
          const sw = registration.installing || registration.waiting;
          if (sw) sw.addEventListener("statechange", () => { if (sw.state === "activated") { clearTimeout(t); res(); } });
          else res();
        });
      }

      // Bestehendes Abo entfernen (z. B. mit altem VAPID-Key) -> sauber neu abonnieren
      try {
        const old = await registration.pushManager.getSubscription();
        if (old) { try { await AMKZ.supabase.from("push_subscriptions").delete().eq("endpoint", old.endpoint); } catch (_) {} await old.unsubscribe(); }
      } catch (_) {}

      let subscription;
      try {
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
        });
      } catch (e) {
        setBtn("Mitteilungen aktivieren");
        notify("Abo-Fehler", "subscribe() fehlgeschlagen: " + (e.message || e), "error");
        return;
      }

      const sub = subscription.toJSON();
      // MULTI-DEVICE (bis zu 5 Geräte pro User): NUR das alte Abo DIESES Geräts
      // (gleicher Endpoint) ersetzen — die anderen Geräte bleiben erhalten.
      try { await AMKZ.supabase.from("push_subscriptions").delete().eq("endpoint", sub.endpoint); } catch (_) {}
      const { error } = await AMKZ.supabase.from("push_subscriptions").insert({
        user_id: AMKZ.state.member.id,
        endpoint: sub.endpoint,
        p256dh: sub.keys.p256dh,
        auth: sub.keys.auth,
        user_agent: navigator.userAgent,
        updated_at: new Date().toISOString(),
      });
      if (error) {
        setBtn("Mitteilungen aktivieren");
        notify("Speicher-Fehler", error.message, "error");
        return;
      }
      // Auf max. 5 Geräte begrenzen: die ältesten über 5 entfernen
      try {
        const { data: allSubs } = await AMKZ.supabase.from("push_subscriptions")
          .select("endpoint, updated_at").eq("user_id", AMKZ.state.member.id)
          .order("updated_at", { ascending: false });
        if (allSubs && allSubs.length > 5) {
          const toDel = allSubs.slice(5).map((r) => r.endpoint).filter(Boolean);
          if (toDel.length) await AMKZ.supabase.from("push_subscriptions").delete().in("endpoint", toDel);
        }
      } catch (_) {}

      // Selbstprüfung: ist das Abo wirklich in der DB?
      let savedCount = 0;
      try {
        const { data: chk } = await AMKZ.supabase.from("push_subscriptions").select("endpoint").eq("user_id", AMKZ.state.member.id);
        savedCount = (chk || []).length;
      } catch (_) {}

      setBtn("Mitteilungen aktiv ✓");
      notify("Mitteilungen aktiv", "Gespeichert (" + savedCount + " Gerät" + (savedCount === 1 ? "" : "e") + "). Du erhältst ab jetzt Push 🚀");
      try {
        await registration.showNotification("AMK Zentrale", {
          body: "Mitteilungen sind aktiv 🚀",
          icon: "https://cdn.shopify.com/s/files/1/0965/9813/1028/files/Transparent.png?v=1747166822",
        });
      } catch (_) {}
    } catch (err) {
      console.error("PUSH ENABLE ERROR", err);
      setBtn("Mitteilungen aktivieren");
      notify("Fehler", err.message || "Mitteilungen konnten nicht aktiviert werden.", "error");
    }
  }

  /* =====================================================
     MOBILE APP MODE
  ===================================================== */

  function isAmkAppPage() {
    return !!byId("amkzApp");
  }

  function hideShopifyHeaderFooter() {
    if (!isAmkAppPage()) return;

    const selectors = [
      "header",
      "footer",
      ".shopify-section-group-header-group",
      ".shopify-section-group-footer-group",
      "#shopify-section-header",
      "#shopify-section-footer",
      ".header-wrapper",
      ".footer",
      ".announcement-bar-section",
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (!el.closest("#amkzApp")) {
          el.style.display = "none";
        }
      });
    });

    document.body.classList.add("amkz-app-mode");
  }

  function ensureMobileBurger() {
    if (!isAmkAppPage()) return;
    if (byId("amkzMobileMenuButton")) return;

    const btn = document.createElement("button");
    btn.id = "amkzMobileMenuButton";
    btn.className = "amkz-mobile-menu-btn";
    btn.type = "button";
    btn.innerHTML = "☰";

    document.body.appendChild(btn);

    btn.addEventListener("click", () => {
      document.body.classList.toggle("amkz-mobile-menu-open");
    });

    document.addEventListener("click", (event) => {
      if (
        document.body.classList.contains("amkz-mobile-menu-open") &&
        !event.target.closest(".amkz-sidebar") &&
        !event.target.closest("#amkzMobileMenuButton")
      ) {
        document.body.classList.remove("amkz-mobile-menu-open");
      }
    });

    document.querySelectorAll(".amkz-nav-item").forEach((item) => {
      item.addEventListener("click", () => {
        document.body.classList.remove("amkz-mobile-menu-open");
      });
    });
  }

  function initMobileAppMode() {
    hideShopifyHeaderFooter();
    ensureMobileBurger();
  }

  /* =====================================================
     CALL SYSTEM — FINAL SINGLE VERSION
  ===================================================== */

  const CALL = {
    pc: null,            // (legacy alias auf den primären Peer – für 1:1-UI/Screen-Share)
    localStream: null,
    remoteStream: null,  // (legacy alias auf den primären Remote-Stream)
    activeCallId: null,  // = Raum-ID (alle Teilnehmer teilen sie)
    activeOtherId: null, // primärer Gegenüber (für 1:1-Anzeige)
    peers: {},           // MESH: otherId -> { pc, remoteStream, audioEl, polite, makingOffer, ignoreOffer }
    participants: new Set(), // andere Teilnehmer-IDs im Raum (ohne mich)
    seenSignals: new Set(),
    iceBuffer: {},      // otherId -> [candidates] (verhindert verlorene ICE)
    screen: null,       // { stream, track } – geteilter Bildschirm (an alle Peers)
    muted: false,
    cameraOff: false,
    polling: false,
    ending: false,
    timerStart: null,
    timerInterval: null,
  };
  function callPeerCount() { return Object.keys(CALL.peers).length; }
  function primaryPeer() { return CALL.peers[CALL.activeOtherId] || Object.values(CALL.peers)[0] || null; }

  // STUN (für Direktverbindung) + TURN-Fallback (für striktes NAT / verschiedene Netze).
  // WICHTIG: Der öffentliche Open-Relay-TURN ist UNZUVERLÄSSIG. Für stabile
  // netzübergreifende Anrufe einen EIGENEN TURN eintragen (metered.ca Free-Tier mit
  // API-Key, coturn oder Twilio) -> unten als zusätzliche Einträge ergänzen.
  // ===== TURN (metered.ca — echter Relay für Büro<->Homeoffice) =====
  // Der Client holt frische Zugangsdaten über den Per-Credential-Key (NICHT der
  // Master-Secret-Key). Fällt der Abruf aus, greifen die fest hinterlegten Server.
  // Neu erzeugen: POST https://amk-zentrale.metered.live/api/v1/turn/credential?secretKey=<SECRET>
  const AMK_METERED_URL = "https://amk-zentrale.metered.live/api/v1/turn/credentials?apiKey=d268e05a5380c8c921781220b324aeddbf6e";
  const AMK_TURN_STATIC = [
    { urls: "stun:stun.relay.metered.ca:80" },
    { urls: "turn:global.relay.metered.ca:80", username: "050d5fb68925f330a9cb5b99", credential: "hoZmY7sUFB52bW+j" },
    { urls: "turn:global.relay.metered.ca:80?transport=tcp", username: "050d5fb68925f330a9cb5b99", credential: "hoZmY7sUFB52bW+j" },
    { urls: "turn:global.relay.metered.ca:443", username: "050d5fb68925f330a9cb5b99", credential: "hoZmY7sUFB52bW+j" },
    { urls: "turns:global.relay.metered.ca:443?transport=tcp", username: "050d5fb68925f330a9cb5b99", credential: "hoZmY7sUFB52bW+j" },
  ];
  function amkBuildIceServers() {
    const ice = [
      { urls: [
        "stun:stun.l.google.com:19302",
        "stun:stun1.l.google.com:19302",
        "stun:stun2.l.google.com:19302",
        "stun:stun3.l.google.com:19302",
        "stun:stun4.l.google.com:19302",
      ] },
      { urls: "stun:stun.cloudflare.com:3478" },
    ];
    // TURN: frisch gefetchte (window.AMK_TURN) bevorzugt, sonst die fest hinterlegten
    const turn = (Array.isArray(window.AMK_TURN) && window.AMK_TURN.length) ? window.AMK_TURN : AMK_TURN_STATIC;
    turn.forEach((s) => { if (s && s.urls) ice.push(s); });
    // optional eigener TURN per #amkzApp-Attribut
    try {
      const root = document.getElementById("amkzApp");
      const url = root && root.dataset && root.dataset.turnUrl;
      if (url) {
        const user = (root.dataset.turnUser || ""), cred = (root.dataset.turnPass || "");
        url.split(",").map((u) => u.trim()).filter(Boolean).forEach((u) => ice.push({ urls: u, username: user, credential: cred }));
      }
    } catch (_) {}
    return ice;
  }
  const RTC_CONFIG = { iceServers: amkBuildIceServers(), iceCandidatePoolSize: 4 };
  // Frische TURN-Zugangsdaten holen (aktualisiert RTC_CONFIG live, falls die Statik abläuft)
  async function amkRefreshTurn() {
    try {
      const r = await fetch(AMK_METERED_URL, { cache: "no-store" });
      const arr = await r.json();
      if (Array.isArray(arr) && arr.length) {
        window.AMK_TURN = arr;
        RTC_CONFIG.iceServers = amkBuildIceServers();
        window.AMK_RTC_HAS_TURN = true;
      }
    } catch (_) {}
  }
  amkRefreshTurn(); setInterval(amkRefreshTurn, 45 * 60 * 1000);
  try { window.AMK_RTC_HAS_TURN = RTC_CONFIG.iceServers.some((s) => /turns?:/.test([].concat(s.urls).join(","))); } catch (_) {}

  function amkBufferIce(otherId, cand) {
    if (!CALL.iceBuffer[otherId]) CALL.iceBuffer[otherId] = [];
    CALL.iceBuffer[otherId].push(cand);
  }
  async function amkFlushIce(otherId) {
    const peer = CALL.peers[otherId];
    if (!peer || !peer.pc.remoteDescription) return;
    const list = CALL.iceBuffer[otherId] || [];
    CALL.iceBuffer[otherId] = [];
    for (const c of list) {
      try { await peer.pc.addIceCandidate(new RTCIceCandidate(c)); } catch (e) { if (!peer.ignoreOffer) console.warn("ICE add", e); }
    }
  }

  const RINGTONE_URL =
    "https://cdn.shopify.com/s/files/1/0965/9813/1028/files/Ringtone_Sound_Effect.mp3?v=1778569610";

  let audioUnlocked = false;

  function unlockAudio() {
    if (audioUnlocked) return;

    try {
      const audio = new Audio(RINGTONE_URL);
      audio.volume = 0.01;
      audio.play()
        .then(() => {
          audio.pause();
          audio.currentTime = 0;
          audioUnlocked = true;
          window.AMK_AUDIO_UNLOCKED = true;
        })
        .catch(() => {});
    } catch (_) {}
    // Benachrichtigungston ebenfalls freischalten (sonst blockt der Browser den Play beim Nachrichteneingang)
    try {
      // NOTIFICATION_URL steht in einer anderen IIFE — hier ueber AMKZ holen.
      // Vorher stand die Konstante direkt hier: das warf einen ReferenceError,
      // den das umgebende catch verschluckte. Folge war, dass der
      // Benachrichtigungston nie freigeschaltet wurde und der Browser ihn
      // beim Nachrichteneingang blockierte.
      const n = new Audio(AMKZ.NOTIFICATION_URL); n.volume = 0.01;
      n.play().then(() => { n.pause(); n.currentTime = 0; }).catch(() => {});
    } catch (_) {}
  }

  function startRing() {
    stopRing();
    // Ring-Guard freigeben (sonst wird die Klingel global blockiert)
    window.__AMK_ALLOW_RING = true;

    // 1) MP3-Klingel
    try {
      const audio = new Audio(RINGTONE_URL);
      audio.loop = true;
      audio.volume = 1;
      window.AMK_RING_AUDIO = audio;
      audio.play().catch(() => {});
    } catch (_) {}

    // 2) Web-Audio-Klingel als zuverlässiger Fallback (Autoplay-resistent nach Geste)
    try {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (Ctx) {
        const ctx = new Ctx();
        window.AMK_RING_CTX = ctx;
        const beep = (t) => {
          const o = ctx.createOscillator(), g = ctx.createGain();
          o.type = "sine"; o.frequency.value = 880;
          o.connect(g); g.connect(ctx.destination);
          const n = ctx.currentTime + t;
          g.gain.setValueAtTime(0.0001, n);
          g.gain.exponentialRampToValueAtTime(0.25, n + 0.05);
          g.gain.setValueAtTime(0.25, n + 0.35);
          g.gain.exponentialRampToValueAtTime(0.0001, n + 0.45);
          o.start(n); o.stop(n + 0.5);
        };
        const cycle = () => { if (window.AMK_RING_CTX === ctx) { beep(0); beep(0.55); } };
        cycle();
        window.AMK_RING_TIMER = setInterval(cycle, 1800);
      }
    } catch (_) {}
  }

  function stopRing() {
    try { if (window.AMK_RING_AUDIO) { window.AMK_RING_AUDIO.pause(); window.AMK_RING_AUDIO.currentTime = 0; } } catch (_) {}
    window.AMK_RING_AUDIO = null;
    try { clearInterval(window.AMK_RING_TIMER); } catch (_) {}
    window.AMK_RING_TIMER = null;
    try { window.AMK_RING_CTX?.close?.(); } catch (_) {}
    window.AMK_RING_CTX = null;
  }

  // Eigene, saubere Signaling-Tabelle (volle Kontrolle über Spalten)
  const RTC_TABLE = "amk_rtc_signals";

  function callPayload(row) {
    return row.payload || row.signal_payload || row.signal_data || {};
  }

  async function markSignalRead(id) {
    if (!id || !AMKZ?.supabase) return;
    try {
      await AMKZ.supabase.from(RTC_TABLE).update({ is_read: true }).eq("id", id);
    } catch (_) {}
  }

  async function sendCallSignal(callId, to, type, data = {}) {
    try {
      const { error } = await AMKZ.supabase.from(RTC_TABLE).insert({
        call_id: callId,
        sender_id: AMKZ.state.member.id,
        receiver_id: to,
        type: type,
        payload: data,
        is_read: false,
      });
      if (error) throw error;
    } catch (e) {
      console.error("RTC signal send error", e);
    }
  }

  async function createCallSession(receiverId, type) {
    // call_id clientseitig erzeugen -> keine Abhängigkeit von call_sessions
    return (window.crypto?.randomUUID ? crypto.randomUUID() : "call_" + Date.now() + "_" + Math.random().toString(36).slice(2));
  }

  function removeOldCallUi() {
    document.querySelectorAll(
      "#amkzIncomingCallPopup,.amkz-incoming-call-popup,#amkzCallOverlay,.amkz-call-overlay,#amkzCallWindow,#amkIncomingFinal,#amkzFloatingCall"
    ).forEach((el) => el.remove());
  }

  function ensureCallUi() {
    if (!byId("amkCallScreenFinal")) {
      document.body.insertAdjacentHTML(
        "beforeend",
        `
        <div id="amkCallScreenFinal" class="amk-call-screen">
          <div class="amk-call-card-final">
            <div class="amk-call-head-final">
              <div class="amk-call-id-final">
                <span id="amkCallAvatarFinal" class="amk-call-ava-final">A</span>
                <div>
                  <strong id="amkCallTitleFinal">AMK Call</strong>
                  <small id="amkCallStatusFinal">Bereit</small>
                </div>
              </div>
              <button id="amkFullscreenFinal" class="amk-call-btn-final" type="button">⛶</button>
            </div>

            <div class="amk-call-body-final">
              <div class="amk-video-main-final">
                <video id="amkRemoteVideoFinal" autoplay playsinline></video>
              </div>
              <video id="amkLocalVideoFinal" autoplay muted playsinline></video>
              <div class="amk-call-stage-final">
                <span id="amkCallAvatarBigFinal" class="amk-call-ava-big">A</span>
                <strong id="amkCallStageName">Mitarbeiter</strong>
                <small id="amkCallStageStatus">Audio Call</small>
                <span id="amkCallTimerFinal" class="amk-call-timer"></span>
              </div>
              <div id="amkCallParticipantsFinal" class="amk-call-participants-final"></div>
            </div>

            <div class="amk-call-controls-final">
              <button id="amkMuteFinal" class="amk-call-btn-final" type="button" title="Mikrofon"><span class="amk-cbi">🎤</span><span class="amk-cbl">Mikro</span></button>
              <button id="amkCameraFinal" class="amk-call-btn-final" type="button" title="Kamera"><span class="amk-cbi">📷</span><span class="amk-cbl">Kamera</span></button>
              <button id="amkScreenShareFinal" class="amk-call-btn-final" type="button" title="Bildschirm teilen"><span class="amk-cbi"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" style="width:22px;height:22px" aria-hidden="true"><rect x="3" y="4.5" width="18" height="12" rx="2"/><path d="M8.5 20.5h7M12 16.5v4"/><path d="M12 13V7.4m0 0L9.7 9.7M12 7.4l2.3 2.3"/></svg></span><span class="amk-cbl">Teilen</span></button>
              <button id="amkCallAddCtrlFinal" class="amk-call-btn-final" type="button" title="Person hinzufügen"><span class="amk-cbi">＋</span><span class="amk-cbl">Person</span></button>
              <button id="amkEndCallFinal" class="amk-call-btn-final danger" type="button" title="Auflegen"><span class="amk-cbi">✕</span><span class="amk-cbl">Auflegen</span></button>
            </div>
          </div>
        </div>
        `
      );
    }

    if (!byId("amkIncomingFinal")) {
      document.body.insertAdjacentHTML(
        "beforeend",
        `
        <div id="amkIncomingFinal" class="amk-incoming-final">
          <div class="amk-incoming-card-final">
            <span id="amkIncomingAvatarFinal" class="amk-call-ava-big">A</span>
            <h2 id="amkIncomingTitleFinal">Eingehender Anruf</h2>
            <p id="amkIncomingTextFinal">AMK Call</p>
            <div class="amk-incoming-actions-final">
              <button id="amkAcceptFinal" type="button">Annehmen</button>
              <button id="amkDeclineFinal" type="button">Ablehnen</button>
            </div>
          </div>
        </div>
        `
      );
    }

    if (!byId("amkGroupModalFinal")) {
      document.body.insertAdjacentHTML(
        "beforeend",
        `
        <div id="amkGroupModalFinal" class="amk-group-modal-final">
          <div class="amk-group-card-final">
            <h2>Gruppencall starten</h2>
            <div id="amkGroupListFinal" class="amk-group-list-final"></div>
            <div class="amk-group-actions-final">
              <button id="amkStartGroupFinal" type="button">Gruppencall starten</button>
              <button id="amkCloseGroupFinal" type="button">Schließen</button>
            </div>
          </div>
        </div>
        `
      );
    }
  }

  function showCallUi(status = "Verbinde...") {
    ensureCallUi();
    removeOldCallUiExceptFinal();

    byId("amkCallScreenFinal")?.classList.add("active");
    setText(byId("amkCallStatusFinal"), status);
  }

  function hideCallUi() {
    byId("amkCallScreenFinal")?.classList.remove("active");
  }

  function removeOldCallUiExceptFinal() {
    document.querySelectorAll(
      "#amkzIncomingCallPopup,.amkz-incoming-call-popup,#amkzCallOverlay,.amkz-call-overlay,#amkzCallWindow,#amkzFloatingCall"
    ).forEach((el) => el.remove());
  }

  function showIncomingCall(signal) {
    ensureCallUi();

    const data = callPayload(signal);
    const isInvite = signal.type === "invite";

    // Anrufer-Namen ermitteln + Call-ID merken (für Abbruch vor Annahme)
    CALL.incomingCallId = signal.call_id;
    CALL.incomingFrom = signal.sender_id;
    const callerName = amkUserName(signal.sender_id) || "Mitarbeiter";

    setText(byId("amkIncomingTitleFinal"), callerName);
    setText(byId("amkIncomingTextFinal"), (isInvite ? "Konferenz · holt dich dazu…" : "Audioanruf · ruft dich an…"));
    const ia = byId("amkIncomingAvatarFinal"); if (ia) ia.textContent = amkInitial(callerName);

    byId("amkIncomingFinal")?.classList.add("active");

    startRing();

    byId("amkAcceptFinal").onclick = async () => {
      byId("amkIncomingFinal")?.classList.remove("active");
      stopRing();
      amkPrimeRemoteAudio(); // Audio innerhalb der Annehmen-Geste entsperren
      CALL.incomingCallId = null;
      if (isInvite) await joinConference(signal);
      else await acceptCall(signal);
    };

    byId("amkDeclineFinal").onclick = async () => {
      byId("amkIncomingFinal")?.classList.remove("active");
      stopRing();
      CALL.incomingCallId = null;
      await sendCallSignal(signal.call_id, signal.sender_id, "decline", {});
      await markSignalRead(signal.id);
    };
  }

  function amkUserName(id) {
    if (!id) return "";
    const u = (AMKZ.state.chatUsers || []).find((x) => String(x.id) === String(id))
      || (AMKZ.state.team || []).find((x) => String(x.id) === String(id));
    return u?.name || u?.email || "";
  }

  // ===== Telefon-Display: zeigt mit WEM man telefoniert (Name + Avatar) =====
  function amkInitial(name) {
    return String(name || "?").trim().charAt(0).toUpperCase() || "?";
  }
  function setCallDisplay(otherId, status) {
    ensureCallUi();
    try { window.AMK_CALL_PARTNER = otherId || CALL.activeOtherId || null; } catch (_) {}
    const name = amkUserName(otherId) || "Mitarbeiter";
    const initial = amkInitial(name);
    setText(byId("amkCallTitleFinal"), name);
    setText(byId("amkCallStageName"), name);
    const a1 = byId("amkCallAvatarFinal"); if (a1) a1.textContent = initial;
    const a2 = byId("amkCallAvatarBigFinal"); if (a2) a2.textContent = initial;
    if (status != null) {
      setText(byId("amkCallStatusFinal"), status);
      setText(byId("amkCallStageStatus"), status);
    }
  }
  function startCallTimer() {
    stopCallTimer();
    CALL.timerStart = Date.now();
    const tick = () => {
      const el = byId("amkCallTimerFinal");
      if (!el) return;
      const total = Math.max(0, Math.floor((Date.now() - CALL.timerStart) / 1000));
      const mm = String(Math.floor(total / 60)).padStart(2, "0");
      const ss = String(total % 60).padStart(2, "0");
      el.textContent = mm + ":" + ss;
    };
    tick();
    CALL.timerInterval = setInterval(tick, 1000);
  }
  function stopCallTimer() {
    if (CALL.timerInterval) { clearInterval(CALL.timerInterval); CALL.timerInterval = null; }
    CALL.timerStart = null;
    const el = byId("amkCallTimerFinal"); if (el) el.textContent = "";
  }
  function markCallConnected() {
    setText(byId("amkCallStatusFinal"), "Verbunden");
    setText(byId("amkCallStageStatus"), "Verbunden");
    byId("amkCallScreenFinal")?.classList.add("amk-call-connected");
    amkResumeRemoteAudio();
    try { callPlayAllRemote(); } catch (_) {}
    if (!CALL.timerInterval) startCallTimer();
  }

  // ===== AUDIO-ENTSPERRUNG (Autoplay) =====
  // Browser (v.a. iOS/Safari, Chrome mobil) blocken remoteAudio.play(), wenn
  // es NICHT direkt aus einer Nutzer-Geste kommt. ontrack läuft aber async NACH
  // der Geste -> beidseitig kein Ton. Lösung: das Audio-Element schon WÄHREND
  // der Tipp-Geste (Anrufen/Annehmen) anlegen + kurz play() -> danach ist es
  // "gesegnet" und spätere Wiedergabe mit echtem srcObject ist erlaubt.
  function amkGetRemoteAudioEl() {
    let a = byId("amkRemoteAudioFinal");
    if (!a) {
      a = document.createElement("audio");
      a.id = "amkRemoteAudioFinal";
      a.autoplay = true;
      a.playsInline = true;
      a.setAttribute("playsinline", "");
      document.body.appendChild(a);
    }
    return a;
  }
  function amkPrimeRemoteAudio() {
    try {
      const a = amkGetRemoteAudioEl();
      a.muted = false; a.volume = 1;
      const p = a.play(); if (p && p.catch) p.catch(() => {});
    } catch (_) {}
  }
  function amkResumeRemoteAudio() {
    try {
      const a = byId("amkRemoteAudioFinal");
      if (a) { a.muted = false; a.volume = 1; const p = a.play(); if (p && p.catch) p.catch(() => {}); }
      const rv = byId("amkRemoteVideoFinal");
      const p2 = rv && rv.play && rv.play(); if (p2 && p2.catch) p2.catch(() => {});
    } catch (_) {}
  }

  // Zentraler Push-Sender (ruft die Edge Function send-push auf)
  async function amkSendPush(userId, title, body, extra = {}) {
    if (!userId) return;
    const root = byId("amkzApp");
    const url = (root?.dataset?.supabaseUrl || "").replace(/\/$/, "");
    const anon = root?.dataset?.supabaseKey || "";
    if (!url || !anon) return;
    try {
      await fetch(url + "/functions/v1/send-push", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + anon, apikey: anon },
        body: JSON.stringify({ user_id: userId, title: title || "AMK Zentrale", body: body || "", url: "/pages/zentrale", ...extra }),
      });
    } catch (e) { console.warn("push send", e); }
  }
  AMKZ.push = AMKZ.push || {};
  AMKZ.push.send = amkSendPush;
  window.AMK_SEND_PUSH = amkSendPush;

  // ===== Anruf-Aktion aus Push/Benachrichtigung verarbeiten =====
  async function amkHandleCallAction(action, callId) {
    try {
      const me = AMKZ.state.member?.id;
      if (!me) return;
      if (action === "open") { pollCallSignals(); return; }

      // passendes Offer holen
      const { data } = await AMKZ.supabase
        .from(RTC_TABLE).select("*")
        .eq("receiver_id", me).eq("type", "offer")
        .order("created_at", { ascending: false }).limit(8);
      const offers = data || [];
      const offer = (callId && offers.find((s) => s.call_id === callId)) || offers[0];

      if (action === "accept") {
        if (offer) { byId("amkIncomingFinal")?.classList.remove("active"); stopRing(); amkPrimeRemoteAudio(); CALL.incomingCallId = null; await acceptCall(offer); }
        else pollCallSignals();
      } else if (action === "decline") {
        const to = offer?.sender_id || callId;
        if (offer) await sendCallSignal(offer.call_id, offer.sender_id, "decline", {});
        byId("amkIncomingFinal")?.classList.remove("active"); stopRing(); CALL.incomingCallId = null;
      }
    } catch (e) { console.warn("call action", e); }
  }

  // Chat aus einer Benachrichtigung heraus öffnen (wartet auf Login + Connect)
  function amkOpenChatFromNotif(userId) {
    if (!userId) return;
    let tries = 0;
    (function go() {
      tries++;
      const ready =
        window.AMKZ && AMKZ.state && AMKZ.state.member &&
        AMKZ.modules && AMKZ.modules.connect && AMKZ.modules.connect.openChat &&
        document.querySelector('.amkz-nav-item[data-view="connect"]');
      if (!ready) { if (tries < 80) setTimeout(go, 250); return; }  // bis ~20s auf Login warten
      try { document.querySelector('.amkz-nav-item[data-view="connect"]').click(); } catch (_) {}
      setTimeout(() => { try { AMKZ.modules.connect.openChat(userId); } catch (_) {} }, 500);
    })();
  }
  window.AMK_OPEN_CHAT = amkOpenChatFromNotif;

  // Nachricht vom Service Worker (Klick auf Anruf- ODER Chat-Benachrichtigung)
  try {
    navigator.serviceWorker?.addEventListener?.("message", (e) => {
      if (e.data && e.data.amkcall) amkHandleCallAction(e.data.amkcall, e.data.call_id || "");
      if (e.data && e.data.amkchat) amkOpenChatFromNotif(e.data.amkchat);
    });
  } catch (_) {}

  // URL-Hash beim App-Öffnen (#amkchat=<userId>) -> Chat direkt öffnen
  function amkCheckChatHash() {
    const m = (location.hash || "").match(/amkchat=([^&]+)/);
    if (!m) return;
    const id = decodeURIComponent(m[1]);
    try { history.replaceState(null, "", location.pathname + location.search); } catch (_) {}
    setTimeout(() => amkOpenChatFromNotif(id), 1000);
  }
  amkCheckChatHash();
  window.addEventListener("hashchange", amkCheckChatHash);

  // Vom Service-Worker gemerkten Chat abholen (zuverlässig auch nach Kaltstart auf iOS)
  async function amkConsumePendingChat() {
    try {
      if (!("caches" in window)) return;
      const c = await caches.open("amk-nav");
      const r = await c.match("pending-chat");
      if (!r) return;
      const data = await r.json();
      await c.delete("pending-chat");
      if (data && data.id && Date.now() - (data.ts || 0) < 180000) {
        amkOpenChatFromNotif(data.id);
      }
    } catch (_) {}
  }
  amkConsumePendingChat();
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") amkConsumePendingChat();
  });
  window.addEventListener("focus", amkConsumePendingChat);

  // URL-Hash beim App-Öffnen (#amkcall=accept&id=...)
  function amkCheckCallHash() {
    const m = (location.hash || "").match(/amkcall=(accept|decline|open)/);
    if (!m) return;
    const idm = (location.hash || "").match(/[?&]id=([^&]*)/);
    const id = idm ? decodeURIComponent(idm[1]) : "";
    try { history.replaceState(null, "", location.pathname + location.search); } catch (_) {}
    setTimeout(() => amkHandleCallAction(m[1], id), 800);
  }

  // Beim Öffnen/Fokussieren der App sofort auf eingehende Anrufe prüfen (schnelles Popup)
  if (!window.__amkCallFocusBound) {
    window.__amkCallFocusBound = true;
    document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") { try { pollCallSignals(); } catch (_) {} } });
    window.addEventListener("focus", () => { try { pollCallSignals(); } catch (_) {} });
    setTimeout(amkCheckCallHash, 1200);
  }

  // Verpassten Anruf protokollieren: Mitteilung + Chat-Nachricht beim Empfänger
  async function logMissedCall(receiverId) {
    if (!receiverId || !AMKZ?.supabase) return;
    const fromName = AMKZ.state.member?.name || AMKZ.state.member?.email || "Mitarbeiter";
    try {
      await AMKZ.supabase.from("notifications").insert({
        target_user_id: receiverId, type: "call", title: "Verpasster Anruf",
        message: `📞 Verpasster Anruf von ${fromName}`, is_read: false,
        created_at: new Date().toISOString(), payload: { from: AMKZ.state.member?.id, push: "false" },
      });
    } catch (_) {}
    try {
      const conv = await AMKZ.api.rpc("amk_get_or_create_conversation", {
        p_user_a: AMKZ.state.member.id, p_user_b: receiverId,
      });
      if (conv?.id) {
        await AMKZ.api.rpc("amk_send_message", {
          p_conversation_id: conv.id, p_sender_id: AMKZ.state.member.id,
          p_receiver_id: receiverId, p_message: `📞 Verpasster Anruf von ${fromName}`,
          p_client_temp_id: "miss_" + Date.now(),
        });
      }
    } catch (_) {}
    // Push für verpassten Anruf
    amkSendPush(receiverId, "Verpasster Anruf", `📞 Verpasster Anruf von ${fromName}`);
  }

  /* ===================== MESH-ANRUFE (bis ~4 Personen) ===================== */
  // Lokalen Mikrofon-Stream EINMAL holen (für alle Peers geteilt)
  async function ensureLocalStream() {
    const live = CALL.localStream && CALL.localStream.getAudioTracks().some((t) => t.readyState === "live");
    if (live) return CALL.localStream;
    CALL.localStream = await navigator.mediaDevices.getUserMedia({
      audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
      video: false,
    });
    CALL.muted = false;
    CALL.localStream.getTracks().forEach((t) => { t.enabled = true; });
    const muteBtn = byId("amkMuteFinal");
    if (muteBtn) { muteBtn.textContent = "🎤"; muteBtn.classList.remove("active"); }
    return CALL.localStream;
  }

  function callPlayAllRemote() {
    Object.values(CALL.peers).forEach((p) => {
      try {
        const a = p.audioEl;
        if (a) { a.muted = false; a.volume = 1; if (!a.srcObject && p.remoteStream) a.srcObject = p.remoteStream; a.play?.().catch(() => {}); }
      } catch (_) {}
    });
    try { const rv = byId("amkRemoteVideoFinal"); if (rv) { rv.play?.().catch(() => {}); } } catch (_) {}
  }
  // Autoplay-Sperre: bei JEDER Nutzer-Geste Ton aller Teilnehmer sicher starten
  if (!window.__amkAudioResumeBound) {
    window.__amkAudioResumeBound = true;
    ["click", "touchstart", "keydown", "pointerdown"].forEach((ev) =>
      document.addEventListener(ev, () => { if (callPeerCount()) callPlayAllRemote(); }, true)
    );
  }

  function peerPolite(otherId) { return String(AMKZ.state.member?.id || "") < String(otherId); }

  function attachRemoteVideo(peer) {
    const rv = byId("amkRemoteVideoFinal");
    if (rv) { rv.srcObject = peer.remoteStream; rv.muted = true; try { rv.play?.().catch(() => {}); } catch (_) {} }
  }
  function hasAnyRemoteVideo() {
    return Object.values(CALL.peers).some((p) => { try { return p.remoteStream.getVideoTracks().length > 0; } catch (_) { return false; } });
  }

  // Erzeugt (oder liefert) die Peer-Verbindung zu EINEM Teilnehmer
  function makePeer(otherId) {
    if (CALL.peers[otherId]) return CALL.peers[otherId];
    const pc = new RTCPeerConnection(RTC_CONFIG);
    const audio = document.createElement("audio");
    audio.autoplay = true; audio.playsInline = true; audio.muted = false; audio.volume = 1;
    audio.id = "amkPeerAudio_" + String(otherId).replace(/[^a-zA-Z0-9_-]/g, "");
    document.body.appendChild(audio);
    const peer = { pc, otherId, remoteStream: new MediaStream(), audioEl: audio, polite: peerPolite(otherId), makingOffer: false, ignoreOffer: false };
    CALL.peers[otherId] = peer;
    CALL.participants.add(otherId);
    // primären Peer (für 1:1-UI) merken
    if (!CALL.activeOtherId) CALL.activeOtherId = otherId;
    CALL.pc = (primaryPeer() || peer).pc;

    pc.ontrack = (event) => {
      (event.streams[0] ? event.streams[0].getTracks() : [event.track]).forEach((track) => {
        try { peer.remoteStream.addTrack(track); } catch (_) {}
        if (track.kind === "video") {
          revealCallVideo(true);
          attachRemoteVideo(peer);
          const back = () => { if (!hasAnyRemoteVideo() && !CALL.screen) revealCallVideo(false); };
          track.addEventListener("ended", () => { try { peer.remoteStream.removeTrack(track); } catch (_) {} back(); });
          track.addEventListener("mute", back);
        }
      });
      audio.srcObject = peer.remoteStream;
      try { audio.play?.().catch(() => {}); } catch (_) {}
      CALL.remoteStream = (primaryPeer() || peer).remoteStream;
      CALL.answered = true; stopRing(); markCallConnected();
    };
    pc.onicecandidate = (event) => {
      if (event.candidate && CALL.activeCallId) sendCallSignal(CALL.activeCallId, otherId, "ice", event.candidate.toJSON());
    };
    pc.onnegotiationneeded = async () => {
      try {
        peer.makingOffer = true;
        await pc.setLocalDescription();
        await sendCallSignal(CALL.activeCallId, otherId, "offer", { sdp: pc.localDescription });
      } catch (e) { console.warn("[call] negotiationneeded", e); } finally { peer.makingOffer = false; }
    };
    pc.oniceconnectionstatechange = () => { if (pc.iceConnectionState === "failed") { try { pc.restartIce?.(); } catch (_) {} } };
    pc.onconnectionstatechange = () => {
      const s = pc.connectionState;
      if (s === "connected") { CALL.answered = true; stopRing(); markCallConnected(); }
      else if (s === "failed" || s === "closed") { removePeer(otherId); }
    };
    updateParticipantsUi();
    return peer;
  }

  // Lokale Tracks (Mikro + ggf. geteilter Bildschirm) an einen Peer hängen
  function addLocalTracksToPeer(peer) {
    if (!CALL.localStream) return;
    const have = peer.pc.getSenders().map((s) => s.track).filter(Boolean);
    CALL.localStream.getTracks().forEach((t) => { if (!have.includes(t)) { try { peer.pc.addTrack(t, CALL.localStream); } catch (_) {} } });
    if (CALL.screen && CALL.screen.track && !have.includes(CALL.screen.track)) { try { peer.pc.addTrack(CALL.screen.track, CALL.screen.stream); } catch (_) {} }
  }

  // Eingehendes Offer eines Teilnehmers (Perfect Negotiation gegen Glare)
  async function handleRemoteOffer(otherId, sdp) {
    let peer = CALL.peers[otherId];
    const isNew = !peer;
    if (!peer) peer = makePeer(otherId);
    const pc = peer.pc;
    const collision = peer.makingOffer || pc.signalingState !== "stable";
    peer.ignoreOffer = !peer.polite && collision;
    if (peer.ignoreOffer) return;
    try {
      await pc.setRemoteDescription(new RTCSessionDescription(sdp));
      if (isNew) addLocalTracksToPeer(peer); // Antwortseite: Tracks NACH dem Remote-Offer -> keine doppelte Verhandlung
      await amkFlushIce(otherId);
      await pc.setLocalDescription(); // implizite Antwort
      await sendCallSignal(CALL.activeCallId, otherId, "answer", { sdp: pc.localDescription });
    } catch (e) { console.warn("[call] handleRemoteOffer", e); }
  }
  async function handleRemoteAnswer(otherId, sdp) {
    const peer = CALL.peers[otherId]; if (!peer) return;
    try { await peer.pc.setRemoteDescription(new RTCSessionDescription(sdp)); await amkFlushIce(otherId); }
    catch (e) { console.warn("[call] handleRemoteAnswer", e); }
  }
  async function handleRemoteIce(otherId, cand) {
    const peer = CALL.peers[otherId];
    if (!peer || !peer.pc.remoteDescription) { amkBufferIce(otherId, cand); return; }
    try { await peer.pc.addIceCandidate(new RTCIceCandidate(cand)); } catch (e) { if (!peer.ignoreOffer) console.warn("ICE add", e); }
  }

  function removePeer(otherId) {
    const peer = CALL.peers[otherId];
    if (!peer) return;
    try { peer.pc.close?.(); } catch (_) {}
    try { peer.audioEl?.remove?.(); } catch (_) {}
    delete CALL.peers[otherId];
    CALL.participants.delete(otherId);
    delete CALL.iceBuffer[otherId];
    if (CALL.activeOtherId === otherId) CALL.activeOtherId = Object.keys(CALL.peers)[0] || null;
    CALL.pc = primaryPeer()?.pc || null;
    CALL.remoteStream = primaryPeer()?.remoteStream || null;
    if (!hasAnyRemoteVideo() && !CALL.screen) revealCallVideo(false);
    updateParticipantsUi();
    if (!CALL.ending && callPeerCount() === 0) endCall(false);
  }

  function updateParticipantsUi() {
    const names = [...CALL.participants].map((id) => amkUserName(id) || "Teilnehmer");
    const n = names.length;
    const label = n <= 1 ? "Audio Call" : `Konferenz · ${n + 1} Teilnehmer`;
    setText(byId("amkCallParticipantsFinal"), label);
    const screen = byId("amkCallScreenFinal");
    if (screen) screen.classList.toggle("amk-conference", n > 1);
    // Bühne: bei Konferenz die Namen zeigen
    if (n > 1) {
      setText(byId("amkCallStageName"), names.join(", "));
      setText(byId("amkCallTitleFinal"), `Konferenz (${n + 1})`);
    }
  }

  // Mikro-Stream aufsetzen + Call-UI zeigen (gemeinsam für Anrufen/Annehmen)
  async function prepareCallMedia() {
    await ensureLocalStream();
    let remoteAudio = byId("amkRemoteAudioFinal");
    if (!remoteAudio) { remoteAudio = document.createElement("audio"); remoteAudio.id = "amkRemoteAudioFinal"; remoteAudio.autoplay = true; remoteAudio.playsInline = true; document.body.appendChild(remoteAudio); }
    window.AMK_REMOTE_AUDIO = remoteAudio;
    showCallUi("Verbinde...");
    const localVideo = byId("amkLocalVideoFinal");
    if (localVideo) { localVideo.muted = true; }
    byId("amkCallScreenFinal")?.classList.add("amk-audio-only");
    updateParticipantsUi();
  }

  // Konferenz beitreten: mit ALLEN bestehenden Teilnehmern verbinden (ich initiiere die Offers)
  async function joinConference(signal) {
    try {
      const data = callPayload(signal);
      await cleanupMediaOnly();
      CALL.ending = false;
      CALL.activeCallId = signal.call_id;
      CALL.isCaller = false;
      CALL.answered = true;
      CALL.incomingCallId = null;
      await markSignalRead(signal.id);
      await prepareCallMedia();
      const myId = AMKZ.state.member?.id;
      const others = (data.participants || []).filter((id) => id && id !== myId);
      others.forEach((id) => { const p = makePeer(id); addLocalTracksToPeer(p); }); // -> Offers via onnegotiationneeded
      CALL.activeOtherId = others[0] || null;
      showCallUi("Verbunden");
      setCallDisplay(CALL.activeOtherId, "Verbunden");
      markCallConnected();
      updateParticipantsUi();
    } catch (e) { console.error("JOIN CONFERENCE ERROR", e); AMKZ.toast?.("Konferenz", e.message || "Beitritt fehlgeschlagen.", "error"); }
  }

  // Person in einen laufenden Call holen: Einladung + Push (die Person verbindet sich dann mit allen)
  async function addPersonToCall(userId) {
    if (!CALL.activeCallId || !userId) return;
    if (userId === AMKZ.state.member?.id) return;
    if (CALL.participants.has(userId)) { AMKZ.toast?.("Konferenz", (amkUserName(userId) || "Person") + " ist schon im Call.", "error"); return; }
    if (callPeerCount() >= 3) { AMKZ.toast?.("Konferenz", "Maximal 4 Personen pro Anruf.", "error"); return; }
    const myId = AMKZ.state.member?.id;
    const participants = [myId, ...CALL.participants].filter((id) => id && id !== userId);
    await sendCallSignal(CALL.activeCallId, userId, "invite", { participants });
    amkSendPush(userId, "📞 Konferenz-Einladung", (AMKZ.state.member?.name || "Jemand") + " holt dich in einen Anruf", {
      type: "call", call_id: CALL.activeCallId, from: myId,
    });
    AMKZ.toast?.("Konferenz", (amkUserName(userId) || "Person") + " wird dazugeholt…");
  }

  async function startCall(type = "video", userId = null) {
    try {
      stopRing();

      const to = userId || AMKZ.state.currentChatUserId;

      if (!to) {
        AMKZ.toast?.("Call", "Bitte zuerst Mitarbeiter im Chat auswählen.", "error");
        return;
      }

      await cleanupMediaOnly();        // sauberer Start (alte Verbindungen schließen)
      CALL.ending = false;
      CALL.activeCallId = await createCallSession(to, type);
      CALL.isCaller = true;
      CALL.answered = false;

      await prepareCallMedia();
      if (type === "video") { try { await enableCamera(); } catch (_) {} } // Kamera VOR dem Peer -> direkt im Offer
      const peer = makePeer(to);
      CALL.activeOtherId = to;
      addLocalTracksToPeer(peer);       // -> onnegotiationneeded sendet das Offer automatisch

      // Push an den Angerufenen (auch wenn App geschlossen/gesperrt) – mit Anruf-Daten
      amkSendPush(to, "📞 Eingehender Anruf", (AMKZ.state.member?.name || "Jemand") + " ruft dich an", {
        type: "call", call_id: CALL.activeCallId, from: AMKZ.state.member?.id,
      });

      showCallUi("Ruft an...");
      setCallDisplay(to, "Ruft an…");
    } catch (error) {
      console.error("CALL START ERROR", error);
      AMKZ.toast?.("Call Fehler", error.message || "Call konnte nicht gestartet werden.", "error");
      await endCall(false);
    }
  }

  async function acceptCall(signal) {
    try {
      const data = callPayload(signal);

      await cleanupMediaOnly();
      CALL.ending = false;
      CALL.activeCallId = signal.call_id;
      CALL.activeOtherId = signal.sender_id;
      CALL.isCaller = false;
      CALL.answered = true; // Angenommen
      CALL.incomingCallId = null;

      await markSignalRead(signal.id);
      await prepareCallMedia();

      // Peer zum Anrufer aufbauen + dessen Offer beantworten (Perfect Negotiation)
      await handleRemoteOffer(signal.sender_id, data.sdp);

      showCallUi("Verbunden");
      setCallDisplay(CALL.activeOtherId, "Verbunden");
      markCallConnected();
    } catch (error) {
      console.error("ACCEPT CALL ERROR", error);
      AMKZ.toast?.("Call Fehler", error.message || "Call konnte nicht angenommen werden.", "error");
    }
  }

  async function cleanupMediaOnly() {
    stopCallTimer();
    CALL.ending = true; // verhindert endCall-Rekursion über onconnectionstatechange("closed")
    byId("amkCallScreenFinal")?.classList.remove("amk-call-connected", "amk-screen-sharing", "amk-sharing-self", "amk-conference");
    // Bildschirmteilen stoppen
    try { CALL.screen?.track?.stop(); CALL.screen?.stream?.getTracks?.().forEach((t) => t.stop()); } catch (_) {}
    CALL.screen = null;
    byId("amkScreenShareFinal")?.classList.remove("active");

    // ALLE Peer-Verbindungen schließen + deren Audio-Elemente entfernen
    Object.values(CALL.peers).forEach((p) => { try { p.pc.close?.(); } catch (_) {} try { p.audioEl?.remove?.(); } catch (_) {} });
    CALL.peers = {};
    CALL.participants = new Set();
    CALL.iceBuffer = {};

    try { CALL.localStream?.getTracks?.().forEach((track) => track.stop()); } catch (_) {}

    CALL.pc = null;
    CALL.localStream = null;
    CALL.remoteStream = null;
    CALL.activeOtherId = null;

    const localVideo = byId("amkLocalVideoFinal");
    const remoteVideo = byId("amkRemoteVideoFinal");
    if (localVideo) localVideo.srcObject = null;
    if (remoteVideo) remoteVideo.srcObject = null;
    CALL.ending = false;
  }

  async function endCall(sendHangup = true) {
    try { window.AMK_CALL_PARTNER = null; if (AMKZ.remoteControl) AMKZ.remoteControl.end(); } catch (_) {}
    const other = CALL.activeOtherId;
    const allParticipants = [...CALL.participants];
    const wasOutgoingUnanswered = sendHangup && other && !CALL.answered && CALL.isCaller;
    try {
      if (sendHangup && CALL.activeCallId && allParticipants.length) {
        for (const pid of allParticipants) { await sendCallSignal(CALL.activeCallId, pid, "hangup", {}); }
      }
    } catch (_) {}

    // Aufleger vor Annahme -> verpasster Anruf beim Gegenüber protokollieren
    if (wasOutgoingUnanswered) { try { await logMissedCall(other); } catch (_) {} }

    await cleanupMediaOnly();
    try { window.AMK_REMOTE_AUDIO?.pause?.(); } catch (_) {}

    CALL.activeCallId = null;
    CALL.activeOtherId = null;
    CALL.incomingCallId = null;
    CALL.incomingFrom = null;
    CALL.answered = false;
    CALL.isCaller = false;
    CALL.muted = false;
    CALL.cameraOff = false;

    stopRing();
    hideCallUi();

    byId("amkIncomingFinal")?.classList.remove("active");
    removeOldCallUiExceptFinal();
  }

  const AMK_SEEN_KEY = "amk_seen_call_signals";
  function amkLoadSeen() {
    try { return new Set(JSON.parse(localStorage.getItem(AMK_SEEN_KEY) || "[]")); } catch (_) { return new Set(); }
  }
  function amkRememberSeen(id) {
    try {
      const s = amkLoadSeen(); s.add(id);
      localStorage.setItem(AMK_SEEN_KEY, JSON.stringify([...s].slice(-300)));
    } catch (_) {}
  }
  function amkOfferIsFresh(signal) {
    const created = new Date(signal.created_at || callPayload(signal).created_at || 0).getTime();
    return created && (Date.now() - created < 60000);
  }

  async function handleCallSignal(signal) {
    if (!signal?.id) return;
    if (signal.sender_id === AMKZ.state.member?.id) return;
    // Dedupe (auch über Reloads hinweg, da is_read evtl. per RLS nicht schreibbar)
    if (CALL.seenSignals.has(signal.id) || amkLoadSeen().has(signal.id)) {
      markSignalRead(signal.id);
      return;
    }
    CALL.seenSignals.add(signal.id);
    amkRememberSeen(signal.id);

    const data = callPayload(signal);

    // EINLADUNG in eine (laufende) Konferenz -> klingelt wie ein eingehender Anruf
    if (signal.type === "invite") {
      await markSignalRead(signal.id);
      if (!CALL.activeCallId) showIncomingCall(signal); // payload.participants = wen ich anrufe
      return;
    }

    if (signal.type === "offer") {
      if (!CALL.activeCallId) {
        // kein aktiver Call -> eingehender Anruf (oder Altlast)
        await markSignalRead(signal.id);
        if (amkOfferIsFresh(signal)) showIncomingCall(signal);
      } else if (signal.call_id === CALL.activeCallId) {
        // im Raum: Offer eines Teilnehmers (NEU = Konferenz-Beitritt, vorhanden = Re-Negotiation)
        await markSignalRead(signal.id);
        await handleRemoteOffer(signal.sender_id, data.sdp);
      } else {
        await markSignalRead(signal.id);
      }
      return;
    }

    // Abbruch/Auflegen VOR Annahme: betrifft das eingehende Popup (noch kein activeCallId)
    if ((signal.type === "hangup" || signal.type === "cancel") &&
        signal.call_id === CALL.incomingCallId && signal.call_id !== CALL.activeCallId) {
      await markSignalRead(signal.id);
      byId("amkIncomingFinal")?.classList.remove("active");
      stopRing();
      const from = CALL.incomingFrom;
      CALL.incomingCallId = null; CALL.incomingFrom = null;
      try { await amkLogMissedForMe(from); } catch (_) {}
      AMKZ.toast?.("Anruf", "Verpasster Anruf.", "error");
      return;
    }

    // ICE je Teilnehmer (sender_id) puffern/zuordnen
    if (signal.type === "ice") {
      await markSignalRead(signal.id);
      if (signal.call_id === CALL.activeCallId) await handleRemoteIce(signal.sender_id, data);
      return;
    }

    await markSignalRead(signal.id);
    if (signal.call_id !== CALL.activeCallId) return;

    if (signal.type === "answer") {
      CALL.answered = true;
      await handleRemoteAnswer(signal.sender_id, data.sdp);
      showCallUi("Verbunden");
      try { callPlayAllRemote(); } catch (_) {}
      return;
    }

    if (signal.type === "decline") {
      if (callPeerCount() <= 1) { AMKZ.toast?.("Call", "Anruf wurde abgelehnt.", "error"); await endCall(false); }
      else { removePeer(signal.sender_id); AMKZ.toast?.("Konferenz", (amkUserName(signal.sender_id) || "Teilnehmer") + " hat abgelehnt."); }
      return;
    }

    if (signal.type === "hangup") {
      // ein Teilnehmer hat aufgelegt -> nur diesen Peer entfernen
      // (removePeer beendet den Call automatisch, wenn niemand mehr da ist)
      if (CALL.peers[signal.sender_id]) removePeer(signal.sender_id);
      else if (callPeerCount() <= 1) await endCall(false);
    }
  }

  // Verpasster Anruf für mich (Empfänger) – lokale Mitteilung; der Anrufer
  // legt zusätzlich serverseitig Notification+Chat an (logMissedCall).
  async function amkLogMissedForMe(fromId) {
    try { AMKZ.refreshDashboardNotifications?.(); } catch (_) {}
  }

  async function pollCallSignals() {
    if (!AMKZ?.supabase || !AMKZ.state.member?.id) return;

    const cutoff = new Date(Date.now() - 30000).toISOString();

    try {
      await AMKZ.supabase
        .from(RTC_TABLE)
        .update({ is_read: true })
        .eq("receiver_id", AMKZ.state.member.id)
        .eq("is_read", false)
        .lt("created_at", cutoff);
    } catch (_) {}

    const { data, error } = await AMKZ.supabase
      .from(RTC_TABLE)
      .select("*")
      .eq("receiver_id", AMKZ.state.member.id)
      .eq("is_read", false)
      .order("created_at", { ascending: true })
      .limit(50);

    if (error) return;

    for (const signal of data || []) {
      await handleCallSignal(signal);
    }
  }

  function toggleMute() {
    CALL.muted = !CALL.muted;

    CALL.localStream?.getAudioTracks?.().forEach((track) => {
      track.enabled = !CALL.muted;
    });

    const btn = byId("amkMuteFinal");
    if (btn) {
      btn.textContent = CALL.muted ? "🔇" : "🎤";
      btn.classList.toggle("active", CALL.muted);
    }
    AMKZ.toast?.("Mikrofon", CALL.muted ? "Stummgeschaltet" : "Mikrofon an");
  }

  function setCamBtn(on) {
    const btn = byId("amkCameraFinal"); if (!btn) return;
    const ic = btn.querySelector(".amk-cbi"); if (ic) ic.textContent = on ? "📷" : "🚫";
    btn.classList.toggle("active", on);
  }
  function showSelfVideo(stream) {
    const lv = byId("amkLocalVideoFinal");
    if (lv) { lv.srcObject = stream; lv.muted = true; try { lv.play?.().catch(() => {}); } catch (_) {} }
    byId("amkCallScreenFinal")?.classList.add("amk-selfcam");
  }
  function hideSelfVideo() {
    if (CALL.screen) return; // Screenshare nutzt die Selbstvorschau weiter
    const lv = byId("amkLocalVideoFinal"); if (lv) lv.srcObject = null;
    byId("amkCallScreenFinal")?.classList.remove("amk-selfcam");
  }

  // Kamera EIN: Track holen, in den lokalen Stream + an alle Peers (renegotiation)
  async function enableCamera() {
    if (CALL.cameraTrack && CALL.cameraTrack.readyState === "live") { setCamBtn(true); return; }
    let cam;
    try { cam = await navigator.mediaDevices.getUserMedia({ video: { width: { ideal: 1280 }, height: { ideal: 720 }, facingMode: "user" }, audio: false }); }
    catch (e) { AMKZ.toast?.("Kamera", "Kein Kamerazugriff möglich.", "error"); return; }
    const track = cam.getVideoTracks()[0]; if (!track) return;
    CALL.cameraTrack = track; CALL.cameraStream = cam; CALL.cameraOff = false;
    if (!CALL.localStream) { try { await ensureLocalStream(); } catch (_) {} }
    try { CALL.localStream && CALL.localStream.addTrack(track); } catch (_) {}
    CALL.camSenders = CALL.camSenders || {};
    Object.values(CALL.peers).forEach((p) => { if (!CALL.camSenders[p.otherId]) { try { CALL.camSenders[p.otherId] = p.pc.addTrack(track, CALL.localStream); } catch (_) {} } });
    track.addEventListener("ended", () => disableCamera());
    showSelfVideo(cam); setCamBtn(true);
    AMKZ.toast?.("Kamera", "Kamera ist an.");
  }
  function disableCamera() {
    const t = CALL.cameraTrack;
    Object.entries(CALL.camSenders || {}).forEach(([id, sender]) => { const p = CALL.peers[id]; try { if (p && sender) p.pc.removeTrack(sender); } catch (_) {} });
    CALL.camSenders = {};
    try { t && t.stop(); } catch (_) {}
    try { CALL.localStream && t && CALL.localStream.removeTrack(t); } catch (_) {}
    try { CALL.cameraStream && CALL.cameraStream.getTracks().forEach((x) => x.stop()); } catch (_) {}
    CALL.cameraTrack = null; CALL.cameraStream = null; CALL.cameraOff = true;
    setCamBtn(false); hideSelfVideo();
  }
  function toggleCamera() {
    if (!CALL.activeCallId) { AMKZ.toast?.("Kamera", "Nur während eines Anrufs möglich.", "error"); return; }
    if (CALL.cameraTrack && CALL.cameraTrack.readyState === "live") disableCamera(); else enableCamera();
  }

  /* ---------- Bildschirm teilen (an ALLE Teilnehmer) ---------- */
  // Video-Bereich ein-/ausblenden (amk-audio-only = Avatar-Ansicht, ohne = Video sichtbar)
  function revealCallVideo(show) {
    const screen = byId("amkCallScreenFinal");
    if (!screen) return;
    screen.classList.toggle("amk-audio-only", !show);
    screen.classList.toggle("amk-screen-sharing", !!show);
  }
  async function startScreenShare() {
    if (!CALL.activeCallId || !callPeerCount()) { AMKZ.toast?.("Bildschirm teilen", "Nur während eines Anrufs möglich.", "error"); return; }
    if (!navigator.mediaDevices?.getDisplayMedia) {
      AMKZ.toast?.("Bildschirm teilen", "Auf diesem Gerät nicht möglich (z. B. iPhone) — bitte am Computer teilen.", "error");
      return;
    }
    let stream;
    try { stream = await navigator.mediaDevices.getDisplayMedia({ video: { frameRate: 15 }, audio: false }); }
    catch (e) { return; } // vom Nutzer abgebrochen
    const track = stream.getVideoTracks()[0];
    if (!track) return;
    CALL.screen = { stream, track, senders: {} };
    // an ALLE Teilnehmer senden (addTrack -> onnegotiationneeded -> automatisches Re-Offer pro Peer)
    Object.values(CALL.peers).forEach((p) => { try { CALL.screen.senders[p.otherId] = p.pc.addTrack(track, stream); } catch (_) {} });
    track.addEventListener("ended", () => stopScreenShare()); // Stopp über die Browser-Leiste
    const lv = byId("amkLocalVideoFinal");
    if (lv) { lv.srcObject = stream; lv.muted = true; try { lv.play?.(); } catch (_) {} }
    byId("amkScreenShareFinal")?.classList.add("active");
    byId("amkCallScreenFinal")?.classList.add("amk-sharing-self");
    AMKZ.toast?.("Bildschirm teilen", "Dein Bildschirm wird jetzt geteilt.");
  }
  async function stopScreenShare() {
    if (!CALL.screen) return;
    const { stream, track, senders } = CALL.screen;
    CALL.screen = null;
    try { track.stop(); } catch (_) {}
    try { stream.getTracks().forEach((t) => t.stop()); } catch (_) {}
    Object.entries(senders || {}).forEach(([otherId, sender]) => { const p = CALL.peers[otherId]; try { if (p && sender) p.pc.removeTrack(sender); } catch (_) {} });
    const lv = byId("amkLocalVideoFinal"); if (lv) lv.srcObject = null;
    byId("amkScreenShareFinal")?.classList.remove("active");
    byId("amkCallScreenFinal")?.classList.remove("amk-sharing-self");
    if (!hasAnyRemoteVideo()) revealCallVideo(false); // zurück zur Audio-Ansicht
    AMKZ.toast?.("Bildschirm teilen", "Beendet.");
  }
  function toggleScreenShare() {
    if (CALL.screen && CALL.screen.track) stopScreenShare();
    else startScreenShare();
  }

  async function openGroupModal() {
    ensureCallUi();

    // Kontext: im laufenden Call = "hinzufügen", sonst = "Gruppencall starten"
    const inCall = !!CALL.activeCallId;
    const modal = byId("amkGroupModalFinal");
    const h2 = modal?.querySelector("h2");
    if (h2) h2.textContent = inCall ? "Person zum Call hinzufügen" : "Gruppencall starten";
    const startBtn = byId("amkStartGroupFinal");
    if (startBtn) startBtn.textContent = inCall ? "Hinzufügen" : "Gruppencall starten";

    const list = byId("amkGroupListFinal");
    if (!list) return;

    const currentId = AMKZ.state.member?.id;
    // bereits im Call befindliche Personen ausblenden (max. 4 Personen gesamt)
    const users = (AMKZ.state.chatUsers || []).filter((u) => u.id !== currentId && !CALL.participants.has(u.id));

    list.innerHTML = users.length
      ? users.map((u) => `
          <label class="amk-group-user-final">
            <input type="checkbox" value="${u.id}">
            <span>${escapeHtml(u.name || u.email || "Mitarbeiter")}</span>
          </label>
        `).join("")
      : `<div class="amkz-empty">Keine Mitarbeiter gefunden.</div>`;

    byId("amkGroupModalFinal")?.classList.add("active");
  }

  async function startGroupCall() {
    const checked = Array.from(
      document.querySelectorAll("#amkGroupListFinal input:checked")
    ).map((input) => input.value);

    byId("amkGroupModalFinal")?.classList.remove("active");

    if (!checked.length) {
      AMKZ.toast?.("Gruppencall", "Bitte Teilnehmer auswählen.", "error");
      return;
    }

    if (CALL.activeCallId) {
      // Anruf läuft -> ausgewählte Personen dazuholen (Mesh)
      for (const id of checked) { await addPersonToCall(id); }
    } else {
      // neuer Gruppencall: mit dem ersten anrufen, die übrigen sofort einladen
      amkPrimeRemoteAudio();
      await startCall("audio", checked[0]);
      for (const id of checked.slice(1)) { await addPersonToCall(id); }
    }
  }

  function ensureGroupButton() {
    if (byId("amkzGroupCallButton")) return;

    const chatHead =
      document.querySelector(".amkz-chat-active-header") ||
      document.querySelector(".amkz-chat-header") ||
      byId("amkzChatActiveName")?.parentElement;

    if (!chatHead) return;

    const btn = document.createElement("button");
    btn.id = "amkzGroupCallButton";
    btn.type = "button";
    btn.textContent = "👥 Gruppencall";
    btn.style.cssText = `
      border:0;
      border-radius:999px;
      padding:12px 18px;
      font-weight:1000;
      cursor:pointer;
      color:white;
      background:linear-gradient(135deg,#2f80ed,#56ccf2);
      margin-left:10px;
    `;

    chatHead.appendChild(btn);
  }

  function bindCallEvents() {
    if (document.body.dataset.amkCallEventsBound) return;
    document.body.dataset.amkCallEventsBound = "true";

    document.addEventListener("click", unlockAudio, true);
    document.addEventListener("touchstart", unlockAudio, true);

    document.addEventListener("click", async (event) => {
      if (event.target.closest("#amkzAudioCallButton")) {
        event.preventDefault();
        event.stopImmediatePropagation();
        amkPrimeRemoteAudio(); // Audio innerhalb der Geste entsperren
        await startCall("audio");
        return;
      }

      if (event.target.closest("#amkzVideoCallButton")) {
        event.preventDefault();
        event.stopImmediatePropagation();
        amkPrimeRemoteAudio();
        await startCall("video"); // Videoanruf: Kamera direkt an
        return;
      }

      if (event.target.closest("#amkEndCallFinal")) {
        event.preventDefault();
        event.stopImmediatePropagation();
        await endCall(true);
        return;
      }

      if (event.target.closest("#amkMuteFinal")) {
        event.preventDefault();
        toggleMute();
        return;
      }

      if (event.target.closest("#amkCameraFinal")) {
        event.preventDefault();
        event.stopImmediatePropagation();
        toggleCamera();
        return;
      }

      if (event.target.closest("#amkScreenShareFinal")) {
        event.preventDefault();
        event.stopImmediatePropagation();
        toggleScreenShare();
        return;
      }

      // Klick auf den geteilten Bildschirm (großes Empfänger-Bild ODER eigene Sender-Vorschau)
      // -> Vollbild. ESC oder erneuter Klick -> wieder klein.
      const sharedVid = event.target.closest("#amkRemoteVideoFinal, #amkLocalVideoFinal");
      if (sharedVid) {
        event.preventDefault();
        if (document.fullscreenElement) {
          try { (document.exitFullscreen || document.webkitExitFullscreen)?.call(document); } catch (_) {}
        } else {
          const req = sharedVid.requestFullscreen || sharedVid.webkitRequestFullscreen || sharedVid.webkitEnterFullscreen;
          try { const p = req && req.call(sharedVid); if (p && p.catch) p.catch(() => {}); } catch (_) {}
        }
        return;
      }

      if (event.target.closest("#amkFullscreenFinal")) {
        event.preventDefault();
        document.querySelector(".amk-call-card-final")?.requestFullscreen?.();
        return;
      }

      if (event.target.closest("#amkCallAddCtrlFinal")) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openGroupModal();
        return;
      }

      if (event.target.closest("#amkzGroupCallButton")) {
        event.preventDefault();
        openGroupModal();
        return;
      }

      if (event.target.closest("#amkCloseGroupFinal")) {
        event.preventDefault();
        byId("amkGroupModalFinal")?.classList.remove("active");
        return;
      }

      if (event.target.closest("#amkStartGroupFinal")) {
        event.preventDefault();
        await startGroupCall();
        return;
      }

      if (
        event.target.closest("#amkAcceptFinal") ||
        event.target.closest("#amkDeclineFinal")
      ) {
        stopRing();
      }
    }, true);
  }

  function initCallSystem() {
    ensureCallUi();
    bindCallEvents();

    clearInterval(window.AMK_CALL_FINAL_TIMER);
    window.AMK_CALL_FINAL_TIMER = setInterval(() => {
      ensureGroupButton();
      pollCallSignals();
    }, 1000);

    setTimeout(() => {
      ensureGroupButton();
      pollCallSignals();
    }, 800);

    // Realtime: eingehende Signale SOFORT verarbeiten (statt bis zu 1 s warten)
    // -> schnellerer, stabilerer Verbindungsaufbau (ICE trickelt sofort durch).
    try {
      const myId = AMKZ.state.member && AMKZ.state.member.id;
      if (myId && AMKZ.supabase && !window.AMK_RTC_REALTIME) {
        window.AMK_RTC_REALTIME = AMKZ.supabase
          .channel("amk_rtc_live_" + myId)
          .on("postgres_changes", { event: "INSERT", schema: "public", table: RTC_TABLE, filter: "receiver_id=eq." + myId }, (p) => {
            try { handleCallSignal(p.new); } catch (_) {}
          })
          .subscribe();
      }
    } catch (_) {}
  }

  /* =====================================================
     TWITCH ANALYTICS
  ===================================================== */

  const TWITCH_CLIENT_ID = "thuqmkz7l0lfxne6bykevparg6upk2";
  const TWITCH_REDIRECT_URI = "https://nouri-amk.com/pages/zentrale";
  const TWITCH_SCOPES = [
    "user:read:email",
    "moderator:read:followers",
    "moderator:read:chatters",
    "channel:read:subscriptions",
    "user:read:chat",
    "channel:bot",
  ].join(" ");

  function twitchId(x) {
    return document.getElementById(x);
  }

  function twitchNum(v) {
    return Number(v || 0);
  }

  function twitchDay() {
    return new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10) /* Nachtschicht 31.10.: Ortszeit statt UTC */;
  }

  function initTwitchDates() {
    const from = twitchId("amkzTwitchFrom");
    const to = twitchId("amkzTwitchTo");

    if (from && !from.value) {
      const d = new Date();
      d.setDate(d.getDate() - 6);
      from.value = d.toISOString().slice(0, 10);
    }

    if (to && !to.value) {
      to.value = twitchDay();
    }
  }

  function readTwitchToken() {
    const hash = new URLSearchParams(location.hash.replace("#", ""));
    const token = hash.get("access_token");

    if (token) {
      localStorage.setItem("amk_twitch_token", token);
      history.replaceState(null, "", location.pathname + location.search);
    }
  }

  function connectTwitch() {
    const channel =
      twitchId("amkzTwitchChannel")?.value?.trim() ||
      twitchId("amkzTwitchLoginInput")?.value?.trim();

    if (channel) {
      localStorage.setItem("amk_twitch_channel", channel);
      localStorage.setItem("amk_twitch_login", channel);
    }

    location.href =
      "https://id.twitch.tv/oauth2/authorize" +
      "?client_id=" + encodeURIComponent(TWITCH_CLIENT_ID) +
      "&redirect_uri=" + encodeURIComponent(TWITCH_REDIRECT_URI) +
      "&response_type=token" +
      "&scope=" + encodeURIComponent(TWITCH_SCOPES);
  }

  async function twitchHelix(path) {
    const token = localStorage.getItem("amk_twitch_token");
    if (!token) throw new Error("Twitch ist noch nicht verbunden.");

    const res = await fetch("https://api.twitch.tv/helix/" + path, {
      headers: {
        "Client-Id": TWITCH_CLIENT_ID,
        Authorization: "Bearer " + token,
      },
    });

    const json = await res.json().catch(() => ({}));

    if (!res.ok) {
      throw new Error(json.message || `Twitch API Fehler ${res.status}`);
    }

    return json;
  }

  function ensureTwitchSection() {
    // DEAKTIVIERT: Twitch-Sektion existiert bereits im Liquid (amkzTwitchPro).
    // Die früher hier injizierte Zweit-Sektion kollidierte damit -> entfernt.
    document.getElementById("amkzTwitchAnalyticsFinal")?.remove();
    return;
    /* eslint-disable */
    const view = twitchId("amkzAnalyticsView");
    if (!view || twitchId("amkzTwitchAnalyticsFinal")) return;

    view.insertAdjacentHTML("beforeend", `
      <div id="amkzTwitchAnalyticsFinal" class="amkz-card amkz-twitch-grid">
        <div class="amkz-card-header">
          <div>
            <h3>Twitch Live Analytics</h3>
            <small>Stream-Performance, Viewer, Peaks, Verlauf und Sessions</small>
          </div>
          <div class="amkz-twitch-actions">
            <input id="amkzTwitchChannel" placeholder="Twitch-Kanalname">
            <button id="amkzTwitchConnectBtn" class="amkz-primary-btn" type="button">Twitch verbinden</button>
            <button id="amkzTwitchLoadBtn" class="amkz-secondary-btn" type="button">Twitch laden</button>
          </div>
        </div>

        <div class="amkz-form-row">
          <div class="amkz-input-group">
            <label>Von</label>
            <input id="amkzTwitchFrom" type="date">
          </div>
          <div class="amkz-input-group">
            <label>Bis</label>
            <input id="amkzTwitchTo" type="date">
          </div>
          <button id="amkzTwitchRangeBtn" class="amkz-secondary-btn" type="button">Zeitraum laden</button>
        </div>

        <div id="amkzTwitchStatus" class="amkz-twitch-status">
          <span class="amkz-twitch-dot"></span>
          Nicht verbunden
        </div>

        <div class="amkz-twitch-kpis">
          <div class="amkz-twitch-card"><small>Live Zuschauer</small><strong id="twLive">0</strong></div>
          <div class="amkz-twitch-card"><small>Peak</small><strong id="twPeak">0</strong></div>
          <div class="amkz-twitch-card"><small>Durchschnitt</small><strong id="twAvg">0</strong></div>
          <div class="amkz-twitch-card"><small>Follower</small><strong id="twFollowers">0</strong></div>
          <div class="amkz-twitch-card"><small>Follower +</small><strong id="twFollowersGained">0</strong></div>
          <div class="amkz-twitch-card"><small>Follower -</small><strong id="twFollowersLost">0</strong></div>
          <div class="amkz-twitch-card"><small>Messages</small><strong id="twMessages">0</strong></div>
          <div class="amkz-twitch-card"><small>Top Chatter</small><strong id="twTopChatter">—</strong><small id="twTopChatterMeta">0 Messages</small></div>
        </div>

        <div class="amkz-twitch-main">
          <div class="amkz-twitch-chart">
            <canvas id="amkzTwitchChart"></canvas>
          </div>

          <div>
            <h3 style="margin:0 0 12px;color:#0b2f66;">Live Verlauf</h3>
            <div id="amkzTwitchTimeline" class="amkz-twitch-scroll">
              <div class="amkz-empty">Noch keine Twitch Daten geladen.</div>
            </div>
          </div>
        </div>

        <div class="amkz-card" style="margin:0;">
          <div class="amkz-card-header">
            <h3>Chat Aktivität</h3>
          </div>
          <div id="amkzTwitchChatters" class="amkz-twitch-scroll">
            <div class="amkz-empty">Noch keine Chatdaten gespeichert.</div>
          </div>
        </div>
      </div>
    `);

    initTwitchDates();

    const saved = localStorage.getItem("amk_twitch_channel") || localStorage.getItem("amk_twitch_login");
    if (saved && twitchId("amkzTwitchChannel")) twitchId("amkzTwitchChannel").value = saved;
  }

  const TWITCH_SNAP_TABLES = ["twitch_snapshots", "amk_twitch_snapshots"];

  async function saveTwitchSnapshot(row) {
    if (!AMKZ?.supabase) return;
    for (const t of TWITCH_SNAP_TABLES) {
      try {
        const { error } = await AMKZ.supabase.from(t).insert(row);
        if (!error) return;
      } catch (_) {}
    }
  }

  async function loadTwitchSnapshots(userId, from, to) {
    if (!AMKZ?.supabase) return [];
    for (const t of TWITCH_SNAP_TABLES) {
      try {
        const { data, error } = await AMKZ.supabase
          .from(t).select("*")
          .eq("twitch_user_id", userId)
          .gte("snapshot_date", from)
          .lte("snapshot_date", to)
          .order("created_at", { ascending: true });
        if (!error && Array.isArray(data)) return data;
      } catch (_) {}
    }
    return [];
  }

  async function loadTwitchChatRows(channel, from, to) {
    if (!AMKZ?.supabase) return [];

    const { data } = await AMKZ.supabase
      .from("amk_twitch_chat_events")
      .select("*")
      .eq("channel_login", channel.toLowerCase())
      .gte("message_date", from)
      .lte("message_date", to)
      .order("created_at", { ascending: true });

    return data || [];
  }

  async function loadTwitchPro() {
    ensureTwitchSection();
    initTwitchDates();

    const channel =
      twitchId("amkzTwitchChannel")?.value?.trim() ||
      twitchId("amkzTwitchLoginInput")?.value?.trim() ||
      localStorage.getItem("amk_twitch_channel") ||
      localStorage.getItem("amk_twitch_login") ||
      "Nouri_AMK";

    localStorage.setItem("amk_twitch_channel", channel);
    localStorage.setItem("amk_twitch_login", channel);

    const from = twitchId("amkzTwitchFrom")?.value || twitchDay();
    const to = twitchId("amkzTwitchTo")?.value || twitchDay();

    try {
      const userRes = await twitchHelix("users?login=" + encodeURIComponent(channel));
      const user = userRes.data?.[0];

      if (!user) throw new Error("Twitch Kanal nicht gefunden.");

      const [streamRes, followerRes] = await Promise.all([
        twitchHelix("streams?user_id=" + encodeURIComponent(user.id)),
        twitchHelix("channels/followers?broadcaster_id=" + encodeURIComponent(user.id)),
      ]);

      const stream = streamRes.data?.[0] || null;
      const followers = twitchNum(followerRes.total);
      const viewers = stream ? twitchNum(stream.viewer_count) : 0;

      await saveTwitchSnapshot({
        twitch_user_id: user.id,
        channel_login: channel.toLowerCase(),
        channel_name: user.display_name || channel,
        snapshot_date: twitchDay(),
        live: !!stream,
        viewer_count: viewers,
        follower_count: followers,
        stream_id: stream?.id || null,
        stream_title: stream?.title || "",
        game_name: stream?.game_name || "",
        started_at: stream?.started_at || null,
        created_at: new Date().toISOString(),
      });

      const [snapshots, chats] = await Promise.all([
        loadTwitchSnapshots(user.id, from, to),
        loadTwitchChatRows(channel, from, to),
      ]);

      renderTwitchPro({ user, stream, snapshots, chats, followers, viewers });
    } catch (error) {
      console.error("TWITCH PRO ERROR", error);

      const box = twitchId("amkzTwitchTimeline");
      if (box) {
        box.innerHTML = `<div class="amkz-empty">Fehler: ${escapeHtml(error.message)}</div>`;
      }

      AMKZ.toast?.("Twitch Fehler", error.message, "error");
    }
  }

  function renderTwitchPro(ctx) {
    const snapshots = ctx.snapshots || [];
    const chats = ctx.chats || [];

    const viewerList = snapshots.map((s) => twitchNum(s.viewer_count));
    const followerList = snapshots.map((s) => twitchNum(s.follower_count));

    const firstFollowers = followerList.length ? followerList[0] : ctx.followers;
    const lastFollowers = followerList.length ? followerList.at(-1) : ctx.followers;

    const peak = Math.max(0, ...viewerList, ctx.viewers);
    const avg = viewerList.length
      ? Math.round(viewerList.reduce((a, b) => a + b, 0) / viewerList.length)
      : ctx.viewers;

    const chatterMap = new Map();

    chats.forEach((m) => {
      const name = m.chatter_name || m.chatter_login || "Unbekannt";
      chatterMap.set(name, (chatterMap.get(name) || 0) + 1);
    });

    const chatters = [...chatterMap.entries()]
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);

    const top = chatters[0];

    const streamIds = new Set(snapshots.map((s) => s.stream_id).filter(Boolean));
    const streamsCount = streamIds.size || (ctx.stream ? 1 : 0);
    let watch = "0h";
    if (ctx.stream && ctx.stream.started_at) {
      const h = (Date.now() - new Date(ctx.stream.started_at).getTime()) / 3600000;
      watch = (h > 0 ? h : 0).toFixed(1) + "h";
    }
    const lastCheck = new Date().toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });

    // LIQUID-IDs (Twitch Command Center) – das war der "0"-Bug
    setText(twitchId("twLiveStatus"), ctx.stream ? "Live" : "Offline");
    setText(twitchId("twCurrentViewers"), ctx.viewers);
    setText(twitchId("twPeakViewers"), peak);
    setText(twitchId("twAvgViewers"), avg);
    setText(twitchId("twFollowersGained"), Math.max(0, lastFollowers - firstFollowers));
    setText(twitchId("twStreamsCount"), streamsCount);
    setText(twitchId("twWatchtime"), watch);
    setText(twitchId("twLastCheck"), lastCheck);

    // alte IDs (falls noch vorhanden) zusätzlich befüllen
    setText(twitchId("twLive"), ctx.viewers);
    setText(twitchId("twPeak"), peak);
    setText(twitchId("twAvg"), avg);
    setText(twitchId("twFollowers"), ctx.followers);
    setText(twitchId("twMessages"), chats.length);
    setText(twitchId("twTopChatter"), top?.name || "—");
    setText(twitchId("twTopChatterMeta"), `${top?.count || 0} Messages`);

    const status = twitchId("amkzTwitchStatus");

    if (status) {
      status.classList.toggle("live", !!ctx.stream);
      status.innerHTML = `
        <span class="amkz-twitch-dot"></span>
        ${ctx.stream ? "LIVE · " + escapeHtml(ctx.stream.title || ctx.user.display_name) : "Offline"}
      `;
    }

    const timeline = twitchId("amkzTwitchTimeline");

    if (timeline) {
      timeline.innerHTML = snapshots.length
        ? snapshots.slice().reverse().map((s) => `
          <div class="amkz-twitch-row">
            <strong>${new Date(s.created_at).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(", ", " ")} · ${twitchNum(s.viewer_count)} Viewer</strong>
            <small>${s.live ? "LIVE" : "Offline"} ${s.game_name ? "· " + escapeHtml(s.game_name) : ""}</small>
            ${s.stream_title ? `<small>${escapeHtml(s.stream_title)}</small>` : ""}
            <small>Follower: ${twitchNum(s.follower_count)}</small>
          </div>
        `).join("")
        : `<div class="amkz-empty">Noch keine Snapshots im Zeitraum.</div>`;
    }

    const chatBox = twitchId("amkzTwitchChatters");

    if (chatBox) {
      chatBox.innerHTML = chatters.length
        ? chatters.slice(0, 20).map((c, i) => `
          <div class="amkz-twitch-chatter-row">
            <strong>#${i + 1} · ${escapeHtml(c.name)}</strong>
            <small>${c.count} Nachrichten</small>
          </div>
        `).join("")
        : `<div class="amkz-empty">Noch keine Chatdaten gespeichert. Dafür brauchst du EventSub/Bot-Speicherung.</div>`;
    }

    drawTwitchChart(snapshots);
  }

  function drawTwitchChart(rows) {
    const canvas = twitchId("amkzTwitchChart");
    if (!canvas || !window.Chart) return;

    window.AMKZ_TWITCH_PRO_CHART?.destroy?.();

    window.AMKZ_TWITCH_PRO_CHART = new Chart(canvas, {
      type: "line",
      data: {
        labels: rows.map((r) =>
          new Date(r.created_at).toLocaleTimeString("de-DE", {
            hour: "2-digit",
            minute: "2-digit",
          })
        ),
        datasets: [
          {
            label: "Viewer",
            data: rows.map((r) => twitchNum(r.viewer_count)),
            borderWidth: 3,
            tension: 0.35,
            fill: true,
            borderColor: "#f7df97",
            backgroundColor: "rgba(230,184,92,.12)",
            pointBackgroundColor: "#f7df97",
            pointBorderColor: "rgba(230,184,92,.4)",
            pointRadius: 2,
          },
          {
            label: "Follower",
            data: rows.map((r) => twitchNum(r.follower_count)),
            borderWidth: 2,
            tension: 0.35,
            yAxisID: "y1",
            borderColor: "#a78bfa",
            backgroundColor: "rgba(167,139,250,.12)",
            pointBackgroundColor: "#a78bfa",
            pointRadius: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: {
          legend: { display: true },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: { precision: 0 },
          },
          y1: {
            position: "right",
            beginAtZero: false,
            grid: { drawOnChartArea: false },
          },
        },
      },
    });
  }

  function bindTwitchEvents() {
    if (document.body.dataset.amkTwitchBound) return;
    document.body.dataset.amkTwitchBound = "true";

    readTwitchToken();
    initTwitchDates();

    document.addEventListener("click", (event) => {
      if (event.target.closest("#amkzTwitchConnectBtn")) {
        connectTwitch();
      }

      if (
        event.target.closest("#amkzTwitchLoadBtn") ||
        event.target.closest("#amkzTwitchRangeBtn") ||
        event.target.closest("#amkzTwitchRefreshBtn")
      ) {
        loadTwitchPro();
      }
    }, true);

    clearInterval(window.AMKZ_TWITCH_PRO_TIMER);
    window.AMKZ_TWITCH_PRO_TIMER = setInterval(() => {
      if (
        AMKZ?.state?.currentView === "analytics" &&
        localStorage.getItem("amk_twitch_token")
      ) {
        loadTwitchPro();
      }
    }, 60000);
  }

  /* =====================================================
     FINAL VIEW EXTENSION
  ===================================================== */

  const previousLoadView = AMKZ.loadView;

  AMKZ.loadView = async function loadViewPart4(view, options = {}) {
    if (typeof previousLoadView === "function") {
      await previousLoadView(view, options);
    }

    initMobileAppMode();
    ensureCallUi();
    ensureGroupButton();

    if (view === "analytics") {
      ensureTwitchSection();

      const saved =
        localStorage.getItem("amk_twitch_channel") ||
        localStorage.getItem("amk_twitch_login");

      if (saved && twitchId("amkzTwitchChannel")) {
        twitchId("amkzTwitchChannel").value = saved;
      }

      if (localStorage.getItem("amk_twitch_token")) {
        loadTwitchPro();
      }
    }
  };

  /* =====================================================
     BOOT
  ===================================================== */

  function bootPart4() {
    registerServiceWorker();
    initMobileAppMode();
    initCallSystem();
    bindTwitchEvents();

    document.addEventListener(
      "click",
      function (event) {
        const btn = event.target.closest("#amkzEnablePushButton");
        if (!btn) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        enableAMKPush();
      },
      true
    );

    setTimeout(initMobileAppMode, 500);
    setTimeout(initMobileAppMode, 1500);
    setTimeout(ensureCallUi, 800);
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", bootPart4)
    : bootPart4();

  /* =====================================================
     PUBLIC API
  ===================================================== */

  AMKZ.modules = AMKZ.modules || {};

  AMKZ.modules.push = {
    registerServiceWorker,
    enableAMKPush,
  };

  AMKZ.modules.call = {
    startCall,
    endCall,
    openGroupModal,
    pollCallSignals,
  };

  AMKZ.modules.twitch = {
    connectTwitch,
    loadTwitchPro,
    ensureTwitchSection,
  };

  window.AMK_CALL_FINAL_V2 = {
    startCall,
    endCall,
    openGroupModal,
  };

  window.AMK_OPEN_FLOATING_CALL = {
    startCall,
    endCall,
  };

  window.AMKZ_PUSH_DEBUG = enableAMKPush;
  window.AMK_STOP_RING = stopRing;
  window.AMK_FORCE_RING = startRing;
})();
/* =====================================================
   AMK ZENTRALE — KONSOLIDIERTE ZUSATZMODULE
   (sauber neu geschrieben — ersetzt die früheren
    konfligierenden V3–V10 Patch-Schichten)

   1) Finance "Eingänge" Tab  (amk_finance_inflows)
   2) Finance-Tab-Umschaltung inkl. Eingänge-Panel
   3) ICS Kalender-Export (.ics Download je Termin)
===================================================== */
(function () {
  "use strict";

  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__inflowsModule) return;
  AMKZ.__inflowsModule = true;

  const U = AMKZ.utils || {};
  const byId = U.byId || ((id) => document.getElementById(id));
  const setHTML = U.setHTML || ((el, v) => { if (el) el.innerHTML = v ?? ""; });
  const escapeHtml = U.escapeHtml || ((v) => String(v ?? ""));
  const money = U.money || ((n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n || 0)));
  const safeNumber = U.safeNumber || ((n) => { const x = Number(n || 0); return Number.isFinite(x) ? x : 0; });
  const value = U.value || ((id) => byId(id)?.value || "");
  const today = U.today || (() => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10) /* Nachtschicht 31.10.: Ortszeit statt UTC */);

  const optionList = AMKZ.shared?.optionList || ((rows, ph) =>
    `<option value="">${escapeHtml(ph || "Auswählen")}</option>` +
    (rows || []).map((r) => `<option value="${escapeHtml(r.id)}">${escapeHtml(r.name || r.title || r.id)}</option>`).join(""));
  const getPartnerName = AMKZ.shared?.getPartnerName || (() => "");
  const getCasinoName = AMKZ.shared?.getCasinoName || (() => "");
  const memberId = () => AMKZ.state?.member?.id || null;
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);

  /* ---------- INFLOWS DATA ---------- */

  async function loadPaidInvoicesAsInflows() {
    for (const t of ["amk_finance_documents", "finance_documents"]) {
      try {
        const { data, error } = await AMKZ.supabase.from(t).select("*").eq("document_type", "invoice").limit(1000);
        if (!error && Array.isArray(data)) {
          return data
            .filter((d) => ["paid", "bezahlt", "received", "completed"].includes(String(d.status || "").toLowerCase()))
            .map((d) => ({
              id: "inv_" + d.id,
              movement_date: (d.document_date || "").slice(0, 10),
              partner_group_id: d.partner_group_id,
              casino_id: d.casino_id,
              stake_amount: 0,
              payout_amount: safeNumber(d.amount),
              profit_amount: safeNumber(d.amount),
              status: "paid",
              note: "Bezahlte Rechnung: " + (d.title || ""),
              source: "invoice",
            }));
        }
      } catch (_) {}
    }
    return [];
  }

  async function loadFinanceInflows() {
    let base = [];
    for (const tbl of ["finance_inflows", "amk_finance_inflows"]) {
      try {
        const { data, error } = await AMKZ.supabase
          .from(tbl)
          .select("*")
          .order("movement_date", { ascending: false })
          .limit(500);
        if (!error && Array.isArray(data)) { base = data; break; }
      } catch (_) {}
    }

    if (!base.length) {
      // Fallback: INCOME-Entries als Eingänge interpretieren
      const incomeEntries = (AMKZ.state.entries || []).filter(
        (e) => String(e.entry_type || "").toUpperCase() === "INCOME"
      );
      base = incomeEntries.map((e) => ({
        id: e.id,
        movement_date: e.entry_date,
        partner_group_id: e.partner_group_id,
        casino_id: e.casino_id,
        stake_amount: safeNumber(e.metadata?.stake_amount || 0),
        payout_amount: safeNumber(e.metadata?.payout_amount || e.amount || 0),
        profit_amount: safeNumber(e.metadata?.profit_amount || e.amount || 0),
        status: e.payment_status || "paid",
        note: e.note || "",
        source: "entries",
      }));
    }

    // Bezahlte Rechnungen erscheinen ebenfalls als Eingänge
    const paid = await loadPaidInvoicesAsInflows();
    return [...paid, ...base].sort((a, b) => String(b.movement_date || "").localeCompare(String(a.movement_date || "")));
  }

  async function saveFinanceInflow(payload) {
    const profit = safeNumber(payload.payoutAmount) - safeNumber(payload.stakeAmount);
    const row = {
      movement_date: payload.date || today(),
      partner_group_id: payload.partnerGroupId || null,
      casino_id: payload.casinoId || null,
      stake_amount: safeNumber(payload.stakeAmount),
      payout_amount: safeNumber(payload.payoutAmount),
      profit_amount: profit,
      status: payload.status || "paid",
      note: payload.note || "",
      created_by: memberId(),
      created_at: new Date().toISOString(),
    };

    for (const tbl of ["finance_inflows", "amk_finance_inflows"]) {
      try {
        const { data, error } = await AMKZ.supabase.from(tbl).insert(row).select("*").single();
        if (!error) return data;
      } catch (_) {}
    }
    {
      // Fallback: als INCOME-Entry speichern, damit nichts verloren geht
      return AMKZ.save.saveEntry({
        entryDate: row.movement_date,
        entryType: "INCOME",
        partnerGroupId: row.partner_group_id,
        casinoId: row.casino_id,
        amount: row.profit_amount,
        paymentStatus: row.status,
        note: row.note || `Casino Eingang: Einsatz ${money(row.stake_amount)} · Auszahlung ${money(row.payout_amount)}`,
      });
    }
  }

  function renderInflowsTable(inflows) {
    setHTML(
      byId("amkzInflowsTableBody"),
      inflows.length
        ? inflows.map((row) => `
          <tr>
            <td>${escapeHtml(row.movement_date || "—")}</td>
            <td>${escapeHtml(getPartnerName(row.partner_group_id) || "—")}</td>
            <td>${escapeHtml(getCasinoName(row.casino_id) || "—")}</td>
            <td>${money(row.stake_amount || 0)}</td>
            <td>${money(row.payout_amount || 0)}</td>
            <td class="amkz-finance-positive">${money(row.profit_amount || 0)}</td>
            <td><span class="amkz-status-pill">${escapeHtml(row.status || "paid")}</span></td>
          </tr>
        `).join("")
        : `<tr><td colspan="7"><div class="amkz-empty">Keine Eingänge vorhanden.</div></td></tr>`
    );
  }

  async function openInflowModal() {
    await AMKZ.data.loadBaseData?.(true);

    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header">
          <div>
            <h3>Eingang / Gewinn erfassen</h3>
            <p>Beispiel: Einsatz 20.000 €, Auszahlung 50.000 € → Gewinn 30.000 €.</p>
          </div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button>
        </div>

        <form id="amkzInflowForm" class="amkz-form-grid">
          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Datum</label>
              <input id="amkzInflowDate" type="date" value="${today()}" required>
            </div>
            <div class="amkz-input-group">
              <label>Status</label>
              <select id="amkzInflowStatus">
                <option value="paid">Bezahlt</option>
                <option value="open">Offen</option>
                <option value="pending">Pending</option>
              </select>
            </div>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Partner</label>
              <select id="amkzInflowPartner">${optionList(AMKZ.state.partners, "Kein Partner")}</select>
            </div>
            <div class="amkz-input-group">
              <label>Casino</label>
              <select id="amkzInflowCasino">${optionList(AMKZ.state.casinos, "Kein Casino", true)}</select>
            </div>
          </div>

          <div class="amkz-form-row">
            <div class="amkz-input-group">
              <label>Einsatz</label>
              <input id="amkzInflowStake" type="number" step="0.01" value="0">
            </div>
            <div class="amkz-input-group">
              <label>Auszahlung</label>
              <input id="amkzInflowPayout" type="number" step="0.01" value="0">
            </div>
          </div>

          <div class="amkz-input-group">
            <label>Notiz</label>
            <textarea id="amkzInflowNote" placeholder="z. B. Casino Ergebnis / Trip"></textarea>
          </div>

          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>
    `);

    byId("amkzInflowForm")?.addEventListener("submit", async (event) => {
      event.preventDefault();
      try {
        await saveFinanceInflow({
          date: value("amkzInflowDate"),
          status: value("amkzInflowStatus"),
          partnerGroupId: value("amkzInflowPartner"),
          casinoId: value("amkzInflowCasino"),
          stakeAmount: value("amkzInflowStake"),
          payoutAmount: value("amkzInflowPayout"),
          note: value("amkzInflowNote"),
        });
        AMKZ.modal.close();
        toast("Gespeichert", "Eingang wurde erfasst.");
        await loadInflowsView();
      } catch (error) {
        console.error(error);
        toast("Fehler", error.message, "error");
      }
    });
  }

  async function loadInflowsView() {
    const inflows = await loadFinanceInflows();
    AMKZ.state.inflows = inflows;
    renderInflowsTable(inflows);
  }

  /* ---------- FINANCE TAB inkl. Eingänge ---------- */

  const FINANCE_PANELS = ["overview", "inflows", "expenses", "invoices", "contracts"];

  function switchFinanceTab(tab) {
    document.querySelectorAll(".amkz-finance-tab").forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.financeTab === tab);
    });
    FINANCE_PANELS.forEach((name) => {
      const panel = byId(`amkzFinance${name.charAt(0).toUpperCase() + name.slice(1)}Panel`);
      if (panel) panel.classList.toggle("is-hidden", name !== tab);
    });
    if (tab === "inflows") loadInflowsView();
  }

  function bindFinanceTabs() {
    document.querySelectorAll(".amkz-finance-tab").forEach((btn) => {
      btn.onclick = () => switchFinanceTab(btn.dataset.financeTab || "overview");
    });
    const createInflow = byId("amkzCreateInflowButton");
    if (createInflow) createInflow.onclick = openInflowModal;
  }

  /* ---------- ICS KALENDER-EXPORT ---------- */

  function pad(n) { return String(n).padStart(2, "0"); }

  function icsStamp(value) {
    const d = value ? new Date(value) : new Date();
    return (
      d.getUTCFullYear() +
      pad(d.getUTCMonth() + 1) +
      pad(d.getUTCDate()) + "T" +
      pad(d.getUTCHours()) +
      pad(d.getUTCMinutes()) +
      pad(d.getUTCSeconds()) + "Z"
    );
  }

  function icsEscape(v) {
    return String(v || "").replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");
  }

  function buildIcs(event) {
    const start = event.starts_at || `${event.event_date}T10:00:00`;
    const end = event.ends_at || `${event.event_date}T11:00:00`;
    return [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//AMK Zentrale//DE",
      "CALSCALE:GREGORIAN",
      "BEGIN:VEVENT",
      `UID:amk-${event.id || Date.now()}@amk-zentrale`,
      `DTSTAMP:${icsStamp()}`,
      `DTSTART:${icsStamp(start)}`,
      `DTEND:${icsStamp(end)}`,
      `SUMMARY:${icsEscape(event.title || "AMK Termin")}`,
      `DESCRIPTION:${icsEscape(event.description || "")}`,
      "END:VEVENT",
      "END:VCALENDAR",
    ].join("\r\n");
  }

  function downloadIcs(event) {
    const blob = new Blob([buildIcs(event)], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${(event.title || "termin").replace(/[^\w.\-]/g, "_")}.ics`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1500);
  }

  AMKZ.calendarIcs = { build: buildIcs, download: downloadIcs };

  function findEventByCard(card) {
    const title = card.querySelector("strong")?.textContent?.trim();
    if (!title) return null;
    const dayKey = AMKZ.state.calendarSelectedDate;
    return (AMKZ.state.calendarEvents || []).find((e) => {
      const k = String(e.event_date || e.starts_at || "").slice(0, 10);
      return (e.title || "Termin") === title && (!dayKey || k === dayKey);
    }) || null;
  }

  function bindIcs() {
    if (document.body.dataset.amkzIcsBound) return;
    document.body.dataset.amkzIcsBound = "true";

    // Klick auf Termin-Karte -> .ics herunterladen
    document.addEventListener("click", (event) => {
      const list = event.target.closest("#amkzCalendarEventList");
      const card = event.target.closest(".amkz-table-row-card");
      if (!list || !card) return;
      const ev = findEventByCard(card);
      if (ev) downloadIcs(ev);
    });

    // Install-Prompt Buttons (Overlay aus dem Liquid)
    byId("amkCalendarInstallClose")?.addEventListener("click", () => {
      byId("amkCalendarInstallPrompt")?.classList.add("is-hidden");
    });
    byId("amkCalendarInstallButton")?.addEventListener("click", () => {
      const ev = AMKZ.state.__lastCalendarEvent;
      if (ev) downloadIcs(ev);
      byId("amkCalendarInstallPrompt")?.classList.add("is-hidden");
    });
  }

  /* ---------- VIEW CHAIN ---------- */

  const prevLoadView = AMKZ.loadView;
  AMKZ.loadView = async function consolidatedLoadView(view, options) {
    const result = await prevLoadView?.call(this, view, options);
    if (view === "finance") {
      bindFinanceTabs();
      setTimeout(loadInflowsView, 200);
    }
    if (view === "calendar") bindIcs();
    return result;
  };

  setTimeout(bindIcs, 1500);

  AMKZ.modules = AMKZ.modules || {};
  AMKZ.modules.inflows = { loadInflowsView, openInflowModal, saveFinanceInflow, switchFinanceTab };
})();
/* =====================================================
   AMK ZENTRALE — V11 FINAL PATCH
   Direct SQL view calculation from v_amk_entry_profit_clean
   No dependency on dropped/cascaded summary RPCs
===================================================== */
(function(){
  'use strict';
  const W = window;
  const AMKZ = W.AMKZ;
  if (!AMKZ || AMKZ.__v11FinalPatch) return;
  AMKZ.__v11FinalPatch = true;

  const U = AMKZ.utils || {};
  const byId = U.byId || ((id)=>document.getElementById(id));
  const setText = U.setText || ((el,v)=>{ if(el) el.textContent = v ?? ''; });
  const setHTML = U.setHTML || ((el,v)=>{ if(el) el.innerHTML = v ?? ''; });
  const escapeHtml = U.escapeHtml || ((v)=>String(v ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c])));
  const money = U.money || ((n)=>new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(Number(n||0)));
  const safeNumber = U.safeNumber || ((n)=>{ const x=Number(n||0); return Number.isFinite(x)?x:0; });
  const value = U.value || ((id)=>byId(id)?.value || '');
  const today = U.today || (()=>new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10) /* Nachtschicht 31.10.: Ortszeit statt UTC */);

  function selectedDate(){ return value('amkzGlobalDate') || AMKZ.state?.selectedDate || today(); }
  function canSeeProfit(){ return AMKZ.state?.permissions?.seeProfit === true; }

  async function ensureBase(){
    try { if (AMKZ.data?.loadBaseData) await AMKZ.data.loadBaseData(false); } catch(e) { console.warn('V11 base load failed', e); }
  }

  async function tableRows(table, queryBuilder, fallback = []){
    try {
      const q = AMKZ.supabase.from(table);
      const { data, error } = await queryBuilder(q);
      if (error) throw error;
      return data || fallback;
    } catch(e) {
      console.warn('V11 table failed:', table, e);
      return fallback;
    }
  }

  async function rpcRows(name, params, fallback = []){
    try {
      const { data, error } = await AMKZ.supabase.rpc(name, params || {});
      if (error) throw error;
      return data || fallback;
    } catch(e) {
      console.warn('V11 RPC failed:', name, e);
      return fallback;
    }
  }

  // --- Zeitraum-Overlap-Helfer für FIX-Deals (tagesanteilige Verteilung) ---
  function ymdToDateLocal(x){ const p = String(x||'').slice(0,10).split('-').map(Number); return (p.length===3 && p[0]) ? new Date(p[0], p[1]-1, p[2]) : null; }
  function daysInclusive(from, to){ const a = ymdToDateLocal(from), b = ymdToDateLocal(to); if(!a||!b) return 0; const d = Math.round((b-a)/86400000)+1; return d>0 ? d : 0; }
  function overlapDaysLocal(aFrom, aTo, bFrom, bTo){ if(!aFrom||!aTo||!bFrom||!bTo) return 0; const from = aFrom>bFrom?aFrom:bFrom; const to = aTo<bTo?aTo:bTo; return from<=to ? daysInclusive(from,to) : 0; }

  function summarizeProfitRows(rows, range){
    const s = { ftdCount:0, redepoCount:0, ftdAmount:0, redepoAmount:0, expectedIncome:0, expectedCost:0, expectedProfit:0 };
    // Hybrid & Fix werden vom CASINO/DEAL gesteuert (kein Deal-Eintrag pro Zeile nötig).
    const casinoById = {};
    (AMKZ.state.casinos || []).forEach((c)=> { casinoById[c.id] = c; });
    const dealTypeOf = (cid)=> String((casinoById[cid]||{}).deal_type || '').toLowerCase();
    const isHybridCasino = (cid)=> dealTypeOf(cid) === 'hybrid';
    const isFixedCasino  = (cid)=> dealTypeOf(cid) === 'fixed';

    const hyb = {}; // casino_id -> { ftd:[Zeilen], cost }
    (rows || []).forEach((row)=>{
      const type = String(row.entry_type || '').toUpperCase();
      s.ftdCount += type === 'FTD' ? 1 : 0;
      s.redepoCount += type === 'REDEPO' ? 1 : 0;
      s.ftdAmount += type === 'FTD' ? safeNumber(row.entry_amount) : 0;
      s.redepoAmount += type === 'REDEPO' ? safeNumber(row.entry_amount) : 0;

      if (isHybridCasino(row.casino_id)) {
        const g = hyb[row.casino_id] || (hyb[row.casino_id] = { ftd: [], cost: 0 });
        g.cost += safeNumber(row.expected_cost) || safeNumber(row.entry_amount);
        if (type === 'FTD') g.ftd.push(row);
        return; // unten kumulativ berechnet
      }

      // FIX-Deal: Einzelzeilen tragen NICHTS bei -> der Fixbetrag wird unten
      // tagesanteilig über den Deal-Zeitraum verrechnet (ersetzt die FTD-Rechnung).
      if (isFixedCasino(row.casino_id)) return;

      s.expectedIncome += safeNumber(row.expected_income);
      s.expectedCost += safeNumber(row.expected_cost);
      s.expectedProfit += safeNumber(row.expected_profit);
    });

    // Hybrid kumulativ: erste N FTDs teilen sich die Pauschale (Betrag/N je FTD), sonst CPA.
    // Baseline = Mindest-Einzahlung pro FTD: unter der Schwelle -> kein CPA (nicht qualifiziert).
    Object.keys(hyb).forEach((cid)=>{
      const c = casinoById[cid] || {};
      const baseAmount = safeNumber(c.baseline_amount);
      const baseFtds = Math.round(safeNumber(c.baseline_ftds));
      const cpa = safeNumber(c.cpa_amount);
      const minDep = safeNumber(c.cpa_min_deposit);
      const g = hyb[cid];
      g.ftd.sort((a,b)=> String(a.entry_date || '').localeCompare(String(b.entry_date || '')));
      let income = 0;
      g.ftd.forEach((r, i)=>{
        const pos = i + 1; // FTD-Nummer (kumulativ im geladenen Zeitraum)
        if (baseFtds > 0 && pos <= baseFtds) { income += baseAmount / baseFtds; return; }
        if (minDep > 0 && safeNumber(r.entry_amount) < minDep) return; // unter Mindest-Einzahlung -> kein CPA
        income += cpa;
      });
      s.expectedIncome += income;
      s.expectedCost += g.cost;
      s.expectedProfit += income - g.cost;
    });

    // FIX-Deals: NUR zeitlich BEGRENZTE Fix-Deals (Start UND Ende) mit Betrag zählen als Einnahme,
    // tagesanteilig über den Zeitraum. Offene Dauer-Deals (kein Ende) werden NICHT automatisch
    // eingerechnet (die laufen i.d.R. über monatliche Rechnungen -> sonst Doppelzählung).
    // Pro Casino zählt nur EIN Fix-Deal (Schutz gegen Duplikate). Beispiel Freshbet 100.000 € · 01.–31.08.
    const r = range || financeRange();
    if (r && r.from && r.to) {
      const seenFixed = {};
      (AMKZ.state.deals || []).forEach((deal)=>{
        if (String(deal.deal_type || '').toLowerCase() !== 'fixed') return;
        const fee = safeNumber(deal.fixed_fee);
        if (!fee || !deal.start_date || !deal.end_date) return; // nur begrenzte Fix-Deals mit Betrag
        /* Der Duplikatschutz ging vorher nur über das Casino. Damit zählte
           pro Casino genau EIN Fix-Deal — und weil die Liste nach Anlagedatum
           absteigend kommt, war das der neueste. Wer wie hier üblich JE MONAT
           einen befristeten Fix-Deal anlegt (01.–31.08., dann 01.–30.09.),
           verlor damit alle älteren aus der Rechnung.
           Der Schlüssel enthält jetzt den Zeitraum: echte Doppelanlagen
           (gleiches Casino, gleicher Zeitraum) fliegen weiter raus,
           aufeinanderfolgende Monate zählen beide. Doppelt zählen können sie
           nicht — unten wird ohnehin nur der überlappende Anteil verrechnet. */
        const key = [deal.casino_id || deal.id || deal.title || "?",
                     String(deal.start_date).slice(0, 10),
                     String(deal.end_date).slice(0, 10)].join("|");
        if (seenFixed[key]) return; seenFixed[key] = true;
        const dFrom = String(deal.start_date).slice(0,10), dTo = String(deal.end_date).slice(0,10);
        const period = daysInclusive(dFrom, dTo); if (period <= 0) return;
        const ov = overlapDaysLocal(String(r.from).slice(0,10), String(r.to).slice(0,10), dFrom, dTo);
        if (ov <= 0) return;
        const inc = fee * ov / period;
        s.expectedIncome += inc;
        s.expectedProfit += inc;
      });
    }

    return s;
  }

  // Zeitraum (von..bis) aus dem State – damit V11 (Dashboard/Tagesanalyse) den Zeitraum respektiert
  function v11Range(){
    let f = AMKZ.state && AMKZ.state.rangeFrom, t = AMKZ.state && AMKZ.state.rangeTo;
    if (!f || !t) return null;
    if (f > t) { const x = f; f = t; t = x; }
    return { from: f, to: t };
  }

  // LOKALES YYYY-MM-DD (NICHT toISOString -> sonst Verschiebung um einen Tag in UTC+x)
  function ymdLocal(d){ return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function addDaysLocal(ymd, n){ const p = String(ymd).split('-').map(Number); return ymdLocal(new Date(p[0], p[1] - 1, p[2] + n)); }
  function currentMonthRange(){
    const now = new Date();
    return {
      from: ymdLocal(new Date(now.getFullYear(), now.getMonth(), 1)),
      to:   ymdLocal(new Date(now.getFullYear(), now.getMonth() + 1, 0)),
    };
  }
  // Finance-Zeitraum: gewählter Range ODER standardmäßig der AKTUELLE MONAT (lokal).
  // toNext = exklusive Obergrenze (Tag nach 'to') -> korrekt auch für Timestamp-Spalten.
  // Finance ist IMMER monatsbasiert (entkoppelt von den Tages-Pickern oben) -> AMKZ.state.financeMonth
  function financeMonthRange(){
    const m = AMKZ.state && AMKZ.state.financeMonth;
    if (m === 'all') return { from: '2000-01-01', to: '2999-12-31' };
    if (m && /^\d{4}-\d{2}$/.test(m)) { const p = m.split('-').map(Number); return { from: ymdLocal(new Date(p[0], p[1]-1, 1)), to: ymdLocal(new Date(p[0], p[1], 0)) }; }
    return currentMonthRange();
  }
  function financeRange(){
    const r = financeMonthRange();
    return { from: r.from, to: r.to, toNext: addDaysLocal(r.to, 1) };
  }
  const MONTH_NAMES_DE = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
  function fmtDe(ymd){ const p = String(ymd).split('-'); return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : ymd; }
  // Sichtbares Zeitraum-Label: gewählter Monat (Standard = aktueller Monat)
  function financePeriodLabel(){
    const m = AMKZ.state && AMKZ.state.financeMonth;
    if (m === 'all') return 'Alle Zeiträume';
    const now = new Date();
    let y = now.getFullYear(), mo = now.getMonth();
    if (m && /^\d{4}-\d{2}$/.test(m)) { const p = m.split('-').map(Number); y = p[0]; mo = p[1]-1; }
    return `${MONTH_NAMES_DE[mo]} ${y}`;
  }

  async function loadProfitRowsForDate(date){
    const r = v11Range();
    return tableRows('v_amk_entry_profit_clean',
      q => r ? q.select('*').gte('entry_date', r.from).lte('entry_date', r.to)
             : q.select('*').eq('entry_date', date), []);
  }

  async function loadAllProfitRows(){
    const r = financeRange();
    return tableRows('v_amk_entry_profit_clean',
      q => q.select('*').gte('entry_date', r.from).lt('entry_date', r.toNext), []);
  }

  async function loadEntriesForDate(date, limit = 0){
    const r = v11Range();
    if (r) {
      try {
        const { data } = await AMKZ.supabase.from('entries').select('*')
          .gte('entry_date', r.from).lte('entry_date', r.to)
          .order('entry_date', { ascending: false });
        return data || [];
      } catch(e) { console.warn('V11 entries range failed', e); return []; }
    }
    try {
      if (AMKZ.data?.loadEntries) return await AMKZ.data.loadEntries({ date, limit });
    } catch(e) { console.warn('V11 entries loader failed', e); }
    return rpcRows('amk_get_entries_limited', { p_date: date, p_limit: Number(limit || 0) }, []);
  }

  async function loadActualRows(date){
    const r = v11Range();
    if (r) {
      try {
        const { data } = await AMKZ.supabase.from('amk_actual_daily_data').select('*')
          .gte('report_date', r.from).lte('report_date', r.to);
        if (data) return data;
      } catch(e) { console.warn('V11 actual range failed', e); }
    }
    try {
      if (AMKZ.data?.loadActualDailyData) return await AMKZ.data.loadActualDailyData(date);
    } catch(e) { console.warn('V11 actual loader failed', e); }
    return rpcRows('amk_get_actual_daily_data', { p_report_date: date }, []);
  }

  function actualSummary(rows){
    return {
      actualProfit: (rows || []).reduce((s,r)=>s + safeNumber(r.actual_profit), 0),
      actualRevenue: (rows || []).reduce((s,r)=>s + safeNumber(r.actual_revenue), 0),
      actualCosts: (rows || []).reduce((s,r)=>s + safeNumber(r.actual_costs), 0)
    };
  }

  function nameById(list,id){ return (list || []).find(x => String(x.id) === String(id))?.name || ''; }

  function renderDashboardEntriesV11(entries){
    const body = byId('amkzDashboardEntriesBody');
    if (!body) return;
    const limit = Number(value('amkzDashboardEntriesLimit') || 15);
    const rows = limit > 0 ? (entries || []).slice(0, limit) : (entries || []);
    setHTML(body, rows.length ? rows.map(entry => `
      <tr class="amkz-entry-row" data-entry-id="${escapeHtml(entry.id || '')}" title="Für Details klicken">
        <td>${escapeHtml(entry.entry_date || '—')}</td>
        <td><span class="amkz-status-pill">${escapeHtml(entry.entry_type || '—')}</span></td>
        <td>${escapeHtml(entry.partner_name || nameById(AMKZ.state?.partners, entry.partner_group_id) || '—')}</td>
        <td>${escapeHtml(entry.casino_name || nameById(AMKZ.state?.casinos, entry.casino_id) || '—')}</td>
        <td>${money(entry.amount || 0)}</td>
        <td>${escapeHtml(entry.payment_status || entry.status || 'open')}</td>
      </tr>
    `).join('') : `<tr><td colspan="6"><div class="amkz-empty">Keine Einträge im gewählten Zeitraum.</div></td></tr>`);
  }

  // Profit-View-Zeilen mit Personen-Daten aus den Einträgen anreichern (Name/Mail/Wallet/Partner)
  function enrichPeople(profitRows, entries){
    const byId = {}, byKey = {};
    const key = (o) => [o.entry_date || '', o.casino_id || '', String(o.entry_type || '').toUpperCase(), (o.amount != null ? o.amount : o.entry_amount)].join('|');
    (entries || []).forEach((e) => { if (e.id != null) byId[String(e.id)] = e; byKey[key(e)] = e; });
    (profitRows || []).forEach((r) => {
      const e = byId[String(r.entry_id != null ? r.entry_id : r.id)] || byKey[key(r)];
      if (!e) return;
      if (!r.customer_name) r.customer_name = e.customer_name;
      if (!r.customer_email) r.customer_email = e.customer_email;
      if (!r.wallet_address) r.wallet_address = e.wallet_address;
      if (!r.partner_name) r.partner_name = e.partner_name || nameById(AMKZ.state && AMKZ.state.partners, e.partner_group_id);
    });
    return profitRows;
  }

  /* Dieselbe Schleuse wie bei den Finanzen: die Ansicht wird beim Öffnen
     mehrfach angestossen (View-Kette, Wecker, Datumswechsel, Aktualisieren-
     Knopf) und rechnet sonst zwei- bis dreimal dasselbe. */
  let dashLauf = null, dashZeit = 0;
  async function loadDashboardCleanV11(erzwingen){
    const jetzt = Date.now();
    if (dashLauf) return dashLauf;
    if (!erzwingen && jetzt - dashZeit < 1500) return;
    dashLauf = dashRechnen().finally(() => { dashLauf = null; dashZeit = Date.now(); });
    return dashLauf;
  }

  async function dashRechnen(){
    const date = selectedDate();
    await ensureBase();
    const [profitRows, entries, actualRows] = await Promise.all([
      loadProfitRowsForDate(date),
      loadEntriesForDate(date, 0),
      loadActualRows(date)
    ]);
    enrichPeople(profitRows, entries);
    const rngV11 = v11Range() || { from: date, to: date };
    const s = summarizeProfitRows(profitRows, rngV11);
    const actual = actualSummary(actualRows);
    // Ist-Gewinn: CPA/Hybrid/Fixed zählen AUTOMATISCH (deterministisch), RevShare bleibt manuell.
    const casinoByIdV11 = {}; (AMKZ.state.casinos || []).forEach((c) => { casinoByIdV11[c.id] = c; });
    const isRevshareRow = (r) => String((casinoByIdV11[r.casino_id] || {}).deal_type || '').toLowerCase() === 'revshare';
    const detRows = (profitRows || []).filter((r) => !isRevshareRow(r));
    const autoIst = summarizeProfitRows(detRows, rngV11).expectedProfit;   // korrekte CPA+Hybrid+Fix-Berechnung
    const manualIst = actual.actualProfit;
    const istTotal = autoIst + manualIst;
    // KPI-Aufschlüsselung cachen (für Klick-Popup „wie kommt die Zahl zustande")
    try { const k = (AMKZ.state.kpi = AMKZ.state.kpi || {}); k.dashRows = profitRows; k.dashActual = actualRows; k.dashS = s; k.dashDetRows = detRows; k.dashAutoIst = autoIst; k.dashManualIst = manualIst; k.dashIstTotal = istTotal; } catch (e) {}

    setText(byId('amkzDashFtdCount'), s.ftdCount);
    setText(byId('amkzDashRedepoCount'), s.redepoCount);
    setText(byId('amkzDashFtdMeta'), money(s.ftdAmount));
    setText(byId('amkzDashRedepoMeta'), money(s.redepoAmount));
    setText(byId('amkzDashExpectedProfit'), canSeeProfit() ? money(s.expectedProfit) : '—');
    setText(byId('amkzDashActualProfit'), canSeeProfit() ? money(istTotal) : '—');

    renderDashboardEntriesV11(entries || []);
  }

  function renderDailyCircleV11(percent){
    const canvas = byId('amkzDailyCircleChart');
    if (!canvas || !W.Chart) return;
    const p = Math.max(0, Math.min(100, safeNumber(percent)));
    try { AMKZ.state.charts.dailyCircle?.destroy?.(); } catch(_) {}
    AMKZ.state.charts.dailyCircle = new Chart(canvas, {
      type:'doughnut',
      data:{ labels:['Erreicht','Offen'], datasets:[{ data:[p, Math.max(100-p,0)], borderWidth:0, backgroundColor:['rgba(230,184,92,.95)','rgba(255,255,255,.05)'] }] },
      options:{ responsive:true, maintainAspectRatio:false, cutout:'76%', plugins:{ legend:{display:false}, tooltip:{enabled:true} } }
    });
  }

  function renderActualRowsV11(rows){
    setHTML(byId('amkzActualDataList'), (rows || []).length ? rows.map(row => `
      <div class="amkz-table-row-card">
        <strong>${escapeHtml(row.partner_name || nameById(AMKZ.state?.partners, row.partner_group_id) || 'Ist-Daten')}</strong><br>
        <small>Gewinn: ${canSeeProfit() ? money(row.actual_profit) : '—'} · Umsatz: ${canSeeProfit() ? money(row.actual_revenue) : '—'} · Kosten: ${canSeeProfit() ? money(row.actual_costs) : '—'}</small>
        ${row.note ? `<p>${escapeHtml(row.note)}</p>` : ''}
      </div>
    `).join('') : `<div class="amkz-empty">Keine Ist-Daten im gewählten Zeitraum.</div>`);
  }

  function partnerSummariesFromProfitRows(rows){
    const map = new Map();
    (rows || []).forEach(row => {
      const key = row.partner_group_id || 'none';
      if (!map.has(key)) map.set(key, { partner_group_id: row.partner_group_id, partner_name: nameById(AMKZ.state?.partners, row.partner_group_id) || 'Ohne Partner', ftd_count:0, redepo_count:0, ftd_amount:0, redepo_amount:0, expected_income:0, expected_cost:0, expected_profit:0 });
      const x = map.get(key);
      const type = String(row.entry_type || '').toUpperCase();
      if (type === 'FTD') { x.ftd_count += 1; x.ftd_amount += safeNumber(row.entry_amount); }
      if (type === 'REDEPO') { x.redepo_count += 1; x.redepo_amount += safeNumber(row.entry_amount); }
      x.expected_income += safeNumber(row.expected_income);
      x.expected_cost += safeNumber(row.expected_cost);
      x.expected_profit += safeNumber(row.expected_profit);
    });
    return Array.from(map.values()).sort((a,b)=>safeNumber(b.expected_profit)-safeNumber(a.expected_profit));
  }

  function renderPartnerCleanV11(rows){
    const metric = value('amkzDailyPartnerMetric') || 'ftds';
    const total = rows.reduce((sum,row)=> metric === 'ngr' ? sum + safeNumber(row.expected_profit) : metric === 'deposits' ? sum + safeNumber(row.ftd_amount) + safeNumber(row.redepo_amount) : sum + safeNumber(row.ftd_count), 0);
    setText(byId('amkzDailyPartnerWheelTotal'), metric === 'ngr' || metric === 'deposits' ? money(total) : total);
    setText(byId('amkzDailyPartnerWheelLabel'), metric === 'ngr' ? 'Gewinn' : metric === 'deposits' ? 'Deposits' : 'FTDs');

    const colors = ['#2f80ed','#56ccf2','#0b2f66','#22c55e','#f59e0b','#ef4444','#8b5cf6','#14b8a6'];
    const parts = [];
    let deg = 0;
    rows.forEach((row, i) => {
      const val = metric === 'deposits' ? safeNumber(row.ftd_amount) + safeNumber(row.redepo_amount) : metric === 'ngr' ? safeNumber(row.expected_profit) : safeNumber(row.ftd_count);
      const positiveVal = Math.max(0, val);
      const positiveTotal = Math.max(0, total);
      const slice = positiveTotal > 0 ? (positiveVal / positiveTotal) * 360 : 0;
      if (slice > 0) parts.push(`${colors[i % colors.length]} ${deg}deg ${deg + slice}deg`);
      deg += slice;
    });
    const wheel = byId('amkzDailyPartnerWheel');
    if (wheel) wheel.style.background = parts.length ? `conic-gradient(${parts.join(',')})` : 'conic-gradient(rgba(47,128,237,.18) 0deg 360deg)';

    setHTML(byId('amkzDailyPartnerLegend'), rows.length ? rows.map((row,i)=>{
      const val = metric === 'deposits' ? safeNumber(row.ftd_amount) + safeNumber(row.redepo_amount) : metric === 'ngr' ? safeNumber(row.expected_profit) : safeNumber(row.ftd_count);
      const pct = total ? Math.round((Math.max(0,val) / Math.max(1,total)) * 100) : 0;
      return `<div class="amkz-partner-legend-row">
        <div class="amkz-partner-legend-name"><span class="amkz-partner-legend-dot" style="background:${colors[i % colors.length]}"></span><div><strong>${escapeHtml(row.partner_name || 'Ohne Partner')}</strong><small>${pct}% Anteil</small></div></div>
        <strong>${metric === 'ngr' || metric === 'deposits' ? money(val) : val}</strong>
      </div>`;
    }).join('') : ``); /* Nachtschicht 31.10. (#82): Leertext steht schon in der Tabelle darunter */

    setHTML(byId('amkzDailyPartnerTableBody'), rows.length ? rows.map(row => {
      const deposits = safeNumber(row.ftd_amount) + safeNumber(row.redepo_amount);
      const val = metric === 'deposits' ? deposits : metric === 'ngr' ? safeNumber(row.expected_profit) : safeNumber(row.ftd_count);
      const pct = total ? Math.round((Math.max(0,val) / Math.max(1,total)) * 100) : 0;
      return `<tr>
        <td>${escapeHtml(row.partner_name || 'Ohne Partner')}</td>
        <td>${safeNumber(row.ftd_count)}</td>
        <td>${money(deposits)}</td>
        <td>${money(row.expected_profit)}</td>
        <td><span class="amkz-partner-percent-pill">${pct}%</span></td>
      </tr>`;
    }).join('') : `<tr><td colspan="5"><div class="amkz-empty">Keine Partnerdaten im gewählten Zeitraum.</div></td></tr>`);
  }

  /* Dieselbe Schleuse wie bei den Finanzen: die Ansicht wird beim Öffnen
     mehrfach angestossen (View-Kette, Wecker, Datumswechsel, Aktualisieren-
     Knopf) und rechnet sonst zwei- bis dreimal dasselbe. */
  let dailyLauf = null, dailyZeit = 0;
  async function loadDailyCleanV11(erzwingen){
    const jetzt = Date.now();
    if (dailyLauf) return dailyLauf;
    if (!erzwingen && jetzt - dailyZeit < 1500) return;
    dailyLauf = dailyRechnen().finally(() => { dailyLauf = null; dailyZeit = Date.now(); });
    return dailyLauf;
  }

  async function dailyRechnen(){
    const date = selectedDate();
    await ensureBase();
    const [profitRows, actualRows] = await Promise.all([
      loadProfitRowsForDate(date),
      loadActualRows(date)
    ]);
    const rngV11 = v11Range() || { from: date, to: date };
    const s = summarizeProfitRows(profitRows, rngV11);
    const actual = actualSummary(actualRows);
    const percent = s.expectedProfit > 0 ? Math.round((actual.actualProfit / s.expectedProfit) * 100) : 0;

    setText(byId('amkzDailyFtdAmount'), money(s.ftdAmount));
    setText(byId('amkzDailyRedepoAmount'), money(s.redepoAmount));
    setText(byId('amkzDailyExpenseAmount'), money(s.expectedCost));
    setText(byId('amkzDailyIncomeAmount'), money(s.expectedIncome));
    setText(byId('amkzDailyExpectedProfit'), canSeeProfit() ? money(s.expectedProfit) : '—');
    setText(byId('amkzDailyActualProfit'), canSeeProfit() ? money(actual.actualProfit) : '—');
    setText(byId('amkzDailyDifference'), canSeeProfit() ? money(actual.actualProfit - s.expectedProfit) : '—');
    setText(byId('amkzDailyPercent'), canSeeProfit() ? `${percent}%` : '—');
    renderDailyCircleV11(canSeeProfit() ? percent : 0);
    renderActualRowsV11(actualRows || []);
    renderPartnerCleanV11(partnerSummariesFromProfitRows(profitRows));
  }

  async function sumPaidInvoices(){
    const r = financeRange();
    const rows = await tableRows('amk_finance_documents',
      q => q.select('amount,status,document_type,document_date,title').gte('document_date', r.from).lt('document_date', r.toNext), []);
    try { (AMKZ.state.kpi = AMKZ.state.kpi || {}).invoices = rows; } catch (e) {}
    return {
      paid: rows.filter(r => String(r.document_type || '').toLowerCase() === 'invoice' && ['paid','received','completed'].includes(String(r.status || '').toLowerCase())).reduce((s,r)=>s+safeNumber(r.amount),0),
      open: rows.filter(r => String(r.document_type || '').toLowerCase() === 'invoice' && !['paid','received','completed','cancelled'].includes(String(r.status || '').toLowerCase())).reduce((s,r)=>s+safeNumber(r.amount),0)
    };
  }

  async function sumFinanceInflows(){
    const r = financeRange();
    const rows = await tableRows('finance_inflows',
      q => q.select('*').gte('movement_date', r.from).lt('movement_date', r.toNext), []);
    try { (AMKZ.state.kpi = AMKZ.state.kpi || {}).inflows = rows; } catch (e) {}
    return rows.filter(r => ['paid','received','completed'].includes(String(r.status || '').toLowerCase())).reduce((s,r)=>s+safeNumber(r.profit_amount),0);
  }

  /* Die Finanzansicht wurde bei jedem Öffnen zwei- bis dreimal komplett
     durchgerechnet: einmal aus loadFinanceView, einmal 450 ms später über
     die View-Kette, dazu ein Wecker nach 1,8 Sekunden und der Aktualisieren-
     Knopf. Jeder Lauf holt vier Abfragen parallel, darunter ALLE Einträge
     des Zeitraums. Ergebnis: dreifache Last und genau das Flackern, das
     man loswerden wollte.
     Deshalb hier eine Schleuse: ein laufender Durchgang wird geteilt, und
     unmittelbar aufeinanderfolgende Aufrufe nehmen dessen Ergebnis. */
  let finLauf = null;
  let finZeit = 0;
  async function loadFinanceCleanV11(erzwingen){
    const jetzt = Date.now();
    if (finLauf) return finLauf;                       // läuft schon -> mitfahren
    if (!erzwingen && jetzt - finZeit < 1500) return;  // gerade eben erst gerechnet
    finLauf = finanzenRechnen().finally(() => { finLauf = null; finZeit = Date.now(); });
    return finLauf;
  }

  async function finanzenRechnen(){
    await ensureBase();
    setText(byId('amkzFinancePeriodLabel'), financePeriodLabel());
    const [profitRows, invoices, inflows, finEntries] = await Promise.all([
      loadAllProfitRows(),
      sumPaidInvoices(),
      sumFinanceInflows(),
      loadEntriesForDate(null, 0)
    ]);
    enrichPeople(profitRows, finEntries);
    const s = summarizeProfitRows(profitRows, financeRange());
    const totalIncome = s.expectedIncome + invoices.paid + inflows;
    const totalExpenses = s.expectedCost;
    const net = totalIncome - totalExpenses;
    // KPI-Aufschlüsselung: exakte Rohdaten + Teilsummen cachen (für Klick-Popup)
    try { const k = (AMKZ.state.kpi = AMKZ.state.kpi || {}); k.finRows = profitRows; k.finS = s; k.finInvoicesPaid = invoices.paid; k.finInvoicesOpen = invoices.open; k.finInflowsSum = inflows; k.finIncome = totalIncome; k.finExpenses = totalExpenses; k.finNet = net; } catch (e) {}

    setText(byId('amkzFinanceIncomeTotal'), money(totalIncome));
    setText(byId('amkzFinanceExpenseTotal'), money(totalExpenses));
    setText(byId('amkzFinanceOpenInvoices'), money(invoices.open));
    setText(byId('amkzFinanceNetTotal'), money(net));

    const list = byId('amkzFinanceMovementsList');
    if (list) {
      setHTML(list, `
        <div class="amkz-table-row-card"><strong>Deal-Einnahmen</strong><br><small>${money(s.expectedIncome)}</small></div>
        <div class="amkz-table-row-card"><strong>FTD/ReDepo/Ausgänge</strong><br><small>${money(s.expectedCost)}</small></div>
        <div class="amkz-table-row-card"><strong>Deal-Gewinn</strong><br><small>${money(s.expectedProfit)}</small></div>
        <div class="amkz-table-row-card"><strong>Bezahlte Rechnungen</strong><br><small>${money(invoices.paid)}</small></div>
        <div class="amkz-table-row-card"><strong>Casino-Eingänge</strong><br><small>${money(inflows)}</small></div>
      `);
    }
  }

  const oldLoadView = AMKZ.loadView;
  AMKZ.loadView = async function(view, options){
    const result = await oldLoadView?.call(this, view, options);
    setTimeout(()=>{
      if (view === 'dashboard') loadDashboardCleanV11();
      if (view === 'daily') loadDailyCleanV11();
      if (view === 'finance') loadFinanceCleanV11();
    }, 450);
    return result;
  };

  document.addEventListener('change', (e)=>{
    if (e.target?.id === 'amkzGlobalDate') {
      setTimeout(()=>{
        if (AMKZ.state?.currentView === 'dashboard') loadDashboardCleanV11(true);
        if (AMKZ.state?.currentView === 'daily') loadDailyCleanV11(true);
      }, 450);
    }
    if (e.target?.id === 'amkzDailyPartnerMetric') setTimeout(loadDailyCleanV11, 100);
  });

  ['amkzRefreshButton','amkzApplyDateRangeFinal'].forEach(id => {
    document.addEventListener('click', (e)=>{
      if (e.target?.id !== id) return;
      setTimeout(()=>{
        if (AMKZ.state?.currentView === 'dashboard') loadDashboardCleanV11(true);
        if (AMKZ.state?.currentView === 'daily') loadDailyCleanV11(true);
        if (AMKZ.state?.currentView === 'finance') loadFinanceCleanV11(true);
      }, 650);
    });
  });

  setTimeout(()=>{
    if (AMKZ.state?.currentView === 'dashboard') loadDashboardCleanV11();
    if (AMKZ.state?.currentView === 'daily') loadDailyCleanV11();
    if (AMKZ.state?.currentView === 'finance') loadFinanceCleanV11();
  }, 1800);

  AMKZ.modules = AMKZ.modules || {};
  AMKZ.modules.v11 = { loadDashboardCleanV11, loadDailyCleanV11, loadFinanceCleanV11 };
})();
/* =====================================================
   AMK ZENTRALE — FX LAYER (rein additiv, kein Backend)
   Ripple · View-Fade · KPI Count-Up · Status-Pill-Farben
   Läuft eigenständig, greift nicht in AMKZ-Logik ein.
===================================================== */
(function () {
  "use strict";

  /* ---------- Button Ripple ---------- */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".amkz-primary-btn, .amkz-secondary-btn");
    if (!btn) return;
    const rect = btn.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height) * 1.2;
    const r = document.createElement("span");
    r.className = "amk-ripple";
    r.style.width = r.style.height = size + "px";
    r.style.left = (e.clientX - rect.left) + "px";
    r.style.top = (e.clientY - rect.top) + "px";
    btn.appendChild(r);
    setTimeout(() => r.remove(), 650);
  }, true);

  /* ---------- Refresh-Button Spin ---------- */
  document.addEventListener("click", (e) => {
    const b = e.target.closest("#amkzRefreshButton");
    if (!b) return;
    b.classList.remove("amk-fx-spin"); void b.offsetWidth; b.classList.add("amk-fx-spin");
    setTimeout(() => b.classList.remove("amk-fx-spin"), 650);
  }, true);

  /* ---------- View Fade-In bei Navigation ---------- */
  function fxView() {
    const view = document.querySelector(".amkz-view:not(.is-hidden)");
    if (!view) return;
    view.classList.remove("amk-fx-in"); void view.offsetWidth; view.classList.add("amk-fx-in");
  }
  document.addEventListener("click", (e) => {
    if (e.target.closest(".amkz-nav-item")) setTimeout(fxView, 60);
  }, true);

  /* ---------- Status-Pill Farben ---------- */
  function colorPill(pill) {
    const t = (pill.textContent || "").trim().toLowerCase();
    // Nachtschicht 31.10.: nur ändern, wenn nötig – vorher wurden bei jeder DOM-Änderung (z. B. Zähl-Animation) alle Pills neu gesetzt (~400 Änderungen/Sek.)
    const want = /(inaktiv|inactive)/.test(t) ? "amk-pill-bad"   // vorher grün, weil „inaktiv“ auch „aktiv“ enthält
      : /(paid|bezahlt|completed|received|signed|done|aktiv|active)/.test(t) ? "amk-pill-paid"
      : /(open|offen|sent|gestellt|scheduled|geplant)/.test(t) ? "amk-pill-open"
      : /(pending|wartet|review)/.test(t) ? "amk-pill-pending"
      : /(cancel|storniert|abgesagt|failed|fehlgeschlagen|inactive|inaktiv)/.test(t) ? "amk-pill-bad"
      : "amk-pill-open";
    ["amk-pill-paid", "amk-pill-open", "amk-pill-pending", "amk-pill-bad"].forEach((c) => { if (c !== want && pill.classList.contains(c)) pill.classList.remove(c); });
    if (!pill.classList.contains(want)) pill.classList.add(want);
  }
  function colorAllPills(root) {
    (root || document).querySelectorAll(".amkz-status-pill").forEach(colorPill);
  }

  /* ---------- KPI Count-Up ---------- */
  const FMT = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function parseNum(str) {
    const m = String(str).replace(/[^\d,.-]/g, "").replace(/\.(?=\d{3}(\D|$))/g, "").replace(",", ".");
    const n = parseFloat(m);
    return Number.isFinite(n) ? n : null;
  }
  function animateValue(el) {
    const target = el.textContent;
    if (el.dataset.fxLast === target || el.dataset.fxBusy === "1") return;
    const isEuro = /€/.test(target);
    const to = parseNum(target);
    if (to === null) { el.dataset.fxLast = target; return; }
    const from = parseNum(el.dataset.fxLast || "0") || 0;
    el.dataset.fxBusy = "1";
    el.classList.remove("amk-fx-pulse"); void el.offsetWidth; el.classList.add("amk-fx-pulse");
    const dur = 650, t0 = performance.now();
    const isInt = !isEuro && Number.isInteger(to);
    function step(now) {
      const p = Math.min(1, (now - t0) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      const val = from + (to - from) * eased;
      el.textContent = isEuro ? (FMT.format(val) + " €") : (isInt ? Math.round(val).toString() : FMT.format(val));
      if (p < 1) { requestAnimationFrame(step); }
      else { el.textContent = target; el.dataset.fxLast = target; el.dataset.fxBusy = "0"; }
    }
    requestAnimationFrame(step);
  }

  function watchKpis() {
    const els = document.querySelectorAll(".amkz-kpi-card strong, .amkz-mini-kpi strong");
    els.forEach((el) => {
      if (el.dataset.fxWatched) return;
      el.dataset.fxWatched = "1";
      el.dataset.fxLast = el.textContent;
      const mo = new MutationObserver(() => { if (el.dataset.fxBusy !== "1") animateValue(el); });
      mo.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- Global Observer (neue Pills/KPIs nach Renders) ---------- */
  const root = new MutationObserver(() => {
    colorAllPills();
    watchKpis();
  });

  function boot() {
    colorAllPills();
    watchKpis();
    fxView();
    const app = document.getElementById("amkzApp") || document.body;
    root.observe(app, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
/* =====================================================
   AMK ZENTRALE — RECHNUNGEN (§ 14 UStG · GoBD)

   Was diese Fassung anders macht als die davor:

     · Die Rechnungsnummer wird nicht mehr GEWUERFELT, sondern von der
       Datenbank fortlaufend vergeben (§ 14 Abs. 4 Nr. 4 UStG). Die alte
       Zufallsnummer AMK-202608-<100..999> konnte doppelt vorkommen.
     · Die Stammdaten des Ausstellers stehen in der Datenbank statt im
       localStorage — sonst sieht die Rechnung auf jedem Rechner anders aus.
     · Pflichtangaben werden vor dem Ausstellen geprueft: Anschrift,
       Steuernummer/USt-IdNr., Leistungszeitraum, Leistungsbeschreibung und
       bei 0 % der Grund der Steuerbefreiung.
     · Jede Rechnung liegt als vollstaendige Momentaufnahme in amk_invoices
       und ist dort unveraenderbar. Der Nachdruck wird AUS DIESEM Datensatz
       gezeichnet — nicht aus den heutigen Stammdaten neu gebaut.
     · Korrigiert wird per Storno (Gegenrechnung), nie durch Loeschen.

   Voraussetzung: zentrale/supabase-rechnungen.sql ist eingespielt.
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__invoiceModule) return;
  AMKZ.__invoiceModule = true;

  /* >>> MUSS mit v_secret in supabase-rechnungen.sql uebereinstimmen <<< */
  const INV_ADMIN_TOKEN = "amk_inv_7Kq2Rm9xTv4B";
  const AUSSTELLER = "NouriAMK";

  const byId = (id) => document.getElementById(id);
  const val = (id) => byId(id)?.value?.trim() || "";
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? ""));
  // Zahlenfelder (type=number) liefern immer „6430.31“ — der Punkt ist dort das Komma.
  // Früher wurde er als Tausenderpunkt gestrichen: aus 6.430,31 € wurden 643.031 €.
  const num = (v) => {
    const s = String(v == null ? "" : v).trim();
    if (/^-?\d+(\.\d+)?$/.test(s)) return Number(s);
    const n = Number(s.replace(/\./g, "").replace(",", ".").replace(/[^\d.-]/g, ""));
    return Number.isFinite(n) ? n : 0;
  };
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  // Lokal, nie toISOString(): zwischen 0 und 2 Uhr deutscher Zeit wäre das UTC-Datum der Vortag —
  // Rechnungsdatum, Leistungszeitraum und Fälligkeit wären dann falsch.
  const isoDay = (d) => { const x = new Date(d); return x.getFullYear() + "-" + String(x.getMonth() + 1).padStart(2, "0") + "-" + String(x.getDate()).padStart(2, "0"); };
  const heute = () => isoDay(new Date());
  const deDatum = (s) => { if (!s) return "—"; const [y, m, d] = String(s).slice(0, 10).split("-"); return `${d}.${m}.${y}`; };
  const geld = (n, w) => new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n || 0)) + " " + (w === "EUR" || !w ? "€" : w);

  /* ---------- Zugriff auf die Rechnungsablage ---------- */
  async function rpc(action, payload) {
    const mitglied = AMKZ.state?.member || {};
    const { data, error } = await AMKZ.supabase.rpc("amk_invoice_admin", {
      p_token: INV_ADMIN_TOKEN,
      p_action: action,
      p_payload: Object.assign({ by: mitglied.name || mitglied.email || "" }, payload || {}),
    });
    if (error) throw new Error(error.message);
    if (data && data.error) {
      throw new Error(data.error === "unauthorized"
        ? "Rechnungs-Token stimmt nicht mit der Datenbank überein (supabase-rechnungen.sql einspielen)."
        : data.error);
    }
    return data;
  }

  /* ---------- Steuerhinweise ----------
     Bei 0 % verlangt § 14 Abs. 4 Nr. 8 UStG einen Grund auf der Rechnung.
     Ohne diesen Satz ist die Rechnung formal falsch — deshalb sind die
     gaengigen Faelle hier fest hinterlegt statt frei getippt. */
  const STEUERFALL = {
    reverse: {
      label: "0 % · Reverse Charge (EU-Unternehmen)",
      satz: 0,
      hinweis: "Steuerschuldnerschaft des Leistungsempfängers (Reverse Charge, Art. 196 MwStSystRL / § 13b UStG).",
      brauchtUstIdEmpfaenger: true,
    },
    drittland: {
      label: "0 % · Empfänger außerhalb der EU",
      satz: 0,
      hinweis: "Nicht im Inland steuerbare sonstige Leistung; Leistungsort am Sitz des Empfängers (§ 3a Abs. 2 UStG).",
      brauchtUstIdEmpfaenger: false,
    },
    klein: {
      label: "0 % · Kleinunternehmer (§ 19 UStG)",
      satz: 0,
      hinweis: "Gemäß § 19 UStG wird keine Umsatzsteuer berechnet.",
      brauchtUstIdEmpfaenger: false,
    },
    ust19: { label: "19 % Umsatzsteuer", satz: 19, hinweis: "", brauchtUstIdEmpfaenger: false },
    ust7:  { label: "7 % Umsatzsteuer",  satz: 7,  hinweis: "", brauchtUstIdEmpfaenger: false },
  };

  /* ---------- Rechnungsadresse je Partner (Vorbelegung) ---------- */
  async function ladeAdresse(pid) {
    if (!pid) return null;
    try {
      const { data } = await AMKZ.supabase.from("amk_partner_billing").select("*").eq("partner_group_id", pid).maybeSingle();
      return data || null;
    } catch (_) { return null; }
  }
  async function merkeAdresse(pid, d) {
    try {
      await AMKZ.supabase.from("amk_partner_billing")
        .upsert(Object.assign({ partner_group_id: pid, updated_at: new Date().toISOString() }, d), { onConflict: "partner_group_id" });
    } catch (_) {}
  }

  /* ============================================================
     STAMMDATEN DES AUSSTELLERS
     Frueher lagen sie im localStorage — also je Rechner anders und
     ohne Sicherung. Jetzt in der Datenbank, weil sie auf jeder
     Rechnung stehen und dort vollstaendig sein muessen.
  ============================================================ */
  async function oeffneStammdaten(danach) {
    let p = {};
    try { p = (await rpc("profile_get", {})).profile || {}; }
    catch (err) { return toast("Fehler", err.message, "error"); }

    const f = (id, label, wert, ph, pflicht) =>
      `<div class="amkz-input-group"><label>${label}${pflicht ? " *" : ""}</label>` +
      `<input id="${id}" value="${esc(wert || "")}" placeholder="${esc(ph || "")}"></div>`;

    AMKZ.modal.open(`
      <div class="amkz-modal amk-invoice-modal">
        <div class="amkz-modal-header">
          <div><h3>Rechnungs-Stammdaten</h3>
          <p>Diese Angaben stehen auf jeder Rechnung — § 14 Abs. 4 Nr. 1 und 2 UStG</p></div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button>
        </div>
        <form id="amkProfilForm" class="amkz-form-grid">
          <div class="amk-inv-section">
            <div class="amk-inv-section-title">Firma</div>
            ${f("cpName", "Vollständiger Name / Firma", p.name, "Nouri Media GmbH", true)}
            <div class="amkz-form-row">
              ${f("cpStreet", "Straße und Hausnummer", p.street, "Musterstraße 1", true)}
              ${f("cpZip", "PLZ", p.zip, "12345", true)}
            </div>
            <div class="amkz-form-row">
              ${f("cpCity", "Ort", p.city, "Köln", true)}
              ${f("cpCountry", "Land", p.country || "DE", "DE")}
            </div>
          </div>
          <div class="amk-inv-section">
            <div class="amk-inv-section-title">Steuer <small>eines von beiden ist Pflicht</small></div>
            <div class="amkz-form-row">
              ${f("cpVatId", "USt-IdNr.", p.vat_id, "DE123456789")}
              ${f("cpTaxNo", "Steuernummer", p.tax_number, "214/5678/9012")}
            </div>
            <div class="amkz-input-group"><label>Kleinunternehmer nach § 19 UStG</label>
              <select id="cpSmall">
                <option value="0"${!p.small_business ? " selected" : ""}>Nein — Umsatzsteuer wird ausgewiesen</option>
                <option value="1"${p.small_business ? " selected" : ""}>Ja — keine Umsatzsteuer</option>
              </select></div>
          </div>
          <div class="amk-inv-section">
            <div class="amk-inv-section-title">Register &amp; Kontakt</div>
            <div class="amkz-form-row">
              ${f("cpCourt", "Registergericht", p.register_court, "Amtsgericht Köln")}
              ${f("cpRegNo", "Registernummer", p.register_number, "HRB 12345")}
            </div>
            <div class="amkz-form-row">
              ${f("cpBoss", "Geschäftsführung", p.managing_director, "Marcel Reith")}
              ${f("cpEmail", "E-Mail", p.email, "buchhaltung@…")}
            </div>
          </div>
          <div class="amk-inv-section">
            <div class="amk-inv-section-title">Zahlung</div>
            <div class="amkz-form-row">
              ${f("cpIban", "IBAN", p.iban, "DE00 0000 0000 0000 0000 00")}
              ${f("cpBic", "BIC", p.bic, "COBADEFFXXX")}
            </div>
            ${f("cpWallet", "Krypto-Adresse (optional)", p.wallet, "0x… / TRC20")}
            ${f("cpWalletName", "Bezeichnung der Wallet (steht auf der Rechnung)", p.bank_name, "EXODUS")}
            <div class="amkz-form-row">
              ${f("cpTerms", "Zahlungsbedingung", p.payment_terms || "10 Tage netto", "10 Tage netto")}
              ${f("cpDays", "Zahlungsziel (Tage)", p.payment_days == null ? 10 : p.payment_days, "10")}
            </div>
            ${f("cpPrefix", "Nummernkreis", p.invoice_prefix || "AMK", "AMK")}
          </div>
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Stammdaten speichern</button>
          </div>
        </form>
      </div>`);

    byId("amkProfilForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      try {
        await rpc("profile_save", {
          name: val("cpName"), street: val("cpStreet"), zip: val("cpZip"), city: val("cpCity"),
          country: val("cpCountry") || "DE", vat_id: val("cpVatId"), tax_number: val("cpTaxNo"),
          register_court: val("cpCourt"), register_number: val("cpRegNo"),
          managing_director: val("cpBoss"), email: val("cpEmail"),
          iban: val("cpIban"), bic: val("cpBic"), wallet: val("cpWallet"), bank_name: val("cpWalletName"),
          payment_terms: val("cpTerms"), payment_days: num(val("cpDays")) || 10,
          small_business: val("cpSmall") === "1", invoice_prefix: val("cpPrefix") || "AMK",
        });
        toast("Gespeichert", "Die Stammdaten stehen ab jetzt auf jeder Rechnung.");
        AMKZ.modal.close();
        if (typeof danach === "function") danach();
      } catch (err) { toast("Fehler", err.message, "error"); }
    });
  }

  /* ============================================================
     RECHNUNG SCHREIBEN
  ============================================================ */
  async function oeffneGenerator() {
    await AMKZ.data?.loadBaseData?.(false);
    const partner = AMKZ.state?.partners || [];

    let profil = {};
    try { profil = (await rpc("profile_get", {})).profile || {}; }
    catch (err) { return toast("Fehler", err.message, "error"); }

    // Marcel 03.11.2026: Auf der Vorlage steht als Aussteller nur „NouriAMK“ —
    // Adresse und Steuernummer sind keine Voraussetzung mehr fuers Erstellen.

    const tag = heute();
    const ersterDesMonats = tag.slice(0, 8) + "01";
    const letzterVormonat = (() => { const d = new Date(); d.setDate(0); return isoDay(d); })();
    const vormonatStart = (() => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() - 1); return isoDay(d); })();
    const faellig = (() => { const d = new Date(); d.setDate(d.getDate() + (profil.payment_days || 10)); return isoDay(d); })();
    const standardFall = profil.small_business ? "klein" : "reverse";

    AMKZ.modal.open(`
      <div class="amkz-modal amk-invoice-modal">
        <div class="amkz-modal-header">
          <div><h3>Rechnung schreiben</h3>
          <p>Nummer wird beim Speichern fortlaufend vergeben · Pflichtangaben nach § 14 UStG</p></div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button>
        </div>
        <form id="amkInvoiceForm" class="amkz-form-grid">

          <div class="amk-inv-section">
            <div class="amk-inv-section-title">Aussteller
              <small>${esc(profil.name || AUSSTELLER)} — Anschrift &amp; Registernummer kommen aus den Stammdaten</small></div>
            <button class="amkz-secondary-btn" type="button" id="invProfilBtn">Stammdaten bearbeiten</button>
          </div>

          <div class="amkz-input-group">
            <label>Partner *</label>
            <select id="invPartner" required>
              <option value="">Partner wählen</option>
              ${partner.map((p) => `<option value="${esc(p.id)}">${esc(p.name || p.id)}</option>`).join("")}
            </select>
          </div>

          <div class="amk-inv-section">
            <div class="amk-inv-section-title">Empfänger <small>wird beim Partner gespeichert · Anschrift nur wenn vorhanden</small></div>
            <div class="amkz-input-group"><label>Firma *</label><input id="invToCompany" placeholder="Sentoka Limited" required></div>
            <div class="amkz-input-group"><label>Anschrift (optional)</label><textarea id="invToAddress" rows="2" placeholder="leer lassen, wenn keine bekannt"></textarea></div>
            <div class="amkz-form-row">
              <div class="amkz-input-group"><label>USt-IdNr. des Empfängers</label><input id="invToVatId" placeholder="MT12345678"></div>
              <div class="amkz-input-group"><label>Registernummer</label><input id="invToCompanyNo" placeholder="022924V"></div>
            </div>
            <div class="amkz-input-group"><label>E-Mail</label><input id="invToEmail" type="email" placeholder="billing@partner.com"></div>
          </div>

          <div class="amk-inv-section">
            <div class="amk-inv-section-title">Leistung</div>
            <div class="amkz-input-group"><label>Bezeichnung der Leistung *</label>
              <input id="invDesc" placeholder="Affiliate-Vermittlungsprovision" required>
              <small>Handelsübliche Bezeichnung — „JUN" allein genügt dem Finanzamt nicht.</small></div>
            <div class="amkz-form-row">
              <div class="amkz-input-group"><label>Leistungszeitraum von *</label><input id="invFrom" type="date" value="${vormonatStart}" required></div>
              <div class="amkz-input-group"><label>bis *</label><input id="invTo" type="date" value="${letzterVormonat}" required></div>
            </div>
            <div class="amkz-form-row">
              <div class="amkz-input-group"><label>Menge</label><input id="invQty" type="number" min="1" step="1" value="1"></div>
              <div class="amkz-input-group"><label>Einzelpreis netto (€) *</label><input id="invPrice" type="number" step="0.01" min="0" placeholder="0,00" required></div>
            </div>
          </div>

          <div class="amk-inv-section">
            <div class="amk-inv-section-title">Umsatzsteuer</div>
            <div class="amkz-input-group"><label>Fall *</label>
              <select id="invVatCase">
                ${Object.keys(STEUERFALL).map((k) => `<option value="${k}"${k === standardFall ? " selected" : ""}>${esc(STEUERFALL[k].label)}</option>`).join("")}
              </select></div>
            <div class="amkz-input-group"><label>Hinweis auf der Rechnung</label>
              <input id="invVatNote" value="${esc(STEUERFALL[standardFall].hinweis)}">
              <small>Bei 0 % ist dieser Satz Pflicht (§ 14 Abs. 4 Nr. 8 UStG).</small></div>
            <div class="amk-inv-summe" id="invSumme"></div>
          </div>

          <div class="amk-inv-section">
            <div class="amk-inv-section-title">Datum &amp; Zahlung</div>
            <div class="amkz-form-row">
              <div class="amkz-input-group"><label>Rechnungsdatum *</label><input id="invDate" type="date" value="${tag}" required></div>
              <div class="amkz-input-group"><label>Fällig bis</label><input id="invDue" type="date" value="${faellig}"></div>
            </div>
            <div class="amkz-input-group"><label>Zahlungsbedingung</label><input id="invTerms" value="${esc(profil.payment_terms || "10 Tage netto")}"></div>
            <div class="amkz-input-group"><label>Freitext (optional)</label><input id="invFree" placeholder="z. B. Bezug: Vereinbarung vom …"></div>
          </div>

          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Rechnung erstellen &amp; als PDF laden</button>
          </div>
        </form>
      </div>`);

    const rechne = () => {
      const fall = STEUERFALL[val("invVatCase")] || STEUERFALL.reverse;
      const netto = Math.round(num(val("invPrice")) * Math.max(1, num(val("invQty")) || 1) * 100) / 100;
      const ust = Math.round(netto * fall.satz) / 100;
      const box = byId("invSumme");
      if (box) {
        box.innerHTML =
          `<div><span>Netto</span><b>${geld(netto)}</b></div>` +
          `<div><span>Umsatzsteuer ${fall.satz} %</span><b>${geld(ust)}</b></div>` +
          `<div class="gross"><span>Gesamtbetrag</span><b>${geld(netto + ust)}</b></div>`;
      }
    };

    byId("invProfilBtn")?.addEventListener("click", () => oeffneStammdaten(() => oeffneGenerator()));
    byId("invVatCase")?.addEventListener("change", (e) => {
      const f = STEUERFALL[e.target.value];
      if (f) byId("invVatNote").value = f.hinweis;
      rechne();
    });
    ["invPrice", "invQty"].forEach((id) => byId(id)?.addEventListener("input", rechne));
    byId("invDate")?.addEventListener("change", (e) => {
      const d = new Date(e.target.value || heute());
      d.setDate(d.getDate() + (profil.payment_days || 10));
      byId("invDue").value = isoDay(d);
    });
    byId("invPartner")?.addEventListener("change", async (e) => {
      const b = await ladeAdresse(e.target.value);
      byId("invToCompany").value = b?.company || (partner.find((p) => p.id === e.target.value)?.name || "");
      byId("invToAddress").value = b?.reg_address || b?.address || "";
      byId("invToVatId").value = b?.vat_id || b?.tax_number || "";
      byId("invToCompanyNo").value = b?.company_number || "";
      byId("invToEmail").value = b?.email || "";
    });
    rechne();

    byId("amkInvoiceForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const knopf = e.target.querySelector('button[type="submit"]');
      if (knopf) { knopf.disabled = true; knopf.textContent = "Rechnung wird gebucht…"; }
      try { await erstelle(partner, profil); }
      catch (err) {
        console.error(err);
        toast("Fehler", err.message || "Rechnung fehlgeschlagen.", "error");
        if (knopf) { knopf.disabled = false; knopf.textContent = "Rechnung erstellen & als PDF laden"; }
      }
    });
  }

  async function erstelle(partner, profil) {
    const pid = val("invPartner");
    const fall = STEUERFALL[val("invVatCase")] || STEUERFALL.reverse;
    const menge = Math.max(1, num(val("invQty")) || 1);
    const preis = num(val("invPrice"));
    if (!pid) throw new Error("Bitte Partner wählen.");
    if (!preis) throw new Error("Bitte einen Betrag eintragen.");
    if (fall.satz === 0 && !val("invVatNote")) {
      throw new Error("Bei 0 % Umsatzsteuer muss der Grund auf der Rechnung stehen.");
    }
    if (new Date(val("invTo")) < new Date(val("invFrom"))) {
      throw new Error("Der Leistungszeitraum endet vor seinem Beginn.");
    }

    const empfaenger = {
      company: val("invToCompany"), address: val("invToAddress"),
      vat_id: val("invToVatId"), company_number: val("invToCompanyNo"), email: val("invToEmail"),
    };
    await merkeAdresse(pid, {
      company: empfaenger.company, reg_address: empfaenger.address,
      vat_id: empfaenger.vat_id, company_number: empfaenger.company_number, email: empfaenger.email,
    });

    const antwort = await rpc("create", {
      issue_date: val("invDate") || heute(),
      service_from: val("invFrom"),
      service_to: val("invTo") || val("invFrom"),
      due_date: val("invDue") || null,
      recipient: empfaenger,
      partner_group_id: pid,
      positions: [{
        description: val("invDesc"),
        quantity: menge,
        unit_price: preis,
        net: Math.round(preis * menge * 100) / 100,
      }],
      net_amount: Math.round(preis * menge * 100) / 100,
      vat_rate: fall.satz,
      vat_note: val("invVatNote"),
      payment_terms: val("invTerms"),
      payment_details: { iban: profil.iban || "", bic: profil.bic || "", wallet: profil.wallet || "", wallet_label: profil.bank_name || "" },
      free_text: val("invFree"),
      currency: "EUR",
    });

    const r = antwort.invoice;
    await zeichnePdf(r);

    // Spiegelzeile fuer die bestehende Finanzuebersicht.
    try {
      await AMKZ.save?.saveFinanceDocument?.({
        documentType: "invoice",
        title: `Rechnung ${r.invoice_no} · ${val("invDesc")}`,
        partnerGroupId: pid, documentDate: r.issue_date,
        amount: Number(r.gross_amount), status: "open",
        note: `${deDatum(r.service_from)}–${deDatum(r.service_to)} · fällig ${deDatum(r.due_date)}`,
      });
    } catch (_) {}

    AMKZ.modal.close();
    toast("Rechnung gebucht", `${r.invoice_no} ist erstellt und liegt unveränderbar in der Ablage.`);
    if (AMKZ.state?.currentView === "finance" && AMKZ.modules?.finance?.loadFinanceView) {
      try { await AMKZ.modules.finance.loadFinanceView(); } catch (_) {}
    }
  }

  /* ============================================================
     PDF — gezeichnet AUS DEM GESPEICHERTEN DATENSATZ
     Damit sieht der Nachdruck in fuenf Jahren aus wie das Original,
     auch wenn sich Stammdaten laengst geaendert haben.
  ============================================================ */
  async function ladeJsPdf() {
    if (window.jspdf?.jsPDF) return true;
    await new Promise((res) => {
      const s = document.createElement("script");
      s.src = "https://cdn.jsdelivr.net/npm/jspdf@2.5.2/dist/jspdf.umd.min.js";
      s.onload = res; s.onerror = res; document.head.appendChild(s);
    });
    return !!window.jspdf?.jsPDF;
  }

  async function zeichnePdf(r) {
    if (!(await ladeJsPdf())) throw new Error("PDF-Bibliothek nicht ladbar.");
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({ unit: "mm", format: "a4" });
    const M = 18, W = 210, GOLD = [200, 144, 43], INK = [24, 28, 38], MUT = [110, 118, 138], LINE = [223, 226, 234];
    const an = r.recipient || {}, storno = Number(r.gross_amount) < 0;

    const zeile = (t, x, y, o) => { doc.text(String(t == null ? "" : t), x, y, o); };

    // Kopf: links Aussteller aus dem Stammdaten-Snapshot der Rechnung (r.issuer), rechts RECHNUNG + Nummer.
    // Alte Rechnungen ohne Anschrift im Snapshot bleiben beim Nachdruck unverändert (nur der Name).
    const aus = r.issuer || {};
    doc.setFont("helvetica", "bold"); doc.setFontSize(13); doc.setTextColor(...INK);
    zeile(aus.name || AUSSTELLER, M, 22);
    if (aus.street) {
      const ausZeilen = [aus.street, [[aus.zip, aus.city].filter(Boolean).join(" "), aus.country].filter(Boolean).join(", ")];
      if (aus.register_number) ausZeilen.push("Company Registration Number: " + aus.register_number + (aus.country ? "  ·  Country of Registration: " + aus.country : ""));
      const steuer = [aus.vat_id && "USt-IdNr.: " + aus.vat_id, aus.tax_number && "Steuernr.: " + aus.tax_number].filter(Boolean).join("  ·  ");
      if (steuer) ausZeilen.push(steuer);
      doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor(...MUT);
      ausZeilen.forEach((t, i) => zeile(t, M, 27.5 + i * 3.6));
      doc.setFont("helvetica", "bold"); doc.setTextColor(...INK);
    }
    doc.setFontSize(24);
    zeile(storno ? "STORNORECHNUNG" : "RECHNUNG", W - M, 24, { align: "right" });
    doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(...MUT);
    zeile(String(r.invoice_no || "") + (r.kopie ? "  ·  Kopie" : ""), W - M, 30, { align: "right" });
    doc.setDrawColor(...GOLD); doc.setLineWidth(0.7); doc.line(M, 41, W - M, 41);

    // Empfaenger
    let y = 52;
    doc.setFontSize(8); doc.setTextColor(...MUT); zeile("RECHNUNG AN", M, y);
    y += 6; doc.setFont("helvetica", "bold"); doc.setFontSize(11.5); doc.setTextColor(...INK);
    zeile(an.company || "—", M, y);
    doc.setFont("helvetica", "normal"); doc.setFontSize(9.5);
    const anZeilen = [];
    if (an.address) anZeilen.push(...doc.splitTextToSize(String(an.address), 88));
    if (an.vat_id) anZeilen.push("USt-IdNr.: " + an.vat_id);
    if (an.company_number) anZeilen.push("Reg.-Nr.: " + an.company_number);
    anZeilen.forEach((t, i) => zeile(t, M, y + 6 + i * 4.6));

    // Kopfdaten rechts — Nummer, Datum, Leistungszeitraum, Faelligkeit
    const kopf = [
      ["Rechnungsnummer", r.invoice_no],
      ["Rechnungsdatum", deDatum(r.issue_date)],
      ["Leistungszeitraum", r.service_from
        ? (r.service_from === r.service_to ? deDatum(r.service_from) : deDatum(r.service_from) + " – " + deDatum(r.service_to))
        : "—"],
      ["Zahlbar bis", deDatum(r.due_date)],
    ];
    let ky = 52;
    kopf.forEach(([k, v]) => {
      doc.setFont("helvetica", "normal"); doc.setFontSize(8.5); doc.setTextColor(...MUT);
      zeile(k, W - M - 62, ky);
      doc.setFont("helvetica", "bold"); doc.setFontSize(9.5); doc.setTextColor(...INK);
      zeile(v, W - M, ky, { align: "right" });
      ky += 6.5;
    });

    // Positionen
    y = Math.max(y + 6 + anZeilen.length * 4.6 + 10, ky + 8);
    doc.setFillColor(246, 247, 251); doc.rect(M, y, W - 2 * M, 9, "F");
    doc.setFont("helvetica", "bold"); doc.setFontSize(8.5); doc.setTextColor(...MUT);
    zeile("BESCHREIBUNG", M + 2, y + 6);
    zeile("MENGE", W - M - 74, y + 6);
    zeile("EINZELPREIS", W - M - 46, y + 6);
    zeile("NETTO", W - M - 2, y + 6, { align: "right" });
    y += 9;
    doc.setFont("helvetica", "normal"); doc.setFontSize(9.5); doc.setTextColor(...INK);
    (r.positions || []).forEach((p) => {
      const txt = doc.splitTextToSize(String(p.description || "—"), 95);
      zeile(txt, M + 2, y + 6);
      zeile(String(p.quantity || 1), W - M - 74, y + 6);
      zeile(geld(p.unit_price, r.currency), W - M - 46, y + 6);
      zeile(geld(p.net, r.currency), W - M - 2, y + 6, { align: "right" });
      y += Math.max(9, txt.length * 5 + 4);
    });
    doc.setDrawColor(...LINE); doc.setLineWidth(0.3); doc.line(M, y + 1, W - M, y + 1);

    // Summen
    let sy = y + 10; const lx = W - M - 62;
    const summen = [
      ["Nettobetrag", geld(r.net_amount, r.currency)],
      [`Umsatzsteuer ${Number(r.vat_rate)} %`, geld(r.vat_amount, r.currency)],
    ];
    summen.forEach(([k, v]) => {
      doc.setFont("helvetica", "normal"); doc.setFontSize(9.5); doc.setTextColor(...MUT);
      zeile(k, lx, sy); doc.setTextColor(...INK); zeile(v, W - M, sy, { align: "right" });
      sy += 6.5;
    });
    sy += 1;
    doc.setFillColor(252, 246, 232);
    doc.roundedRect(lx - 4, sy - 5, (W - M) - (lx - 4), 12, 1.5, 1.5, "F");
    doc.setFont("helvetica", "bold"); doc.setFontSize(11.5); doc.setTextColor(...GOLD);
    zeile("Gesamtbetrag", lx, sy + 3); zeile(geld(r.gross_amount, r.currency), W - M, sy + 3, { align: "right" });

    // Steuerhinweis + Freitext
    let hy = sy + 18;
    doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(...INK);
    if (r.vat_note) { doc.splitTextToSize(String(r.vat_note), W - 2 * M).forEach((t) => { zeile(t, M, hy); hy += 4.6; }); hy += 2; }
    if (r.free_text) {
      doc.setTextColor(...MUT);
      doc.splitTextToSize(String(r.free_text), W - 2 * M).forEach((t) => { zeile(t, M, hy); hy += 4.6; });
      hy += 2;
    }

    // Zahlung
    const zahl = r.payment_details || {};
    doc.setTextColor(...INK); doc.setFont("helvetica", "bold"); doc.setFontSize(9);
    zeile("Zahlung", M, hy + 2); hy += 7;
    doc.setFont("helvetica", "normal"); doc.setTextColor(...MUT); doc.setFontSize(9);
    if (r.payment_terms) { zeile(r.payment_terms, M, hy); hy += 4.6; }
    if (zahl.iban) { zeile("IBAN " + zahl.iban + (zahl.bic ? "  ·  BIC " + zahl.bic : ""), M, hy); hy += 4.6; }
    if (zahl.wallet) {
      if (zahl.wallet_label) { zeile("Wallet: " + zahl.wallet_label, M, hy); hy += 4.6; }
      doc.setFont("courier", "normal"); zeile(zahl.wallet, M, hy); doc.setFont("helvetica", "normal"); hy += 4.6;
    }

    // Keine Fusszeile: Aussteller steht oben im Kopf (EITH Ventures Limited, Marcel 03.11.2026).

    doc.save(`${storno ? "Storno" : "Rechnung"}_${r.invoice_no}_${String(an.company || "Partner").replace(/[^\w]+/g, "_")}.pdf`);
  }

  /* ---------- Nachdruck aus der Ablage ---------- */
  async function nachdruck(kennung) {
    try {
      const a = await rpc("get", typeof kennung === "string" ? { invoice_no: kennung } : kennung);
      await zeichnePdf(a.invoice);
      toast("Rechnung", `${a.invoice.invoice_no} erneut geladen — identisch zum Original.`);
    } catch (err) { toast("Fehler", err.message, "error"); }
  }

  /* ---------- Storno ---------- */
  async function storniere(id, grund) {
    const a = await rpc("cancel", { id: id, reason: grund || "" });
    await zeichnePdf(a.storno);
    toast("Storniert", `${a.original_no} wurde storniert — Gegenrechnung ${a.storno.invoice_no}.`);
    return a;
  }

  /* ---------- Bruecke fuer die alte Finanzansicht ----------
     Dort haengt der Wieder-Download an einem Datensatz aus
     amk_finance_documents. Steht eine Rechnungsnummer im Titel,
     wird das Original aus der Rechnungsablage geholt. */
  async function downloadRecord(rec) {
    if (!rec) return;
    // 1) Original-PDF hängt am Beleg (alle Altrechnungen seit 03.11.2026) → genau diese Datei laden.
    if (rec.file_url) return ladeDatei(rec.file_url, dateiname(rec));
    // 2) Neue Rechnung aus der Ablage → Nachdruck aus dem unveränderbaren Datensatz.
    // Präfix ist frei wählbar (invoice_prefix) — Kleinbuchstaben und Ziffern zulassen.
    const m = String(rec.title || "").match(/[A-Za-z0-9]{1,8}-\d{4}-\d{3,6}/);
    if (m) {
      try { const a = await rpc("get", { invoice_no: m[0] }); await zeichnePdf(a.invoice); return; }
      catch (_) { /* keine neue Rechnung — weiter mit der Kopie */ }
    }
    // 3) Kein Original da → Kopie aus den Daten des Belegs, als „Kopie“ markiert.
    try { await zeichnePdf(await kopieAusBeleg(rec)); toast("Rechnung", "Kopie aus den gespeicherten Daten erstellt."); }
    catch (err) { toast("Fehler", err.message, "error"); }
  }

  function dateiname(rec) {
    return (String(rec.title || "Rechnung").replace(/[^\wäöüÄÖÜß.\- ]+/g, " ").replace(/\s+/g, "_") || "Rechnung") + ".pdf";
  }

  async function ladeDatei(url, name) {
    try {
      const antwort = await fetch(url);
      if (!antwort.ok) throw new Error("HTTP " + antwort.status);
      const blob = await antwort.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob); a.download = name;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(a.href), 4000);
    } catch (_) {
      window.open(url, "_blank", "noopener");
    }
  }

  async function kopieAusBeleg(rec) {
    const notiz = String(rec.note || "");
    const nr = (notiz.match(/Nr:\s*([^·\s]+)/) || [])[1]
      || (String(rec.title || "").match(/AMK-\d{6}-\d{3}/) || [])[0] || "ohne Nr.";
    const firma = ((notiz.match(/(?:Empfänger|Firma):\s*([^·]+)/) || [])[1] || "").trim()
      || rec.partner_name || AMKZ.shared?.getPartnerName?.(rec.partner_group_id) || "";
    let profil = {};
    try { profil = (await rpc("profile_get", {})).profile || {}; } catch (_) {}
    const betrag = Number(rec.amount || 0);
    return {
      invoice_no: nr, kopie: true, issue_date: rec.document_date, service_from: null, due_date: null,
      recipient: { company: firma },
      positions: [{ description: rec.title || "Provision", quantity: 1, unit_price: betrag, net: betrag }],
      net_amount: betrag, vat_rate: 0, vat_amount: 0, gross_amount: betrag,
      currency: /\bUSD\b/.test(notiz) ? "USD" : "EUR",
      payment_details: { wallet: profil.wallet || "" },
    };
  }

  /* ---------- Stil fuer die Summenbox ---------- */
  (function stil() {
    if (document.getElementById("amkInvStil")) return;
    const s = document.createElement("style");
    s.id = "amkInvStil";
    s.textContent =
      ".amk-inv-summe{margin-top:10px;border-top:1px solid rgba(255,255,255,.10);padding-top:8px;font-size:13px}" +
      ".amk-inv-summe div{display:flex;justify-content:space-between;padding:3px 0}" +
      ".amk-inv-summe .gross{border-top:1px solid rgba(212,175,55,.35);margin-top:5px;padding-top:7px;font-size:15px;color:#f0d488}" +
      ".amk-inv-summe .gross b{font-weight:800}";
    document.head.appendChild(s);
  })();

  document.addEventListener("click", (e) => {
    if (e.target.closest("#amkzCreateInvoiceButton")) {
      e.preventDefault(); e.stopImmediatePropagation();
      oeffneGenerator().catch((err) => { console.error(err); toast("Fehler", err.message, "error"); });
    }
  }, true);

  AMKZ.invoice = {
    open: oeffneGenerator,
    zeichne: zeichnePdf,          // fuer Nachdruck-Tests und Fehlersuche
    stammdaten: oeffneStammdaten,
    downloadRecord: downloadRecord,
    nachdruck: nachdruck,
    storniere: storniere,
    rpc: rpc,
  };
})();
/* =====================================================
   AMK ZENTRALE — ENTRIES EXTRAS
   1) QR-Wallet-Scanner (Handy) -> Wallet auto-ausfüllen
      + in Zwischenablage kopieren (für Direktauszahlung)
   2) FTD-Schutz in Echtzeit:
      - gleiche Wallet-Adresse 2x  -> blockieren (nur FTD)
      - gleiche E-Mail 2x je Casino -> blockieren (nur FTD)
      Meldung sofort beim Eingeben, nicht erst beim Speichern.
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__entriesExtras) return;
  AMKZ.__entriesExtras = true;

  const byId = (id) => document.getElementById(id);
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  let blocked = false;
  let debTimer = null;

  /* ============ QR SCANNER (jsQR – dekodiert zuverlässig, auch auf iOS) ============ */
  async function ensureQrLib() {
    if (window.jsQR) return true;
    await new Promise((res) => {
      const s = document.createElement("script");
      s.src = "https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.js";
      s.onload = res; s.onerror = res; document.head.appendChild(s);
    });
    return !!window.jsQR;
  }

  function buildScannerOverlay() {
    let ov = byId("amkQrOverlay");
    if (ov) return ov;
    ov = document.createElement("div");
    ov.id = "amkQrOverlay";
    ov.className = "amk-qr-overlay";
    ov.innerHTML = `
      <div class="amk-qr-card">
        <div class="amk-qr-head">
          <strong>Wallet scannen</strong>
          <button type="button" id="amkQrClose" class="amk-qr-x" aria-label="Schließen" title="Schließen">×</button>
        </div>
        <div id="amkQrReader" class="amk-qr-reader"></div>
        <p class="amk-qr-hint">QR-Code der Wallet vor die Kamera halten…</p>
      </div>`;
    document.body.appendChild(ov);
    return ov;
  }

  async function copyToClipboard(text) {
    try { await navigator.clipboard.writeText(text); return true; }
    catch (_) {
      try { const t = document.createElement("textarea"); t.value = text; document.body.appendChild(t); t.select(); document.execCommand("copy"); t.remove(); return true; } catch (e) { return false; }
    }
  }

  let qrStream = null, qrRAF = null, qrVideo = null;
  async function startScan(targetInput) {
    if (!(await ensureQrLib())) { toast("Scanner", "QR-Bibliothek konnte nicht geladen werden.", "error"); return; }
    const ov = buildScannerOverlay();
    ov.classList.add("active");
    byId("amkQrClose").onclick = stopScan;

    const reader = byId("amkQrReader");
    reader.innerHTML = '<video playsinline muted autoplay style="width:100%;display:block;"></video>';
    qrVideo = reader.querySelector("video");
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d", { willReadFrequently: true });

    try {
      qrStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: { ideal: "environment" } }, audio: false,
      });
      qrVideo.srcObject = qrStream;
      qrVideo.setAttribute("playsinline", "true");
      await qrVideo.play();
    } catch (e) {
      console.error(e);
      toast("Kamera", "Kamerazugriff nicht möglich. Bitte Berechtigung erlauben.", "error");
      await stopScan();
      return;
    }

    // Dekodier-Schleife: Frame -> Canvas -> jsQR
    const tick = () => {
      if (!qrVideo || !qrStream) return;
      if (qrVideo.readyState >= 2 && qrVideo.videoWidth) {
        canvas.width = qrVideo.videoWidth;
        canvas.height = qrVideo.videoHeight;
        ctx.drawImage(qrVideo, 0, 0, canvas.width, canvas.height);
        let img = null;
        try { img = ctx.getImageData(0, 0, canvas.width, canvas.height); } catch (_) {}
        if (img && window.jsQR) {
          const code = window.jsQR(img.data, img.width, img.height, { inversionAttempts: "dontInvert" });
          if (code && code.data) {
            const wallet = String(code.data || "").trim().replace(/^(bitcoin|ethereum|tron|ton|litecoin):/i, "").split("?")[0];
            if (targetInput) {
              targetInput.value = wallet;
              targetInput.dispatchEvent(new Event("input", { bubbles: true }));
            }
            copyToClipboard(wallet);
            stopScan();
            toast("Wallet gescannt", "Adresse eingefügt & kopiert ✓");
            return;
          }
        }
      }
      qrRAF = requestAnimationFrame(tick);
    };
    qrRAF = requestAnimationFrame(tick);
  }

  async function stopScan() {
    try { if (qrRAF) cancelAnimationFrame(qrRAF); } catch (_) {}
    qrRAF = null;
    try { if (qrStream) qrStream.getTracks().forEach((t) => t.stop()); } catch (_) {}
    qrStream = null;
    if (qrVideo) { try { qrVideo.srcObject = null; } catch (_) {} qrVideo = null; }
    const reader = byId("amkQrReader"); if (reader) reader.innerHTML = "";
    byId("amkQrOverlay")?.classList.remove("active");
  }

  function injectScanButton() {
    const wallet = byId("amkzWalletAddress");
    if (!wallet || wallet.dataset.amkScan) return;
    wallet.dataset.amkScan = "1";
    const wrap = document.createElement("div");
    wrap.className = "amk-wallet-row";
    wallet.parentNode.insertBefore(wrap, wallet);
    wrap.appendChild(wallet);
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "amk-scan-btn";
    btn.id = "amkWalletScanBtn";
    btn.innerHTML = "📷 Scannen";
    wrap.appendChild(btn);
    btn.addEventListener("click", () => startScan(wallet));
    // Copy-Button daneben
    const cp = document.createElement("button");
    cp.type = "button"; cp.className = "amk-scan-btn ghost"; cp.innerHTML = "⧉";
    cp.title = "Wallet kopieren";
    cp.addEventListener("click", async () => { if (wallet.value.trim()) { await copyToClipboard(wallet.value.trim()); toast("Kopiert", "Wallet in Zwischenablage."); } });
    wrap.appendChild(cp);
  }

  /* ============ FTD-SCHUTZ (Echtzeit) ============ */
  let dupFound = false, override = false, lastDupKey = null;
  const escFtd = (s) => String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  const moneyFtd = (n) => { try { return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n || 0)); } catch (_) { return (n || 0) + " €"; } };

  function warnBox() {
    const form = byId("amkzEntryForm");
    let w = byId("amkFtdWarn");
    if (!w) {
      if (!form) return null;
      w = document.createElement("div");
      w.id = "amkFtdWarn";
      w.className = "amk-ftd-warn";
      const actions = form.querySelector(".amkz-modal-actions");
      form.insertBefore(w, actions || null);
    }
    if (!w.querySelector(".amk-ftd-msg")) {
      // Struktur: Meldung + „wer ist das" (klickbar) + Bestätigungs-Haken
      w.innerHTML =
        '<div class="amk-ftd-msg"></div>' +
        '<div class="amk-ftd-who" style="display:none"></div>' +
        '<label class="amk-ftd-override"><input type="checkbox" id="amkFtdOverride"><span>Ich habe das geprüft – Zahlung trotzdem ausführen</span></label>';
    }
    return w;
  }

  // who = { id, name, casino, date, amount } | null
  function renderWarn(msg, who) {
    const w = warnBox(); if (!w) return;
    const m = w.querySelector(".amk-ftd-msg");
    const wh = w.querySelector(".amk-ftd-who");
    if (m) m.textContent = msg || "";
    if (wh) {
      if (who && who.id) {
        const meta = [who.casino, who.date, who.amount != null ? moneyFtd(who.amount) : ""].filter(Boolean).join(" · ");
        wh.innerHTML = 'Bereits verwendet von <a href="#" class="amk-ftd-link" data-ftd-open="' + escFtd(who.id) + '">' +
          escFtd(who.name || "Eintrag öffnen") + '</a>' + (meta ? ' <span class="amk-ftd-meta">· ' + escFtd(meta) + '</span>' : '') +
          ' <span class="amk-ftd-hint">→ klicken, um zur Zahlung zu springen</span>';
        wh.style.display = "";
      } else { wh.innerHTML = ""; wh.style.display = "none"; }
    }
    const cb = byId("amkFtdOverride"); if (cb) cb.checked = override;
  }

  function applyBlock() {
    blocked = dupFound && !override;
    const w = byId("amkFtdWarn");
    if (w) { w.classList.toggle("active", dupFound); w.classList.toggle("confirmed", dupFound && override); }
    const submit = byId("amkzEntryForm")?.querySelector('button[type="submit"]');
    if (submit) { submit.disabled = blocked; submit.style.opacity = blocked ? ".5" : ""; submit.style.pointerEvents = blocked ? "none" : ""; }
  }

  function setDup(on, msg, who) {
    dupFound = !!on;
    const key = on && who ? String(who.id) : null;
    if (!on) { override = false; lastDupKey = null; }
    else if (key !== lastDupKey) { override = false; lastDupKey = key; } // neue Dublette -> erneut bestätigen
    renderWarn(on ? msg : "", on ? who : null);
    applyBlock();
  }
  // rückwärts-kompatibel (alte Aufrufe ohne who)
  function setBlocked(on, msg) { setDup(on, msg, null); }

  function whoFrom(e) {
    if (!e) return null;
    return { id: e.id, name: e.customer_name || e.customer_email || "Eintrag öffnen", casino: e.casino_name || "", date: e.entry_date || "", amount: e.amount != null ? e.amount : null };
  }

  async function checkFtd() {
    const typeEl = byId("amkzEntryType");
    if (!typeEl) return;
    const type = String(typeEl.value || "").toUpperCase();
    if (type !== "FTD") { setDup(false, ""); return; }
    if (!AMKZ.supabase) return;

    const wallet = (byId("amkzWalletAddress")?.value || "").trim();
    const email = (byId("amkzCustomerEmail")?.value || "").trim().toLowerCase();
    const casinoId = byId("amkzEntryCasino")?.value || "";
    const sel = "id, customer_name, customer_email, casino_id, casino_name, entry_date, amount";

    try {
      // 1) Wallet doppelt (nur FTD)
      if (wallet) {
        const { data } = await AMKZ.supabase.from("entries").select(sel).eq("entry_type", "FTD").eq("wallet_address", wallet).limit(1);
        if (data && data.length) { setDup(true, "⛔ Diese Wallet-Adresse wurde bereits für einen FTD verwendet – blockiert.", whoFrom(data[0])); return; }
      }
      // 2) E-Mail je Casino doppelt (nur FTD)
      if (email && casinoId) {
        const { data } = await AMKZ.supabase.from("entries").select(sel).eq("entry_type", "FTD").eq("casino_id", casinoId).ilike("customer_email", email).limit(1);
        if (data && data.length) { setDup(true, "⛔ Diese E-Mail wurde für dieses Casino bereits als FTD genutzt – blockiert.", whoFrom(data[0])); return; }
      }
      setDup(false, "");
    } catch (e) { console.warn("FTD-Check", e); setDup(false, ""); }
  }

  function injectFtdStyle() {
    if (byId("amk-ftd-style")) return;
    const s = document.createElement("style"); s.id = "amk-ftd-style";
    s.textContent =
      '#amkFtdWarn .amk-ftd-msg{font-weight:700}' +
      '#amkFtdWarn .amk-ftd-who{margin-top:9px;font-size:13px;font-weight:600;line-height:1.5}' +
      '#amkFtdWarn .amk-ftd-link{color:#fca5a5;font-weight:900;text-decoration:underline;text-underline-offset:2px;cursor:pointer}' +
      '#amkFtdWarn .amk-ftd-link:hover{color:#fecaca}' +
      '#amkFtdWarn.confirmed .amk-ftd-link{color:#fbbf24}' +
      '#amkFtdWarn .amk-ftd-meta{opacity:.85;font-weight:600}' +
      '#amkFtdWarn .amk-ftd-hint{display:block;margin-top:2px;font-size:11.5px;font-weight:600;opacity:.7}' +
      '#amkFtdWarn .amk-ftd-override{display:flex;align-items:center;gap:9px;margin-top:12px;padding-top:11px;border-top:1px solid rgba(255,255,255,.14);font-weight:800;font-size:13px;cursor:pointer}' +
      '#amkFtdWarn .amk-ftd-override input{width:19px;height:19px;accent-color:#f59e0b;cursor:pointer;flex:none}' +
      '#amkFtdWarn.confirmed{background:rgba(245,158,11,.14)!important;border-color:rgba(245,158,11,.55)!important;color:#fbbf24!important}' +
      /* Peek-Overlay (über dem Formular) */
      '.amk-peek{position:fixed;inset:0;z-index:100000;display:none;align-items:flex-start;justify-content:center;padding:6vh 16px 16px;background:rgba(4,4,8,.68);backdrop-filter:blur(6px);overflow:auto}' +
      '.amk-peek.active{display:flex}' +
      '.amk-peek-card{width:min(640px,100%);background:linear-gradient(180deg,rgba(255,255,255,.03),rgba(255,255,255,0) 40%),#141118;border:1px solid rgba(212,175,55,.25);border-radius:22px;padding:22px 22px 20px;box-shadow:0 40px 100px -30px rgba(0,0,0,.9);animation:amkPeekIn .22s ease}' +
      '@keyframes amkPeekIn{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}' +
      '.amk-peek-head{display:flex;align-items:flex-start;justify-content:space-between;gap:14px;margin-bottom:16px}' +
      '.amk-peek-head h3{margin:0;font-size:1.2rem;font-weight:800;color:#f0e6cf}' +
      '.amk-peek-head p{margin:4px 0 0;font-size:.82rem;color:#9c968a;font-weight:600}' +
      '.amk-peek-x{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);color:#f0e6cf;width:38px;height:38px;border-radius:50%;font-size:1.2rem;cursor:pointer;flex:none;line-height:1}' +
      '.amk-peek-x:hover{background:rgba(255,255,255,.12)}' +
      '.amk-peek-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:18px}' +
      '.amk-peek-kv{background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.07);border-radius:13px;padding:11px 14px}' +
      '.amk-peek-kv span{display:block;font-size:.66rem;font-weight:800;letter-spacing:.09em;text-transform:uppercase;color:#8b867b;margin-bottom:4px}' +
      '.amk-peek-kv b{font-size:.98rem;color:#f2ecdd;font-weight:700;word-break:break-word}' +
      '.amk-peek-wide{grid-column:1/-1}.amk-peek-mono{font-family:ui-monospace,Menlo,monospace;font-size:.82rem!important;letter-spacing:-.01em}' +
      '.amk-peek-back{width:100%;padding:14px;border-radius:14px;border:none;cursor:pointer;font-weight:800;font-size:.98rem;color:#1a1206;background:linear-gradient(135deg,#f0d38a,#c79b3b);box-shadow:0 12px 28px -12px rgba(212,175,55,.65)}' +
      '.amk-peek-back:hover{filter:brightness(1.06)}' +
      '.amk-peek-empty,.amk-peek-loading{padding:24px;text-align:center;color:#9c968a;font-weight:600}' +
      '@media(max-width:560px){.amk-peek-grid{grid-template-columns:1fr}.amk-peek{padding:3vh 10px 10px}.amk-peek-card{padding:18px 16px 16px}}';
    document.head.appendChild(s);
  }

  function wireForm() {
    const form = byId("amkzEntryForm");
    if (!form || form.dataset.amkFtd) return;
    form.dataset.amkFtd = "1";
    injectFtdStyle();
    injectScanButton();
    setBlocked(false, "");
    ["amkzWalletAddress", "amkzCustomerEmail", "amkzEntryCasino", "amkzEntryType"].forEach((id) => {
      const el = byId(id);
      if (!el) return;
      const run = () => { clearTimeout(debTimer); debTimer = setTimeout(checkFtd, 250); };
      el.addEventListener("input", run);
      el.addEventListener("change", run);
    });
  }

  // Submit hart blockieren, falls FTD-Block aktiv (Capture, vor dem Save-Handler)
  document.addEventListener("submit", (e) => {
    if (e.target?.id === "amkzEntryForm" && blocked) {
      e.preventDefault(); e.stopImmediatePropagation();
      toast("Blockiert", "Bitte den Haken 'Zahlung trotzdem ausführen' setzen, um die Dublette zu bestätigen.", "error");
    }
  }, true);

  // Klick auf den Namen -> Peek-Overlay ÜBER dem Formular (Formular + Warnung bleiben erhalten)
  document.addEventListener("click", (e) => {
    const a = e.target.closest?.("[data-ftd-open]");
    if (a) { e.preventDefault(); openWalletPeek(a.getAttribute("data-ftd-open")); return; }
    const pc = e.target.closest?.("[data-peek-close]");
    if (pc) { e.preventDefault(); closeWalletPeek(); return; }
  });

  async function openWalletPeek(id) {
    if (!id || !AMKZ.supabase) return;
    let ov = byId("amkWalletPeek");
    if (!ov) {
      ov = document.createElement("div"); ov.id = "amkWalletPeek"; ov.className = "amk-peek";
      ov.addEventListener("click", (ev) => { if (ev.target === ov) closeWalletPeek(); });
      document.body.appendChild(ov);
    }
    ov.innerHTML = `<div class="amk-peek-card"><div class="amk-peek-loading">Lädt …</div></div>`;
    ov.classList.add("active");
    let e = null;
    try { const { data } = await AMKZ.supabase.from("entries").select("*").eq("id", id).maybeSingle(); e = data; } catch (_) {}
    if (!byId("amkWalletPeek")) return;
    const row = (l, v) => v ? `<div class="amk-peek-kv"><span>${escFtd(l)}</span><b>${escFtd(v)}</b></div>` : "";
    const body = !e ? `<div class="amk-peek-empty">Eintrag nicht gefunden.</div>` : `
      <div class="amk-peek-grid">
        ${row("Datum", e.entry_date)}${row("Typ", e.entry_type)}
        ${row("Betrag", moneyFtd(e.amount || 0))}${row("Status", e.payment_status || e.status)}
        ${row("Partner", e.partner_name)}${row("Casino", e.casino_name)}
        ${row("Kundenname", e.customer_name)}${row("Kunden E-Mail", e.customer_email)}
        ${e.wallet_address ? `<div class="amk-peek-kv amk-peek-wide"><span>Wallet</span><b class="amk-peek-mono">${escFtd(e.wallet_address)}</b></div>` : ""}
        ${row("Erstellt von", e.created_by_name || e.created_by)}${row("Erstellt am", (e.created_at || "").slice(0, 16).replace("T", " "))}
      </div>`;
    ov.innerHTML = `
      <div class="amk-peek-card">
        <div class="amk-peek-head">
          <div><h3>Bestehende Zahlung</h3><p>${escFtd((e && e.entry_type) || "FTD")} · ${escFtd((e && e.entry_date) || "")}</p></div>
          <button type="button" class="amk-peek-x" data-peek-close aria-label="Schließen">×</button>
        </div>
        ${body}
        <button type="button" class="amk-peek-back" data-peek-close>← Zurück zur Eintragung</button>
      </div>`;
  }
  function closeWalletPeek() { const ov = byId("amkWalletPeek"); if (ov) ov.classList.remove("active"); }

  // Bestätigungs-Haken -> Zahlung trotz Warnung erlauben (z. B. wenn das Casino-Block-Fenster sehr klein ist)
  document.addEventListener("change", (e) => {
    if (e.target?.id === "amkFtdOverride") { override = !!e.target.checked; applyBlock(); }
  });

  // Modal-Öffnen erkennen
  const mo = new MutationObserver(() => { if (byId("amkzEntryForm")) wireForm(); });
  const root = byId("amkzModalOverlay") || document.body;
  mo.observe(root, { childList: true, subtree: true });

  AMKZ.entriesExtras = { startScan, checkFtd };
})();
/* =====================================================
   AMK ZENTRALE — INLINE EDIT
   - Partner per Klick bearbeiten (Tippfehler etc.)
   - Casino per Klick bearbeiten
   - Rechnung: Name/Partner/Datum/Betrag bearbeiten
   - Rechnungs-Status per Klick: offen -> versendet -> bezahlt
   Kanonische Werte (SQL-sauber):
     Invoice-Status: open | sent | paid
     Partner/Casino-Status: active | paused | inactive
   IDs bleiben unverändert -> Joins/Berechnungen konsistent.
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__editModule) return;
  AMKZ.__editModule = true;

  const byId = (id) => document.getElementById(id);
  const val = (id) => byId(id)?.value ?? "";
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? ""));
  const money = (AMKZ.utils && AMKZ.utils.money) || ((n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n || 0)));
  const num = (v) => { const n = Number(String(v).replace(",", ".").replace(/[^\d.-]/g, "")); return Number.isFinite(n) ? n : 0; };
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const opt = AMKZ.shared?.optionList || ((rows, ph, sel) => `<option value="">${esc(ph)}</option>` + (rows || []).map((r) => `<option value="${esc(r.id)}" ${String(r.id) === String(sel) ? "selected" : ""}>${esc(r.name || r.id)}</option>`).join(""));
  const findById = (arr, id) => (arr || []).find((r) => String(r.id) === String(id)) || null;

  async function updateRow(tables, id, payload) {
    for (const t of tables) {
      try {
        const { error } = await AMKZ.supabase.from(t).update(payload).eq("id", id);
        if (!error) return true;
      } catch (_) {}
    }
    return false;
  }
  async function reloadView() {
    try { await AMKZ.data?.loadBaseData?.(true); } catch (_) {}
    try { await AMKZ.loadView(AMKZ.state.currentView, { force: true }); } catch (_) {}
  }

  /* ============ PARTNER EDIT ============ */
  function openPartnerEdit(id) {
    const p = findById(AMKZ.state.partners, id);
    if (!p) return;
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header"><div><h3>Partner bearbeiten</h3><p>${esc(p.name || "")}</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <form id="amkPartnerEditForm" class="amkz-form-grid">
          <div class="amkz-input-group"><label>Name</label><input id="peName" value="${esc(p.name || "")}" required></div>
          <div class="amkz-input-group"><label>Status</label>
            <select id="peStatus">
              <option value="active" ${p.status === "active" ? "selected" : ""}>Aktiv</option>
              <option value="paused" ${p.status === "paused" ? "selected" : ""}>Pausiert</option>
              <option value="inactive" ${p.status === "inactive" ? "selected" : ""}>Inaktiv</option>
            </select>
          </div>
          <div class="amkz-input-group"><label>Notiz</label><textarea id="peNote">${esc(p.note || "")}</textarea></div>
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>`);
    byId("amkPartnerEditForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const ok = await updateRow(["partner_groups"], id, { name: val("peName").trim(), status: val("peStatus"), note: val("peNote"), updated_at: new Date().toISOString() });
      if (!ok) return toast("Fehler", "Partner konnte nicht gespeichert werden (RLS?).", "error");
      AMKZ.modal.close(); toast("Gespeichert", "Partner aktualisiert."); reloadView();
    });
  }

  /* ============ CASINO EDIT ============ */
  function openCasinoEdit(id) {
    const c = findById(AMKZ.state.casinos, id);
    if (!c) return;
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header"><div><h3>Casino bearbeiten</h3><p>${esc(c.name || "")}</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <form id="amkCasinoEditForm" class="amkz-form-grid">
          <div class="amkz-input-group"><label>Casino-Name</label><input id="ceName" value="${esc(c.name || "")}" required></div>
          <div class="amkz-input-group"><label>Partnergruppe</label><select id="cePartner">${opt(AMKZ.state.partners, "Kein Partner", c.partner_group_id)}</select></div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Status</label>
              <select id="ceStatus">
                <option value="active" ${c.status === "active" ? "selected" : ""}>Aktiv</option>
                <option value="paused" ${c.status === "paused" ? "selected" : ""}>Pausiert</option>
                <option value="inactive" ${c.status === "inactive" ? "selected" : ""}>Inaktiv</option>
              </select>
            </div>
            <div class="amkz-input-group"><label>Deal-Basis</label>
              <select id="ceDeal">
                ${["revshare", "cpa", "hybrid", "fixed"].map((d) => `<option value="${d}" ${(c.deal_type || "") === d ? "selected" : ""}>${d}</option>`).join("")}
              </select>
            </div>
          </div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>RevShare %</label><input id="ceRev" type="number" step="0.01" value="${num(c.revshare_percent)}"></div>
            <div class="amkz-input-group"><label>CPA-Betrag</label><input id="ceCpa" type="number" step="0.01" value="${num(c.cpa_amount)}"></div>
          </div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Baseline-Betrag (€)</label><input id="ceBase" type="number" step="0.01" value="${num(c.baseline_amount)}" placeholder="z. B. 30000"></div>
            <div class="amkz-input-group"><label>Baseline FTDs</label><input id="ceBaseFtds" type="number" step="1" value="${num(c.baseline_ftds)}" placeholder="z. B. 120"></div>
          </div>
          <p class="amkz-form-hint">Hybrid: Pauschale für die ersten X FTDs – jede weitere FTD = CPA + RevShare. Sonst beide auf 0.</p>
          <div class="amkz-input-group"><label>Notiz</label><textarea id="ceNote">${esc(c.note || "")}</textarea></div>
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>`);
    byId("amkCasinoEditForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const ok = await updateRow(["casinos"], id, {
        name: val("ceName").trim(), partner_group_id: val("cePartner") || null, status: val("ceStatus"),
        deal_type: val("ceDeal"), revshare_percent: num(val("ceRev")), cpa_amount: num(val("ceCpa")),
        baseline_amount: num(val("ceBase")), baseline_ftds: Math.round(num(val("ceBaseFtds"))),
        note: val("ceNote"), updated_at: new Date().toISOString(),
      });
      if (!ok) return toast("Fehler", "Casino konnte nicht gespeichert werden (RLS?).", "error");
      AMKZ.modal.close(); toast("Gespeichert", "Casino aktualisiert."); reloadView();
    });
  }

  /* ============ INVOICE EDIT ============ */
  const INV_TABLES = ["amk_finance_documents", "finance_documents"];
  const STATUS_LABEL = { open: "Offen", sent: "Versendet", paid: "Bezahlt" };
  const STATUS_NEXT = { open: "sent", sent: "paid", paid: "open" };

  function canonStatus(s) {
    s = String(s || "open").toLowerCase();
    if (["paid", "bezahlt", "received", "completed"].includes(s)) return "paid";
    if (["sent", "versendet", "gestellt"].includes(s)) return "sent";
    return "open";
  }

  async function setInvoiceStatus(id, status) {
    const ok = await updateRow(INV_TABLES, id, { status, updated_at: new Date().toISOString() });
    if (!ok) {
      try { await AMKZ.supabase.rpc("amk_update_invoice_status", { p_invoice_id: id, p_status: status }); return true; } catch (_) {}
    }
    return ok;
  }

  function openInvoiceEdit(id) {
    const inv = findById(AMKZ.state.invoices, id);
    if (!inv) return;
    const st = canonStatus(inv.status);
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header"><div><h3>Rechnung bearbeiten</h3><p>${esc(inv.title || "")}</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <form id="amkInvEditForm" class="amkz-form-grid">
          <div class="amkz-input-group"><label>Rechnungsname</label><input id="ieTitle" value="${esc(inv.title || "")}" required></div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Partner</label><select id="iePartner">${opt(AMKZ.state.partners, "Kein Partner", inv.partner_group_id)}</select></div>
            <div class="amkz-input-group"><label>Datum</label><input id="ieDate" type="date" value="${esc((inv.document_date || "").slice(0, 10))}"></div>
          </div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Betrag (€)</label><input id="ieAmount" type="number" step="0.01" value="${num(inv.amount)}"></div>
            <div class="amkz-input-group"><label>Status</label>
              <select id="ieStatus">
                <option value="open" ${st === "open" ? "selected" : ""}>Offen</option>
                <option value="sent" ${st === "sent" ? "selected" : ""}>Versendet</option>
                <option value="paid" ${st === "paid" ? "selected" : ""}>Bezahlt</option>
              </select>
            </div>
          </div>
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>`);
    byId("amkInvEditForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const ok = await updateRow(INV_TABLES, id, {
        title: val("ieTitle").trim(), partner_group_id: val("iePartner") || null,
        document_date: val("ieDate") || null, amount: num(val("ieAmount")), status: val("ieStatus"),
        updated_at: new Date().toISOString(),
      });
      if (!ok) return toast("Fehler", "Rechnung konnte nicht gespeichert werden (RLS?).", "error");
      AMKZ.modal.close(); toast("Gespeichert", "Rechnung aktualisiert."); reloadView();
    });
  }

  /* ============ RE-RENDER mit Edit-Affordances ============ */
  function enhancePartners() {
    const box = byId("amkzPartnersList");
    if (!box || !(AMKZ.state.partners || []).length) return;
    box.innerHTML = AMKZ.state.partners.map((p) => `
      <div class="amkz-table-row-card amk-editable" data-partner-id="${esc(p.id)}" title="Zum Bearbeiten klicken">
        <div class="amk-edit-pencil">✎</div>
        <strong>${esc(p.name || "Partner")}</strong><br>
        <small>Status: ${esc(p.status || "active")}</small>
        ${p.note ? `<p>${esc(p.note)}</p>` : ""}
      </div>`).join("");
  }
  function enhanceCasinos() {
    const body = byId("amkzCasinosTableBody");
    if (!body || !(AMKZ.state.casinos || []).length) return;
    const pn = (id) => AMKZ.shared?.getPartnerName?.(id) || "—";
    body.innerHTML = AMKZ.state.casinos.map((c) => `
      <tr class="amk-editable" data-casino-id="${esc(c.id)}" title="Zum Bearbeiten klicken">
        <td><span class="amk-edit-pencil">✎</span> ${esc(c.name || "Casino")}</td>
        <td>${esc(pn(c.partner_group_id))}</td>
        <td>${esc(c.deal_type || "—")}</td>
        <td>${money(c.cpa_amount || 0)}</td>
        <td>${Number(c.revshare_percent || 0)}%</td>
        <td>${esc(c.status || "active")}</td>
      </tr>`).join("");
  }
  function enhanceInvoices() {
    const body = byId("amkzInvoicesTableBody");
    if (!body) return;
    const all = AMKZ.state.invoices || [];
    // Default-Ansicht = laufender Monat (Umschalten über den Finance-Monatsumschalter)
    if (AMKZ.state.financeMonth === undefined) {
      const d = new Date(); AMKZ.state.financeMonth = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0");
    }
    const month = AMKZ.state.financeMonth;
    const list = (month && month !== "all")
      ? all.filter((inv) => String(inv.document_date || "").slice(0, 7) === month)
      : all;
    const pn = (inv) => inv.partner_name || AMKZ.shared?.getPartnerName?.(inv.partner_group_id) || "—";
    if (!list.length) {
      body.innerHTML = `<tr><td colspan="7"><div class="amkz-empty">${all.length ? "Keine Rechnungen in diesem Zeitraum." : "Noch keine Rechnungen."}</div></td></tr>`;
      return;
    }
    body.innerHTML = list.map((inv) => {
      const st = canonStatus(inv.status);
      return `<tr data-invoice-id="${esc(inv.id)}">
        <td class="amk-num">${esc((inv.document_date || "—"))}</td>
        <td>${esc(inv.title || "Rechnung")}</td>
        <td>${esc(pn(inv))}</td>
        <td>${esc(inv.casino_name || "—")}</td>
        <td class="amk-num">${money(inv.amount || 0)}</td>
        <td><button type="button" class="amk-inv-status amk-st-${st}" data-inv-status="${esc(inv.id)}" data-cur="${st}">${STATUS_LABEL[st]}</button></td>
        <td><div class="amk-row-actions"><button type="button" class="amk-row-pdf" data-inv-pdf="${esc(inv.id)}">⬇︎ PDF</button><button type="button" class="amk-row-edit" data-inv-edit="${esc(inv.id)}">Bearbeiten</button></div></td>
      </tr>`;
    }).join("");
  }

  function enhanceAll() {
    const v = AMKZ.state.currentView;
    if (v === "partners") enhancePartners();
    if (v === "casinos") enhanceCasinos();
    if (v === "finance") enhanceInvoices();
  }

  const prevLoadView = AMKZ.loadView;
  AMKZ.loadView = async function editChainLoadView(view, options) {
    const r = await prevLoadView?.call(this, view, options);
    setTimeout(enhanceAll, 500);
    return r;
  };
  // Falls Finance-Tab später geklickt wird
  document.addEventListener("click", (e) => {
    if (e.target.closest('.amkz-finance-tab[data-finance-tab="invoices"]')) setTimeout(enhanceInvoices, 350);
  });

  /* ============ KLICK-HANDLER ============ */
  document.addEventListener("click", async (e) => {
    // Status-Zyklus
    const st = e.target.closest("[data-inv-status]");
    if (st) {
      e.preventDefault(); e.stopPropagation();
      const id = st.getAttribute("data-inv-status");
      const next = STATUS_NEXT[canonStatus(st.dataset.cur)] || "sent";
      st.textContent = "…";
      const ok = await setInvoiceStatus(id, next);
      if (!ok) { toast("Fehler", "Status nicht speicherbar (RLS?).", "error"); enhanceInvoices(); return; }
      const inv = findById(AMKZ.state.invoices, id); if (inv) inv.status = next;
      st.dataset.cur = next; st.textContent = STATUS_LABEL[next];
      st.className = "amk-inv-status amk-st-" + next;
      toast("Status", "Rechnung: " + STATUS_LABEL[next]);
      return;
    }
    // Rechnung bearbeiten
    const pdf = e.target.closest("[data-inv-pdf]");
    if (pdf) {
      e.preventDefault(); e.stopPropagation();
      const rec = findById(AMKZ.state.invoices, pdf.getAttribute("data-inv-pdf"));
      if (rec && AMKZ.invoice?.downloadRecord) AMKZ.invoice.downloadRecord(rec);
      else toast("PDF", "Rechnungsdaten nicht gefunden.", "error");
      return;
    }
    const ie = e.target.closest("[data-inv-edit]");
    if (ie) { e.preventDefault(); e.stopPropagation(); openInvoiceEdit(ie.getAttribute("data-inv-edit")); return; }
    // Partner bearbeiten
    const pc = e.target.closest("[data-partner-id]");
    if (pc) { openPartnerEdit(pc.getAttribute("data-partner-id")); return; }
    // Casino bearbeiten
    const cc = e.target.closest("[data-casino-id]");
    if (cc) { openCasinoEdit(cc.getAttribute("data-casino-id")); return; }
  });

  AMKZ.edit = { openPartnerEdit, openCasinoEdit, openInvoiceEdit, setInvoiceStatus, enhanceAll };
})();
/* =====================================================
   AMK ZENTRALE — CALL UI EXTRAS (WhatsApp-Feeling)
   - Ringback beim Anrufer ("tut tut") bis angenommen
   - (Gegenüber klingelt weiter über die vorhandene Klingel)
   - Minimieren-Button (Anruf läuft weiter, Popup klein)
   - Audio-Call: Videobereich aus, kompakte Leiste
   - Live-Gesprächstimer
   Greift NICHT in die Signaling/WebRTC-Logik ein.
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__callUiExtras) return;
  AMKZ.__callUiExtras = true;

  const byId = (id) => document.getElementById(id);
  let rbCtx = null, rbTimer = null, timerInt = null, startTs = 0;

  /* ---------- Ringback (Web Audio) ---------- */
  function startRingback() {
    if (rbTimer) return;
    try {
      rbCtx = new (window.AudioContext || window.webkitAudioContext)();
      const beep = (offset) => {
        if (!rbCtx) return;
        const o = rbCtx.createOscillator(), g = rbCtx.createGain();
        o.type = "sine"; o.frequency.value = 425;
        o.connect(g); g.connect(rbCtx.destination);
        const t = rbCtx.currentTime + offset;
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(0.16, t + 0.04);
        g.gain.setValueAtTime(0.16, t + 0.22);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.28);
        o.start(t); o.stop(t + 0.3);
      };
      const cycle = () => { beep(0); beep(0.45); }; // "tut tut"
      cycle();
      rbTimer = setInterval(cycle, 2200);
    } catch (_) {}
  }
  function stopRingback() {
    clearInterval(rbTimer); rbTimer = null;
    if (rbCtx) { try { rbCtx.close(); } catch (_) {} rbCtx = null; }
  }

  /* ---------- Timer ---------- */
  function startTimer() {
    if (timerInt) return;
    startTs = Date.now();
    timerInt = setInterval(() => {
      const s = Math.floor((Date.now() - startTs) / 1000);
      const el = byId("amkCallTimer");
      if (el) el.textContent = " · " + String(Math.floor(s / 60)).padStart(2, "0") + ":" + String(s % 60).padStart(2, "0");
    }, 1000);
  }
  function stopTimer() { clearInterval(timerInt); timerInt = null; const el = byId("amkCallTimer"); if (el) el.textContent = ""; }

  /* ---------- Minimize-Button + Timer-Slot sicherstellen ---------- */
  function ensureExtras() {
    const head = document.querySelector("#amkCallScreenFinal .amk-call-head-final");
    if (head && !byId("amkCallMin")) {
      const b = document.createElement("button");
      b.id = "amkCallMin"; b.type = "button"; b.className = "amk-call-btn-final";
      b.textContent = "—"; b.title = "Minimieren";
      head.appendChild(b);
      b.addEventListener("click", () => byId("amkCallScreenFinal")?.classList.toggle("amk-call-min"));
    }
    const inner = document.querySelector("#amkCallScreenFinal .amk-call-head-final > div");
    if (inner && !byId("amkCallTimer")) {
      const t = document.createElement("small"); t.id = "amkCallTimer"; t.className = "amk-call-timer";
      inner.appendChild(t);
    }
  }

  /* ---------- Status beobachten ---------- */
  function watch() {
    const screen = byId("amkCallScreenFinal");
    if (!screen) return;
    ensureExtras();
    const active = screen.classList.contains("active");
    const status = (byId("amkCallStatusFinal")?.textContent || "").toLowerCase();
    const parts = (byId("amkCallParticipantsFinal")?.textContent || "").toLowerCase();
    const connected = /verbunden|connected/.test(status);

    // Audio-only Layout
    screen.classList.toggle("amk-audio-only", /audio/.test(parts) && !/video/.test(parts));

    if (!active) { stopRingback(); stopTimer(); screen.classList.remove("amk-call-min"); return; }
    if (connected) { stopRingback(); startTimer(); }
    // "Ruft an…" zeigt NUR der Anrufer -> eindeutig sein Ringback ("tut tut")
    else if (/ruft an|ruft|calling/.test(status)) { startRingback(); }
    else { stopRingback(); }
  }
  setInterval(watch, 500);

  AMKZ.callUiExtras = { startRingback, stopRingback };
})();

/* =====================================================
   AMK ZENTRALE — PATCH: Team entfernen · Kalender Urlaub
   + Benachrichtigung bei Kalender-Eintrag (assigned)
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__teamCalPatch) return;
  AMKZ.__teamCalPatch = true;

  const byId = (id) => document.getElementById(id);
  const val = (id) => byId(id)?.value?.trim() || "";
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? ""));
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const me = () => AMKZ.state?.member || null;

  /* ---------- Benachrichtigung bei Kalender-Zuordnung ---------- */
  async function notifyUser(targetId, title, message, payload) {
    if (!targetId || targetId === me()?.id) return;
    try {
      await AMKZ.supabase.from("notifications").insert({
        target_user_id: targetId, type: "calendar", title, message,
        is_read: false, created_at: new Date().toISOString(), payload: Object.assign({ from: me()?.id || null, push: "false" }, payload || {}),
      });
    } catch (_) {}
    try { window.AMK_SEND_PUSH?.(targetId, title, message, { from: me()?.id || null }); } catch (_) {}   // Push bisher vergessen (11.09.)
  }
  if (AMKZ.save && AMKZ.save.saveCalendarEvent && !AMKZ.save.__wrappedNotify) {
    const orig = AMKZ.save.saveCalendarEvent;
    AMKZ.save.saveCalendarEvent = async function (payload = {}) {
      const res = await orig(payload);
      try {
        const targets = []
          .concat(payload.assignedTo || [])
          .concat(payload.participants || payload.participantIds || []);
        const seen = {};
        for (const t of targets) {
          if (!t || seen[t]) continue; seen[t] = 1;
          await notifyUser(t, "Kalender-Eintrag",
            `${me()?.name || "Jemand"} hat dich bei "${payload.title || "Termin"}" am ${payload.eventDate || ""} eingetragen.`,
            { event: payload.title, date: payload.eventDate });
        }
      } catch (_) {}
      return res;
    };
    AMKZ.save.__wrappedNotify = true;
  }

  /* ---------- Team: Mitarbeiter entfernen ---------- */
  function injectTeamRemove() {
    document.querySelectorAll(".amkz-team-row-final").forEach((row) => {
      if (row.querySelector(".amk-team-remove")) return;
      const save = row.querySelector(".amkz-save-rights-final");
      if (!save) return;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "amk-team-remove";
      btn.dataset.removeTeam = row.dataset.teamId || "";
      btn.textContent = "Entfernen";
      save.insertAdjacentElement("afterend", btn);
    });
  }
  async function removeTeamMember(id, name) {
    if (!id) return;
    if (!confirm(`Mitarbeiter "${name || ""}" wirklich entfernen?`)) return;
    try {
      const r = await AMKZ.teamApi("entfernen", { id });   // Server löscht, bei Bezügen nur deaktivieren
      toast("Team", r.geloescht ? "Mitarbeiter entfernt." : "Mitarbeiter deaktiviert.");
      AMKZ.modules?.team?.loadTeamView?.();
    } catch (err) { toast("Fehler", err.message, "error"); }
  }

  /* ---------- Kalender: Urlaub beantragen ---------- */
  function injectVacationButton() {
    const header = byId("amkzCreateCalendarButton")?.parentElement;
    if (!header || byId("amkzVacationBtn")) return;
    const b = document.createElement("button");
    b.id = "amkzVacationBtn";
    b.type = "button";
    b.className = "amkz-secondary-btn";
    b.textContent = "🏖 Urlaub beantragen";
    byId("amkzCreateCalendarButton").insertAdjacentElement("beforebegin", b);
  }
  // Genehmiger auflösen: Mateo, Alex & Nouri (per E-Mail/Name/Rolle), Fallback = Manager/Admins
  async function resolveApprovers() {
    let team = [];
    try { team = (await AMKZ.data?.loadTeam?.(true)) || []; } catch (_) {}
    if (!team.length) { try { const { data } = await AMKZ.supabase.from("team_members").select("id,name,email,role"); team = data || []; } catch (_) {} }
    const low = (v) => String(v || "").toLowerCase();
    const wanted = [
      { key: "Mateo", email: "mateo@amk.com", names: ["mateo"], roles: [] },
      { key: "Alex",  email: null,            names: ["alex"],  roles: ["manager"] },
      { key: "Nouri", email: null,            names: ["nouri"], roles: ["owner", "ceo", "admin", "admin_owner"] },
    ];
    const picked = [];
    wanted.forEach((w) => {
      let m = null;
      if (w.email) m = team.find((t) => low(t.email) === w.email);
      if (!m) m = team.find((t) => w.names.some((n) => low(t.name).includes(n)));
      if (!m && w.roles.length) m = team.find((t) => w.roles.includes(low(t.role)) && !picked.some((p) => p.id === t.id));
      if (m && !picked.some((p) => p.id === m.id)) picked.push({ id: m.id, name: m.name || m.email || w.key });
    });
    if (!picked.length) {
      team.filter((t) => ["admin", "manager", "owner", "ceo", "management", "admin_owner"].includes(low(t.role)))
        .forEach((t) => { if (!picked.some((p) => p.id === t.id)) picked.push({ id: t.id, name: t.name || t.email }); });
    }
    return picked;
  }
  // DM + Mitteilung (Glocke) + Push an einen Genehmiger
  async function notifyApproverFull(userId, title, text) {
    const myId = me()?.id;
    if (!userId || userId === myId || !AMKZ.supabase) return;
    try {
      const { data: conv } = await AMKZ.supabase.rpc("amk_get_or_create_conversation", { p_user_a: myId, p_user_b: userId });
      const convId = conv?.id || (Array.isArray(conv) ? conv[0]?.id : null);
      if (convId) await AMKZ.supabase.rpc("amk_send_message", { p_conversation_id: convId, p_sender_id: myId, p_receiver_id: userId, p_message: text, p_client_temp_id: `vac_${Date.now()}_${Math.random().toString(36).slice(2)}` });
    } catch (_) {}
    try { await AMKZ.supabase.from("notifications").insert({ target_user_id: userId, created_for: userId, type: "calendar", title, message: text, is_read: false, created_at: new Date().toISOString(), payload: { from: myId, push: "false" } }); } catch (_) {}
    try { window.AMK_SEND_PUSH?.(userId, title, text, { from: myId }); } catch (_) {}
  }
  async function findVacationEventId(title) {
    const myId = me()?.id;
    try {
      const { data } = await AMKZ.supabase.from("planning_calendar").select("id,created_at")
        .eq("created_by", myId).eq("title", title).order("created_at", { ascending: false }).limit(1);
      return data && data[0] ? data[0].id : null;
    } catch (_) { return null; }
  }
  async function openVacationModal() {
    const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10) /* Nachtschicht 31.10.: Ortszeit statt UTC */;
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header"><div><h3>Urlaub beantragen</h3><p>Antrag geht an Mateo, Alex & Nouri — erst wenn ALLE genehmigen, erscheint der Urlaub im Kalender.</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <form id="amkVacForm" class="amkz-form-grid">
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Von</label><input id="vacFrom" type="date" value="${today}" required></div>
            <div class="amkz-input-group"><label>Bis</label><input id="vacTo" type="date" value="${today}" required></div>
          </div>
          <div class="amkz-input-group"><label>Grund / Notiz</label><textarea id="vacNote" placeholder="z. B. Familienurlaub"></textarea></div>
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Antrag senden</button>
          </div>
        </form>
      </div>`);
    byId("amkVacForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const from = val("vacFrom"), to = val("vacTo"), note = val("vacNote");
      if (!from || !to) return;
      if (to < from) { toast("Urlaub", 'Bis darf nicht vor Von liegen.', "error"); return; }
      const submitBtn = e.submitter; if (submitBtn) submitBtn.disabled = true;
      const meName = me()?.name || me()?.email || "Mitarbeiter";
      const title = `Urlaub: ${meName}`;
      try {
        const res = await AMKZ.save.saveCalendarEvent({
          title,
          description: `Urlaubsantrag ${from} bis ${to}${note ? " · " + note : ""}`,
          eventDate: from, endDate: to, startTime: "00:00", endTime: "23:59",
          assignedTo: me()?.id || null, eventType: "urlaub", status: "beantragt",
        });
        let eventId = res?.id || (Array.isArray(res) ? res[0]?.id : null) || (typeof res === "string" ? res : null);
        if (!eventId) eventId = await findVacationEventId(title);

        const approvers = (await resolveApprovers()).filter((a) => a.id && a.id !== me()?.id);
        if (eventId && approvers.length) {
          try {
            await AMKZ.supabase.from("calendar_event_invites").insert(
              approvers.map((a) => ({ event_id: eventId, user_id: a.id, inviter_id: me()?.id, title, status: "pending" }))
            );
          } catch (err) { console.warn("[urlaub] Genehmiger-Zeilen", err); }
          for (const a of approvers) {
            await notifyApproverFull(a.id, "🏖 Urlaubsantrag",
              `🏖 ${meName} beantragt Urlaub ${from} – ${to}${note ? " · " + note : ""}. [[VAC:${eventId}]]`);
          }
        }
        AMKZ.modal.close();
        toast("Urlaub", approvers.length
          ? `Antrag an ${approvers.map((a) => a.name).join(", ")} gesendet. Erscheint im Kalender, sobald alle genehmigt haben.`
          : "Antrag gespeichert (keine Genehmiger gefunden — bitte Team prüfen).");
        AMKZ.modules?.calendar?.loadCalendarView?.();
      } catch (err) { console.error(err); toast("Fehler", err.message, "error"); if (submitBtn) submitBtn.disabled = false; }
    });
  }

  /* ---------- Klick-Handler ---------- */
  document.addEventListener("click", (e) => {
    const rm = e.target.closest("[data-remove-team]");
    if (rm) {
      e.preventDefault(); e.stopPropagation();
      const row = rm.closest(".amkz-team-row-final");
      const name = row?.querySelector(".amkz-team-user-final strong")?.textContent || "";
      removeTeamMember(rm.getAttribute("data-remove-team"), name);
      return;
    }
    if (e.target.closest("#amkzVacationBtn")) { e.preventDefault(); openVacationModal(); return; }
  });

  /* ---------- View-Chain: Buttons einspeisen ---------- */
  const prev = AMKZ.loadView;
  AMKZ.loadView = async function teamCalChain(view, options) {
    const r = await prev?.call(this, view, options);
    if (view === "team") setTimeout(injectTeamRemove, 500);
    if (view === "calendar") setTimeout(injectVacationButton, 400);
    return r;
  };
  setTimeout(() => { injectTeamRemove(); injectVacationButton(); }, 1500);

  AMKZ.teamCal = { removeTeamMember, openVacationModal };
})();

/* =====================================================
   AMK ZENTRALE — UI EXTRAS v2
   Lautsprecher-Toggle (Call) · Mobiler Vollbild-Chat
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__uiExtras2) return;
  AMKZ.__uiExtras2 = true;

  const byId = (id) => document.getElementById(id);
  const isMobile = () => window.matchMedia("(max-width: 760px)").matches;

  /* ---- Lautsprecher-Toggle in den Anruf-Steuerungen ---- */
  function ensureSpeakerBtn() {
    const controls = document.querySelector("#amkCallScreenFinal .amk-call-controls-final");
    if (controls && !byId("amkSpeakerFinal")) {
      const b = document.createElement("button");
      b.id = "amkSpeakerFinal";
      b.type = "button";
      b.className = "amk-call-btn-final";
      b.innerHTML = '<span class="amk-cbi">🔊</span><span class="amk-cbl">Ton</span>';
      b.title = "Lautsprecher an/aus";
      controls.insertBefore(b, controls.firstChild);
      b.addEventListener("click", () => {
        const a = window.AMK_REMOTE_AUDIO;
        if (!a) return;
        a.muted = !a.muted;
        const ic = b.querySelector(".amk-cbi"); if (ic) ic.textContent = a.muted ? "🔇" : "🔊";
        b.classList.toggle("active", a.muted);
        (AMKZ.toast || function () {})("Lautsprecher", a.muted ? "Aus" : "An");
      });
    }
  }
  setInterval(ensureSpeakerBtn, 800);

  /* ---- Mobiler Vollbild-Chat: Liste -> tippen -> Chat ---- */
  function ensureChatBack() {
    const head = document.querySelector("#amkzConnectView .amkz-chat-header");
    if (head && !byId("amkChatBack")) {
      const b = document.createElement("button");
      b.id = "amkChatBack";
      b.type = "button";
      b.className = "amk-chat-back";
      b.textContent = "‹";
      b.title = "Zurück";
      head.insertBefore(b, head.firstChild);
    }
  }

  document.addEventListener("click", (e) => {
    // Mitarbeiter in der Liste getippt -> Chat als Vollbild öffnen (nur Handy)
    if (e.target.closest("#amkzConnectView .amkz-chat-user") && isMobile()) {
      document.body.classList.add("amk-chat-open");
      setTimeout(ensureChatBack, 200);
    }
    // Zurück-Button -> zur Liste
    if (e.target.closest("#amkChatBack")) {
      document.body.classList.remove("amk-chat-open");
    }
    // Bereich wechseln -> Vollbild-Chat schließen
    if (e.target.closest(".amkz-nav-item")) {
      document.body.classList.remove("amk-chat-open");
    }
  }, true);

  AMKZ.uiExtras2 = { ensureSpeakerBtn };
})();

/* =====================================================
   AMK ZENTRALE — View-Marker (body[data-amk-view])
   Damit CSS pro Ansicht reagieren kann (z. B. Topbar in
   Connect am Handy ausblenden).
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__viewMarker) return;
  AMKZ.__viewMarker = true;
  function sync() {
    const v = AMKZ.state && AMKZ.state.currentView;
    if (v && document.body.getAttribute("data-amk-view") !== v) {
      document.body.setAttribute("data-amk-view", v);
      // Bereichswechsel -> ggf. offenen Vollbild-Chat schließen
      if (v !== "connect") document.body.classList.remove("amk-chat-open");
    }
  }
  setInterval(sync, 350);
  sync();
})();


/* =====================================================
   AMK ZENTRALE — STREAMING-VERWALTUNG (v3)
   - Eintragung: Opening / SR / Reserve (je Konto + Betrag), kein Status
   - Streamer aus Team (echter Empfänger für die 8-Uhr-Nachricht)
   - Balance-Check: alle Konten grün(geladen)/rot(leer), klick toggelt, Speichern bleibt
   - "Balance laden": rote Konten -> 1 Klick -> Nachricht an Mateo (Chat+Push+Kopie)
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__streamMgmt) return;
  AMKZ.__streamMgmt = true;

  const byId = (id) => document.getElementById(id);
  const sb = () => AMKZ.supabase;
  const me = () => AMKZ.state && AMKZ.state.member;
  const canManage = () => !!(AMKZ.state && AMKZ.state.permissions && AMKZ.state.permissions.manageStreaming === true);

  function esc(s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }

  let currentTab = "plan";
  let editingId = null;
  let DATA = { accounts: [], plan: [], team: [], messages: [], accByCasino: {} };

  async function loadAll() {
    const out = { accounts: [], plan: [], team: [], messages: [], accByCasino: {} };
    if (!sb()) return out;
    try {
      const [acc, plan, team, msgs] = await Promise.all([
        AMKZ.spalten("streaming_accounts").then((sp) => sb().from("streaming_accounts").select(sp).order("sort_order", { ascending: true })),
        sb().from("streaming_plan").select("*").order("plan_date", { ascending: true }),
        sb().from("team_members").select("id,name,is_active").order("name", { ascending: true }),
        sb().from("streaming_messages").select("*").order("created_at", { ascending: false }).limit(40),
      ]);
      out.accounts = acc.data || [];
      await AMKZ.mitGeheim(out.accounts, "amk_streaming_geheim");   // Passwörter nur mit Sitzung
      out.plan = plan.data || [];
      out.team = (team.data || []).filter((t) => t.is_active !== false);
      out.messages = msgs.data || [];
    } catch (e) { console.warn("[streaming] loadAll", e); }
    out.accounts.forEach((a) => { (out.accByCasino[a.casino_name] = out.accByCasino[a.casino_name] || []).push(a); });
    DATA = out;
    return out;
  }

  function acctById(id) { return DATA.accounts.find((a) => a.id === id) || {}; }

  /* ---------- Kalender füttern ---------- */
  function feedCalendar(d) {
    const sp = window.__amkStreamingplan;
    if (!sp) return;
    const shiftMap = { early: "Früh", late: "Spät", prime: "Prime" };
    const findAcc = (casino, email) => (d.accByCasino[casino] || []).find((a) => a.login_email === email) || (d.accByCasino[casino] || [])[0] || {};
    const entries = (d.plan || []).map((p) => {
      // Alle Spielkonten dieses Streams (Opening / SR / Reserve) mit Login/Passwort
      const accounts = [
        { label: "Opening", casino: p.opening_casino, email: p.opening_email, amount: p.opening_amount },
        { label: "SR", casino: p.sr_casino, email: p.sr_email, amount: p.sr_amount },
        { label: "Reserve", casino: p.reserve_casino, email: p.reserve_email, amount: p.reserve_amount },
      ].filter((x) => x.casino).map((x) => {
        const a = findAcc(x.casino, x.email);
        return { label: x.label, casino: x.casino, login: x.email || a.login_email || "", password: a.login_password || "", amount: x.amount || "" };
      });
      return {
        date: p.plan_date, shift: shiftMap[p.shift] || p.shift || "Spät", time: "",
        person: p.person || "", status: p.status || "live",
        opening: p.opening_casino ? `${p.opening_amount || ""} ${p.opening_casino}` : (p.opening || ""),
        sr: p.sr_casino ? `${p.sr_amount || ""} ${p.sr_casino}` : (p.sr || ""),
        info: p.info || "",
        note: p.note || "",
        accounts,
      };
    });
    sp.cfg.embeddedData = entries;
    sp.cfg.entriesOnly = true; // nur echte Einträge, keine generierte Rotation
    sp.cfg.embeddedUpdated = new Date().toISOString();
    try { sp.load(); } catch (e) {}
  }

  /* ---------- Panel ---------- */
  function renderManage(d) {
    const panel = byId("amkzStreamManagePanel");
    if (!panel) return;

    const personOptions = d.team.map((t) => `<option value="${esc(t.id)}">${esc(t.name)}</option>`).join("");
    const acctOptions = d.accounts.filter((a) => !a.is_hidden).map((a) => `<option value="${esc(a.id)}">${esc(a.casino_name)} · ${esc(a.login_email || "")}</option>`).join("");
    const acctOpt = (label) => `<option value="">– ${label} –</option>${acctOptions}`;

    const formCard = `
      <div class="amkz-stream-card">
        <h3>Neue Eintragung</h3>
        <p class="amkz-stream-sub">Streamer + Opening / SR / Reserve – wird morgens um 8 Uhr automatisch an den Streamer gesendet.</p>
        <form id="amkzStreamPlanForm" class="amkz-stream-form">
          <label>Datum<input type="date" name="plan_date" required></label>
          <label>Schicht
            <select name="shift"><option value="early">Früh (12:00)</option><option value="late" selected>Spät (18:00)</option><option value="prime">Prime (So)</option></select>
          </label>
          <label class="amkz-full">Streamer<select name="person_id" required>${personOptions}</select></label>

          <label>Opening – Betrag<input type="text" name="opening_amount" placeholder="14K"></label>
          <label>Opening – Konto<select name="opening_acct">${acctOpt("Konto wählen")}</select></label>
          <label>SR – Betrag<input type="text" name="sr_amount" placeholder="10K"></label>
          <label>SR – Konto<select name="sr_acct">${acctOpt("Konto wählen")}</select></label>
          <label>Reserve – Betrag<input type="text" name="reserve_amount" placeholder="10K"></label>
          <label>Reserve – Konto<select name="reserve_acct">${acctOpt("Konto wählen")}</select></label>

          <label class="amkz-full">Info<input type="text" name="info" placeholder="z. B. Season-Opening"></label>
          <label class="amkz-full">Notiz<textarea name="note"></textarea></label>
          <div class="amkz-full"><button type="submit" class="amkz-primary-btn">Eintragung speichern</button></div>
        </form>
      </div>`;

    const todayStr = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10) /* Nachtschicht 31.10.: Ortszeit statt UTC */;
    const upcoming = (d.plan || []).filter((p) => (p.plan_date || "") >= todayStr).slice(0, 60);
    const planList = `
      <div class="amkz-stream-card">
        <h3>Geplante Streams</h3>
        <p class="amkz-stream-sub">${upcoming.length} kommende · Morgen-Versand 8 Uhr</p>
        <div class="amkz-stream-plan-list">
          ${upcoming.length ? upcoming.map((p) => {
            const shiftLbl = { early: "Früh", late: "Spät", prime: "Prime" }[p.shift] || p.shift || "";
            const info = [
              p.opening_casino ? `Opening ${p.opening_amount || ""} ${p.opening_casino}` : "",
              p.sr_casino ? `SR ${p.sr_amount || ""} ${p.sr_casino}` : "",
              p.reserve_casino ? `Reserve ${p.reserve_amount || ""} ${p.reserve_casino}` : "",
            ].filter(Boolean).join(" · ");
            return `<div class="amkz-stream-plan-row">
              <span class="amkz-spr-date">${esc(p.plan_date)}</span>
              <span class="amkz-spr-main"><strong>${esc(p.person || "—")} · ${esc(shiftLbl)}</strong><small>${esc(info || "—")}</small></span>
              ${p.person_id ? `<button type="button" class="amkz-secondary-btn amkz-spr-send" data-plan-send="${esc(p.id)}" title="Streaminfo jetzt an ${esc(p.person || "Streamer")} senden">📤 Senden</button>` : ""}
              <button type="button" class="amkz-secondary-btn amkz-spr-edit" data-plan-edit="${esc(p.id)}">Bearbeiten</button>
              <button type="button" class="amkz-spr-del" data-plan-del="${esc(p.id)}">Löschen</button>
            </div>`;
          }).join("") : `<div class="amkz-empty">Noch keine Eintragungen.</div>`}
        </div>
      </div>`;

    // Balance-Check: grün(geladen)/rot(leer), klick toggelt, Speichern bleibt.
    // Ausgeblendete Konten (is_hidden) erscheinen hier NICHT.
    const chips = d.accounts.filter((a) => !a.is_hidden).map((a) => {
      const empty = a.is_loaded === false;
      return `<button type="button" class="amkz-acct-chip ${empty ? "empty" : "loaded"}" data-acct="${esc(a.id)}" data-casino="${esc(a.casino_name)}" data-email="${esc(a.login_email || "")}" data-amount="${esc(a.reload_amount || 10000)}">
        <strong>${esc(a.casino_name)}</strong><span>${esc(a.login_email || "")}</span></button>`;
    }).join("");
    const balCard = `
      <div class="amkz-stream-card">
        <h3>Balance-Check</h3>
        <p class="amkz-stream-sub">Grün = geladen, Rot = leer. Antippen zum Umschalten, „Status speichern" merkt es sich.</p>
        <div class="amkz-acct-chips">${chips || '<div class="amkz-empty">Keine Konten. Erst Casino-Zugänge anlegen.</div>'}</div>
        <div style="display:flex;gap:8px;margin-top:12px;flex-wrap:wrap">
          <button type="button" class="amkz-secondary-btn" data-bal-save>Status speichern</button>
          <button type="button" class="amkz-primary-btn" data-balance-laden>💰 Balance laden (an Mateo)</button>
        </div>
        <div id="amkzBalanceMsgWrap" class="amkz-balance-msg is-hidden">
          <textarea id="amkzBalanceMsg" readonly rows="6"></textarea>
          <button type="button" class="amkz-secondary-btn" data-balance-copy>Text kopieren</button>
        </div>
      </div>`;

    // Nachrichten-Verlauf: jederzeit kopieren / an Affiliates senden
    const msgCard = `
      <div class="amkz-stream-card">
        <h3>Nachrichten-Verlauf</h3>
        <p class="amkz-stream-sub">Jede „Balance laden"-Nachricht – jederzeit kopieren oder per WhatsApp an die Affiliates senden.</p>
        <div class="amkz-msg-list">
          ${(d.messages || []).length ? d.messages.map((m) => `
            <div class="amkz-msg-item" data-msg="${esc(m.id)}">
              <div class="amkz-msg-meta">${esc(new Date(m.created_at).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(", ", " "))}${m.created_by_name ? " · " + esc(m.created_by_name) : ""}</div>
              <pre class="amkz-msg-body">${esc(m.body)}</pre>
              <div class="amkz-msg-actions">
                <button type="button" class="amkz-secondary-btn" data-msg-copy="${esc(m.id)}">📋 Kopieren</button>
                <button type="button" class="amkz-secondary-btn" data-msg-wa="${esc(m.id)}">🟢 WhatsApp</button>
                <button type="button" class="amkz-spr-del" data-msg-del="${esc(m.id)}">✕</button>
              </div>
            </div>`).join("") : `<div class="amkz-empty">Noch keine Nachrichten.</div>`}
        </div>
      </div>`;

    const accRows = d.accounts.slice().sort((x, y) => (x.is_hidden ? 1 : 0) - (y.is_hidden ? 1 : 0)).map((a) => /* Nachtschicht 31.10.: sichtbare Zugänge zuerst */
      `<div class="amkz-acc-row${a.is_hidden ? " amkz-acc-hidden" : ""}" data-acct="${esc(a.id)}">
        <input class="amkz-acc-casino" value="${esc(a.casino_name)}" placeholder="Casino">
        <input class="amkz-acc-login" value="${esc(a.login_email || "")}" placeholder="E-Mail">
        <input class="amkz-acc-pw" value="${esc(a.login_password || "")}" placeholder="Passwort">
        <button type="button" class="amkz-secondary-btn amkz-acc-save" data-acc-save>Speichern</button>
        <button type="button" class="amkz-secondary-btn amkz-acc-hide" data-acc-hide="${esc(a.id)}" data-hidden="${a.is_hidden ? "1" : "0"}">${a.is_hidden ? "👁 Einblenden" : "🚫 Ausblenden"}</button>
        <button type="button" class="amkz-spr-del amkz-acc-del" data-acc-del="${esc(a.id)}" title="Zugang löschen" aria-label="Zugang löschen">✕</button>
      </div>`).join("");
    const accCard = `
      <div class="amkz-stream-card">
        <h3>Casino-Zugänge</h3>
        <p class="amkz-stream-sub">Einmal eintragen – Streamer sehen Login/Passwort automatisch im Plan-Detail. „Ausblenden" nimmt ein Konto aus dem Balance-Check (oben) &amp; den Konto-Auswahlen – jederzeit wieder einblendbar.</p>
        <div class="amkz-acc-list${d.accounts.length > 5 ? " amkz-acc-collapsed" : ""}">${accRows || '<div class="amkz-empty">Noch keine Konten.</div>'}</div>
        ${d.accounts.length > 5 ? `<button type="button" class="amkz-secondary-btn amkz-acc-showall" data-acc-showall>Alle ${d.accounts.length} Konten anzeigen ▾</button>` : ""}
        <form id="amkzAccAddForm" class="amkz-acc-row amkz-acc-add" style="margin-top:10px">
          <input name="casino_name" placeholder="Neues Casino" required>
          <input name="login_email" placeholder="E-Mail">
          <input name="login_password" placeholder="Passwort">
          <button type="submit" class="amkz-primary-btn">+ Konto</button>
          <span></span>
        </form>
      </div>`;

    // Nachrichten-Verlauf jetzt LINKS (unter Formular+Plan) für ein sauberes Bild.
    // 26.10.2026: Sendeplan, Neue Eintragung, Geplante Streams und Nachrichten-Verlauf entfernt (Marcel) —
    // die Stream-Zentrale zeigt nur noch Balance-Check, Casino-Zugänge und (per Modul KONTO-BALANCES) Kontostände.
    void formCard; void msgCard; void planList;
    const geladen = d.accounts.filter((a) => !a.is_hidden && a.is_loaded !== false).length, alle = d.accounts.filter((a) => !a.is_hidden).length;
    panel.innerHTML = `<div class="amksz-kopf"><div><div class="amksz-eyebrow">Konten &amp; Balance</div><h2 class="amksz-titel">Casino-Konten</h2>
        <p>Welche Casino-Konten geladen sind, Zugänge und Kontostände an einem Ort.</p></div>
        <div class="amksz-kennzahlen"><div><b>${geladen}</b><small>geladen</small></div><div class="leer"><b>${alle - geladen}</b><small>leer</small></div><div><b>${alle}</b><small>Konten</small></div></div></div>
      <div class="amkz-stream-grid amksz-grid"><div>${balCard}</div><div>${accCard}</div></div>`;
  }

  /* ---------- Empfänger auflösen ---------- */
  async function findMateo() {
    try {
      const { data } = await sb().from("team_members").select("id,name")
        .or("email.eq.mateo@amk.com,name.ilike.mateo").limit(1).maybeSingle();
      return data || null;
    } catch (e) { return null; }
  }

  async function sendToUser(userId, title, message) {
    if (!userId) return;
    const myId = me()?.id || null;
    // ECHTE Chat-Nachricht über die Konversations-RPCs (sonst conversation_id=null -> unsichtbar)
    try {
      if (myId && userId !== myId) {
        const { data: conv } = await sb().rpc("amk_get_or_create_conversation", { p_user_a: myId, p_user_b: userId });
        const convId = conv?.id || (Array.isArray(conv) ? conv[0]?.id : null);
        if (convId) {
          await sb().rpc("amk_send_message", {
            p_conversation_id: convId,
            p_sender_id: myId,
            p_receiver_id: userId,
            p_message: message,
            p_client_temp_id: `tmp_${Date.now()}_${Math.random().toString(36).slice(2)}`,
          });
        } else {
          await sb().from("internal_messages").insert({ sender_id: myId, receiver_id: userId, message, message_type: "text", is_read: false, created_at: new Date().toISOString() });
        }
      }
    } catch (e) { console.warn("[streaming] chat send", e); }
    try {
      await sb().from("notifications").insert({
        target_user_id: userId, created_for: userId, type: "topup",
        title, message, is_read: false, created_at: new Date().toISOString(), payload: { from: myId, push: "false" },
      });
    } catch (e) {}
    // from = Absender -> Tippen auf die Push öffnet direkt den Chat mit dem Absender
    try { window.AMK_SEND_PUSH && window.AMK_SEND_PUSH(userId, title, message, { from: myId }); } catch (e) {}
  }

  // Streaminfo-Text für einen Plan-Eintrag (gleiche Form wie die Morgen-Nachricht)
  function buildStreaminfo(p) {
    const lines = ["Streaminfo:"];
    if (p.opening_casino) lines.push(`${p.opening_amount || ""} Opening - ${p.opening_casino} - ${p.opening_email || ""}`.trim());
    if (p.sr_casino) lines.push(`${p.sr_amount || ""} SR - ${p.sr_casino} - ${p.sr_email || ""}`.trim());
    if (p.reserve_casino) lines.push(`${p.reserve_amount || ""} reserve - ${p.reserve_casino} - ${p.reserve_email || ""}`.trim());
    return lines.join("\n");
  }

  // Streaminfo SOFORT an den Streamer (manueller Versand; unabhängig von Cron/Edge-Function)
  async function sendStreaminfoNow(planId) {
    const p = (DATA.plan || []).find((x) => x.id === planId);
    if (!p) return;
    if (!p.person_id) { AMKZ.toast?.("Streaminfo", "Für diesen Stream ist kein Streamer (Team-Mitglied) hinterlegt.", "error"); return; }
    const info = buildStreaminfo(p);
    if (info === "Streaminfo:") { AMKZ.toast?.("Streaminfo", "Keine Opening/SR/Reserve-Daten zum Senden.", "error"); return; }
    await sendToUser(p.person_id, "📺 Streaminfo", info);
    AMKZ.toast?.("Gesendet", `Streaminfo an ${p.person || "Streamer"} gesendet (Chat + Mitteilung + Push).`);
  }

  /* ---------- Aktionen ---------- */
  async function balanceLaden() {
    const reds = [...document.querySelectorAll(".amkz-acct-chip.empty")];
    if (!reds.length) { AMKZ.toast?.("Balance laden", "Markiere zuerst die leeren (roten) Konten.", "error"); return; }
    const lines = reds.map((ch) => `${ch.dataset.casino} - ${ch.dataset.email} - 10K`);
    const msg = "Hey, could you please reload the following balances for me?\n" + lines.join("\n") + "\n\nThanks!";
    const mateo = await findMateo();
    await sendToUser(mateo?.id, "💰 Balance laden", msg);
    // In den Nachrichten-Verlauf legen (jederzeit kopierbar / an Affiliates sendbar)
    try {
      await sb().from("streaming_messages").insert({
        kind: "balance", title: "Balance laden", body: msg,
        created_by: me()?.id || null, created_by_name: me()?.name || me()?.email || "",
      });
    } catch (e) {}
    const wrap = byId("amkzBalanceMsgWrap"), ta = byId("amkzBalanceMsg");
    if (ta) ta.value = msg;
    if (wrap) wrap.classList.remove("is-hidden");
    try { await navigator.clipboard.writeText(msg); } catch (e) {}
    AMKZ.toast?.("Gesendet", mateo ? "An Mateo + im Verlauf gespeichert." : "Im Verlauf gespeichert – Text kopiert.");
    refresh();
  }

  async function saveBalanceStatus() {
    const chips = [...document.querySelectorAll(".amkz-acct-chip")];
    for (const ch of chips) {
      const isLoaded = !ch.classList.contains("empty");
      try { await sb().from("streaming_accounts").update({ is_loaded: isLoaded, updated_at: new Date().toISOString() }).eq("id", ch.dataset.acct); } catch (e) {}
    }
    AMKZ.toast?.("Gespeichert", "Balance-Status gemerkt.");
  }

  async function addPlan(form) {
    const f = new FormData(form);
    const oa = acctById(f.get("opening_acct")), sa = acctById(f.get("sr_acct")), ra = acctById(f.get("reserve_acct"));
    const person = (DATA.team.find((t) => t.id === f.get("person_id")) || {}).name || "";
    const row = {
      plan_date: f.get("plan_date"), shift: f.get("shift"),
      person, person_id: f.get("person_id") || null, status: "live",
      opening_casino: oa.casino_name || null, opening_email: oa.login_email || null, opening_amount: f.get("opening_amount") || null,
      sr_casino: sa.casino_name || null, sr_email: sa.login_email || null, sr_amount: f.get("sr_amount") || null,
      reserve_casino: ra.casino_name || null, reserve_email: ra.login_email || null, reserve_amount: f.get("reserve_amount") || null,
      info: f.get("info") || null, note: f.get("note") || null,
      created_by: me()?.id || null, created_by_name: me()?.name || me()?.email || "",
    };
    if (!row.plan_date) return;

    if (editingId) {
      // Bestehenden Eintrag aktualisieren
      const { error } = await sb().from("streaming_plan").update(row).eq("id", editingId);
      if (error) { AMKZ.toast?.("Fehler", error.message, "error"); return; }
      editingId = null;
      AMKZ.toast?.("Aktualisiert", "Eintragung geändert.");
      refresh();
      return;
    }

    const { error } = await sb().from("streaming_plan").insert(row);
    if (error) { AMKZ.toast?.("Fehler", error.message, "error"); return; }

    // Vorab-Streaminfo sofort an Mateo (zur Kontrolle)
    try {
      const info = buildStreaminfo(row);
      if (info !== "Streaminfo:") {
        const mateo = await findMateo();
        const shiftLbl = { early: "Früh 12:00", late: "Spät 18:00", prime: "Prime" }[row.shift] || row.shift || "";
        await sendToUser(mateo?.id, "📋 Vorab-Streaminfo",
          `📋 Vorab · ${row.plan_date} · ${row.person || ""} (${shiftLbl})\n\n${info}`);
      }
    } catch (e) {}

    AMKZ.toast?.("Gespeichert", "Eintragung gespeichert · Vorab an Mateo.");
    refresh();
  }

  // Eintrag zum Bearbeiten ins Formular laden
  function fillPlanForm(p) {
    const form = byId("amkzStreamPlanForm");
    if (!form || !p) return;
    const acctId = (casino, email) => {
      const a = DATA.accounts.find((x) => x.casino_name === casino && x.login_email === email);
      return a ? a.id : "";
    };
    const set = (name, val) => { if (form.elements[name]) form.elements[name].value = val || ""; };
    set("plan_date", p.plan_date);
    set("shift", p.shift || "late");
    set("person_id", p.person_id);
    set("opening_acct", acctId(p.opening_casino, p.opening_email));
    set("opening_amount", p.opening_amount);
    set("sr_acct", acctId(p.sr_casino, p.sr_email));
    set("sr_amount", p.sr_amount);
    set("reserve_acct", acctId(p.reserve_casino, p.reserve_email));
    set("reserve_amount", p.reserve_amount);
    set("info", p.info);
    set("note", p.note);
    editingId = p.id;
    const btn = form.querySelector('button[type="submit"]');
    if (btn) btn.textContent = "Eintragung aktualisieren";
    try { form.scrollIntoView({ behavior: "smooth", block: "start" }); } catch (_) {}
  }

  async function delPlan(id) { if (!window.confirm("Diese Sendeplan-Eintragung wirklich löschen?")) return; try { await sb().from("streaming_plan").delete().eq("id", id); } catch (e) {} if (editingId === id) editingId = null; refresh(); }

  async function saveAccount(row) {
    const payload = {
      casino_name: row.querySelector(".amkz-acc-casino").value.trim(),
      login_email: row.querySelector(".amkz-acc-login").value.trim(),
      login_password: row.querySelector(".amkz-acc-pw").value.trim(),
      updated_at: new Date().toISOString(),
    };
    // Passwort nicht geladen (amk_streaming_geheim) und Feld leer -> nicht überschreiben
    const alt = DATA.accounts.find((a) => String(a.id) === String(row.dataset.acct));
    if (alt && !Object.prototype.hasOwnProperty.call(alt, "login_password") && !payload.login_password) delete payload.login_password;
    const { error } = await sb().from("streaming_accounts").update(payload).eq("id", row.dataset.acct);
    if (error) { AMKZ.toast?.("Fehler", error.message, "error"); return; }
    AMKZ.toast?.("Gespeichert", "Zugang aktualisiert.");
    refresh();
  }
  async function addAccount(form) {
    const f = new FormData(form);
    const payload = { casino_name: (f.get("casino_name") || "").trim(), login_email: (f.get("login_email") || "").trim(), login_password: (f.get("login_password") || "").trim(), reload_amount: 10000, is_loaded: true };
    if (!payload.casino_name) return;
    const { error } = await sb().from("streaming_accounts").insert(payload);
    if (error) { AMKZ.toast?.("Fehler", error.message, "error"); return; }
    AMKZ.toast?.("Hinzugefügt", "Konto angelegt.");
    refresh();
  }
  async function delAccount(id) { if (!window.confirm("Diesen Casino-Zugang wirklich endgültig löschen? Zum Verstecken lieber „Ausblenden“ nutzen.")) return; /* Nachtschicht 31.10.: vorher ohne Rückfrage gelöscht */ try { await sb().from("streaming_accounts").delete().eq("id", id); } catch (e) {} refresh(); }
  async function toggleHideAccount(id, currentlyHidden) {
    try {
      await sb().from("streaming_accounts").update({ is_hidden: !currentlyHidden, updated_at: new Date().toISOString() }).eq("id", id);
      AMKZ.toast?.(currentlyHidden ? "Eingeblendet" : "Ausgeblendet", currentlyHidden ? "Konto ist wieder im Balance-Check." : "Konto aus dem Balance-Check genommen.");
    } catch (e) { AMKZ.toast?.("Fehler", "Sichtbarkeit nicht gespeichert.", "error"); }
    refresh();
  }

  /* ---------- Tabs + Init ---------- */
  function switchTab(tab) {
    currentTab = tab;
    document.querySelectorAll(".amkz-stream-tab").forEach((b) => b.classList.toggle("active", b.dataset.streamTab === tab));
    byId("amkzStreamPlanPanel")?.classList.toggle("is-hidden", tab !== "plan");
    byId("amkzStreamManagePanel")?.classList.toggle("is-hidden", tab !== "manage");
  }
  async function refresh() {
    const data = await loadAll();
    feedCalendar(data);
    if (canManage()) renderManage(data);
    return data;
  }
  async function initStreamingView() {
    const manageTab = byId("amkzStreamManageTab");
    if (manageTab) manageTab.hidden = !canManage();
    if (!canManage() && currentTab === "manage") switchTab("plan");
    await refresh();
  }
  AMKZ.streaming = { refresh: initStreamingView };

  /* ---------- Events ---------- */
  if (!document.body.dataset.amkStreamBound) {
    document.body.dataset.amkStreamBound = "1";
    document.addEventListener("click", (e) => {
      const tab = e.target.closest(".amkz-stream-tab");
      if (tab) { switchTab(tab.dataset.streamTab); if (tab.dataset.streamTab === "manage") refresh(); return; }
      const chip = e.target.closest(".amkz-acct-chip");
      if (chip) { chip.classList.toggle("empty"); chip.classList.toggle("loaded"); return; }
      if (e.target.closest("[data-balance-laden]")) { balanceLaden(); return; }
      if (e.target.closest("[data-bal-save]")) { saveBalanceStatus(); return; }
      if (e.target.closest("[data-balance-copy]")) { const ta = byId("amkzBalanceMsg"); if (ta) { try { navigator.clipboard.writeText(ta.value); } catch (x) {} AMKZ.toast?.("Kopiert", "Text in der Zwischenablage."); } return; }
      const mCopy = e.target.closest("[data-msg-copy]");
      if (mCopy) { const m = (DATA.messages || []).find((x) => x.id === mCopy.getAttribute("data-msg-copy")); if (m) { try { navigator.clipboard.writeText(m.body); } catch (x) {} AMKZ.toast?.("Kopiert", "Nachricht in der Zwischenablage."); } return; }
      const mWa = e.target.closest("[data-msg-wa]");
      if (mWa) { const m = (DATA.messages || []).find((x) => x.id === mWa.getAttribute("data-msg-wa")); if (m) { window.open("https://wa.me/?text=" + encodeURIComponent(m.body), "_blank"); } return; }
      const mDel = e.target.closest("[data-msg-del]");
      if (mDel) { if (!window.confirm("Diese Nachricht wirklich löschen?")) return; sb().from("streaming_messages").delete().eq("id", mDel.getAttribute("data-msg-del")).then(() => refresh()); return; }
      const edit = e.target.closest("[data-plan-edit]");
      if (edit) { const p = (DATA.plan || []).find((x) => x.id === edit.getAttribute("data-plan-edit")); if (p) fillPlanForm(p); return; }
      const del = e.target.closest("[data-plan-del]"); if (del) { delPlan(del.getAttribute("data-plan-del")); return; }
      const sendInfo = e.target.closest("[data-plan-send]"); if (sendInfo) { sendStreaminfoNow(sendInfo.getAttribute("data-plan-send")); return; }
      const accSave = e.target.closest("[data-acc-save]"); if (accSave) { saveAccount(accSave.closest(".amkz-acc-row")); return; }
      const accHide = e.target.closest("[data-acc-hide]"); if (accHide) { toggleHideAccount(accHide.getAttribute("data-acc-hide"), accHide.getAttribute("data-hidden") === "1"); return; }
      const accDel = e.target.closest("[data-acc-del]"); if (accDel) { delAccount(accDel.getAttribute("data-acc-del")); return; }
    });
    document.addEventListener("submit", (e) => {
      if (e.target && e.target.id === "amkzStreamPlanForm") { e.preventDefault(); addPlan(e.target); }
      if (e.target && e.target.id === "amkzAccAddForm") { e.preventDefault(); addAccount(e.target); }
    });
  }

  const prev = AMKZ.loadView;
  AMKZ.loadView = async function (view, options) {
    const r = await (prev ? prev.call(this, view, options) : undefined);
    if (view === "streaming") setTimeout(initStreamingView, 250);
    return r;
  };
})();


/* =====================================================================
   MODERNE ANIMIERTE ICONS — ersetzt die Emoji-Icons in Nav + Tabs
   durch saubere Inline-SVG-Linien-Icons (currentColor -> Theme/Gold).
   Läuft per JS -> wirkt lokal UND auf Shopify ohne doppelte Markup-Pflege.
   ===================================================================== */
(function () {
  if (!window.AMKZ || AMKZ.__iconsBound) return;
  AMKZ.__iconsBound = true;

  const S = (inner) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" class="amkz-ico-svg" aria-hidden="true">${inner}</svg>`;
  const I = {
    dashboard: S('<rect x="3" y="3" width="7" height="7" rx="1.6"/><rect x="14" y="3" width="7" height="7" rx="1.6"/><rect x="3" y="14" width="7" height="7" rx="1.6"/><rect x="14" y="14" width="7" height="7" rx="1.6"/>'),
    daily:     S('<circle cx="12" cy="12" r="8.5"/><path d="M12 12V3.5"/><path d="M12 12l6.4-3.7"/>'),
    entries:   S('<circle cx="12" cy="12" r="8.5"/><path d="M12 8.3v7.4M8.3 12h7.4"/>'),
    connect:   S('<path d="M20.5 11.3a8 7 0 0 1-11.4 6.4L4 19l1.4-4.3A8 7 0 1 1 20.5 11.3Z"/>'),
    calendar:  S('<rect x="3.5" y="5" width="17" height="15.5" rx="2.4"/><path d="M3.5 9.5h17M8 3.5v4M16 3.5v4"/>'),
    bonushunt: S('<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4.4"/><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none"/>'),
    casinos:   S('<path d="M6 4h12l3 5-9 11L3 9Z"/><path d="M3 9h18M9 4 7 9l5 11 5-11-2-5"/>'),
    partners:  S('<circle cx="8.7" cy="12" r="4.9"/><circle cx="15.3" cy="12" r="4.9"/>'),
    finance:   S('<path d="M3 8.5A2.5 2.5 0 0 1 5.5 6H18a1.5 1.5 0 0 0 0 3"/><path d="M3 8.5V17A2.5 2.5 0 0 0 5.5 19.5H19A1.5 1.5 0 0 0 20.5 18v-7A1.5 1.5 0 0 0 19 9.5H5.5"/><circle cx="16.6" cy="14" r="1.25" fill="currentColor" stroke="none"/>'),
    team:      S('<circle cx="9" cy="8.4" r="3.2"/><path d="M3.6 19a5.4 5.4 0 0 1 10.8 0"/><path d="M16.2 5.6a3.2 3.2 0 0 1 0 6.1M17.4 19a5.4 5.4 0 0 0-2.9-4.8"/>'),
    analytics: S('<path d="M4 20h16"/><rect x="5" y="12" width="3.3" height="6.5" rx="1"/><rect x="10.4" y="7.5" width="3.3" height="11" rx="1"/><rect x="15.8" y="4.5" width="3.3" height="14" rx="1"/>'),
    streaming: S('<rect x="2.5" y="6" width="14.5" height="12" rx="2.4"/><path d="M17 10.5 21.5 8v8L17 13.5Z"/>'),
    settings:  S('<circle cx="16" cy="7" r="2"/><circle cx="8" cy="12" r="2"/><circle cx="13" cy="17" r="2"/><path d="M4 7h10M18 7h2M4 12h2M10 12h10M4 17h7M15 17h5"/>'),
    store:     S('<path d="M5 8.5h14l.9 11.5H4.1z"/><path d="M8.5 8.5V6.8a3.5 3.5 0 0 1 7 0v1.7"/>'),
    // --- Inline-/Button-Icons (globaler Emoji-Ersatz) ---
    dice:      S('<rect x="4" y="4" width="16" height="16" rx="3.2"/><circle cx="8.7" cy="8.7" r="1.15" fill="currentColor" stroke="none"/><circle cx="15.3" cy="8.7" r="1.15" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.15" fill="currentColor" stroke="none"/><circle cx="8.7" cy="15.3" r="1.15" fill="currentColor" stroke="none"/><circle cx="15.3" cy="15.3" r="1.15" fill="currentColor" stroke="none"/>'),
    mic:       S('<rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v3"/>'),
    image:     S('<rect x="3.5" y="5" width="17" height="14" rx="2.5"/><circle cx="8.5" cy="10" r="1.7"/><path d="m4 17 4.6-4 3 2.5L15.5 11l5 5"/>'),
    phone:     S('<path d="M6.4 4h3l1.5 4-2 1.5a11 11 0 0 0 5 5l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A16 16 0 0 1 4.4 6.2 2 2 0 0 1 6.4 4Z"/>'),
    trash:     S('<path d="M4 7h16M9 7V5.2A1.6 1.6 0 0 1 10.6 3.6h2.8A1.6 1.6 0 0 1 15 5.2V7M6.2 7l1 12.4A1.6 1.6 0 0 0 8.8 21h6.4a1.6 1.6 0 0 0 1.6-1.6L17.8 7M10 11v6M14 11v6"/>'),
    ban:       S('<circle cx="12" cy="12" r="8.5"/><path d="m6.2 6.2 11.6 11.6"/>'),
    edit:      S('<path d="M4 20h4L19 9a1.9 1.9 0 0 0-2.7-2.7L5 17.5z"/><path d="m14.5 7.5 2 2"/>'),
    clipboard: S('<rect x="5" y="4.5" width="14" height="16" rx="2.2"/><rect x="9" y="2.9" width="6" height="3.2" rx="1.2"/><path d="M8.6 11h6.8M8.6 14.5h6.8"/>'),
    trophy:    S('<path d="M7 4h10v4.5a5 5 0 0 1-10 0z"/><path d="M7 5.5H4.6A2.4 2.4 0 0 0 7 9.2M17 5.5h2.4A2.4 2.4 0 0 1 17 9.2M10 13.8h4l-.5 3.2h-3zM8.5 20.5h7"/>'),
    pin:       S('<path d="M12 21s6.4-5.1 6.4-10.4A6.4 6.4 0 0 0 5.6 10.6C5.6 15.9 12 21 12 21Z"/><circle cx="12" cy="10.4" r="2.3"/>'),
    rocket:    S('<path d="M14.2 4c3 0 5.8 2.8 5.8 2.8s-1 4-4 7l-3 3-3-3-3-3 3-3c2.2-2.8 4.2-3.8 4.2-3.8Z"/><circle cx="14.5" cy="9.5" r="1.4"/><path d="M5 15l-1.6 1.6M8.2 18.2l-1.6 1.6M6.5 13 4 14"/>'),
    mute:      S('<path d="M4 9.5h3l4-3.5v12l-4-3.5H4z"/><path d="m15 9.5 4.5 5M19.5 9.5l-4.5 5"/>'),
    volume:    S('<path d="M4 9.5h3l4-3.5v12l-4-3.5H4z"/><path d="M15 8.6a5 5 0 0 1 0 6.8M17.6 6a8.5 8.5 0 0 1 0 12"/>'),
    money:     S('<rect x="3" y="6" width="18" height="12" rx="2.4"/><circle cx="12" cy="12" r="2.8"/><path d="M6 9.6v4.8M18 9.6v4.8"/>'),
    broadcast: S('<rect x="3" y="5" width="18" height="12" rx="2.2"/><path d="M8.5 21h7M12 17v4"/>'),
    hourglass: S('<path d="M6.5 3.5h11M6.5 20.5h11M8 3.5c0 5 8 4 8 8.5s-8 3.5-8 8.5M16 3.5c0 5-8 4-8 8.5s8 3.5 8 8.5"/>'),
    attach:    S('<path d="M19 11.5 11.5 19a4 4 0 0 1-5.7-5.7l8-8a2.6 2.6 0 0 1 3.7 3.7l-8 8a1.2 1.2 0 0 1-1.7-1.7l7.2-7.2"/>'),
    beach:     S('<path d="M12 4a8 8 0 0 1 7.6 5.6H4.4A8 8 0 0 1 12 4ZM12 4v16M9 20h6"/>'),
    send:      S('<path d="M4.5 12 20 4.5l-6 15-3-6z"/><path d="m11 13.5 9-9"/>'),
    dot:       S('<circle cx="12" cy="12" r="5.5" fill="currentColor" stroke="none"/>'),
    celebrate: S('<path d="M4 20 9 7l8 8zM9 7l1.5-3M14 9l3-1M16 13l3 .5M11 4.5 12 7"/>'),
    broom:     S('<path d="M17 3 10.5 9.5M11 9l4 4-5 5-5-1-1-3zM8 16l4 4"/>'),
    warning:   S('<path d="M12 3.6 21 19H3z"/><path d="M12 9.5v4M12 16.6v.2"/>'),
    arrowright:S('<path d="M5 12h13M12.5 6.5 18.5 12 12.5 17.5"/>'),
    arrowdown: S('<path d="M12 4.5v14M6.5 13 12 18.5 17.5 13"/>'),
    fullscreen:S('<path d="M4 9V5.5A1.5 1.5 0 0 1 5.5 4H9M15 4h3.5A1.5 1.5 0 0 1 20 5.5V9M20 15v3.5a1.5 1.5 0 0 1-1.5 1.5H15M9 20H5.5A1.5 1.5 0 0 1 4 18.5V15"/>'),
    star:      S('<path d="M12 3.5 14.6 9l6 .7-4.5 4.1 1.3 6L12 16.8 6.6 19.9l1.3-6L3.4 9.7l6-.7z"/>'),
    menu:      S('<path d="M4 7h16M4 12h16M4 17h16"/>'),
    close:     S('<path d="M6 6l12 12M18 6 6 18"/>'),
    check:     S('<path d="m5 12.5 5 5 9-10.5"/>'),
    xcircle:   S('<circle cx="12" cy="12" r="8.5"/><path d="m9 9 6 6M15 9l-6 6"/>'),
    globe:     S('<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17"/><path d="M12 3.5c2.6 2.4 4 5.3 4 8.5s-1.4 6.1-4 8.5c-2.6-2.4-4-5.3-4-8.5s1.4-6.1 4-8.5Z"/>'),
    megaphone: S('<path d="M4 10.3v3.4A1.3 1.3 0 0 0 5.3 15H7l7 4.2V4.8L7 9H5.3A1.3 1.3 0 0 0 4 10.3Z"/><path d="M17 9.4a4 4 0 0 1 0 5.2"/>'),
    ticket:    S('<path d="M4 8.6A1.6 1.6 0 0 1 5.6 7h12.8A1.6 1.6 0 0 1 20 8.6v1.9a1.6 1.6 0 0 0 0 3v1.9A1.6 1.6 0 0 1 18.4 17H5.6A1.6 1.6 0 0 1 4 15.4v-1.9a1.6 1.6 0 0 0 0-3Z"/><path d="M13 8v1.4M13 11.3v1.4M13 14.6V16"/>'),
    rec:       S('<circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="3.3" fill="currentColor" stroke="none"/>'),
    panels:    S('<rect x="3" y="4" width="18" height="6" rx="1.7"/><rect x="3" y="14" width="18" height="6" rx="1.7"/><circle cx="6.6" cy="7" r="1.05" fill="currentColor" stroke="none"/><circle cx="6.6" cy="17" r="1.05" fill="currentColor" stroke="none"/>'),
    link:      S('<path d="M9.6 14.4 14.4 9.6"/><path d="M7.9 12.1 6.5 13.5a3 3 0 0 0 4.2 4.2l1.4-1.4"/><path d="M16.1 11.9l1.4-1.4a3 3 0 0 0-4.2-4.2l-1.4 1.4"/>'),
    mail:      S('<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 7 8.5 6 8.5-6"/>'),
    chatdots:  S('<path d="M20.5 11.3a8 7 0 0 1-11.4 6.4L4 19l1.4-4.3A8 7 0 1 1 20.5 11.3Z"/><circle cx="8.6" cy="11.6" r=".95" fill="currentColor" stroke="none"/><circle cx="12" cy="11.6" r=".95" fill="currentColor" stroke="none"/><circle cx="15.4" cy="11.6" r=".95" fill="currentColor" stroke="none"/>'),
    /* Nachtschicht 31.10.: fehlende Linien-Icons für restliche Emojis */
    bell:      S('<path d="M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 2h-15z"/><path d="M10 20.5a2 2 0 0 0 4 0"/>'),
    eye:       S('<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z"/><circle cx="12" cy="12" r="2.8"/>'),
    search:    S('<circle cx="10.5" cy="10.5" r="6"/><path d="m15 15 5 5"/>'),
    flag:      S('<path d="M5 21V4"/><path d="M5 4.5h11l-2 4 2 4H5"/>'),
    user:      S('<circle cx="12" cy="8" r="3.8"/><path d="M4.5 20a7.5 7.5 0 0 1 15 0"/>'),
  };
  // Emoji -> Icon-Schlüssel (globaler Ersatz im gesamten UI; getippte Chat-Emojis bleiben)
  const EMO = {
    "🎲":"dice","🎤":"mic","📷":"image","📞":"phone","🗑":"trash","⛔":"ban","🚫":"ban",
    "✎":"edit","📝":"edit","📋":"clipboard","🎯":"bonushunt","🏆":"trophy","📌":"pin",
    "🚀":"rocket","🔇":"mute","🔊":"volume","💰":"money","📺":"broadcast","⏳":"hourglass",
    "📎":"attach","👥":"team","🏖":"beach","📤":"send","🟢":"dot","🎉":"celebrate","🧹":"broom",
    "⚠":"warning","➤":"send","➜":"arrowright","⬇":"arrowdown","⛶":"fullscreen","★":"star",
    "☰":"menu","✕":"close","✓":"check","✅":"check","❌":"xcircle",
    "🔔":"bell","👁":"eye","📈":"analytics","📊":"analytics","🎰":"dice","⚙":"settings","🎟":"ticket",
    "🔎":"search","🏁":"flag","✏":"edit","👤":"user","✉":"mail",
    /* Nachtschicht 31.10.: Mitteilungs-Symbole */ "🗓":"calendar","📅":"calendar","💬":"chatdots","💶":"money","🎧":"chatdots","🎬":"broadcast","🕘":"hourglass"
  };
  const EMO_SRC = "(?:" + Object.keys(EMO).map((e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|") + ")\\uFE0F?";
  const EMO_RE = new RegExp(EMO_SRC, "gu");   // für den exec-Loop (g)
  const EMO_TEST = new RegExp(EMO_SRC, "u");  // zustandslos für .test()
  const EMO_SKIP = "#amkzMessagesContainer, #amkzPinnedBar, .amkz-emo, .amkz-ico, textarea, input, select, script, style, [data-no-emoji]";
  function replaceInText(node) {
    if (!node || node.nodeType !== 3) return;
    if (node.parentElement && node.parentElement.closest(EMO_SKIP)) return;
    const txt = node.nodeValue;
    if (!EMO_TEST.test(txt)) return;
    const frag = document.createDocumentFragment();
    let last = 0, m; EMO_RE.lastIndex = 0;
    while ((m = EMO_RE.exec(txt))) {
      const emo = m[0].replace(/️$/, "");
      const key = EMO[emo];
      if (m.index > last) frag.appendChild(document.createTextNode(txt.slice(last, m.index)));
      if (key && I[key]) { const sp = document.createElement("span"); sp.className = "amkz-emo"; sp.innerHTML = I[key]; frag.appendChild(sp); }
      else frag.appendChild(document.createTextNode(m[0]));
      last = m.index + m[0].length;
    }
    if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last)));
    const pb = node.parentElement && node.parentElement.closest("button");
    node.parentNode.replaceChild(frag, node);
    /* Nachtschicht 31.10. (#85): reine Symbol-Knöpfe bekommen eine Beschriftung (Tooltip + Screenreader) */
    if (pb && !pb.textContent.trim() && !pb.getAttribute("aria-label")) {
      const k = EMO[(txt.trim().match(EMO_RE) || [""])[0].replace(/\uFE0F$/, "")];
      const lab = { close: (/del|hw-x/.test(pb.className) ? "Entfernen" : "Schließen"), edit: "Bearbeiten", search: "Suchen", settings: "Einstellungen", menu: "Menü", send: "Senden", fullscreen: "Vollbild", bell: "Mitteilungen", eye: "Anzeigen", attach: "Anhängen", check: "Bestätigen" }[k];
      if (lab) { pb.setAttribute("aria-label", lab); if (!pb.title) pb.title = lab; }
    }
  }
  function replaceEmojis(root) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(n) {
        const p = n.parentElement;
        if (!p || p.closest(EMO_SKIP)) return NodeFilter.FILTER_REJECT;
        return EMO_TEST.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });
    const list = []; let n; while ((n = walker.nextNode())) list.push(n);
    list.forEach(replaceInText);
  }
  const NAV = { dashboard: "dashboard", daily: "daily", entries: "entries", connect: "connect", calendar: "calendar", bonushunt: "bonushunt", casinos: "casinos", partners: "partners", finance: "finance", team: "team", ftdbilanz: "analytics", streaming: "streaming", dashboards: "panels", giveaway: "ticket", halloween: "celebrate", metaspins: "celebrate", support: "chatdots", webseiten: "globe", postfach: "mail" };
  const STREAM_TABS = { plan: ["calendar", "Plan"], manage: ["settings", "Verwaltung"], store: ["store", "Store"] };

  function apply() {
    // Sidebar-Navigation
    document.querySelectorAll(".amkz-nav-item[data-view]").forEach((btn) => {
      const key = NAV[btn.dataset.view]; if (!key || !I[key]) return;
      let span = btn.querySelector("span");
      if (!span) { span = document.createElement("span"); btn.insertBefore(span, btn.firstChild); }
      if (span.dataset.ico !== key) { span.innerHTML = I[key]; span.dataset.ico = key; span.classList.add("amkz-ico"); }
    });
    // Streaming-Tabs (Plan / Verwaltung / Store)
    document.querySelectorAll(".amkz-stream-tab[data-stream-tab]").forEach((btn) => {
      const def = STREAM_TABS[btn.dataset.streamTab]; if (!def || !I[def[0]]) return;
      if (btn.dataset.ico === def[0]) return;
      btn.innerHTML = `<span class="amkz-ico">${I[def[0]]}</span><span class="amkz-tab-lbl">${def[1]}</span>`;
      btn.dataset.ico = def[0];
    });
  }
  AMKZ.applyIcons = apply;

  let writing = false;
  const run = () => {
    if (writing) return;
    writing = true;
    try { apply(); replaceEmojis(document.body); } catch (e) {} finally { writing = false; }
  };
  if (document.readyState !== "loading") run(); else document.addEventListener("DOMContentLoaded", run);
  // Tabs/Inhalte werden dynamisch nachgerendert -> nach jedem View-Wechsel erneut anwenden
  const prevLoad = AMKZ.loadView;
  AMKZ.loadView = async function (v, o) { const r = await (prevLoad ? prevLoad.call(this, v, o) : undefined); setTimeout(run, 60); return r; };
  // Live: dynamische DOM-Änderungen SYNCHRON (im MutationObserver-Microtask -> VOR dem Paint,
  // daher KEIN Aufblitzen der alten Emojis) und nur die geänderten Knoten verarbeiten.
  const obs = new MutationObserver((muts) => {
    if (writing) return;
    writing = true;
    try {
      for (const mu of muts) {
        if (mu.type === "characterData") { replaceInText(mu.target); continue; }
        mu.addedNodes.forEach((nd) => {
          if (nd.nodeType === 1) { if (!nd.closest || !nd.closest(EMO_SKIP)) replaceEmojis(nd); }
          else if (nd.nodeType === 3) replaceInText(nd);
        });
      }
    } catch (e) {} finally { writing = false; }
  });
  const startObs = () => { try { obs.observe(document.body, { childList: true, subtree: true, characterData: true }); } catch (e) {} };
  if (document.body) startObs(); else document.addEventListener("DOMContentLoaded", startObs);
  // Sicherheitsnetz
  setTimeout(run, 400); setTimeout(run, 1500);
})();

/* =====================================================
   AMK ZENTRALE — CRUD-ERWEITERUNG (Phase 1)
   „Alle Felder bearbeitbar + löschbar."
   - Deal:     bearbeiten (Karte klicken / ✎) + löschen (🗑)
   - Ausgabe:  bearbeiten (✎) + löschen (🗑)   [entries: OPERATING_EXPENSE]
   - Rechnung: löschen (🗑)   [Bearbeiten liefert schon das Inline-Edit-Modul]
   - Vertrag:  bearbeiten (✎) + löschen (🗑)
   Schreibt auf die echten Tabellen (deals / entries / finance_documents).
   RLS "for all using(true)" ist bereits gesetzt (supabase.sql).
   Läuft NACH den bestehenden enhance*-Funktionen (Timing 650ms > 500ms).
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__crudExtend) return;
  AMKZ.__crudExtend = true;

  const byId = (id) => document.getElementById(id);
  const val = (id) => byId(id)?.value ?? "";
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m])));
  const money = (AMKZ.utils && AMKZ.utils.money) || ((n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n || 0)));
  const num = (v) => { const n = Number(String(v).replace(",", ".").replace(/[^\d.-]/g, "")); return Number.isFinite(n) ? n : 0; };
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  // Eigene Implementierung MIT Vorauswahl (die Kern-optionList kennt kein 3. "selected"-Argument)
  const opt = (rows, ph, sel) => `<option value="">${esc(ph)}</option>` +
    (rows || []).map((r) => `<option value="${esc(r.id)}" ${String(r.id) === String(sel) ? "selected" : ""}>${esc(r.name || r.title || r.email || r.id)}</option>`).join("");
  const findById = (arr, id) => (arr || []).find((r) => String(r.id) === String(id)) || null;
  const pn = (id) => AMKZ.shared?.getPartnerName?.(id) || "—";
  const cn = (id) => AMKZ.shared?.getCasinoName?.(id) || "—";
  const nowISO = () => new Date().toISOString();
  const FIN_TABLES = ["finance_documents", "amk_finance_documents"];

  /* ---------- Supabase-Helfer (mehrere Tabellen-Fallbacks) ---------- */
  async function delRow(tables, id) {
    for (const t of tables) {
      try { const { error } = await AMKZ.supabase.from(t).delete().eq("id", id); if (!error) return true; } catch (_) {}
    }
    return false;
  }
  async function updRow(tables, id, payload) {
    for (const t of tables) {
      try { const { error } = await AMKZ.supabase.from(t).update(payload).eq("id", id); if (!error) return true; } catch (_) {}
    }
    return false;
  }
  async function reloadAll() {
    try { await AMKZ.data?.loadBaseData?.(true); } catch (_) {}
    try { await AMKZ.data?.loadDeals?.(true); } catch (_) {}
    try { await AMKZ.loadView(AMKZ.state.currentView, { force: true }); } catch (_) {}
    if (AMKZ.state.currentView === "finance") { try { await AMKZ.modules?.finance?.loadFinanceView?.(); } catch (_) {} }
    setTimeout(runEnhancers, 400);
  }

  /* ============ DEAL: bearbeiten ============ */
  function openDealEdit(id) {
    const d = findById(AMKZ.state.deals, id);
    if (!d) return;
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header"><div><h3>Deal bearbeiten</h3><p>${esc(d.title || "Deal")}</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <form id="amkDealEditForm" class="amkz-form-grid">
          <div class="amkz-input-group"><label>Titel</label><input id="deTitle" value="${esc(d.title || "")}" required></div>
          <div class="amkz-input-group"><label>Casino</label><select id="deCasino">${opt(AMKZ.state.casinos, "Kein Casino", d.casino_id)}</select></div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Deal-Typ</label>
              <select id="deType">${["revshare", "cpa", "hybrid", "fixed"].map((x) => `<option value="${x}" ${(d.deal_type || "") === x ? "selected" : ""}>${x}</option>`).join("")}</select></div>
            <div class="amkz-input-group"><label>Status</label>
              <select id="deStatus">${["active", "paused", "ended"].map((x) => `<option value="${x}" ${(d.status || "active") === x ? "selected" : ""}>${x}</option>`).join("")}</select></div>
          </div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>RevShare %</label><input id="deRev" type="number" step="0.01" value="${num(d.revshare_percent)}"></div>
            <div class="amkz-input-group"><label>CPA-Betrag</label><input id="deCpa" type="number" step="0.01" value="${num(d.cpa_amount)}"></div>
          </div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Fixbetrag</label><input id="deFixed" type="number" step="0.01" value="${num(d.fixed_fee)}"></div>
            <div class="amkz-input-group"><label>Startdatum</label><input id="deStart" type="date" value="${esc((d.start_date || "").slice(0, 10))}"></div>
          </div>
          <div class="amkz-input-group"><label>Enddatum</label><input id="deEnd" type="date" value="${esc((d.end_date || "").slice(0, 10))}"></div>
          <div class="amkz-input-group"><label>Notiz</label><textarea id="deNote">${esc(d.note || "")}</textarea></div>
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>`);
    byId("amkDealEditForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const title = val("deTitle").trim();
      const note = val("deNote").trim();
      const ok = await updRow(["deals"], id, {
        casino_id: val("deCasino") || null,
        deal_type: val("deType"),
        cpa_amount: num(val("deCpa")),
        revshare_percent: num(val("deRev")),
        fixed_amount: num(val("deFixed")),
        start_date: val("deStart") || null,
        end_date: val("deEnd") || null,
        notes: title + (note ? " · " + note : ""),
        updated_at: nowISO(),
      });
      if (!ok) return toast("Fehler", "Deal konnte nicht gespeichert werden (RLS?).", "error");
      // Status separat (Spalte existiert evtl. nicht -> Best effort, bricht das Speichern nicht)
      try { await AMKZ.supabase.from("deals").update({ status: val("deStatus") }).eq("id", id); } catch (_) {}
      AMKZ.modal.close(); toast("Gespeichert", "Deal aktualisiert."); reloadAll();
    });
  }

  /* ============ AUSGABE: bearbeiten ============ */
  function openExpenseEdit(id) {
    const x = findById(AMKZ.state.expenses, id);
    if (!x) return;
    const st = String(x.payment_status || "paid");
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header"><div><h3>Ausgabe bearbeiten</h3><p>${esc(x.note || "Ausgabe")}</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <form id="amkExpEditForm" class="amkz-form-grid">
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Datum</label><input id="exDate" type="date" value="${esc((x.entry_date || "").slice(0, 10))}"></div>
            <div class="amkz-input-group"><label>Betrag (€)</label><input id="exAmount" type="number" step="0.01" value="${num(x.amount)}"></div>
          </div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Partner</label><select id="exPartner">${opt(AMKZ.state.partners, "Kein Partner", x.partner_group_id)}</select></div>
            <div class="amkz-input-group"><label>Casino</label><select id="exCasino">${opt(AMKZ.state.casinos, "Kein Casino", x.casino_id)}</select></div>
          </div>
          <div class="amkz-input-group"><label>Status</label>
            <select id="exStatus">${[["paid", "Bezahlt / Raus"], ["open", "Offen"], ["pending", "Ausstehend"]].map(([v, l]) => `<option value="${v}" ${st === v ? "selected" : ""}>${l}</option>`).join("")}</select></div>
          <div class="amkz-input-group"><label>Notiz / Beschreibung</label><textarea id="exNote">${esc(x.note || "")}</textarea></div>
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>`);
    byId("amkExpEditForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const ok = await AMKZ.__entryUpd(id, {
        entry_date: val("exDate") || null,
        amount: num(val("exAmount")),
        partner_group_id: val("exPartner") || null,
        casino_id: val("exCasino") || null,
        payment_status: val("exStatus"),
        note: val("exNote"),
      });
      if (!ok) return toast("Fehler", "Ausgabe konnte nicht gespeichert werden (RLS?).", "error");
      AMKZ.modal.close(); toast("Gespeichert", "Ausgabe aktualisiert."); reloadAll();
    });
  }

  /* ============ VERTRAG: bearbeiten ============ */
  function openContractEdit(id) {
    const c = findById(AMKZ.state.contracts, id);
    if (!c) return;
    const st = String(c.status || "open");
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header"><div><h3>Vertrag bearbeiten</h3><p>${esc(c.title || "Vertrag")}</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <form id="amkConEditForm" class="amkz-form-grid">
          <div class="amkz-input-group"><label>Vertragsname</label><input id="coTitle" value="${esc(c.title || "")}" required></div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Partner</label><select id="coPartner">${opt(AMKZ.state.partners, "Kein Partner", c.partner_group_id)}</select></div>
            <div class="amkz-input-group"><label>Casino</label><select id="coCasino">${opt(AMKZ.state.casinos, "Kein Casino", c.casino_id)}</select></div>
          </div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Datum</label><input id="coDate" type="date" value="${esc((c.document_date || "").slice(0, 10))}"></div>
            <div class="amkz-input-group"><label>Betrag (€)</label><input id="coAmount" type="number" step="0.01" value="${num(c.amount)}"></div>
          </div>
          <div class="amkz-input-group"><label>Status</label>
            <select id="coStatus">${[["open", "Offen"], ["signed", "Unterschrieben"], ["archived", "Archiviert"]].map(([v, l]) => `<option value="${v}" ${st === v ? "selected" : ""}>${l}</option>`).join("")}</select></div>
          <div class="amkz-input-group"><label>Notiz</label><textarea id="coNote">${esc(c.note || "")}</textarea></div>
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>`);
    byId("amkConEditForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const ok = await updRow(FIN_TABLES, id, {
        title: val("coTitle").trim(),
        partner_group_id: val("coPartner") || null,
        casino_id: val("coCasino") || null,
        document_date: val("coDate") || null,
        amount: num(val("coAmount")),
        status: val("coStatus"),
        note: val("coNote"),
        updated_at: nowISO(),
      });
      if (!ok) return toast("Fehler", "Vertrag konnte nicht gespeichert werden (RLS?).", "error");
      AMKZ.modal.close(); toast("Gespeichert", "Vertrag aktualisiert."); reloadAll();
    });
  }

  /* ============ Löschen (mit Bestätigung) ============ */
  async function doDelete(kind, id, label, tables) {
    if (!window.confirm(`${label} wirklich unwiderruflich löschen?`)) return;
    const ok = await delRow(tables, id);
    if (!ok) return toast("Fehler", "Löschen nicht möglich (RLS/Verknüpfung?).", "error");
    toast("Gelöscht", `${kind} entfernt.`);
    reloadAll();
  }

  /* ============ Affordances einspielen (idempotent) ============ */
  function enhanceDeals() {
    const box = byId("amkzDealsList");
    if (!box) return;
    const list = AMKZ.state.deals || [];
    if (!list.length) return;
    box.innerHTML = list.map((d) => `
      <div class="amkz-table-row-card amk-crud-card" data-deal-card="${esc(d.id)}" title="Zum Bearbeiten klicken">
        <div class="amk-crud-actions">
          <button type="button" class="amk-crud-edit" data-deal-edit="${esc(d.id)}" title="Bearbeiten">✎</button>
          <button type="button" class="amk-crud-del" data-deal-del="${esc(d.id)}" title="Löschen">🗑</button>
        </div>
        <strong>${esc(d.title || "Deal")}</strong><br>
        <small>${esc(pn(d.partner_group_id))} · ${esc(cn(d.casino_id))} · ${esc(d.status || "active")}</small>
        <p>${esc(d.deal_type || "revshare")} · CPA ${money(d.cpa_amount || 0)} · RevShare ${Number(d.revshare_percent || 0)}% · Fixed ${money(d.fixed_fee || 0)}</p>
      </div>`).join("");
  }
  function enhanceExpenses() {
    const body = byId("amkzExpensesTableBody");
    if (!body) return;
    const list = AMKZ.state.expenses || [];
    if (!list.length) return;
    body.innerHTML = list.map((x) => `
      <tr data-expense-row="${esc(x.id)}">
        <td>${esc(x.entry_date || "—")}</td>
        <td>${esc(x.partner_name || pn(x.partner_group_id))}</td>
        <td>${esc(x.casino_name || cn(x.casino_id))}</td>
        <td class="amk-num">${money(x.amount || 0)}</td>
        <td>${esc(x.note || "—")}</td>
        <td>
          <span class="amkz-status-pill">${esc(x.payment_status || "open")}</span>
          <span class="amk-row-actions">
            <button type="button" class="amk-crud-edit" data-expense-edit="${esc(x.id)}" title="Bearbeiten">✎</button>
            <button type="button" class="amk-crud-del" data-expense-del="${esc(x.id)}" title="Löschen">🗑</button>
          </span>
        </td>
      </tr>`).join("");
  }
  function enhanceContracts() {
    const box = byId("amkzContractsList");
    if (!box) return;
    const list = AMKZ.state.contracts || [];
    if (!list.length) return;
    box.innerHTML = list.map((c) => `
      <div class="amkz-table-row-card amk-crud-card" data-contract-card="${esc(c.id)}" title="Zum Bearbeiten klicken">
        <div class="amk-crud-actions">
          <button type="button" class="amk-crud-edit" data-contract-edit="${esc(c.id)}" title="Bearbeiten">✎</button>
          <button type="button" class="amk-crud-del" data-contract-del="${esc(c.id)}" title="Löschen">🗑</button>
        </div>
        <strong>${esc(c.title || "Vertrag")}</strong><br>
        <small>${esc([c.partner_name, pn(c.partner_group_id)].find(function (n) { return n && n !== "—"; }) /* Nachtschicht 31.10.: kein „— ·“ */ || "Kein Partner")}${c.casino_name ? " · " + esc(c.casino_name) : ""} · ${esc(({ open: "Offen", paid: "Bezahlt", sent: "Gestellt / Gesendet", signed: "Unterschrieben", archived: "Archiviert" })[c.status || "open"] || c.status)}${c.document_date ? " · " + esc(String(c.document_date).replace(/^(\d{4})-(\d{2})-(\d{2}).*$/, "$3.$2.$1")) : ""}</small>
        <p>${money(c.amount || 0)}</p>
        ${c.file_url ? `<a class="amkz-doc-link" href="${esc(c.file_url)}" target="_blank" rel="noopener">Datei öffnen</a>` : `<small>Keine Datei hinterlegt</small>`}
        ${c.note ? `<p>${esc(c.note)}</p>` : ""}
      </div>`).join("");
  }
  function enhanceInvoicesDelete() {
    const body = byId("amkzInvoicesTableBody");
    if (!body) return;
    body.querySelectorAll("tr[data-invoice-id]").forEach((tr) => {
      const id = tr.getAttribute("data-invoice-id");
      const act = tr.querySelector(".amk-row-actions");
      if (act && !act.querySelector("[data-invoice-del]")) {
        const b = document.createElement("button");
        b.type = "button"; b.className = "amk-crud-del"; b.setAttribute("data-invoice-del", id); b.title = "Löschen"; b.textContent = "🗑";
        act.appendChild(b);
      }
    });
  }
  function runEnhancers() {
    try { enhanceDeals(); } catch (_) {}
    try { enhanceExpenses(); } catch (_) {}
    try { enhanceContracts(); } catch (_) {}
    try { enhanceInvoicesDelete(); } catch (_) {}
  }

  /* ============ Klick-Delegation ============ */
  document.addEventListener("click", async (e) => {
    // Deal
    const dEdit = e.target.closest("[data-deal-edit]");
    if (dEdit) { e.preventDefault(); e.stopPropagation(); openDealEdit(dEdit.getAttribute("data-deal-edit")); return; }
    const dDel = e.target.closest("[data-deal-del]");
    if (dDel) { e.preventDefault(); e.stopPropagation(); const d = findById(AMKZ.state.deals, dDel.getAttribute("data-deal-del")); doDelete("Deal", dDel.getAttribute("data-deal-del"), `Deal „${d?.title || ""}"`, ["deals"]); return; }
    const dCard = e.target.closest("[data-deal-card]");
    if (dCard) { openDealEdit(dCard.getAttribute("data-deal-card")); return; }
    // Ausgabe
    const xEdit = e.target.closest("[data-expense-edit]");
    if (xEdit) { e.preventDefault(); e.stopPropagation(); openExpenseEdit(xEdit.getAttribute("data-expense-edit")); return; }
    const xDel = e.target.closest("[data-expense-del]");
    if (xDel) { e.preventDefault(); e.stopPropagation(); const x = findById(AMKZ.state.expenses, xDel.getAttribute("data-expense-del")); doDelete("Ausgabe", xDel.getAttribute("data-expense-del"), `Ausgabe „${x?.note || ""}" (${money(x?.amount || 0)})`, ["entries"]); return; }
    // Vertrag
    const cEdit = e.target.closest("[data-contract-edit]");
    if (cEdit) { e.preventDefault(); e.stopPropagation(); openContractEdit(cEdit.getAttribute("data-contract-edit")); return; }
    const cDel = e.target.closest("[data-contract-del]");
    if (cDel) { e.preventDefault(); e.stopPropagation(); const c = findById(AMKZ.state.contracts, cDel.getAttribute("data-contract-del")); doDelete("Vertrag", cDel.getAttribute("data-contract-del"), `Vertrag „${c?.title || ""}"`, FIN_TABLES); return; }
    const cCard = e.target.closest("[data-contract-card]");
    if (cCard) { openContractEdit(cCard.getAttribute("data-contract-card")); return; }
    // Rechnung löschen
    const iDel = e.target.closest("[data-invoice-del]");
    if (iDel) { e.preventDefault(); e.stopPropagation(); const inv = findById(AMKZ.state.invoices, iDel.getAttribute("data-invoice-del")); doDelete("Rechnung", iDel.getAttribute("data-invoice-del"), `Rechnung „${inv?.title || ""}" (Achtung: Rechnungen müssen aufbewahrt werden (GoBD) – lieber Status auf „Archiviert“ setzen)`, FIN_TABLES) /* Nachtschicht 31.10.: GoBD-Hinweis */; return; }
  });

  /* ============ In View-Wechsel + Finance-Tabs einhängen ============ */
  const prevLoadView = AMKZ.loadView;
  AMKZ.loadView = async function crudLoadView(view, options) {
    const r = await (prevLoadView ? prevLoadView.call(this, view, options) : undefined);
    setTimeout(runEnhancers, 650);
    return r;
  };
  document.addEventListener("click", (e) => {
    if (e.target.closest(".amkz-finance-tab")) setTimeout(runEnhancers, 450);
  });

  /* ============ Styles (Gold-/Rot-Buttons, Theme-passend) ============ */
  if (!byId("amk-crud-style")) {
    const s = document.createElement("style");
    s.id = "amk-crud-style";
    s.textContent = `
      .amk-crud-card{position:relative;cursor:pointer;transition:border-color .15s,transform .05s;}
      .amk-crud-card:hover{border-color:rgba(212,175,55,.5);}
      .amk-crud-actions{position:absolute;top:10px;right:10px;display:flex;gap:6px;z-index:2;}
      .amk-crud-edit,.amk-crud-del{border:none;cursor:pointer;border-radius:8px;padding:4px 9px;font-size:13px;line-height:1;font-family:inherit;transition:background .15s,color .15s;}
      .amk-crud-edit{background:rgba(212,175,55,.16);color:#e9c76a;border:1px solid rgba(212,175,55,.38);}
      .amk-crud-edit:hover{background:rgba(212,175,55,.30);color:#fff;}
      .amk-crud-del{background:rgba(220,60,60,.14);color:#ff8080;border:1px solid rgba(220,60,60,.42);}
      .amk-crud-del:hover{background:rgba(220,60,60,.34);color:#fff;}
      td .amk-row-actions{display:inline-flex;gap:6px;margin-left:10px;vertical-align:middle;}
    `;
    document.head.appendChild(s);
  }

  // Falls die View schon offen ist (Modul lädt spät)
  setTimeout(runEnhancers, 900);

  AMKZ.crud = { openDealEdit, openExpenseEdit, openContractEdit, runEnhancers };
})();

/* =====================================================
   AMK ZENTRALE — STAKE / BANKROLL-TRACKING (Phase 2)
   Konto-Ledger je Mitarbeiter + Casino.
   Buchungen: Stake rein / Wager-Verlust / Wager-Gewinn / Auszahlung / Korrektur.
   Restguthaben = serverseitig (View v_amk_stake_accounts).
   Neuer Tab „Stakes" in den Finanzen (per JS eingehängt, eigene Sichtbarkeit).
   Benötigt: supabase-stakes.sql (sonst freundlicher Hinweis im Panel).
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__stakeModule) return;
  AMKZ.__stakeModule = true;

  const byId = (id) => document.getElementById(id);
  const val = (id) => byId(id)?.value ?? "";
  const chk = (id) => !!byId(id)?.checked;
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m])));
  const money = (AMKZ.utils && AMKZ.utils.money) || ((n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n || 0)));
  const num = (v) => { const n = Number(String(v).replace(",", ".").replace(/[^\d.-]/g, "")); return Number.isFinite(n) ? n : 0; };
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const opt = (rows, ph, sel) => `<option value="">${esc(ph)}</option>` + (rows || []).map((r) => `<option value="${esc(r.id)}" ${String(r.id) === String(sel) ? "selected" : ""}>${esc(r.name || r.title || r.id)}</option>`).join("");
  const findById = (arr, id) => (arr || []).find((r) => String(r.id) === String(id)) || null;
  const nowISO = () => new Date().toISOString();
  const today = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10) /* Nachtschicht 31.10.: Ortszeit statt UTC */;
  const member = () => AMKZ.state?.member || null;

  const KINDS = [
    { k: "stake_in", label: "Stake rein", cls: "in", sign: "+" },
    { k: "wager_win", label: "Wager-Gewinn", cls: "win", sign: "+" },
    { k: "wager_loss", label: "Wager-Verlust", cls: "loss", sign: "−" },
    { k: "payout", label: "Auszahlung an Firma", cls: "payout", sign: "−" },
    { k: "adjust", label: "Korrektur (+/−)", cls: "adjust", sign: "±" },
  ];
  const kindMeta = (k) => KINDS.find((x) => x.k === k) || { label: k, cls: "adjust", sign: "" };

  /* ---------- Daten laden ---------- */
  async function loadStakes() {
    AMKZ.state.stakeError = null;
    try {
      const { data: accs, error } = await AMKZ.supabase.from("v_amk_stake_accounts").select("*").order("created_at", { ascending: false });
      if (error) throw error;
      AMKZ.state.stakeAccounts = accs || [];
      const ids = (accs || []).map((a) => a.id);
      const byAcc = {};
      if (ids.length) {
        const { data: movs } = await AMKZ.supabase.from("amk_stake_movements").select("*").in("account_id", ids).order("movement_date", { ascending: false }).order("created_at", { ascending: false });
        (movs || []).forEach((m) => { (byAcc[m.account_id] = byAcc[m.account_id] || []).push(m); });
      }
      AMKZ.state.stakeMovements = byAcc;
    } catch (e) {
      AMKZ.state.stakeAccounts = [];
      AMKZ.state.stakeMovements = {};
      AMKZ.state.stakeError = e?.message || String(e);
    }
  }

  /* ---------- UI ---------- */
  // Stake ist jetzt direkt in die Ausgabe integriert (Partner -> "Stake").
  // Der frühere eigene "Stakes"-Tab wird daher NICHT mehr angezeigt/entfernt.
  function ensureStakesUi() {
    document.querySelector('.amkz-finance-tabs [data-finance-tab="stakes"]')?.remove();
    byId("amkzFinanceStakesPanel")?.remove();
  }

  /* ---------- Render ---------- */
  function renderStakes() {
    const box = byId("amkzStakesList");
    if (!box) return;
    if (AMKZ.state.stakeError) {
      box.innerHTML = `<div class="amkz-empty">Stake-Tabellen fehlen noch.<br><small>Bitte <b>supabase-stakes.sql</b> im Supabase SQL-Editor ausführen.</small><br><small style="opacity:.6">(${esc(AMKZ.state.stakeError)})</small></div>`;
      return;
    }
    const accs = AMKZ.state.stakeAccounts || [];
    if (!accs.length) { box.innerHTML = `<div class="amkz-empty">Noch keine Stake-Konten. Lege eins an (z. B. „Kevin @ Dice").</div>`; return; }
    box.innerHTML = accs.map((a) => {
      const movs = (AMKZ.state.stakeMovements || {})[a.id] || [];
      const remaining = Number(a.remaining || 0);
      const cName = a.casino_name || AMKZ.shared?.getCasinoName?.(a.casino_id) || "—";
      return `
        <div class="amkz-stk-acc" data-stake-acc="${esc(a.id)}">
          <div class="amkz-stk-head">
            <div class="amkz-stk-title">
              <strong>${esc(a.employee_name || "Mitarbeiter")}</strong>
              <span class="amkz-stk-at">@ ${esc(cName)}</span>
              ${a.label ? `<span class="amkz-stk-label">${esc(a.label)}</span>` : ""}
            </div>
            <div class="amkz-stk-remain">
              <small>Restguthaben</small>
              <strong class="${remaining < 0 ? "neg" : ""}">${money(remaining)}</strong>
            </div>
          </div>
          <div class="amkz-stk-stats">
            <span class="amkz-stk-chip in">Rein ${money(a.total_in || 0)}</span>
            <span class="amkz-stk-chip loss">Verloren ${money(a.total_loss || 0)}</span>
            <span class="amkz-stk-chip win">Gewonnen ${money(a.total_win || 0)}</span>
            <span class="amkz-stk-chip payout">Ausgezahlt ${money(a.total_payout || 0)}</span>
          </div>
          <div class="amkz-stk-actions">
            <button class="amkz-primary-btn amkz-stk-book" type="button" data-stake-book="${esc(a.id)}">+ Buchung</button>
            <button class="amk-crud-edit" type="button" data-stake-acc-edit="${esc(a.id)}" title="Konto bearbeiten">✎</button>
            <button class="amk-crud-del" type="button" data-stake-acc-del="${esc(a.id)}" title="Konto löschen">🗑</button>
          </div>
          <div class="amkz-stk-movs">
            ${movs.length ? movs.map((m) => {
              const km = kindMeta(m.kind);
              return `<div class="amkz-stk-mov ${km.cls}" data-stake-mov="${esc(m.id)}">
                <span class="amkz-stk-mov-date">${esc((m.movement_date || "").slice(0, 10) || "—")}</span>
                <span class="amkz-stk-mov-kind ${km.cls}">${esc(km.label)}</span>
                <span class="amkz-stk-mov-amt ${km.cls}">${km.sign}${money(Math.abs(Number(m.amount || 0)))}</span>
                <span class="amkz-stk-mov-note">${esc(m.note || "")}</span>
                <span class="amkz-stk-mov-act">
                  <button class="amk-crud-edit" type="button" data-stake-mov-edit="${esc(m.id)}" title="Bearbeiten">✎</button>
                  <button class="amk-crud-del" type="button" data-stake-mov-del="${esc(m.id)}" title="Löschen">🗑</button>
                </span>
              </div>`;
            }).join("") : `<div class="amkz-stk-empty">Noch keine Buchungen.</div>`}
          </div>
        </div>`;
    }).join("");
  }

  async function reloadStakes() { await loadStakes(); renderStakes(); }

  /* ---------- Modals ---------- */
  function empDatalist() {
    const names = new Set();
    (AMKZ.state.team || []).forEach((t) => { const n = t.name || t.display_name || t.email; if (n) names.add(n); });
    (AMKZ.state.stakeAccounts || []).forEach((a) => { if (a.employee_name) names.add(a.employee_name); });
    return `<datalist id="stkEmpList">${[...names].map((n) => `<option value="${esc(n)}"></option>`).join("")}</datalist>`;
  }

  function openStakeAccountModal(id) {
    const a = id ? findById(AMKZ.state.stakeAccounts, id) : null;
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header"><div><h3>${a ? "Stake-Konto bearbeiten" : "Neues Stake-Konto"}</h3><p>Arbeitskonto je Mitarbeiter · Casino</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <form id="amkStkAccForm" class="amkz-form-grid">
          ${empDatalist()}
          <div class="amkz-input-group"><label>Mitarbeiter</label><input id="stkEmp" list="stkEmpList" value="${esc(a?.employee_name || "")}" placeholder="z. B. Kevin" required></div>
          <div class="amkz-input-group"><label>Casino</label><select id="stkCasino">${opt(AMKZ.state.casinos, "Kein Casino", a?.casino_id)}</select></div>
          <div class="amkz-input-group"><label>Bezeichnung (optional)</label><input id="stkLabel" value="${esc(a?.label || "")}" placeholder="z. B. Dice-Bankroll"></div>
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>`);
    byId("amkStkAccForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const casinoId = val("stkCasino") || null;
      const casinoName = casinoId ? (AMKZ.shared?.getCasinoName?.(casinoId) || null) : null;
      const payload = {
        employee_name: val("stkEmp").trim(),
        casino_id: casinoId,
        casino_name: casinoName,
        label: val("stkLabel").trim() || null,
        updated_at: nowISO(),
      };
      let ok = false;
      try {
        if (a) { const { error } = await AMKZ.supabase.from("amk_stake_accounts").update(payload).eq("id", id); ok = !error; }
        else { payload.created_by = member()?.id || null; const { error } = await AMKZ.supabase.from("amk_stake_accounts").insert(payload); ok = !error; }
      } catch (_) {}
      if (!ok) return toast("Fehler", "Konto nicht speicherbar (supabase-stakes.sql ausgeführt?).", "error");
      AMKZ.modal.close(); toast("Gespeichert", a ? "Konto aktualisiert." : "Stake-Konto angelegt."); reloadStakes();
    });
  }

  function openStakeMovementModal(accountId, movId) {
    const acc = findById(AMKZ.state.stakeAccounts, accountId);
    if (!acc) return;
    const m = movId ? findById((AMKZ.state.stakeMovements || {})[accountId] || [], movId) : null;
    const curKind = m?.kind || "stake_in";
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header"><div><h3>${m ? "Buchung bearbeiten" : "Neue Buchung"}</h3><p>${esc(acc.employee_name)} @ ${esc(acc.casino_name || "—")}</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <form id="amkStkMovForm" class="amkz-form-grid">
          <div class="amkz-input-group"><label>Art</label>
            <select id="stkKind">${KINDS.map((x) => `<option value="${x.k}" ${curKind === x.k ? "selected" : ""}>${x.label}</option>`).join("")}</select></div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Betrag (€)</label><input id="stkAmount" type="number" step="0.01" value="${m ? num(m.amount) : ""}" placeholder="z. B. 10000" required></div>
            <div class="amkz-input-group"><label>Datum</label><input id="stkDate" type="date" value="${esc((m?.movement_date || today()).slice(0, 10))}"></div>
          </div>
          <div class="amkz-input-group"><label>Notiz</label><input id="stkNote" value="${esc(m?.note || "")}" placeholder="optional"></div>
          ${m ? "" : `<label class="amkz-stk-mirror"><input type="checkbox" id="stkMirror" checked> Bei „Stake rein" auch als <b>Ausgabe</b> in den Finanzen zeigen</label>`}
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>`);
    byId("amkStkMovForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const kind = val("stkKind");
      const amount = num(val("stkAmount"));
      const mvDate = val("stkDate") || today();
      const note = val("stkNote").trim();
      let ok = false;
      try {
        if (m) {
          const { error } = await AMKZ.supabase.from("amk_stake_movements").update({ kind, amount, movement_date: mvDate, note, updated_at: nowISO() }).eq("id", movId);
          ok = !error;
        } else {
          const { error } = await AMKZ.supabase.from("amk_stake_movements").insert({ account_id: accountId, kind, amount, movement_date: mvDate, note, created_by: member()?.id || null });
          ok = !error;
          // Spiegel-Ausgabe für „Stake rein"
          if (ok && kind === "stake_in" && chk("stkMirror") && AMKZ.save?.saveEntry) {
            try {
              await AMKZ.save.saveEntry({
                entryDate: mvDate, entryType: "OPERATING_EXPENSE",
                casinoId: acc.casino_id || "", amount,
                note: `Stake: ${acc.employee_name} → ${acc.casino_name || "Casino"}${note ? " · " + note : ""}`,
                paymentStatus: "paid",
              });
            } catch (mErr) { console.warn("Stake-Spiegel-Ausgabe", mErr); }
          }
        }
      } catch (_) {}
      if (!ok) return toast("Fehler", "Buchung nicht speicherbar.", "error");
      AMKZ.modal.close(); toast("Gebucht", m ? "Buchung aktualisiert." : "Buchung gespeichert.");
      reloadStakes();
      if (!m && kind === "stake_in" && chk("stkMirror") && AMKZ.state.currentView === "finance") { try { await AMKZ.modules?.finance?.loadFinanceView?.(); } catch (_) {} }
    });
  }

  /* ---------- Klick-Delegation ---------- */
  document.addEventListener("click", async (e) => {
    if (e.target.closest("[data-stake-add-account]")) { e.preventDefault(); openStakeAccountModal(null); return; }
    const book = e.target.closest("[data-stake-book]"); if (book) { e.preventDefault(); openStakeMovementModal(book.getAttribute("data-stake-book"), null); return; }
    const aEd = e.target.closest("[data-stake-acc-edit]"); if (aEd) { e.preventDefault(); openStakeAccountModal(aEd.getAttribute("data-stake-acc-edit")); return; }
    const aDel = e.target.closest("[data-stake-acc-del]"); if (aDel) {
      e.preventDefault(); const id = aDel.getAttribute("data-stake-acc-del"); const a = findById(AMKZ.state.stakeAccounts, id);
      if (!window.confirm(`Konto „${a?.employee_name || ""} @ ${a?.casino_name || ""}" inkl. aller Buchungen löschen?`)) return;
      let ok = false; try { const { error } = await AMKZ.supabase.from("amk_stake_accounts").delete().eq("id", id); ok = !error; } catch (_) {}
      if (!ok) return toast("Fehler", "Konto nicht löschbar.", "error");
      toast("Gelöscht", "Stake-Konto entfernt."); reloadStakes(); return;
    }
    const mEd = e.target.closest("[data-stake-mov-edit]"); if (mEd) {
      e.preventDefault(); const mid = mEd.getAttribute("data-stake-mov-edit"); const acc = e.target.closest("[data-stake-acc]")?.getAttribute("data-stake-acc");
      if (acc) openStakeMovementModal(acc, mid); return;
    }
    const mDel = e.target.closest("[data-stake-mov-del]"); if (mDel) {
      e.preventDefault(); const mid = mDel.getAttribute("data-stake-mov-del");
      if (!window.confirm("Diese Buchung löschen?")) return;
      let ok = false; try { const { error } = await AMKZ.supabase.from("amk_stake_movements").delete().eq("id", mid); ok = !error; } catch (_) {}
      if (!ok) return toast("Fehler", "Buchung nicht löschbar.", "error");
      toast("Gelöscht", "Buchung entfernt."); reloadStakes(); return;
    }
  });

  /* ---------- Tab-Sichtbarkeit ---------- */
  document.addEventListener("click", (e) => {
    const tabBtn = e.target.closest(".amkz-finance-tab");
    if (!tabBtn) return;
    const tab = tabBtn.dataset.financeTab;
    const panel = byId("amkzFinanceStakesPanel");
    if (!panel) return;
    if (tab === "stakes") {
      document.querySelectorAll(".amkz-finance-panel").forEach((p) => p.classList.toggle("is-hidden", p !== panel));
      document.querySelectorAll(".amkz-finance-tab").forEach((b) => b.classList.toggle("active", b === tabBtn));
      reloadStakes();
    } else {
      panel.classList.add("is-hidden"); // andere Tabs: mein Panel weg (Kern-switch kennt es nicht)
    }
  });

  /* ---------- In View-Wechsel einhängen ---------- */
  const prevLoadView = AMKZ.loadView;
  AMKZ.loadView = async function stakeLoadView(view, options) {
    const r = await (prevLoadView ? prevLoadView.call(this, view, options) : undefined);
    if (view === "finance") setTimeout(ensureStakesUi, 300);
    return r;
  };

  /* ---------- Styles ---------- */
  if (!byId("amk-stake-style")) {
    const s = document.createElement("style");
    s.id = "amk-stake-style";
    s.textContent = `
      .amkz-stk-list{display:flex;flex-direction:column;gap:14px;}
      .amkz-stk-acc{border:1px solid rgba(212,175,55,.22);border-radius:16px;padding:16px 18px;background:linear-gradient(180deg,rgba(255,255,255,.03),rgba(0,0,0,.12));}
      .amkz-stk-head{display:flex;justify-content:space-between;align-items:flex-start;gap:12px;flex-wrap:wrap;}
      .amkz-stk-title{display:flex;align-items:baseline;gap:8px;flex-wrap:wrap;}
      .amkz-stk-title strong{font-size:1.12rem;}
      .amkz-stk-at{opacity:.7;font-size:.92rem;}
      .amkz-stk-label{font-size:.72rem;padding:2px 8px;border-radius:999px;background:rgba(212,175,55,.16);color:#e9c76a;border:1px solid rgba(212,175,55,.3);}
      .amkz-stk-remain{text-align:right;}
      .amkz-stk-remain small{display:block;opacity:.6;font-size:.7rem;text-transform:uppercase;letter-spacing:.04em;}
      .amkz-stk-remain strong{font-size:1.5rem;background:linear-gradient(90deg,#f4d98a,#c79b3b);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;}
      .amkz-stk-remain strong.neg{background:none;-webkit-text-fill-color:#ff8080;color:#ff8080;}
      .amkz-stk-stats{display:flex;flex-wrap:wrap;gap:8px;margin:12px 0;}
      .amkz-stk-chip{font-size:.76rem;padding:4px 10px;border-radius:999px;border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.04);}
      .amkz-stk-chip.in{color:#9fd8a0;border-color:rgba(120,200,120,.3);}
      .amkz-stk-chip.loss{color:#ff9a9a;border-color:rgba(220,90,90,.3);}
      .amkz-stk-chip.win{color:#e9c76a;border-color:rgba(212,175,55,.3);}
      .amkz-stk-chip.payout{color:#9fc0e8;border-color:rgba(90,140,220,.3);}
      .amkz-stk-actions{display:flex;gap:8px;align-items:center;margin-bottom:10px;}
      .amkz-stk-actions .amkz-stk-book{padding:7px 14px;font-size:.85rem;}
      .amkz-stk-movs{display:flex;flex-direction:column;gap:2px;border-top:1px solid rgba(255,255,255,.07);padding-top:8px;}
      .amkz-stk-mov{display:grid;grid-template-columns:88px 130px 110px 1fr auto;gap:8px;align-items:center;padding:6px 4px;border-radius:8px;font-size:.86rem;}
      .amkz-stk-mov:hover{background:rgba(255,255,255,.04);}
      .amkz-stk-mov-date{opacity:.65;font-variant-numeric:tabular-nums;}
      .amkz-stk-mov-kind{font-size:.74rem;}
      .amkz-stk-mov-kind.in,.amkz-stk-mov-amt.in{color:#9fd8a0;}
      .amkz-stk-mov-kind.loss,.amkz-stk-mov-amt.loss{color:#ff9a9a;}
      .amkz-stk-mov-kind.win,.amkz-stk-mov-amt.win{color:#e9c76a;}
      .amkz-stk-mov-kind.payout,.amkz-stk-mov-amt.payout{color:#9fc0e8;}
      .amkz-stk-mov-amt{font-weight:700;text-align:right;font-variant-numeric:tabular-nums;}
      .amkz-stk-mov-note{opacity:.7;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
      .amkz-stk-mov-act{display:inline-flex;gap:5px;}
      .amkz-stk-empty,.amkz-stk-sub{opacity:.55;font-size:.8rem;padding:4px 0;}
      .amkz-stk-mirror{display:flex;align-items:center;gap:8px;font-size:.85rem;opacity:.9;cursor:pointer;}
      .amkz-stk-mirror input{width:auto;}
      @media(max-width:760px){.amkz-stk-mov{grid-template-columns:1fr auto;grid-auto-rows:min-content;}.amkz-stk-mov-note{grid-column:1/-1;white-space:normal;}.amkz-stk-mov-date{order:1}.amkz-stk-mov-kind{order:2;text-align:right}.amkz-stk-mov-amt{order:3}.amkz-stk-mov-act{order:4}}
    `;
    document.head.appendChild(s);
  }

  AMKZ.stakes = { loadStakes, renderStakes, ensureStakesUi, openStakeAccountModal, openStakeMovementModal, reloadStakes };
})();

/* =====================================================
   AMK ZENTRALE — BELEG-SCAN (Phase 3)
   Foto/PDF vom Restaurant/Hotel -> Claude Vision (Edge Function
   scan-receipt) -> editierbare Vorschau -> als Ausgabe speichern.
   Button „📷 Beleg scannen" im Ausgaben-Panel.
   Benötigt: Edge Function `scan-receipt` deployed + Secret ANTHROPIC_API_KEY.
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__receiptScan) return;
  AMKZ.__receiptScan = true;

  const byId = (id) => document.getElementById(id);
  const val = (id) => byId(id)?.value ?? "";
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m])));
  const money = (AMKZ.utils && AMKZ.utils.money) || ((n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n || 0)));
  const num = (v) => { const n = Number(String(v).replace(",", ".").replace(/[^\d.-]/g, "")); return Number.isFinite(n) ? n : 0; };
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const opt = (rows, ph, sel) => `<option value="">${esc(ph)}</option>` +
    (rows || []).map((r) => `<option value="${esc(r.id)}" ${String(r.id) === String(sel) ? "selected" : ""}>${esc(r.name || r.title || r.id)}</option>`).join("");
  const today = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10) /* Nachtschicht 31.10.: Ortszeit statt UTC */;
  const CATS = ["Restaurant", "Hotel", "Reise", "Transport", "Lebensmittel", "Büro", "Unterhaltung", "Sonstiges"];
  const DOC_BUCKET = "amk-documents";

  function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(String(r.result || "").replace(/^data:[^,]+,/, ""));
      r.onerror = () => reject(new Error("Datei nicht lesbar"));
      r.readAsDataURL(file);
    });
  }
  function endpoint() {
    const root = byId("amkzApp");
    const url = (root?.dataset?.supabaseUrl || "").replace(/\/$/, "");
    const anon = root?.dataset?.supabaseKey || "";
    return { url: url ? url + "/functions/v1/scan-receipt" : "", anon };
  }

  /* ---------- Scan-Button einhängen ---------- */
  function ensureScanButton() {
    const createBtn = byId("amkzCreateExpenseButton");
    const host = createBtn?.parentElement || byId("amkzFinanceExpensesPanel")?.querySelector(".amkz-card-header");
    if (!host || host.querySelector("[data-receipt-scan]")) return;
    const b = document.createElement("button");
    b.type = "button"; b.className = "amkz-secondary-btn amkz-receipt-btn"; b.dataset.receiptScan = "1";
    b.innerHTML = "📷 Beleg scannen";
    if (createBtn) createBtn.insertAdjacentElement("beforebegin", b);
    else host.appendChild(b);
  }

  /* ---------- Modal Schritt 1: Upload ---------- */
  function openScanModal() {
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header"><div><h3>Beleg scannen</h3><p>Foto oder PDF hochladen — wird automatisch als Ausgabe erkannt</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <div class="amkz-form-grid">
          <div class="amkz-input-group">
            <label>Beleg (Foto oder PDF)</label>
            <input id="rcFile" type="file" accept="image/*,application/pdf" capture="environment">
          </div>
          <div id="rcPreview" class="amkz-rc-preview is-hidden"></div>
          <div id="rcStatus" class="amkz-rc-status"></div>
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" id="rcAnalyze" type="button" disabled>Analysieren</button>
          </div>
        </div>
      </div>`);

    const fileInput = byId("rcFile");
    const analyzeBtn = byId("rcAnalyze");
    let currentFile = null;

    fileInput?.addEventListener("change", () => {
      currentFile = fileInput.files?.[0] || null;
      analyzeBtn.disabled = !currentFile;
      const prev = byId("rcPreview");
      if (currentFile && /^image\//.test(currentFile.type)) {
        const u = URL.createObjectURL(currentFile);
        prev.innerHTML = `<img src="${u}" alt="Beleg">`;
        prev.classList.remove("is-hidden");
      } else if (currentFile) {
        prev.innerHTML = `<div class="amkz-rc-file">📄 ${esc(currentFile.name)}</div>`;
        prev.classList.remove("is-hidden");
      } else {
        prev.classList.add("is-hidden"); prev.innerHTML = "";
      }
    });

    analyzeBtn?.addEventListener("click", async () => {
      if (!currentFile) return;
      const { url, anon } = endpoint();
      if (!url) { toast("Fehler", "Supabase-URL fehlt.", "error"); return; }
      const status = byId("rcStatus");
      analyzeBtn.disabled = true;
      status.innerHTML = `<span class="amkz-rc-spin"></span> Beleg wird gelesen …`;
      try {
        const b64 = await fileToBase64(currentFile);
        const res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: "Bearer " + anon, apikey: anon },
          body: JSON.stringify({ fileBase64: b64, mediaType: currentFile.type || "image/jpeg", fileName: currentFile.name }),
        });
        const out = await res.json().catch(() => null);
        if (!res.ok || !out?.ok) {
          const msg = out?.error || `HTTP ${res.status}`;
          status.innerHTML = `<span class="amkz-rc-err">⚠︎ ${esc(msg)}</span>`;
          analyzeBtn.disabled = false;
          if (res.status === 404) status.innerHTML += `<br><small>Edge Function „scan-receipt" ist noch nicht deployed.</small>`;
          return;
        }
        openReviewForm(out.data || {}, currentFile);
      } catch (e) {
        status.innerHTML = `<span class="amkz-rc-err">⚠︎ ${esc(String(e?.message || e))}</span>`;
        analyzeBtn.disabled = false;
      }
    });
  }

  /* ---------- Modal Schritt 2: Vorschau prüfen ---------- */
  function openReviewForm(d, file) {
    const cat = CATS.includes(d.category) ? d.category : "Sonstiges";
    const vatLine = (Number(d.vat_amount) || Number(d.vat_rate))
      ? `MwSt: ${money(d.vat_amount || 0)}${d.vat_rate ? " (" + Number(d.vat_rate) + "%)" : ""}` : "keine MwSt erkannt";
    AMKZ.modal.open(`
      <div class="amkz-modal">
        <div class="amkz-modal-header"><div><h3>Ausgabe prüfen</h3><p>Automatisch erkannt — bitte kontrollieren, dann speichern</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <form id="rcForm" class="amkz-form-grid">
          <div class="amkz-rc-detected">🧾 ${esc(d.merchant || "Beleg")} · ${esc(vatLine)}</div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Datum</label><input id="rcDate" type="date" value="${esc((d.date || today()).slice(0, 10) || today())}"></div>
            <div class="amkz-input-group"><label>Betrag (${esc(d.currency || "EUR")})</label><input id="rcAmount" type="number" step="0.01" value="${num(d.amount)}" required></div>
          </div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Kategorie</label>
              <select id="rcCat">${CATS.map((c) => `<option value="${c}" ${c === cat ? "selected" : ""}>${c}</option>`).join("")}</select></div>
            <div class="amkz-input-group"><label>Status</label>
              <select id="rcStatusSel">${[["paid", "Bezahlt"], ["open", "Offen"], ["pending", "Ausstehend"]].map(([v, l]) => `<option value="${v}" ${v === "paid" ? "selected" : ""}>${l}</option>`).join("")}</select></div>
          </div>
          <div class="amkz-input-group"><label>Beschreibung / Händler</label>
            <input id="rcNote" value="${esc(d.merchant ? d.merchant + (d.note && d.note !== d.merchant ? " · " + d.note : "") : (d.note || ""))}"></div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Partner (optional)</label><select id="rcPartner">${opt(AMKZ.state.partners, "Kein Partner")}</select></div>
            <div class="amkz-input-group"><label>Casino (optional)</label><select id="rcCasino">${opt(AMKZ.state.casinos, "Kein Casino")}</select></div>
          </div>
          <label class="amkz-stk-mirror"><input type="checkbox" id="rcAttach" checked> Beleg-Datei mit speichern (im Dokumente-Bucket)</label>
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Als Ausgabe speichern</button>
          </div>
        </form>
      </div>`);

    byId("rcForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const submit = e.target.querySelector('button[type="submit"]');
      if (submit) { submit.disabled = true; submit.textContent = "Speichert …"; }
      try {
        // 1) Beleg optional hochladen
        let receiptUrl = "";
        if (byId("rcAttach")?.checked && file) {
          try {
            const safe = file.name.replace(/[^\w.\-äöüÄÖÜß]/g, "_");
            const path = `receipts/${Date.now()}_${safe}`;
            const up = await AMKZ.supabase.storage.from(DOC_BUCKET).upload(path, file, { upsert: true });
            if (!up.error) receiptUrl = AMKZ.supabase.storage.from(DOC_BUCKET).getPublicUrl(path).data?.publicUrl || "";
          } catch (_) {}
        }
        // 2) Ausgabe (entry) anlegen — nutzt getesteten saveEntry
        const row = await AMKZ.save.saveEntry({
          entryDate: val("rcDate") || today(),
          entryType: "OPERATING_EXPENSE",
          partnerGroupId: val("rcPartner") || "",
          casinoId: val("rcCasino") || "",
          amount: num(val("rcAmount")),
          note: `${val("rcNote").trim() || "Beleg"} · ${val("rcCat")}`,
          paymentStatus: val("rcStatusSel") || "paid",
        });
        // 3) Zusatzinfos (Kategorie/MwSt/Beleg-URL) in metadata nachtragen
        if (row?.id) {
          try {
            await AMKZ.supabase.from("entries").update({
              metadata: { ...(row.metadata || {}), category: val("rcCat"), vat_amount: num(d.vat_amount), vat_rate: num(d.vat_rate), receipt_url: receiptUrl, source_scan: true },
            }).eq("id", row.id);
          } catch (_) {}
        }
        AMKZ.modal.close();
        toast("Gespeichert", "Beleg als Ausgabe eingetragen.");
        if (AMKZ.state.currentView === "finance") { try { await AMKZ.modules?.finance?.loadFinanceView?.(); } catch (_) {} }
        try { await AMKZ.data?.loadBaseData?.(true); } catch (_) {}
        setTimeout(() => { try { AMKZ.crud?.runEnhancers?.(); } catch (_) {} }, 400);
      } catch (err) {
        console.error(err);
        toast("Fehler", err?.message || "Konnte nicht gespeichert werden.", "error");
        if (submit) { submit.disabled = false; submit.textContent = "Als Ausgabe speichern"; }
      }
    });
  }

  /* ---------- Verdrahtung ---------- */
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-receipt-scan]")) { e.preventDefault(); openScanModal(); return; }
    if (e.target.closest('.amkz-finance-tab[data-finance-tab="expenses"]')) setTimeout(ensureScanButton, 300);
  });
  const prevLoadView = AMKZ.loadView;
  AMKZ.loadView = async function receiptLoadView(view, options) {
    const r = await (prevLoadView ? prevLoadView.call(this, view, options) : undefined);
    if (view === "finance") setTimeout(ensureScanButton, 400);
    return r;
  };

  /* ---------- Styles ---------- */
  if (!byId("amk-receipt-style")) {
    const s = document.createElement("style");
    s.id = "amk-receipt-style";
    s.textContent = `
      .amkz-receipt-btn{border:1px solid rgba(212,175,55,.4)!important;color:#e9c76a!important;}
      .amkz-receipt-btn:hover{background:rgba(212,175,55,.16)!important;}
      .amkz-rc-preview{border:1px dashed rgba(212,175,55,.3);border-radius:12px;padding:10px;text-align:center;background:rgba(255,255,255,.03);}
      .amkz-rc-preview img{max-width:100%;max-height:260px;border-radius:8px;}
      .amkz-rc-file{padding:14px;color:#e9c76a;font-size:.95rem;}
      .amkz-rc-status{min-height:20px;font-size:.9rem;display:flex;align-items:center;gap:8px;flex-wrap:wrap;}
      .amkz-rc-err{color:#ff8080;}
      .amkz-rc-detected{padding:10px 12px;border-radius:10px;background:rgba(212,175,55,.12);border:1px solid rgba(212,175,55,.3);color:#e9c76a;font-size:.92rem;}
      .amkz-rc-spin{width:15px;height:15px;border:2px solid rgba(212,175,55,.3);border-top-color:#e9c76a;border-radius:50%;display:inline-block;animation:amkzRcSpin .8s linear infinite;}
      @keyframes amkzRcSpin{to{transform:rotate(360deg)}}
    `;
    document.head.appendChild(s);
  }

  AMKZ.receipt = { openScanModal, ensureScanButton, openReviewForm };
})();

/* =====================================================
   AMK ZENTRALE — STAKE IN AUSGABE (statt eigenem Tab)
   Beim Ausgabe-Eintrag: Partner -> "🎰 Stake" wählen.
   Dann klappt eine Stake-Ausgabe auf: Mitarbeiter, Casino,
   "Geschickt" (z. B. 10.000€ -> geht in die Ausgaben) und
   "Übrig nach Wager" (z. B. 9.873€ -> tatsächlich verfügbar).
   Verlust = Geschickt − Übrig wird automatisch berechnet.
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__stakeExpense) return;
  AMKZ.__stakeExpense = true;

  const byId = (id) => document.getElementById(id);
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m])));
  const money = (AMKZ.utils && AMKZ.utils.money) || ((n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n || 0)));
  const num = (v) => { const n = Number(String(v).replace(",", ".").replace(/[^\d.-]/g, "")); return Number.isFinite(n) ? n : 0; };
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const cn = (id) => AMKZ.shared?.getCasinoName?.(id) || "";
  const today = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10) /* Nachtschicht 31.10.: Ortszeit statt UTC */;
  const STAKE = "__STAKE__";

  function empNames() {
    const set = new Set();
    (AMKZ.state?.team || []).forEach((t) => { const nm = t.name || t.display_name || t.email; if (nm) set.add(nm); });
    (AMKZ.state?.expenses || []).forEach((x) => { const e = x?.metadata?.employee; if (e) set.add(e); });
    return [...set];
  }

  function ensureStakeOption() {
    const typeSel = byId("amkzEntryType"), partnerSel = byId("amkzEntryPartner");
    if (!typeSel || !partnerSel) return;
    const isExpense = typeSel.value === "OPERATING_EXPENSE";
    const existing = partnerSel.querySelector('option[value="' + STAKE + '"]');
    if (isExpense && !existing) {
      const o = document.createElement("option");
      o.value = STAKE; o.textContent = "🎰 Stake (Arbeitskapital)";
      partnerSel.insertBefore(o, partnerSel.options[1] || null);
    } else if (!isExpense && existing) {
      if (partnerSel.value === STAKE) { partnerSel.value = ""; exitStakeMode(); }
      existing.remove();
    }
  }

  function grp(id) { return byId(id)?.closest(".amkz-input-group") || null; }
  function row(id) { return byId(id)?.closest(".amkz-form-row") || null; }

  function enterStakeMode() {
    const form = byId("amkzEntryForm");
    if (!form || byId("amkzStakeBlock")) return;
    [grp("amkzEntryAmount"), grp("amkzEntryDeal"), row("amkzCustomerName"), grp("amkzWalletAddress")]
      .forEach((el) => { if (el) { el.dataset.stakeHidden = "1"; el.style.display = "none"; } });
    const anchor = row("amkzEntryPartner") || grp("amkzEntryCasino");
    const block = document.createElement("div");
    block.id = "amkzStakeBlock"; block.className = "amkz-stkx-block";
    block.innerHTML = `
      <div class="amkz-stkx-head">🎰 Stake-Ausgabe — Arbeitskapital</div>
      <datalist id="stkxEmpList">${empNames().map((n) => `<option value="${esc(n)}"></option>`).join("")}</datalist>
      <div class="amkz-input-group"><label>Mitarbeiter</label><input id="stkxEmp" list="stkxEmpList" placeholder="z. B. Kevin"></div>
      <div class="amkz-form-row">
        <div class="amkz-input-group"><label>Geschickt (kommt in Ausgaben)</label><input id="stkxSent" type="number" step="0.01" min="0" placeholder="10000"></div>
        <div class="amkz-input-group"><label>Übrig nach Wager (verfügbar)</label><input id="stkxRemain" type="number" step="0.01" min="0" placeholder="9873"></div>
      </div>
      <div class="amkz-stkx-loss" id="stkxLoss">Verlust: —</div>`;
    (anchor || form).insertAdjacentElement("afterend", block);

    const recalc = () => {
      const s = num(byId("stkxSent")?.value), r = num(byId("stkxRemain")?.value);
      const l = s - r;
      byId("stkxLoss").innerHTML = s ? `Geht in Ausgaben: <b>${money(s)}</b> · Verfügbar: <b>${money(r)}</b> · Verlust: <b class="${l > 0 ? "neg" : ""}">${money(l)}</b>` : "Verlust: —";
    };
    byId("stkxSent")?.addEventListener("input", recalc);
    byId("stkxRemain")?.addEventListener("input", recalc);
    const submit = form.querySelector('button[type="submit"]');
    if (submit) { submit.dataset.stakeLabel = submit.textContent; submit.textContent = "Stake-Ausgabe speichern"; }
  }

  function exitStakeMode() {
    byId("amkzStakeBlock")?.remove();
    document.querySelectorAll('[data-stake-hidden="1"]').forEach((el) => { el.style.display = ""; el.removeAttribute("data-stake-hidden"); });
    const submit = byId("amkzEntryForm")?.querySelector('button[type="submit"]');
    if (submit && submit.dataset.stakeLabel) { submit.textContent = submit.dataset.stakeLabel; delete submit.dataset.stakeLabel; }
  }

  function wire() {
    const form = byId("amkzEntryForm");
    if (!form || form.dataset.stakeWired) return;
    form.dataset.stakeWired = "1";
    const typeSel = byId("amkzEntryType"), partnerSel = byId("amkzEntryPartner");
    ensureStakeOption();
    typeSel?.addEventListener("change", () => { ensureStakeOption(); if (partnerSel?.value !== STAKE) exitStakeMode(); });
    partnerSel?.addEventListener("change", () => { if (partnerSel.value === STAKE) enterStakeMode(); else exitStakeMode(); });
  }

  // Submit abfangen, wenn Stake-Modus aktiv (Capture -> vor dem Core-Handler)
  document.addEventListener("submit", async (e) => {
    if (e.target?.id !== "amkzEntryForm") return;
    if (byId("amkzEntryPartner")?.value !== STAKE) return;
    e.preventDefault(); e.stopImmediatePropagation();
    const member = AMKZ.state?.member;
    if (!member?.id) return toast("Fehler", "Nicht angemeldet.", "error");
    const sent = num(byId("stkxSent")?.value);
    const remain = num(byId("stkxRemain")?.value);
    if (sent <= 0) return toast("Fehler", "Geschickt-Betrag fehlt.", "error");
    const emp = (byId("stkxEmp")?.value || "").trim();
    const casinoId = byId("amkzEntryCasino")?.value || "";
    const casinoName = cn(casinoId);
    const date = byId("amkzEntryDate")?.value || today();
    const base = (byId("amkzEntryNote")?.value || "").trim();
    const loss = sent - remain;
    const note = `Stake: ${emp || "—"}${casinoName ? " → " + casinoName : ""} · geschickt ${money(sent)} · übrig ${money(remain)} · Verlust ${money(loss)}${base ? " · " + base : ""}`;
    const btn = e.target.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = "Speichert …"; }
    try {
      const rowData = await AMKZ.save.saveEntry({ entryDate: date, entryType: "OPERATING_EXPENSE", casinoId, amount: sent, note, paymentStatus: "paid" });
      if (rowData?.id) {
        try {
          await AMKZ.supabase.from("entries").update({ metadata: { ...(rowData.metadata || {}), stake: true, employee: emp, sent, remaining: remain, loss } }).eq("id", rowData.id);
        } catch (_) {}
      }
      AMKZ.modal.close();
      toast("Gespeichert", `Stake-Ausgabe: ${money(sent)} raus, ${money(remain)} verfügbar.`);
      try { await AMKZ.data?.loadBaseData?.(true); } catch (_) {}
      if (AMKZ.state.currentView === "finance") { try { await AMKZ.modules?.finance?.loadFinanceView?.(); } catch (_) {} }
      setTimeout(() => { try { AMKZ.crud?.runEnhancers?.(); } catch (_) {} updateStakeSummary(); }, 400);
    } catch (err) {
      console.error(err);
      if (btn) { btn.disabled = false; btn.textContent = "Stake-Ausgabe speichern"; }
      toast("Fehler", err?.message || "Konnte nicht gespeichert werden.", "error");
    }
  }, true);

  /* ---------- „Stake übrig gesamt"-Badge im Ausgaben-Panel ---------- */
  function updateStakeSummary() {
    const panel = byId("amkzFinanceExpensesPanel");
    const header = panel?.querySelector(".amkz-card-header");
    if (!header) return;
    const stakes = (AMKZ.state?.expenses || []).filter((x) => x?.metadata?.stake);
    let badge = byId("amkzStakeAvail");
    if (!stakes.length) { badge?.remove(); return; }
    const avail = stakes.reduce((a, x) => a + num(x.metadata.remaining), 0);
    const lost = stakes.reduce((a, x) => a + num(x.metadata.loss), 0);
    if (!badge) {
      badge = document.createElement("div"); badge.id = "amkzStakeAvail"; badge.className = "amkz-stkx-avail";
      header.appendChild(badge);
    }
    badge.innerHTML = `🎰 Stake verfügbar: <b>${money(avail)}</b> · Verlust ges.: <b>${money(lost)}</b>`;
  }

  /* ---------- Modal-Öffnen erkennen + Summary hooken ---------- */
  const mo = new MutationObserver(() => { if (byId("amkzEntryForm")) wire(); });
  mo.observe(byId("amkzModalOverlay") || document.body, { childList: true, subtree: true });

  const prevLoadView = AMKZ.loadView;
  AMKZ.loadView = async function stakeExpLoadView(view, options) {
    const r = await (prevLoadView ? prevLoadView.call(this, view, options) : undefined);
    if (view === "finance") setTimeout(updateStakeSummary, 700);
    return r;
  };
  document.addEventListener("click", (e) => {
    if (e.target.closest('.amkz-finance-tab[data-finance-tab="expenses"]')) setTimeout(updateStakeSummary, 500);
  });

  if (!byId("amk-stkx-style")) {
    const s = document.createElement("style");
    s.id = "amk-stkx-style";
    s.textContent = `
      .amkz-stkx-block{border:1px solid rgba(212,175,55,.3);border-radius:12px;padding:12px 14px;margin:4px 0;background:rgba(212,175,55,.06);display:flex;flex-direction:column;gap:10px;}
      .amkz-stkx-head{color:#e9c76a;font-weight:700;font-size:.95rem;}
      .amkz-stkx-loss{font-size:.86rem;opacity:.9;}
      .amkz-stkx-loss b.neg{color:#ff8080;}
      .amkz-stkx-avail{font-size:.8rem;padding:5px 11px;border-radius:999px;background:rgba(212,175,55,.14);border:1px solid rgba(212,175,55,.3);color:#e9c76a;}
    `;
    document.head.appendChild(s);
  }

  AMKZ.stakeExpense = { updateStakeSummary };
})();

/* =====================================================
   AMK ZENTRALE — DESIGN REFRESH v2 (Designer-Politur)
   Feine Verbesserungsebene über der Dark-Luxe-Basis:
   weichere Gold-Akzente, mehr Tiefe/Glas, ruhigere Karten,
   bessere Tabellen/Inputs/Buttons/Hover. Nur kosmetisch,
   keine Layout-Struktur. Wird NACH der CSS-Datei injiziert.
===================================================== */
(function () {
  "use strict";
  return; /* PREMIUM 2026: globaler Design-Injektor deaktiviert - Optik kommt jetzt allein aus amk-zentrale.css (Master Premium Layer) */
  if (document.getElementById("amk-refresh-v2")) return;
  const s = document.createElement("style");
  s.id = "amk-refresh-v2";
  s.textContent = `
    :root{ --lxg:#e9cd86; --lxg2:#c79b3b; }
    html{ -webkit-font-smoothing:antialiased; text-rendering:optimizeLegibility; }
    ::selection{ background:rgba(212,175,55,.28); color:#fff; }

    /* ---- Karten: ruhiger, mehr Tiefe, dezenter Rand statt harter Balken ---- */
    .amkz-card, .amkz-kpi-card, .amkz-table-row-card{
      border:1px solid rgba(212,175,55,.14) !important;
      border-radius:20px !important;
      background:
        linear-gradient(180deg, rgba(255,255,255,.035), rgba(255,255,255,0) 42%),
        #14141b !important;
      box-shadow:0 1px 0 rgba(255,255,255,.04) inset, 0 18px 44px -18px rgba(0,0,0,.7) !important;
      transition:transform .18s ease, border-color .18s ease, box-shadow .18s ease;
    }
    .amkz-card:hover, .amkz-kpi-card:hover{
      border-color:rgba(212,175,55,.34) !important;
      box-shadow:0 1px 0 rgba(255,255,255,.06) inset, 0 24px 60px -20px rgba(0,0,0,.8), 0 0 0 1px rgba(212,175,55,.05) !important;
    }
    /* harte Gold-Oberkante der KPIs -> elegant zentriert & weich */
    .amkz-kpi-card::after{
      left:50% !important; right:auto !important; transform:translateX(-50%);
      width:46% !important; height:2px !important; opacity:.55 !important; border-radius:2px;
      background:linear-gradient(90deg, transparent, var(--lxg), transparent) !important;
    }
    .amkz-kpi-card{ padding:20px 22px !important; }
    .amkz-kpi-card:hover{ transform:translateY(-3px); }
    .amkz-kpi-card small{ letter-spacing:.08em; text-transform:uppercase; opacity:.62; font-size:.68rem; }
    .amkz-kpi-card > span{ opacity:.6; }

    /* ---- Überschriften mit Gold-Strich ---- */
    .amkz-card-header h3{ letter-spacing:.01em; }

    /* ---- Tabellen: ruhige Kopfzeile, weicher Zeilen-Hover ---- */
    .amkz-table{ border-collapse:separate; border-spacing:0; }
    .amkz-table thead th{
      background:linear-gradient(180deg, rgba(212,175,55,.10), rgba(212,175,55,.03)) !important;
      color:var(--lxg) !important; font-size:.7rem; letter-spacing:.06em; text-transform:uppercase;
      border-bottom:1px solid rgba(212,175,55,.16) !important; padding:12px 14px !important;
    }
    .amkz-table tbody td{ padding:12px 14px !important; border-bottom:1px solid rgba(255,255,255,.05) !important; }
    .amkz-table tbody tr{ transition:background .14s ease; }
    .amkz-table tbody tr:hover{ background:rgba(212,175,55,.055) !important; }

    /* ---- Pills / Status ---- */
    .amkz-status-pill, .amkz-type-pill{
      border-radius:999px !important; padding:4px 12px !important; font-weight:600; font-size:.74rem;
      border:1px solid rgba(255,255,255,.12);
    }
    .amk-pill-open, .amkz-status-pill{ background:rgba(255,255,255,.05); }

    /* ---- Buttons ---- */
    .amkz-primary-btn{
      background:linear-gradient(135deg, var(--lxg), var(--lxg2)) !important; color:#1a1206 !important;
      border:none !important; font-weight:700; border-radius:12px !important;
      box-shadow:0 10px 24px -10px rgba(212,175,55,.6); transition:transform .14s ease, filter .14s ease, box-shadow .14s ease;
    }
    .amkz-primary-btn:hover{ transform:translateY(-1px); filter:brightness(1.06); box-shadow:0 14px 30px -10px rgba(212,175,55,.7); }
    .amkz-primary-btn:active{ transform:translateY(0); }
    .amkz-secondary-btn{
      background:rgba(255,255,255,.045) !important; color:#eee !important;
      border:1px solid rgba(212,175,55,.28) !important; border-radius:12px !important; transition:background .14s ease, border-color .14s ease;
    }
    .amkz-secondary-btn:hover{ background:rgba(212,175,55,.12) !important; border-color:rgba(212,175,55,.5) !important; }

    /* ---- Inputs / Selects / Textareas: sauberer Fokus (Gold-Ring) ---- */
    .amkz-input-group input, .amkz-input-group select, .amkz-input-group textarea{
      border-radius:11px !important; transition:border-color .15s ease, box-shadow .15s ease, background .15s ease;
    }
    .amkz-input-group input:focus, .amkz-input-group select:focus, .amkz-input-group textarea:focus{
      outline:none !important; border-color:rgba(212,175,55,.6) !important;
      box-shadow:0 0 0 3px rgba(212,175,55,.14) !important;
    }

    /* ---- Navigation ---- */
    .amkz-nav-item{ border-radius:12px !important; transition:background .14s ease, color .14s ease; }
    .amkz-nav-item:hover{ background:rgba(212,175,55,.08) !important; }
    .amkz-nav-item.active{
      background:linear-gradient(135deg, rgba(212,175,55,.22), rgba(212,175,55,.08)) !important;
      box-shadow:inset 0 0 0 1px rgba(212,175,55,.3);
    }

    /* ---- Modals ---- */
    .amkz-modal{ border-radius:22px !important; border:1px solid rgba(212,175,55,.18) !important;
      box-shadow:0 40px 100px -30px rgba(0,0,0,.85) !important; }

    /* ---- Feine Scrollbars ---- */
    *::-webkit-scrollbar{ width:9px; height:9px; }
    *::-webkit-scrollbar-thumb{ background:rgba(212,175,55,.28); border-radius:9px; border:2px solid transparent; background-clip:padding-box; }
    *::-webkit-scrollbar-thumb:hover{ background:rgba(212,175,55,.45); background-clip:padding-box; }
    *::-webkit-scrollbar-track{ background:transparent; }

    /* ---- Toasts etwas edler ---- */
    .amkz-toast{ border-radius:14px !important; border:1px solid rgba(212,175,55,.25) !important; }
  `;
  (document.head || document.documentElement).appendChild(s);
})();


/* =====================================================
   AMK ZENTRALE — DESIGN v3 (kräftige Politur, durchsetzungsstark)
   Höhere Spezifität (html body …) + ans Ende gehängt, damit es sich
   auch auf Shopify sicher gegen die Basis-CSS durchsetzt.
   Kernidee: die harten Gold-Balken weg -> ruhige Glas-Karten,
   goldener Punkt am Label, große Gold-Zahl, mehr Luft, feine Hover.
===================================================== */
(function () {
  "use strict";
  return; /* PREMIUM 2026: Design-v3-Injektor deaktiviert - Optik kommt jetzt allein aus amk-zentrale.css (Master Premium Layer) */
  const ID = "amk-design-v3";
  function inject() {
    let s = document.getElementById(ID);
    if (!s) { s = document.createElement("style"); s.id = ID; }
    s.textContent = `
      html{ -webkit-font-smoothing:antialiased; text-rendering:optimizeLegibility; }
      ::selection{ background:rgba(212,175,55,.30); color:#fff; }

      /* ---- Gold-Oberkanten der Karten KOMPLETT weg (das wirkte schwer) ---- */
      html body .amkz-kpi-card::after,
      html body .amkz-card::after,
      html body .amkz-kpi-card::before{ display:none !important; content:none !important; }

      /* ---- KPI-Karten: ruhiges Glas, goldener Label-Punkt, große Zahl ---- */
      html body .amkz-kpi-card{
        border:1px solid rgba(212,175,55,.15) !important; border-radius:22px !important;
        background:linear-gradient(160deg, rgba(233,205,134,.055), rgba(255,255,255,.012) 34%, rgba(0,0,0,.14)), #131319 !important;
        box-shadow:0 1px 0 rgba(255,255,255,.05) inset, 0 22px 52px -24px rgba(0,0,0,.82) !important;
        padding:22px 24px !important; transition:transform .2s ease, border-color .2s ease, box-shadow .2s ease !important;
      }
      html body .amkz-kpi-card:hover{ transform:translateY(-4px);
        border-color:rgba(212,175,55,.42) !important;
        box-shadow:0 28px 66px -22px rgba(0,0,0,.85), 0 0 46px -18px rgba(212,175,55,.42) !important; }
      html body .amkz-kpi-card small{ display:inline-flex; align-items:center; gap:8px;
        text-transform:uppercase; letter-spacing:.11em; font-size:.66rem; opacity:.6; }
      html body .amkz-kpi-card small::before{ content:""; width:6px; height:6px; border-radius:50%;
        background:linear-gradient(135deg,#f4d98a,#c79b3b); box-shadow:0 0 9px rgba(212,175,55,.75); flex:0 0 auto; }
      html body .amkz-kpi-card strong{ font-size:2.15rem !important; letter-spacing:-.02em; line-height:1.05; }
      html body .amkz-kpi-card > span{ opacity:.55; font-size:.82rem; }

      /* ---- Karten allgemein ---- */
      html body .amkz-card, html body .amkz-table-row-card{
        border:1px solid rgba(212,175,55,.12) !important; border-radius:20px !important;
        background:linear-gradient(180deg, rgba(255,255,255,.028), rgba(255,255,255,0) 42%), #121218 !important;
        box-shadow:0 1px 0 rgba(255,255,255,.04) inset, 0 20px 48px -22px rgba(0,0,0,.78) !important;
      }
      html body .amkz-card-header h3{ font-weight:800; letter-spacing:.004em; }

      /* ---- Sidebar / Navigation ---- */
      html body .amkz-nav-item{ border-radius:14px !important; transition:background .16s ease, color .16s ease; }
      html body .amkz-nav-item:hover{ background:rgba(212,175,55,.08) !important; }
      html body .amkz-nav-item.active{
        background:linear-gradient(135deg, rgba(240,211,138,.95), rgba(199,155,59,.9)) !important; color:#1a1206 !important;
        box-shadow:0 12px 26px -12px rgba(212,175,55,.6) !important; }
      html body .amkz-nav-item.active *{ color:#1a1206 !important; }

      /* ---- Buttons ---- */
      html body .amkz-primary-btn{
        background:linear-gradient(135deg,#f0d38a,#c79b3b) !important; color:#1a1206 !important; border:none !important;
        border-radius:13px !important; font-weight:700; box-shadow:0 12px 28px -12px rgba(212,175,55,.65) !important;
        transition:transform .14s ease, filter .14s ease, box-shadow .14s ease; }
      html body .amkz-primary-btn:hover{ transform:translateY(-1px); filter:brightness(1.06); box-shadow:0 16px 36px -12px rgba(212,175,55,.82) !important; }
      html body .amkz-secondary-btn{ background:rgba(255,255,255,.04) !important; border:1px solid rgba(212,175,55,.28) !important; color:#f0e6cf !important; border-radius:13px !important; transition:background .14s ease, border-color .14s ease; }
      html body .amkz-secondary-btn:hover{ background:rgba(212,175,55,.12) !important; border-color:rgba(212,175,55,.5) !important; }

      /* ---- Tabellen ---- */
      html body .amkz-table thead th{
        background:linear-gradient(180deg, rgba(212,175,55,.10), rgba(212,175,55,.02)) !important; color:#e9cd86 !important;
        text-transform:uppercase; letter-spacing:.06em; font-size:.68rem; border-bottom:1px solid rgba(212,175,55,.16) !important; padding:13px 16px !important; }
      html body .amkz-table tbody td{ padding:14px 16px !important; border-bottom:1px solid rgba(255,255,255,.05) !important; }
      html body .amkz-table tbody tr{ transition:background .14s ease; }
      html body .amkz-table tbody tr:hover{ background:rgba(212,175,55,.06) !important; }

      /* ---- Pills / Status / Typ ---- */
      html body .amkz-status-pill, html body .amkz-type-pill{
        border-radius:999px !important; padding:4px 12px !important; font-weight:600; font-size:.74rem; border:1px solid rgba(255,255,255,.1); }
      html body .amkz-status-pill{ background:rgba(255,255,255,.05); }

      /* ---- Inputs / Selects / Textareas ---- */
      html body .amkz-input-group input, html body .amkz-input-group select, html body .amkz-input-group textarea{
        border-radius:12px !important; transition:border-color .15s ease, box-shadow .15s ease, background .15s ease; }
      html body .amkz-input-group input:focus, html body .amkz-input-group select:focus, html body .amkz-input-group textarea:focus{
        outline:none !important; border-color:rgba(212,175,55,.6) !important; box-shadow:0 0 0 3px rgba(212,175,55,.14) !important; }

      /* ---- Modals + Scrollbars + Toasts ---- */
      html body .amkz-modal{ border-radius:22px !important; border:1px solid rgba(212,175,55,.18) !important; box-shadow:0 40px 100px -30px rgba(0,0,0,.85) !important; }
      html body *::-webkit-scrollbar{ width:9px; height:9px; }
      html body *::-webkit-scrollbar-thumb{ background:rgba(212,175,55,.28); border-radius:9px; border:2px solid transparent; background-clip:padding-box; }
      html body *::-webkit-scrollbar-thumb:hover{ background:rgba(212,175,55,.45); background-clip:padding-box; }
      html body .amkz-toast{ border-radius:14px !important; border:1px solid rgba(212,175,55,.25) !important; }
    `;
    // Ans ENDE von <body> hängen -> gewinnt auch gegen spät geladene Stylesheets
    (document.body || document.documentElement).appendChild(s);
  }
  inject();
  // ein paar Mal nachlegen, falls die Basis-CSS erst später lädt / neu rendert
  let tries = 0;
  const iv = setInterval(() => { inject(); if (++tries >= 5) clearInterval(iv); }, 1500);
})();

/* =====================================================
   AMK ZENTRALE — CRM (Spieler-Akten + Suche + Affiliate-Kontakte)
   - Klick auf Entry -> Detail-Popup (Wallet/Name/Mail/alles)
   - Suchleiste über den Entries -> Spieler / Partner / Casino
   - Spieler-Profil: alle Einzahlungen + Notizen (Anruf-Log) + Fake-Warnung
   - Partner/Casino-Drilldown: alle Personen die damit zu tun hatten
   - Affiliate-Kontakte (z. B. „22 Bet" + Whatsapp/Telegram/Insta)
   Braucht supabase-crm.sql (crm_notes, crm_contacts).
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__crm) return;
  AMKZ.__crm = true;

  const byId = (id) => document.getElementById(id);
  const val = (id) => byId(id)?.value ?? "";
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m])));
  const money = (AMKZ.utils && AMKZ.utils.money) || ((n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n || 0)));
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const sb = () => AMKZ.supabase;
  const pn = (id) => AMKZ.shared?.getPartnerName?.(id) || "—";
  const cn = (id) => AMKZ.shared?.getCasinoName?.(id) || "—";
  const member = () => AMKZ.state?.member || null;
  const CRM = { persons: {} };

  // Ruft die 300K-Giveaway-API über den Proxy (Edge Function `giveaway`) auf.
  async function callGiveaway(action, params) {
    const root = byId("amkzApp");
    const base = (root?.dataset?.supabaseUrl || "").replace(/\/$/, "");
    const anon = root?.dataset?.supabaseKey || "";
    if (!base) return null;
    try {
      const res = await fetch(base + "/functions/v1/giveaway", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + anon, apikey: anon },
        body: JSON.stringify({ action, ...(params || {}) }),
      });
      return await res.json().catch(() => null);
    } catch (_) { return null; }
  }

  function personFromEntry(e) {
    const email = (e.customer_email || "").trim();
    const wallet = (e.wallet_address || "").trim();
    const name = (e.customer_name || "").trim();
    const key = (email.toLowerCase() || wallet || name.toLowerCase() || "?");
    return { name, email, wallet, key, label: name || email || wallet || "Unbekannt" };
  }
  function orFor(p) {
    const c = [];
    if (p.email && !/[,()]/.test(p.email)) c.push(`customer_email.eq.${p.email}`);
    if (p.wallet && !/[,()]/.test(p.wallet)) c.push(`wallet_address.eq.${p.wallet}`);
    if (p.name && !/[,()]/.test(p.name)) c.push(`customer_name.eq.${p.name}`);
    return c.join(",");
  }

  /* ---------- Entry-Detail ---------- */
  async function openEntryDetail(id, back) {
    if (!id) return;
    CRM.entryBack = back || null;
    let e = null;
    try { const { data } = await sb().from("entries").select("*").eq("id", id).maybeSingle(); e = data; } catch (_) {}
    if (!e) return toast("Fehler", "Eintrag nicht gefunden.", "error");
    const p = personFromEntry(e);
    const row = (l, v) => v ? `<div class="amkz-crm-kv"><span>${esc(l)}</span><b>${esc(v)}</b></div>` : "";
    AMKZ.modal.open(`
      <div class="amkz-modal amkz-crm-modal">
        <div class="amkz-modal-header"><div><h3>Eintrag-Details</h3><p>${esc(e.entry_type || "")} · ${esc(e.entry_date || "")}</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        ${back ? `<button class="amkz-secondary-btn amkz-crm-back" data-crm-back>← Zurück zur Akte: ${esc(back.label)}</button>` : ""}
        <div class="amkz-crm-detail">
          ${row("Datum", e.entry_date)}${row("Typ", e.entry_type)}
          ${row("Betrag", money(e.amount || 0))}${row("Status", e.payment_status || e.status)}
          ${row("Partner", e.partner_name || pn(e.partner_group_id))}${row("Casino", e.casino_name || cn(e.casino_id))}
          ${row("Kundenname", e.customer_name)}${row("Kunden E-Mail", e.customer_email)}
          ${e.wallet_address ? `<div class="amkz-crm-kv wide"><span>Wallet</span><b class="amkz-crm-mono">${esc(e.wallet_address)}</b></div>` : ""}
          ${row("Notiz", e.note)}${row("Erstellt von", e.created_by_name || e.created_by)}${row("Erstellt am", (e.created_at || "").slice(0, 16).replace("T", " "))}
        </div>
        ${p.label !== "Unbekannt" ? `<button class="amkz-primary-btn" data-crm-openperson="${esc(p.key)}" style="width:100%;margin-top:6px">👤 Spieler-Akte öffnen: ${esc(p.label)}</button>` : ""}
      </div>`);
    CRM.persons[p.key] = p;
  }

  /* ---------- Spieler-Akte ---------- */
  // Notiz an Mitarbeiter senden: echte Chat-Nachricht + Notification + Push
  async function crmSendToUser(userId, title, message) {
    if (!userId) return;
    const myId = (member() && member().id) || null;
    try {
      if (myId && userId !== myId) {
        const { data: conv } = await sb().rpc("amk_get_or_create_conversation", { p_user_a: myId, p_user_b: userId });
        const convId = conv?.id || (Array.isArray(conv) ? conv[0]?.id : null);
        if (convId) {
          await sb().rpc("amk_send_message", { p_conversation_id: convId, p_sender_id: myId, p_receiver_id: userId, p_message: message, p_client_temp_id: `tmp_${Date.now()}_${Math.random().toString(36).slice(2)}` });
        } else {
          await sb().from("internal_messages").insert({ sender_id: myId, receiver_id: userId, message, message_type: "text", is_read: false, created_at: new Date().toISOString() });
        }
      }
    } catch (e) { console.warn("[crm] send", e); }
    try { await sb().from("notifications").insert({ target_user_id: userId, created_for: userId, type: "crm_note", title, message, is_read: false, created_at: new Date().toISOString(), payload: { from: myId, push: "false" } }); } catch (e) {}
    try { window.AMK_SEND_PUSH && window.AMK_SEND_PUSH(userId, title, message, { from: myId }); } catch (e) {}
  }

  async function openPersonProfile(p) {
    if (!p) return;
    let entries = [];
    try {
      const orc = orFor(p);
      if (orc) { const { data } = await sb().from("entries").select("*").or(orc).order("entry_date", { ascending: false }).limit(5000); entries = data || []; }
    } catch (_) {}
    let notes = [];
    try { const { data } = await sb().from("crm_notes").select("*").eq("person_key", p.key).order("created_at", { ascending: false }); notes = data || []; } catch (err) { notes = []; }
    try { await AMKZ.data.loadTeam(false); } catch (_) {}
    const teamChecks = (AMKZ.state.team || []).filter((m) => m.id !== (member() && member().id)).map((m) => `<label class="amkz-crm-chk"><input type="checkbox" class="amkz-crm-notify-cb" value="${esc(m.id)}"><span>${esc(m.name || m.email || "Mitarbeiter")}</span></label>`).join("");

    const total = entries.reduce((a, e) => a + Number(e.amount || 0), 0);
    const ftd = entries.filter((e) => String(e.entry_type).toUpperCase() === "FTD");
    // Fake-Warnung: gleiche Wallet/Mail unter anderem Namen
    const names = new Set(entries.map((e) => (e.customer_name || "").trim().toLowerCase()).filter(Boolean));
    const fake = names.size > 1;
    // Aufschlüsselung je Name (für die klickbare Fake-Warnung — "wo wurde es verwendet")
    const byNameMap = {};
    entries.forEach((e) => {
      const nm = (e.customer_name || "").trim(); if (!nm) return;
      const k = nm.toLowerCase();
      if (!byNameMap[k]) byNameMap[k] = { name: nm, count: 0, total: 0, emails: new Set(), wallets: new Set(), casinos: new Set(), last: "" };
      const b = byNameMap[k];
      b.count++; b.total += Number(e.amount || 0);
      if (e.customer_email) b.emails.add(e.customer_email);
      if (e.wallet_address) b.wallets.add(e.wallet_address);
      const cas = e.casino_name || cn(e.casino_id); if (cas) b.casinos.add(cas);
      const d = e.entry_date || ""; if (d > b.last) b.last = d;
    });
    CRM.namesBreakdown = { src: p, list: Object.values(byNameMap).sort((a, b) => b.total - a.total) };

    const noteRows = notes.length ? notes.map((nt) => `
      <div class="amkz-crm-note"><div class="amkz-crm-note-txt">${esc(nt.note)}</div>
      <div class="amkz-crm-note-meta">${esc(nt.author || "—")} · ${esc((nt.created_at || "").slice(0, 16).replace("T", " "))}
      <button class="amkz-crm-note-del" data-crm-notedel="${esc(nt.id)}" title="Löschen">🗑</button></div></div>`).join("")
      : `<div class="amkz-crm-empty">Noch keine Notizen.</div>`;

    // 300K-Giveaway: per E-Mail; findet nichts -> Fallback per Name (falls im Giveaway andere Mail)
    let gv = null, gvState = "none";
    if (p.email) {
      const r = await callGiveaway("check", { email: p.email });
      if (r === null) gvState = "off";
      else if (r.status === "success" && (Number(r.totalTickets) > 0 || r.hasDeposits)) { gv = r; gvState = "ok"; }
    }
    if (!gv && gvState !== "off" && p.name) {
      const gr = await callGiveaway("search", { q: p.name });
      if (gr === null) gvState = "off";
      else if (gr.status === "success" && Array.isArray(gr.players) && gr.players.length) {
        const best = gr.players.find((x) => String(x.name || "").toLowerCase() === p.name.toLowerCase()) || gr.players[0];
        if (best?.email) { const r2 = await callGiveaway("check", { email: best.email }); if (r2 && r2.status === "success" && (Number(r2.totalTickets) > 0 || r2.hasDeposits)) { gv = r2; gvState = "ok"; } }
      }
    }
    let gvHtml = `<div class="amkz-crm-sec">🎟 300K Giveaway</div>`;
    if (gvState === "ok" && gv) {
      const deps = gv.deposits || [];
      gvHtml += `<div class="amkz-crm-stats">
          <div class="amkz-crm-stat"><small>Tickets</small><strong>${esc(gv.totalTickets || 0)}</strong></div>
          <div class="amkz-crm-stat"><small>Giveaway-Einzahlungen</small><strong>${money(gv.totalDeposits || 0)}</strong></div>
          <div class="amkz-crm-stat"><small>Anzahl</small><strong>${esc(gv.depositCount || deps.length || 0)}</strong></div>
        </div>`;
    } else if (gvState === "off") {
      gvHtml += `<div class="amkz-crm-empty">⚠ Nicht verbunden — Edge Function „giveaway" muss deployt sein (Supabase → Edge Functions).</div>`;
    } else {
      gvHtml += `<div class="amkz-crm-empty">Keine Giveaway-Tickets für ${esc(p.email || p.label)}.</div>`;
    }

    /* ---------- KOMPLETTE HISTORIE ----------
       Alles was es zu dieser Person gibt in EINER scrollbaren Liste:
       - 💠 System  = von uns eingetragen (FTD / ReDepo / Zahlung …) aus `entries`
       - 🎟 Gewinnspiel = Einzahlungen aus dem 300K-Giveaway
       Nichts wird abgeschnitten, jede Zeile ist erreichbar. */
    const dkey = (v) => {
      const t = String(v || "").trim();
      let m = t.match(/^(\d{2})\.(\d{2})\.(\d{4})(?:[ T](\d{2}):(\d{2}))?/);
      if (m) return `${m[3]}-${m[2]}-${m[1]}T${m[4] || "00"}:${m[5] || "00"}`;
      m = t.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
      if (m) return `${m[1]}-${m[2]}-${m[3]}T${m[4] || "00"}:${m[5] || "00"}`;
      return "0000-00-00T00:00";
    };
    const gvDeps = (gvState === "ok" && gv && Array.isArray(gv.deposits)) ? gv.deposits : [];
    const hist = [];
    entries.forEach((e) => hist.push({
      src: "sys", k: dkey(e.entry_date), date: e.entry_date || "",
      type: e.entry_type || "—", casino: e.casino_name || cn(e.casino_id) || "—",
      amount: Number(e.amount || 0), tickets: null,
      status: e.status || e.entry_status || "", id: e.id || "",
    }));
    gvDeps.forEach((d) => hist.push({
      src: "gv", k: dkey(d.date), date: d.date || "",
      type: "Einzahlung", casino: d.casino || "—",
      amount: Number(d.amount || 0), tickets: Number(d.tickets || 0),
      status: d.status || "", id: "",
    }));
    hist.sort((a, b) => (a.k < b.k ? 1 : a.k > b.k ? -1 : 0));
    const nGv = hist.filter((h) => h.src === "gv").length;
    const nSys = hist.length - nGv;
    const histRows = hist.length ? hist.map((h) => `
      <tr class="amkz-crm-hrow${h.src === "sys" ? " amkz-entry-row amkz-crm-clickrow" : ""}" data-crm-src="${h.src}"${h.src === "sys" ? ` data-entry-id="${esc(h.id)}" title="Für alle Details (Wallet/BTC, Name, Mail …) klicken"` : ` title="Einzahlung aus dem 300K-Gewinnspiel"`}>
        <td class="amkz-crm-hdate">${esc(h.date || "—")}</td>
        <td><span class="amkz-crm-srcpill ${h.src}">${h.src === "gv" ? "🎟 Gewinnspiel" : "💠 System"}</span></td>
        <td><span class="amkz-status-pill">${esc(h.type)}</span></td>
        <td>${esc(h.casino)}</td>
        <td class="amk-num">${money(h.amount)}</td>
        <td class="amk-num">${h.tickets != null ? "🎟 " + Number(h.tickets).toLocaleString("de-DE") : "—"}</td>
        <td>${h.status ? `<span class="amkz-crm-stpill">${esc(h.status)}</span>` : "—"}</td>
      </tr>`).join("")
      : `<tr><td colspan="7"><div class="amkz-empty">Keine Einträge.</div></td></tr>`;
    const histHtml = `
      <div class="amkz-crm-sec">Komplette Historie <span class="amkz-crm-cnt">${hist.length} ${hist.length === 1 ? "Eintrag" : "Einträge"}</span></div>
      <div class="amkz-crm-hfilter">
        <button type="button" class="amkz-crm-hfbtn active" data-crm-hf="all">Alle (${hist.length})</button>
        <button type="button" class="amkz-crm-hfbtn" data-crm-hf="gv">🎟 Gewinnspiel (${nGv})</button>
        <button type="button" class="amkz-crm-hfbtn" data-crm-hf="sys">💠 System / FTD (${nSys})</button>
      </div>
      <div class="amkz-table-wrap amkz-crm-hwrap" id="amkzCrmHist"><table class="amkz-table amkz-crm-htable">
        <thead><tr><th>Datum</th><th>Quelle</th><th>Typ</th><th>Casino</th><th class="amk-num">Betrag</th><th class="amk-num">Tickets</th><th>Status</th></tr></thead>
        <tbody>${histRows}</tbody></table></div>
      <p class="amkz-crm-hint">💠 System = von uns eingetragen (FTD / ReDepo / Zahlung) · 🎟 Gewinnspiel = aus dem 300K-Giveaway. Liste scrollt — jeder Eintrag ist drin.</p>`;

    AMKZ.modal.open(`
      <div class="amkz-modal amkz-crm-modal amkz-crm-wide">
        <div class="amkz-modal-header"><div><h3>👤 ${esc(p.label)}${p.email ? ` <button type="button" class="amkz-crm-chatbtn" data-crm-tochat="${esc(p.email)}" title="Zum Anfragen-Chat">💬 Chat</button>` : ""}</h3>
          <p>${[p.email, p.wallet].filter(Boolean).map(esc).join(" · ") || "—"}</p></div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>

        ${fake ? `<button type="button" class="amkz-crm-warn amkz-crm-warnbtn" data-crm-names="1">⚠ Achtung: diese Wallet/E-Mail wurde unter <b>${names.size} verschiedenen Namen</b> genutzt — möglicher Fake/Doppelaccount. <u>Namen &amp; Akten anzeigen →</u></button>` : ""}

        <div class="amkz-crm-stats">
          <div class="amkz-crm-stat"><small>Gesamt-Volumen</small><strong>${money(total)}</strong></div>
          <div class="amkz-crm-stat"><small>Einträge</small><strong>${entries.length}</strong></div>
          <div class="amkz-crm-stat"><small>FTDs</small><strong>${ftd.length}</strong></div>
        </div>

        ${gvHtml}

        ${histHtml}

        <div class="amkz-crm-sec">Notizen (Anruf-Log, Warnungen)</div>
        <div class="amkz-crm-noteadd">
          <input id="amkzCrmNoteInput" placeholder="z. B. Anruf 10 Min · Problem Auszahlung Freshbet / Push ist raus">
          <button class="amkz-primary-btn" data-crm-noteadd>+ Notiz</button>
        </div>
        ${teamChecks ? `<div class="amkz-crm-notify">
          <div class="amkz-crm-notify-head">👥 Notiz zusätzlich an Mitarbeiter senden <small>(mit Name, E-Mail &amp; Notiz)</small></div>
          <div class="amkz-crm-notify-list">${teamChecks}</div>
        </div>` : ""}
        <div class="amkz-crm-notes" id="amkzCrmNotes">${noteRows}</div>
      </div>`);
    CRM.currentPerson = p;
  }

  /* ---------- Partner/Casino-Drilldown ---------- */
  async function openScopeProfile(type, id, name) {
    let entries = [];
    try {
      const col = type === "partner" ? "partner_group_id" : "casino_id";
      const { data } = await sb().from("entries").select("*").eq(col, id).order("entry_date", { ascending: false }).limit(500);
      entries = data || [];
    } catch (_) {}
    const byPerson = {};
    entries.forEach((e) => { const p = personFromEntry(e); if (!byPerson[p.key]) byPerson[p.key] = { p, count: 0, sum: 0 }; byPerson[p.key].count++; byPerson[p.key].sum += Number(e.amount || 0); CRM.persons[p.key] = p; });
    const persons = Object.values(byPerson).sort((a, b) => b.sum - a.sum);
    const total = entries.reduce((a, e) => a + Number(e.amount || 0), 0);
    const rows = persons.length ? persons.map((o) => `
      <tr class="amkz-crm-clickrow" data-crm-openperson="${esc(o.p.key)}"><td>👤 ${esc(o.p.label)}</td>
      <td>${esc(o.p.email || o.p.wallet || "—")}</td><td class="amk-num">${o.count}</td><td class="amk-num">${money(o.sum)}</td></tr>`).join("")
      : `<tr><td colspan="4"><div class="amkz-empty">Keine Personen gefunden.</div></td></tr>`;
    AMKZ.modal.open(`
      <div class="amkz-modal amkz-crm-modal amkz-crm-wide">
        <div class="amkz-modal-header"><div><h3>${type === "partner" ? "🏢" : "🎰"} ${esc(name)}</h3>
          <p>${persons.length} Personen · ${entries.length} Einträge · ${money(total)}</p></div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <div class="amkz-table-wrap amkz-crm-scroll"><table class="amkz-table"><thead><tr><th>Person</th><th>Kontakt</th><th>Einträge</th><th>Volumen</th></tr></thead><tbody>${rows}</tbody></table></div>
        <p class="amkz-crm-hint">Auf eine Person klicken → komplette Akte mit Notizen.</p>
      </div>`);
  }

  /* ---------- Suche ---------- */
  let searchTimer = null;
  async function doSearch(q) {
    const box = byId("amkzCrmResults"); if (!box) return;
    const qs = String(q || "").replace(/[,%()]/g, " ").trim();
    if (qs.length < 2) { box.classList.remove("show"); box.innerHTML = ""; return; }
    // Personen aus entries
    let persons = [];
    try {
      const { data } = await sb().from("entries").select("customer_name,customer_email,wallet_address,partner_group_id,casino_id")
        .or(`customer_name.ilike.%${qs}%,customer_email.ilike.%${qs}%,wallet_address.ilike.%${qs}%`).limit(300);
      const seen = {};
      (data || []).forEach((e) => { const p = personFromEntry(e); if (p.label !== "Unbekannt" && !seen[p.key]) { seen[p.key] = 1; persons.push(p); CRM.persons[p.key] = p; } });
      persons = persons.slice(0, 15);
    } catch (_) {}
    const ql = qs.toLowerCase();
    const partners = (AMKZ.state?.partners || []).filter((p) => String(p.name).toLowerCase().includes(ql)).slice(0, 8);
    const casinos = (AMKZ.state?.casinos || []).filter((c) => String(c.name).toLowerCase().includes(ql)).slice(0, 8);

    // 300K-Giveaway-Spieler (per Name/E-Mail) — Duplikate zu den System-Spielern raus
    let gvPlayers = [];
    try {
      const gr = await callGiveaway("search", { q: qs });
      if (gr && gr.status === "success" && Array.isArray(gr.players)) {
        const known = new Set(persons.map((p) => p.key));
        gr.players.forEach((pl) => {
          const key = (pl.email || "").toLowerCase() || String(pl.name || "").toLowerCase();
          if (!key || known.has(key)) return;
          const p = { name: pl.name || "", email: (pl.email || "").toLowerCase(), wallet: "", key, label: pl.name || pl.email || "Spieler", giveaway: pl };
          CRM.persons[key] = p; gvPlayers.push(p);
        });
      }
    } catch (_) {}

    // Support-Anfragen (Chat) — E-Mails aus den Anfragen sind hier auch findbar
    let supPlayers = [];
    try {
      const sr = await (AMKZ.support && AMKZ.support.search ? AMKZ.support.search(qs) : Promise.resolve([]));
      const known = new Set([...persons.map((p) => p.key), ...gvPlayers.map((p) => p.key)]);
      (sr || []).forEach((s) => {
        const key = (s.email || "").toLowerCase() || String(s.name || "").toLowerCase();
        if (!key || known.has(key)) return; known.add(key);
        const p = { name: s.name || "", email: (s.email || "").toLowerCase(), wallet: "", key, label: s.name || s.email || "Spieler", support: s };
        CRM.persons[key] = p; supPlayers.push(p);
      });
    } catch (_) {}

    let html = "";
    if (persons.length) html += `<div class="amkz-crm-rsec">Spieler</div>` + persons.map((p) => `<div class="amkz-crm-ritem" data-crm-openperson="${esc(p.key)}">👤 <b>${esc(p.label)}</b> <small>${esc(p.email || p.wallet || "")}</small></div>`).join("");
    if (partners.length) html += `<div class="amkz-crm-rsec">Partner</div>` + partners.map((p) => `<div class="amkz-crm-ritem" data-crm-partner="${esc(p.id)}" data-crm-name="${esc(p.name)}">🏢 <b>${esc(p.name)}</b></div>`).join("");
    if (casinos.length) html += `<div class="amkz-crm-rsec">Casinos</div>` + casinos.map((c) => `<div class="amkz-crm-ritem" data-crm-casino="${esc(c.id)}" data-crm-name="${esc(c.name)}">🎰 <b>${esc(c.name)}</b></div>`).join("");
    if (gvPlayers.length) html += `<div class="amkz-crm-rsec">🎟 300K Giveaway</div>` + gvPlayers.map((p) => `<div class="amkz-crm-ritem" data-crm-openperson="${esc(p.key)}">🎟 <b>${esc(p.label)}</b> <small>${esc(p.giveaway.totalTickets || 0)} Tickets · ${money(p.giveaway.totalDeposits || 0)}</small></div>`).join("");
    if (supPlayers.length) html += `<div class="amkz-crm-rsec">💬 Anfragen (Chat)</div>` + supPlayers.map((p) => `<div class="amkz-crm-ritem" data-crm-openperson="${esc(p.key)}">💬 <b>${esc(p.label)}</b> <small>${esc(p.email || "")}${p.support && p.support.count > 1 ? " · " + p.support.count + "×" : ""}</small></div>`).join("");
    box.innerHTML = html || `<div class="amkz-crm-rsec">Nichts gefunden.</div>`;
    box.classList.add("show");
  }

  function ensureSearchBar() {
    const body = byId("amkzEntriesTableBody"); if (!body) return;
    if (byId("amkzCrmSearch")) return;
    const card = body.closest(".amkz-card") || body.closest(".amkz-view") || body.parentElement;
    if (!card) return;
    const wrap = document.createElement("div");
    wrap.id = "amkzCrmSearch"; wrap.className = "amkz-crm-search";
    wrap.innerHTML = `
      <div class="amkz-crm-searchrow">
        <input id="amkzCrmQuery" placeholder="Spieler / Partner / Casino suchen (Name, E-Mail, Wallet) …">
        <button class="amkz-secondary-btn" data-crm-contacts>👥 Affiliate-Kontakte</button>
      </div>
      <div id="amkzCrmResults" class="amkz-crm-results"></div>`;
    card.insertBefore(wrap, card.firstChild);
    byId("amkzCrmQuery").addEventListener("input", (e) => { clearTimeout(searchTimer); const v = e.target.value; searchTimer = setTimeout(() => doSearch(v), 250); });
  }

  /* ---------- Affiliate-Kontakte ---------- */
  async function openContacts() {
    let contacts = [];
    try { const { data } = await sb().from("crm_contacts").select("*").order("name"); contacts = data || []; } catch (_) {}
    const link = (label, v, href) => v ? `<a href="${href}" target="_blank" rel="noopener">${label}</a>` : "";
    const rows = contacts.length ? contacts.map((c) => `
      <div class="amkz-crm-contact" data-crm-contact="${esc(c.id)}">
        <div class="amkz-crm-contact-main"><strong>${esc(c.name)}</strong>${c.contact_person ? ` · ${esc(c.contact_person)}` : ""}</div>
        <div class="amkz-crm-contact-links">
          ${link("WhatsApp", c.whatsapp, "https://wa.me/" + String(c.whatsapp || "").replace(/[^\d]/g, ""))}
          ${link("Telegram", c.telegram, (String(c.telegram || "").startsWith("http") ? c.telegram : "https://t.me/" + String(c.telegram || "").replace(/^@/, "")))}
          ${link("Instagram", c.instagram, (String(c.instagram || "").startsWith("http") ? c.instagram : "https://instagram.com/" + String(c.instagram || "").replace(/^@/, "")))}
          ${c.email ? `<a href="mailto:${esc(c.email)}">Mail</a>` : ""}${c.phone ? `<span>${esc(c.phone)}</span>` : ""}
        </div>
        ${c.note ? `<div class="amkz-crm-contact-note">${esc(c.note)}</div>` : ""}
        <div class="amkz-crm-contact-act"><button class="amk-crud-edit" data-crm-contactedit="${esc(c.id)}">✎</button><button class="amk-crud-del" data-crm-contactdel="${esc(c.id)}">🗑</button></div>
      </div>`).join("") : `<div class="amkz-crm-empty">Noch keine Kontakte.</div>`;
    AMKZ.modal.open(`
      <div class="amkz-modal amkz-crm-modal amkz-crm-wide">
        <div class="amkz-modal-header"><div><h3>👥 Affiliate-Kontakte</h3><p>Ansprechpartner, WhatsApp/Telegram/Instagram, Notizen</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <button class="amkz-primary-btn" data-crm-contactnew style="margin-bottom:10px">+ Neuer Kontakt</button>
        <div class="amkz-crm-contacts">${rows}</div>
      </div>`);
    CRM.contacts = contacts;
  }
  function openContactForm(c) {
    c = c || {};
    AMKZ.modal.open(`
      <div class="amkz-modal amkz-crm-modal">
        <div class="amkz-modal-header"><div><h3>${c.id ? "Kontakt bearbeiten" : "Neuer Affiliate-Kontakt"}</h3></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <form id="amkzCrmContactForm" class="amkz-form-grid">
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Name / Affiliate</label><input id="ccName" value="${esc(c.name || "")}" placeholder="z. B. 22 Bet" required></div>
            <div class="amkz-input-group"><label>Ansprechpartner</label><input id="ccPerson" value="${esc(c.contact_person || "")}"></div>
          </div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>WhatsApp</label><input id="ccWa" value="${esc(c.whatsapp || "")}" placeholder="+49…"></div>
            <div class="amkz-input-group"><label>Telegram</label><input id="ccTg" value="${esc(c.telegram || "")}" placeholder="@name"></div>
          </div>
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>Instagram</label><input id="ccIg" value="${esc(c.instagram || "")}" placeholder="@name"></div>
            <div class="amkz-input-group"><label>E-Mail / Telefon</label><input id="ccEmail" value="${esc(c.email || "")}" placeholder="mail@…"></div>
          </div>
          <div class="amkz-input-group"><label>Notiz</label><textarea id="ccNote">${esc(c.note || "")}</textarea></div>
          <div class="amkz-modal-actions"><button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button><button class="amkz-primary-btn" type="submit">Speichern</button></div>
        </form>
      </div>`);
    byId("amkzCrmContactForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const payload = { name: val("ccName").trim(), contact_person: val("ccPerson").trim(), whatsapp: val("ccWa").trim(), telegram: val("ccTg").trim(), instagram: val("ccIg").trim(), email: val("ccEmail").trim(), note: val("ccNote").trim(), updated_at: new Date().toISOString() };
      let err;
      if (c.id) ({ error: err } = await sb().from("crm_contacts").update(payload).eq("id", c.id));
      else { payload.created_by = member()?.id || null; ({ error: err } = await sb().from("crm_contacts").insert(payload)); }
      if (err) return toast("Fehler", err.message, "error");
      toast("Gespeichert", "Kontakt gespeichert."); openContacts();
    });
  }

  /* ---------- Fake-Aufschlüsselung: alle Namen auf einer Wallet/Mail ---------- */
  function openNamesBreakdown() {
    const nb = CRM.namesBreakdown; if (!nb || !nb.list.length) return;
    const src = nb.src;
    const rows = nb.list.map((b) => {
      const email0 = [...b.emails][0] || src.email || "";
      const wallet0 = [...b.wallets][0] || src.wallet || "";
      // Schlüssel pro NAME eindeutig (mehrere Namen teilen sich dieselbe Mail/Wallet)
      const key = "nm:" + b.name.toLowerCase();
      const pObj = { name: b.name, email: email0, wallet: wallet0, key, label: b.name };
      CRM.persons[key] = pObj;
      return `<button type="button" class="amkz-crm-nameRow" data-crm-openname="${esc(key)}">
        <div class="amkz-crm-nameRow-top"><b>${esc(b.name)}</b><span class="amkz-crm-nameRow-sum">${money(b.total)} · ${b.count} Einträge</span></div>
        <div class="amkz-crm-nameRow-sub">${[...b.emails].map(esc).join(", ") || "—"}${b.wallets.size ? ` · 💰 ${esc(wallet0)}` : ""}</div>
        <div class="amkz-crm-nameRow-sub amkz-crm-mut">${[...b.casinos].slice(0, 5).map(esc).join(", ")}${b.last ? ` · zuletzt ${esc(b.last)}` : ""}</div>
      </button>`;
    }).join("");
    AMKZ.modal.open(`<div class="amkz-modal amkz-crm-modal">
      <div class="amkz-modal-header"><div><h3>⚠ ${nb.list.length} Namen auf dieser Identität</h3>
        <p>${[src.email, src.wallet].filter(Boolean).map(esc).join(" · ") || esc(src.label)}</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
      <button class="amkz-secondary-btn amkz-crm-back" data-crm-backperson>← Zurück zur Akte</button>
      <div class="amkz-crm-hint">Tippe auf einen Namen, um dessen Akte zu öffnen und zu sehen, wo überall diese Wallet/Mail verwendet wurde.</div>
      <div class="amkz-crm-names">${rows}</div>
    </div>`);
  }

  /* ---------- Klick-Delegation ---------- */
  document.addEventListener("click", async (e) => {
    const toChat = e.target.closest("[data-crm-tochat]");
    if (toChat) { e.preventDefault(); e.stopPropagation(); const em = toChat.getAttribute("data-crm-tochat"); try { AMKZ.modal.close(); } catch (_) {} if (AMKZ.support && AMKZ.support.openByEmail) AMKZ.support.openByEmail(em); else toast("Anfragen", "Support-Modul nicht bereit.", "error"); return; }
    if (e.target.closest("[data-crm-names]")) { e.preventDefault(); e.stopPropagation(); openNamesBreakdown(); return; }
    if (e.target.closest("[data-crm-backperson]")) { e.preventDefault(); e.stopPropagation(); if (CRM.currentPerson) openPersonProfile(CRM.currentPerson); return; }
    const onm = e.target.closest("[data-crm-openname]"); if (onm) { e.preventDefault(); e.stopPropagation(); openPersonProfile(CRM.persons[onm.getAttribute("data-crm-openname")]); return; }
    if (e.target.closest("[data-crm-back]")) { e.preventDefault(); e.stopPropagation(); if (CRM.entryBack) openPersonProfile(CRM.entryBack); return; }
    // Historie filtern (Alle / 🎟 Gewinnspiel / 💠 System) — nur ein-/ausblenden, nichts nachladen
    const hf = e.target.closest("[data-crm-hf]");
    if (hf) {
      e.preventDefault(); e.stopPropagation();
      const mode = hf.getAttribute("data-crm-hf");
      const box = byId("amkzCrmHist");
      if (box) box.querySelectorAll("tr.amkz-crm-hrow").forEach((tr) => {
        tr.classList.toggle("amkz-crm-hide", !(mode === "all" || tr.getAttribute("data-crm-src") === mode));
      });
      (hf.parentElement ? hf.parentElement.querySelectorAll(".amkz-crm-hfbtn") : []).forEach((b) => b.classList.toggle("active", b === hf));
      if (box) box.scrollTop = 0;
      return;
    }
    const openP = e.target.closest("[data-crm-openperson]");
    if (openP) { e.preventDefault(); e.stopPropagation(); openPersonProfile(CRM.persons[openP.getAttribute("data-crm-openperson")]); return; }
    const rp = e.target.closest("[data-crm-partner]"); if (rp) { e.preventDefault(); openScopeProfile("partner", rp.getAttribute("data-crm-partner"), rp.getAttribute("data-crm-name")); return; }
    const rc = e.target.closest("[data-crm-casino]"); if (rc) { e.preventDefault(); openScopeProfile("casino", rc.getAttribute("data-crm-casino"), rc.getAttribute("data-crm-name")); return; }
    if (e.target.closest("[data-crm-contacts]")) { e.preventDefault(); openContacts(); return; }
    if (e.target.closest("[data-crm-contactnew]")) { e.preventDefault(); openContactForm(null); return; }
    const ce = e.target.closest("[data-crm-contactedit]"); if (ce) { e.preventDefault(); openContactForm((CRM.contacts || []).find((x) => String(x.id) === ce.getAttribute("data-crm-contactedit"))); return; }
    const cd = e.target.closest("[data-crm-contactdel]"); if (cd) { e.preventDefault(); if (!confirm("Kontakt löschen?")) return; await sb().from("crm_contacts").delete().eq("id", cd.getAttribute("data-crm-contactdel")); toast("Gelöscht", "Kontakt entfernt."); openContacts(); return; }
    // Notiz speichern
    if (e.target.closest("[data-crm-noteadd]")) {
      e.preventDefault();
      const p = CRM.currentPerson; const txt = val("amkzCrmNoteInput").trim();
      if (!p || !txt) return;
      const author = member()?.name || member()?.email || "Team";
      const { error } = await sb().from("crm_notes").insert({ person_key: p.key, person_label: p.label, note: txt, author });
      if (error) return toast("Fehler", error.message, "error");
      // Ausgewählte Mitarbeiter benachrichtigen (Chat + Notification + Push) mit Spieler-Infos
      const ids = [...document.querySelectorAll(".amkz-crm-notify-cb:checked")].map((cb) => cb.value);
      if (ids.length) {
        const person = [p.label || "Spieler", p.email, p.wallet].filter(Boolean).join(" · ");
        const title = "📝 Spieler-Notiz: " + (p.label || "Spieler");
        const message = "Spieler: " + person + "\nNotiz: " + txt + "\nVon: " + author + "\n\n→ In der Zentrale unter CRM/Spielersuche „" + (p.label || p.email || p.wallet || "") + "\" öffnen.";
        for (const uid of ids) { try { await crmSendToUser(uid, title, message); } catch (_) {} }
        toast("Gesendet", ids.length + " Mitarbeiter benachrichtigt.");
      } else {
        toast("Notiz gespeichert", "");
      }
      openPersonProfile(p); return;
    }
    const nd = e.target.closest("[data-crm-notedel]"); if (nd) { e.preventDefault(); if (!window.confirm("Diese Notiz wirklich löschen?")) return; await sb().from("crm_notes").delete().eq("id", nd.getAttribute("data-crm-notedel")); if (CRM.currentPerson) openPersonProfile(CRM.currentPerson); return; }
    // Entry-Row -> Detail (nur wenn nicht ein Button/Link geklickt wurde)
    const rowEl = e.target.closest(".amkz-entry-row");
    if (rowEl && !e.target.closest("a,button")) {
      const id = rowEl.getAttribute("data-entry-id");
      // aus einer offenen Akte heraus -> Zurück-Ziel merken
      const back = rowEl.closest("#amkzModalOverlay") ? CRM.currentPerson : null;
      if (id) openEntryDetail(id, back);
      return;
    }
  });

  /* ---------- Suchleiste in Entries einhängen ---------- */
  const prevLoadView = AMKZ.loadView;
  AMKZ.loadView = async function crmLoadView(view, options) {
    const r = await (prevLoadView ? prevLoadView.call(this, view, options) : undefined);
    if (view === "entries") setTimeout(ensureSearchBar, 400);
    return r;
  };
  setTimeout(ensureSearchBar, 1200);

  /* ---------- Styles ---------- */
  if (!byId("amk-crm-style")) {
    const s = document.createElement("style");
    s.id = "amk-crm-style";
    s.textContent = `
      .amkz-entry-row{cursor:pointer;}
      .amkz-crm-back{margin-bottom:12px;}
      .amkz-crm-search{margin-bottom:14px;position:relative;}
      .amkz-crm-searchrow{display:flex;gap:8px;}
      #amkzCrmQuery{flex:1;background:rgba(255,255,255,.05);border:1px solid rgba(212,175,55,.25);border-radius:12px;padding:11px 14px;color:#eee;font-size:.92rem;}
      #amkzCrmQuery:focus{outline:none;border-color:rgba(212,175,55,.6);box-shadow:0 0 0 3px rgba(212,175,55,.14);}
      .amkz-crm-results{position:absolute;z-index:40;left:0;right:0;top:100%;margin-top:6px;max-height:56vh;overflow-y:auto;display:none;
        background:#101015;border:1px solid rgba(212,175,55,.3);border-radius:14px;box-shadow:0 24px 60px -18px rgba(0,0,0,.8);}
      .amkz-crm-results.show{display:block;}
      .amkz-crm-rsec{padding:8px 14px 4px;font-size:.7rem;text-transform:uppercase;letter-spacing:.06em;opacity:.5;}
      .amkz-crm-ritem{padding:9px 14px;cursor:pointer;display:flex;gap:8px;align-items:center;border-top:1px solid rgba(255,255,255,.04);}
      .amkz-crm-ritem:hover{background:rgba(212,175,55,.1);}
      .amkz-crm-ritem small{opacity:.55;}
      .amkz-crm-wide{max-width:940px;width:min(940px,96vw);}
      .amkz-crm-detail{display:grid;grid-template-columns:1fr 1fr;gap:8px 16px;}
      .amkz-crm-kv{display:flex;flex-direction:column;gap:2px;padding:8px 10px;background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.07);border-radius:10px;}
      .amkz-crm-kv.wide{grid-column:1/-1;}
      .amkz-crm-kv span{font-size:.68rem;text-transform:uppercase;letter-spacing:.05em;opacity:.55;}
      .amkz-crm-kv b{font-size:.92rem;word-break:break-word;}
      .amkz-crm-mono{font-family:ui-monospace,Menlo,monospace;font-size:.8rem;}
      .amkz-crm-warn{background:rgba(220,90,90,.14);border:1px solid rgba(220,90,90,.4);color:#ffb3b3;border-radius:12px;padding:10px 13px;font-size:.86rem;margin-bottom:10px;}
      .amkz-crm-warnbtn{display:block;width:100%;text-align:left;cursor:pointer;font:inherit;transition:background .15s,border-color .15s;}
      .amkz-crm-chatbtn{vertical-align:2px;margin-left:10px;background:linear-gradient(135deg,#e0b24a,#c8902b);border:0;color:#1a1305;font-weight:800;font-size:.72rem;border-radius:9px;padding:4px 11px;cursor:pointer}
      .amkz-crm-chatbtn:hover{filter:brightness(1.08)}
      .amkz-crm-warnbtn:hover{background:rgba(220,90,90,.22);border-color:rgba(220,90,90,.7);}
      .amkz-crm-warnbtn u{color:#ffd0d0;text-underline-offset:2px;white-space:nowrap;}
      .amkz-crm-hint{opacity:.6;font-size:.8rem;margin:4px 2px 10px;}
      .amkz-crm-names{display:flex;flex-direction:column;gap:8px;max-height:60vh;overflow-y:auto;}
      .amkz-crm-nameRow{text-align:left;cursor:pointer;background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.09);border-radius:13px;padding:11px 14px;color:inherit;font:inherit;transition:transform .12s,border-color .15s,background .15s;}
      .amkz-crm-nameRow:hover{transform:translateY(-1px);border-color:rgba(212,175,55,.5);background:rgba(212,175,55,.08);}
      .amkz-crm-nameRow-top{display:flex;justify-content:space-between;gap:10px;align-items:baseline;}
      .amkz-crm-nameRow-top b{font-size:1rem;}
      .amkz-crm-nameRow-sum{color:#f0d488;font-weight:800;font-size:.85rem;white-space:nowrap;}
      .amkz-crm-nameRow-sub{font-size:.78rem;opacity:.7;margin-top:3px;word-break:break-all;}
      .amkz-crm-nameRow-sub.amkz-crm-mut{opacity:.45;}
      .amkz-crm-stats{display:flex;gap:10px;margin-bottom:8px;flex-wrap:wrap;}
      .amkz-crm-modal .amkz-modal-header p{word-break:break-all;}
      .amkz-crm-stat{flex:1 1 108px;min-width:0;background:rgba(255,255,255,.04);border:1px solid rgba(212,175,55,.18);border-radius:14px;padding:12px;text-align:center;}
      .amkz-crm-stat small{display:block;opacity:.55;font-size:.68rem;text-transform:uppercase;letter-spacing:.04em;}
      .amkz-crm-stat strong{font-size:1.3rem;background:linear-gradient(135deg,#f4d98a,#c79b3b);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;}
      .amkz-crm-sec{margin:14px 0 6px;font-size:.75rem;text-transform:uppercase;letter-spacing:.05em;opacity:.6;color:#e9cd86;}
      .amkz-crm-scroll{max-height:min(46vh,520px);overflow-y:auto !important;overflow-x:auto !important;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;}
      /* --- Komplette Historie (System + Gewinnspiel) --- */
      .amkz-crm-cnt{float:right;font-size:.7rem;letter-spacing:.04em;opacity:.75;background:rgba(230,184,92,.12);border:1px solid rgba(230,184,92,.28);border-radius:999px;padding:2px 10px;color:#f0d488;}
      .amkz-crm-hfilter{display:flex;gap:6px;flex-wrap:wrap;margin:0 0 8px;}
      .amkz-crm-hfbtn{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.12);color:inherit;opacity:.75;border-radius:10px;padding:6px 12px;font:inherit;font-size:.78rem;font-weight:700;cursor:pointer;white-space:nowrap;}
      .amkz-crm-hfbtn:hover{background:rgba(230,184,92,.1);}
      .amkz-crm-hfbtn.active{background:rgba(230,184,92,.16);border-color:rgba(230,184,92,.45);color:#f0d488;opacity:1;}
      .amkz-crm-hwrap{max-height:min(54vh,600px) !important;overflow-y:auto !important;overflow-x:auto !important;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;}
      .amkz-crm-htable{min-width:680px;table-layout:auto !important;}
      .amkz-crm-htable td,.amkz-crm-htable th{overflow:hidden !important;padding-right:16px;}
      .amkz-crm-htable thead th{position:sticky;top:0;z-index:3;background:#0d0d12 !important;}
      .amkz-crm-hdate{white-space:nowrap;font-variant-numeric:tabular-nums;}
      .amkz-crm-hide{display:none !important;}
      .amkz-crm-srcpill{display:inline-block;padding:2px 9px;border-radius:999px;font-size:.7rem;font-weight:800;white-space:nowrap;}
      .amkz-crm-srcpill.gv{background:rgba(230,184,92,.16);color:#f0d488;border:1px solid rgba(230,184,92,.3);}
      .amkz-crm-srcpill.sys{background:rgba(120,170,255,.14);color:#a9c7ff;border:1px solid rgba(120,170,255,.28);}
      .amkz-crm-stpill{display:inline-block;padding:2px 9px;border-radius:999px;font-size:.7rem;font-weight:700;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.12);white-space:nowrap;}
      @media (max-width:640px){ .amkz-crm-hwrap{max-height:62vh !important;} .amkz-crm-scroll{max-height:52vh;} }
      .amkz-crm-clickrow{cursor:pointer;} .amkz-crm-clickrow:hover{background:rgba(212,175,55,.08);}
      .amkz-crm-noteadd{display:flex;gap:8px;margin-bottom:8px;}
      .amkz-crm-noteadd input{flex:1;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.14);border-radius:10px;padding:9px 12px;color:#eee;font-size:.86rem;}
      .amkz-crm-notes{display:flex;flex-direction:column;gap:6px;max-height:26vh;overflow-y:auto;}
      .amkz-crm-note{background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.07);border-radius:10px;padding:8px 11px;}
      .amkz-crm-note-txt{font-size:.9rem;}
      .amkz-crm-note-meta{font-size:.72rem;opacity:.55;margin-top:4px;display:flex;justify-content:space-between;align-items:center;}
      .amkz-crm-note-del{background:none;border:none;color:#ff8080;cursor:pointer;}
      .amkz-crm-empty,.amkz-crm-hint{opacity:.55;font-size:.82rem;padding:6px 0;}
      .amkz-crm-contacts{display:flex;flex-direction:column;gap:8px;max-height:60vh;overflow-y:auto;}
      .amkz-crm-contact{position:relative;background:rgba(255,255,255,.03);border:1px solid rgba(212,175,55,.15);border-radius:12px;padding:11px 13px;}
      .amkz-crm-contact-main strong{font-size:1rem;}
      .amkz-crm-contact-links{display:flex;gap:10px;flex-wrap:wrap;margin-top:5px;font-size:.82rem;}
      .amkz-crm-contact-links a{color:#e9c76a;text-decoration:none;border:1px solid rgba(212,175,55,.3);border-radius:8px;padding:2px 9px;}
      .amkz-crm-contact-links a:hover{background:rgba(212,175,55,.14);}
      .amkz-crm-contact-note{font-size:.82rem;opacity:.75;margin-top:6px;}
      .amkz-crm-contact-act{position:absolute;top:10px;right:10px;display:flex;gap:6px;}
    `;
    document.head.appendChild(s);
  }

  AMKZ.crm = { openEntryDetail, openPersonProfile, openScopeProfile, openContacts, ensureSearchBar };
})();

/* =====================================================
   AMK ZENTRALE — KONTO-BALANCES (Stand + Verlauf)
   + 300K TICKET-BOOST-Verwaltung
   Beide Karten werden in die Streaming-Verwaltung (#amkzStreamManagePanel)
   eingehängt. SQL: supabase-balances.sql + supabase-boost.sql + supabase-boost-casinos.sql.
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__balanceLedger) return;
  AMKZ.__balanceLedger = true;

  const byId = (id) => document.getElementById(id);
  const sb = () => AMKZ.supabase;
  const me = () => AMKZ.state && AMKZ.state.member;
  const esc = (s) => String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  const money = (n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n || 0));
  const nowISO = () => new Date().toISOString();
  const canManage = () => !!(AMKZ.state && AMKZ.state.permissions && AMKZ.state.permissions.manageStreaming === true);
  // „36.410" / „36410,50" / „10k" -> Zahl
  function parseAmt(v) {
    let s = String(v == null ? "" : v).trim().toLowerCase().replace(/€/g, "").replace(/\s/g, "");
    if (!s) return 0;
    let kFactor = 1;
    if (/k$/.test(s)) { kFactor = 1000; s = s.replace(/k$/, ""); }
    if (s.indexOf(",") > -1) s = s.replace(/\./g, "").replace(",", ".");        // deutsch: Punkt=Tausender, Komma=Dezimal
    else if (/^\d{1,3}(\.\d{3})+$/.test(s)) s = s.replace(/\./g, "");            // 12.500 / 1.234.567 -> Tausenderpunkte
    const n = parseFloat(s.replace(/[^\d.\-]/g, ""));
    return isNaN(n) ? 0 : n * kFactor;
  }

  let ACCOUNTS = [], LATEST = {}, BOOST = null, obs = null, injecting = false;

  async function load() {
    if (!sb()) return;
    try {
      const { data: accs } = await sb().from("streaming_accounts").select(await AMKZ.spalten("streaming_accounts")).order("sort_order", { ascending: true });
      ACCOUNTS = (accs || []).filter((a) => !a.is_hidden);
    } catch (e) { ACCOUNTS = []; }
    LATEST = {};
    try {
      const ids = ACCOUNTS.map((a) => a.id);
      if (ids.length) {
        const { data: logs } = await sb().from("streaming_balance_log").select("*").in("account_id", ids).order("logged_at", { ascending: false });
        (logs || []).forEach((l) => { if (!LATEST[l.account_id]) LATEST[l.account_id] = l; });
      }
    } catch (e) {}
  }

  /* ---------- Balance-Karte ---------- */
  function balanceCardHtml() {
    const total = ACCOUNTS.reduce((s, a) => s + Number(a.current_balance || 0), 0);
    const rows = ACCOUNTS.map((a) => {
      const bal = a.current_balance != null ? Number(a.current_balance) : 0;
      const when = a.balance_updated_at ? new Date(a.balance_updated_at).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(", ", " ")
        : (LATEST[a.id] ? new Date(LATEST[a.id].logged_at).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(", ", " ") : ""); // Nachtschicht 31.10.: einheitlich TT.MM.JJJJ HH:MM, sonst „Noch kein Stand“
      const ini = (a.casino_name || "?").trim().replace(/[^\p{L}\p{N}]/gu, "").slice(0, 2).toUpperCase() || "?";
      const _cn = String(a.casino_name || "").toLowerCase().trim();
      const _cs = (window.AMKZ && AMKZ.state && AMKZ.state.casinos) || [];
      const _m = _cs.find((c) => String(c.name || "").toLowerCase().trim() === _cn);
      const logo = a.logo_url || a.casino_logo || (_m && (_m.logo_url || _m.logo)) || (window.AMK_CASINO_LOGOS || {})[_cn] || "";
      return `<div class="amk-bl-row" data-bl-acct="${esc(a.id)}">
        <div class="amk-bl-lead">
          <div class="amk-bl-ava">${logo ? `<img src="${esc(logo)}" alt="${esc(a.casino_name || "")}" onerror="this.outerHTML='${esc(ini)}'">` : esc(ini)}</div>
          <div class="amk-bl-id"><strong>${esc(a.casino_name)}</strong><small>${esc(a.login_email || "")}</small></div>
        </div>
        <div class="amk-bl-field">
          <div class="amk-bl-input"><span class="amk-bl-cur">€</span><input type="text" class="amk-bl-amt" value="${bal ? esc(String(bal).replace(".", ",")) : ""}" placeholder="0,00" inputmode="decimal" data-bl-input="${esc(a.id)}"></div>
          <div class="amk-bl-last">${when ? "Stand: " + esc(when) : "Noch kein Stand"}</div>
        </div>
        <div class="amk-bl-actions">
          <button type="button" class="amk-bl-save" data-bl-save="${esc(a.id)}">Speichern</button>
          <button type="button" class="amk-bl-hist" data-bl-hist="${esc(a.id)}">📈 Verlauf</button>
        </div>
      </div>`;
    }).join("");
    return `<div class="amkz-stream-card amk-bl-card" id="amkBalanceLedgerCard">
      <div class="amk-bl-top">
        <div class="amk-bl-topl"><h3>Kontostände &amp; Verlauf</h3>
          <p class="amkz-stream-sub">Aktuellen Stand je Konto eintragen (z. B. nach Opening von 10K auf 36.410€). Jede Änderung wird im Verlauf gespeichert.</p></div>
        <div class="amk-bl-total"><small>Gesamt aktuell</small><strong>${money(total)}</strong></div>
      </div>
      <div class="amk-bl-list">${rows || '<div class="amkz-empty">Keine Konten. Erst Casino-Zugänge anlegen.</div>'}</div>
    </div>`;
  }

  async function saveBalance(id) {
    const acc = ACCOUNTS.find((a) => a.id === id); if (!acc) return;
    const inp = document.querySelector('[data-bl-input="' + id + '"]');
    if (!inp) return;
    const val = parseAmt(inp.value);
    const prev = acc.current_balance != null ? Number(acc.current_balance) : null;
    let ok = false;
    try { const { error } = await sb().from("streaming_accounts").update({ current_balance: val, balance_updated_at: nowISO(), updated_at: nowISO() }).eq("id", id); ok = !error; if (error) throw error; }
    catch (e) { try { const { error } = await sb().from("streaming_accounts").update({ current_balance: val, updated_at: nowISO() }).eq("id", id); ok = !error; } catch (_) {} }
    try {
      await sb().from("streaming_balance_log").insert({ account_id: id, casino_name: acc.casino_name, login_email: acc.login_email, balance: val, prev_balance: prev, logged_by: me()?.id || null, logged_by_name: me()?.name || me()?.email || "" });
    } catch (e) { /* Log-Tabelle evtl. noch nicht angelegt */ }
    if (ok) { AMKZ.toast?.("Gespeichert", acc.casino_name + ": " + money(val)); acc.current_balance = val; acc.balance_updated_at = nowISO(); await refresh(); }
    else AMKZ.toast?.("Fehler", "Konnte den Stand nicht speichern.", "error");
  }

  async function showHistory(id) {
    const acc = ACCOUNTS.find((a) => a.id === id);
    let logs = [];
    try { const { data } = await sb().from("streaming_balance_log").select("*").eq("account_id", id).order("logged_at", { ascending: false }).limit(80); logs = data || []; } catch (e) {}
    const rows = logs.length ? logs.map((l) => {
      const delta = (l.prev_balance != null) ? (Number(l.balance) - Number(l.prev_balance)) : null;
      const dtxt = (delta == null) ? "" : (delta >= 0 ? "+" : "") + money(delta);
      const dcls = (delta == null) ? "" : (delta >= 0 ? "up" : "down");
      return `<div class="amk-blh-row">
        <div class="amk-blh-main"><strong>${money(l.balance)}</strong> ${dtxt ? `<span class="amk-blh-delta ${dcls}">${esc(dtxt)}</span>` : ""}</div>
        <div class="amk-blh-meta">${l.note ? esc(l.note) + " · " : ""}${l.logged_by_name ? esc(l.logged_by_name) + " · " : ""}${esc(new Date(l.logged_at).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(", ", " "))}</div>
      </div>`;
    }).join("") : '<div class="amkz-empty">Noch kein Verlauf für dieses Konto.</div>';
    AMKZ.modal.open(`<div class="amk-blh-modal">
      <button class="amk-blh-x" data-amkz-close-modal aria-label="Schließen">✕</button>
      <h3>Verlauf · ${esc(acc ? acc.casino_name : "")} <small>${esc(acc ? acc.login_email || "" : "")}</small></h3>
      <div class="amk-blh-list">${rows}</div>
    </div>`);
  }

  /* ---------- Boost-Verwaltungskarte ---------- */
  function boostFnUrl() {
    const root = byId("amkzApp");
    const url = root?.dataset?.supabaseUrl || "https://cbwxgikndyyzdslmfpmo.supabase.co";
    return { url: url.replace(/\/$/, "") + "/functions/v1/giveaway", key: root?.dataset?.supabaseKey || "" };
  }
  async function boostCall(payload) {
    const { url, key } = boostFnUrl();
    // Schreiben braucht seit dem 03.09. die Hub-Sitzung (Team-Anmeldung wie Casino-Hub/Verlosung). Sie geht im
    // Body mit (admin_token) — als Header muesste die Function ihn erst in CORS erlauben; sie liest beides.
    const sitzung = localStorage.getItem("amkch_token") || "";
    const r = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json", apikey: key, Authorization: "Bearer " + key }, body: JSON.stringify(Object.assign({ admin_token: sitzung }, payload)) });
    return r.json().catch(() => ({}));
  }
  /* Ohne gueltige Hub-Sitzung sagt die Function „Nicht angemeldet." — vorher blieb es beim Fehler, jetzt fragt
     die Zentrale einmal nach dem Zentrale-Passwort (dieselbe Anmeldung wie Casino-Hub/Verlosung, 30 Tage). */
  function boostAnmelden() {
    return new Promise((fertig) => {
      if (!AMKZ.modal || !AMKZ.modal.open) { fertig(false); return; }
      const mail = (AMKZ.state && AMKZ.state.member && AMKZ.state.member.email) || "";
      AMKZ.modal.open(`<div class="amkz-modal" style="max-width:460px">
        <div class="amkz-modal-header"><div><h3>🔒 Kurz bestätigen</h3><p>Boost speichern braucht die Team-Anmeldung wie beim Casino-Hub — einmal dein Zentrale-Passwort, dann bleibt es 30 Tage.</p></div><button type="button" class="amkz-modal-close" data-amkz-close-modal>✕</button></div>
        <div class="amkz-form-grid" style="display:grid;gap:10px">
          <input id="amkBoostLoginMail" type="email" placeholder="E-Mail" value="${esc(mail)}" autocomplete="username">
          <input id="amkBoostLoginPass" type="password" placeholder="Zentrale-Passwort" autocomplete="current-password">
          <div id="amkBoostLoginMsg" class="amkz-login-error" aria-live="polite"></div>
          <button type="button" class="amkz-primary-btn" id="amkBoostLoginGo">Bestätigen und speichern</button>
        </div></div>`);
      const go = byId("amkBoostLoginGo"), pass = byId("amkBoostLoginPass"); if (!go) { fertig(false); return; }
      let erledigt = false;
      const overlay = byId("amkzModalOverlay");
      const beob = new MutationObserver(() => { if (overlay && !overlay.classList.contains("active") && !erledigt) { erledigt = true; beob.disconnect(); fertig(false); } });
      if (overlay) beob.observe(overlay, { attributes: true, attributeFilter: ["class"] });
      const los = async () => {
        go.disabled = true; go.textContent = "Prüft …";
        try {
          const api = window.AMK_HUB_API || "https://cbwxgikndyyzdslmfpmo.supabase.co/functions/v1/vertrieb";
          const res = await fetch(api, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ action: "hub_login", email: byId("amkBoostLoginMail").value.trim(), password: pass.value }) });
          const d = await res.json().catch(() => ({}));
          if (!res.ok || d.ok === false || !d.token) throw new Error(d.error || "Anmeldung fehlgeschlagen");
          localStorage.setItem("amkch_token", d.token);
          erledigt = true; beob.disconnect(); AMKZ.modal.close(); fertig(true);
        } catch (e) { const m = byId("amkBoostLoginMsg"); if (m) m.textContent = e.message; go.disabled = false; go.textContent = "Bestätigen und speichern"; }
      };
      go.addEventListener("click", los);
      pass.addEventListener("keydown", (e) => { if (e.key === "Enter") { e.preventDefault(); los(); } });
      setTimeout(() => pass.focus(), 80);
    });
  }
  const WD = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
  const boostHasCasinos = () => Array.isArray(BOOST && BOOST.casinos) && BOOST.casinos.length > 0;
  function boostCasinoRows() {
    const list = (BOOST && BOOST.casinos) || [];
    if (!list.length) return `<div class="amk-boostc-todo">
      <strong>Noch nicht eingerichtet.</strong> Zwei Schritte, dann erscheinen hier alle Casinos:
      <ol><li>In Supabase → SQL-Editor die Datei <code>supabase-boost-casinos.sql</code> ausführen.</li>
      <li>Edge Function <code>giveaway</code> neu deployen (Datei <code>supabase/functions/giveaway/index.ts</code>).</li></ol>
      Solange gilt das alte Verhalten: der Boost greift bei <strong>allen</strong> Casinos.</div>`;
    return list.map((c) => {
      const own = (c.multiplier != null && Number(c.multiplier) !== Number((BOOST.config || {}).multiplier || 20));
      return `<div class="amk-boostc-row ${c.enabled ? "is-on" : ""} ${c.active ? "is-live" : ""}" data-boostc="${esc(c.casino)}">
        <label class="amk-boostc-name">
          <input type="checkbox" class="amk-boostc-on" data-boostc-on="${esc(c.casino)}" ${c.enabled ? "checked" : ""}>
          <span>${esc(c.casino)}</span>
        </label>
        <label class="amk-boostc-mult">Faktor
          <input type="number" class="amk-boostc-x" data-boostc-x="${esc(c.casino)}" min="1" max="100" step="1"
                 value="${own ? esc(c.multiplier) : ""}" placeholder="global">
        </label>
        <span class="amk-boostc-state">${c.active ? "🔥 läuft" : c.enabled ? "scharf" : "aus"}</span>
      </div>`;
    }).join("");
  }
  function boostCardHtml() {
    const c = (BOOST && BOOST.config) || {}, st = (BOOST && BOOST.state) || {};
    const enabled = c.enabled !== false;
    // banner_mode kommt erst mit der neuen Edge Function — sonst aus dem alten Schalter ableiten.
    const bannerMode = ["immer", "live", "aus"].includes(c.banner_mode) ? c.banner_mode : (c.show_banner === false ? "aus" : "immer");
    const armed = (st.active_casinos || []);
    const noCasino = enabled && armed.length === 0;
    const statusTxt = (BOOST && BOOST.__err) ? `<span class="amk-boost-err">⚠︎ ${BOOST.__err}</span>` : !BOOST ? "wird geladen…" : (st.active
      ? `<span class="amk-boost-live">🔥 LÄUFT GERADE</span> · endet in ${Math.floor((st.seconds_left||0)/3600)}h ${Math.floor(((st.seconds_left||0)%3600)/60)}m`
      : (st.window_open && boostHasCasinos())
      ? `<span class="amk-boost-err">Fenster offen, aber kein Casino scharf</span>`
      : `nächster: ${WD[c.weekday ?? 0]} ${String(c.start_hour ?? 16).padStart(2,"0")}:00 Uhr`);
    const wdOpts = WD.map((n, i) => `<option value="${i}" ${Number(c.weekday) === i ? "selected" : ""}>${n}</option>`).join("");
    const scope = !BOOST ? "" : !boostHasCasinos()
      ? `<span class="amk-boost-scope">Casino-Freigaben noch nicht aktiv — der Boost greift derzeit bei <strong>allen</strong> Casinos.</span>`
      : armed.length === 0
      ? `<span class="amk-boost-scope is-none">Kein Casino scharf — der Boost greift nirgends.</span>`
      : st.all_casinos_armed
      ? `<span class="amk-boost-scope">Scharf für <strong>alle Casinos</strong></span>`
      : `<span class="amk-boost-scope">Scharf nur für <strong>${armed.map(esc).join(", ")}</strong></span>`;
    const sqlHint = (BOOST && !BOOST.__err && BOOST.casinos_table === false)
      ? `<div class="amk-boost-err" style="margin-bottom:10px">⚠︎ Tabelle <code>giveaway_boost_casinos</code> fehlt — <strong>supabase-boost-casinos.sql</strong> in Supabase ausführen. Solange gilt der Boost für alle Casinos.</div>` : "";
    return `<div class="amkz-stream-card amk-boost-card" id="amkBoostCard">
      <h3>300K Giveaway · Ticket-Boost</h3>
      <p class="amkz-stream-sub">Automatischer Punkte-Boost. Läuft serverseitig — im Zeitfenster zählt jede Einzahlung mehrfach, aber <strong>nur bei den Casinos, die du unten scharf stellst</strong>.</p>
      ${sqlHint}
      <div class="amk-boost-status">Status: ${statusTxt}</div>
      <div class="amk-boost-grid">
        <label class="amk-boost-toggle"><input type="checkbox" id="amkBoostEnabled" ${enabled ? "checked" : ""}> Boost aktiv</label>
        <label>Faktor (global)<input type="number" id="amkBoostMult" min="1" max="100" step="1" value="${esc(c.multiplier ?? 20)}"></label>
        <label>Wochentag<select id="amkBoostWeekday">${wdOpts}</select></label>
        <label>Start (Std)<input type="number" id="amkBoostStart" min="0" max="23" value="${esc(c.start_hour ?? 16)}"></label>
        <label>Ende (Std)<input type="number" id="amkBoostEnd" min="1" max="24" value="${esc(c.end_hour ?? 22)}"></label>
      </div>
      <div class="amk-boostb">
        <div class="amk-boostc-head"><strong>Ticket-Eingabe</strong></div>
        <p class="amk-boostc-note">Sperrt das Eintragen neuer Einzahlungen für <strong>alle Casinos</strong> — serverseitig, also auf der 300K-Seite und jedem anderen Eingabeweg. Bereits eingetragene Tickets bleiben, Korrekturen hier in der Zentrale gehen weiter. Solange gesperrt ist, zeigt keine Seite das Boost-Banner.</p>
        <div class="amk-boostb-grid">
          <label>Eingabe
            <select id="amkBoostEntries">
              <option value="offen" ${c.entries_open === false ? "" : "selected"}>Offen — Spieler können eintragen</option>
              <option value="zu" ${c.entries_open === false ? "selected" : ""}>Gesperrt — keine neuen Einträge</option>
            </select>
          </label>
          <label class="amk-boostb-url">Hinweis für Spieler
            <input type="text" id="amkBoostEntriesNote" maxlength="300" placeholder="Die Ticket-Eingabe ist geschlossen." value="${esc(c.entries_note || "")}">
          </label>
        </div>
        ${(BOOST && BOOST.sperre_sql_fehlt) ? `<div class="amk-boost-err" style="margin-top:8px">⚠︎ Sperre nicht gespeichert — <strong>supabase-ticket-sperre.sql</strong> in Supabase ausführen.</div>` : ""}
        <span class="amk-boost-scope ${c.entries_open === false ? "is-none" : ""}">${
          c.entries_open === false ? "⛔ Die Ticket-Eingabe ist <strong>gesperrt</strong> — Einzahlungen werden abgelehnt."
          : "Die Ticket-Eingabe ist <strong>offen</strong>."
        }</span>
      </div>
      <div class="amk-boostb">
        <div class="amk-boostc-head"><strong>Banner auf den Webseiten</strong></div>
        <p class="amk-boostc-note">Steuert das Boost-Bild auf der Giveaway-Seite und der Front.</p>
        <div class="amk-boostb-grid">
          <label>Wann anzeigen
            <select id="amkBoostBannerMode">
              ${[["immer", "Immer anzeigen"], ["live", "Nur wenn der Boost läuft"], ["aus", "Nie anzeigen"]]
                .map(([v, t]) => `<option value="${v}" ${bannerMode === v ? "selected" : ""}>${t}</option>`).join("")}
            </select>
          </label>
          <label class="amk-boostb-url">Banner-Bild (URL)
            <input type="url" id="amkBoostBannerUrl" placeholder="https://cdn.shopify.com/…" value="${esc(c.banner_url || "")}">
          </label>
        </div>
        ${c.banner_url ? `<div class="amk-boostb-prev"><img src="${esc(c.banner_url)}" alt="Vorschau Boost-Banner" loading="lazy"></div>` : ""}
        <span class="amk-boost-scope ${bannerMode === "live" && !st.active ? "is-none" : ""}">${
          bannerMode === "aus" ? "Das Banner steht aktuell auf <strong>keiner</strong> Seite."
          : bannerMode === "live" ? (st.active
              ? "Der Boost läuft — das Banner ist <strong>gerade sichtbar</strong>."
              : "Das Banner erscheint erst, <strong>sobald der Boost läuft</strong>. Aktuell ist es ausgeblendet.")
          : "Das Banner steht <strong>dauerhaft</strong> auf den Seiten — auch außerhalb des Boost-Fensters."
        }</span>
      </div>
      <div class="amk-boostb">
        <div class="amk-boostc-head"><strong>Live-Ticker „Extra-Punkte vergeben"</strong></div>
        <p class="amk-boostc-note">Die Liste der Boost-Tage auf der 300K-Seite, der Front und der Boost-Section. „Nur ab Datum" blendet ältere Boost-Tage aus, die Summe zählt dann nur die gezeigten Tage.</p>
        <div class="amk-boostb-grid">
          <label>Ticker zeigt
            <select id="amkBoostTicker">
              ${[["alle", "Alle Boost-Tage"], ["ab", "Nur Tage ab Datum"], ["aus", "Ticker ausblenden"]]
                .map(([v, t]) => `<option value="${v}" ${(c.ticker_mode || "alle") === v ? "selected" : ""}>${t}</option>`).join("")}
            </select>
          </label>
          <label>ab Datum
            <input type="date" id="amkBoostTickerAb" value="${esc(String(c.ticker_ab || "").slice(0, 10) || (() => { const d = new Date(); return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0"); })())}">
          </label>
        </div>
        ${(BOOST && BOOST.ticker_sql_fehlt) ? `<div class="amk-boost-err" style="margin-top:8px">⚠︎ Ticker-Einstellung nicht gespeichert — <strong>supabase-boost-ticker.sql</strong> in Supabase ausführen.</div>` : ""}
      </div>
      <div class="amk-boostc">
        <div class="amk-boostc-head">
          <strong>Casinos einzeln scharf stellen</strong>
          <div class="amk-boostc-quick">
            <button type="button" class="amkz-secondary-btn" data-boostc-all="1">Alle an</button>
            <button type="button" class="amkz-secondary-btn" data-boostc-all="0">Alle aus</button>
          </div>
        </div>
        <p class="amk-boostc-note">Faktor leer = globaler Faktor (${esc(c.multiplier ?? 20)}×). Eigener Wert überschreibt ihn nur für dieses Casino.</p>
        <div class="amk-boostc-list">${boostCasinoRows()}</div>
        ${scope}
      </div>
      <div class="amk-boost-foot">
        <button type="button" class="amkz-primary-btn" data-boost-save>Boost speichern</button>
        <span class="amk-boost-extra">${BOOST ? "Bisher vergeben: <strong>" + Number(st.__totalExtra || (BOOST.totalExtra||0)).toLocaleString("de-DE") + " Extra-Punkte</strong>" : ""}</span>
      </div>
      ${noCasino ? "" : ""}
    </div>`;
  }
  async function loadBoost() {
    try {
      const r = await boostCall({ action: "boost_config" });
      BOOST = (r && r.status === "success") ? r
        : { __err: (r && r.message) || "Boost-Funktion antwortet nicht — Edge-Function 'giveaway' neu deployen + supabase-boost.sql ausführen." };
    } catch (e) { BOOST = { __err: "Boost-Funktion nicht erreichbar — Edge-Function 'giveaway' deployen." }; }
    // Gesamt-Extra separat holen (boost_status liefert totalExtra)
    try { const s = await boostCall({ action: "boost_status" }); if (s && s.status === "success") { BOOST = BOOST || {}; BOOST.totalExtra = s.totalExtra || 0; BOOST.byCasino = s.byCasino || []; } } catch (e) {}
  }
  function collectBoostCasinos() {
    return Array.from(document.querySelectorAll("[data-boostc]")).map((row) => {
      const casino = row.getAttribute("data-boostc");
      const on = row.querySelector("[data-boostc-on]");
      const x  = row.querySelector("[data-boostc-x]");
      const v  = x && String(x.value).trim();
      return { casino, enabled: !!(on && on.checked), multiplier: v ? Number(v) : null };
    });
  }
  async function saveBoost() {
    const casinos = collectBoostCasinos();
    const save = {
      enabled: !!byId("amkBoostEnabled")?.checked,
      banner_mode: byId("amkBoostBannerMode")?.value || "immer",
      banner_url: (byId("amkBoostBannerUrl")?.value || "").trim(),
      ticker_mode: byId("amkBoostTicker")?.value || "alle",
      ticker_ab: byId("amkBoostTickerAb")?.value || null,
      entries_open: byId("amkBoostEntries")?.value !== "zu",
      entries_note: (byId("amkBoostEntriesNote")?.value || "").trim(),
      multiplier: Number(byId("amkBoostMult")?.value) || 20,
      weekday: Number(byId("amkBoostWeekday")?.value) || 0,
      start_hour: Number(byId("amkBoostStart")?.value) || 16,
      end_hour: Number(byId("amkBoostEnd")?.value) || 22,
      casinos,
    };
    let r = await boostCall({ action: "boost_config", save });
    if (r && (r.code === "UNAUTHORIZED" || /Nicht angemeldet/.test(String(r.message || "")))) {
      localStorage.removeItem("amkch_token");
      if (await boostAnmelden()) r = await boostCall({ action: "boost_config", save });
      else { AMKZ.toast?.("Nicht gespeichert", "Ohne Team-Anmeldung lässt sich der Boost nicht speichern.", "error"); return; }
    }
    if (r && r.status === "success") {
      BOOST = Object.assign({ totalExtra: BOOST?.totalExtra || 0, byCasino: BOOST?.byCasino || [] }, r);
      const armed = (r.state && r.state.active_casinos) || [];
      AMKZ.toast?.("Gespeichert", armed.length ? "Boost scharf für: " + armed.join(", ") : "Boost gespeichert — aktuell ist kein Casino scharf gestellt.");
      if (r.ticker_sql_fehlt) AMKZ.toast?.("Ticker nicht gespeichert", "In Supabase noch supabase-boost-ticker.sql ausführen, dann Ticker-Einstellung erneut speichern.", "error");
      if (r.sperre_sql_fehlt) AMKZ.toast?.("Sperre nicht gespeichert", "In Supabase noch supabase-ticket-sperre.sql ausführen, dann erneut speichern.", "error");
      else if (r.config && r.config.entries_open === false) AMKZ.toast?.("Ticket-Eingabe gesperrt", "Neue Einzahlungen werden ab sofort abgelehnt.");
      repaintBoostCard();
    }
    else AMKZ.toast?.("Fehler", (r && r.message) || "Boost-Konfiguration nicht gespeichert. SQL supabase-boost.sql ausgeführt?", "error");
  }
  // Zeichnet die Karte neu — egal, in welcher Ansicht sie gerade hängt.
  // Hat sich eine Ansicht per AMKZ.boost.onChange eingetragen, zeichnet die.
  function repaintBoostCard() {
    if (typeof AMKZ.boost?.onChange === "function") { AMKZ.boost.onChange(); return; }
    const el = byId("amkBoostCard"); if (!el) return;
    el.outerHTML = boostCardHtml();
  }
  // Öffentliche Schnittstelle: die Giveaway-Ansicht rendert die Karte damit selbst.
  AMKZ.boost = {
    html: boostCardHtml,
    repaint: repaintBoostCard,
    save: saveBoost,
    anmelden: boostAnmelden,
    async load(force) { if (force) BOOST = null; if (BOOST === null) await loadBoost(); return BOOST; },
    get data() { return BOOST; },
  };

  /* ---------- Einhängen ---------- */
  function panelReady() {
    const panel = byId("amkzStreamManagePanel");
    if (!panel || panel.classList.contains("is-hidden")) return null;
    if (!panel.querySelector(".amkz-acct-chips")) return null; // Manage-View noch nicht gerendert
    return panel;
  }
  function withPause(fn) {
    if (obs) obs.disconnect();
    try { fn(); } finally { const p = byId("amkzStreamManagePanel"); if (obs && p) obs.observe(p, { childList: true, subtree: true }); }
  }
  function inject() {
    const panel = panelReady(); if (!panel) return;
    injecting = true;
    withPause(() => {
      // Balance-Karte
      const balHtml = balanceCardHtml();
      let card = byId("amkBalanceLedgerCard");
      if (card) card.outerHTML = balHtml;
      else {
        const anchor = panel.querySelector("[data-balance-laden]")?.closest(".amkz-stream-card");
        const tmp = document.createElement("div"); tmp.innerHTML = balHtml;
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(tmp.firstElementChild, anchor.nextSibling);
        else panel.appendChild(tmp.firstElementChild);
      }
      // Die Boost-Karte lebt in der Giveaway-Ansicht (AMKZ.boost) — hier nicht mehr einhängen.
    });
    injecting = false;
  }
  let refreshing = false;
  async function refresh() {
    if (refreshing) return; refreshing = true;
    try { await load(); inject(); }
    finally { refreshing = false; }
  }

  function ensureObserver() {
    const panel = byId("amkzStreamManagePanel");
    if (!panel || obs) return;
    let t = null;
    obs = new MutationObserver(() => {
      if (injecting) return;
      if (byId("amkBalanceLedgerCard")) return;
      clearTimeout(t); t = setTimeout(() => { if (panelReady()) inject(); }, 120);
    });
    obs.observe(panel, { childList: true, subtree: true });
  }

  /* ---------- Events ---------- */
  if (!document.body.dataset.amkBalanceBound) {
    document.body.dataset.amkBalanceBound = "1";
    document.addEventListener("click", (e) => {
      const save = e.target.closest("[data-bl-save]"); if (save) { saveBalance(save.getAttribute("data-bl-save")); return; }
      const hist = e.target.closest("[data-bl-hist]"); if (hist) { showHistory(hist.getAttribute("data-bl-hist")); return; }
      if (e.target.closest("[data-boost-save]")) { saveBoost(); return; }
      const all = e.target.closest("[data-boostc-all]");
      if (all) {
        const on = all.getAttribute("data-boostc-all") === "1";
        document.querySelectorAll("[data-boostc-on]").forEach((cb) => { cb.checked = on; cb.closest("[data-boostc]")?.classList.toggle("is-on", on); });
        return;
      }
    });
    document.addEventListener("change", (e) => {
      const cb = e.target.closest?.("[data-boostc-on]");
      if (cb) cb.closest("[data-boostc]")?.classList.toggle("is-on", cb.checked);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && e.target && e.target.classList && e.target.classList.contains("amk-bl-amt")) {
        e.preventDefault(); const id = e.target.getAttribute("data-bl-input"); if (id) saveBalance(id);
      }
    });
  }

  const prev = AMKZ.loadView;
  AMKZ.loadView = async function balanceLedgerLoadView(view, options) {
    const r = await (prev ? prev.call(this, view, options) : undefined);
    if (view === "streaming" && canManage()) {
      setTimeout(() => { ensureObserver(); refresh(); }, 600);
      setTimeout(() => { if (panelReady() && !byId("amkBalanceLedgerCard")) refresh(); }, 1200);
    }
    return r;
  };

  injectStyle();
  function injectStyle() {
    if (byId("amk-balance-style")) return;
    const s = document.createElement("style"); s.id = "amk-balance-style";
    s.textContent = `
      .amk-bl-top{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;flex-wrap:wrap;margin-bottom:16px}
      .amk-bl-topl{min-width:0}.amk-bl-card h3{margin:0 0 4px}
      .amk-bl-total{flex:none;text-align:right;padding:11px 18px;border-radius:15px;background:linear-gradient(135deg,rgba(212,175,55,.16),rgba(212,175,55,.04));border:1px solid rgba(212,175,55,.24)}
      .amk-bl-total small{display:block;font-size:.62rem;letter-spacing:.11em;text-transform:uppercase;color:#9c968a;margin-bottom:3px;font-weight:800}
      .amk-bl-total strong{font-size:1.4rem;color:#e9cd86;font-weight:850;letter-spacing:-.02em}
      .amk-bl-list{display:flex;flex-direction:column;gap:11px;max-height:452px;overflow-y:auto;padding-right:8px;scrollbar-width:thin}
      .amk-bl-list::-webkit-scrollbar{width:8px}
      .amk-bl-list::-webkit-scrollbar-thumb{background:rgba(206,170,108,.28);border-radius:999px}
      .amk-bl-row{display:flex;align-items:center;gap:18px;padding:15px 18px;border-radius:18px;background:linear-gradient(180deg,rgba(255,255,255,.03),rgba(255,255,255,0));border:1px solid rgba(255,255,255,.08);transition:border-color .15s ease,background .15s ease}
      .amk-bl-row:hover{border-color:rgba(212,175,55,.3);background:linear-gradient(180deg,rgba(212,175,55,.05),rgba(255,255,255,0))}
      .amk-bl-lead{display:flex;align-items:center;gap:12px;flex:1 1 190px;min-width:0}
      .amk-bl-ava{width:56px;height:56px;border-radius:16px;flex:none;display:grid;place-items:center;font-weight:900;font-size:1.2rem;color:#211a0b;background:linear-gradient(135deg,#e8d19e,#c3a05e);box-shadow:0 8px 20px -8px rgba(206,170,108,.7),inset 0 1px 0 rgba(255,255,255,.32);overflow:hidden}
      .amk-bl-ava img{width:100%;height:100%;object-fit:contain;padding:6px}
      .amk-bl-id{min-width:0}
      .amk-bl-id strong{display:block;font-size:1.24rem;color:#f4f1ec;font-weight:800;letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .amk-bl-id small{display:block;font-size:.98rem;color:#bcb8ae;font-weight:500;margin-top:3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .amk-bl-field{flex:0 0 auto;display:flex;flex-direction:column;gap:5px;align-items:flex-end}
      .amk-bl-input{display:flex;align-items:center;gap:8px;background:rgba(0,0,0,.28);border:1px solid rgba(212,175,55,.28);border-radius:12px;padding:0 14px;height:46px;transition:border-color .15s ease,box-shadow .15s ease}
      .amk-bl-input:focus-within{border-color:rgba(212,175,55,.6);box-shadow:0 0 0 3px rgba(212,175,55,.14)}
      .amk-bl-cur{color:#c79b3b;font-weight:850;font-size:1.05rem}
      .amk-bl-input input{width:132px;border:none;background:transparent;color:#fff;font-weight:800;font-size:1.12rem;text-align:right;outline:none;padding:0}
      .amk-bl-last{font-size:.72rem;color:#8b867b}
      .amk-bl-actions{flex:none;display:flex;gap:8px;align-items:center}
      .amk-bl-save{padding:0 18px;height:46px;border:none;border-radius:12px;cursor:pointer;font-weight:800;color:#1a1206;background:linear-gradient(135deg,#f0d38a,#c79b3b);box-shadow:0 10px 24px -12px rgba(212,175,55,.65);white-space:nowrap}
      .amk-bl-save:hover{filter:brightness(1.06)}
      .amk-bl-hist{height:46px;padding:0 14px;border-radius:12px;cursor:pointer;font-weight:700;color:#f0e6cf;background:rgba(255,255,255,.05);border:1px solid rgba(212,175,55,.28);white-space:nowrap}
      .amk-bl-hist:hover{background:rgba(212,175,55,.12)}
      @media(max-width:1024px){
        .amk-bl-row{flex-wrap:wrap;gap:12px}
        .amk-bl-lead{flex:1 1 100%}
        .amk-bl-field{flex:1 1 auto;align-items:stretch}
        .amk-bl-input{flex:1}.amk-bl-input input{flex:1;width:auto}
      }
      @media(max-width:560px){
        .amk-bl-total{width:100%;text-align:left}
        .amk-bl-field,.amk-bl-actions{flex:1 1 100%}
        .amk-bl-actions{display:grid;grid-template-columns:1fr auto}
        .amk-bl-save{width:100%}
      }
      .amk-blh-modal{position:relative;max-width:460px;margin:0 auto;background:#14100a;border:1px solid rgba(255,199,58,.25);border-radius:18px;padding:24px}
      .amk-blh-modal h3{margin:0 0 16px;font-size:1.15rem}
      .amk-blh-modal h3 small{color:var(--amkz-muted,#8b877e);font-weight:400;font-size:.8rem}
      .amk-blh-x{position:absolute;top:14px;right:14px;background:none;border:none;color:#fff;font-size:1.2rem;cursor:pointer;opacity:.7}
      .amk-blh-list{display:flex;flex-direction:column;gap:8px;max-height:52vh;overflow:auto}
      .amk-blh-row{padding:10px 13px;border-radius:10px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08)}
      .amk-blh-main strong{font-size:1.05rem}
      .amk-blh-delta{font-size:.82rem;font-weight:800;margin-left:8px;padding:2px 8px;border-radius:100px}
      .amk-blh-delta.up{color:#34d399;background:rgba(52,211,153,.12)}
      .amk-blh-delta.down{color:#f87171;background:rgba(248,113,113,.12)}
      .amk-blh-meta{font-size:.74rem;color:var(--amkz-muted,#8b877e);margin-top:3px}
      .amk-boost-card .amk-boost-status{font-size:.9rem;margin-bottom:12px;color:var(--amkz-muted,#8b877e)}
      .amk-boost-live{color:#e4b64a;font-weight:800}
      .amk-boost-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(120px,1fr));gap:10px;margin-bottom:14px}
      .amk-boost-grid label{display:flex;flex-direction:column;gap:5px;font-size:.78rem;color:var(--amkz-muted,#8b877e)}
      .amk-boost-grid input,.amk-boost-grid select{padding:8px 10px;border-radius:9px;border:1px solid rgba(255,199,58,.25);background:rgba(0,0,0,.3);color:#fff;font-weight:600}
      .amk-boost-toggle{flex-direction:row!important;align-items:center;gap:8px!important;color:#fff!important;font-weight:700;font-size:.9rem!important;grid-column:1/-1}
      .amk-boost-toggle input{width:auto}
      .amk-boost-toggle-banner{color:#f0d488!important}
      .amk-boost-foot{display:flex;align-items:center;gap:14px;flex-wrap:wrap}
      .amk-boost-extra{font-size:.84rem;color:var(--amkz-muted,#8b877e)}
      .amk-boost-extra strong{color:#e4b64a}
      .amk-boostb{margin:16px 0 14px;padding:14px;border-radius:12px;border:1px solid rgba(255,199,58,.16);background:rgba(0,0,0,.22)}
      .amk-boostb-grid{display:grid;grid-template-columns:minmax(200px,240px) minmax(240px,1fr);gap:10px;margin-bottom:12px}
      .amk-boostb-grid label{display:flex;flex-direction:column;gap:5px;font-size:.78rem;color:var(--amkz-muted,#8b877e)}
      .amk-boostb-grid input,.amk-boostb-grid select{padding:8px 10px;border-radius:9px;border:1px solid rgba(255,199,58,.25);background:rgba(0,0,0,.3);color:#fff;font-weight:600;min-width:0}
      .amk-boostb-grid .amk-boostb-url input{font-weight:500;font-size:.8rem}
      .amk-boostb-prev{margin-bottom:10px;border-radius:10px;overflow:hidden;border:1px solid rgba(255,255,255,.08);background:rgba(0,0,0,.3);max-width:420px}
      .amk-boostb-prev img{display:block;width:100%;height:auto}
      @media (max-width:640px){ .amk-boostb-grid{grid-template-columns:1fr} }
      .amk-boostc{margin:16px 0 14px;padding:14px;border-radius:12px;border:1px solid rgba(255,199,58,.16);background:rgba(0,0,0,.22)}
      .amk-boostc-head{display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;margin-bottom:6px}
      .amk-boostc-head strong{color:#f0d488;font-size:.95rem}
      .amk-boostc-quick{display:flex;gap:8px}
      .amk-boostc-quick .amkz-secondary-btn{padding:5px 10px;font-size:.75rem}
      .amk-boostc-note{font-size:.76rem;color:var(--amkz-muted,#8b877e);margin:0 0 10px}
      .amk-boostc-todo{padding:12px 14px;border-radius:10px;border:1px solid rgba(255,199,58,.28);background:rgba(255,199,58,.06);font-size:.84rem;color:#f0d488;line-height:1.55}
      .amk-boostc-todo ol{margin:8px 0 8px 18px;padding:0}
      .amk-boostc-todo li{margin:3px 0}
      .amk-boostc-todo code{background:rgba(0,0,0,.35);padding:1px 6px;border-radius:5px;color:#fff}
      .amk-boostc-list{display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:8px}
      .amk-boostc-row{display:flex;align-items:center;gap:10px;padding:8px 10px;border-radius:10px;border:1px solid rgba(255,255,255,.07);background:rgba(255,255,255,.02);opacity:.55;transition:.15s}
      .amk-boostc-row.is-on{opacity:1;border-color:rgba(255,199,58,.3);background:rgba(255,199,58,.05)}
      .amk-boostc-row.is-live{border-color:#e4b64a;box-shadow:0 0 0 1px rgba(228,182,74,.25)}
      .amk-boostc-name{display:flex!important;flex-direction:row!important;align-items:center;gap:8px;font-weight:700;color:#fff;font-size:.86rem;flex:1 1 auto;min-width:0;cursor:pointer}
      .amk-boostc-name span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
      .amk-boostc-name input{width:auto}
      .amk-boostc-mult{display:flex!important;flex-direction:row!important;align-items:center;gap:6px;font-size:.7rem;flex:0 0 auto;color:var(--amkz-muted,#8b877e)}
      .amk-boostc-mult input{width:58px;padding:5px 7px;border-radius:8px;border:1px solid rgba(255,199,58,.25);background:rgba(0,0,0,.35);color:#fff;font-weight:700;text-align:center}
      .amk-boostc-state{font-size:.7rem;color:var(--amkz-muted,#8b877e);flex:0 0 auto;min-width:44px;text-align:right}
      .amk-boostc-row.is-live .amk-boostc-state{color:#e4b64a;font-weight:800}
      .amk-boost-scope{display:block;margin-top:10px;font-size:.8rem;color:var(--amkz-muted,#8b877e)}
      .amk-boost-scope strong{color:#e4b64a}
      .amk-boost-scope.is-none{color:#e08a7a}
    `;
    document.head.appendChild(s);
  }

  AMKZ.balances = { refresh, showHistory, saveBalance };
})();

/* =====================================================================
   AMK ZENTRALE — Casino-Zugänge „Alle anzeigen"-Umschalter (additiv)
   ===================================================================== */
(function () {
  "use strict";
  document.addEventListener("click", function (e) {
    const b = e.target && e.target.closest && e.target.closest("[data-acc-showall]");
    if (!b) return;
    const card = b.closest(".amkz-stream-card");
    const list = card && card.querySelector(".amkz-acc-list");
    if (!list) return;
    const expanded = list.classList.toggle("amkz-acc-expanded");
    list.classList.toggle("amkz-acc-collapsed", !expanded);
    b.textContent = expanded ? "Weniger anzeigen ▴" : "Alle Konten anzeigen ▾";
  });
  // Casino-Logo-Zuordnung nach Name (kleingeschrieben) -> erscheint im Balance-Avatar.
  // FreshBet-Logo-URL hier eintragen (z. B. Shopify Files-Link), dann zeigt der Avatar das Logo:
  window.AMK_CASINO_LOGOS = window.AMK_CASINO_LOGOS || {
    freshbet: "https://cdn.shopify.com/s/files/1/0965/9813/1028/files/Freshbet.png?v=1781871149"
  };
})();

/* =====================================================================
   AMK ZENTRALE — KPI-AUFSCHLÜSSELUNG (Klick auf Kennzahl -> „wie kommt die Zahl")
   Dashboard + Finance. Nutzt die von V11 gecachten Rohdaten (AMKZ.state.kpi).
   ===================================================================== */
(function () {
  "use strict";
  const esc = (v) => String(v == null ? "" : v).replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]));
  const money = (n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n) || 0);
  const num = (n) => Number(n) || 0;
  const K = () => (window.AMKZ && AMKZ.state && AMKZ.state.kpi) || {};
  const casName = (r) => r.casino_name || ((window.AMKZ && AMKZ.state && (AMKZ.state.casinos || []).find((c) => String(c.id) === String(r.casino_id))) || {}).name || "—";
  const who = (r) => r.customer_name || r.customer_email || r.wallet_address || r.customer_wallet || r.partner_name || r.player_name || r.name || "—";

  function line(main, sub, val) {
    return `<div class="amkz-kpi-line"><div class="amkz-kpi-line-l"><strong>${esc(main)}</strong>${sub ? `<small>${esc(sub)}</small>` : ""}</div><span class="amkz-kpi-line-v">${val}</span></div>`;
  }
  function shell(title, sub, body, totalLabel, totalVal) {
    return `<div class="amkz-modal amkz-kpi-modal">
      <div class="amkz-modal-header"><div><h3>${esc(title)}</h3><p>${esc(sub)}</p></div><button class="amkz-modal-close" data-amkz-close-modal type="button">✕</button></div>
      <div class="amkz-kpi-break">${body || '<div class="amkz-empty">Keine Positionen im Zeitraum.</div>'}</div>
      <div class="amkz-kpi-total"><span>${esc(totalLabel)}</span><strong>${totalVal}</strong></div>
    </div>`;
  }
  function open(html) {
    // Core-Modal nutzen -> Schließen (X + Hintergrund + ESC) wird korrekt verdrahtet
    if (window.AMKZ && AMKZ.modal && typeof AMKZ.modal.open === "function") { AMKZ.modal.open(html); return; }
    const ov = document.getElementById("amkzModalOverlay"); if (!ov) return;
    ov.innerHTML = html; ov.classList.add("active");
    ov.querySelectorAll("[data-amkz-close-modal]").forEach((b) => b.addEventListener("click", () => { ov.classList.remove("active"); ov.innerHTML = ""; }));
    ov.addEventListener("click", (e) => { if (e.target === ov) { ov.classList.remove("active"); ov.innerHTML = ""; } }, { once: true });
  }

  const B = {
    amkzDashFtdCount() { const rows = (K().dashRows || []).filter((r) => String(r.entry_type || "").toUpperCase() === "FTD"); const sum = rows.reduce((s, r) => s + num(r.entry_amount), 0);
      return shell("FTDs — Aufschlüsselung", rows.length + " FTD im Zeitraum", rows.map((r) => line(who(r), (r.entry_date || "") + " · " + casName(r), money(r.entry_amount))).join(""), "Anzahl FTDs · Summe", rows.length + " · " + money(sum)); },
    amkzDashRedepoCount() { const rows = (K().dashRows || []).filter((r) => String(r.entry_type || "").toUpperCase() === "REDEPO"); const sum = rows.reduce((s, r) => s + num(r.entry_amount), 0);
      return shell("ReDepos — Aufschlüsselung", rows.length + " ReDepo im Zeitraum", rows.map((r) => line(who(r), (r.entry_date || "") + " · " + casName(r), money(r.entry_amount))).join(""), "Anzahl ReDepos · Summe", rows.length + " · " + money(sum)); },
    amkzDashExpectedProfit() { const rows = (K().dashRows || []); const body = rows.map((r) => line(who(r), (r.entry_date || "") + " · " + casName(r) + " · " + esc(r.entry_type || ""), money(r.expected_profit))).join(""); return shell("Deal-Gewinn Soll — Aufschlüsselung", "Erwarteter Gewinn je Eintrag (laut Deal)", body, "Deal-Gewinn Soll gesamt", money((K().dashS || {}).expectedProfit)); },
    amkzDashActualProfit() { const k = K(); const det = (k.dashDetRows || []); const man = (k.dashActual || []); let body = "";
      if (det.length) body += `<div class="amkz-kpi-sec">⚙︎ Automatisch (CPA / Deal)</div>` + det.map((r) => line(who(r), (r.entry_date || "") + " · " + casName(r) + " · " + esc(r.entry_type || ""), money(r.expected_profit))).join("");
      if (man.length) body += `<div class="amkz-kpi-sec">✎ Manuell erfasst (RevShare / Ist)</div>` + man.map((r) => line(r.partner_name || "Ist-Daten", (r.report_date || ""), money(r.actual_profit))).join("");
      const sub = "Automatisch " + money(k.dashAutoIst) + "  +  Manuell " + money(k.dashManualIst);
      return shell("Ist-Gewinn — Aufschlüsselung", sub, body, "Ist-Gewinn gesamt", money(k.dashIstTotal != null ? k.dashIstTotal : 0)); },
    amkzFinanceIncomeTotal() { const k = K(); const comp = [line("Deal-Einnahmen", "Erwartete Einnahmen aus Deals", money((k.finS || {}).expectedIncome)), line("Bezahlte Rechnungen", "Status bezahlt / erhalten", money(k.finInvoicesPaid)), line("Casino-Eingänge", "Finanz-Eingänge (Gewinne)", money(k.finInflowsSum))].join(""); return shell("Gesamt Eingänge — Aufschlüsselung", "So setzt sich der Wert zusammen", comp, "Gesamt Eingänge", money(k.finIncome)); },
    amkzFinanceExpenseTotal() { const rows = (K().finRows || []).filter((r) => num(r.expected_cost) !== 0); const body = rows.map((r) => line(who(r), (r.entry_date || "") + " · " + casName(r) + " · " + esc(r.entry_type || ""), money(r.expected_cost))).join(""); return shell("Gesamt Ausgänge — Aufschlüsselung", "FTD/ReDepo-Kosten & Ausgaben", body, "Gesamt Ausgänge", money((K().finS || {}).expectedCost)); },
    amkzFinanceOpenInvoices() { const inv = (K().invoices || []).filter((r) => String(r.document_type || "").toLowerCase() === "invoice" && !["paid", "received", "completed", "cancelled"].includes(String(r.status || "").toLowerCase())); const body = inv.map((r) => line(r.title || "Rechnung", (r.document_date || "") + " · " + esc(r.status || "offen"), money(r.amount))).join(""); return shell("Offene Rechnungen — Aufschlüsselung", inv.length + " offene Rechnung(en)", body, "Offen gesamt", money(K().finInvoicesOpen)); },
    amkzFinanceNetTotal() { const k = K(); const body = [line("Gesamt Eingänge", "", money(k.finIncome)), line("− Gesamt Ausgänge", "", money(k.finExpenses))].join(""); return shell("Netto-Finanzstand — Aufschlüsselung", "Eingänge minus Ausgänge", body, "Netto-Finanzstand", money(k.finNet)); },
  };

  document.addEventListener("click", function (e) {
    if (e.target.closest("#amkzModalOverlay")) return;
    const card = e.target.closest(".amkz-kpi-card"); if (!card) return;
    const strong = card.querySelector("strong[id]"); if (!strong) return;
    const build = B[strong.id]; if (!build) return;
    try { open(build()); } catch (err) { console.warn("[kpi-break]", err); }
  });

  function mark() {
    Object.keys(B).forEach((id) => {
      const el = document.getElementById(id); const card = el && el.closest(".amkz-kpi-card");
      if (card && !card.classList.contains("amkz-kpi-clickable")) {
        card.classList.add("amkz-kpi-clickable");
        card.setAttribute("title", "Klicken für Aufschlüsselung");
        const h = document.createElement("span"); h.className = "amkz-kpi-hint"; h.textContent = "ⓘ"; card.appendChild(h);
      }
    });
  }
  setInterval(mark, 1500); mark();
})();

/* =====================================================================
   AMK ZENTRALE — FINANCE-MONATSUMSCHALTER (Übersicht + Rechnungen)
   Finance ist immer monatsbasiert; Standard = laufender Monat.
   EIN Umschalter am „August 2026"-Chip (Übersicht) + in der Rechnungsliste,
   beide synchron über AMKZ.state.financeMonth. Treibt V11-KPIs + Rechnungsliste.
   ===================================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__financeMonth) return;
  AMKZ.__financeMonth = true;

  const byId = (id) => document.getElementById(id);
  const MONTHS = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
  const curKey = () => { const d = new Date(); return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0"); };
  const label = (k) => { if (k === "all") return "Alle Zeiträume"; const p = String(k).split("-"); return p.length === 2 ? `${MONTHS[(+p[1]) - 1]} ${p[0]}` : k; };
  const ensureMonth = () => { if (AMKZ.state.financeMonth === undefined) AMKZ.state.financeMonth = curKey(); return AMKZ.state.financeMonth; };

  function months() {
    const set = new Set(); const now = new Date();
    for (let i = 0; i < 12; i++) { const d = new Date(now.getFullYear(), now.getMonth() - i, 1); set.add(d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0")); }
    (AMKZ.state?.invoices || []).forEach((inv) => { const m = String(inv.document_date || "").slice(0, 7); if (/^\d{4}-\d{2}$/.test(m)) set.add(m); });
    return Array.from(set).sort((a, b) => b.localeCompare(a));
  }
  function optionsHtml(sel) {
    return months().map((m) => `<option value="${m}"${m === sel ? " selected" : ""}>${label(m)}</option>`).join("") +
      `<option value="all"${sel === "all" ? " selected" : ""}>Alle Zeiträume</option>`;
  }
  // Rechnungsstatus-Karte (offen/bezahlt/Verträge) monatsgenau neu rendern
  function renderStatus() {
    const box = byId("amkzFinanceInvoiceStatusList"); if (!box) return;
    const m = ensureMonth();
    const all = AMKZ.state?.invoices || [];
    const inv = (m && m !== "all") ? all.filter((i) => String(i.document_date || "").slice(0, 7) === m) : all;
    const open = inv.filter((i) => String(i.status || "open").toLowerCase() !== "paid").length;
    const paid = inv.filter((i) => String(i.status || "").toLowerCase() === "paid").length;
    const contracts = (AMKZ.state?.contracts || []).length;
    box.innerHTML =
      `<div class="amkz-table-row-card"><strong>${open} ${open === 1 ? "offene Rechnung" : "offene Rechnungen"}</strong><br><small>müssen noch geprüft/bezahlt werden</small></div>` +
      `<div class="amkz-table-row-card"><strong>${paid} ${paid === 1 ? "bezahlte Rechnung" : "bezahlte Rechnungen"}</strong><br><small>abgeschlossen</small></div>` +
      `<div class="amkz-table-row-card"><strong>${contracts} ${contracts === 1 ? "Vertrag" : "Verträge"}</strong><br><small>hinterlegt im System</small></div>`;
  }
  function apply(m) {
    AMKZ.state.financeMonth = m;
    try { AMKZ.modules?.v11?.loadFinanceCleanV11?.(); } catch (_) {}   // KPIs (Übersicht) neu
    try { AMKZ.edit?.enhanceAll?.(); } catch (_) {}                     // Rechnungsliste neu
    try { renderStatus(); } catch (_) {}                               // Status-Karte monatsgenau
    setTimeout(() => { try { AMKZ.crud?.runEnhancers?.(); } catch (_) {} sync(); renderStatus(); }, 90);
  }
  function bind(el) { if (!el || el.__b) return; el.__b = 1; el.addEventListener("change", () => apply(el.value)); }
  function sync() { const v = ensureMonth(); ["amkzFinanceMonthTop", "amkzInvoiceMonthSelect"].forEach((id) => { const s = byId(id); if (s) { s.innerHTML = optionsHtml(v); s.value = v; } }); }

  function renderTop() {
    const per = document.querySelector(".amkz-finance-period"); if (!per) return;
    ensureMonth();
    let sel = byId("amkzFinanceMonthTop");
    if (!sel) {
      const strong = byId("amkzFinancePeriodLabel"); if (strong) strong.style.display = "none";
      sel = document.createElement("select"); sel.id = "amkzFinanceMonthTop"; sel.setAttribute("aria-label", "Monat"); sel.className = "amk-fin-monthsel"; per.appendChild(sel);
    }
    sel.innerHTML = optionsHtml(AMKZ.state.financeMonth); sel.value = AMKZ.state.financeMonth; bind(sel);
  }
  function renderInvoiceBar() {
    const panel = byId("amkzFinanceInvoicesPanel"); if (!panel) return;
    ensureMonth();
    let bar = byId("amkzInvoiceMonthBar");
    if (!bar) {
      const card = panel.querySelector(".amkz-card") || panel;
      const wrap = card.querySelector(".amkz-table-wrap");
      bar = document.createElement("div"); bar.id = "amkzInvoiceMonthBar"; bar.className = "amk-inv-monthbar";
      if (wrap) card.insertBefore(bar, wrap); else card.appendChild(bar);
    }
    bar.innerHTML = `<span class="amk-inv-monthbar-lbl">🗓 Zeitraum</span><select id="amkzInvoiceMonthSelect" class="amk-fin-monthsel"></select>`;
    const s = byId("amkzInvoiceMonthSelect"); s.innerHTML = optionsHtml(AMKZ.state.financeMonth); s.value = AMKZ.state.financeMonth; bind(s);
  }
  function renderAll() { try { renderTop(); } catch (_) {} try { renderInvoiceBar(); } catch (_) {} try { renderStatus(); } catch (_) {} }

  (function injectStyle() {
    if (byId("amk-fin-month-style")) return;
    const st = document.createElement("style"); st.id = "amk-fin-month-style";
    st.textContent = `
      .amk-fin-monthsel{min-height:38px;padding:6px 14px;border-radius:12px;font-size:.92rem;font-weight:700;
        background:rgba(200,170,110,.10);color:inherit;border:1px solid rgba(200,170,110,.4);cursor:pointer;letter-spacing:.01em}
      .amk-fin-monthsel:focus{outline:none;border-color:rgba(200,170,110,.75);box-shadow:0 0 0 3px rgba(200,170,110,.14)}
      .amk-inv-monthbar{display:flex;align-items:center;gap:10px;margin:0 0 14px;flex-wrap:wrap}
      .amk-inv-monthbar-lbl{font-size:.82rem;letter-spacing:.02em;opacity:.75;font-weight:600}
      .amkz-finance-period{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
    `;
    document.head.appendChild(st);
  })();

  const prev = AMKZ.loadView;
  AMKZ.loadView = async function finMonthChain(view, options) {
    const r = await prev?.call(this, view, options);
    if (view === "finance") setTimeout(renderAll, 580);
    return r;
  };
  document.addEventListener("click", (e) => { if (e.target.closest(".amkz-finance-tab")) setTimeout(renderAll, 360); });
  setTimeout(renderAll, 1600);
})();

/* =====================================================================
   AMK ZENTRALE — TEAM 2.0: Login (Registrieren + Passwort vergessen),
   Mitarbeiter-Profile (Karten + Popup: Email/Passwort/Gehalt/Zahlung/Bild/Rechte),
   Gehalt/Lohn als Ausgabe (gekoppelt an Mitarbeiter). Styles inklusive.
   ===================================================================== */
(function () {
  "use strict";
  if (document.getElementById("amk-team2-style")) return;
  const s = document.createElement("style"); s.id = "amk-team2-style";
  s.textContent = `
    .amkz-auth-extras{display:flex;align-items:center;justify-content:center;gap:12px;margin-top:16px}
    .amkz-auth-link{background:none;border:none;color:#c8aa6e;font-weight:700;font-size:.9rem;cursor:pointer;padding:4px 6px;letter-spacing:.01em}
    .amkz-auth-link:hover{color:#f0d488;text-decoration:underline}
    .amkz-auth-sep{opacity:.4}
    .amkz-pending-screen{display:flex;align-items:center;justify-content:center;min-height:70vh;padding:24px}
    .amkz-pending-card{max-width:520px;text-align:center;background:linear-gradient(180deg,rgba(20,20,26,.96),rgba(9,9,12,.98));border:1px solid rgba(200,170,110,.3);border-radius:22px;padding:38px 34px;box-shadow:0 24px 60px rgba(0,0,0,.5)}
    .amkz-pending-ic{font-size:46px;margin-bottom:8px}
    .amkz-pending-card h2{color:#f0d488;margin:0 0 10px;font-size:1.4rem}
    .amkz-pending-card p{opacity:.85;line-height:1.6;margin:0 0 10px}
    .amkz-pending-card small{opacity:.5}
    /* Profil-Karten */
    .amkz-tp-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:14px;margin-top:8px}
    .amkz-tp-card{display:flex;align-items:center;gap:14px;padding:15px 16px;border-radius:18px;cursor:pointer;text-align:left;
      background:linear-gradient(165deg,rgba(255,255,255,.04),rgba(255,255,255,.015));border:1px solid rgba(255,255,255,.09);transition:transform .15s,border-color .2s,box-shadow .2s;position:relative}
    .amkz-tp-card:hover{transform:translateY(-2px);border-color:rgba(200,170,110,.45);box-shadow:0 14px 34px rgba(0,0,0,.4)}
    .amkz-tp-ava{width:52px;height:52px;border-radius:50%;flex:0 0 52px;display:flex;align-items:center;justify-content:center;font-weight:900;font-size:1.15rem;color:#0b0b0d;background:linear-gradient(135deg,#f7df97,#c8902b);background-size:cover;background-position:center}
    .amkz-tp-ava.lg{width:84px;height:84px;flex:0 0 84px;font-size:1.9rem}
    .amkz-tp-ava.amkz-has-photo{color:transparent}
    .amkz-tp-info{min-width:0;flex:1}
    .amkz-tp-info strong{display:block;font-size:1.02rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
    .amkz-tp-info small{display:block;opacity:.6;font-size:.8rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
    .amkz-tp-role{display:inline-block;margin-top:4px;font-size:.7rem;text-transform:uppercase;letter-spacing:.08em;color:#c8aa6e;font-weight:800}
    .amkz-tp-badge{position:absolute;top:10px;right:12px;font-size:.66rem;font-weight:800;padding:3px 9px;border-radius:999px;text-transform:uppercase;letter-spacing:.05em}
    .amkz-tp-badge.on{background:rgba(52,211,153,.16);color:#34d399}
    .amkz-tp-badge.off{background:rgba(255,255,255,.08);color:#999}
    .amkz-tp-badge.pend{background:rgba(230,184,92,.18);color:#f0d488}
    /* Profil-Popup */
    .amkz-tp-modal{max-width:560px}
    .amkz-tp-head{display:flex;align-items:center;gap:16px;margin-bottom:6px}
    .amkz-tp-avaedit{position:relative;cursor:pointer;flex:0 0 auto}
    .amkz-tp-avahint{position:absolute;left:0;right:0;bottom:-6px;text-align:center;font-size:.62rem;color:#c8aa6e;font-weight:800}
    .amkz-tp-headmeta{flex:1;display:flex;flex-direction:column;gap:8px}
    .amkz-tp-nameinput{font-size:1.1rem;font-weight:800}
    .amkz-tp-pass{display:flex;gap:6px}
    .amkz-tp-pass input{flex:1}
    .amkz-tp-eye{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.14);border-radius:10px;cursor:pointer;padding:0 12px;color:inherit}
    .amkz-tp-rights{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:6px}
    .amkz-tp-right{display:flex;align-items:center;gap:7px;padding:7px 10px;border-radius:10px;background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);cursor:pointer;font-size:.82rem}
    .amkz-tp-right.on{border-color:rgba(200,170,110,.5);background:rgba(200,170,110,.1);color:#f0d488}
    .amkz-tp-actions{display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin-top:6px}
    .amkz-tp-toggle{display:flex;align-items:center;gap:6px;font-size:.85rem;font-weight:700}
    .amkz-tp-spacer{flex:1}
    /* Profilbild gewinnt gegen jeden Theme-Gold-Gradient: via CSS-Variable + !important, rund, randlos */
    .amkz-user-avatar.amkz-has-photo,.amkz-chat-avatar.amkz-has-photo,.amkz-tp-ava.amkz-has-photo,
    .amkz-chat-active-avatar.amkz-has-photo,#amkzChatActiveAvatar.amkz-has-photo{
      background-color:transparent !important;background-size:cover !important;background-position:center !important;
      background-repeat:no-repeat !important;border-radius:50% !important;overflow:hidden;color:transparent !important;font-size:0 !important}
    /* alte Rechte-Tabelle im Team-Bereich ausblenden (Rechte sind jetzt im Profil-Popup) */
    #amkzTeamView table,#amkzTeamView .amkz-table-wrap{display:none !important}
    #amkzTeamView .amkz-team-row-final{display:none !important}
  `;
  document.head.appendChild(s);
})();

/* ---------- Login-Extras: Registrieren + Passwort vergessen ---------- */
(function () {
  "use strict";
  const AMKZ = window.AMKZ; if (!AMKZ || AMKZ.__authExtras) return; AMKZ.__authExtras = true;
  const byId = (id) => document.getElementById(id);
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const sb = () => AMKZ.supabase;

  async function findMateo() { try { const { data } = await sb().from("team_members").select("id,name").or("email.eq.mateo@amk.com,name.ilike.mateo").limit(1).maybeSingle(); return data; } catch (_) { return null; } }
  async function notifyFrom(fromId, targetId, title, message) {
    if (!targetId) return;
    try { if (fromId) { const { data: conv } = await sb().rpc("amk_get_or_create_conversation", { p_user_a: fromId, p_user_b: targetId }); const cid = conv?.id || (Array.isArray(conv) ? conv[0]?.id : null); if (cid) await sb().rpc("amk_send_message", { p_conversation_id: cid, p_sender_id: fromId, p_receiver_id: targetId, p_message: message, p_client_temp_id: `auth_${Date.now()}_${Math.random().toString(36).slice(2)}` }); } } catch (_) {}
    try { await sb().from("notifications").insert({ target_user_id: targetId, created_for: targetId, type: "team", title, message, is_read: false, created_at: new Date().toISOString(), payload: { from: fromId || null, push: "false" } }); } catch (_) {}
    try { window.AMK_SEND_PUSH?.(targetId, title, message, {}); } catch (_) {}
  }
  function injectLinks() {
    const form = byId("amkzLoginForm"); if (!form || byId("amkzAuthExtras")) return;
    const box = document.createElement("div"); box.id = "amkzAuthExtras"; box.className = "amkz-auth-extras";
    box.innerHTML = `<button type="button" class="amkz-auth-link" data-auth="register">Registrieren</button><span class="amkz-auth-sep">·</span><button type="button" class="amkz-auth-link" data-auth="forgot">Passwort vergessen?</button>`;
    form.insertAdjacentElement("afterend", box);
  }
  function openRegister() {
    AMKZ.modal.open(`<div class="amkz-modal"><div class="amkz-modal-header"><div><h3>Registrieren</h3><p>Konto anlegen — ein Admin gibt dich anschließend frei.</p></div><button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
      <form id="amkRegForm" class="amkz-form-grid">
        <div class="amkz-input-group"><label>Name</label><input id="regName" required></div>
        <div class="amkz-input-group"><label>E-Mail</label><input id="regEmail" type="email" required></div>
        <div class="amkz-input-group"><label>Passwort</label><input id="regPass" type="password" required></div>
        <div class="amkz-modal-actions"><button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button><button class="amkz-primary-btn" type="submit">Konto anlegen</button></div>
      </form></div>`);
    byId("amkRegForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const name = byId("regName").value.trim(), email = byId("regEmail").value.trim().toLowerCase(), pass = byId("regPass").value.trim();
      if (!name || !email || !pass) return;
      const btn = e.submitter; if (btn) btn.disabled = true;
      try {
        // Über den Server: immer unfreigegeben und ohne Rechte, egal was jemand schickt
        const ins = (await AMKZ.teamApi("registrieren", { name, email, passwort: pass })).mitglied;
        const mateo = await findMateo();
        if (mateo) await notifyFrom(ins?.id, mateo.id, "🆕 Neue Registrierung", `${name} (${email}) hat sich registriert und wartet auf Freigabe im Team-Bereich.`);
        AMKZ.modal.close();
        toast("Registriert", "Konto angelegt. Du kannst dich einloggen — dein Portal wird nach der Freigabe aktiv.");
      } catch (err) { toast("Fehler", err.message || "Registrierung fehlgeschlagen", "error"); if (btn) btn.disabled = false; }
    });
  }
  function openForgot() {
    AMKZ.modal.open(`<div class="amkz-modal"><div class="amkz-modal-header"><div><h3>Passwort vergessen</h3><p>Name + E-Mail eingeben — Mateo wird sofort benachrichtigt.</p></div><button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
      <form id="amkForgotForm" class="amkz-form-grid">
        <div class="amkz-input-group"><label>Name</label><input id="fgName" required></div>
        <div class="amkz-input-group"><label>E-Mail</label><input id="fgEmail" type="email" required></div>
        <div class="amkz-modal-actions"><button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button><button class="amkz-primary-btn" type="submit">Mateo benachrichtigen</button></div>
      </form></div>`);
    byId("amkForgotForm").addEventListener("submit", async (e) => {
      e.preventDefault();
      const name = byId("fgName").value.trim(), email = byId("fgEmail").value.trim().toLowerCase();
      if (!name || !email) return;
      const btn = e.submitter; if (btn) btn.disabled = true;
      try {
        let fromId = null; try { const { data } = await sb().from("team_members").select("id").eq("email", email).limit(1).maybeSingle(); fromId = data?.id || null; } catch (_) {}
        const mateo = await findMateo();
        if (mateo) await notifyFrom(fromId, mateo.id, "🔑 Passwort vergessen", `${name} (${email}) hat das Passwort vergessen und braucht ein neues.`);
        AMKZ.modal.close();
        toast("Gesendet", mateo ? "Mateo wurde benachrichtigt." : "Konnte Mateo nicht finden — bitte Admin kontaktieren.");
      } catch (err) { toast("Fehler", err.message || "Konnte nicht senden", "error"); if (btn) btn.disabled = false; }
    });
  }
  document.addEventListener("click", (e) => { const b = e.target.closest("[data-auth]"); if (!b) return; e.preventDefault(); if (b.dataset.auth === "register") openRegister(); else openForgot(); });
  injectLinks(); setTimeout(injectLinks, 700); setTimeout(injectLinks, 1800);
})();

/* ---------- Team = Mitarbeiter-Profile (Karten + Popup) ---------- */
(function () {
  "use strict";
  const AMKZ = window.AMKZ; if (!AMKZ || AMKZ.__teamProfiles) return; AMKZ.__teamProfiles = true;
  const byId = (id) => document.getElementById(id);
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m])));
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const sb = () => AMKZ.supabase;
  const RIGHTS = [["can_view_dashboard", "Dashboard"], ["can_view_entries", "Einträge"], ["can_view_connect", "Connect"], ["can_view_calendar", "Kalender"], ["can_view_streaming", "Streaming"], ["can_manage_streaming", "Streaming-Verwaltung"], ["can_view_casinos", "Casinos (Partner & Casinos)"], ["can_view_webseiten", "Webseiten"], ["can_view_partners", "Partner"], ["can_view_affiliates", "Affiliate-Dashboards"], ["can_view_giveaway", "Giveaway"], ["can_view_postfach", "Support-Postfach (E-Mail)"], ["can_view_support", "Anfragen"], ["can_support_cz", "Anfragen 🇨🇿 CZ"], ["can_support_de", "Anfragen 🇩🇪 DE"], ["can_view_finance", "Finanzen"], ["can_view_profit", "Gewinn sehen"], ["can_manage_team", "Team verwalten"]];
  const ROLES = ["employee", "ftd", "finance", "manager", "admin"];
  const initial = (u) => String(u.name || u.email || "?").charAt(0).toUpperCase();
  // Avatar-URL: Map (aus __avatarSync, hat avatar_url) ZUERST, sonst was am Datensatz hängt
  const avatarOf = (u) => (u && ((AMKZ.state.avatarById || {})[u.id] || u.avatar_url)) || "";
  const DEFAULT_TRUE = ["can_view_dashboard", "can_view_entries", "can_view_connect", "can_view_calendar", "can_view_streaming"];
  const rightOn = (u, f) => (DEFAULT_TRUE.includes(f) ? u[f] !== false : u[f] === true);
  // Blaues Verifizierungs-Badge (Twitter/Instagram-Stil) — sichtbar wenn is_verified
  const VERIFY = '<svg class="amkz-verify-ic" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" style="vertical-align:-3px"><path fill="#1d9bf0" d="M12 1.6l2.28 1.66 2.82-.06.97 2.66 2.66.97-.06 2.82L22.4 12l-1.73 2.28.06 2.82-2.66.97-.97 2.66-2.82-.06L12 22.4l-2.28-1.73-2.82.06-.97-2.66-2.66-.97.06-2.82L1.6 12l1.73-2.28-.06-2.82 2.66-.97.97-2.66 2.82.06z"/><path fill="#fff" d="m10.55 14.6-2.2-2.2-1.2 1.2 3.4 3.4 6-6-1.2-1.2z"/></svg>';
  const isVerified = (u) => {
    if (!u) return false;
    if (u.is_verified === true) return true;
    if (String(u.name || "").trim().toLowerCase() === "mateo") return true;
    if (AMKZ.state.verifiedIds && AMKZ.state.verifiedIds.has && AMKZ.state.verifiedIds.has(u.id)) return true;
    // Fallback: per ID im Team nachschlagen (Chat-User haben evtl. kein is_verified)
    const t = (AMKZ.state.team || []).find((x) => x.id === u.id);
    return !!(t && (t.is_verified === true || String(t.name || "").trim().toLowerCase() === "mateo"));
  };
  AMKZ.isVerified = isVerified; AMKZ.verifyBadge = VERIFY;
  // Verifizierte IDs global laden (funktioniert überall: Connect, Sidebar, Team) — robust falls Spalte fehlt
  AMKZ.loadVerified = async function loadVerified() {
    try {
      let res = await sb().from("team_members").select("id,name,is_verified");
      if (res.error) res = await sb().from("team_members").select("id,name");
      const rows = res.data || [];
      AMKZ.state.verifiedIds = new Set(rows.filter((t) => t.is_verified === true || String(t.name || "").trim().toLowerCase() === "mateo").map((t) => t.id));
    } catch (_) { AMKZ.state.verifiedIds = AMKZ.state.verifiedIds || new Set(); }
    return AMKZ.state.verifiedIds;
  };
  function ensureVerifyStyle() {
    if (document.getElementById("amk-verify-style")) return;
    const st = document.createElement("style"); st.id = "amk-verify-style";
    st.textContent = `
      .amkz-tp-info strong{display:inline-flex;align-items:center;gap:2px}
      .amkz-verify-ic{width:16px;height:16px;display:inline-block;flex:none;filter:drop-shadow(0 1px 2px rgba(29,155,240,.4))}
      .amkz-hr-badges .amkz-verify-badge{display:inline-flex;align-items:center;gap:5px;font-size:.72rem;font-weight:800;color:#1d9bf0;background:rgba(29,155,240,.12);border:1px solid rgba(29,155,240,.42);border-radius:999px;padding:3px 11px;margin-left:8px}
      .amkz-hr-badges .amkz-verify-badge .amkz-verify-ic{width:15px;height:15px}
      .amkz-tp-verifytoggle{color:#1d9bf0}
      .amkz-tp-verifytoggle .amkz-verify-ic{width:16px;height:16px;vertical-align:-3px;margin:0 1px}
      /* Badge inline direkt hinter dem Namen (Chatliste + Header) */
      .amkz-chat-user strong,#amkzChatActiveName{display:inline-flex;align-items:center;gap:4px}
      .amkz-chat-user strong .amkz-verify-ic,#amkzChatActiveName .amkz-verify-ic{width:16px;height:16px}
      /* Verify-Badge unten rechts AM Avatar der Sidebar-Karte (wie Instagram-Kamera-Position) */
      .amkz-user-avatar{position:relative !important;overflow:visible !important}
      .amkz-user-verify{position:absolute;bottom:-3px;right:-3px;width:21px;height:21px;border-radius:50%;background:#0b0b0d;display:grid;place-items:center;box-shadow:0 1px 4px rgba(0,0,0,.6);z-index:6;pointer-events:none}
      .amkz-user-verify .amkz-verify-ic{width:21px;height:21px}
    `;
    document.head.appendChild(st);
  }
  AMKZ.ensureVerifyStyle = ensureVerifyStyle;
  try { ensureVerifyStyle(); } catch (_) {}

  function cardHtml(u) {
    const aurl = avatarOf(u);
    const ava = aurl ? `<div class="amkz-tp-ava amkz-has-photo" style="background-image:url('${esc(aurl)}') !important"></div>` : `<div class="amkz-tp-ava">${esc(initial(u))}</div>`;
    const badge = u.is_approved === false ? `<span class="amkz-tp-badge pend">wartet auf Freigabe</span>` : (u.is_active === false ? `<span class="amkz-tp-badge off">inaktiv</span>` : `<span class="amkz-tp-badge on">aktiv</span>`);
    return `<button type="button" class="amkz-tp-card" data-tp="${esc(u.id)}">${ava}<div class="amkz-tp-info"><strong>${esc(u.name || "—")}${isVerified(u) ? VERIFY : ""}</strong><small>${esc(u.email || "")}</small><span class="amkz-tp-role" title="Rolle: ${esc(u.role || "employee")}">${esc(({ employee: "Mitarbeiter", ftd: "FTD-Mitarbeiter", finance: "Finanzen", manager: "Manager", admin: "Admin" })[String(u.role || "employee").toLowerCase()] || u.role)}</span></div>${badge}</button>`;
  }
  function render() {
    const view = byId("amkzTeamView"); if (!view) return;
    ensureVerifyStyle();
    const card = view.querySelector(".amkz-card") || view;
    const wrap = view.querySelector(".amkz-table-wrap");
    let grid = byId("amkzTpGrid");
    if (!grid) {
      grid = document.createElement("div"); grid.id = "amkzTpGrid"; grid.className = "amkz-tp-grid";
      // Karten NEBEN (nicht IN) die ausgeblendete Tabelle setzen, sonst werden sie mitversteckt
      if (wrap && wrap.parentElement) wrap.parentElement.insertBefore(grid, wrap);
      else { const hdr = card.querySelector(".amkz-card-header"); if (hdr) hdr.insertAdjacentElement("afterend", grid); else card.appendChild(grid); }
    }
    const team = AMKZ.state.team || [];
    grid.innerHTML = team.length ? team.map(cardHtml).join("") : `<div class="amkz-empty">Noch keine Mitarbeiter.</div>`;
  }
  async function reload() {
    try {
      const { data } = await sb().from("team_members").select(await AMKZ.spalten("team_members")).order("name", { ascending: true });
      if (Array.isArray(data)) {
        await AMKZ.mitGeheim(data, "amk_team_privat");   // Gehalt/Zahlungsdaten nur mit Recht
        /* Das Passwortfeld wird sofort verworfen. Die Oberfläche braucht es
           nicht mehr (siehe Profil-Formular), und was nicht im Arbeitsspeicher
           liegt, kann auch nicht versehentlich irgendwo landen — nicht im
           Formular, nicht in einer Fehlermeldung, nicht im Sitzungsspeicher. */
        AMKZ.state.team = data.map((m) => { const k = Object.assign({}, m); delete k.password; return k; });
      }
    } catch (_) {}
    render();
  }

  function ensureHrStyle() {
    if (document.getElementById("amk-hr-style")) return;
    const st = document.createElement("style"); st.id = "amk-hr-style";
    st.textContent = `
      .amkz-hr-modal{max-width:820px;width:96vw}
      .amkz-hr-top{display:flex;gap:18px;align-items:center;flex-wrap:wrap;padding:4px 2px 14px;border-bottom:1px solid rgba(255,255,255,.08);margin-bottom:14px}
      .amkz-hr-idcol{flex:1;min-width:220px;display:flex;flex-direction:column;gap:8px}
      .amkz-hr-idcol .amkz-tp-nameinput{font-size:1.25rem;font-weight:800}
      .amkz-hr-badges{display:flex;gap:8px;flex-wrap:wrap}
      .amkz-hr-rings{display:flex;gap:16px}
      .amkz-hr-ring{display:flex;flex-direction:column;align-items:center;gap:4px}
      .amkz-hr-ring small{font-size:.72rem;opacity:.6;text-transform:uppercase;letter-spacing:.06em;font-weight:800}
      .amkz-hr-donut{width:104px;height:104px}
      .amkz-hr-donut-top{fill:rgba(255,255,255,.55);font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.5px}
      .amkz-hr-donut-big{fill:#f2f1ee;font-size:16px;font-weight:900}
      .amkz-hr-tabs{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px}
      .amkz-hr-tab{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.09);color:inherit;border-radius:12px;padding:8px 16px;font-weight:700;cursor:pointer;font-size:.9rem}
      .amkz-hr-tab.active{background:rgba(200,170,110,.14);border-color:rgba(200,170,110,.5);color:#f0d488}
      .amkz-hr-panel.is-hidden{display:none}
      .amkz-hr-task{display:flex;align-items:center;gap:10px;padding:9px 12px;border-radius:11px;background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);margin-bottom:6px}
      .amkz-hr-task.done{opacity:.5}.amkz-hr-task.done .amkz-hr-task-t{text-decoration:line-through}
      .amkz-hr-task-t{flex:1;font-weight:600}
      .amkz-hr-task-due{font-size:.72rem;opacity:.6}
      .amkz-hr-taskadd{display:flex;gap:8px;margin-top:8px;flex-wrap:wrap}
      .amkz-hr-taskadd input[type=text]{flex:1;min-width:160px}
      .amkz-hr-doc{display:flex;align-items:center;gap:10px;padding:9px 12px;border-radius:11px;background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);margin-bottom:6px}
      .amkz-hr-doc a{flex:1;color:#e9c76a;font-weight:600;text-decoration:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .amkz-hr-docup{display:inline-flex;align-items:center;gap:8px;cursor:pointer;background:rgba(200,170,110,.12);border:1px solid rgba(200,170,110,.4);border-radius:12px;padding:9px 16px;font-weight:700;color:#f0d488;margin-top:8px}
    `;
    document.head.appendChild(st);
  }
  function hrDonut(pct, top, big, color) {
    pct = Math.max(0, Math.min(100, pct || 0)); const C = 2 * Math.PI * 44, off = C * (1 - pct / 100);
    return `<svg viewBox="0 0 120 120" class="amkz-hr-donut"><circle cx="60" cy="60" r="44" fill="none" stroke="rgba(255,255,255,.09)" stroke-width="11"/><circle cx="60" cy="60" r="44" fill="none" stroke="${color}" stroke-width="11" stroke-linecap="round" stroke-dasharray="${C.toFixed(1)}" stroke-dashoffset="${off.toFixed(1)}" transform="rotate(-90 60 60)"/><text x="60" y="55" text-anchor="middle" class="amkz-hr-donut-top">${top}</text><text x="60" y="74" text-anchor="middle" class="amkz-hr-donut-big">${big}</text></svg>`;
  }
  const money0 = (v) => new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 }).format(Number(v) || 0) + " €";

  function openProfile(id) {
    const u = (AMKZ.state.team || []).find((x) => String(x.id) === String(id)); if (!u) return;
    ensureHrStyle(); ensureVerifyStyle();
    const aurl = avatarOf(u);
    const avaStyle = aurl ? `background-image:url('${esc(aurl)}') !important` : "";
    const inp = (id2, label, val, type) => `<div class="amkz-input-group"><label>${label}</label><input id="${id2}" type="${type || "text"}" value="${esc(val ?? "")}"></div>`;
    AMKZ.modal.open(`<div class="amkz-modal amkz-hr-modal"><div class="amkz-modal-header"><div><h3>Mitarbeiter-Profil</h3><p>Alles über den Mitarbeiter — Daten · Gehalt · Urlaub · Aufgaben · Dokumente</p></div><button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
      <form id="amkTpForm">
        <div class="amkz-hr-top">
          <label class="amkz-tp-avaedit"><div class="amkz-tp-ava lg ${aurl ? "amkz-has-photo" : ""}" id="tpAvaPrev" style="${avaStyle}">${aurl ? "" : esc(initial(u))}</div><input id="tpAvaFile" type="file" accept="image/*" hidden><span class="amkz-tp-avahint">📷 ändern</span></label>
          <div class="amkz-hr-idcol">
            <input id="tpName" class="amkz-tp-nameinput" value="${esc(u.name || "")}" placeholder="Name">
            <div class="amkz-form-row"><select id="tpRole">${ROLES.map((r) => `<option value="${r}" ${String(u.role || "employee") === r ? "selected" : ""}>${r}</option>`).join("")}</select><input id="tpPosition" value="${esc(u.position || "")}" placeholder="Position"></div>
            <div class="amkz-hr-badges"><span class="amkz-tp-badge ${u.is_approved === false ? "pend" : (u.is_active === false ? "off" : "on")}">${u.is_approved === false ? "wartet auf Freigabe" : (u.is_active === false ? "inaktiv" : "aktiv")}</span>${isVerified(u) ? `<span class="amkz-verify-badge">${VERIFY} Verifiziert</span>` : ""}</div>
          </div>
          <div class="amkz-hr-rings">
            <div class="amkz-hr-ring"><div id="hrSalDonut">${hrDonut(0, "dieses Jahr", "…", "#e9c76a")}</div><small>Lohn Ist</small></div>
            <div class="amkz-hr-ring"><div id="hrVacDonut">${hrDonut(0, "Rest", "…", "#34d399")}</div><small>Urlaub</small></div>
          </div>
        </div>
        <div class="amkz-hr-tabs">
          <button type="button" class="amkz-hr-tab active" data-hrtab="daten">Daten</button>
          <button type="button" class="amkz-hr-tab" data-hrtab="aufgaben">Aufgaben</button>
          <button type="button" class="amkz-hr-tab" data-hrtab="dokumente">Dokumente</button>
          <button type="button" class="amkz-hr-tab" data-hrtab="zugang">Zugang & Rechte</button>
        </div>
        <div class="amkz-hr-panel" data-panel="daten">
          <div class="amkz-form-row">${inp("tpPhone", "Telefon", u.phone)}${inp("tpDept", "Fachbereich / Abteilung", u.department)}</div>
          <div class="amkz-input-group"><label>Adresse</label><textarea id="tpAddress" rows="2">${esc(u.address || "")}</textarea></div>
          <div class="amkz-form-row">${inp("tpBirthday", "Geburtstag", (u.birthday || "").slice(0, 10), "date")}${inp("tpStart", "Eintrittsdatum", (u.start_date || "").slice(0, 10), "date")}</div>
          <div class="amkz-form-row">${inp("tpGehalt", "Gehalt (€)", Number(u.gehalt || 0), "number")}${inp("tpGehaltNote", "Intervall / Notiz", u.gehalt_note || "monatlich")}</div>
          <div class="amkz-form-row">${inp("tpVac", "Urlaubsanspruch (Tage/Jahr)", Number(u.vacation_days_year || 30), "number")}<div class="amkz-input-group"><label>Zahlungsdaten (IBAN / PayPal / Wallet)</label><textarea id="tpPay" rows="1">${esc(u.payment_info || "")}</textarea></div></div>
        </div>
        <div class="amkz-hr-panel is-hidden" data-panel="aufgaben">
          <div id="hrTasks"><div class="amkz-empty">Lädt …</div></div>
          <div class="amkz-hr-taskadd"><input type="text" id="hrTaskTitle" placeholder="Neue Aufgabe…"><input type="date" id="hrTaskDue"><button type="button" class="amkz-secondary-btn" id="hrTaskAdd">+ Aufgabe</button></div>
        </div>
        <div class="amkz-hr-panel is-hidden" data-panel="dokumente">
          <div id="hrDocs"><div class="amkz-empty">Lädt …</div></div>
          <label class="amkz-hr-docup">📎 Dokument hochladen<input id="hrDocFile" type="file" hidden></label>
        </div>
        <div class="amkz-hr-panel is-hidden" data-panel="zugang">
          <div class="amkz-form-row">
            <div class="amkz-input-group"><label>E-Mail</label><input id="tpEmail" type="email" value="${esc(u.email || "")}"></div>
            <div class="amkz-input-group"><label>Passwort</label><div class="amkz-tp-pass"><input id="tpPass" type="password" value="" autocomplete="new-password" placeholder="leer lassen = unverändert"><button type="button" class="amkz-tp-eye" data-tp-eye>👁</button></div>
              <small>Nur ausfüllen, wenn du ein neues Passwort vergeben willst. Das bestehende wird nicht angezeigt.</small></div>
          </div>
          <div class="amkz-input-group"><label>Rechte</label><div class="amkz-tp-rights">${RIGHTS.map(([f, l]) => `<label class="amkz-tp-right ${rightOn(u, f) ? "on" : ""}"><input type="checkbox" data-right="${f}" ${rightOn(u, f) ? "checked" : ""}><span>${l}</span></label>`).join("")}</div></div>
          <div class="amkz-tp-actions">
            <label class="amkz-tp-toggle"><input type="checkbox" id="tpActive" ${u.is_active !== false ? "checked" : ""}> Aktiv</label>
            <label class="amkz-tp-toggle"><input type="checkbox" id="tpApproved" ${u.is_approved !== false ? "checked" : ""}> Freigegeben</label>
            <label class="amkz-tp-toggle amkz-tp-verifytoggle"><input type="checkbox" id="tpVerified" ${isVerified(u) ? "checked" : ""}> ${VERIFY} Verifizieren</label>
          </div>
        </div>
        <div class="amkz-tp-actions">
          <button type="button" class="amkz-crud-del" data-tp-del="${esc(u.id)}">🗑 Entfernen</button>
          <div class="amkz-tp-spacer"></div>
          <button class="amkz-primary-btn" type="submit">Speichern</button>
        </div>
      </form></div>`);
    const form = byId("amkTpForm");
    // Tabs
    form.querySelectorAll("[data-hrtab]").forEach((b) => b.addEventListener("click", () => {
      form.querySelectorAll("[data-hrtab]").forEach((x) => x.classList.toggle("active", x === b));
      form.querySelectorAll("[data-panel]").forEach((p) => p.classList.toggle("is-hidden", p.dataset.panel !== b.dataset.hrtab));
    }));
    form.querySelector("[data-tp-eye]")?.addEventListener("click", () => { const p = byId("tpPass"); p.type = p.type === "password" ? "text" : "password"; });
    form.querySelectorAll(".amkz-tp-right input").forEach((cb) => cb.addEventListener("change", () => cb.closest(".amkz-tp-right").classList.toggle("on", cb.checked)));
    let newAvatar = null;
    byId("tpAvaFile")?.addEventListener("change", async (e) => {
      const file = e.target.files && e.target.files[0]; if (!file) return;
      toast("Upload", "Profilbild wird hochgeladen…");
      try {
        const ext = (file.name.split(".").pop() || "jpg").replace(/[^\w]/g, "") || "jpg";
        const path = `avatars/${u.id}_${Date.now()}.${ext}`;
        const { error } = await sb().storage.from("amk-chat-files").upload(path, file, { upsert: true }); if (error) throw error;
        const { data } = sb().storage.from("amk-chat-files").getPublicUrl(path);
        newAvatar = data?.publicUrl || null;
        const prev = byId("tpAvaPrev"); if (prev && newAvatar) { prev.style.setProperty("background-image", `url('${newAvatar}')`, "important"); prev.classList.add("amkz-has-photo"); prev.textContent = ""; }
        toast("Fertig", "Bild gesetzt — Speichern nicht vergessen.");
      } catch (err) { toast("Fehler", err.message || "Upload fehlgeschlagen", "error"); }
    });
    // Ringe füllen (Lohn Ist dieses Jahr + Urlaub)
    (async () => {
      const yr = new Date().getFullYear();
      try {
        const { data: sal } = await sb().from("entries").select("amount,entry_date").eq("entry_type", "OPERATING_EXPENSE").eq("metadata->>employee_id", String(u.id)).gte("entry_date", yr + "-01-01").lt("entry_date", (yr + 1) + "-01-01");
        const total = (sal || []).reduce((a, r) => a + Number(r.amount || 0), 0);
        const months = new Set((sal || []).map((r) => String(r.entry_date).slice(5, 7))).size;
        const d = byId("hrSalDonut"); if (d) d.innerHTML = hrDonut(months / 12 * 100, "dieses Jahr", money0(total), "#e9c76a");
      } catch (_) { const d = byId("hrSalDonut"); if (d) d.innerHTML = hrDonut(0, "dieses Jahr", money0(0), "#e9c76a"); }
      try {
        const { data: vac } = await sb().from("planning_calendar").select("starts_at,ends_at,created_by,assigned_to,event_type").eq("event_type", "urlaub").gte("starts_at", yr + "-01-01");
        let taken = 0; (vac || []).filter((e) => e.created_by === u.id || e.assigned_to === u.id).forEach((e) => { if (e.starts_at && e.ends_at) { const dd = Math.round((new Date(e.ends_at) - new Date(e.starts_at)) / 86400000) + 1; if (dd > 0) taken += dd; } });
        const anspruch = Number(u.vacation_days_year || 30); const rest = Math.max(0, anspruch - taken);
        const d = byId("hrVacDonut"); if (d) d.innerHTML = hrDonut(anspruch ? taken / anspruch * 100 : 0, "Rest", rest + " T", "#34d399");
      } catch (_) {}
    })();
    // Aufgaben
    async function renderTasks() {
      const box = byId("hrTasks"); if (!box) return;
      let rows = []; try { const { data } = await sb().from("employee_tasks").select("*").eq("employee_id", u.id).order("created_at", { ascending: false }); rows = data || []; } catch (_) {}
      box.innerHTML = rows.length ? rows.map((t) => `<div class="amkz-hr-task ${t.done ? "done" : ""}"><input type="checkbox" data-task-done="${esc(t.id)}" ${t.done ? "checked" : ""}><span class="amkz-hr-task-t">${esc(t.title)}</span>${t.due ? `<span class="amkz-hr-task-due">bis ${esc(String(t.due).slice(0, 10))}</span>` : ""}<button type="button" class="amkz-crud-del" data-task-del="${esc(t.id)}">🗑</button></div>`).join("") : `<div class="amkz-empty">Keine Aufgaben.</div>`;
      box.querySelectorAll("[data-task-done]").forEach((cb) => cb.addEventListener("change", async () => { try { await sb().from("employee_tasks").update({ done: cb.checked }).eq("id", cb.dataset.taskDone); } catch (_) {} renderTasks(); }));
      box.querySelectorAll("[data-task-del]").forEach((b) => b.addEventListener("click", async () => { if (!window.confirm("Diese Aufgabe wirklich löschen?")) return; try { await sb().from("employee_tasks").delete().eq("id", b.dataset.taskDel); } catch (_) {} renderTasks(); }));
    }
    renderTasks();
    byId("hrTaskAdd")?.addEventListener("click", async () => {
      const title = byId("hrTaskTitle").value.trim(); if (!title) return;
      const due = byId("hrTaskDue").value || null;
      try { await sb().from("employee_tasks").insert({ employee_id: u.id, title, due, created_by: AMKZ.state.member?.id || null }); byId("hrTaskTitle").value = ""; byId("hrTaskDue").value = ""; renderTasks(); toast("Aufgabe", "Hinzugefügt."); } catch (err) { toast("Fehler", err.message || "Aufgabe fehlgeschlagen (SQL ausgeführt?)", "error"); }
    });
    // Dokumente
    let docs = Array.isArray(u.documents) ? u.documents.slice() : [];
    function renderDocs() {
      const box = byId("hrDocs"); if (!box) return;
      box.innerHTML = docs.length ? docs.map((d, i) => `<div class="amkz-hr-doc"><a href="${esc(d.url)}" target="_blank" rel="noopener">📄 ${esc(d.name || "Dokument")}</a><button type="button" class="amkz-crud-del" data-doc-del="${i}">🗑</button></div>`).join("") : `<div class="amkz-empty">Keine Dokumente.</div>`;
      box.querySelectorAll("[data-doc-del]").forEach((b) => b.addEventListener("click", async () => { docs.splice(Number(b.dataset.docDel), 1); try { await sb().from("team_members").update({ documents: docs }).eq("id", u.id); } catch (_) {} renderDocs(); }));
    }
    renderDocs();
    byId("hrDocFile")?.addEventListener("change", async (e) => {
      const file = e.target.files && e.target.files[0]; if (!file) return;
      toast("Upload", "Dokument wird hochgeladen…");
      try {
        const safe = file.name.replace(/[^\w.\-]/g, "_");
        const path = `docs/${u.id}/${Date.now()}_${safe}`;
        const { error } = await sb().storage.from("amk-chat-files").upload(path, file, { upsert: true }); if (error) throw error;
        const { data } = sb().storage.from("amk-chat-files").getPublicUrl(path);
        docs.push({ name: file.name, url: data?.publicUrl || "", uploaded_at: new Date().toISOString() });
        await sb().from("team_members").update({ documents: docs }).eq("id", u.id);
        renderDocs(); toast("Fertig", "Dokument gespeichert.");
      } catch (err) { toast("Fehler", err.message || "Upload fehlgeschlagen", "error"); }
    });
    form.querySelector("[data-tp-del]")?.addEventListener("click", async () => {
      if (String((AMKZ.state.member || {}).id) === String(u.id)) {
        return toast("Nicht möglich", "Dich selbst kannst du nicht entfernen.", "error");
      }
      if (!confirm(`Mitarbeiter "${u.name || u.email}" wirklich entfernen?`)) return;
      try { const r = await AMKZ.teamApi("entfernen", { id: u.id }); AMKZ.modal.close(); toast("Team", r.geloescht ? "Entfernt." : "Deaktiviert."); reload(); }
      catch (err) { toast("Fehler", err.message, "error"); }
    });
    /* Gehalt/Zahlungsdaten kommen nur über amk_team_privat (Sitzung + Recht).
       Fehlen sie, bleiben die Felder gesperrt und werden NICHT mitgeschickt —
       sonst würde ein Speichern das echte Gehalt mit 0 überschreiben. */
    const privatGeladen = Object.prototype.hasOwnProperty.call(u, "gehalt");
    if (!privatGeladen) {
      ["tpGehalt", "tpGehaltNote", "tpPay"].forEach((id2) => {
        const el = byId(id2); if (!el) return;
        el.value = ""; el.disabled = true; el.placeholder = "🔒 geschützt";
        el.title = "Nur mit Recht „Team verwalten“ oder „Finanzen“ und gültiger Anmeldung sichtbar.";
      });
    }
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const val = (id2) => { const el = byId(id2); return el ? el.value : ""; };
      const payload = {
        name: val("tpName").trim(), email: val("tpEmail").trim().toLowerCase(),
        role: val("tpRole"), position: val("tpPosition").trim(), phone: val("tpPhone").trim(), department: val("tpDept").trim(),
        address: val("tpAddress").trim(), birthday: val("tpBirthday") || null, start_date: val("tpStart") || null,
        gehalt: Number(val("tpGehalt")) || 0, gehalt_note: val("tpGehaltNote").trim(), vacation_days_year: Number(val("tpVac")) || 0,
        payment_info: val("tpPay").trim(), is_active: byId("tpActive").checked, is_approved: byId("tpApproved").checked, is_verified: byId("tpVerified") ? byId("tpVerified").checked : undefined, updated_at: new Date().toISOString(),
      };
      if (newAvatar) payload.avatar_url = newAvatar;
      if (!privatGeladen) { delete payload.gehalt; delete payload.gehalt_note; delete payload.payment_info; }

      /* Das Passwort stand vorher im Formular — als Klartext im value-Attribut,
         also für jeden lesbar, der auf den Bildschirm schaut oder den Quelltext
         der Seite ansieht. Und es wurde bei JEDEM Speichern mitgeschickt: wäre
         das Feld je leer gewesen, hätte ein normales Speichern dem Mitarbeiter
         das Passwort gelöscht.
         Jetzt startet das Feld leer und wird nur gesendet, wenn wirklich etwas
         drinsteht. */
      const neuesPasswort = val("tpPass");
      if (neuesPasswort) payload.password = neuesPasswort;

      form.querySelectorAll(".amkz-tp-right input").forEach((cb) => { payload[cb.dataset.right] = cb.checked; });
      /* Wer sich selbst bearbeitet, kann sich mit zwei Klicks aussperren:
         Häkchen "aktiv" weg -> die Sitzungsprüfung wirft einen beim nächsten
         Laden hinaus. Häkchen "Team verwalten" weg -> niemand kommt mehr an
         die Rechte, auch nicht an die eigenen. Beides ohne Rückfrage und
         ohne Weg zurück, wenn es der einzige Verwalter war. */
      const binIchSelbst = String((AMKZ.state.member || {}).id) === String(u.id);
      if (binIchSelbst) {
        if (payload.is_active === false) {
          toast("Nicht möglich", "Du kannst dich nicht selbst deaktivieren — das sperrt dich aus der Zentrale aus.", "error");
          return;
        }
        if (payload.can_manage_team === false) {
          toast("Nicht möglich", "Du kannst dir das Recht „Team verwalten“ nicht selbst entziehen — danach käme niemand mehr an die Rechte.", "error");
          return;
        }
      }

      const btn = e.submitter; if (btn) btn.disabled = true;
      try {
        /* Über den Server (Edge Function `team`): prüft Sitzung + „Team verwalten“, lässt nur erlaubte
           Felder durch und meldet zurück, was gespeichert ist. Gegenprobe: jedes Häkchen muss so
           zurückkommen, wie es abgeschickt wurde — sonst laute Meldung statt stillem Verlust
           (Fehler vom 26.10.2026: 14 Rechte flogen still raus, weil eine Spalte fehlte). */
        delete payload.updated_at;
        const antwort = await AMKZ.teamApi("speichern", { id: u.id, felder: payload });
        const neu = antwort.mitglied || {};
        const rechte = Object.keys(payload).filter((k) => /^can_|^is_/.test(k) && typeof payload[k] === "boolean");
        const abweichend = rechte.filter((k) => neu[k] !== payload[k]);
        const titel = (k) => (RIGHTS.find((r) => r[0] === k) || [k, k])[1];
        AMKZ.modal.close(); reload();
        if (abweichend.length) toast("Nicht alles gespeichert", "Nicht übernommen: " + abweichend.map(titel).join(", ") + ".", "error");
        else toast("Gespeichert", "Profil und alle Rechte sind gespeichert.");
      } catch (err) { toast("Fehler", err.message || "Speichern fehlgeschlagen", "error"); if (btn) btn.disabled = false; }
    });
  }
  document.addEventListener("click", (e) => { const c = e.target.closest("[data-tp]"); if (c) { e.preventDefault(); openProfile(c.getAttribute("data-tp")); } });
  const prev = AMKZ.loadView;
  AMKZ.loadView = async function tpChain(v, o) { const r = await prev?.call(this, v, o); if (v === "team") setTimeout(() => { if ((AMKZ.state.team || []).length) render(); else reload(); }, 550); return r; };
})();

/* ---------- Gehalt / Lohn als Ausgabe (gekoppelt an Mitarbeiter) ---------- */
(function () {
  "use strict";
  const AMKZ = window.AMKZ; if (!AMKZ || AMKZ.__salaryExpense) return; AMKZ.__salaryExpense = true;
  const byId = (id) => document.getElementById(id);
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? ""));
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const sb = () => AMKZ.supabase;
  const team = () => AMKZ.state.team || [];

  function ensureOption() {
    const typeSel = byId("amkzEntryType"), pSel = byId("amkzEntryPartner"); if (!typeSel || !pSel) return;
    const isExp = String(typeSel.value || "").toUpperCase() === "OPERATING_EXPENSE";
    let opt = pSel.querySelector('option[value="__SALARY__"]');
    if (isExp && !opt) { opt = document.createElement("option"); opt.value = "__SALARY__"; opt.textContent = "💶 Gehalt / Lohn"; pSel.appendChild(opt); }
    if (!isExp && opt) { if (pSel.value === "__SALARY__") { pSel.value = ""; exitMode(); } opt.remove(); }
  }
  function enterMode() {
    const amt = byId("amkzEntryAmount"); if (byId("amkzSalaryBlock")) return;
    const anchor = (amt && amt.closest(".amkz-input-group")) || byId("amkzEntryForm"); if (!anchor) return;
    const block = document.createElement("div"); block.id = "amkzSalaryBlock"; block.className = "amkz-input-group amkz-salary-block";
    block.innerHTML = `<label>Mitarbeiter (Gehalt)</label><select id="salEmp">${team().map((t) => `<option value="${esc(t.id)}" data-geh="${Number(t.gehalt || 0)}">${esc(t.name || t.email || "—")}${t.gehalt ? " · " + Number(t.gehalt).toLocaleString("de-DE") + " €" : ""}</option>`).join("")}</select>`;
    (anchor.parentElement || anchor).insertBefore(block, anchor.nextSibling || null);
    const sel = byId("salEmp");
    const setAmt = () => { const o = sel.selectedOptions[0]; const g = o ? Number(o.dataset.geh || 0) : 0; if (amt && g > 0) amt.value = g; };
    sel.addEventListener("change", setAmt); setAmt();
  }
  function exitMode() { byId("amkzSalaryBlock")?.remove(); }
  function wire() {
    const form = byId("amkzEntryForm"), typeSel = byId("amkzEntryType"), pSel = byId("amkzEntryPartner");
    if (!form || !typeSel || !pSel || form.dataset.salaryWired) return; form.dataset.salaryWired = "1";
    ensureOption();
    typeSel.addEventListener("change", () => { ensureOption(); if (pSel.value === "__SALARY__") { pSel.value = ""; exitMode(); } });
    pSel.addEventListener("change", () => { if (pSel.value === "__SALARY__") enterMode(); else exitMode(); });
  }
  document.addEventListener("submit", async (e) => {
    const f = e.target; if (!f || f.id !== "amkzEntryForm") return;
    const pSel = byId("amkzEntryPartner"); if (!pSel || pSel.value !== "__SALARY__") return;
    e.preventDefault(); e.stopImmediatePropagation();
    const empSel = byId("salEmp"); const empId = empSel && empSel.value; const empName = (empSel && empSel.selectedOptions[0] && empSel.selectedOptions[0].textContent.split(" · ")[0]) || "";
    const amount = Number(byId("amkzEntryAmount") && byId("amkzEntryAmount").value) || 0;
    const date = (byId("amkzEntryDate") && byId("amkzEntryDate").value) || undefined;
    try {
      const row = await AMKZ.save.saveEntry({ entryType: "OPERATING_EXPENSE", entryDate: date, amount, note: `Gehalt: ${empName}`, partnerGroupId: null });
      if (row && row.id && empId) { try { await sb().from("entries").update({ metadata: { ...(row.metadata || {}), salary: true, employee_id: empId, employee: empName } }).eq("id", row.id); } catch (_) {} }
      AMKZ.modal && AMKZ.modal.close && AMKZ.modal.close();
      toast("Gehalt gebucht", `${empName}: ${amount.toLocaleString("de-DE")} € als Ausgabe erfasst.`);
      try { AMKZ.modules?.v11?.loadFinanceCleanV11?.(); } catch (_) {}
    } catch (err) { toast("Fehler", err.message || "Speichern fehlgeschlagen", "error"); }
  }, true);
  const mo = new MutationObserver(() => { if (byId("amkzEntryForm")) wire(); });
  mo.observe(byId("amkzModalOverlay") || document.body, { childList: true, subtree: true });
})();

/* ---------- Avatar-Sync: Profilbilder in Sidebar (über Logout) + Connect-Chat ---------- */
(function () {
  "use strict";
  const AMKZ = window.AMKZ; if (!AMKZ || AMKZ.__avatarSync) return; AMKZ.__avatarSync = true;
  try { window.AMKZ_BUILD = "avatars-final-v6"; console.log("%cAMK BUILD · avatars-final-v6 (Profilbilder aktiv)", "color:#e9c76a;font-weight:800"); } catch (e) {}
  const byId = (id) => document.getElementById(id);
  const sb = () => AMKZ.supabase;
  AMKZ.state = AMKZ.state || {}; AMKZ.state.avatarById = AMKZ.state.avatarById || {};

  /* --- Bulletproof-Paint: echtes <img> in jeden Foto-Avatar legen ---
     WebKit/iOS-PWA rendert leere background-image-Avatare unzuverlässig
     (Box kollabiert / Bild wird nicht gemalt). Ein echtes <img> paintet
     auf JEDER Engine. Läuft zentral über ALLE Avatar-Typen. */
  function ensurePhotoImg(el) {
    if (!el || !el.classList || !el.classList.contains("amkz-has-photo")) return;
    let url = el.dataset ? el.dataset.avaUrl : "";
    if (!url) {
      const bg = (el.style && el.style.backgroundImage) || "";
      const m = bg.match(/url\((?:"|')?(.*?)(?:"|')?\)/);
      if (m) url = m[1];
    }
    if (!url || url === "none") return;
    let img = el.querySelector(":scope > img.amkz-ava-img");
    if (!img) { img = document.createElement("img"); img.className = "amkz-ava-img"; img.alt = ""; img.decoding = "async"; el.insertBefore(img, el.firstChild); }
    if (img.getAttribute("src") !== url) img.setAttribute("src", url);
  }
  function sweepPhotos(root) {
    (root || document).querySelectorAll(".amkz-has-photo").forEach(ensurePhotoImg);
  }
  AMKZ.ensurePhotoImg = ensurePhotoImg; AMKZ.sweepPhotos = sweepPhotos;
  // Sofort reagieren, sobald irgendwo ein Foto-Avatar auftaucht/sich ändert
  try {
    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === "attributes" && m.target && m.target.classList && m.target.classList.contains("amkz-has-photo")) ensurePhotoImg(m.target);
        m.addedNodes && m.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.classList && n.classList.contains("amkz-has-photo")) ensurePhotoImg(n);
          if (n.querySelectorAll) n.querySelectorAll(".amkz-has-photo").forEach(ensurePhotoImg);
        });
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "style"] });
  } catch (_) {}

  function applySidebar() {
    const me = AMKZ.state.member; if (!me) return;
    const map = AMKZ.state.avatarById || {};
    let url = map[me.id] || me.avatar_url;
    if (!url && me.email) { const t = (AMKZ.state.team || []).find((x) => String(x.email || "").toLowerCase() === String(me.email).toLowerCase()); if (t) url = map[t.id] || t.avatar_url; }
    const el = byId("amkzUserAvatar"); if (!el || !url) return;
    if (el.dataset.avaUrl === url && el.classList.contains("amkz-has-photo")) return;
    el.dataset.avaUrl = url; el.textContent = ""; el.style.setProperty("background-image", `url('${url}')`, "important"); el.classList.add("amkz-has-photo");
    ensurePhotoImg(el);
  }
  function patchChat() {
    const map = AMKZ.state.avatarById || {};
    document.querySelectorAll(".amkz-chat-user[data-chat-user-id]").forEach((btn) => {
      const url = map[btn.getAttribute("data-chat-user-id")]; if (!url) return;
      const av = btn.querySelector(".amkz-chat-avatar"); if (!av || av.dataset.avaUrl === url) return;
      av.dataset.avaUrl = url; av.textContent = ""; av.style.setProperty("background-image", `url('${url}')`, "important"); av.classList.add("amkz-has-photo");
    });
    // Team-Profil-Karten
    document.querySelectorAll(".amkz-tp-card[data-tp]").forEach((card) => {
      const url = map[card.getAttribute("data-tp")]; if (!url) return;
      const av = card.querySelector(".amkz-tp-ava"); if (!av || av.dataset.avaUrl === url) return;
      av.dataset.avaUrl = url; av.textContent = ""; av.style.setProperty("background-image", `url('${url}')`, "important"); av.classList.add("amkz-has-photo");
    });
    // aktiver Chat-Header
    const hdr = document.querySelector(".amkz-chat-active-avatar, #amkzChatActiveAvatar");
    if (hdr && AMKZ.state.currentChatUserId) { const u = map[AMKZ.state.currentChatUserId]; if (u && hdr.dataset.avaUrl !== u) { hdr.dataset.avaUrl = u; hdr.textContent = ""; hdr.style.setProperty("background-image", `url('${u}')`, "important"); hdr.classList.add("amkz-has-photo"); } }
  }
  async function load() {
    try {
      const { data } = await sb().from("team_members").select("id,avatar_url");
      if (Array.isArray(data)) { const m = {}; data.forEach((r) => { if (r.avatar_url) m[r.id] = r.avatar_url; }); AMKZ.state.avatarById = m; }
    } catch (_) {}
    applySidebar(); patchChat(); sweepPhotos();
  }
  load(); setInterval(load, 30000);
  setInterval(() => { applySidebar(); patchChat(); sweepPhotos(); }, 2000); // günstig: nur DOM-Patch der noch bildlosen Avatare
})();

/* =====================================================================
   GIVEAWAY-ADMIN — volle Einsicht ins 300K-Gewinnspiel (Supabase)
   Accounts + Tickets/Einzahlungen, Live-Suche, Status-Filter,
   Account-Drilldown, CSV-Export. Liest token-geschützt über die RPC
   amk_giveaway_admin (siehe supabase-giveaway-admin.sql).
   ===================================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ; if (!AMKZ || AMKZ.__giveawayAdmin) return; AMKZ.__giveawayAdmin = true;

  // >>> MUSS mit v_secret in supabase-giveaway-admin.sql übereinstimmen <<<
  const GV_ADMIN_TOKEN = "amk_gv_aMU3heSihudfeuz8Tf7Smgw0w2DW1o";
  // >>> MUSS mit v_secret in supabase-cz-raffle.sql übereinstimmen <<<
  const CZ_RAFFLE_TOKEN = "amk_cz_YzqjjkYjs9NzOEmlFMmZDQxdKdakla";

  const byId = (id) => document.getElementById(id);
  const sb = () => AMKZ.supabase;
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m])));
  const money = (v) => new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 }).format(Number(v) || 0) + " €";
  const num = (v) => new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 }).format(Number(v) || 0);
  const fmtDate = (v) => { if (!v) return "—"; const d = new Date(v); return isNaN(d) ? String(v) : d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(", ", " "); };

  /* Nachtschicht 31.10.: Twitch-Konten haben registered_at als Text „17.9.2026, 13:32:34“ → einheitlich „17.09.2026 13:32“ */
  const gvReg = (u) => { const s = String((u && u.registered_at) || ""); const m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{2,4})(?:,?\s*(\d{1,2}):(\d{2}))?/); if (!m) return fmtDate(u && (u.registered_at || u.created_at)); const p = (x) => String(x).padStart(2, "0"); return p(m[1]) + "." + p(m[2]) + "." + (m[3].length === 2 ? "20" + m[3] : m[3]) + (m[4] ? " " + p(m[4]) + ":" + m[5] : ""); };

  // Rueckfall-Liste fuer das Casino-Feld beim Korrigieren. Die Edge Function
  // `giveaway` liest die gueltigen Casinos seit 08.09.2026 aus dem Casino-Hub;
  // hier kommen zusaetzlich alle Casinos dazu, die in Eintraegen vorkommen.
  const GV_CASINOS = ["MetaSpins", "IZZI", "IRIS", "FUGU", "IRWIN", "MARTIN", "FLAGMAN", "21.com", "Freshbet"];

  /* Wie viele Zeilen gezeichnet werden. Vorher waren es IMMER alle — bei
     mehreren tausend Einzahlungen baut der Browser genauso viele Tabellen-
     zeilen samt Knöpfen auf. Auf dem Handy dauert das Sekunden und frisst
     Speicher, und beim Tippen im Suchfeld passiert es bei jedem Zeichen neu.
     Jetzt in Blöcken; gezählt, gerechnet und exportiert wird weiterhin über
     ALLE gefilterten Zeilen. */
  const BLOCK = 200;
  const state = { loaded: false, loading: false, tab: "accounts", q: "", status: "", casino: "", zeige: BLOCK, users: [], deposits: [], stats: null, boostLoading: false,
    cz: { loaded: false, loading: false, rows: [], template: { subject: "", body: "" }, stats: {}, tplDirty: false, authFail: false, rpcMissing: false, loadError: "" } };

  // Datum einer Einzahlung als yyyy-mm-dd (aus deposit_date "dd.MM.yyyy …" oder created_at)
  function depDateKey(d) {
    const dd = String(d.deposit_date || "");
    const m = dd.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
    if (m) return m[3] + "-" + m[2] + "-" + m[1];
    const c = String(d.created_at || "");
    return c ? c.slice(0, 10) : "";
  }
  // Aktiver Zeitraum kommt aus der globalen Leiste oben rechts (Zeitraum laden)
  const rangeFrom = () => AMKZ.state && AMKZ.state.rangeFrom;
  const rangeTo = () => AMKZ.state && AMKZ.state.rangeTo;
  const filterActive = () => !!(rangeFrom() && rangeTo()) || !!state.casino || !!state.q.trim();
  // Liste aller Casinos (für das Filter-Dropdown)
  function casinoList() { return [...new Set(state.deposits.map((d) => String(d.casino || "").trim()).filter(Boolean))].sort(); }
  // KPIs aus einer Einzahlungs-Liste
  function depKpis(deps) {
    const einzahler = new Set(deps.map((d) => String(d.email || "").toLowerCase()).filter(Boolean)).size;
    const betrag = deps.reduce((a, d) => a + Number(d.amount || 0), 0);
    const tickets = deps.reduce((a, d) => a + Number(d.tickets || 0), 0);
    return { einzahler, count: deps.length, betrag, tickets };
  }

  // Edge-Function-Basis für den Verlosungs-Versand (cz-raffle)
  function czFnBase() {
    const root = byId("amkzApp");
    const url = (root?.dataset?.supabaseUrl || "https://cbwxgikndyyzdslmfpmo.supabase.co").replace(/\/$/, "");
    return { url: url + "/functions/v1/cz-raffle", key: root?.dataset?.supabaseKey || "" };
  }
  const meName = () => (AMKZ.state && AMKZ.state.member && AMKZ.state.member.name) || "";

  function ensureStyle() {
    if (byId("amk-gv-style")) return;
    const s = document.createElement("style"); s.id = "amk-gv-style";
    s.textContent = `
      .amkz-gv-root{display:flex;flex-direction:column;gap:16px}
      .amkz-gv-kpis{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:14px}
      .amkz-gv-kpi{background:linear-gradient(165deg,rgba(255,255,255,.05),rgba(255,255,255,.015));border:1px solid rgba(200,170,110,.22);border-radius:18px;padding:16px 18px;position:relative;overflow:hidden}
      .amkz-gv-kpi::after{content:"";position:absolute;inset:0 0 auto 0;height:3px;background:linear-gradient(90deg,#f7df97,#c8902b)}
      .amkz-gv-kpi small{display:block;font-size:.72rem;text-transform:uppercase;letter-spacing:.08em;opacity:.6;font-weight:800;margin-bottom:6px}
      .amkz-gv-kpi strong{font-size:1.7rem;font-weight:900;color:#f0d488;line-height:1}
      .amkz-gv-card{background:linear-gradient(180deg,rgba(20,20,26,.6),rgba(9,9,12,.55));border:1px solid rgba(255,255,255,.08);border-radius:22px;padding:16px 16px 8px}
      .amkz-gv-toolbar{display:flex;gap:10px;flex-wrap:wrap;align-items:center;margin-bottom:12px}
      .amkz-gv-filterbar{display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;margin:0 0 12px;padding:9px 14px;border-radius:12px;background:rgba(200,170,110,.1);border:1px solid rgba(200,170,110,.3);color:#f0d488;font-size:.86rem}
      .amkz-gv-filterbar b{color:#fff}
      .amkz-gv-reset{background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.16);color:#eee;border-radius:9px;padding:6px 12px;font-weight:700;font-size:.8rem;cursor:pointer}
      .amkz-gv-reset:hover{background:rgba(255,255,255,.16)}
      .amkz-gv-tabs{display:flex;gap:6px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08);border-radius:12px;padding:4px}
      .amkz-gv-boostwrap{padding:0 0 12px}
      .amkz-gv-boostwrap .amk-boost-card{background:none;border:0;padding:0;margin:0;box-shadow:none}
      .amkz-gv-boostwrap .amk-boost-card h3{margin-top:0}
      .amkz-gv-tab{background:none;border:0;color:inherit;opacity:.7;font-weight:700;font-size:.88rem;padding:7px 14px;border-radius:9px;cursor:pointer}
      .amkz-gv-tab.active{background:rgba(200,170,110,.16);color:#f0d488;opacity:1}
      .amkz-gv-search{flex:1;min-width:200px}
      .amkz-gv-search input{width:100%;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.12);border-radius:12px;padding:10px 14px;color:inherit;font-size:.9rem}
      .amkz-gv-search input::placeholder{opacity:.5}
      .amkz-gv-status{background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.12);border-radius:12px;padding:10px 12px;color:inherit;font-size:.86rem}
      .amkz-gv-btn{background:rgba(200,170,110,.12);border:1px solid rgba(200,170,110,.4);border-radius:12px;padding:9px 15px;font-weight:700;color:#f0d488;cursor:pointer;font-size:.86rem;white-space:nowrap}
      .amkz-gv-btn:hover{background:rgba(200,170,110,.2)}
      .amkz-gv-count{opacity:.55;font-size:.82rem;font-weight:700;margin-left:auto}
      .amkz-gv-tablewrap{overflow-x:auto;border-radius:14px}
      table.amkz-gv-table{width:100%;border-collapse:collapse;font-size:.86rem}
      .amkz-gv-table thead th{text-align:left;font-size:.68rem;text-transform:uppercase;letter-spacing:.06em;opacity:.55;font-weight:800;padding:8px 12px;border-bottom:1px solid rgba(255,255,255,.1);white-space:nowrap;position:sticky;top:0;background:rgba(12,12,16,.9);backdrop-filter:blur(6px)}
      .amkz-gv-table tbody td{padding:11px 12px;border-bottom:1px solid rgba(255,255,255,.05);white-space:nowrap}
      .amkz-gv-table tbody tr.clickable{cursor:pointer;transition:background .12s}
      .amkz-gv-table tbody tr.clickable:hover{background:rgba(200,170,110,.07)}
      .amkz-gv-table .num{text-align:right;font-variant-numeric:tabular-nums}
      .amkz-gv-gold{color:#f0d488;font-weight:800}
      .amkz-gv-mut{opacity:.55}
      .amkz-gv-pill{display:inline-block;padding:3px 10px;border-radius:999px;font-size:.7rem;font-weight:800;text-transform:uppercase;letter-spacing:.04em}
      .amkz-gv-pill.ok{background:rgba(52,211,153,.16);color:#34d399}
      .amkz-gv-pill.open{background:rgba(230,184,92,.18);color:#f0d488}
      .amkz-gv-pill.other{background:rgba(255,255,255,.08);color:#bbb}
      .amkz-gv-setup{background:rgba(230,120,92,.1);border:1px solid rgba(230,120,92,.4);border-radius:16px;padding:20px 22px;line-height:1.6}
      .amkz-gv-setup h3{margin:0 0 8px;color:#f0a488}
      .amkz-gv-setup code{background:rgba(0,0,0,.4);padding:2px 7px;border-radius:6px;color:#f0d488;font-size:.85em}
      .amkz-gv-empty{padding:30px;text-align:center;opacity:.5}
      .amkz-gv-dd-head{display:flex;flex-direction:column;gap:2px;margin-bottom:12px}
      .amkz-gv-dd-stats{display:flex;gap:18px;flex-wrap:wrap;margin:8px 0 14px}
      .amkz-gv-dd-stat strong{display:block;color:#f0d488;font-size:1.2rem;font-weight:900}
      .amkz-gv-dd-stat small{opacity:.55;font-size:.72rem;text-transform:uppercase;letter-spacing:.05em}
      .amkz-gv-dd-sec{margin:14px 0 6px;font-size:.75rem;text-transform:uppercase;letter-spacing:.05em;opacity:.6;color:#e9cd86}
      .amkz-gv-dd-cnt{float:right;background:rgba(230,184,92,.12);border:1px solid rgba(230,184,92,.28);border-radius:999px;padding:2px 10px;color:#f0d488;font-size:.7rem}
      .amkz-gv-ddscroll{max-height:min(56vh,620px);overflow-y:auto;overflow-x:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;border-radius:14px}
      .amkz-gv-ddscroll .amkz-gv-tablewrap{overflow:visible}
      @media (max-width:640px){ .amkz-gv-ddscroll{max-height:64vh} }
      .amkz-cz-send{background:linear-gradient(135deg,#f7df97,#c8902b);border:0;color:#1a1206;border-radius:10px;padding:7px 13px;font-weight:800;font-size:.8rem;cursor:pointer;white-space:nowrap}
      .amkz-cz-send:hover{filter:brightness(1.06)}
      .amkz-cz-send:disabled{opacity:.6;cursor:default}
      .amkz-cz-mini{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.14);color:inherit;border-radius:9px;padding:6px 9px;font-size:.82rem;cursor:pointer;margin-left:6px}
      .amkz-cz-mini:hover{background:rgba(255,255,255,.12)}
      .amkz-cz-mini.del:hover{background:rgba(220,90,90,.18);border-color:rgba(220,90,90,.5)}
      .amkz-cz-tpl{margin:14px 2px 8px;background:rgba(255,255,255,.03);border:1px solid rgba(200,170,110,.22);border-radius:16px;padding:14px 15px}
      .amkz-cz-tpl-head{display:flex;flex-direction:column;gap:2px;margin-bottom:10px}
      .amkz-cz-tpl-head strong{font-size:.92rem;color:#f0d488}
      .amkz-cz-tpl-head code{background:rgba(0,0,0,.4);padding:1px 6px;border-radius:5px;color:#f0d488;font-size:.85em}
      .amkz-cz-tpl-subject,.amkz-cz-tpl-body{width:100%;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.12);border-radius:11px;padding:10px 13px;color:inherit;font-size:.9rem;font-family:inherit}
      .amkz-cz-tpl-subject{margin-bottom:9px;font-weight:700}
      .amkz-cz-tpl-body{resize:vertical;line-height:1.55;min-height:150px}
      .amkz-cz-tpl-foot{display:flex;align-items:center;gap:12px;margin-top:10px;flex-wrap:wrap}
      .amkz-gv-actcell{text-align:right;white-space:nowrap}
      .amkz-gv-pill.blocked{background:rgba(220,90,90,.18);color:#f08a8a}
      button.amkz-gv-pill{border:0;font-family:inherit;line-height:1.5}
      button.amkz-gv-pill.tap{cursor:pointer;transition:filter .12s,transform .08s;min-height:26px}
      button.amkz-gv-pill.tap:hover{filter:brightness(1.25)}
      button.amkz-gv-pill.tap:active{transform:scale(.94)}
      .amkz-gv-table tbody tr.gvblocked td{opacity:.5}
      .amkz-gv-table tbody tr.gvblocked td .amkz-gv-pill{opacity:1}
      .amkz-gv-sum{display:flex;align-items:center;gap:14px;flex-wrap:wrap;margin:0 2px 12px;padding:9px 14px;border-radius:12px;background:rgba(255,255,255,.035);border:1px solid rgba(255,255,255,.08);font-size:.82rem}
      .amkz-gv-kpinote{display:block;margin-top:5px;font-style:normal;font-size:.72rem;font-weight:700;color:#f08a8a;opacity:.9}
      .amkz-gv-sumitem{opacity:.85}
      .amkz-gv-sumitem b{font-weight:900;margin:0 2px}
      .amkz-gv-sumitem small{opacity:.55;font-size:.9em}
      .amkz-gv-sumitem.ok b{color:#34d399}
      .amkz-gv-sumitem.open b{color:#f0d488}
      .amkz-gv-sumitem.blocked b{color:#f08a8a}
      .amkz-gv-sumbar{flex:1;min-width:90px;height:6px;border-radius:99px;background:rgba(255,255,255,.09);overflow:hidden}
      .amkz-gv-sumbar i{display:block;height:100%;border-radius:99px;background:linear-gradient(90deg,#34d399,#f7df97);transition:width .25s}
      @media(max-width:640px){.amkz-gv-sumbar{order:9;flex-basis:100%}}
      .amkz-gv-boostbadge{font-size:.68rem;font-weight:800;color:#f7b955;margin-left:5px}
      .amkz-gv-loglist{display:flex;flex-direction:column;gap:8px;max-height:60vh;overflow-y:auto;padding-right:4px}
      .amkz-gv-logitem{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08);border-radius:12px;padding:10px 12px;font-size:.84rem}
      .amkz-gv-logitem.del{border-color:rgba(220,90,90,.35);background:rgba(220,90,90,.07)}
      .amkz-gv-logitem b{color:#f0d488}
      .amkz-gv-loghead{display:flex;justify-content:space-between;gap:10px;flex-wrap:wrap;margin-bottom:3px}
      @media(max-width:640px){.amkz-gv-kpi strong{font-size:1.35rem}}
      .amkz-gv-mehr td{padding:14px 12px;text-align:center;border-top:1px dashed rgba(255,255,255,.14)}
      .amkz-gv-mehr .amkz-gv-mut{display:block;margin-top:7px;font-size:.78rem}
    `;
    document.head.appendChild(s);
  }

  /* ---------- Status einer Einzahlung ----------
     OFFEN     = noch nicht geprüft
     GEPRÜFT   = geprüft & freigegeben -> zählt für die Auslosung
     GESPERRT  = fliegt aus der Auslosung raus
     Klick auf die Pille schaltet weiter: OFFEN → GEPRÜFT → GESPERRT → OFFEN. */
  const GV_STATES = ["OFFEN", "GEPRÜFT", "GESPERRT"];
  const GV_STATE_META = {
    OFFEN:    { cls: "open",    label: "OFFEN",    icon: "⏳", title: "Noch nicht geprüft — klicken = geprüft" },
    "GEPRÜFT": { cls: "ok",      label: "GEPRÜFT",  icon: "✅", title: "Geprüft & freigegeben — klicken = sperren" },
    GESPERRT: { cls: "blocked", label: "GESPERRT", icon: "⛔", title: "Zählt NICHT für die Auslosung — klicken = wieder offen" },
  };
  // Altbestand: "BESTÄTIGT"/"OK" gilt als geprüft, leer/"OPEN" als offen.
  function normStatus(v) {
    const u = String(v || "").trim().toUpperCase();
    if (u === "" || u === "OPEN") return "OFFEN";
    if (u === "BESTÄTIGT" || u === "BESTAETIGT" || u === "OK" || u === "CONFIRMED") return "GEPRÜFT";
    if (u === "GEPRUEFT") return "GEPRÜFT";
    if (u === "BLOCKED" || u === "GESPERRT") return "GESPERRT";
    return GV_STATES.includes(u) ? u : u; // unbekannter Altwert: unverändert anzeigen
  }
  const nextStatus = (v) => { const i = GV_STATES.indexOf(normStatus(v)); return GV_STATES[(i + 1) % GV_STATES.length]; };

  function statusPill(st, id) {
    const u = normStatus(st);
    const m = GV_STATE_META[u] || { cls: "other", label: u || "OFFEN", icon: "", title: "" };
    const txt = `${m.icon ? m.icon + " " : ""}${esc(m.label)}`;
    if (!id || !canEdit()) return `<span class="amkz-gv-pill ${m.cls}">${txt}</span>`;
    return `<button type="button" class="amkz-gv-pill ${m.cls} tap" data-gv-status="${esc(id)}" title="${esc(m.title)}">${txt}</button>`;
  }

  // Schreib-/Lese-Aufrufe der Admin-Funktion (siehe supabase-giveaway-edit.sql)
  async function gvRpc(action, payload) {
    const { data, error } = await sb().rpc("amk_giveaway_admin", { p_token: GV_ADMIN_TOKEN, p_action: action, p_payload: payload || {} });
    if (error) throw error;
    if (data && data.error) throw new Error(data.error === "unauthorized" ? "Admin-Token stimmt nicht mit der Datenbank ueberein." : data.error);
    return data;
  }
  // Fehlt die neue 3-Parameter-Funktion, sagen wir klar was zu tun ist.
  function gvWriteError(err, was) {
    const msg = String((err && err.message) || "");
    if (/schema cache|does not exist|not exist|not found|p_payload/i.test(msg)) {
      toast("Giveaway", "Korrigieren/Loeschen ist noch nicht freigeschaltet — Datei supabase-giveaway-edit.sql einmal im Supabase SQL-Editor ausfuehren.", "error");
    } else {
      toast("Giveaway", was + " fehlgeschlagen: " + msg, "error");
    }
  }
  // Korrigieren/Loeschen nur auf Chef-Ebene (Admin, Finanzen oder Team-Verwaltung).
  // Wer nur can_view_giveaway hat, schaut zu.
  function canEdit() {
    const p = (AMKZ.state && AMKZ.state.permissions) || {};
    return p.isAdmin === true || p.finance === true || p.team === true;
  }
  const findDep = (id) => state.deposits.find((d) => String(d.id) === String(id));

  async function loadData(force) {
    if (state.loading) return;
    if (state.loaded && !force) return;
    state.loading = true;
    render(); // zeigt Lade-/aktualisiere-Zustand
    try {
      const { data, error } = await sb().rpc("amk_giveaway_admin", { p_token: GV_ADMIN_TOKEN, p_action: "all" });
      if (error) throw error;
      if (!data || data.error) { state.authFail = true; state.loaded = true; state.loading = false; render(); return; }
      state.authFail = false;
      state.stats = data.stats || null;
      state.users = Array.isArray(data.users) ? data.users : [];
      state.deposits = Array.isArray(data.deposits) ? data.deposits : [];
      state.loaded = true; state.rpcMissing = false;
    } catch (err) {
      // RPC existiert noch nicht -> Setup-Hinweis
      const msg = String(err && err.message || "");
      state.rpcMissing = /not exist|not found|schema cache|amk_giveaway_admin|function/i.test(msg);
      state.loadError = msg;
      state.loaded = true;
    }
    state.loading = false;
    render();
  }

  function filteredUsers() {
    const q = state.q.trim().toLowerCase();
    if (!q) return state.users;
    return state.users.filter((u) => `${u.name || ""} ${u.email || ""} ${u.username || ""}`.toLowerCase().includes(q));
  }
  function filteredDeposits() {
    const q = state.q.trim().toLowerCase();
    const st = state.status;
    const cas = state.casino;
    const from = rangeFrom(), to = rangeTo();
    const useRange = !!(from && to);
    return state.deposits.filter((d) => {
      if (st && normStatus(d.status) !== st) return false;
      if (cas && String(d.casino || "").trim() !== cas) return false;
      if (useRange) { const k = depDateKey(d); if (!k || k < from || k > to) return false; }
      if (!q) return true;
      return `${d.name || ""} ${d.email || ""} ${d.casino || ""}`.toLowerCase().includes(q);
    });
  }

  // Fusszeile unter einer gekuerzten Tabelle: sagt was fehlt und holt es nach.
  function mehrZeile(gesamt, gezeigt, spalten) {
    if (gesamt <= gezeigt) return "";
    const rest = gesamt - gezeigt;
    return `<tr class="amkz-gv-mehr"><td colspan="${spalten}">
      <button type="button" class="amkz-gv-btn" id="amkzGvMehr">
        weitere ${num(Math.min(BLOCK, rest))} anzeigen</button>
      <span class="amkz-gv-mut">${num(gezeigt)} von ${num(gesamt)} · ${num(rest)} noch nicht geladen</span>
    </td></tr>`;
  }

  function usersTable(rows, alle) {
    if (!rows.length) return `<div class="amkz-gv-empty">Keine Accounts gefunden.</div>`;
    const gesamt = rows.length;
    if (!alle) rows = rows.slice(0, state.zeige);
    return `<div class="amkz-gv-tablewrap"><table class="amkz-gv-table">
      <thead><tr><th>Name</th><th>E-Mail</th><th>Username</th><th class="num">Einz.</th><th class="num">Summe</th><th class="num">Tickets</th><th>Registriert</th></tr></thead>
      <tbody>${rows.map((u) => `<tr class="clickable" data-gv-user="${esc(u.email)}">
        <td><strong>${esc(u.name || "—")}</strong></td>
        <td class="amkz-gv-mut">${esc(u.email || "")}</td>
        <td class="amkz-gv-mut">${esc(u.username || "—")}</td>
        <td class="num">${num(u.deposit_count)}</td>
        <td class="num amkz-gv-gold">${money(u.total_amount)}</td>
        <td class="num amkz-gv-gold">${num(u.total_tickets)}</td>
        <td class="amkz-gv-mut">${esc(gvReg(u))}</td>
      </tr>`).join("")}${mehrZeile(gesamt, rows.length, 7)}</tbody></table></div>`;
  }
  function depositsTable(rows, alle) {
    if (!rows.length) return `<div class="amkz-gv-empty">Keine Tickets/Einzahlungen gefunden.</div>`;
    const gesamt = rows.length;
    if (!alle) rows = rows.slice(0, state.zeige);
    const ed = canEdit();
    return `<div class="amkz-gv-tablewrap"><table class="amkz-gv-table">
      <thead><tr><th>Datum</th><th>Name</th><th>E-Mail</th><th>Casino</th><th class="num">Betrag</th><th class="num">Tickets</th><th>Status</th>${ed ? `<th class="amkz-gv-actcell">Aktion</th>` : ""}</tr></thead>
      <tbody>${rows.map((d) => `<tr data-gv-row="${esc(d.id)}" class="${normStatus(d.status) === "GESPERRT" ? "gvblocked" : ""}">
        <td class="amkz-gv-mut">${esc(d.deposit_date || fmtDate(d.created_at))}</td>
        <td><strong>${esc(d.name || "—")}</strong></td>
        <td class="amkz-gv-mut">${esc(d.email || "")}</td>
        <td>${esc(d.casino || "—")}</td>
        <td class="num amkz-gv-gold">${money(d.amount)}</td>
        <td class="num amkz-gv-gold">${num(d.tickets)}${Number(d.boost_mult || 1) > 1 ? `<span class="amkz-gv-boostbadge">×${num(d.boost_mult)}</span>` : ""}</td>
        <td>${statusPill(d.status, d.id)}</td>
        ${ed ? `<td class="amkz-gv-actcell">
          <button type="button" class="amkz-cz-mini" data-gv-edit="${esc(d.id)}" title="Eintrag korrigieren">✏️</button>
          <button type="button" class="amkz-cz-mini del" data-gv-del="${esc(d.id)}" title="Eintrag löschen">🗑</button>
        </td>` : ""}
      </tr>`).join("")}${mehrZeile(gesamt, rows.length, ed ? 8 : 7)}</tbody></table></div>`;
  }

  /* ---------- Eintrag korrigieren / loeschen ---------- */
  function openDepEdit(id) {
    const d = findDep(id); if (!d) return;
    const mult = Number(d.boost_mult || 1) || 1;
    const casinos = [...new Set(GV_CASINOS.concat(casinoList(), [d.casino || ""]).map((c) => String(c || "").trim()).filter(Boolean))];
    const stCur = normStatus(d.status);
    const stOpts = [...new Set(GV_STATES.concat([stCur]))];
    const emails = [...new Set(state.users.map((u) => String(u.email || "")).filter(Boolean))];
    AMKZ.modal.open(`
      <div class="amkz-modal" style="max-width:620px;width:96vw">
        <div class="amkz-modal-header"><div><h3>Eintrag korrigieren</h3>
          <p>${esc(d.name || d.email || "")} · ${esc(d.deposit_date || fmtDate(d.created_at))}</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        <form id="amkzGvEditForm" class="amkz-form-grid">
          <div class="amkz-input-group"><label>Casino</label>
            <select id="gvEdCasino">${casinos.map((c) => `<option value="${esc(c)}" ${c === d.casino ? "selected" : ""}>${esc(c)}</option>`).join("")}</select></div>
          <div class="amkz-input-group"><label>Betrag (€)</label>
            <input id="gvEdAmount" type="number" step="1" min="0" value="${esc(Number(d.amount) || 0)}"></div>
          <div class="amkz-input-group"><label>Tickets</label>
            <input id="gvEdTickets" type="number" step="1" min="0" value="${esc(Number(d.tickets) || 0)}">
            <small class="amkz-gv-mut">${mult > 1 ? `🔥 Boost-Einzahlung ×${num(mult)} — Tickets = Betrag × ${num(mult)}.` : "1€ = 1 Ticket."} Wird beim Ändern des Betrags automatisch neu gerechnet — du kannst sie danach frei überschreiben.</small></div>
          <div class="amkz-input-group"><label>Status</label>
            <select id="gvEdStatus">${stOpts.map((o) => `<option value="${esc(o)}" ${o === stCur ? "selected" : ""}>${esc((GV_STATE_META[o] ? GV_STATE_META[o].icon + " " : "") + (o === "OFFEN" ? "Offen" : o === "GEPRÜFT" ? "Geprüft — zählt für die Auslosung" : o === "GESPERRT" ? "Gesperrt — zählt NICHT" : o))}</option>`).join("")}</select></div>
          <div class="amkz-input-group"><label>Konto (E-Mail)</label>
            <input id="gvEdEmail" list="gvEdEmails" value="${esc(d.email || "")}">
            <datalist id="gvEdEmails">${emails.map((e) => `<option value="${esc(e)}"></option>`).join("")}</datalist>
            <small class="amkz-gv-mut">Falsches Konto? Hier auf die richtige E-Mail umhängen — sie muss im Gewinnspiel registriert sein.</small></div>
          <div class="amkz-input-group"><label>Name</label><input id="gvEdName" value="${esc(d.name || "")}"></div>
          <div class="amkz-input-group"><label>Datum</label>
            <input id="gvEdDate" value="${esc(d.deposit_date || "")}" placeholder="28.08.2026 09:52"></div>
          <div class="amkz-modal-actions">
            <button class="amkz-secondary-btn" type="button" id="gvEdDelete" style="margin-right:auto">🗑 Löschen</button>
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">Speichern</button>
          </div>
        </form>
      </div>`);

    const amountEl = byId("gvEdAmount"), ticketsEl = byId("gvEdTickets");
    let ticketsManual = false;
    ticketsEl?.addEventListener("input", () => { ticketsManual = true; });
    amountEl?.addEventListener("input", () => {
      if (ticketsManual || !ticketsEl) return;
      ticketsEl.value = String(Math.round((Number(amountEl.value) || 0) * mult));
    });
    byId("gvEdDelete")?.addEventListener("click", () => delDeposit(id));
    byId("amkzGvEditForm")?.addEventListener("submit", async (e) => {
      e.preventDefault();
      const btn = e.target.querySelector(".amkz-primary-btn");
      if (btn) { btn.disabled = true; btn.textContent = "Speichert …"; }
      try {
        await gvRpc("deposit_update", {
          id,
          casino: byId("gvEdCasino")?.value || "",
          amount: String(Number(byId("gvEdAmount")?.value) || 0),
          tickets: String(Number(byId("gvEdTickets")?.value) || 0),
          status: byId("gvEdStatus")?.value || "",
          email: (byId("gvEdEmail")?.value || "").trim(),
          name: (byId("gvEdName")?.value || "").trim(),
          deposit_date: (byId("gvEdDate")?.value || "").trim(),
          by: meName(),
        });
        AMKZ.modal.close();
        toast("Giveaway", "Eintrag korrigiert ✓", "success");
        await loadData(true);
      } catch (err) {
        if (btn) { btn.disabled = false; btn.textContent = "Speichern"; }
        gvWriteError(err, "Speichern");
      }
    });
  }

  // Klick auf die Status-Pille: sofort umschalten, dann speichern.
  // Klemmt die Datenbank, springt die Pille zurück.
  const statusBusy = new Set();
  async function cycleStatus(id) {
    const d = findDep(id); if (!d || statusBusy.has(id)) return;
    const before = d.status;
    const after = nextStatus(before);
    statusBusy.add(id);
    d.status = after;
    paintStatus(id);
    try {
      await gvRpc("deposit_status", { id, status: after, by: meName() });
      if (after === "GESPERRT") toast("Giveaway", "Gesperrt — diese Einzahlung zählt nicht für die Auslosung.", "info");
    } catch (err) {
      d.status = before;
      paintStatus(id);
      gvWriteError(err, "Status ändern");
    } finally { statusBusy.delete(id); }
  }
  // Pille(n) dieser Einzahlung neu zeichnen — in der Tabelle UND im Drilldown,
  // ohne die ganze Ansicht neu aufzubauen (Scrollposition bleibt).
  function paintStatus(id) {
    const d = findDep(id); if (!d) return;
    const scopes = [byId("amkzGiveawayRoot"), byId("amkzModalOverlay")].filter(Boolean);
    scopes.forEach((sc) => {
      sc.querySelectorAll(`[data-gv-status="${CSS.escape(String(id))}"]`).forEach((btn) => {
        const holder = document.createElement("div");
        holder.innerHTML = statusPill(d.status, d.id);
        const fresh = holder.firstElementChild; if (!fresh) return;
        btn.replaceWith(fresh);
        fresh.addEventListener("click", (e) => { e.stopPropagation(); cycleStatus(id); });
      });
      sc.querySelectorAll(`[data-gv-row="${CSS.escape(String(id))}"]`).forEach((tr) => {
        tr.classList.toggle("gvblocked", normStatus(d.status) === "GESPERRT");
      });
    });
    const sum = byId("amkzGvStatusSum");
    if (sum) sum.outerHTML = statusSummary(filteredDeposits());
  }
  // Prüf-Fortschritt über den gerade sichtbaren Einträgen
  function statusSummary(rows) {
    const acc = { OFFEN: { n: 0, t: 0 }, "GEPRÜFT": { n: 0, t: 0 }, GESPERRT: { n: 0, t: 0 } };
    rows.forEach((d) => { const k = normStatus(d.status); if (acc[k]) { acc[k].n++; acc[k].t += Number(d.tickets || 0); } });
    const done = acc["GEPRÜFT"].n + acc.GESPERRT.n;
    const pct = rows.length ? Math.round((done / rows.length) * 100) : 0;
    return `<div class="amkz-gv-sum" id="amkzGvStatusSum">
      <span class="amkz-gv-sumitem open">⏳ offen <b>${num(acc.OFFEN.n)}</b></span>
      <span class="amkz-gv-sumitem ok">✅ geprüft <b>${num(acc["GEPRÜFT"].n)}</b> <small>${num(acc["GEPRÜFT"].t)} Tickets</small></span>
      <span class="amkz-gv-sumitem blocked">⛔ gesperrt <b>${num(acc.GESPERRT.n)}</b> <small>${num(acc.GESPERRT.t)} Tickets raus</small></span>
      <span class="amkz-gv-sumbar" title="${num(done)} von ${num(rows.length)} geprüft"><i style="width:${pct}%"></i></span>
      <span class="amkz-gv-mut" style="font-size:.78rem">${num(pct)}% durch</span>
    </div>`;
  }

  async function delDeposit(id) {
    const d = findDep(id); if (!d) return;
    const ok = confirm("Eintrag wirklich löschen?\n\n"
      + (d.name || "—") + "  ·  " + (d.email || "")
      + "\n" + (d.casino || "—") + "  ·  " + money(d.amount) + "  ·  " + num(d.tickets) + " Tickets"
      + "\n" + (d.deposit_date || "")
      + "\n\nDie Tickets werden dem Teilnehmer damit abgezogen.");
    if (!ok) return;
    try {
      await gvRpc("deposit_delete", { id, by: meName() });
      AMKZ.modal.close();
      toast("Giveaway", "Eintrag gelöscht.", "success");
      await loadData(true);
    } catch (err) { gvWriteError(err, "Löschen"); }
  }

  /* ---------- Aenderungsverlauf ---------- */
  function logDiff(r) {
    const b = r.data_before || {}, a = r.data_after || {};
    if (r.action === "delete") return `Gelöscht: ${esc(b.casino || "—")} · ${money(b.amount)} · ${num(b.tickets)} Tickets`;
    if (r.action === "status") return `Status: <b>${esc(normStatus(b.status))}</b> → <b>${esc(normStatus(a.status))}</b> · ${esc(b.casino || "—")} · ${num(b.tickets)} Tickets`;
    const cols = [["casino", "Casino", (v) => esc(v || "—")], ["amount", "Betrag", money], ["tickets", "Tickets", num],
      ["status", "Status", (v) => esc(String(v || "OFFEN").toUpperCase())], ["email", "Konto", (v) => esc(v || "")], ["deposit_date", "Datum", (v) => esc(v || "")], ["name", "Name", (v) => esc(v || "")]];
    const parts = cols.filter(([k]) => String(b[k] ?? "") !== String(a[k] ?? ""))
      .map(([k, lbl, f]) => `${lbl}: <b>${f(b[k])}</b> → <b>${f(a[k])}</b>`);
    return parts.length ? parts.join(" · ") : "keine inhaltliche Änderung";
  }
  async function openGvLog() {
    let rows = [];
    try { const r = await gvRpc("log", {}); rows = Array.isArray(r && r.log) ? r.log : []; }
    catch (err) { gvWriteError(err, "Verlauf laden"); return; }
    AMKZ.modal.open(`
      <div class="amkz-modal" style="max-width:760px;width:96vw">
        <div class="amkz-modal-header"><div><h3>🕘 Änderungsverlauf</h3>
          <p>Die letzten ${num(rows.length)} Korrekturen &amp; Löschungen im Gewinnspiel</p></div>
        <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
        ${rows.length ? `<div class="amkz-gv-loglist">${rows.map((r) => `
          <div class="amkz-gv-logitem ${r.action === "delete" ? "del" : ""}">
            <div class="amkz-gv-loghead">
              <strong>${r.action === "delete" ? "🗑 Gelöscht" : r.action === "status" ? "🔖 Status" : "✏️ Korrigiert"} · ${esc(r.email || "")}</strong>
              <span class="amkz-gv-mut">${esc(fmtDate(r.created_at))}${r.changed_by ? " · " + esc(r.changed_by) : ""}</span>
            </div>
            <div class="amkz-gv-mut">${logDiff(r)}</div>
          </div>`).join("")}</div>`
        : `<div class="amkz-gv-empty">Noch nichts korrigiert oder gelöscht.</div>`}
      </div>`);
  }

  /* ================= 🇨🇿 TSCHECHIEN — Wöchentliche Verlosung ================= */
  async function czRpc(action, payload) {
    const { data, error } = await sb().rpc("amk_cz_raffle_admin", { p_token: CZ_RAFFLE_TOKEN, p_action: action, p_payload: payload || {} });
    if (error) throw error;
    return data;
  }
  async function loadCz(force) {
    if (state.cz.loading) return;
    if (state.cz.loaded && !force) return;
    state.cz.loading = true; if (state.tab === "cz") render();
    try {
      const data = await czRpc("all");
      if (!data || data.error) { state.cz.authFail = true; }
      else {
        state.cz.authFail = false;
        state.cz.rows = Array.isArray(data.rows) ? data.rows : [];
        state.cz.stats = data.stats || {};
        if (!state.cz.tplDirty) state.cz.template = { subject: (data.template && data.template.subject) || "", body: (data.template && data.template.body) || "" };
      }
      state.cz.loaded = true; state.cz.rpcMissing = false;
    } catch (err) {
      const msg = String((err && err.message) || "");
      state.cz.rpcMissing = /not exist|not found|schema cache|amk_cz_raffle_admin|function/i.test(msg);
      state.cz.loadError = msg; state.cz.loaded = true;
    }
    state.cz.loading = false;
    if (state.tab === "cz") render();
  }
  const fillTpl = (t, row) => String(t || "").replace(/\{email\}/g, row.email || "").replace(/\{name\}/g, row.name || "");
  function czFilteredRows() {
    const q = state.q.trim().toLowerCase();
    let rows = state.cz.rows;
    if (state.status === "OPEN") rows = rows.filter((r) => !r.sent_at);
    else if (state.status === "SENT") rows = rows.filter((r) => r.sent_at);
    if (q) rows = rows.filter((r) => `${r.email || ""} ${r.name || ""}`.toLowerCase().includes(q));
    return rows;
  }
  function czTable(rows) {
    if (!rows.length) return `<div class="amkz-gv-empty">Noch keine Anmeldungen zur Verlosung.</div>`;
    return `<div class="amkz-gv-tablewrap"><table class="amkz-gv-table">
      <thead><tr><th>Datum</th><th>E-Mail</th><th>Name</th><th>Status</th><th style="text-align:right">Aktion</th></tr></thead>
      <tbody>${rows.map((r) => `<tr>
        <td class="amkz-gv-mut">${esc(fmtDate(r.created_at))}</td>
        <td><strong>${esc(r.email)}</strong></td>
        <td class="amkz-gv-mut">${esc(r.name || "—")}</td>
        <td>${r.sent_at ? `<span class="amkz-gv-pill ok" title="${esc(fmtDate(r.sent_at))}${r.sent_by ? " · " + esc(r.sent_by) : ""}">Kontaktiert</span>` : `<span class="amkz-gv-pill open">Offen</span>`}</td>
        <td style="text-align:right;white-space:nowrap">
          <button type="button" class="amkz-cz-send" data-cz-send="${esc(r.id)}">✉ ${r.sent_at ? "Erneut" : "Senden"}</button>
          ${r.sent_at ? `<button type="button" class="amkz-cz-mini" data-cz-unsend="${esc(r.id)}" title="Als offen markieren">↩</button>` : ""}
          <button type="button" class="amkz-cz-mini del" data-cz-del="${esc(r.id)}" title="Eintrag löschen">🗑</button>
        </td>
      </tr>`).join("")}</tbody></table></div>`;
  }
  function czPanel() {
    if (state.cz.rpcMissing) return czSetupHtml(false);
    if (state.cz.authFail) return czSetupHtml(true);
    if (!state.cz.loaded) return `<div class="amkz-gv-empty">Lädt Verlosungs-Anmeldungen …</div>`;
    const t = state.cz.template || {};
    return `${czTable(czFilteredRows())}
      <div class="amkz-cz-tpl">
        <div class="amkz-cz-tpl-head">
          <strong>✉ E-Mail-Vorlage (wird beim „Senden" verschickt)</strong>
          <small class="amkz-gv-mut">Platzhalter <code>{email}</code> &amp; <code>{name}</code> werden pro Empfänger ersetzt.</small>
        </div>
        <input id="amkzCzTplSubject" class="amkz-cz-tpl-subject" type="text" placeholder="Betreff" value="${esc(t.subject || "")}">
        <textarea id="amkzCzTplBody" class="amkz-cz-tpl-body" rows="9" placeholder="Text der E-Mail…">${esc(t.body || "")}</textarea>
        <div class="amkz-cz-tpl-foot">
          <button type="button" class="amkz-gv-btn" id="amkzCzTplSave">Vorlage speichern</button>
          <span class="amkz-gv-mut" style="font-size:.78rem">Wird für alle Mitarbeiter gespeichert.</span>
        </div>
      </div>`;
  }
  function czSetupHtml(auth) {
    return `<div class="amkz-gv-setup">
      <h3>⚙️ Einmaliges Setup nötig</h3>
      <p>${auth ? "Das Admin-Token stimmt noch nicht mit der Datenbank überein." : "Die Verlosungs-Anmeldungen können noch nicht gelesen werden."}
      Führe die Datei <code>supabase-cz-raffle.sql</code> einmal im Supabase&nbsp;→&nbsp;SQL-Editor aus.</p>
      ${state.cz.loadError ? `<p class="amkz-gv-mut" style="font-size:.8rem">Technisch: ${esc(state.cz.loadError)}</p>` : ""}
      <button type="button" class="amkz-gv-btn" id="amkzCzRetry" style="margin-top:6px">↻ Erneut versuchen</button>
    </div>`;
  }
  async function czSend(id) {
    const row = state.cz.rows.find((r) => r.id === id); if (!row) return;
    const subject = (byId("amkzCzTplSubject")?.value || state.cz.template.subject || "").trim();
    const body = fillTpl(byId("amkzCzTplBody")?.value || state.cz.template.body || "", row);
    if (!body) { toast("Verlosung", "Der Vorlagentext ist leer.", "error"); return; }
    const btn = byId("amkzGiveawayRoot")?.querySelector(`[data-cz-send="${CSS.escape(id)}"]`);
    if (btn) { btn.disabled = true; btn.textContent = "Sendet …"; }
    try {
      const { url, key } = czFnBase();
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", apikey: key, Authorization: "Bearer " + key },
        body: JSON.stringify({ action: "send", token: CZ_RAFFLE_TOKEN, id, email: row.email, subject, body, by: meName() }),
      }).then((r) => r.json()).catch(() => ({}));
      if (res && res.ok) { toast("Verlosung", "E-Mail an " + row.email + " gesendet ✓", "success"); await loadCz(true); return; }
      // Kein Resend-Key ODER Function fehlt → Mail-App-Fallback
      await czMailto(row, subject, body, res && res.needsConfig);
    } catch (err) {
      await czMailto(row, subject, body, true);
    } finally {
      if (state.tab === "cz") render();
    }
  }
  async function czMailto(row, subject, body, cfg) {
    const href = "mailto:" + encodeURIComponent(row.email) + "?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body);
    try { window.location.href = href; } catch (_) {}
    toast("Verlosung", cfg ? "Auto-Versand noch nicht eingerichtet — Mail-App geöffnet, nur noch senden klicken." : "Mail-App geöffnet — im Programm auf senden klicken.", "info");
    try { await czRpc("mark_sent", { id: row.id, by: meName() }); await loadCz(true); } catch (_) {}
  }
  async function czSaveTpl() {
    const subject = (byId("amkzCzTplSubject")?.value || "").trim();
    const body = byId("amkzCzTplBody")?.value || "";
    try {
      await czRpc("template_set", { subject, body, by: meName() });
      state.cz.template = { subject, body }; state.cz.tplDirty = false;
      toast("Verlosung", "Vorlage gespeichert ✓", "success");
      const b = byId("amkzCzTplSave"); if (b) b.textContent = "Gespeichert ✓";
    } catch (err) { toast("Verlosung", "Speichern fehlgeschlagen: " + ((err && err.message) || ""), "error"); }
  }
  async function czDelete(id) {
    const row = state.cz.rows.find((r) => r.id === id); if (!row) return;
    if (!confirm("Eintrag „" + row.email + "\" wirklich löschen?")) return;
    try { await czRpc("delete", { id }); await loadCz(true); toast("Verlosung", "Eintrag gelöscht."); }
    catch (err) { toast("Verlosung", "Löschen fehlgeschlagen.", "error"); }
  }
  async function czUnsend(id) { try { await czRpc("unsend", { id }); await loadCz(true); } catch (_) {} }
  function bindCzButtons() {
    const root = byId("amkzGiveawayRoot"); if (!root) return;
    root.querySelectorAll("[data-cz-send]").forEach((b) => b.addEventListener("click", () => czSend(b.dataset.czSend)));
    root.querySelectorAll("[data-cz-unsend]").forEach((b) => b.addEventListener("click", () => czUnsend(b.dataset.czUnsend)));
    root.querySelectorAll("[data-cz-del]").forEach((b) => b.addEventListener("click", () => czDelete(b.dataset.czDel)));
  }

  /* ---------- Tab „Ticket-Boost" ---------- */
  function boostPanel() {
    if (!AMKZ.boost) {
      return `<div class="amkz-gv-setup"><h3>Boost-Modul nicht geladen</h3>
        <p>Die Datei <code>amk-zentrale.js</code> ist nicht vollständig geladen. Seite einmal neu laden.</p></div>`;
    }
    if (state.boostLoading && !AMKZ.boost.data) return `<div class="amkz-gv-empty">Boost-Einstellungen werden geladen…</div>`;
    return `<div class="amkz-gv-boostwrap">${AMKZ.boost.html()}</div>`;
  }
  async function loadBoostTab(force) {
    if (!AMKZ.boost) return;
    AMKZ.boost.onChange = () => { if (state.tab === "boost") render(); };
    state.boostLoading = true; render();
    try { await AMKZ.boost.load(force); } finally { state.boostLoading = false; }
    render();
  }

  function render() {
    const root = byId("amkzGiveawayRoot"); if (!root) return;
    ensureStyle();

    // Der Boost-Tab hängt an der Edge Function, nicht am Admin-RPC —
    // er bleibt auch bedienbar, wenn die Teilnehmer-Tabellen noch klemmen.
    if (state.tab !== "boost") {
      if (state.rpcMissing || (state.loadError && !state.loaded)) {
        root.innerHTML = setupHtml(); return;
      }
      if (!state.loaded && state.loading) {
        root.innerHTML = `<div class="amkz-gv-card"><div class="amkz-gv-empty">Lädt Gewinnspiel-Daten …</div></div>`; return;
      }
      if (state.authFail) { root.innerHTML = setupHtml(true); return; }
    }

    const s = state.stats || {};
    const isAcc = state.tab === "accounts";
    const isCz = state.tab === "cz";
    const isBoost = state.tab === "boost";
    const uRows = filteredUsers(), dRows = filteredDeposits();
    const cz = state.cz.stats || {};
    const czRows = isCz ? czFilteredRows() : [];

    const flt = filterActive();
    const k = depKpis(dRows); // KPIs aus dem GEFILTERTEN Zeitraum/Casino/Suche
    const suf = flt ? " · gefiltert" : "";
    const bst = (AMKZ.boost && AMKZ.boost.data) || null;
    const bstState = (bst && bst.state) || {};
    const kpis = isBoost ? `
      <div class="amkz-gv-kpi"><small>Boost-Status</small><strong style="font-size:1.15rem">${bstState.active ? "🔥 läuft" : bstState.window_open ? "Fenster offen" : "wartet"}</strong></div>
      <div class="amkz-gv-kpi"><small>Scharfe Casinos</small><strong>${num((bstState.active_casinos || []).length)}</strong></div>
      <div class="amkz-gv-kpi"><small>Höchster Faktor</small><strong>${bst ? num(bstState.multiplier) + "×" : "—"}</strong></div>
      <div class="amkz-gv-kpi"><small>Extra-Punkte gesamt</small><strong>${num((bst && bst.totalExtra) || 0)}</strong></div>`
    : isCz ? `
      <div class="amkz-gv-kpi"><small>Anmeldungen</small><strong>${num(cz.total)}</strong></div>
      <div class="amkz-gv-kpi"><small>Kontaktiert</small><strong>${num(cz.sent)}</strong></div>
      <div class="amkz-gv-kpi"><small>Offen</small><strong>${num(cz.open)}</strong></div>
      <div class="amkz-gv-kpi"><small>Diese Woche</small><strong>${num(cz.this_week)}</strong></div>`
    : `
      <div class="amkz-gv-kpi"><small>${flt ? "Einzahlungen" + suf : "Teilnehmer"}</small><strong>${flt ? num(k.count) : num(s.participants)}</strong></div>
      <div class="amkz-gv-kpi"><small>Aktive Einzahler${suf}</small><strong>${num(flt ? k.einzahler : s.active_depositors)}</strong></div>
      <div class="amkz-gv-kpi"><small>Einzahlungen gesamt${suf}</small><strong>${money(flt ? k.betrag : s.total_deposits)}</strong></div>
      <div class="amkz-gv-kpi"><small>Tickets gesamt${suf}</small><strong>${num(flt ? k.tickets : s.total_tickets)}</strong>${(!flt && Number(s.blocked_tickets) > 0) ? `<em class="amkz-gv-kpinote">⛔ ${num(s.blocked_tickets)} gesperrt · ${num(s.valid_tickets)} gültig</em>` : ""}</div>`;

    const searchPh = isCz ? "Suchen: E-Mail, Name …" : "Suchen: Name, E-Mail" + (isAcc ? ", Username" : ", Casino") + " …"; /* Nachtschicht 31.10. (#83) */
    const statusSel = isBoost ? "" : isCz ? `<select id="amkzGvStatus" class="amkz-gv-status">
            <option value="">Alle</option>
            <option value="OPEN" ${state.status === "OPEN" ? "selected" : ""}>Offen</option>
            <option value="SENT" ${state.status === "SENT" ? "selected" : ""}>Kontaktiert</option>
          </select>`
      : (!isAcc ? `<select id="amkzGvStatus" class="amkz-gv-status">
            <option value="">Alle Status</option>
            ${GV_STATES.map((o) => `<option value="${esc(o)}" ${state.status === o ? "selected" : ""}>${esc(GV_STATE_META[o].icon + " " + (o === "OFFEN" ? "Offen" : o === "GEPRÜFT" ? "Geprüft" : "Gesperrt"))}</option>`).join("")}
          </select>` : "");
    const countTxt = isBoost ? ((bstState.active_casinos || []).length ? "scharf: " + (bstState.active_casinos || []).join(", ") : "kein Casino scharf")
      : isCz ? num(czRows.length) + (czRows.length === 1 ? " Anmeldung" : " Anmeldungen") : (isAcc ? num(uRows.length) + (uRows.length === 1 ? " Account" : " Accounts") : num(dRows.length) + (dRows.length === 1 ? " Eintrag" : " Einträge"));
    const content = isBoost ? boostPanel() : isCz ? czPanel() : (isAcc ? usersTable(uRows) : depositsTable(dRows));

    const fmtDay = (iso) => { const m = String(iso || "").match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? m[3] + "." + m[2] + "." + m[1] : iso; };
    const casinoSel = (isCz || isBoost) ? "" : `<select id="amkzGvCasino" class="amkz-gv-status" aria-label="Casino">
            <option value="">Alle Casinos</option>
            ${casinoList().map((c) => `<option value="${esc(c)}" ${state.casino === c ? "selected" : ""}>${esc(c)}</option>`).join("")}
          </select>`;
    const fParts = [];
    if (rangeFrom() && rangeTo()) fParts.push(`📅 ${fmtDay(rangeFrom())} – ${fmtDay(rangeTo())}`);
    if (state.casino) fParts.push(`🎰 ${esc(state.casino)}`);
    const filterBar = (!isCz && !isBoost && flt) ? `<div class="amkz-gv-filterbar"><span>Gefiltert: <b>${fParts.join(" · ")}</b></span><button type="button" class="amkz-gv-reset" id="amkzGvReset">✕ Filter zurücksetzen</button></div>` : "";

    root.innerHTML = `
      <div class="amkz-gv-kpis">${kpis}</div>
      <div class="amkz-gv-card">
        <div class="amkz-gv-toolbar">
          <div class="amkz-gv-tabs">
            <button type="button" class="amkz-gv-tab ${isAcc ? "active" : ""}" data-gv-tab="accounts">Accounts</button>
            <button type="button" class="amkz-gv-tab ${state.tab === "tickets" ? "active" : ""}" data-gv-tab="tickets">Tickets / Einzahlungen</button>
            <button type="button" class="amkz-gv-tab ${isCz ? "active" : ""}" data-gv-tab="cz">CZ-Verlosung</button>
            <button type="button" class="amkz-gv-tab ${isBoost ? "active" : ""}" data-gv-tab="boost">Ticket-Boost</button>
          </div>
          ${isBoost ? "" : `<div class="amkz-gv-search"><input id="amkzGvSearch" type="text" placeholder="${searchPh}" value="${esc(state.q)}"></div>`}
          ${casinoSel}
          ${statusSel}
          ${(!isBoost && !isCz && !isAcc && canEdit()) ? `<button type="button" class="amkz-gv-btn" id="amkzGvLog">🕘 Verlauf</button>` : ""}
          ${isBoost ? "" : `<button type="button" class="amkz-gv-btn" id="amkzGvCsv">⬇ CSV</button>`}
          <button type="button" class="amkz-gv-btn" id="amkzGvRefresh">${(isBoost ? state.boostLoading : isCz ? state.cz.loading : state.loading) ? "…" : "↻"} Aktualisieren</button>
          <span class="amkz-gv-count">${countTxt}</span>
        </div>
        ${filterBar}
        ${(!isAcc && !isCz && !isBoost && dRows.length) ? statusSummary(dRows) : ""}
        ${content}
      </div>`;

    wire();
  }

  function setupHtml(auth) {
    return `<div class="amkz-gv-setup">
      <h3>⚙️ Einmaliges Setup nötig</h3>
      <p>${auth
        ? "Die Datenbank kennt noch das <strong>alte</strong> Admin-Token (am 03.09. getauscht, weil das alte öffentlich lag)."
        : "Die Zentrale kann die Gewinnspiel-Daten noch nicht lesen."}
      Führe die Datei <code>supabase-giveaway-edit.sql</code> einmal im Supabase&nbsp;→&nbsp;SQL-Editor aus — sie legt die Admin-Funktion mit dem aktuellen Token neu an.</p>
      <p>Danach erscheinen hier <strong>alle Accounts, Tickets &amp; Einzahlungen</strong> live (ohne Passwörter). <code>supabase-giveaway-admin.sql</code> ist nur noch ein Verweis und legt die Funktion nicht mehr an.</p>
      ${state.loadError ? `<p class="amkz-gv-mut" style="font-size:.8rem">Technisch: ${esc(state.loadError)}</p>` : ""}
      <button type="button" class="amkz-gv-btn" id="amkzGvRetry" style="margin-top:6px">↻ Erneut versuchen</button>
    </div>`;
  }

  function openDrill(email) {
    const u = state.users.find((x) => String(x.email || "").toLowerCase() === String(email).toLowerCase());
    const deps = state.deposits.filter((d) => String(d.email || "").toLowerCase() === String(email).toLowerCase());
    const name = (u && u.name) || (deps[0] && deps[0].name) || email;
    AMKZ.modal.open(`<div class="amkz-modal" style="max-width:720px;width:96vw">
      <div class="amkz-modal-header"><div class="amkz-gv-dd-head">
        <h3 style="margin:0">${esc(name)}</h3>
        <small class="amkz-gv-mut">${esc(email)}${u && u.username ? " · @" + esc(u.username) : ""}</small>
      </div><button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
      <div class="amkz-gv-dd-stats">
        <div class="amkz-gv-dd-stat"><strong>${num(deps.length)}</strong><small>Einzahlungen</small></div>
        <div class="amkz-gv-dd-stat"><strong>${money(deps.reduce((a, d) => a + Number(d.amount || 0), 0))}</strong><small>Summe</small></div>
        <div class="amkz-gv-dd-stat"><strong>${num(deps.reduce((a, d) => a + Number(d.tickets || 0), 0))}</strong><small>Tickets</small></div>
        <div class="amkz-gv-dd-stat"><strong>${esc(u && gvReg(u) || "—")}</strong><small>Registriert</small></div>
      </div>
      ${pwHtml(u, email)}
      <div class="amkz-gv-dd-sec">Alle Einzahlungen <span class="amkz-gv-dd-cnt">${num(deps.length)}</span></div>
      <div class="amkz-gv-ddscroll">${depositsTable(deps, true)}</div>
    </div>`);
    bindRows(byId("amkzModalOverlay"));
    pwWire(u, email);
  }
  AMKZ.giveawayAkte = openDrill;   // Konto-Akte von aussen oeffnen (Meldungen, Anfragen, Pruefungen)

  /* ---------- Zugang: Passwort zuruecksetzen (13.09.) ----------
     Passwoerter liegen seit der Absicherung nur als Hash vor — ansehen geht nicht mehr. Bei
     „Passwort vergessen" setzt das Team hier ein neues; es kommt einmal im Klartext zurueck
     (Function giveaway, Aktion password_reset, Hub-Sitzung wie beim Boost) und laesst sich
     samt fertiger Nachricht an den Spieler kopieren. */
  function pwDarf() { const p = (AMKZ.state && AMKZ.state.permissions) || {}; return p.isAdmin === true || p.finance === true || p.team === true; }
  function pwHtml(u, email) {
    if (!pwDarf()) return "";
    return `<div class="amkz-gv-dd-sec">Zugang <span class="amkz-gv-mut">Passwort liegt nur als Hash vor · ansehen geht nicht, neu setzen schon</span></div>
      <div class="amkz-gv-pw" id="amkzGvPw">
        <div class="amkz-gv-pw-zeile">
          <input id="amkzGvPwNeu" placeholder="Neues Passwort · leer = automatisch erzeugen" autocomplete="off" spellcheck="false">
          <button type="button" class="amkz-gv-btn" id="amkzGvPwWuerfel" title="Vorschlag erzeugen">🎲</button>
          <button type="button" class="amkz-gv-btn amkz-gv-btn-gold" id="amkzGvPwSetzen">🔑 Passwort zurücksetzen</button>
        </div>
        <div id="amkzGvPwErgebnis" class="amkz-gv-pw-ergebnis" hidden></div>
      </div>`;
  }
  function pwVorschlag() { const z = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789"; const r = new Uint8Array(10); crypto.getRandomValues(r); return Array.from(r, (b) => z[b % z.length]).join(""); }
  async function gvFn(payload) {
    const root = byId("amkzApp"); const url = (root?.dataset?.supabaseUrl || "").replace(/\/$/, "") + "/functions/v1/giveaway"; const key = root?.dataset?.supabaseKey || "";
    const ruf = async () => { const r = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json", apikey: key, Authorization: "Bearer " + key }, body: JSON.stringify(Object.assign({ admin_token: localStorage.getItem("amkch_token") || "" }, payload)) }); return r.json().catch(() => ({})); };
    let d = await ruf();
    if (d && (d.code === "UNAUTHORIZED" || /Nicht angemeldet/.test(String(d.message || "")))) {
      localStorage.removeItem("amkch_token");
      if (AMKZ.boost && AMKZ.boost.anmelden && await AMKZ.boost.anmelden()) d = await ruf();
      else return { status: "error", message: "Ohne Team-Anmeldung geht das nicht." };
    }
    return d;
  }
  function pwWire(u, email) {
    const setzen = byId("amkzGvPwSetzen"); if (!setzen) return;
    const feld = byId("amkzGvPwNeu"), out = byId("amkzGvPwErgebnis");
    byId("amkzGvPwWuerfel").addEventListener("click", () => { feld.value = pwVorschlag(); feld.focus(); });
    setzen.addEventListener("click", async () => {
      const pw = feld.value.trim();
      if (pw && pw.length < 6) { toast("Passwort", "Mindestens 6 Zeichen.", "error"); return; }
      if (!confirm(`Neues Passwort für ${email} setzen? Das alte gilt danach nicht mehr.`)) return;
      setzen.disabled = true; setzen.textContent = "Setzt …";
      try {
        const d = await gvFn({ action: "password_reset", email, password: pw || undefined });
        if (!d || d.status !== "success") throw new Error((d && d.message) || "Fehlgeschlagen");
        const name = d.name || d.username || email;
        const nachricht = `Hallo ${name}, hier ist dein neues Passwort für das 300K-Giveaway: ${d.password}\nAnmeldung mit deiner E-Mail ${email} auf nouri-amk.com. Bitte nach dem Einloggen nicht weitergeben.`;
        out.hidden = false;
        out.innerHTML = `<div class="amkz-gv-pw-neu"><small>Neues Passwort · nur jetzt sichtbar</small><code id="amkzGvPwWert">${esc(d.password)}</code>
          <div class="amkz-gv-pw-knoepfe"><button type="button" class="amkz-gv-btn" data-pw-kopie="pw">Passwort kopieren</button><button type="button" class="amkz-gv-btn" data-pw-kopie="text">Nachricht an Spieler kopieren</button></div></div>`;
        out.querySelectorAll("[data-pw-kopie]").forEach((b) => b.addEventListener("click", () => {
          const t = b.getAttribute("data-pw-kopie") === "pw" ? d.password : nachricht;
          (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(() => toast("Kopiert", b.getAttribute("data-pw-kopie") === "pw" ? "Passwort in der Zwischenablage." : "Nachricht in der Zwischenablage."), () => prompt("Zum Kopieren:", t));
        }));
        feld.value = "";
        toast("Passwort gesetzt", `${name} kann sich jetzt mit dem neuen Passwort anmelden.`);
      } catch (e) { toast("Passwort", e.message, "error"); }
      setzen.disabled = false; setzen.textContent = "🔑 Passwort zurücksetzen";
    });
  }

  function toCsv(rows, cols) {
    const head = cols.map((c) => c[1]).join(";");
    const body = rows.map((r) => cols.map((c) => `"${String(r[c[0]] ?? "").replace(/"/g, '""')}"`).join(";")).join("\n");
    return head + "\n" + body;
  }
  function download(name, text) {
    const blob = new Blob(["﻿" + text], { type: "text/csv;charset=utf-8" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = name; a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 2000);
  }

  // KPIs live aktualisieren, ohne die ganze View neu zu zeichnen (Fokus im Suchfeld bleibt)
  function patchKpis() {
    const root = byId("amkzGiveawayRoot"); if (!root || state.tab === "cz") return;
    const flt = filterActive(); const suf = flt ? " · gefiltert" : "";
    const k = depKpis(filteredDeposits()); const s = state.stats || {};
    const kp = root.querySelectorAll(".amkz-gv-kpis .amkz-gv-kpi");
    if (kp.length < 4) return;
    const set = (i, label, val) => { const sm = kp[i].querySelector("small"), st = kp[i].querySelector("strong"); if (sm) sm.textContent = label; if (st) st.textContent = val; };
    set(0, flt ? "Einzahlungen" + suf : "Teilnehmer", flt ? num(k.count) : num(s.participants));
    set(1, "Aktive Einzahler" + suf, num(flt ? k.einzahler : s.active_depositors));
    set(2, "Einzahlungen gesamt" + suf, money(flt ? k.betrag : s.total_deposits));
    set(3, "Tickets gesamt" + suf, num(flt ? k.tickets : s.total_tickets));
  }

  function wire() {
    const root = byId("amkzGiveawayRoot"); if (!root) return;
    root.querySelector("#amkzGvRetry")?.addEventListener("click", () => loadData(true));
    root.querySelector("#amkzCzRetry")?.addEventListener("click", () => loadCz(true));
    root.querySelector("#amkzGvRefresh")?.addEventListener("click", () =>
      state.tab === "boost" ? loadBoostTab(true) : state.tab === "cz" ? loadCz(true) : loadData(true));
    root.querySelectorAll("[data-gv-tab]").forEach((b) => b.addEventListener("click", () => {
      if (state.tab === b.dataset.gvTab) return;
      state.tab = b.dataset.gvTab; state.q = ""; state.status = "";
      render();
      if (state.tab === "cz") loadCz(false);
      if (state.tab === "boost" && !AMKZ.boost?.data) loadBoostTab(false);
    }));
    const search = root.querySelector("#amkzGvSearch");
    if (search) search.addEventListener("input", () => {
      state.q = search.value;
      state.zeige = BLOCK;   // neue Suche -> wieder beim ersten Block anfangen
      // nur die Tabelle neu zeichnen, Fokus behalten
      const isAcc = state.tab === "accounts", isCz = state.tab === "cz";
      const wrap = root.querySelector(".amkz-gv-tablewrap"); const cnt = root.querySelector(".amkz-gv-count");
      const rows = isCz ? czFilteredRows() : (isAcc ? filteredUsers() : filteredDeposits());
      const html = isCz ? czTable(rows) : (isAcc ? usersTable(rows) : depositsTable(rows));
      if (wrap) wrap.outerHTML = html; else { const empty = root.querySelector(".amkz-gv-empty"); if (empty) empty.outerHTML = html; }
      if (cnt) cnt.textContent = isCz ? num(rows.length) + (rows.length === 1 ? " Anmeldung" : " Anmeldungen") : (isAcc ? num(rows.length) + (rows.length === 1 ? " Account" : " Accounts") : num(rows.length) + (rows.length === 1 ? " Eintrag" : " Einträge"));
      const sum = root.querySelector("#amkzGvStatusSum");
      if (sum && !isCz && !isAcc) sum.outerHTML = statusSummary(rows);
      if (!isCz) patchKpis();
      if (isCz) bindCzButtons(); else { bindRows(); bindMehr(); }
    });
    // Casino-Filter -> volle Neuberechnung (KPIs + Tabelle + Statuszeile)
    root.querySelector("#amkzGvCasino")?.addEventListener("change", (e) => { state.casino = e.target.value; state.zeige = BLOCK; render(); });
    // Filter zurücksetzen (auch den globalen Zeitraum oben rechts)
    root.querySelector("#amkzGvReset")?.addEventListener("click", () => {
      state.casino = ""; state.q = ""; state.zeige = BLOCK;
      if (AMKZ.state) { AMKZ.state.rangeFrom = null; AMKZ.state.rangeTo = null; }
      const f = byId("amkzDateFromFinal"), t = byId("amkzDateToFinal"); if (f) f.value = ""; if (t) t.value = "";
      render();
    });
    root.querySelector("#amkzGvStatus")?.addEventListener("change", (e) => { state.status = e.target.value; state.zeige = BLOCK; render(); });
    root.querySelector("#amkzGvLog")?.addEventListener("click", openGvLog);
    root.querySelector("#amkzGvCsv")?.addEventListener("click", () => {
      if (state.tab === "cz") download("verlosung-cz.csv", toCsv(czFilteredRows(), [["created_at", "Datum"], ["email", "E-Mail"], ["name", "Name"], ["sent_at", "Kontaktiert"], ["sent_by", "Von"]]));
      else if (state.tab === "accounts") download("giveaway-accounts.csv", toCsv(filteredUsers(), [["name", "Name"], ["email", "E-Mail"], ["username", "Username"], ["deposit_count", "Einzahlungen"], ["total_amount", "Summe"], ["total_tickets", "Tickets"], ["registered_at", "Registriert"]]));
      else download("giveaway-tickets.csv", toCsv(filteredDeposits(), [["deposit_date", "Datum"], ["name", "Name"], ["email", "E-Mail"], ["casino", "Casino"], ["amount", "Betrag"], ["tickets", "Tickets"], ["status", "Status"]]));
      toast("Export", "CSV heruntergeladen.");
    });
    // CZ: Senden/Löschen + Vorlage
    bindCzButtons();
    root.querySelector("#amkzCzTplSave")?.addEventListener("click", czSaveTpl);
    ["amkzCzTplSubject", "amkzCzTplBody"].forEach((id) => {
      const el = byId(id); if (!el) return;
      el.addEventListener("input", () => { state.cz.tplDirty = true; const b = byId("amkzCzTplSave"); if (b) b.textContent = "Vorlage speichern"; });
    });
    bindRows();
    bindMehr();
  }

  /* Nachladen zeichnet nur die Tabelle neu, nicht die ganze Ansicht — sonst
     springt die Seite beim Nachladen wieder nach oben, genau dahin, wo man
     gerade nicht hinwollte. */
  function bindMehr() {
    const root = byId("amkzGiveawayRoot"); if (!root) return;
    const b = root.querySelector("#amkzGvMehr");
    if (!b) return;
    b.addEventListener("click", () => {
      state.zeige += BLOCK;
      const isAcc = state.tab === "accounts";
      const rows = isAcc ? filteredUsers() : filteredDeposits();
      const wrap = root.querySelector(".amkz-gv-tablewrap");
      if (wrap) wrap.outerHTML = isAcc ? usersTable(rows) : depositsTable(rows);
      bindRows();
      bindMehr();
    });
  }

  function bindRows(scope) {
    const root = scope || byId("amkzGiveawayRoot"); if (!root) return;
    root.querySelectorAll("[data-gv-user]").forEach((tr) => tr.addEventListener("click", () => openDrill(tr.dataset.gvUser)));
    root.querySelectorAll("[data-gv-edit]").forEach((b) => b.addEventListener("click", (e) => { e.stopPropagation(); openDepEdit(b.dataset.gvEdit); }));
    root.querySelectorAll("[data-gv-del]").forEach((b) => b.addEventListener("click", (e) => { e.stopPropagation(); delDeposit(b.dataset.gvDel); }));
    root.querySelectorAll("[data-gv-status]").forEach((b) => b.addEventListener("click", (e) => { e.stopPropagation(); cycleStatus(b.dataset.gvStatus); }));
  }

  // In den View-Wechsel einklinken
  const prev = AMKZ.loadView;
  AMKZ.loadView = async function gvChain(v, o) {
    const r = await prev?.call(this, v, o);
    if (v === "giveaway") setTimeout(() => { render(); loadData(false); }, 60);
    return r;
  };
})();

/* ---------- Chat: WhatsApp-Style Tages-Trenner (Styles) ---------- */
(function () {
  "use strict";
  if (document.getElementById("amk-chatday-style")) return;
  const s = document.createElement("style"); s.id = "amk-chatday-style";
  s.textContent = `
    .amkz-chat-daydivider{display:flex;align-items:center;justify-content:center;margin:16px 0 12px;position:relative}
    .amkz-chat-daydivider::before{content:"";position:absolute;left:0;right:0;top:50%;height:1px;background:rgba(255,255,255,.08)}
    .amkz-chat-daydivider span{position:relative;background:rgba(200,170,110,.14);color:#e9c76a;font-size:.72rem;font-weight:800;letter-spacing:.04em;text-transform:uppercase;padding:5px 14px;border-radius:999px;border:1px solid rgba(200,170,110,.28);backdrop-filter:blur(6px)}
  `;
  document.head.appendChild(s);
})();

/* =====================================================================
   CALL UX v2 — Premium Fullscreen (Zoom/Discord-Niveau, Zentrale-Look)
   Überschreibt das alte Eck-Widget: Vollbild-Bühne, Selbstbild-Kachel,
   gläserne Steuerleiste mit Icon+Label. Reines Design (keine Logik).
   ===================================================================== */
(function () {
  "use strict";
  if (document.getElementById("amk-callux-style")) return;
  const s = document.createElement("style"); s.id = "amk-callux-style";
  s.textContent = `
    /* Vollbild statt 330px-Ecke */
    .amk-call-screen{position:fixed !important;inset:0 !important;right:0 !important;bottom:0 !important;width:100% !important;max-width:none !important;height:100% !important;z-index:2147483000}
    .amk-call-card-final{position:absolute;inset:0;width:100%;height:100%;border-radius:0 !important;border:0 !important;overflow:hidden;display:flex;flex-direction:column;
      background:radial-gradient(120% 90% at 50% -10%, #171a24 0%, #0c0d12 55%, #070709 100%) !important;color:#eee}
    /* Kopfzeile */
    .amk-call-head-final{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:16px 22px;z-index:5;
      background:linear-gradient(180deg,rgba(0,0,0,.5),transparent)}
    .amk-call-id-final{display:flex;align-items:center;gap:12px}
    .amk-call-ava-final{width:42px;height:42px;border-radius:50%;display:grid;place-items:center;font-weight:900;color:#0b0b0d;
      background:linear-gradient(135deg,#f7df97,#c8902b);background-size:cover;background-position:center;font-size:1.05rem}
    #amkCallTitleFinal{font-size:1.05rem;font-weight:800;color:#f4f1ea;display:block}
    #amkCallStatusFinal{font-size:.8rem;color:#8fe3b0;opacity:.9}
    #amkFullscreenFinal{background:rgba(255,255,255,.06) !important;border:1px solid rgba(255,255,255,.12) !important;color:#eee !important;width:42px;height:42px;border-radius:12px}
    /* Bühne */
    .amk-call-body-final{position:relative;flex:1;display:grid !important;place-items:center;min-height:0;overflow:hidden}
    /* Sichtbarkeit steuert die bestehende Logik (amk-audio-only / amk-screen-sharing via revealCallVideo) — hier NUR Größe/Look */
    .amk-video-main-final{position:absolute !important;inset:0 !important;width:100% !important;height:100% !important;aspect-ratio:auto !important;border-radius:0 !important;background:#000 !important}
    .amk-call-screen.amk-screen-sharing .amk-video-main-final{display:grid !important;place-items:center}
    #amkRemoteVideoFinal{width:100%;height:100%;object-fit:contain;background:#000}
    /* Selbstbild-Kachel (Kamera/Screenshare-Vorschau) */
    #amkLocalVideoFinal{position:absolute;right:20px;bottom:120px;width:230px;max-width:34vw;aspect-ratio:16/10;object-fit:cover;
      border-radius:16px;border:2px solid rgba(200,170,110,.55);box-shadow:0 18px 40px -12px rgba(0,0,0,.8);background:#111;z-index:6;display:none}
    .amk-call-screen.amk-selfcam #amkLocalVideoFinal,.amk-call-screen.amk-sharing-self #amkLocalVideoFinal{display:block}
    /* Avatar-Ansicht (Audio-only) */
    .amk-call-screen.amk-audio-only .amk-call-stage-final{position:relative;z-index:2;gap:10px}
    .amk-call-ava-big{width:132px;height:132px;border-radius:50%;display:grid;place-items:center;font-size:3rem;font-weight:900;color:#0b0b0d;
      background:linear-gradient(135deg,#f7df97,#c8902b);background-size:cover;background-position:center;box-shadow:0 0 0 10px rgba(200,170,110,.08),0 20px 60px -18px rgba(0,0,0,.8)}
    #amkCallStageName{font-size:1.5rem;font-weight:800;color:#f4f1ea}
    #amkCallStageStatus{opacity:.6}
    .amk-call-timer{font-variant-numeric:tabular-nums;color:#e9c76a;font-weight:800;letter-spacing:.04em;margin-top:2px}
    .amk-call-participants-final{position:absolute;top:16px;left:50%;transform:translateX(-50%);z-index:5;font-size:.82rem;font-weight:700;color:#cdd3df;
      background:rgba(0,0,0,.4);border:1px solid rgba(255,255,255,.1);padding:6px 14px;border-radius:999px;backdrop-filter:blur(8px)}
    /* Steuerleiste — gläserne Pille, unten zentriert */
    .amk-call-controls-final{position:absolute !important;left:50%;bottom:26px;transform:translateX(-50%);z-index:8;display:flex;gap:10px;
      padding:12px 16px;border-radius:22px;background:rgba(18,19,26,.72);border:1px solid rgba(255,255,255,.1);backdrop-filter:blur(16px);
      box-shadow:0 20px 50px -18px rgba(0,0,0,.85)}
    .amk-call-btn-final{width:auto !important;height:auto !important;border-radius:16px !important;display:flex !important;flex-direction:column;align-items:center;gap:4px;
      min-width:64px;padding:10px 12px !important;cursor:pointer;font:inherit;transition:transform .12s,background .18s,border-color .18s;
      background:rgba(255,255,255,.06) !important;border:1px solid rgba(255,255,255,.1) !important;color:#e9e9ee !important}
    #amkCameraFinal{display:flex !important}
    .amk-call-btn-final .amk-cbi{font-size:20px;line-height:1;display:grid;place-items:center;height:22px}
    .amk-call-btn-final .amk-cbl{font-size:.68rem;font-weight:700;opacity:.75;letter-spacing:.02em}
    .amk-call-btn-final:hover{transform:translateY(-2px);background:rgba(255,255,255,.12) !important}
    .amk-call-btn-final.active{background:rgba(200,170,110,.9) !important;border-color:rgba(200,170,110,1) !important;color:#1a1305 !important}
    .amk-call-btn-final.active .amk-cbl{opacity:.9}
    .amk-call-btn-final.danger,#amkEndCallFinal{background:linear-gradient(135deg,#ef5350,#d61f1f) !important;border:0 !important;color:#fff !important}
    .amk-call-btn-final.danger:hover{filter:brightness(1.08)}
    /* Klick auf Bühne = Vollbild-Cursor */
    .amk-call-screen:not(.amk-audio-only) #amkRemoteVideoFinal{cursor:zoom-in}
    @media(max-width:640px){
      #amkLocalVideoFinal{right:12px;bottom:104px;width:120px}
      .amk-call-controls-final{gap:6px;padding:9px 10px;bottom:16px;border-radius:18px}
      .amk-call-btn-final{min-width:52px;padding:8px 8px !important}
      .amk-call-btn-final .amk-cbl{font-size:.6rem}
      .amk-call-ava-big{width:104px;height:104px;font-size:2.4rem}
    }
  `;
  document.head.appendChild(s);
})();

/* =====================================================================
   FERNSTEUERUNG — Controller-Seite (Zentrale)
   Fragt den AMK-Agent des Gegenübers an -> Freigabe am Ziel-PC -> zeigt
   dessen Bildschirm und sendet Maus/Tastatur über den WebRTC-Datenkanal.
   Gegenstück: /remote-agent (nativer Agent). Setup: supabase-remote.sql.
   ===================================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ; if (!AMKZ || AMKZ.__remoteControl) return; AMKZ.__remoteControl = true;
  const byId = (id) => document.getElementById(id);
  const sb = () => AMKZ.supabase;
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const me = () => AMKZ.state.member || {};
  // Fernsteuerung darf JEDER Mitarbeiter anfragen — der Schutz ist die
  // Freigabe direkt am Ziel-PC (nichts passiert ohne Bestätigung dort).
  const canControl = () => !!(AMKZ.state.member && AMKZ.state.member.id);

  // Nutzt denselben (frisch gefetchten) TURN wie das Call-System.
  const AMK_TURN_STATIC_RC = [
    { urls: "stun:stun.relay.metered.ca:80" },
    { urls: "turn:global.relay.metered.ca:80", username: "050d5fb68925f330a9cb5b99", credential: "hoZmY7sUFB52bW+j" },
    { urls: "turn:global.relay.metered.ca:443", username: "050d5fb68925f330a9cb5b99", credential: "hoZmY7sUFB52bW+j" },
    { urls: "turns:global.relay.metered.ca:443?transport=tcp", username: "050d5fb68925f330a9cb5b99", credential: "hoZmY7sUFB52bW+j" },
  ];
  function rcIce() {
    const turn = (Array.isArray(window.AMK_TURN) && window.AMK_TURN.length) ? window.AMK_TURN : AMK_TURN_STATIC_RC;
    return { iceServers: [{ urls: ["stun:stun.l.google.com:19302", "stun:stun1.l.google.com:19302"] }].concat(turn) };
  }

  const RC = { session: null, pc: null, dc: null, sig: null, sesChan: null, seen: new Set() };

  function ensureStyle() {
    if (byId("amk-rc-style")) return;
    const s = document.createElement("style"); s.id = "amk-rc-style";
    s.textContent = `
      #amkzRcBtn.amkz-icon-btn.on{background:rgba(220,60,60,.2);border-color:rgba(220,60,60,.55)}
      .amkz-rc-overlay{position:fixed;inset:0;z-index:99999;background:#05060a;display:flex;flex-direction:column}
      .amkz-rc-bar{display:flex;align-items:center;gap:12px;padding:10px 16px;background:#0d0f16;border-bottom:1px solid rgba(255,255,255,.08);color:#eee}
      .amkz-rc-bar .dot{width:10px;height:10px;border-radius:50%;background:#e6b85c}
      .amkz-rc-bar.live .dot{background:#dc3c3c;animation:amkRecPulse 1.1s infinite}
      .amkz-rc-bar strong{font-size:.95rem}
      .amkz-rc-bar small{opacity:.6;font-size:.8rem}
      .amkz-rc-spacer{flex:1}
      .amkz-rc-stop{background:#dc3c3c;border:0;color:#fff;font-weight:800;padding:9px 18px;border-radius:11px;cursor:pointer}
      .amkz-rc-hint{background:rgba(200,170,110,.14);color:#f0d488;font-weight:700;padding:6px 12px;border-radius:9px;font-size:.8rem}
      .amkz-rc-stage{flex:1;position:relative;display:grid;place-items:center;overflow:hidden;background:#000}
      .amkz-rc-stage video{max-width:100%;max-height:100%;outline:none;cursor:crosshair}
      .amkz-rc-wait{position:absolute;inset:0;display:grid;place-items:center;color:#aaa;font-size:1rem;text-align:center;padding:24px}
    `;
    document.head.appendChild(s);
  }

  function ensureButton() {
    // Steuer-Button gehört NUR in den Anruf (neben die Call-Controls), Ziel = Gesprächspartner.
    const oldHeader = byId("amkzRcBtn"); if (oldHeader && oldHeader.closest(".amkz-chat-actions")) oldHeader.remove();
    const controls = document.querySelector("#amkCallScreenFinal.active .amk-call-controls-final");
    const inCall = !!controls && !!window.AMK_CALL_PARTNER && canControl();
    let b = byId("amkzRcCallBtn");
    if (!inCall) { if (b) b.remove(); return; }
    if (!b) {
      ensureStyle();
      b = document.createElement("button"); b.id = "amkzRcCallBtn"; b.type = "button"; b.className = "amk-call-btn-final";
      b.title = "Bildschirm des Gegenübers steuern";
      b.innerHTML = '<span class="amk-cbi">🖥️</span><span class="amk-cbl">Steuern</span>';
      b.addEventListener("click", requestControl);
    }
    const endBtn = controls.querySelector("#amkEndCallFinal");
    if (b.parentElement !== controls) controls.insertBefore(b, endBtn || null);
    b.classList.toggle("active", !!RC.session);
  }

  async function requestControl() {
    if (RC.session) return;
    const targetId = window.AMK_CALL_PARTNER || AMKZ.state.currentChatUserId; if (!targetId) return;
    const name = byId("amkCallStageName")?.textContent || byId("amkzChatActiveName")?.textContent || "Mitarbeiter";
    let agent = null;
    try {
      const { data, error } = await sb().from("remote_agents").select("*").eq("team_member_id", targetId).eq("online", true).order("last_seen", { ascending: false }).limit(1);
      if (error) throw error;
      agent = data && data[0];
    } catch (err) {
      const msg = String(err && err.message || "");
      if (/relation|does not exist|schema cache|remote_agents/i.test(msg)) return toast("Setup nötig", "Führe supabase-remote.sql aus, dann Agent installieren.", "error");
      return toast("Fehler", msg, "error");
    }
    if (!agent) return toast("Kein Agent", `${name} hat gerade keinen AMK-Agent online. (Agent installiert & angemeldet?)`, "error");

    let session;
    try {
      const { data, error } = await sb().from("remote_sessions").insert({
        controller_id: me().id || null, controller_name: me().name || me().email || "Zentrale",
        target_member_id: targetId, agent_id: agent.id, status: "requested",
      }).select("*").single();
      if (error) throw error;
      session = data;
    } catch (err) { return toast("Fehler", err.message || "Sitzung fehlgeschlagen", "error"); }

    RC.session = session; RC.seen = new Set();
    openOverlay(name);
    ensureButton();
    // auf Freigabe/Ablehnung warten
    RC.sesChan = sb().channel("rc-ses-" + session.id)
      .on("postgres_changes", { event: "UPDATE", schema: "public", table: "remote_sessions", filter: "id=eq." + session.id }, (p) => {
        const s = p.new; if (!s) return;
        if (s.status === "approved") startPeer(session);
        else if (s.status === "denied") { toast("Abgelehnt", `${name} hat die Steuerung abgelehnt.`); endControl("denied", false); }
        else if (s.status === "ended") endControl("remote_ended", false);
      }).subscribe();
    // Sicherheits-Timeout: keine Reaktion binnen 45s
    RC.timeout = setTimeout(() => { if (RC.session && RC.session.id === session.id && !RC.pc) { toast("Keine Antwort", "Der Agent hat nicht reagiert.", "error"); endControl("timeout", true); } }, 45000);
  }

  async function startPeer(session) {
    if (RC.pc) return;
    setBarLive(false, "verbindet…");
    const pc = new RTCPeerConnection(rcIce()); RC.pc = pc;
    // Eingabe-Kanal (Maus/Tastatur)
    const dc = pc.createDataChannel("input", { ordered: true }); RC.dc = dc;
    dc.onopen = () => attachInput();
    // wir empfangen das Bild
    try { pc.addTransceiver("video", { direction: "recvonly" }); } catch (_) {}
    pc.ontrack = (ev) => { const v = byId("amkzRcVideo"); if (v && ev.streams && ev.streams[0]) { v.srcObject = ev.streams[0]; hideWait(); } };
    pc.onicecandidate = (ev) => { if (ev.candidate) writeSignal(session.id, "controller", "ice", ev.candidate.toJSON()); };
    pc.onconnectionstatechange = () => {
      if (pc.connectionState === "connected") setBarLive(true, "Steuerung aktiv");
      if (["failed", "closed", "disconnected"].includes(pc.connectionState)) endControl("connection_lost", true);
    };
    // Signale vom Agent mithören
    RC.sig = sb().channel("rc-sig-" + session.id)
      .on("postgres_changes", { event: "INSERT", schema: "public", table: "remote_signals", filter: "session_id=eq." + session.id }, (p) => handleSignal(p.new))
      .subscribe();
    // Offer erstellen
    try {
      const offer = await pc.createOffer();
      await pc.setLocalDescription(offer);
      await writeSignal(session.id, "controller", "offer", { type: offer.type, sdp: offer.sdp });
    } catch (err) { toast("Fehler", "Verbindung fehlgeschlagen: " + (err.message || ""), "error"); endControl("offer_failed", true); }
  }

  async function handleSignal(row) {
    if (!row || row.from_role !== "agent" || RC.seen.has(row.id) || !RC.pc) return;
    RC.seen.add(row.id);
    try {
      if (row.kind === "answer") await RC.pc.setRemoteDescription(new RTCSessionDescription(row.payload));
      else if (row.kind === "ice") await RC.pc.addIceCandidate(new RTCIceCandidate(row.payload));
    } catch (_) {}
  }
  async function writeSignal(sid, role, kind, payload) { try { await sb().from("remote_signals").insert({ session_id: sid, from_role: role, kind, payload }); } catch (_) {} }

  /* ---------- Eingabe erfassen und senden ---------- */
  function sendInput(ev) { const dc = RC.dc; if (dc && dc.readyState === "open") { try { dc.send(JSON.stringify(ev)); } catch (_) {} } }
  function normXY(e, v) {
    const r = v.getBoundingClientRect();
    const x = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
    const y = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
    return { x, y };
  }
  function attachInput() {
    const v = byId("amkzRcVideo"); if (!v || v.dataset.inputBound) return; v.dataset.inputBound = "1";
    v.addEventListener("mousemove", (e) => { const p = normXY(e, v); sendInput({ t: "move", x: p.x, y: p.y }); });
    v.addEventListener("mousedown", (e) => { e.preventDefault(); const p = normXY(e, v); sendInput({ t: "down", button: e.button, x: p.x, y: p.y }); });
    v.addEventListener("mouseup", (e) => { e.preventDefault(); const p = normXY(e, v); sendInput({ t: "up", button: e.button, x: p.x, y: p.y }); });
    v.addEventListener("contextmenu", (e) => e.preventDefault());
    v.addEventListener("wheel", (e) => { e.preventDefault(); sendInput({ t: "scroll", dy: Math.sign(e.deltaY) * Math.min(5, Math.ceil(Math.abs(e.deltaY) / 40)) }); }, { passive: false });
    v.tabIndex = 0;
    const keyH = (down) => (e) => { if (!RC.session) return; e.preventDefault(); if (e.key.length === 1 && down && !e.ctrlKey && !e.metaKey) sendInput({ t: "type", text: e.key }); else sendInput({ t: "key", key: e.key, down }); };
    v.addEventListener("keydown", keyH(true));
    v.addEventListener("keyup", keyH(false));
    v.focus();
  }

  /* ---------- Overlay / UI ---------- */
  function openOverlay(name) {
    ensureStyle();
    let ov = byId("amkzRcOverlay");
    if (!ov) { ov = document.createElement("div"); ov.id = "amkzRcOverlay"; ov.className = "amkz-rc-overlay"; document.body.appendChild(ov); }
    ov.innerHTML = `
      <div class="amkz-rc-bar" id="amkzRcBar">
        <span class="dot"></span><strong>Fernsteuerung — ${(AMKZ.utils?.escapeHtml || ((x)=>x))(name)}</strong>
        <small id="amkzRcStatus">wartet auf Freigabe…</small>
        <span class="amkz-rc-spacer"></span>
        <span class="amkz-rc-hint">Klicke ins Bild, um zu steuern</span>
        <button class="amkz-rc-stop" id="amkzRcStop">Steuerung beenden</button>
      </div>
      <div class="amkz-rc-stage">
        <video id="amkzRcVideo" autoplay playsinline></video>
        <div class="amkz-rc-wait" id="amkzRcWait">Warte auf Freigabe am PC von ${(AMKZ.utils?.escapeHtml || ((x)=>x))(name)}…<br><small>Der Kollege muss die Anfrage bestätigen.</small></div>
      </div>`;
    byId("amkzRcStop").addEventListener("click", () => endControl("controller_stopped", true));
  }
  function setBarLive(live, status) { const bar = byId("amkzRcBar"); if (bar) bar.classList.toggle("live", live); const st = byId("amkzRcStatus"); if (st) st.textContent = status; }
  function hideWait() { const w = byId("amkzRcWait"); if (w) w.style.display = "none"; }

  async function endControl(reason, notify) {
    const s = RC.session;
    clearTimeout(RC.timeout);
    try { RC.dc && RC.dc.close(); } catch (_) {}
    try { RC.pc && RC.pc.close(); } catch (_) {}
    try { RC.sig && sb().removeChannel(RC.sig); } catch (_) {}
    try { RC.sesChan && sb().removeChannel(RC.sesChan); } catch (_) {}
    RC.pc = null; RC.dc = null; RC.sig = null; RC.sesChan = null; RC.session = null;
    if (s && notify) { try { await sb().from("remote_sessions").update({ status: "ended", end_reason: reason, ended_at: new Date().toISOString() }).eq("id", s.id); } catch (_) {} }
    const ov = byId("amkzRcOverlay"); if (ov) ov.remove();
    ensureButton();
  }
  AMKZ.remoteControl = { request: requestControl, end: () => endControl("api", true) };

  // Button dauerhaft sicherstellen
  setInterval(ensureButton, 1500);
  const prevLV = AMKZ.loadView;
  AMKZ.loadView = async function rcChain(v, o) { const r = await prevLV?.call(this, v, o); ensureButton(); return r; };
})();

/* =====================================================================
   🔁 STREAM-ÄNDERUNGSANTRÄGE — Dienstplan-Wechsel mit Genehmigung
   Streamer stellt im Streaming-Bereich (Plan) einen Antrag auf Änderung
   (Datum + Schicht + gewünschter neuer Streamer + Grund). Der Owner sieht
   die Anträge in der Streaming-Verwaltung und genehmigt/lehnt ab. Bei
   Genehmigung wird streaming_plan für diesen Tag/Schicht AUTOMATISCH auf
   den neuen Streamer umgestellt. Tabelle: supabase-streaming-changes.sql.
   ===================================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ; if (!AMKZ || AMKZ.__streamChange) return; AMKZ.__streamChange = true;

  const byId = (id) => document.getElementById(id);
  const sb = () => AMKZ.supabase;
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const modal = () => AMKZ.modal;
  const me = () => AMKZ.state.member || {};
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m])));
  const canView = () => AMKZ.state?.permissions?.streaming === true;
  const canManage = () => AMKZ.state?.permissions?.manageStreaming === true;

  const SHIFTS = { early: "Früh (12:00)", late: "Spät (18:00)", prime: "Prime (So)" };
  const store = { team: [], pending: [], recent: [], loaded: false };
  const todayISO = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10) /* Nachtschicht 31.10.: Ortszeit statt UTC */;
  const fmtDay = (v) => { if (!v) return "—"; const d = new Date(v + "T00:00:00"); return isNaN(d) ? String(v) : d.toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit" }); };

  async function loadData() {
    try {
      const [tm, rq] = await Promise.all([
        sb().from("team_members").select("id,name,role,can_manage_streaming,is_active,is_approved").order("name", { ascending: true }),
        sb().from("streaming_change_requests").select("*").order("created_at", { ascending: false }).limit(40),
      ]);
      store.team = (tm.data || []).filter((t) => t.is_active !== false);
      const all = rq.data || [];
      store.pending = all.filter((r) => r.status === "pending");
      store.recent = all.filter((r) => r.status !== "pending").slice(0, 8);
      store.loaded = true;
      return true;
    } catch (e) { return false; }
  }

  function adminIds() {
    const ADMIN = ["admin", "owner", "admin_owner", "ceo", "management", "manager"];
    return store.team.filter((t) => t.is_approved !== false && (t.can_manage_streaming === true || ADMIN.includes(String(t.role || "").toLowerCase()))).map((t) => t.id).filter(Boolean);
  }
  async function pushTo(ids, title, body) {
    for (const id of ids) { if (!id) continue; try { await AMKZ.push?.send?.(id, title, body, { url: "/pages/zentrale", tag: "stream-change" }); } catch (_) {} }
  }
  async function logMessage(kind, title, body) {
    try { await sb().from("streaming_messages").insert({ kind, title, body, created_by: me()?.id || null, created_by_name: me()?.name || me()?.email || "" }); } catch (_) {}
  }

  /* ---------- Antrag stellen (Streamer) ---------- */
  function teamOptions(sel) { return store.team.map((t) => `<option value="${esc(t.id)}" ${t.id === sel ? "selected" : ""}>${esc(t.name)}</option>`).join(""); }

  function openRequestModal() {
    if (!store.team.length) { loadData().then(() => store.team.length ? openRequestModal() : toast("Team fehlt", "Keine Mitarbeiter geladen.", "error")); return; }
    modal().open(`<div class="amkz-modal amkz-sc-modal">
      <div class="amkz-modal-header"><div><h3>🔁 Dienstplan-Änderung beantragen</h3><p>Dein Antrag geht an die Verwaltung zur Genehmigung.</p></div><button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>
      <div class="amkz-sc-form">
        <div class="amkz-sc-row">
          <label>Datum<input type="date" id="scDate" value="${todayISO()}"></label>
          <label>Schicht<select id="scShift">${Object.keys(SHIFTS).map((k) => `<option value="${k}" ${k === "late" ? "selected" : ""}>${SHIFTS[k]}</option>`).join("")}</select></label>
        </div>
        <label>Gewünschter Streamer (übernimmt)<select id="scNew">${teamOptions(me()?.id)}</select></label>
        <label>Uhrzeit (optional)<input type="text" id="scTime" placeholder="z. B. 18:00"></label>
        <label>Grund<textarea id="scReason" rows="3" placeholder="z. B. Arzttermin – Credo übernimmt heute 18 Uhr"></textarea></label>
        <div class="amkz-sc-actions">
          <button type="button" class="amkz-secondary-btn" data-amkz-close-modal>Abbrechen</button>
          <button type="button" class="amkz-primary-btn" id="scSubmit">Antrag senden</button>
        </div>
      </div></div>`);
    byId("scSubmit").addEventListener("click", async () => {
      const date = byId("scDate").value, shift = byId("scShift").value;
      const newId = byId("scNew").value, newName = (store.team.find((t) => t.id === newId) || {}).name || "";
      if (!date) { toast("Fehlt", "Bitte ein Datum wählen.", "error"); return; }
      const payload = {
        plan_date: date, shift, time_label: byId("scTime").value.trim() || null,
        new_person_id: newId || null, new_person: newName, reason: byId("scReason").value.trim() || null,
        status: "pending", requested_by: me()?.id || null, requested_by_name: me()?.name || me()?.email || "",
      };
      try {
        const ins = await sb().from("streaming_change_requests").insert(payload).select("id").maybeSingle();
        if (ins.error) throw ins.error;
        const reqId = ins?.data?.id;
        modal().close();
        toast("Antrag gesendet", "Die Verwaltung wurde benachrichtigt.", "success");
        await logMessage("change_request", "🔁 Änderungsantrag", `${payload.requested_by_name}: ${fmtDay(date)} ${SHIFTS[shift]} → ${newName}${payload.reason ? " · " + payload.reason : ""}`);
        // Connect-Nachricht MIT Genehmigen/Ablehnen-Buttons an die Admins (Marker [[SC:id]])
        const admins = adminIds();
        if (reqId) {
          const body = `🔁 ${payload.requested_by_name} beantragt Streamwechsel: ${fmtDay(date)} · ${SHIFTS[shift]} → ${newName}${payload.reason ? " · " + payload.reason : ""}. [[SC:${reqId}]]`;
          for (const aid of admins) { try { await AMKZ.connectNotify?.(aid, "🔁 Änderungsantrag", body); } catch (_) {} }
        }
        pushTo(admins, "🔁 Neuer Änderungsantrag", `${payload.requested_by_name}: ${fmtDay(date)} · ${SHIFTS[shift]} → ${newName}`);
        loadData().then(ensureUi);
      } catch (e) {
        toast("Fehler", /does not exist|relation|schema cache/i.test(e.message || "") ? "Bitte supabase-streaming-changes.sql ausführen." : (e.message || "Antrag fehlgeschlagen."), "error");
      }
    });
  }

  /* ---------- Genehmigen / Ablehnen (Owner) ---------- */
  async function decide(id, approve) {
    let req = store.pending.find((r) => r.id === id);
    if (!req) { try { const { data } = await sb().from("streaming_change_requests").select("*").eq("id", id).maybeSingle(); req = data; } catch (_) {} }
    if (!req || req.status !== "pending") { if (req && req.status !== "pending") toast("Info", "Antrag wurde bereits bearbeitet.", "error"); return; }
    if (approve) {
      // streaming_plan für Datum + Schicht finden oder anlegen
      try {
        const { data: existing } = await sb().from("streaming_plan").select("id").eq("plan_date", req.plan_date).eq("shift", req.shift).limit(1);
        let planId = null;
        if (existing && existing.length) {
          planId = existing[0].id;
          await sb().from("streaming_plan").update({ person: req.new_person, person_id: req.new_person_id, updated_at: new Date().toISOString() }).eq("id", planId);
        } else {
          const ins = await sb().from("streaming_plan").insert({
            plan_date: req.plan_date, shift: req.shift, person: req.new_person, person_id: req.new_person_id,
            status: req.shift === "prime" ? "prime" : "live", time_label: req.time_label || null,
            created_by: me()?.id || null, created_by_name: me()?.name || me()?.email || "",
          }).select("id").maybeSingle();
          planId = ins?.data?.id || null;
        }
        await sb().from("streaming_change_requests").update({ status: "approved", decided_by: me()?.id || null, decided_by_name: me()?.name || me()?.email || "", decided_at: new Date().toISOString(), plan_id: planId }).eq("id", id);
        toast("Genehmigt ✓", `${req.new_person} ist für ${fmtDay(req.plan_date)} eingesetzt.`, "success");
        await logMessage("change_approved", "✅ Änderung genehmigt", `${fmtDay(req.plan_date)} ${SHIFTS[req.shift]} → ${req.new_person} (Antrag von ${req.requested_by_name || "?"})`);
        pushTo([req.requested_by, req.new_person_id].filter(Boolean), "✅ Dienstplan-Änderung genehmigt", `${fmtDay(req.plan_date)} · ${SHIFTS[req.shift]} → ${req.new_person}`);
        // Streamingplan-Kalender neu einlesen, falls Modul da
        try { AMKZ.loadView && AMKZ.loadView(AMKZ.state.currentView, { force: true }); } catch (_) {}
      } catch (e) { toast("Fehler", e.message || "Genehmigung fehlgeschlagen.", "error"); return; }
    } else {
      try {
        await sb().from("streaming_change_requests").update({ status: "rejected", decided_by: me()?.id || null, decided_by_name: me()?.name || me()?.email || "", decided_at: new Date().toISOString() }).eq("id", id);
        toast("Abgelehnt", "Antrag abgelehnt.", "success");
        pushTo([req.requested_by].filter(Boolean), "❌ Änderungsantrag abgelehnt", `${fmtDay(req.plan_date)} · ${SHIFTS[req.shift]}`);
      } catch (e) { toast("Fehler", e.message || "Ablehnen fehlgeschlagen.", "error"); return; }
    }
    await loadData(); ensureUi();
  }

  /* ---------- UI-Injektion ---------- */
  function requestBtnHtml() {
    return `<div class="amkz-sc-bar" id="amkzScBar">
      <div class="amkz-sc-bar-txt"><strong>🔁 Dienstplan ändern?</strong><span>Stelle einen Antrag auf Streamwechsel – die Verwaltung bestätigt.</span></div>
      <button type="button" class="amkz-sc-req-btn" id="amkzScReqBtn">+ Änderung beantragen</button>
    </div>`;
  }
  function requestsCardHtml() {
    const p = store.pending;
    const rows = p.length ? p.map((r) => `
      <div class="amkz-sc-item">
        <div class="amkz-sc-item-main">
          <strong>${fmtDay(r.plan_date)} · ${SHIFTS[r.shift] || r.shift || ""}${r.time_label ? " · " + esc(r.time_label) : ""}</strong>
          <span>→ <b>${esc(r.new_person || "?")}</b>${r.current_person ? " (statt " + esc(r.current_person) + ")" : ""}</span>
          <small>Antrag von ${esc(r.requested_by_name || "?")}${r.reason ? " · " + esc(r.reason) : ""}</small>
        </div>
        <div class="amkz-sc-item-actions">
          <button type="button" class="amkz-sc-ok" data-sc-ok="${r.id}">✓ Genehmigen</button>
          <button type="button" class="amkz-sc-no" data-sc-no="${r.id}">Ablehnen</button>
        </div>
      </div>`).join("") : `<div class="amkz-sc-empty">Keine offenen Anträge.</div>`;
    const recent = store.recent.length ? `<div class="amkz-sc-recent">${store.recent.map((r) => `<div class="amkz-sc-rec ${r.status}">${r.status === "approved" ? "✅" : "❌"} ${fmtDay(r.plan_date)} ${SHIFTS[r.shift] || ""} → ${esc(r.new_person || "")} <small>${esc(r.requested_by_name || "")}</small></div>`).join("")}</div>` : "";
    return `<div class="amkz-stream-card amkz-sc-card" id="amkzScCard">
      <h3>🔁 Änderungsanträge${p.length ? ` <span class="amkz-sc-badge">${p.length}</span>` : ""}</h3>
      <p class="amkz-stream-sub">Bei „Genehmigen" wird der Dienstplan automatisch auf den neuen Streamer umgestellt.</p>
      <div class="amkz-sc-list">${rows}</div>
      ${recent}
    </div>`;
  }

  function ensureUi() {
    // 26.10.2026: Änderungsanträge aus der Stream-Zentrale entfernt (Marcel). Bestätigen alter Anträge
    // aus dem Chat ([[SC:id]] → AMKZ.streamChangeDecide) funktioniert weiter.
    byId("amkzScBar")?.remove(); byId("amkzScCard")?.remove();
    if (byId("amkzStreamingView")) return;
    const view = byId("amkzStreamingView");
    if (!view || view.classList.contains("is-hidden")) return;

    // 1) Antrag-Button im Plan-Panel (für alle mit Streaming-Recht)
    const planPanel = byId("amkzStreamPlanPanel");
    if (planPanel && !planPanel.classList.contains("is-hidden") && canView()) {
      if (!byId("amkzScBar")) {
        const tmp = document.createElement("div"); tmp.innerHTML = requestBtnHtml();
        planPanel.insertBefore(tmp.firstElementChild, planPanel.firstChild);
        byId("amkzScReqBtn")?.addEventListener("click", () => { if (store.loaded) openRequestModal(); else loadData().then(openRequestModal); });
      }
    }

    // 2) Anträge-Karte in der Verwaltung (nur Owner)
    const managePanel = byId("amkzStreamManagePanel");
    if (managePanel && !managePanel.classList.contains("is-hidden") && canManage()) {
      const html = requestsCardHtml();
      let card = byId("amkzScCard");
      if (card) card.outerHTML = html;
      else { const tmp = document.createElement("div"); tmp.innerHTML = html; managePanel.insertBefore(tmp.firstElementChild, managePanel.firstChild); }
    }
  }

  // Delegierte Klicks für Genehmigen/Ablehnen
  if (!document.body.dataset.amkScBound) {
    document.body.dataset.amkScBound = "1";
    document.addEventListener("click", (e) => {
      const ok = e.target.closest("[data-sc-ok]"); if (ok) { decide(ok.getAttribute("data-sc-ok"), true); return; }
      const no = e.target.closest("[data-sc-no]"); if (no) { if (confirm("Antrag ablehnen?")) decide(no.getAttribute("data-sc-no"), false); return; }
    });
  }

  function ensureStyle() {
    if (byId("amk-sc-style")) return;
    const s = document.createElement("style"); s.id = "amk-sc-style";
    s.textContent = `
      .amkz-sc-bar{display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;background:linear-gradient(135deg,rgba(200,170,110,.14),rgba(255,255,255,.02));border:1px solid rgba(200,170,110,.3);border-radius:16px;padding:14px 18px;margin-bottom:14px}
      .amkz-sc-bar-txt{display:flex;flex-direction:column;gap:2px}
      .amkz-sc-bar-txt strong{font-size:1rem}
      .amkz-sc-bar-txt span{opacity:.6;font-size:.82rem}
      .amkz-sc-req-btn{background:linear-gradient(135deg,#e0b24a,#c8902b);border:0;color:#1a1305;font-weight:900;border-radius:12px;padding:11px 20px;cursor:pointer;font-size:.9rem;white-space:nowrap}
      .amkz-sc-req-btn:hover{filter:brightness(1.07)}
      .amkz-sc-card .amkz-sc-badge{display:inline-block;background:#dc3c3c;color:#fff;font-size:.72rem;font-weight:900;border-radius:999px;padding:2px 9px;margin-left:6px;vertical-align:middle}
      .amkz-sc-list{display:flex;flex-direction:column;gap:9px;margin-top:8px}
      .amkz-sc-item{display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.09);border-radius:13px;padding:12px 15px}
      .amkz-sc-item-main{display:flex;flex-direction:column;gap:2px;min-width:0;flex:1}
      .amkz-sc-item-main strong{font-size:.94rem}
      .amkz-sc-item-main span{font-size:.86rem;opacity:.85}
      .amkz-sc-item-main b{color:#f0d488}
      .amkz-sc-item-main small{opacity:.5;font-size:.78rem}
      .amkz-sc-item-actions{display:flex;gap:8px;flex:none}
      .amkz-sc-ok{background:rgba(80,200,120,.14);border:1px solid rgba(80,200,120,.45);color:#8fe3b0;border-radius:10px;padding:9px 14px;font-weight:800;font-size:.84rem;cursor:pointer}
      .amkz-sc-ok:hover{background:rgba(80,200,120,.24)}
      .amkz-sc-no{background:rgba(220,90,90,.1);border:1px solid rgba(220,90,90,.4);color:#ff9a9a;border-radius:10px;padding:9px 14px;font-weight:700;font-size:.84rem;cursor:pointer}
      .amkz-sc-empty{padding:20px;text-align:center;opacity:.5;font-size:.86rem}
      .amkz-sc-recent{margin-top:12px;border-top:1px solid rgba(255,255,255,.07);padding-top:10px;display:flex;flex-direction:column;gap:5px}
      .amkz-sc-rec{font-size:.8rem;opacity:.65}
      .amkz-sc-rec small{opacity:.6;margin-left:6px}
      .amkz-sc-modal{max-width:500px;width:94vw}
      .amkz-sc-form{display:flex;flex-direction:column;gap:12px;padding:4px 2px}
      .amkz-sc-form label{display:flex;flex-direction:column;gap:5px;font-size:.82rem;font-weight:700;opacity:.85}
      .amkz-sc-form input,.amkz-sc-form select,.amkz-sc-form textarea{background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.14);color:inherit;border-radius:10px;padding:10px 12px;font-size:.92rem;font-family:inherit}
      .amkz-sc-form textarea{resize:vertical}
      .amkz-sc-row{display:grid;grid-template-columns:1fr 1fr;gap:10px}
      .amkz-sc-actions{display:flex;gap:10px;justify-content:flex-end;margin-top:6px}
    `;
    document.head.appendChild(s);
  }

  const prevLV = AMKZ.loadView;
  AMKZ.loadView = async function scChain(v, o) {
    const r = await prevLV?.call(this, v, o);
    if (v === "streaming") { ensureStyle(); if (!store.loaded) await loadData(); setTimeout(ensureUi, 120); setTimeout(ensureUi, 700); }
    return r;
  };
  // Persistenz über Tab-Wechsel im Streaming-Bereich
  setInterval(() => { const view = byId("amkzStreamingView"); if (view && !view.classList.contains("is-hidden")) ensureUi(); }, 1400);
  // Genehmigen/Ablehnen direkt aus der Connect-Nachricht (Marker [[SC:id]])
  AMKZ.streamChangeDecide = (id, approve) => decide(id, approve);
})();

/* =====================================================================
   💬 ANFRAGEN — Support Live-Chat (Backend in der Zentrale)
   Spieler schreiben über "Jetzt chatten" auf der Front; Anfragen landen
   hier, nach LAND aufgeteilt. Nur zugeteilte Mitarbeiter (Recht pro Land)
   sehen & beantworten ihr Land. Zwei-Wege-Echtzeit-Übersetzer für CZ:
   eingehende CZ-Nachricht -> Deutsch für den Mitarbeiter; Antwort Deutsch
   -> Tschechisch an den Spieler. Läuft über Edge Function `support`.
   ===================================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ; if (!AMKZ || AMKZ.__support) return; AMKZ.__support = true;

  const byId = (id) => document.getElementById(id);
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m])));
  const me = () => AMKZ.state.member || {};
  const allowedCountries = () => (AMKZ.state.permissions && AMKZ.state.permissions.supportCountries) || [];
  const allowed = () => AMKZ.state?.permissions?.support === true && allowedCountries().length > 0;

  // MUSS mit ADMIN_TOKEN in supabase/functions/support/index.ts übereinstimmen:
  const SUPPORT_TOKEN = "amk_support_7Kq2Zx9r";
  const MM_EMAIL = "marcelreith2@t-online.de";
  const CLABEL = { CZ: "🇨🇿 Tschechien", DE: "🇩🇪 Deutschland" };

  const state = { requests: [], activeId: null, req: null, msgs: [], filter: "ALL", busy: false, poll: null, tcache: {}, replyTimer: null };

  /* ---------- API ---------- */
  async function api(action, params) {
    const root = byId("amkzApp");
    const url = (root?.dataset?.supabaseUrl || "").replace(/\/$/, "");
    const anon = root?.dataset?.supabaseKey || "";
    const res = await fetch(url + "/functions/v1/support", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + anon, apikey: anon },
      body: JSON.stringify(Object.assign({ action }, params || {})),
    });
    if (!res.ok && res.status === 404) throw new Error("NOT_DEPLOYED");
    return res.json();
  }
  const adm = (action, params) => api(action, Object.assign({ token: SUPPORT_TOKEN, member_id: me().id }, params || {}));

  /* ---------- Übersetzung (MyMemory) ---------- */
  async function translate(text, from, to) {
    const q = String(text || "").trim(); if (!q) return "";
    const key = from + "|" + to + "|" + q;
    if (state.tcache[key]) return state.tcache[key];
    const url = "https://api.mymemory.translated.net/get?q=" + encodeURIComponent(q) + "&langpair=" + encodeURIComponent(from + "|" + to) + (MM_EMAIL ? "&de=" + encodeURIComponent(MM_EMAIL) : "");
    /* Ein fremder Dienst darf die Anfragen nicht lahmlegen. Antwortet er
       nicht, kommt ein leerer Text zurück — die Antwort geht dann eben auf
       Deutsch raus, statt dass gar nichts passiert. */
    try {
      const res = await fetch(url);
      if (!res.ok) return "";
      const data = await res.json();
      let out = (data && data.responseData && data.responseData.translatedText) || "";
      out = out.replace(/^[\s"'\-–—]+/, "").trim();
      if (out && !/MYMEMORY WARNING|QUERY LENGTH/i.test(out)) { state.tcache[key] = out; return out; }
    } catch (_) {}
    return "";
  }

  const fmtWhen = (v) => { if (!v) return ""; const d = new Date(v); return isNaN(d) ? "" : d.toLocaleString("de-DE", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }); };

  /* ---------- Laden ---------- */
  async function loadList() {
    const r = await adm("admin_list");
    if (r && r.ok) state.requests = r.requests || [];
    return r;
  }
  async function openReq(key) {
    state.activeKey = key;
    zeigeGespraech(true);   // auf dem Handy: Liste weg, Gespraech her
    if (String(key).startsWith("email:")) {
      const g = groupRequests(state.requests).find((x) => x.key === key);
      if (!g) return;
      let merged = [], headerReq = null;
      for (const rid of g.reqIds) {
        const r = await adm("admin_messages", { request_id: rid });
        if (r && r.ok) { merged = merged.concat(r.messages || []); if (rid === g.replyRequestId) headerReq = r.request; }
      }
      merged.sort((a, b) => (String(a.created_at) < String(b.created_at) ? -1 : 1));
      state.req = headerReq || g.reqs[0]; state.msgs = merged; state.activeId = g.replyRequestId; state.replyRequestId = g.replyRequestId;
    } else {
      const r = await adm("admin_messages", { request_id: key });
      if (r && r.ok) { state.req = r.request; state.msgs = r.messages || []; }
      state.activeId = key; state.replyRequestId = key;
    }
    renderConversation();
    renderList();
    if (state.req && state.req.country === "CZ") translateIncoming();
  }

  async function translateIncoming() {
    const reqId = state.activeId;
    for (const m of state.msgs.filter((x) => x.sender === "player" && !/^\[img\]/i.test(String(x.body || "")))) {
      const de = await translate(m.body, "cs", "de");
      if (de && state.activeId === reqId) {
        const el = document.querySelector(`[data-msg="${m.id}"] .amkz-sup-trans`);
        if (el) { el.textContent = "🇩🇪 " + de; el.style.display = "block"; }
      }
    }
  }

  /* ---------- Rendering ---------- */
  function countryTabs() {
    const cs = allowedCountries();
    if (cs.length < 2) return "";
    return `<div class="amkz-sup-tabs">
      <button type="button" class="amkz-sup-tab ${state.filter === "ALL" ? "active" : ""}" data-sup-filter="ALL">Alle</button>
      ${cs.map((c) => `<button type="button" class="amkz-sup-tab ${state.filter === c ? "active" : ""}" data-sup-filter="${c}">${CLABEL[c] || c}</button>`).join("")}
    </div>`;
  }
  // Anfragen nach E-Mail gruppieren: gleiche E-Mail = EIN Gespräch im Backend (Spieler sieht nur seine Session)
  function groupRequests(rows) {
    const byEmail = {}, groups = [];
    rows.forEach((r) => {
      const email = String(r.player_email || "").trim().toLowerCase();
      if (email) {
        if (!byEmail[email]) { byEmail[email] = { key: "email:" + email, email, country: r.country, reqs: [] }; groups.push(byEmail[email]); }
        byEmail[email].reqs.push(r);
      } else {
        groups.push({ key: r.id, email: "", country: r.country, reqs: [r] });
      }
    });
    groups.forEach((g) => {
      g.staff_unread = g.reqs.reduce((a, r) => a + (r.staff_unread || 0), 0);
      const latest = g.reqs.slice().sort((a, b) => (String(a.last_message_at) < String(b.last_message_at) ? 1 : -1))[0];
      g.last_message_at = latest.last_message_at; g.subject = latest.subject; g.last_sender = latest.last_sender;
      g.name = latest.player_name || g.reqs[0].player_name; g.status = g.reqs.some((r) => r.status !== "closed") ? "open" : "closed";
      g.replyRequestId = latest.id; g.reqIds = g.reqs.map((r) => r.id);
    });
    groups.sort((a, b) => (String(a.last_message_at) < String(b.last_message_at) ? 1 : -1));
    return groups;
  }
  function listHtml() {
    let rows = state.requests;
    if (state.filter !== "ALL") rows = rows.filter((r) => r.country === state.filter);
    if (!rows.length) return `<div class="amkz-sup-empty">Keine Anfragen.</div>`;
    return groupRequests(rows).map((g) => `
      <button type="button" class="amkz-sup-item ${g.key === state.activeKey ? "active" : ""} ${g.status === "closed" ? "closed" : ""}" data-sup-open="${esc(g.key)}">
        <div class="amkz-sup-item-top">
          <strong>${esc(g.name || "Spieler")}</strong>
          <span class="amkz-sup-flag">${(CLABEL[g.country] || g.country).split(" ")[0]}</span>
          ${g.reqs.length > 1 ? `<span class="amkz-sup-thread">${g.reqs.length}×</span>` : ""}
          ${g.staff_unread > 0 ? `<span class="amkz-sup-dot"></span>` : ""}
        </div>
        <div class="amkz-sup-item-sub">${esc(g.email || (g.subject || "").slice(0, 60) || "—")}</div>
        <div class="amkz-sup-item-meta">${g.last_sender === "player" ? "● " : "✓ "}${fmtWhen(g.last_message_at)}${g.status === "closed" ? " · geschlossen" : ""}</div>
      </button>`).join("");
  }
  function renderList() {
    const el = byId("amkzSupList"); if (el) el.innerHTML = listHtml();
    const cnt = byId("amkzSupCount"); if (cnt) { const open = state.requests.filter((r) => r.status !== "closed").length; cnt.textContent = state.requests.filter((r) => r.status !== "closed" && (r.staff_unread || 0) > 0).length + " ungelesen · " + state.requests.filter((r) => r.status !== "closed" && r.last_sender === "player").length + " unbeantwortet (●) · " + open + " offen"; /* Nachtschicht 31.10.: „0 warten“ neben vielen ● war missverständlich */ }
    updateSupportBadge();
  }
  // Rotes Zähler-Badge am "Anfragen"-Nav-Item (ungelesene Anfragen) — überall sichtbar
  function updateSupportBadge() {
    const nav = document.querySelector('.amkz-nav-item[data-view="support"]'); if (!nav) return;
    const n = (state.requests || []).filter((r) => r.status !== "closed" && (r.staff_unread || 0) > 0).length;
    let b = nav.querySelector(".amkz-nav-badge");
    if (n > 0) { if (!b) { b = document.createElement("span"); b.className = "amkz-nav-badge"; nav.appendChild(b); } b.textContent = n > 9 ? "9+" : String(n); b.style.display = "grid"; }
    else if (b) b.style.display = "none";
  }
  async function pollBadge() {
    if (!allowed() || !me().id) return;
    try { const r = await adm("admin_list"); if (r && r.ok) { state.requests = r.requests || []; updateSupportBadge(); } } catch (_) {}
  }

  function msgHtml(m) {
    const staff = m.sender === "staff";
    const main = staff ? (m.original || m.body) : m.body; // Mitarbeiter sieht bei CZ sein deutsches Original
    const img = /^\[img\](https?:\/\/\S+)/i.exec(String(main || ""));
    const content = img
      ? `<a href="${esc(img[1])}" target="_blank" rel="noopener"><img class="amkz-sup-img" src="${esc(img[1])}" alt="Bild"></a>`
      : `<div class="amkz-sup-text">${esc(main)}</div>`;
    return `<div class="amkz-sup-msg ${staff ? "staff" : "player"}" data-msg="${m.id}">
      <div class="amkz-sup-bubble">
        ${staff && m.original && m.original !== m.body && !img ? `<div class="amkz-sup-sent">➤ ${esc(m.body)}</div>` : ""}
        ${content}
        <div class="amkz-sup-trans" style="display:none"></div>
        <div class="amkz-sup-time">${staff ? esc(m.staff_name || "Support") + " · " : ""}${fmtWhen(m.created_at)}</div>
      </div>
    </div>`;
  }
  /* Auf dem Handy stehen Liste und Gespraech untereinander. Wer dort eine
     Anfrage antippt, sieht erst mal NICHTS passieren: das Gespraech wird weit
     unterhalb der Liste gezeichnet, ausserhalb des Bildschirms. Deshalb hier
     dasselbe Verhalten wie in jedem Messenger — entweder Liste oder Gespraech,
     mit einem Zurueck-Knopf dazwischen. Am Schreibtisch bleibt alles wie es
     war: dort stehen beide Spalten nebeneinander und die Klasse tut nichts. */
  function zeigeGespraech(an) {
    const shell = document.querySelector(".amkz-sup-shell");
    if (shell) shell.classList.toggle("hat-chat", an !== false);
  }
  function zurueckZurListe() {
    zeigeGespraech(false);
    state.activeKey = null;
    state.activeId = null;
    state.req = null;
    renderList();
    const root = byId("amkzSupportRoot");
    if (root && root.scrollIntoView) root.scrollIntoView({ block: "start", behavior: "smooth" });
  }

  function renderConversation() {
    const wrap = byId("amkzSupConv"); if (!wrap) return;
    if (!state.req) { wrap.innerHTML = `<div class="amkz-sup-empty amkz-sup-conv-empty">Wähle links eine Anfrage.</div>`; return; }

    /* Die Abrufschleife zeichnet das Gespräch alle vier Sekunden neu, sobald
       eine Nachricht ankommt — und baut dabei auch das Eingabefeld neu auf.
       Wer gerade eine Antwort tippt, verliert sie mitten im Satz. Deshalb
       wird der Entwurf samt Schreibmarke vorher gesichert.
       Genauso die Leseposition: wer nach oben gescrollt hat, um etwas
       nachzulesen, darf nicht bei jeder neuen Nachricht ans Ende gerissen
       werden. Ans Ende gesprungen wird nur, wer ohnehin schon unten war. */
    const altInput = byId("amkzSupInput");
    const entwurf = altInput ? altInput.value : "";
    const marke = altInput ? altInput.selectionStart : null;
    const hatteFokus = altInput && document.activeElement === altInput;
    const altMsgs = byId("amkzSupMsgs");
    const warUnten = !altMsgs ||
      (altMsgs.scrollHeight - altMsgs.scrollTop - altMsgs.clientHeight) < 60;
    const r = state.req; const isCz = r.country === "CZ";
    wrap.innerHTML = `
      <div class="amkz-sup-conv-head">
        <button type="button" class="amkz-sup-back" id="amkzSupBack" aria-label="Zurück zur Liste">‹</button>
        <div>
          <strong><button type="button" class="amkz-sup-nameopen" data-sup-openperson="1" data-sup-email="${esc(r.player_email || "")}" data-sup-name="${esc(r.player_name || "")}" title="Spielerakte öffnen">${esc(r.player_name || "Spieler")}</button> <span class="amkz-sup-flag">${(CLABEL[r.country] || r.country).split(" ")[0]}</span></strong>
          <small>${esc(r.player_email || "keine E-Mail")}</small>
        </div>
        <div class="amkz-sup-conv-actions">
          <button type="button" class="amkz-sup-btn" id="amkzSupProfile" data-sup-openperson="1" data-sup-email="${esc(r.player_email || "")}" data-sup-name="${esc(r.player_name || "")}">👤 Akte</button>
          <button type="button" class="amkz-sup-btn" id="amkzSupClose">${r.status === "closed" ? "Wieder öffnen" : "Schließen"}</button>
        </div>
      </div>
      <div class="amkz-sup-msgs" id="amkzSupMsgs">${state.msgs.map(msgHtml).join("")}</div>
      <div class="amkz-sup-reply">
        ${isCz ? `<div class="amkz-sup-reply-cz">
            <textarea id="amkzSupInput" rows="2" placeholder="Antwort auf Deutsch – wird automatisch tschechisch gesendet…"></textarea>
            <div class="amkz-sup-preview" id="amkzSupPreview">🇨🇿 Vorschau erscheint hier…</div>
          </div>`
          : `<textarea id="amkzSupInput" rows="2" placeholder="Antwort schreiben…"></textarea>`}
        <button type="button" class="amkz-sup-send" id="amkzSupSend">Senden ➤</button>
      </div>`;
    const msgsEl = byId("amkzSupMsgs");
    if (msgsEl && warUnten) msgsEl.scrollTop = msgsEl.scrollHeight;
    else if (msgsEl && altMsgs) msgsEl.scrollTop = altMsgs.scrollTop;

    const neuInput = byId("amkzSupInput");
    if (neuInput && entwurf) {
      neuInput.value = entwurf;
      if (hatteFokus) {
        neuInput.focus();
        try { neuInput.setSelectionRange(marke, marke); } catch (_) {}
      }
    }

    byId("amkzSupSend")?.addEventListener("click", sendReply);
    byId("amkzSupClose")?.addEventListener("click", toggleClose);
    byId("amkzSupBack")?.addEventListener("click", zurueckZurListe);
    const input = byId("amkzSupInput");
    input?.addEventListener("keydown", (e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendReply(); } });
    if (isCz && input) input.addEventListener("input", () => {
      clearTimeout(state.replyTimer);
      state.replyTimer = setTimeout(async () => {
        const de = input.value.trim(); const prev = byId("amkzSupPreview"); if (!prev) return;
        if (!de) { prev.textContent = "🇨🇿 Vorschau erscheint hier…"; return; }
        const cz = await translate(de, "de", "cs"); prev.textContent = "🇨🇿 " + (cz || "(Übersetzung…)");
      }, 500);
    });
  }

  async function sendReply() {
    if (state.busy || !state.req) return;
    const input = byId("amkzSupInput"); const raw = input ? input.value.trim() : ""; if (!raw) return;
    state.busy = true;
    let body = raw, original = null;
    try {
      /* Die Übersetzung stand früher VOR dem try. Scheiterte sie — Netz weg,
         Dienst überlastet —, sprang der Fehler aus der Funktion heraus und
         das finally lief nie. state.busy blieb auf true und es liess sich bis
         zum Neuladen der Seite keine Antwort mehr senden. */
      if (state.req.country === "CZ") {
        const cz = await translate(raw, "de", "cs");
        if (cz) { body = cz; original = raw; }
      }
      const r = await adm("admin_reply", { request_id: state.replyRequestId || state.activeId, body, original });
      if (r && r.ok) {
        state.msgs.push(r.message);
        if (input) input.value = "";
        const prev = byId("amkzSupPreview"); if (prev) prev.textContent = "🇨🇿 Vorschau erscheint hier…";
        renderConversation();
      } else toast("Fehler", (r && r.error) || "Senden fehlgeschlagen.", "error");
    } catch (e) { toast("Fehler", e.message === "NOT_DEPLOYED" ? "Edge Function support noch nicht deployed." : e.message, "error"); }
    finally { state.busy = false; }
  }
  async function toggleClose() {
    if (!state.req) return;
    const reopen = state.req.status === "closed";
    /* Vorher wurde der Zustand blind umgeschaltet. Schlug der Aufruf fehl,
       zeigte die Oberfläche "geschlossen", während die Anfrage in der
       Datenbank offen blieb — und beim nächsten Laden war sie wieder da. */
    try {
      const r = await adm("admin_close", { request_id: state.activeId, reopen });
      if (!r || r.ok !== true) throw new Error((r && r.error) || "Konnte nicht gespeichert werden.");
      state.req.status = reopen ? "open" : "closed";
      await loadList(); renderList(); renderConversation();
    } catch (e) {
      toast("Fehler", e.message === "NOT_DEPLOYED"
        ? "Edge Function support noch nicht deployed."
        : (e.message || "Konnte nicht gespeichert werden."), "error");
    }
  }

  async function render() {
    const root = byId("amkzSupportRoot"); if (!root) return;
    if (!allowed()) { root.innerHTML = `<div class="amkz-sup-empty">Kein Zugriff – dir ist kein Land für Anfragen freigegeben.</div>`; return; }
    if (!root.querySelector(".amkz-sup-shell")) {
      root.innerHTML = `
        <div class="amkz-sup-shell">
          <aside class="amkz-sup-side">
            <div class="amkz-sup-side-head"><h3>Posteingang</h3><span id="amkzSupCount" class="amkz-sup-count">0 offen</span></div>
            ${countryTabs()}
            <div class="amkz-sup-list" id="amkzSupList"><div class="amkz-sup-empty">Lädt …</div></div>
          </aside>
          <section class="amkz-sup-main" id="amkzSupConv"><div class="amkz-sup-empty amkz-sup-conv-empty">Wähle links eine Anfrage.</div></section>
        </div>`;
      root.querySelectorAll("[data-sup-filter]").forEach((b) => b.addEventListener("click", () => { state.filter = b.getAttribute("data-sup-filter"); root.querySelectorAll("[data-sup-filter]").forEach((x) => x.classList.toggle("active", x === b)); renderList(); }));
    }
    let r;
    try { r = await loadList(); } catch (e) {
      if (e.message === "NOT_DEPLOYED") { root.innerHTML = `<div class="amkz-sup-setup"><h3>💬 Anfragen – einrichten</h3><p>Führe <code>supabase-support-chat.sql</code> aus und deploye die Edge Function <code>support</code>. Danach erscheint hier der Live-Chat.</p></div>`; return; }
      root.innerHTML = `<div class="amkz-sup-empty">Fehler: ${esc(e.message)}</div>`; return;
    }
    renderList();
  }

  // Delegierte Klicks für Anfrage öffnen + Name -> Spielerakte
  document.addEventListener("click", (e) => {
    const op = e.target.closest("[data-sup-openperson]");
    if (op) {
      e.preventDefault(); e.stopPropagation();
      const em = op.getAttribute("data-sup-email") || "", nm = op.getAttribute("data-sup-name") || "";
      const key = (em || nm || "").toLowerCase();
      AMKZ.crm?.openPersonProfile?.({ name: nm, email: em, wallet: "", key, label: nm || em || "Spieler" });
      return;
    }
    const it = e.target.closest("[data-sup-open]"); if (it) openReq(it.getAttribute("data-sup-open"));
  });

  // Öffnet den Anfragen-Chat einer bestimmten E-Mail (aus der Spielerakte heraus)
  async function openByEmail(email) {
    const em = String(email || "").trim().toLowerCase(); if (!em) return false;
    try { AMKZ.switchView && AMKZ.switchView("support"); } catch (_) {}
    ensureStyle(); render();
    try { await loadList(); } catch (_) {}
    await new Promise((r) => setTimeout(r, 120));
    const g = groupRequests(state.requests).find((x) => x.email === em);
    if (g) { renderList(); openReq(g.key); return true; }
    toast("Kein Chat", "Für " + em + " gibt es noch keine Anfrage.", "error");
    return false;
  }
  async function searchByQuery(q) {
    const ql = String(q || "").toLowerCase(); if (ql.length < 2) return [];
    if (!(state.requests || []).length) { try { await loadList(); } catch (_) {} }
    const groups = groupRequests(state.requests || []);
    return groups.filter((g) => (String(g.email || "") + " " + String(g.name || "")).toLowerCase().includes(ql))
      .map((g) => ({ email: g.email, name: g.name, unread: g.staff_unread, count: g.reqs.length }));
  }
  // Fuer die Startseite: wie viele Gespraeche warten auf eine Antwort?
  // Gezaehlt werden offene Anfragen mit ungelesenen Nachrichten — genau das,
  // was auch das rote Zeichen an der Seitenleiste zeigt.
  function ungeleseneAnfragen() {
    return (state.requests || []).filter(function (r) {
      return r.status !== "closed" && (r.staff_unread || 0) > 0;
    }).length;
  }
  async function ungeleseneAnfragenFrisch() {
    try { await loadList(); } catch (_) {}
    return ungeleseneAnfragen();
  }

  AMKZ.support = {
    openByEmail, search: searchByQuery,
    ungelesen: ungeleseneAnfragen,
    ungelesenFrisch: ungeleseneAnfragenFrisch,
    unbeantwortet: () => (state.requests || []).filter((r) => r.status !== "closed" && r.last_sender === "player").length, // Nachtschicht 31.10.: gleiche Zählung wie oben in „Anfragen“
  };

  function startPoll() {
    stopPoll();
    state.poll = setInterval(async () => {
      if (document.hidden) return;   // im Hintergrund-Reiter ruht die Abfrage
      const view = byId("amkzSupportView"); if (!view || view.classList.contains("is-hidden")) return;
      try {
        await loadList(); renderList();
        if (state.activeKey && String(state.activeKey).startsWith("email:")) {
          // Gruppen-Thread: alle Requests der E-Mail neu mergen, wenn sich was geändert hat
          const g = groupRequests(state.requests).find((x) => x.key === state.activeKey);
          if (g) {
            let merged = [];
            for (const rid of g.reqIds) { const r = await adm("admin_messages", { request_id: rid }); if (r && r.ok) merged = merged.concat(r.messages || []); }
            if (merged.length !== state.msgs.length) {
              merged.sort((a, b) => (String(a.created_at) < String(b.created_at) ? -1 : 1));
              state.msgs = merged; state.replyRequestId = g.replyRequestId; renderConversation();
              if (state.req && state.req.country === "CZ") translateIncoming();
            }
          }
        } else if (state.activeId) {
          const r = await adm("admin_messages", { request_id: state.activeId });
          if (r && r.ok && (r.messages || []).length !== state.msgs.length) {
            state.req = r.request; state.msgs = r.messages || []; renderConversation();
            if (state.req.country === "CZ") translateIncoming();
          }
        }
      } catch (_) {}
    }, 4000);
  }
  function stopPoll() { if (state.poll) { clearInterval(state.poll); state.poll = null; } }

  function ensureStyle() {
    if (byId("amk-sup-style")) return;
    const s = document.createElement("style"); s.id = "amk-sup-style";
    s.textContent = `
      .amkz-sup-root{height:100%}
      .amkz-sup-shell{display:grid;grid-template-columns:360px 1fr;gap:14px;height:calc(100vh - 190px);min-height:460px}
      .amkz-sup-back{display:none;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.14);
        color:inherit;border-radius:10px;width:34px;height:34px;font-size:20px;line-height:1;cursor:pointer;flex:0 0 auto}
      @media(max-width:820px){
        /* Untereinander waere die Falle: das Gespraech landet unterhalb der
           ganzen Liste, ausserhalb des Bildschirms — der Tipp auf eine Anfrage
           sah aus, als passiere nichts. Deshalb: immer nur eine der beiden
           Spalten, dazu der Zurueck-Knopf. */
        .amkz-sup-shell{grid-template-columns:1fr;height:auto}
        .amkz-sup-shell .amkz-sup-main{display:none}
        .amkz-sup-shell.hat-chat .amkz-sup-side{display:none}
        .amkz-sup-shell.hat-chat .amkz-sup-main{display:flex;height:calc(100vh - 170px);min-height:420px}
        .amkz-sup-shell.hat-chat .amkz-sup-back{display:grid;place-items:center}
        .amkz-sup-side{height:calc(100vh - 170px);min-height:380px}
        .amkz-sup-conv-head{gap:8px;padding:10px 12px}
        .amkz-sup-conv-head > div:first-of-type{min-width:0}
        .amkz-sup-conv-head strong{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}
        .amkz-sup-conv-head small{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}
        /* Eine Zeile, keine gestapelten Knoepfe: die Kopfzeile darf auf dem
           Handy nicht die halbe Hoehe des Gespraechs fressen. */
        .amkz-sup-conv-actions{flex-wrap:nowrap;flex:0 0 auto}
        .amkz-sup-conv-actions .amkz-sup-btn{padding:6px 9px;font-size:.72rem}
      }
      .amkz-sup-side{background:linear-gradient(180deg,rgba(20,20,26,.6),rgba(9,9,12,.55));border:1px solid rgba(255,255,255,.08);border-radius:18px;padding:14px;display:flex;flex-direction:column;min-height:0}
      .amkz-sup-side-head{display:flex;flex-wrap:wrap;align-items:baseline;justify-content:space-between;gap:2px 10px;margin-bottom:10px}
      .amkz-sup-side-head h3{margin:0;font-size:1.05rem;font-weight:800;white-space:nowrap}
      .amkz-sup-count{font-size:.76rem;opacity:.6;font-weight:700}
      .amkz-sup-tabs{display:flex;gap:6px;flex-wrap:wrap;margin-bottom:10px}
      .amkz-sup-tab{background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.12);color:inherit;border-radius:10px;padding:6px 12px;font-weight:700;font-size:.8rem;cursor:pointer}
      .amkz-sup-tab.active{background:rgba(200,170,110,.16);border-color:rgba(200,170,110,.5);color:#f0d488}
      .amkz-sup-list{flex:1;overflow:auto;display:flex;flex-direction:column;gap:7px;min-height:0}
      .amkz-sup-item{text-align:left;background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:12px;padding:10px 12px;cursor:pointer;color:inherit;font:inherit}
      .amkz-sup-item:hover{background:rgba(255,255,255,.06)}
      .amkz-sup-item.active{border-color:rgba(200,170,110,.5);background:rgba(200,170,110,.08)}
      .amkz-sup-item.closed{opacity:.5}
      .amkz-sup-item-top{display:flex;align-items:center;gap:7px}
      .amkz-sup-item-top strong{font-size:.9rem;flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .amkz-sup-flag{font-size:.9rem}
      .amkz-sup-dot{width:9px;height:9px;border-radius:50%;background:#ff4d4d;flex:none;box-shadow:0 0 8px rgba(255,77,77,.8)}
      .amkz-sup-thread{font-size:.66rem;font-weight:800;background:rgba(200,170,110,.18);color:#f0d488;border-radius:6px;padding:1px 6px;flex:none}
      .amkz-sup-item-sub{font-size:.8rem;opacity:.7;margin:3px 0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .amkz-sup-item-meta{font-size:.72rem;opacity:.45}
      .amkz-sup-main{background:linear-gradient(180deg,rgba(20,20,26,.6),rgba(9,9,12,.55));border:1px solid rgba(255,255,255,.08);border-radius:18px;display:flex;flex-direction:column;min-height:0;overflow:hidden}
      .amkz-sup-conv-empty{margin:auto}
      .amkz-sup-conv-head{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:14px 16px;border-bottom:1px solid rgba(255,255,255,.08)}
      .amkz-sup-conv-head strong{display:block;font-size:.98rem}
      .amkz-sup-conv-head small{opacity:.55;font-size:.8rem}
      .amkz-sup-nameopen{background:none;border:0;color:inherit;font:inherit;font-weight:800;cursor:pointer;padding:0;text-decoration:underline;text-decoration-color:rgba(200,170,110,.55);text-underline-offset:3px}
      .amkz-sup-nameopen:hover{color:#f0d488}
      .amkz-sup-btn{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.14);color:inherit;border-radius:10px;padding:8px 14px;font-weight:700;font-size:.82rem;cursor:pointer}
      .amkz-sup-msgs{flex:1;overflow:auto;padding:16px;display:flex;flex-direction:column;gap:10px;min-height:0}
      .amkz-sup-msg{display:flex}
      .amkz-sup-msg.player{justify-content:flex-start}
      .amkz-sup-msg.staff{justify-content:flex-end}
      .amkz-sup-bubble{max-width:76%;border-radius:14px;padding:9px 13px;font-size:.9rem;line-height:1.45}
      .amkz-sup-img{max-width:260px;max-height:280px;border-radius:11px;display:block;cursor:pointer;object-fit:cover}
      .amkz-sup-msg.player .amkz-sup-bubble{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.09);border-bottom-left-radius:4px}
      .amkz-sup-msg.staff .amkz-sup-bubble{background:linear-gradient(135deg,rgba(200,170,110,.22),rgba(200,170,110,.12));border:1px solid rgba(200,170,110,.35);border-bottom-right-radius:4px}
      .amkz-sup-sent{font-size:.78rem;opacity:.6;margin-bottom:3px;color:#f0d488}
      .amkz-sup-trans{font-size:.82rem;opacity:.7;margin-top:4px;font-style:italic;border-top:1px dashed rgba(255,255,255,.12);padding-top:4px}
      .amkz-sup-time{font-size:.68rem;opacity:.45;margin-top:4px}
      .amkz-sup-reply{border-top:1px solid rgba(255,255,255,.08);padding:12px 14px;display:flex;gap:10px;align-items:flex-end}
      .amkz-sup-reply-cz{flex:1;display:flex;flex-direction:column;gap:6px}
      .amkz-sup-reply textarea{flex:1;width:100%;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.14);color:inherit;border-radius:12px;padding:10px 13px;font:inherit;font-size:.92rem;resize:none}
      .amkz-sup-preview{background:rgba(200,170,110,.08);border:1px dashed rgba(200,170,110,.35);border-radius:10px;padding:7px 11px;font-size:.85rem;color:#f0d488}
      .amkz-sup-send{background:linear-gradient(135deg,#e0b24a,#c8902b);border:0;color:#1a1305;font-weight:900;border-radius:12px;padding:11px 18px;cursor:pointer;white-space:nowrap}
      .amkz-sup-empty{padding:26px;text-align:center;opacity:.5;font-size:.88rem}
      .amkz-sup-setup{background:rgba(230,120,92,.08);border:1px solid rgba(230,120,92,.35);border-radius:16px;padding:22px;line-height:1.6}
      .amkz-sup-setup h3{margin:0 0 8px;color:#f0a488}
      .amkz-sup-setup code{background:rgba(0,0,0,.4);padding:2px 7px;border-radius:6px;color:#f0d488}
    `;
    document.head.appendChild(s);
  }

  const prevLV = AMKZ.loadView;
  AMKZ.loadView = async function supChain(v, o) {
    const r = await prevLV?.call(this, v, o);
    if (v === "support") { ensureStyle(); render(); startPoll(); } else { stopPoll(); }
    return r;
  };
  // Hintergrund-Badge: ungelesene Anfragen auch außerhalb des Anfragen-Views anzeigen
  setTimeout(pollBadge, 3500);
  setInterval(pollBadge, 20000);
})();

/* ---------- Kalender-Seitenspalte: „Meine Termine"-Kopf sauber umbrechen ----------
   Zwei Buttons (🏖 Urlaub beantragen + „+ Termin") passten nicht neben den Titel
   in die schmale Spalte und liefen über. Titel volle Breite, Buttons als saubere
   Reihe darunter (umbruchsicher). Reines Layout, per JS injiziert. */
(function () {
  "use strict";
  if (document.getElementById("amk-calhead-style")) return;
  const s = document.createElement("style"); s.id = "amk-calhead-style";
  s.textContent = `
    .amkz-calendar-side .amkz-card-header{
      flex-wrap:wrap !important; align-items:stretch !important; row-gap:10px !important;
    }
    .amkz-calendar-side .amkz-card-header > div:first-child{
      flex:1 1 100% !important; min-width:0 !important;
    }
    .amkz-calendar-side .amkz-card-header small{ white-space:nowrap; overflow:hidden; text-overflow:ellipsis; display:block; max-width:100% }
    /* Beide Buttons untereinander, jeweils volle Breite -> NIE Überlauf.
       ID-Selektoren = maximale Priorität, schlägt jede Live-/Premium-Regel. */
    #amkzVacationBtn,
    #amkzCreateCalendarButton{
      flex:1 1 100% !important; width:100% !important; min-width:0 !important; box-sizing:border-box !important;
      white-space:nowrap; text-align:center; padding:11px 14px !important; font-size:13.5px !important; line-height:1.15 !important;
    }
  `;
  document.head.appendChild(s);
})();

/* ---------- Topbar: „Mitteilungen aktivieren" ausgeschrieben + nichts mehr quetschen ----------
   Das alte „TOPBAR v2"-CSS setzte flex-wrap:nowrap + versteckte den Button zu einem Icon
   (Platzsparer). Bei vollem Header quetschte das die Buttons zu dünnen Streifen. Fix:
   Topbar darf umbrechen, Controls behalten ihre Breite, „Mitteilungen aktivieren" zeigt
   Glocke + vollen Text. ID-Selektoren = schlägt die alten !important-Regeln. */
(function () {
  "use strict";
  if (document.getElementById("amk-topbar-fix-style")) return;
  const s = document.createElement("style"); s.id = "amk-topbar-fix-style";
  s.textContent = `
    .amkz-topbar-actions{ flex-wrap:wrap !important; row-gap:8px !important; }
    .amkz-topbar-actions > *, .amkz-final-date-range > *{ flex:0 0 auto !important; }

    /* EIN Mass fuer alles in der Kopfzeile. Diese Regeln stehen hier und
       nicht in der CSS-Datei, weil dieser Block zur Laufzeit eingehaengt
       wird und damit als letzter gilt — in der Datei wuerden sie von den
       Grundregeln (46 Pixel hohe Knoepfe) ueberschrieben. */
    .amkz-topbar-actions > *,
    .amkz-topbar-actions .amkz-secondary-btn,
    .amkz-topbar-actions .amkz-primary-btn,
    .amkz-topbar-actions input[type="date"],
    .amkz-topbar-actions .amkz-date-filter,
    .amkz-final-date-range input,
    .amkz-final-date-range button{
      height:36px !important; min-height:36px !important;
      border-radius:999px !important; font-size:12.5px !important;
      padding:0 13px !important;
    }
    .amkz-final-date-range{ height:36px !important; align-items:center !important; }
    /* Der Titel darf schrumpfen, damit die Leiste daneben bleibt statt
       darunter zu rutschen. */
    .amkz-topbar-title{ min-width:0 !important; flex:0 1 auto !important; }
    .amkz-topbar-title h1{ white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }

    /* Umbrechen ist am grossen Bildschirm richtig — auf schmalen wird daraus
       ein Turm. Gemessen: bei 375 Pixeln standen sieben Bedienelemente
       untereinander, 298 Pixel hoch, ein gutes Drittel des Bildschirms,
       bevor der erste Inhalt kam. Deshalb hier zwei Stufen.
       Die Regeln stehen bewusst in DIESEM Block: er wird zur Laufzeit
       eingehaengt und schlaegt damit alles aus der CSS-Datei. Stuenden sie
       dort, wuerde die Zeile darueber sie wieder ueberschreiben. */

    /* 780 bis 1180: eine Nummer kleiner, dann passt es in eine Zeile */
    @media (max-width:1180px){
      .amkz-topbar-actions{ gap:6px !important; }
      .amkz-topbar-actions .amkz-secondary-btn,
      .amkz-topbar-actions .amkz-primary-btn,
      .amkz-final-date-range button{ height:34px !important; padding:0 10px !important; font-size:12px !important; }
      .amkz-topbar-actions input[type="date"],
      .amkz-topbar-actions .amkz-date-filter,
      .amkz-final-date-range input{ height:34px !important; width:106px !important; min-width:0 !important; padding:0 8px !important; font-size:12px !important; }
      .amkz-final-date-range{ gap:6px !important; }
      .amkz-topbar-title p{ display:none !important; }
    }


    /* „Mitteilungen aktivieren" wieder ausgeschrieben (Glocke + Text) */
    #amkzEnablePushButton{
      width:auto !important; min-width:0 !important; padding:0 14px !important; font-size:12.5px !important;
      display:inline-flex !important; align-items:center !important; gap:7px !important; white-space:nowrap !important;
    }
    #amkzEnablePushButton::before{ flex:0 0 auto !important; width:16px !important; height:16px !important; }
    @media(max-width:900px){
      #amkzEnablePushButton{ font-size:12px !important; }
    }

    /* 781 bis 1180 Pixel (schmale Cockpit-Leiste, Tablet quer, halbes Fenster):
       dieselben Chips wie am Handy, aber alles in EINER Zeile — Platz reicht:
       REC 71 + 3 Chips 114 + 2 Datumsfelder 256 + Heute 59 + Laden 38 + Luecken 56 = 594 px
       bei mindestens 627 px Inhaltsbreite. Vorher: zwei Zeilen, 144 px hoch,
       Datumsfelder auf 106 px abgeschnitten ("05.09.202"). */
    @media (min-width:781px) and (max-width:1180px){
      .amkz-topbar-actions{ flex-wrap:nowrap !important; width:auto !important; }
      #amkzEnablePushButton, #amkzRefreshButton, #amkzDesignSchalter{
        width:38px !important; padding:0 !important; font-size:0 !important;
        position:relative !important; overflow:hidden;
      }
      #amkzEnablePushButton::before, #amkzRefreshButton::before{
        position:absolute !important; top:50% !important; left:50% !important;
        transform:translate(-50%,-50%) !important; display:block !important;
        width:18px !important; height:18px !important; z-index:1;
      }
      #amkzDesignSchalter::before{
        content:"\u25D1"; position:absolute; inset:0; display:grid; place-items:center;
        color:var(--amk-text-2); line-height:1; font-size:16px; z-index:1;
      }
      .amkz-final-date-range{ display:flex !important; flex-wrap:nowrap !important; gap:6px !important; }
      .amkz-final-date-range input, .amkz-topbar-actions input[type="date"]{ width:128px !important; min-width:128px !important; font-size:13px !important; padding:0 8px !important; }
      #amkzTodayBtnFinal{ width:auto !important; padding:0 12px !important; }
      #amkzRecTopBtn{ padding:0 12px !important; }
      .amkz-topbar-title p{ display:none !important; }
    }

    /* Bis 780 Pixel: zwei ruhige Zeilen statt einer Wischleiste.
       Zeile 1 sind die Chips (Aufnahme, Fassung, Mitteilungen, Aktualisieren),
       Zeile 2 ist der Zeitraum ueber die volle Breite. Vorher lag alles in
       einer scrollbaren Zeile: 1216 Pixel Inhalt bei 341 Pixel Platz, man sah
       also nie mehr als ein Drittel und musste raten, was rechts noch kommt. */
    @media (max-width:780px){
      .amkz-topbar-actions{
        display:flex !important; flex-wrap:wrap !important; align-items:center !important;
        gap:8px !important; width:100% !important; padding:4px !important;
        overflow:visible !important;
        -webkit-mask-image:none !important; mask-image:none !important;
      }
      .amkz-topbar-actions > *{ flex:0 0 auto !important; width:auto !important; max-width:none !important; }

      /* Chips: Beschriftung optisch aus, Symbol mittig darueber gelegt —
         nicht daneben. Mit display:grid wurde der leere Textknoten zur ersten
         Zeile und schob das Symbol aus dem Knopf heraus. */
      #amkzEnablePushButton, #amkzRefreshButton, #amkzDesignSchalter{
        width:38px !important; padding:0 !important; font-size:0 !important;
        position:relative !important; overflow:hidden;
      }
      /* Das Symbol liegt in ::before, NICHT in ::after — ::after gehoert dem
         Lichtstrahl am Rahmen. Glocke und Pfeil kommen als SVG-Maske aus der
         Stildatei und werden hier nur mittig gesetzt; ein eigenes "content"
         waere zwecklos, die Stildatei setzt content:"" mit !important. */
      #amkzEnablePushButton::before, #amkzRefreshButton::before{
        position:absolute !important; top:50% !important; left:50% !important;
        transform:translate(-50%,-50%) !important; display:block !important;
        width:18px !important; height:18px !important; z-index:1;
      }
      #amkzDesignSchalter::before{
        content:"\u25D1"; position:absolute; inset:0; display:grid; place-items:center;
        color:var(--amk-text-2); line-height:1; font-size:16px; z-index:1;
      }
      #amkzRecTopBtn{ padding:0 12px !important; }

      /* Zeile 2: Zeitraum. Die beiden Felder teilen sich den Platz gleich auf,
         "Heute" bleibt lesbar, "Zeitraum laden" wird zum Pfeil-Chip. */
      /* Der Zeitraum-Kasten loest sich auf (display:contents), damit seine vier
         Bedienelemente direkt in der Leiste liegen und einzeln sortiert werden
         koennen: "Heute" und der Pfeil gehen zu den Chips in Zeile eins, die
         beiden Datumsfelder bekommen Zeile zwei fuer sich allein — sonst
         blieben ihnen nur 96 Pixel und das Datum war abgeschnitten.
         Kein Raster: einzelne Elemente bringen aus der Handy-Fassung ein
         "grid-column:1/-1" mit und sprangen darin in eigene Zeilen. */
      .amkz-final-date-range{ display:contents !important; }
      /* Mehrere Bedienelemente stehen aus der Handy-Fassung auf voller Breite.
         In einer gemeinsamen Zeile wuerde damit jedes einzelne den Bildschirm
         fuellen. */
      .amkz-final-date-range > *{ width:auto !important; min-width:0 !important; max-width:none !important; }
      #amkzTodayBtnFinal{ order:5 !important; }
      #amkzApplyDateRangeFinal{ order:6 !important; }
      .amkz-final-date-range input{ order:9 !important; }
      .amkz-final-date-range input,
      .amkz-topbar-actions input[type="date"]{
        flex:1 1 120px !important; width:auto !important; min-width:0 !important;
        font-size:12px !important; padding:0 10px !important;
      }
      /* Kennung schlaegt Klasse: die Regel eine Zeile hoeher erreicht diesen
         Knopf nicht, er zog sich sonst ueber die ganze Zeile. */
      #amkzTodayBtnFinal{ flex:0 0 auto !important; width:auto !important; padding:0 12px !important; font-size:11.5px !important; }
      #amkzApplyDateRangeFinal{
        flex:0 0 38px !important; width:38px !important; padding:0 !important;
        font-size:0 !important; position:relative !important; overflow:hidden;
      }
      #amkzApplyDateRangeFinal::before{
        content:"\u279C"; position:absolute; inset:0; display:grid; place-items:center;
        color:var(--amk-text-2); line-height:1; font-size:15px; z-index:1;
      }
      .amkz-topbar-title h1{ font-size:20px !important; }
    }
  `;
  document.head.appendChild(s);
})();


/* ============================================================================
   TOPBAR-HÖHE MESSEN
   Die Topbar ist auf dem Desktop position:fixed und liegt damit nicht mehr im
   Fluss — der Inhalt darunter muss ihre Höhe als Abstand freihalten. Fest
   verdrahtet waren das 76px, was nur stimmte, solange die Leiste einzeilig
   blieb. Brechen die Buttons rechts um, wird sie ~123px hoch und die obersten
   ~47px JEDER Ansicht rutschten unter die Leiste (KPI-Überschriften weg).

   Statt zu raten wird hier die echte Höhe gemessen und als --amkz-topbar-h
   gesetzt. amk-zentrale.css liest sie in .amkz-content{padding-top} und in
   .amkz-hub{top}. Der ResizeObserver deckt alles ab: Fensterbreite, Ansichts-
   wechsel mit längerem Titel, nachgeladene Buttons, Schriftgrößen.
   ========================================================================= */
(function () {
  "use strict";
  if (window.__amkTopbarHeightWatch) return;
  window.__amkTopbarHeightWatch = true;

  const root = document.documentElement;
  let letzte = -1;

  function messen() {
    const bar = document.querySelector(".amkz-content .amkz-topbar, .amkz-topbar");
    if (!bar) return;
    // Unter 901px steht die Leiste wieder im Fluss — dann keinen Abstand reservieren.
    const fixiert = getComputedStyle(bar).position === "fixed";
    const h = fixiert ? Math.ceil(bar.getBoundingClientRect().height) : 0;
    if (h === letzte) return;
    letzte = h;
    root.style.setProperty("--amkz-topbar-h", h + "px");
  }

  function starten() {
    messen();
    const bar = document.querySelector(".amkz-content .amkz-topbar, .amkz-topbar");
    if (bar && window.ResizeObserver) new ResizeObserver(messen).observe(bar);
    addEventListener("resize", messen, { passive: true });
    // Ansichtswechsel tauschen den Titel aus -> Höhe kann sich ändern
    const prev = AMKZ.loadView;
    if (typeof prev === "function") {
      AMKZ.loadView = async function topbarHeightChain(v, o) {
        const r = await prev.call(this, v, o);
        requestAnimationFrame(messen);
        return r;
      };
    }
  }

  if (document.readyState === "loading") addEventListener("DOMContentLoaded", starten, { once: true });
  else starten();
  addEventListener("load", messen, { once: true });
})();


/* Seit 22.10.2026: Tschechien und Partnerprogramm (Vertrieb) werden in der
   Zentrale nicht mehr gepflegt. Die Kanäle bleiben in der Datenbank, tauchen
   hier aber nirgends mehr auf. Der Server schreibt beim Speichern nur die
   mitgeschickten Kanäle — bestehende CZ-/Vertriebs-Platzierungen bleiben also
   unangetastet. */
window.AMKZ_KANAELE_SICHTBAR = function (liste) {
  return (liste || []).filter(function (ch) { return ch && ch.key !== "cz" && ch.key !== "vertrieb"; });
};

/* ============================================================================
   CASINO-HUB
   Der Kontrollraum für alle Casinos: einmal anlegen, überall ausspielen.
   Ein Casino liegt genau einmal in der Datenbank. Über die Kanal-Matrix wird
   entschieden, wo es erscheint und an welcher Position: Hauptfront, 300K,
   Tschechien, Partnerprogramm.

   WARUM DIESER BLOCK ANDERS ARBEITET ALS DER REST DER DATEI:
   Die übrige Zentrale spricht direkt mit Supabase (AMKZ.supabase). Dieser
   Bereich nicht — er läuft über die Edge Function "vertrieb" mit eigener
   Anmeldung und eigenem Token. Grund: CPA, Baseline, RevShare und RAF dürfen
   mit dem öffentlichen anon-Key niemals lesbar sein. Deshalb hat dieser Block
   sein eigenes api() und seine eigene Sitzung.
============================================================================ */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;

  "use strict";

  var API = (window.AMK_HUB_API ||
    "https://cbwxgikndyyzdslmfpmo.supabase.co/functions/v1/vertrieb");

  var HUB = {
    token: localStorage.getItem("amkch_token") || "",
    user: null,
    casinos: [],
    channels: [],
    accounting: [],
    loaded: false,
    lastCredentials: null,
  };

  /* ------------------------------------------------------------- Helfer */
  var byId = function (id) { return document.getElementById(id); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  function esc(v) {
    return String(v == null ? "" : v).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[c];
    });
  }
  function eur(v) {
    return (Number(v) || 0).toLocaleString("de-DE", {
      style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 2
    });
  }
  function intDe(v) { return (Number(v) || 0).toLocaleString("de-DE"); }

  function api(action, payload) {
    return fetch(API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Object.assign({ action: action, token: HUB.token }, payload || {}))
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok || data.ok === false) throw new Error(data.error || "Unbekannter Fehler");
        return data;
      });
    });
  }

  // Jede Aenderung am Hub melden. Die Ansicht "Webseiten" zeigt dieselben
  // Daten und muss sich sonst nicht neu laden.
  function gemeldet(was) {
    try {
      document.dispatchEvent(new CustomEvent("amkch:changed", { detail: { was: was } }));
    } catch (_) { /* aeltere Browser: dann eben ohne Meldung */ }
  }

  function toast(title, message, type) {
    // Die Zentrale bringt eigene Toasts mit — wenn vorhanden, die benutzen
    if (window.AMKZ && typeof window.AMKZ.toast === "function") {
      window.AMKZ.toast(title, message || "", type || "success");
      return;
    }
    var box = byId("amkchToasts");
    if (!box) {
      box = document.createElement("div");
      box.id = "amkchToasts";
      box.className = "amkch-toasts";
      document.body.appendChild(box);
    }
    var el = document.createElement("div");
    el.className = "amkch-toast " + (type === "error" ? "is-error" : "is-ok");
    el.innerHTML = "<strong>" + esc(title) + "</strong>" +
      (message ? "<small>" + esc(message) + "</small>" : "");
    box.appendChild(el);
    setTimeout(function () { el.remove(); }, 3800);
  }

  /* ============================================================================
     EINBAU IN DIE ZENTRALE
  ============================================================================ */




  // Beim Login der Zentrale nebenbei eine Hub-Session holen —
  // dann muss niemand ein zweites Mal ein Passwort eintippen.
  function hookLogin() {
    var form = byId("amkzLoginForm");
    if (!form || form.dataset.amkchHooked) return;
    form.dataset.amkchHooked = "1";

    form.addEventListener("submit", function () {
      var email = (byId("amkzLoginEmail") || {}).value || "";
      var password = (byId("amkzLoginPass") || byId("amkzLoginPassword") || {}).value || "";
      if (!email || !password) return;
      HUB.lastCredentials = { email: email, password: password };

      // Der Zentrale-Login läuft parallel; kurz warten und dann anmelden.
      setTimeout(function () {
        hubLogin(email, password).catch(function () { /* ohne Hub geht die Zentrale weiter */ });
      }, 900);
    }, true);
  }

  function hubLogin(email, password) {
    return api("hub_login", { email: email, password: password }).then(function (res) {
      HUB.token = res.token;
      HUB.user = res.user;
      localStorage.setItem("amkch_token", res.token);
      return res;
    });
  }

  /* ============================================================================
     ANSICHT
  ============================================================================ */
  function renderLoginPrompt(message) {
    byId("amkchRoot").innerHTML =
      '<div class="amkch-panel amkch-login">' +
        '<h3>Casino-Hub</h3>' +
        '<p>' + esc(message || "Zum Bearbeiten der Casinos einmal mit deinem Zentrale-Passwort anmelden. Die Anmeldung hält 30 Tage.") + '</p>' +
        '<div class="amkch-field"><label>E-Mail</label>' +
          '<input type="email" id="amkchEmail" autocomplete="email" value="' +
            esc((window.AMKZ && window.AMKZ.state && window.AMKZ.state.member && window.AMKZ.state.member.email) || "") + '"></div>' +
        '<div class="amkch-field"><label>Passwort</label>' +
          '<input type="password" id="amkchPassword" autocomplete="current-password"></div>' +
        '<button class="amkch-btn" type="button" id="amkchLoginBtn">Anmelden</button>' +
        '<div class="amkch-msg" id="amkchLoginMsg"></div>' +
      '</div>';

    byId("amkchLoginBtn").addEventListener("click", function () {
      var btn = this;
      var msg = byId("amkchLoginMsg");
      msg.className = "amkch-msg";
      btn.disabled = true;
      btn.textContent = "Meldet an …";
      hubLogin(byId("amkchEmail").value, byId("amkchPassword").value)
        .then(function () { renderHub(); })
        .catch(function (err) {
          msg.className = "amkch-msg is-error";
          msg.textContent = err.message;
          btn.disabled = false;
          btn.textContent = "Anmelden";
        });
    });
  }

  async function renderHub() {
    var root = byId("amkchRoot");
    if (!root) return;

    if (!HUB.token) {
      if (HUB.lastCredentials) {
        try {
          await hubLogin(HUB.lastCredentials.email, HUB.lastCredentials.password);
        } catch (e) { /* weiter zum Anmeldedialog */ }
      }
      if (!HUB.token) return renderLoginPrompt();
    }

    root.innerHTML = '<div class="amkch-panel"><div class="amkch-empty">Lädt Casinos …</div></div>';

    var data;
    try {
      data = await api("hub_casinos");
    } catch (err) {
      if (/Nicht angemeldet/.test(err.message)) {
        localStorage.removeItem("amkch_token");
        HUB.token = "";
        return renderLoginPrompt("Die Anmeldung ist abgelaufen. Bitte erneut anmelden.");
      }
      root.innerHTML = '<div class="amkch-panel"><div class="amkch-empty">⚠ ' + esc(err.message) + "</div></div>";
      return;
    }

    HUB.casinos = data.casinos || [];
    HUB.channels = window.AMKZ_KANAELE_SICHTBAR(data.channels);
    HUB.accounting = data.accounting || [];
    HUB.loaded = true;

    renderMatrix();
  }

  function placementOf(casino, channel) {
    return (casino.placements || []).filter(function (p) { return p.channel === channel; })[0] || null;
  }

  function renderMatrix() {
    var root = byId("amkchRoot");
    var channels = HUB.channels;

    var activeCount = HUB.casinos.filter(function (c) { return c.is_active; }).length;
    var perChannel = channels.map(function (ch) {
      var n = HUB.casinos.filter(function (c) {
        var p = placementOf(c, ch.key);
        return c.is_active && p && p.is_enabled;
      }).length;
      return { ch: ch, count: n };
    });

    root.innerHTML =
      '<div class="amkch-head">' +
        '<div>' +
          '<h3>Casino-Hub</h3>' +
          '<p>Ein Casino, alle Kanäle. Was du hier setzt, steht sofort auf der ' +
          'Hauptfront, im 300K-Giveaway, auf der CZ-Seite und im Partnerprogramm.</p>' +
        '</div>' +
        '<div class="amkch-head-actions">' +
          '<button class="amkch-btn ghost" type="button" id="amkchRefresh">Neu laden</button>' +
          '<button class="amkch-btn" type="button" id="amkchNew">+ Casino anlegen</button>' +
        '</div>' +
      '</div>' +

      '<div class="amkch-cards">' +
        '<div class="amkch-kpi"><label>Casinos</label><strong>' + intDe(activeCount) + "</strong>" +
          "<small>" + intDe(HUB.casinos.length - activeCount) + " deaktiviert</small></div>" +
        perChannel.map(function (x) {
          return '<div class="amkch-kpi"><label>' + esc(x.ch.label) + "</label>" +
            "<strong>" + intDe(x.count) + "</strong><small>Casinos sichtbar</small></div>";
        }).join("") +
      "</div>" +

      '<div class="amkch-panel">' +
        '<div class="amkch-panel-head">' +
          "<div><h4>Kanal-Matrix</h4>" +
          "<p>Haken setzen = erscheint dort. Die Zahl ist die Position (1 = ganz oben).</p></div>" +
        "</div>" +
        '<div class="amkch-table-wrap">' +
          '<table class="amkch-table">' +
            "<thead><tr>" +
              "<th>Casino</th>" +
              channels.map(function (ch) {
                return '<th class="amkch-ch">' + esc(ch.label) +
                  (ch.is_public === false ? '<br><small>intern</small>' : "") + "</th>";
              }).join("") +
              '<th class="amkch-num">CPA</th>' +
              '<th class="amkch-num">Partner €</th>' +
              "<th>Status</th><th></th>" +
            "</tr></thead>" +
            "<tbody>" +
              (HUB.casinos.length
                ? HUB.casinos.map(matrixRow).join("")
                : '<tr><td colspan="' + (channels.length + 5) + '">' +
                  '<div class="amkch-empty">Noch kein Casino im Hub. Lege eines an — ' +
                  'es erscheint danach überall dort, wo du es freigibst.</div></td></tr>') +
            "</tbody>" +
          "</table>" +
        "</div>" +
      "</div>" +

      '<div class="amkch-panel">' +
        '<div class="amkch-panel-head">' +
          "<div><h4>Vorschau je Kanal</h4>" +
          "<p>Genau die Liste, die die jeweilige Seite bekommt — inklusive Reihenfolge.</p></div>" +
          '<select id="amkchPreviewChannel" class="amkch-select">' +
            channels.map(function (ch) {
              return '<option value="' + esc(ch.key) + '">' + esc(ch.label) + "</option>";
            }).join("") +
          "</select>" +
        "</div>" +
        '<div id="amkchPreview"><div class="amkch-empty">Kanal wählen…</div></div>' +
      "</div>";

    byId("amkchRefresh").addEventListener("click", renderHub);
    byId("amkchNew").addEventListener("click", function () { openEditor(null); });

    $$("[data-edit-casino]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var casino = HUB.casinos.filter(function (c) { return c.id === btn.dataset.editCasino; })[0];
        openEditor(casino || null);
      });
    });

    $$("[data-toggle-channel]").forEach(function (box) {
      box.addEventListener("change", function () {
        setPlacement(box.dataset.casino, box.dataset.toggleChannel, { is_enabled: box.checked });
      });
    });

    $$("[data-rank]").forEach(function (input) {
      input.addEventListener("change", function () {
        setPlacement(input.dataset.casino, input.dataset.rank, { rank: input.value });
      });
    });

    var sel = byId("amkchPreviewChannel");
    sel.addEventListener("change", function () { loadPreview(sel.value); });
    loadPreview(sel.value);
  }

  function matrixRow(c) {
    return "<tr" + (c.is_active ? "" : ' class="is-off"') + ">" +
      "<td>" +
        '<div class="amkch-casino">' +
          (c.logo_url
            ? '<img src="' + esc(c.logo_url) + '" alt="">'
            : '<span class="amkch-dot" style="background:' + esc(c.brand_color || "#e6b85c") + '"></span>') +
          "<div><strong>" + esc(c.name) + "</strong>" +
          '<small>' + esc(c.bonus_text || "—") + "</small></div>" +
        "</div>" +
      "</td>" +
      HUB.channels.map(function (ch) {
        var p = placementOf(c, ch.key);
        var on = !!(p && p.is_enabled);
        return '<td class="amkch-ch">' +
          '<label class="amkch-check">' +
            '<input type="checkbox" data-toggle-channel="' + esc(ch.key) + '" data-casino="' + esc(c.id) + '"' +
              (on ? " checked" : "") + ">" +
            "<span></span>" +
          "</label>" +
          '<input class="amkch-rank" type="number" min="1" max="99" ' +
            'data-rank="' + esc(ch.key) + '" data-casino="' + esc(c.id) + '" ' +
            'value="' + (p ? p.rank : 99) + '"' + (on ? "" : " disabled") + ">" +
        "</td>";
      }).join("") +
      '<td class="amkch-num">' + eur(c.cpa) + "</td>" +
      '<td class="amkch-num amkch-gold">' + eur(c.partner_commission) + "</td>" +
      "<td>" + (c.is_active
        ? '<span class="amkch-pill on">Aktiv</span>'
        : '<span class="amkch-pill off">Aus</span>') + "</td>" +
      '<td><button class="amkch-btn xs" type="button" data-edit-casino="' + esc(c.id) + '">Bearbeiten</button></td>' +
    "</tr>";
  }

  function setPlacement(casinoId, channel, patch) {
    api("hub_set_placement", Object.assign({ casino_id: casinoId, channel: channel }, patch))
      .then(function () {
        toast("Gespeichert", "Platzierung aktualisiert.");
        gemeldet("placement");
        return api("hub_casinos");
      })
      .then(function (data) {
        HUB.casinos = data.casinos || [];
        renderMatrix();
      })
      .catch(function (err) { toast("Fehler", err.message, "error"); });
  }

  function loadPreview(channel) {
    var box = byId("amkchPreview");
    box.innerHTML = '<div class="amkch-empty">Lädt …</div>';
    api("hub_channel_preview", { channel: channel })
      .then(function (res) {
        var list = (res.casinos || []).filter(function (c) { return c.is_enabled && c.is_active; });
        if (!list.length) {
          box.innerHTML = '<div class="amkch-empty">In diesem Kanal ist noch kein Casino freigegeben.</div>';
          return;
        }
        box.innerHTML = '<div class="amkch-preview">' + list.map(function (c, i) {
          return '<div class="amkch-preview-item">' +
            '<span class="amkch-pos">' + (i + 1) + "</span>" +
            (c.logo ? '<img src="' + esc(c.logo) + '" alt="">' : '<span class="amkch-dot"></span>') +
            "<div><strong>" + esc(c.name) + "</strong><small>" + esc(c.bonus || "—") + "</small></div>" +
            (c.featured ? '<span class="amkch-pill on">Featured</span>' : "") +
            '<a class="amkch-link" href="' + esc(c.cta || "#") + '" target="_blank" rel="noopener">Link prüfen ↗</a>' +
          "</div>";
        }).join("") + "</div>";
      })
      .catch(function (err) {
        box.innerHTML = '<div class="amkch-empty">⚠ ' + esc(err.message) + "</div>";
      });
  }


  /* ============================================================================
     BAUSTEINE FUER DEN EDITOR
     Zahlungsmethoden und Spieleanbieter wurden vorher als Komma-Liste
     eingetippt — ein Tippfehler ("Masterard") landete unbemerkt auf der
     Hauptfront. Ab jetzt: anklicken. Was nicht in der Liste steht, kommt
     ins Feld darunter und wird beim naechsten Oeffnen mit angeboten.
  ============================================================================ */
  var ZAHLUNG_KATALOG = [
    "Visa", "Mastercard", "Maestro", "PayPal", "Sofort", "Klarna", "SEPA",
    "Giropay", "Trustly", "Apple Pay", "Google Pay", "Paysafecard", "MiFinity",
    "Jeton", "Neteller", "Skrill", "Revolut", "Flexepin", "Interac", "AstroPay",
    "Bitcoin", "Ethereum", "Litecoin", "Tether (USDT)", "USD Coin (USDC)",
    "Ripple (XRP)", "Dogecoin", "Tron (TRX)", "Solana", "Cardano"
  ];

  var ANBIETER_KATALOG = [
    "Pragmatic Play", "Play'n GO", "NetEnt", "Nolimit City", "Hacksaw Gaming",
    "Push Gaming", "Relax Gaming", "Yggdrasil", "ELK Studios", "BGaming",
    "Red Tiger", "Thunderkick", "Wazdan", "Playson", "Novomatic", "Betsoft",
    "EGT", "Big Time Gaming", "Blueprint Gaming", "Quickspin", "Game Art",
    "Evolution", "Pragmatic Live", "Ezugi", "Microgaming", "Booongo"
  ];

  var LAND_KATALOG = ["DE", "AT", "CH", "CZ", "SK", "PL", "NL", "BE", "LU", "IT", "ES", "FI", "SE", "NO", "CA"];

  // Aus Katalog + bereits gespeicherten Werten eine Kaestchen-Liste bauen.
  // Reihenfolge: erst der Katalog, danach alles Eigene — so bleibt die
  // Anordnung stabil und Eigenes geht nicht unter.
  function auswahlfeld(id, katalog, gewaehlt, spalten) {
    var gesetzt = (gewaehlt || []).map(function (x) { return String(x).trim(); }).filter(Boolean);
    var klein = gesetzt.map(function (x) { return x.toLowerCase(); });
    var alle = katalog.slice();
    gesetzt.forEach(function (x) {
      if (katalog.map(function (k) { return k.toLowerCase(); }).indexOf(x.toLowerCase()) === -1) alle.push(x);
    });

    return '<div class="amkch-tags" data-tags="' + esc(id) + '"' +
        (spalten ? ' style="--ch-tag-min:' + esc(spalten) + '"' : "") + ">" +
      alle.map(function (w) {
        var on = klein.indexOf(w.toLowerCase()) !== -1;
        return '<label class="amkch-tag' + (on ? " is-on" : "") + '">' +
          '<input type="checkbox" value="' + esc(w) + '"' + (on ? " checked" : "") + ">" +
          "<span>" + esc(w) + "</span></label>";
      }).join("") +
      "</div>" +
      '<div class="amkch-tag-add">' +
        '<input type="text" data-tagadd="' + esc(id) + '" placeholder="Fehlt etwas? Hier eintragen und Enter drücken">' +
        '<button class="amkch-btn xs ghost" type="button" data-tagbtn="' + esc(id) + '">Hinzufügen</button>' +
      "</div>";
  }

  // Liest ein Auswahlfeld aus — als echtes Array, nicht als Komma-Text.
  function auswahlLesen(overlay, id) {
    var box = overlay.querySelector('[data-tags="' + id + '"]');
    if (!box) return [];
    return $$('input[type="checkbox"]', box)
      .filter(function (i) { return i.checked; })
      .map(function (i) { return i.value; });
  }

  // Haken setzen faerbt das Etikett; das Eingabefeld legt neue Etiketten an.
  function auswahlVerdrahten(overlay, id) {
    var box = overlay.querySelector('[data-tags="' + id + '"]');
    if (!box) return;

    box.addEventListener("change", function (e) {
      var label = e.target.closest(".amkch-tag");
      if (label) label.classList.toggle("is-on", e.target.checked);
    });

    var feld = overlay.querySelector('[data-tagadd="' + id + '"]');
    var knopf = overlay.querySelector('[data-tagbtn="' + id + '"]');

    var anlegen = function () {
      var werte = String(feld.value || "").split(",")
        .map(function (x) { return x.trim(); }).filter(Boolean);
      if (!werte.length) return;

      werte.forEach(function (wert) {
        var da = $$('input[type="checkbox"]', box).filter(function (i) {
          return i.value.toLowerCase() === wert.toLowerCase();
        })[0];
        if (da) { da.checked = true; da.closest(".amkch-tag").classList.add("is-on"); return; }

        var label = document.createElement("label");
        label.className = "amkch-tag is-on";
        label.innerHTML = '<input type="checkbox" value="' + esc(wert) + '" checked><span>' + esc(wert) + "</span>";
        box.appendChild(label);
      });
      feld.value = "";
    };

    if (knopf) knopf.addEventListener("click", anlegen);
    feld.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); anlegen(); }
    });
  }

  /* Logo per Link: Vorschau, damit ein toter Link sofort auffaellt und nicht
     erst auf der Hauptfront. */
  function logoVorschau(url) {
    return '<div class="amkch-logo-vorschau" id="chLogoVorschau">' +
      (url
        ? '<img src="' + esc(url) + '" alt="" id="chLogoBild">' +
          '<small>Sieht das richtig aus, ist der Link in Ordnung.</small>'
        : '<span class="amkch-logo-leer">Noch kein Logo</span>' +
          "<small>Link einsetzen — die Vorschau erscheint sofort.</small>") +
      "</div>";
  }

  function logoVerdrahten(overlay) {
    var feld = overlay.querySelector("#chLogo");
    var kasten = overlay.querySelector("#chLogoVorschau");
    if (!feld || !kasten) return;

    var zeichnen = function () {
      var url = String(feld.value || "").trim();
      if (!url) {
        kasten.className = "amkch-logo-vorschau";
        kasten.innerHTML = '<span class="amkch-logo-leer">Noch kein Logo</span>' +
          "<small>Link einsetzen — die Vorschau erscheint sofort.</small>";
        return;
      }
      kasten.className = "amkch-logo-vorschau is-laedt";
      kasten.innerHTML = '<img alt=""><small>Lädt …</small>';
      var bild = kasten.querySelector("img");
      bild.onload = function () {
        kasten.className = "amkch-logo-vorschau";
        kasten.querySelector("small").textContent =
          "Geladen — " + bild.naturalWidth + " × " + bild.naturalHeight + " Pixel.";
      };
      bild.onerror = function () {
        kasten.className = "amkch-logo-vorschau is-fehler";
        kasten.innerHTML = '<span class="amkch-logo-leer">✕</span>' +
          "<small>Dieser Link liefert kein Bild. Bitte die Adresse prüfen — " +
          "sie muss direkt auf die Bilddatei zeigen (.svg, .png, .webp).</small>";
      };
      bild.src = url;
    };

    var warten = null;
    feld.addEventListener("input", function () {
      clearTimeout(warten);
      warten = setTimeout(zeichnen, 420);
    });
    feld.addEventListener("change", zeichnen);
  }

  /* ============================================================================
     CASINO-EDITOR
  ============================================================================ */
  function openEditor(c, vorgabe) {
    // Der Editor braucht die Kanaele (fuer die Platzierungen) und die
    // Buchhaltungs-Casinos. Wird er aus der Ansicht "Webseiten" heraus
    // geoeffnet, ohne dass der Casino-Hub vorher offen war, sind beide noch
    // leer — dann fehlten im Fenster ausgerechnet die Haken "Wo soll es
    // erscheinen?". Also erst holen, dann oeffnen.
    if (!HUB.channels.length) {
      api("hub_casinos").then(function (data) {
        HUB.casinos = data.casinos || HUB.casinos;
        HUB.channels = window.AMKZ_KANAELE_SICHTBAR(data.channels);
        HUB.accounting = data.accounting || [];
        if (HUB.channels.length) openEditor(c, vorgabe);
        else toast("Fehler", "Die Kanäle konnten nicht geladen werden.", "error");
      }).catch(function (err) {
        toast("Fehler", err.message, "error");
      });
      return;
    }

    var isEdit = !!c;
    // Wird der Editor aus einer Kanal-Ansicht heraus geoeffnet ("Webseiten"),
    // ist dieser Kanal beim Anlegen gleich angehakt — sonst legt man ein
    // Casino an und wundert sich, dass es nirgends auftaucht.
    var vorgabeKanal = (vorgabe && vorgabe.channel) || null;
    var v = function (f, d) { return esc(c && c[f] != null ? c[f] : (d || "")); };
    var n = function (f) { return Number(c && c[f]) || 0; };
    var arr = function (f) { return esc(((c && c[f]) || []).join(", ")); };
    // Max. Bonus steht in zwei Spalten (Zahl + Einheit), im Fenster aber in
    // einem Feld. Euro bleibt unsichtbar wie bisher, alles andere wird
    // angehaengt — damit dort wieder genau das steht, was man getippt hat.
    var maxBonusAnzeige = function (casino) {
      if (!casino) return "";
      var betrag = Number(casino.max_bonus) || 0;
      var einheit = String(casino.max_bonus_unit || "€").trim() || "€";
      var text = String(betrag).replace(".", ",");
      return esc(einheit === "€" ? text : text + " " + einheit);
    };

    var overlay = document.createElement("div");
    overlay.className = "amkch-modal";
    overlay.innerHTML =
      '<div class="amkch-modal-card">' +
        '<div class="amkch-modal-head">' +
          "<div><h3>" + (isEdit ? "Casino bearbeiten" : "Casino anlegen") + "</h3>" +
          "<p>" + (isEdit ? esc(c.name) : "Einmal ausfüllen — danach überall verfügbar.") + "</p></div>" +
          '<button class="amkch-modal-close" type="button">✕</button>' +
        "</div>" +
        '<div class="amkch-modal-body">' +

          '<div class="amkch-section">Grunddaten</div>' +
          '<div class="amkch-row">' +
            '<div class="amkch-field"><label>Name *</label><input id="chName" value="' + v("name") + '" placeholder="IZZI"></div>' +
            '<div class="amkch-field"><label>Markengruppe</label><input id="chBrand" value="' + v("brand_group") + '" placeholder="roy / freshbet"></div>' +
          "</div>" +
          '<div class="amkch-row">' +
            '<div class="amkch-field"><label>Logo — Link zur Bilddatei</label>' +
              '<input id="chLogo" value="' + v("logo_url") + '" placeholder="https://…/logo.svg">' +
              "<small>Direkter Link auf die Datei (.svg, .png, .webp). Rechtsklick auf das " +
              "Logo im Affiliate-Backend → „Bildadresse kopieren“.</small>" +
              logoVorschau(c && c.logo_url) + "</div>" +
            '<div class="amkch-field"><label>Logo-Zuschnitt</label>' +
              '<select id="chLogoStyle">' +
                '<option value=""' + (!c || !c.logo_style ? " selected" : "") + ">normal (breit)</option>" +
                '<option value="sq"' + (c && c.logo_style === "sq" ? " selected" : "") + ">quadratisch</option>" +
                '<option value="sqw"' + (c && c.logo_style === "sqw" ? " selected" : "") + ">quadratisch, weiß</option>" +
              "</select></div>" +
          "</div>" +
          '<div class="amkch-row">' +
            '<div class="amkch-field"><label>Markenfarbe</label><input id="chColor" value="' + v("brand_color", "#e6b85c") + '"></div>' +
            '<div class="amkch-field"><label>Länder</label>' +
              auswahlfeld("countries", LAND_KATALOG, (c && c.countries) || ["DE", "AT", "CH"], "78px") + "</div>" +
          "</div>" +

          '<div class="amkch-section">Angebot (steht auf allen Seiten)</div>' +
          '<div class="amkch-field"><label>Bonus-Text</label>' +
            '<input id="chBonus" value="' + v("bonus_text") + '" placeholder="300 % Bonuspaket bis 1.500 € + 500 Freispiele"></div>' +
          '<div class="amkch-row3">' +
            '<div class="amkch-field"><label>Bonus %</label><input type="number" id="chBonusPct" value="' + n("bonus_pct") + '"></div>' +
            '<div class="amkch-field"><label>Max. Bonus</label>' +
              '<input id="chMaxBonus" value="' + maxBonusAnzeige(c) + '" placeholder="1500 oder 1 BTC">' +
              "<small>Zahl allein = Euro. Andere Währung dahinterschreiben: " +
              "<code>1 BTC</code>, <code>0,05 ETH</code>, <code>250 USD</code>.</small></div>" +
            '<div class="amkch-field"><label>Freispiele</label><input type="number" id="chFreespins" value="' + n("freespins") + '"></div>' +
          "</div>" +
          "<p class='amkch-hint'>Diese drei Zahlen steuern die Sortierung auf der Hauptfront " +
          "(Höchster Bonus, Meiste Freispiele).</p>" +
          '<div class="amkch-row">' +
            '<div class="amkch-field"><label>Bonuscode</label><input id="chCode" value="' + v("promo_code") + '" placeholder="NOURIAMK"></div>' +
            '<div class="amkch-field"><label>Auszahlungstext</label><input id="chPayout" value="' + v("payout_text") + '" placeholder="1 Std. Crypto · 2–3 Std. Bank"></div>' +
          "</div>" +
          '<div class="amkch-field"><label>Freispiele ohne Einzahlung</label>' +
            '<select id="chNoDep">' +
              '<option value="0"' + (!c || !c.auto_no_deposit ? " selected" : "") + ">Nein — der Code gibt nur den Bonus</option>" +
              '<option value="1"' + (c && c.auto_no_deposit ? " selected" : "") + ">Ja — Freispiele ohne Einzahlung mit dem Code</option>" +
            "</select>" +
            "<small>Mit „Ja“ steht das Angebot auf der Karte der Hauptfront ganz oben, " +
            "und der Code-Knopf bekommt das Geschenk-Zeichen. WIE VIELE Freispiele es " +
            "sind, steht in der Hinweiszeile darüber — z. B. „250 Freispiele OHNE " +
            "Einzahlung … Crown Coins von Endorphina“ bei SpinBetter.</small></div>" +
          '<div class="amkch-field"><label>Gewinnspiel</label>' +
            '<select id="chGiveaway">' +
              '<option value="1"' + (!c || c.in_giveaway !== false ? " selected" : "") + ">Ja — Einzahlungen zählen für Tickets</option>" +
              '<option value="0"' + (c && c.in_giveaway === false ? " selected" : "") + ">Nein — nur Partner-Casino, keine Tickets</option>" +
            "</select>" +
            "<small>Bei „Nein“ nimmt die Giveaway-Function keine Einzahlungen für dieses Casino an " +
            "und die Karte auf der Hauptfront trägt „Partner Casino“ statt „Giveaway Casino“.</small></div>" +
          '<div class="amkch-field"><label>Bonusart</label>' +
            '<select id="chSticky">' +
              '<option value=""' + (!c || !c.bonus_sticky ? " selected" : "") + ">— noch nicht geprüft —</option>" +
              '<option value="nonsticky"' + (c && c.bonus_sticky === "nonsticky" ? " selected" : "") + ">Nonsticky — erst das eigene Geld, Auszahlen jederzeit möglich</option>" +
              '<option value="sticky"' + (c && c.bonus_sticky === "sticky" ? " selected" : "") + ">Sticky — Einzahlung und Bonus verschmelzen, Auszahlen erst nach Umsatz</option>" +
              '<option value="rmw"' + (c && c.bonus_sticky === "rmw" ? " selected" : "") + ">Real Money Wager — sticky, aber der Umsatz zählt auf dein Echtgeld</option>" +
            "</select>" +
            "<small>Steht als Abzeichen auf der Karte und als „Bonusart“ auf der Deal-Seite. " +
            "Solange hier nichts steht, behaupten die Seiten gar nichts — vorher stand bei " +
            "<em>jedem</em> Casino fest „Nonsticky“ im Code.<br>" +
            "<b>Real Money Wager</b> ist die Krypto-Variante von Sticky: derselbe Umsatzfaktor, " +
            "aber gerechnet auf deine Einzahlung statt auf den Bonus — also viel weniger " +
            "Umsatz. Im Zweifel steht es in den Bonusbedingungen des Casinos.</small></div>" +
          '<div class="amkch-row">' +
            '<div class="amkch-field"><label>Auszahlungs-Rang</label><input type="number" id="chPayoutRank" value="' + (n("payout_rank") || 3) + '">' +
              "<small>1 = am schnellsten, für die Sortierung</small></div>" +
            '<div class="amkch-field"><label>Button-Text</label><input id="chCta" value="' + v("cta_text", "Jetzt spielen") + '"></div>' +
          "</div>" +
          '<div class="amkch-field"><label>Hinweiszeile (darf &lt;strong&gt; enthalten)</label>' +
            '<textarea id="chHighlight">' + v("highlight_html") + "</textarea></div>" +
          '<div class="amkch-field"><label>Kurzbeschreibung</label><textarea id="chDesc">' + v("description") + "</textarea></div>" +
          '<div class="amkch-field"><label>Kleingedrucktes</label><input id="chTerms" value="' + v("terms_text") + '"></div>' +
          '<div class="amkch-field"><label>Spieleanbieter</label>' +
            auswahlfeld("providers", ANBIETER_KATALOG, (c && c.providers) || []) +
            "<small>Erscheint auf der Hauptfront in den Karten-Details.</small></div>" +
          '<div class="amkch-field"><label>Zahlungsmethoden — anklicken, was das Casino annimmt</label>' +
            auswahlfeld("payment_methods", ZAHLUNG_KATALOG, (c && c.payment_methods) || []) +
            "<small>Steht in der aufgeklappten Karte und wird auf den Partnerseiten " +
            "mit ausgespielt.</small></div>" +
          '<div class="amkch-section">Nur für einzelne Seiten</div>' +
          "<p class='amkch-hint'>Diese vier Felder braucht nicht jede Seite. Bleiben sie leer, " +
          "greifen sinnvolle Ersatzwerte — die Hauptfront benutzt sie ohnehin nicht.</p>" +
          '<div class="amkch-row">' +
            '<div class="amkch-field"><label>Kurzangebot (300K)</label>' +
              '<input id="chBonusShort" value="' + v("bonus_short") + '" placeholder="300% bis 1.500€ + 500 FS">' +
              "<small>Die 300K-Kacheln sind schmal. Leer = der lange Bonus-Text von oben.</small></div>" +
            '<div class="amkch-field"><label>Sterne (Tschechien)</label>' +
              '<input type="number" step="0.1" min="0" max="5" id="chRating" value="' + (c ? n("rating") : 0) + '">' +
              "<small>0 blendet die Bewertung aus.</small></div>" +
          "</div>" +
          '<div class="amkch-row">' +
            '<div class="amkch-field"><label>Ersatzzeichen</label>' +
              '<input id="chInitials" maxlength="4" value="' + v("initials") + '" placeholder="BS">' +
              "<small>Steht da, wenn das Logo nicht lädt. Leer = zwei Buchstaben des Namens.</small></div>" +
            '<div class="amkch-field"><label>Stichpunkte (Tschechien)</label>' +
              '<input id="chFeatures" value="' + arr("features") + '" placeholder="200 free spinů, Rychlé výplaty">' +
              "<small>Mit Komma trennen. Erscheinen unter der Karte.</small></div>" +
          "</div>" +

          '<div class="amkch-field"><label>Bonuspaket (JSON, optional)</label>' +
            '<textarea id="chPackage" class="amkch-mono" placeholder=\'{"sum":"…","steps":[{"n":1,"main":"100% bis 600€","extra":"","min":"ab 20€"}],"wagerBonus":40}\'>' +
            (c && c.package ? esc(JSON.stringify(c.package, null, 2)) : "") + "</textarea>" +
            "<small>Erzeugt die aufklappbare Paket-Ansicht auf der Hauptfront. Leer lassen = kein Paket.</small></div>" +

          '<div class="amkch-section">Verlinkung</div>' +
          '<div class="amkch-field"><label>Dein Link (Front, 300K, Tschechien)</label>' +
            '<input id="chCtaUrl" value="' + v("cta_url") + '" placeholder="https://izziway65.com/…"></div>' +
          '<div class="amkch-row">' +
            '<div class="amkch-field"><label>Partnerlink mit {SUBID}</label>' +
              '<input id="chTracker" value="' + v("tracker_url") + '" placeholder="https://…?subid={SUBID}"></div>' +
            '<div class="amkch-field"><label>SubID-Parameter</label>' +
              '<input id="chSubidParam" value="' + v("subid_param", "subid") + '"></div>' +
          "</div>" +
          "<p class='amkch-hint'>Fehlt <code>{SUBID}</code> im Partnerlink, hängt das System " +
          "den Parameter selbst an. Welchen dein Programm erwartet, sagt dir der Affiliate-Manager.</p>" +

          '<div class="amkch-section">Konditionen — nur intern</div>' +
          '<div class="amkch-internal">' +
            '<p class="amkch-hint">Diese Werte bekommen weder die Hauptfront noch die ' +
            "Vertriebspartner zu sehen. Der Partner sieht ausschließlich seine Provision in Euro.</p>" +
            '<div class="amkch-row">' +
              '<div class="amkch-field"><label>CPA €</label><input type="number" step="0.01" id="chCpa" value="' + n("cpa") + '"></div>' +
              '<div class="amkch-field"><label>Baseline €</label><input type="number" step="0.01" id="chBaseline" value="' + n("baseline") + '"></div>' +
            "</div>" +
            '<div class="amkch-row">' +
              '<div class="amkch-field"><label>RevShare %</label><input type="number" step="0.01" id="chRevshare" value="' + n("revshare_pct") + '"></div>' +
              '<div class="amkch-field"><label>RAF-Share %</label><input type="number" step="0.01" id="chRaf" value="' + n("raf_share") + '"></div>' +
            "</div>" +
            '<div class="amkch-row">' +
              '<div class="amkch-field"><label>Affiliate-Manager</label><input id="chManager" value="' + v("affiliate_manager") + '"></div>' +
              '<div class="amkch-field"><label>Affiliate-Backend</label><input id="chBackend" value="' + v("affiliate_backend") + '"></div>' +
            "</div>" +
            '<div class="amkch-field"><label>Deal-Notiz</label><textarea id="chDealNote">' + v("deal_note") + "</textarea></div>" +
            '<div class="amkch-row">' +
              '<div class="amkch-field"><label>Partner-Provision € pro FTD</label>' +
                '<input type="number" step="0.01" id="chPartnerCom" value="' + (c ? n("partner_commission") : 50) + '"></div>' +
              '<div class="amkch-field"><label>Buchhaltung (Casino der Zentrale)</label>' +
                '<select id="chAccounting"><option value="">— nicht verknüpft —</option>' +
                HUB.accounting.map(function (a) {
                  return '<option value="' + esc(a.id) + '"' +
                    (c && c.zentrale_casino_id === a.id ? " selected" : "") + ">" + esc(a.name) + "</option>";
                }).join("") + "</select>" +
                "<small>Verbindet den Hub mit deiner bestehenden Deal-Rechnung.</small></div>" +
            "</div>" +
          "</div>" +

          '<div class="amkch-section">Wo soll es erscheinen?</div>' +
          '<div class="amkch-placements">' +
            HUB.channels.map(function (ch) {
              var p = c ? placementOf(c, ch.key) : null;
              var on = p ? p.is_enabled : (ch.key === vorgabeKanal);
              return '<div class="amkch-placement">' +
                '<label class="amkch-check">' +
                  '<input type="checkbox" data-pl="' + esc(ch.key) + '"' + (on ? " checked" : "") + "><span></span>" +
                "</label>" +
                "<div><strong>" + esc(ch.label) + "</strong><small>" + esc(ch.description || "") + "</small></div>" +
                '<input class="amkch-rank" type="number" min="1" max="99" data-plrank="' + esc(ch.key) + '" value="' +
                  (p ? p.rank : 99) + '" title="Position">' +
                '<label class="amkch-feat"><input type="checkbox" data-plfeat="' + esc(ch.key) + '"' +
                  (p && p.featured ? " checked" : "") + "> hervorheben</label>" +
              "</div>";
            }).join("") +
          "</div>" +

          '<div class="amkch-section">Status</div>' +
          '<div class="amkch-field"><label>Casino aktiv</label>' +
            '<select id="chActive">' +
              '<option value="1"' + (!c || c.is_active !== false ? " selected" : "") + ">Ja — überall dort sichtbar, wo freigegeben</option>" +
              '<option value="0"' + (c && c.is_active === false ? " selected" : "") + ">Nein — überall ausgeblendet</option>" +
            "</select></div>" +
        "</div>" +
        '<div class="amkch-modal-foot">' +
          (isEdit ? '<button class="amkch-btn danger" type="button" id="chDelete">Löschen</button>' : "") +
          '<button class="amkch-btn ghost" type="button" id="chCancel">Abbrechen</button>' +
          '<button class="amkch-btn" type="button" id="chSave">Speichern</button>' +
        "</div>" +
      "</div>";

    document.body.appendChild(overlay);
    document.body.style.overflow = "hidden";

    logoVerdrahten(overlay);
    ["countries", "providers", "payment_methods"].forEach(function (id) {
      auswahlVerdrahten(overlay, id);
    });

    var close = function () {
      overlay.remove();
      document.body.style.overflow = "";
    };
    overlay.querySelector(".amkch-modal-close").addEventListener("click", close);
    byId("chCancel").addEventListener("click", close);
    overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
    /* Nachtschicht 31.10. (#89): Esc schließt den Editor wie alle anderen Fenster */
    var escClose = function (e) { if (e.key !== "Escape") return; document.removeEventListener("keydown", escClose); if (document.body.contains(overlay)) close(); };
    document.addEventListener("keydown", escClose);

    // Position und Hervorheben nur bedienbar, wenn der Kanal angehakt ist
    $$("[data-pl]", overlay).forEach(function (box) {
      var sync = function () {
        var rank = overlay.querySelector('[data-plrank="' + box.dataset.pl + '"]');
        var feat = overlay.querySelector('[data-plfeat="' + box.dataset.pl + '"]');
        if (rank) rank.disabled = !box.checked;
        if (feat) feat.disabled = !box.checked;
      };
      box.addEventListener("change", sync);
      sync();
    });

    if (isEdit) {
      byId("chDelete").addEventListener("click", function () {
        if (!confirm('"' + c.name + '" wirklich löschen? Wenn schon Provisionen gebucht sind, geht das nicht — dann bitte nur deaktivieren.')) return;
        api("hub_delete_casino", { casino_id: c.id })
          .then(function () { toast("Gelöscht", c.name); close(); gemeldet("delete"); renderHub(); })
          .catch(function (err) { toast("Nicht möglich", err.message, "error"); });
      });
    }

    byId("chSave").addEventListener("click", function () {
      var btn = this;
      var val = function (id) { return (byId(id) || {}).value || ""; };

      if (!val("chName").trim()) return toast("Name fehlt", "Bitte einen Casino-Namen eingeben.", "error");

      var placements = HUB.channels.map(function (ch) {
        var box = overlay.querySelector('[data-pl="' + ch.key + '"]');
        var rank = overlay.querySelector('[data-plrank="' + ch.key + '"]');
        var feat = overlay.querySelector('[data-plfeat="' + ch.key + '"]');
        return {
          channel: ch.key,
          is_enabled: !!(box && box.checked),
          rank: rank ? rank.value : 99,
          featured: !!(feat && feat.checked)
        };
      });

      btn.disabled = true;
      btn.textContent = "Speichert …";

      api("hub_save_casino", {
        id: c ? c.id : "",
        name: val("chName"),
        brand_group: val("chBrand"),
        logo_url: val("chLogo"),
        logo_style: val("chLogoStyle"),
        brand_color: val("chColor"),
        countries: auswahlLesen(overlay, "countries"),
        bonus_text: val("chBonus"),
        bonus_pct: val("chBonusPct"),
        max_bonus: val("chMaxBonus"),
        freespins: val("chFreespins"),
        promo_code: val("chCode"),
        payout_text: val("chPayout"),
        bonus_sticky: val("chSticky"),
        auto_no_deposit: val("chNoDep") === "1",
        in_giveaway: val("chGiveaway") !== "0",
        payout_rank: val("chPayoutRank"),
        cta_text: val("chCta"),
        highlight_html: val("chHighlight"),
        description: val("chDesc"),
        terms_text: val("chTerms"),
        bonus_short: val("chBonusShort"),
        rating: val("chRating"),
        initials: val("chInitials"),
        features: val("chFeatures"),
        providers: auswahlLesen(overlay, "providers"),
        payment_methods: auswahlLesen(overlay, "payment_methods"),
        package: val("chPackage"),
        cta_url: val("chCtaUrl"),
        tracker_url: val("chTracker"),
        subid_param: val("chSubidParam"),
        cpa: val("chCpa"),
        baseline: val("chBaseline"),
        revshare_pct: val("chRevshare"),
        raf_share: val("chRaf"),
        affiliate_manager: val("chManager"),
        affiliate_backend: val("chBackend"),
        deal_note: val("chDealNote"),
        partner_commission: val("chPartnerCom"),
        zentrale_casino_id: val("chAccounting"),
        is_active: val("chActive") === "1",
        placements: placements
      }).then(function () {
        toast("Gespeichert", val("chName") + " ist aktualisiert.");
        close();
        gemeldet("save");
        renderHub();
      }).catch(function (err) {
        toast("Fehler", err.message, "error");
        btn.disabled = false;
        btn.textContent = "Speichern";
      });
    });
  }


  /* ============================================================================
     START
     Kein Selbst-Einhaengen mehr: Navigationsknopf und Ansicht stehen fest im
     Markup, der Eintrag steht in VIEW_CONFIG. Es bleibt die Kette an
     loadView — dieselbe Form, die auch die uebrigen Bereiche verwenden.
  ============================================================================ */
  // Beim Zentrale-Login nebenbei eine Hub-Sitzung holen, damit niemand ein
  // zweites Mal ein Passwort eintippen muss. Das Anmeldeformular steht fest
  // im Markup, ein einmaliger Aufruf genuegt.
  hookLogin();

  const zuvor = AMKZ.loadView;
  AMKZ.loadView = async function casinohubChain(view, options) {
    const ergebnis = await zuvor?.call(this, view, options);
    if (view === "casinohub") await renderHub();
    return ergebnis;
  };

  window.AMK_CASINO_HUB = {
    render: renderHub,
    state: HUB,
    api: api,
    login: hubLogin,
    openEditor: openEditor,
    toast: toast,
    esc: esc,
    kataloge: {
      zahlung: ZAHLUNG_KATALOG,
      anbieter: ANBIETER_KATALOG,
      laender: LAND_KATALOG
    }
  };
})();


/* ============================================================================
   WEBSEITEN
   Je Seite: welche Casinos stehen auf der Hauptfront und im 300K-Giveaway,
   in welcher Reihenfolge, was ist hervorgehoben, ist die Seite online.
   Seit 22.10.2026 der einzige Ort dafür — der Bereich „Casino-Hub" ist raus,
   sein Code läuft unsichtbar weiter (Anmeldung + Casino-Editor, auch für
   Halloween). Tschechien und Partnerprogramm sind ausgeblendet.

   Nutzt die Anmeldung und den Casino-Editor des Blocks darüber; beides darf
   es nur einmal geben. Deshalb steht dieser Block hinter dem Casino-Hub.
============================================================================ */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;

  "use strict";

  var API = (window.AMK_HUB_API ||
    "https://cbwxgikndyyzdslmfpmo.supabase.co/functions/v1/vertrieb");

  var WS = {
    kanal: localStorage.getItem("amkws_kanal") || "front",
    casinos: [],
    channels: [],
    geladen: false,
    // Reihenfolge, die gerade auf dem Bildschirm steht — erst mit
    // "Reihenfolge speichern" geht sie an den Server. Sonst würde jedes
    // Verschieben eine Schreiboperation je Casino auslösen.
    reihenfolge: [],
    gespeicherteReihenfolge: [],
  };

  var byId = function (id) { return document.getElementById(id); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  function esc(v) {
    return String(v == null ? "" : v).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[c];
    });
  }
  function intDe(v) { return (Number(v) || 0).toLocaleString("de-DE"); }
  function eur(v) {
    return (Number(v) || 0).toLocaleString("de-DE", {
      style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 2
    });
  }

  function hub() { return window.AMK_CASINO_HUB || null; }

  // Alles läuft über dieselbe Anmeldung wie der Casino-Hub. Gibt es das
  // Hub-Modul nicht, arbeitet dieses hier mit dem gespeicherten Token weiter —
  // dann fehlt nur der Casino-Editor.
  function api(action, payload) {
    var h = hub();
    if (h && typeof h.api === "function") return h.api(action, payload);

    return fetch(API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Object.assign(
        { action: action, token: localStorage.getItem("amkch_token") || "" },
        payload || {}
      ))
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok || data.ok === false) throw new Error(data.error || "Unbekannter Fehler");
        return data;
      });
    });
  }

  function toast(title, message, type) {
    if (window.AMKZ && typeof window.AMKZ.toast === "function") {
      return window.AMKZ.toast(title, message || "", type || "success");
    }
    var h = hub();
    if (h && typeof h.toast === "function") return h.toast(title, message, type);
    console.log(title, message);
  }

  /* ============================================================================
     EINBAU IN DIE ZENTRALE
  ============================================================================ */




  /* ============================================================================
     DATEN
  ============================================================================ */
  async function laden() {
    var data = await api("hub_casinos");
    WS.casinos = data.casinos || [];
    WS.channels = window.AMKZ_KANAELE_SICHTBAR(data.channels);
    WS.geladen = true;
    reihenfolgeAusDaten();

    // Denselben Stand auch dem Casino-Hub geben. Beide Ansichten holen
    // dieselbe Antwort; ohne das steht der Hub beim Wechsel auf altem Stand
    // und sein Editor haette keine Kanaele zum Anhaken.
    var h = hub();
    if (h && h.state) {
      h.state.casinos = WS.casinos;
      h.state.channels = WS.channels;
      h.state.accounting = data.accounting || h.state.accounting || [];
      h.state.loaded = true;
    }
  }

  function platzierung(casino, kanal) {
    return (casino.placements || []).filter(function (p) { return p.channel === kanal; })[0] || null;
  }

  function aufSeite(kanal) {
    return WS.casinos
      .filter(function (c) {
        var p = platzierung(c, kanal);
        return p && p.is_enabled;
      })
      .sort(function (a, b) {
        return (platzierung(a, kanal).rank || 99) - (platzierung(b, kanal).rank || 99);
      });
  }

  function nichtAufSeite(kanal) {
    return WS.casinos.filter(function (c) {
      var p = platzierung(c, kanal);
      return !(p && p.is_enabled);
    }).sort(function (a, b) { return String(a.name).localeCompare(String(b.name), "de"); });
  }

  function reihenfolgeAusDaten() {
    WS.reihenfolge = aufSeite(WS.kanal).map(function (c) { return c.id; });
    WS.gespeicherteReihenfolge = WS.reihenfolge.slice();
  }

  function reihenfolgeGeaendert() {
    if (WS.reihenfolge.length !== WS.gespeicherteReihenfolge.length) return true;
    for (var i = 0; i < WS.reihenfolge.length; i++) {
      if (WS.reihenfolge[i] !== WS.gespeicherteReihenfolge[i]) return true;
    }
    return false;
  }

  function casinoById(id) {
    return WS.casinos.filter(function (c) { return c.id === id; })[0] || null;
  }

  function kanalInfo(key) {
    return WS.channels.filter(function (c) { return c.key === key; })[0] ||
      { key: key, label: key, description: "", is_public: true };
  }

  // Wohin zeigt die fertige Seite? Für die öffentlichen Kanäle gibt es feste
  // Adressen; sie stehen hier und nicht in der Datenbank, weil sie sich seit
  // Jahren nicht ändern und ein leerer Knopf schlimmer wäre als ein fester.
  var SEITEN_ADRESSE = {
    front: "https://nouri-amk.com/",
    k300: "https://nouri-amk.com/pages/300k",
    cz: "https://nouri-amk.com/pages/cz",
    vertrieb: "https://nouri-amk.com/pages/vertrieb-portal"
  };

  // Alle vier Seiten lesen ihre Casinos inzwischen aus dem Hub:
  //   front    → FRONT/front.js            ruft /casinos/front ab
  //   k300     → 300 K/300k.js             ruft /casinos/k300 ab
  //   cz       → Tschechien/front-tschechien.js ruft /casinos/cz ab
  //   vertrieb → die Partner waehlen aus, was im Vertriebs-Admin freigegeben ist
  //
  // Alle drei oeffentlichen Seiten haben ein Sicherheitsnetz: ist der Hub
  // nicht erreichbar, leer oder braucht laenger als vier Sekunden, zeigen sie
  // ihre eingebaute Liste. Eine leere Seite kann es dadurch nicht geben.

  /* ============================================================================
     ANSICHT
  ============================================================================ */
  function renderAnmeldung(nachricht) {
    byId("amkwsRoot").innerHTML =
      '<div class="amkws-panel amkws-login">' +
        "<h3>Webseiten</h3>" +
        "<p>" + esc(nachricht || "Zum Steuern der Seiten einmal mit deinem Zentrale-Passwort anmelden. Die Anmeldung hält 30 Tage und gilt auch für den Casino-Hub.") + "</p>" +
        '<div class="amkws-field"><label>E-Mail</label>' +
          '<input type="email" id="amkwsEmail" autocomplete="email" value="' +
            esc((window.AMKZ && window.AMKZ.state && window.AMKZ.state.member &&
                 window.AMKZ.state.member.email) || "") + '"></div>' +
        '<div class="amkws-field"><label>Passwort</label>' +
          '<input type="password" id="amkwsPass" autocomplete="current-password"></div>' +
        '<button class="amkws-btn" type="button" id="amkwsLoginBtn">Anmelden</button>' +
        '<div class="amkws-msg" id="amkwsLoginMsg"></div>' +
      "</div>";

    byId("amkwsLoginBtn").addEventListener("click", function () {
      var btn = this;
      var msg = byId("amkwsLoginMsg");
      var h = hub();
      if (!h || typeof h.login !== "function") {
        msg.className = "amkws-msg is-error";
        msg.textContent = "Der Casino-Hub ist nicht geladen. Bitte die Seite neu laden.";
        return;
      }
      msg.className = "amkws-msg";
      btn.disabled = true;
      btn.textContent = "Meldet an …";
      h.login(byId("amkwsEmail").value, byId("amkwsPass").value)
        .then(function () { render(); })
        .catch(function (err) {
          msg.className = "amkws-msg is-error";
          msg.textContent = err.message;
          btn.disabled = false;
          btn.textContent = "Anmelden";
        });
    });
  }

  async function render() {
    var root = byId("amkwsRoot");
    if (!root) return;

    var h = hub();
    var token = (h && h.state && h.state.token) || localStorage.getItem("amkch_token") || "";
    if (!token) return renderAnmeldung();

    root.innerHTML = '<div class="amkws-panel"><div class="amkws-empty">Lädt Seiten …</div></div>';

    try {
      await laden();
    } catch (err) {
      if (/Nicht angemeldet/.test(err.message)) {
        localStorage.removeItem("amkch_token");
        if (h && h.state) h.state.token = "";
        return renderAnmeldung("Die Anmeldung ist abgelaufen. Bitte erneut anmelden.");
      }
      root.innerHTML = '<div class="amkws-panel"><div class="amkws-empty">⚠ ' + esc(err.message) + "</div></div>";
      return;
    }

    if (!WS.channels.some(function (c) { return c.key === WS.kanal; })) {
      WS.kanal = (WS.channels[0] || {}).key || "front";
      reihenfolgeAusDaten();
    }

    zeichne();
  }

  function zeichne() {
    var root = byId("amkwsRoot");
    var info = kanalInfo(WS.kanal);
    var drauf = WS.reihenfolge.map(casinoById).filter(Boolean);
    var draussen = nichtAufSeite(WS.kanal);
    var adresse = SEITEN_ADRESSE[WS.kanal] || "";

    root.innerHTML =
      '<div class="amkws-head">' +
        "<div><h3>Casinos je Seite</h3>" +
        "<p>Jede Seite bekommt genau die Casinos, die hier stehen — in genau dieser " +
        "Reihenfolge. Änderungen sind sofort live, ein Deploy ist nicht nötig.</p></div>" +
        '<div class="amkws-head-actions">' +
          '<button class="amkws-btn ghost" type="button" id="amkwsRefresh">Neu laden</button>' +
          '<button class="amkws-btn" type="button" id="amkwsNew">+ Casino anlegen</button>' +
        "</div>" +
      "</div>" +

      /* ---- Kanalauswahl ---- */
      '<div class="amkws-kanaele">' +
        WS.channels.map(function (ch) {
          var n = aufSeite(ch.key).length;
          return '<button type="button" class="amkws-kanal' +
            (ch.key === WS.kanal ? " is-on" : "") + '" data-kanal="' + esc(ch.key) + '">' +
            "<strong>" + esc(ch.label) + "</strong>" +
            "<span>" + intDe(n) + (n === 1 ? " Casino" : " Casinos") + "</span>" +
            "<small>" + esc(ch.description || "") + "</small>" +
            (ch.is_public === false ? '<i class="amkws-intern">intern</i>' : "") +
            (ch.is_online === false ? '<i class="amkws-offen">offline</i>' : "") +
          "</button>";
        }).join("") +
      "</div>" +

      /* ---- Der gewählte Kanal ---- */
      '<div class="amkws-panel">' +
        '<div class="amkws-panel-head">' +
          "<div><h4>" + esc(info.label) + "</h4>" +
          "<p>" + esc(info.description || "") + "</p></div>" +
          '<div class="amkws-panel-actions">' +
            (adresse
              ? '<a class="amkws-btn ghost" href="' + esc(adresse) + '" target="_blank" rel="noopener">Seite ansehen ↗</a>'
              : "") +
            '<button class="amkws-btn ghost" type="button" id="amkwsAdd">+ Casino aufnehmen</button>' +
          "</div>" +
        "</div>" +

        /* Der grosse Schalter: die ganze Seite an oder aus. Steht bewusst
           ueber den Listen — wer ihn umlegt, soll sehen, worauf er wirkt. */
        '<div class="amkws-schalter' + (info.is_online === false ? " is-aus" : "") + '">' +
          '<label class="amkws-kippe">' +
            '<input type="checkbox" id="amkwsOnline"' + (info.is_online === false ? "" : " checked") + ">" +
            "<span></span></label>" +
          "<div>" +
            "<strong>" + (info.is_online === false
              ? "Diese Seite zeigt gerade keine Casinos"
              : "Diese Seite ist online") + "</strong>" +
            "<p>" + (info.is_online === false
              ? "Besucher sehen statt der Casinos den Hinweistext. Die Seite selbst " +
                "bleibt erreichbar, und die Auswahl unten bleibt so, wie sie ist — " +
                "wieder anschalten stellt genau diesen Stand wieder her."
              : "Die Casinos unten stehen live auf der Seite. Zum Abschalten den " +
                "Schalter umlegen — die Auswahl bleibt dabei erhalten.") + "</p>" +
            '<div class="amkws-schalter-feld">' +
              "<label>Was steht dort, solange die Seite aus ist?</label>" +
              '<input type="text" id="amkwsOfflineNote" value="' + esc(info.offline_note || "") + '" ' +
                'placeholder="z. B. Die Aktion ist beendet — bald geht es weiter.">' +
              '<button class="amkws-btn xs ghost" type="button" id="amkwsNoteSave">Text speichern</button>' +
            "</div>" +
          "</div>" +
        "</div>" +

        '<div class="amkws-spalten">' +
          /* Links: was auf der Seite steht */
          '<div class="amkws-spalte">' +
            '<div class="amkws-spalte-kopf">' +
              "<strong>Auf dieser Seite</strong>" +
              "<small>Ziehen oder ▲▼ — Position 1 steht ganz oben</small>" +
            "</div>" +
            '<div class="amkws-liste" id="amkwsListe">' +
              (drauf.length
                ? drauf.map(zeile).join("")
                : '<div class="amkws-empty">Hier steht noch kein Casino. ' +
                  "Rechts eines aufnehmen oder oben ein neues anlegen.</div>") +
            "</div>" +
            '<div class="amkws-sichern" id="amkwsSichern">' +
              '<button class="amkws-btn" type="button" id="amkwsSave">Reihenfolge speichern</button>' +
              '<button class="amkws-btn ghost" type="button" id="amkwsReset">Verwerfen</button>' +
              "<small>Solange das hier steht, ist die neue Reihenfolge noch nicht live.</small>" +
            "</div>" +
          "</div>" +

          /* Rechts: was noch nicht drauf ist */
          '<div class="amkws-spalte amkws-spalte--rest">' +
            '<div class="amkws-spalte-kopf">' +
              "<strong>Nicht auf dieser Seite</strong>" +
              "<small>" + intDe(draussen.length) + " im Hub verfügbar</small>" +
            "</div>" +
            '<div class="amkws-liste amkws-liste--rest">' +
              (draussen.length
                ? draussen.map(restZeile).join("")
                : '<div class="amkws-empty">Alle Casinos stehen auf dieser Seite.</div>') +
            "</div>" +
          "</div>" +
        "</div>" +
      "</div>" +

      /* ---- Vorschau ---- */
      '<div class="amkws-panel">' +
        '<div class="amkws-panel-head">' +
          "<div><h4>So bekommt die Seite die Liste</h4>" +
          "<p>Genau diese Daten holt sich die Seite von der Schnittstelle — " +
          "inklusive Reihenfolge, Logo und Link. Was hier fehlt, fehlt auch dort.</p></div>" +
          '<button class="amkws-btn ghost" type="button" id="amkwsPreviewBtn">Vorschau laden</button>' +
        "</div>" +
        '<div id="amkwsPreview"><div class="amkws-empty">Auf „Vorschau laden“ tippen.</div></div>' +
      "</div>";

    verdrahten();
  }

  function logoBild(c) {
    return c.logo_url
      ? '<img src="' + esc(c.logo_url) + '" alt="" loading="lazy">'
      : '<span class="amkws-dot" style="background:' + esc(c.brand_color || "#cfae74") + '"></span>';
  }

  function zeile(c, i) {
    var p = platzierung(c, WS.kanal) || {};
    var fehlt = [];
    if (!c.logo_url) fehlt.push("Logo");
    if (!c.bonus_text) fehlt.push("Bonus-Text");
    if (!c.bonus_sticky) fehlt.push("Bonusart");
    if (!(p.cta_url_override || c.cta_url || c.tracker_url)) fehlt.push("Link");

    return '<div class="amkws-zeile' + (c.is_active === false ? " is-aus" : "") + '" ' +
        'draggable="true" data-id="' + esc(c.id) + '">' +
woher() +
      '<span class="amkws-pos">' + (i + 1) + "</span>" +
      '<span class="amkws-logo">' + logoBild(c) + "</span>" +
      '<div class="amkws-info">' +
        "<strong>" + esc(c.name) + "</strong>" +
        "<small>" + esc(c.bonus_text || "— kein Bonus-Text hinterlegt —") + "</small>" +
        (fehlt.length
          ? '<em class="amkws-fehlt">Fehlt noch: ' + esc(fehlt.join(", ")) + "</em>"
          : "") +
        (c.is_active === false
          ? '<em class="amkws-fehlt">Casino ist deaktiviert — steht auf keiner Seite</em>'
          : "") +
      "</div>" +
      '<label class="amkws-stern" title="Auf der Seite hervorheben">' +
        '<input type="checkbox" data-featured="' + esc(c.id) + '"' + (p.featured ? " checked" : "") + ">" +
        "<span>★</span></label>" +
      '<div class="amkws-pfeile">' +
        '<button type="button" data-hoch="' + esc(c.id) + '" title="Nach oben">▲</button>' +
        '<button type="button" data-runter="' + esc(c.id) + '" title="Nach unten">▼</button>' +
      "</div>" +
      '<div class="amkws-zeile-actions">' +
        '<button class="amkws-btn xs ghost" type="button" data-edit="' + esc(c.id) + '">Bearbeiten</button>' +
        '<button class="amkws-btn xs ghost" type="button" data-link="' + esc(c.id) + '">Link</button>' +
        '<button class="amkws-btn xs danger" type="button" data-ab="' + esc(c.id) + '" title="Von dieser Seite nehmen (bleibt im Hub)">Entfernen</button>' +
      "</div>" +
    "</div>";
  }

  // Griff zum Ziehen. Eigene Funktion, weil die Zeile sonst unübersichtlich wird.
  function woher() {
    return '<span class="amkws-griff" title="Zum Verschieben ziehen">⠿</span>';
  }

  function restZeile(c) {
    return '<div class="amkws-zeile amkws-zeile--rest' +
        (c.is_active === false ? " is-aus" : "") + '" data-id="' + esc(c.id) + '">' +
      '<span class="amkws-logo">' + logoBild(c) + "</span>" +
      '<div class="amkws-info">' +
        "<strong>" + esc(c.name) + "</strong>" +
        "<small>" + esc(c.bonus_text || "—") + "</small>" +
      "</div>" +
      '<div class="amkws-zeile-actions">' +
        '<button class="amkws-btn xs ghost" type="button" data-edit="' + esc(c.id) + '">Bearbeiten</button>' +
        '<button class="amkws-btn xs" type="button" data-auf="' + esc(c.id) + '">Aufnehmen</button>' +
      "</div>" +
    "</div>";
  }

  /* ============================================================================
     BEDIENUNG
  ============================================================================ */
  function verdrahten() {
    $$("[data-kanal]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (reihenfolgeGeaendert() &&
            !confirm("Die geänderte Reihenfolge ist noch nicht gespeichert. Trotzdem wechseln?")) return;
        WS.kanal = btn.dataset.kanal;
        localStorage.setItem("amkws_kanal", WS.kanal);
        reihenfolgeAusDaten();
        zeichne();
      });
    });

    byId("amkwsRefresh").addEventListener("click", function () { render(); });

    var neu = function () {
      var h = hub();
      if (!h || typeof h.openEditor !== "function") {
        return toast("Nicht möglich", "Der Casino-Hub ist nicht geladen.", "error");
      }
      h.openEditor(null, { channel: WS.kanal });
    };
    byId("amkwsNew").addEventListener("click", neu);
    byId("amkwsAdd").addEventListener("click", function () {
      var rest = document.querySelector(".amkws-liste--rest");
      if (rest && rest.querySelector(".amkws-zeile")) {
        rest.scrollIntoView({ behavior: "smooth", block: "center" });
        rest.classList.add("is-hinweis");
        setTimeout(function () { rest.classList.remove("is-hinweis"); }, 1400);
      } else {
        neu();
      }
    });

    $$("[data-edit]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var h = hub();
        if (!h || typeof h.openEditor !== "function") {
          return toast("Nicht möglich", "Der Casino-Hub ist nicht geladen.", "error");
        }
        h.openEditor(casinoById(btn.dataset.edit), { channel: WS.kanal });
      });
    });

    $$("[data-auf]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        setzePlatzierung(btn.dataset.auf, {
          is_enabled: true,
          rank: WS.reihenfolge.length + 1
        }, "aufgenommen");
      });
    });

    $$("[data-ab]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var c = casinoById(btn.dataset.ab);
        if (!confirm('"' + (c ? c.name : "") + '" von dieser Seite nehmen? ' +
          "Das Casino bleibt im Hub und auf allen anderen Seiten.")) return;
        setzePlatzierung(btn.dataset.ab, { is_enabled: false }, "entfernt");
      });
    });

    $$("[data-featured]").forEach(function (box) {
      box.addEventListener("change", function () {
        setzePlatzierung(box.dataset.featured, { featured: box.checked }, null);
      });
    });

    $$("[data-hoch]").forEach(function (btn) {
      btn.addEventListener("click", function () { verschiebe(btn.dataset.hoch, -1); });
    });
    $$("[data-runter]").forEach(function (btn) {
      btn.addEventListener("click", function () { verschiebe(btn.dataset.runter, 1); });
    });

    $$("[data-link]").forEach(function (btn) {
      btn.addEventListener("click", function () { linkDialog(btn.dataset.link); });
    });

    var schalter = byId("amkwsOnline");
    if (schalter) {
      schalter.addEventListener("change", function () {
        var an = schalter.checked;
        schalter.disabled = true;
        api("hub_set_channel", { channel: WS.kanal, is_online: an })
          .then(function () {
            toast(an ? "Seite ist online" : "Seite ist aus",
              an ? "Die Casinos stehen wieder auf der Seite."
                 : "Besucher sehen jetzt den Hinweistext.");
            return render();
          })
          .catch(function (err) {
            toast("Fehler", err.message, "error");
            schalter.checked = !an;
            schalter.disabled = false;
          });
      });
    }

    var notiz = byId("amkwsNoteSave");
    if (notiz) {
      notiz.addEventListener("click", function () {
        var wert = byId("amkwsOfflineNote").value.trim();
        notiz.disabled = true;
        api("hub_set_channel", { channel: WS.kanal, offline_note: wert })
          .then(function () {
            toast("Gespeichert", "Der Hinweistext steht bereit.");
            return render();
          })
          .catch(function (err) {
            toast("Fehler", err.message, "error");
            notiz.disabled = false;
          });
      });
    }

    byId("amkwsSave").addEventListener("click", reihenfolgeSpeichern);
    byId("amkwsReset").addEventListener("click", function () {
      WS.reihenfolge = WS.gespeicherteReihenfolge.slice();
      zeichne();
    });

    byId("amkwsPreviewBtn").addEventListener("click", vorschau);

    ziehenVerdrahten();
    sichernZeigen();
  }

  function sichernZeigen() {
    var kasten = byId("amkwsSichern");
    if (kasten) kasten.classList.toggle("is-da", reihenfolgeGeaendert());
  }

  function verschiebe(id, richtung) {
    var i = WS.reihenfolge.indexOf(id);
    var j = i + richtung;
    if (i < 0 || j < 0 || j >= WS.reihenfolge.length) return;
    WS.reihenfolge[i] = WS.reihenfolge[j];
    WS.reihenfolge[j] = id;
    zeichne();
  }

  /* --- Ziehen und Ablegen -------------------------------------------------
     Zusätzlich zu ▲▼, nicht statt: auf dem Telefon ist Ziehen fummelig, und
     wer viele Positionen tauscht, will nicht 20-mal tippen. */
  function ziehenVerdrahten() {
    var liste = byId("amkwsListe");
    if (!liste) return;
    var gezogen = null;

    $$(".amkws-zeile", liste).forEach(function (zeileEl) {
      zeileEl.addEventListener("dragstart", function (e) {
        gezogen = zeileEl;
        zeileEl.classList.add("is-zieht");
        try { e.dataTransfer.setData("text/plain", zeileEl.dataset.id); } catch (_) {}
        e.dataTransfer.effectAllowed = "move";
      });
      zeileEl.addEventListener("dragend", function () {
        zeileEl.classList.remove("is-zieht");
        $$(".amkws-zeile", liste).forEach(function (z) { z.classList.remove("is-ziel"); });
        gezogen = null;
        // Reihenfolge aus dem DOM übernehmen und neu zeichnen
        WS.reihenfolge = $$(".amkws-zeile", liste).map(function (z) { return z.dataset.id; });
        zeichne();
      });
      zeileEl.addEventListener("dragover", function (e) {
        if (!gezogen || gezogen === zeileEl) return;
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
        zeileEl.classList.add("is-ziel");

        var kasten = zeileEl.getBoundingClientRect();
        var untereHaelfte = (e.clientY - kasten.top) > kasten.height / 2;
        liste.insertBefore(gezogen, untereHaelfte ? zeileEl.nextSibling : zeileEl);
      });
      zeileEl.addEventListener("dragleave", function () { zeileEl.classList.remove("is-ziel"); });
      zeileEl.addEventListener("drop", function (e) { e.preventDefault(); });
    });
  }

  function setzePlatzierung(casinoId, patch, wort) {
    api("hub_set_placement", Object.assign(
      { casino_id: casinoId, channel: WS.kanal }, patch
    )).then(function () {
      var c = casinoById(casinoId);
      if (wort) toast("Gespeichert", (c ? c.name : "Casino") + " " + wort + ".");
      return render();
    }).catch(function (err) {
      toast("Fehler", err.message, "error");
    });
  }

  function reihenfolgeSpeichern() {
    var btn = byId("amkwsSave");
    btn.disabled = true;
    btn.textContent = "Speichert …";
    api("hub_reorder", { channel: WS.kanal, order: WS.reihenfolge })
      .then(function () {
        WS.gespeicherteReihenfolge = WS.reihenfolge.slice();
        toast("Gespeichert", "Die neue Reihenfolge ist live.");
        return render();
      })
      .catch(function (err) {
        toast("Fehler", err.message, "error");
        btn.disabled = false;
        btn.textContent = "Reihenfolge speichern";
      });
  }

  /* --- Abweichender Link nur für diese Seite ----------------------------- */
  function linkDialog(casinoId) {
    var c = casinoById(casinoId);
    if (!c) return;
    var p = platzierung(c, WS.kanal) || {};
    var info = kanalInfo(WS.kanal);

    var overlay = document.createElement("div");
    overlay.className = "amkws-modal";
    overlay.innerHTML =
      '<div class="amkws-modal-card">' +
        '<div class="amkws-modal-head">' +
          "<div><h3>Link für „" + esc(info.label) + "“</h3>" +
          "<p>" + esc(c.name) + "</p></div>" +
          '<button class="amkws-modal-close" type="button">✕</button>' +
        "</div>" +
        '<div class="amkws-modal-body">' +
          '<div class="amkws-field"><label>Standardlink aus dem Casino-Hub</label>' +
            '<input type="text" value="' + esc(c.cta_url || c.tracker_url || "") + '" readonly>' +
            "<small>Gilt überall dort, wo unten nichts eingetragen ist.</small></div>" +
          '<div class="amkws-field"><label>Nur für diese Seite</label>' +
            '<input type="text" id="amkwsLinkFeld" value="' + esc(p.cta_url_override || "") + '" ' +
              'placeholder="leer lassen = Standardlink verwenden">' +
            "<small>Sinnvoll, wenn dieselbe Marke je Seite eine eigene Kampagne hat — " +
            "dann bleibt die Auswertung im Affiliate-Backend sauber getrennt.</small></div>" +
        "</div>" +
        '<div class="amkws-modal-foot">' +
          '<button class="amkws-btn ghost" type="button" id="amkwsLinkAb">Abbrechen</button>' +
          '<button class="amkws-btn" type="button" id="amkwsLinkOk">Speichern</button>' +
        "</div>" +
      "</div>";

    document.body.appendChild(overlay);
    var zu = function () { overlay.remove(); };
    overlay.querySelector(".amkws-modal-close").addEventListener("click", zu);
    byId("amkwsLinkAb").addEventListener("click", zu);
    overlay.addEventListener("click", function (e) { if (e.target === overlay) zu(); });
    /* Nachtschicht 31.10. (#89): Esc schließt auch das Link-Fenster */
    var escZu = function (e) { if (e.key !== "Escape") return; document.removeEventListener("keydown", escZu); if (document.body.contains(overlay)) zu(); };
    document.addEventListener("keydown", escZu);

    byId("amkwsLinkOk").addEventListener("click", function () {
      var wert = byId("amkwsLinkFeld").value.trim();
      this.disabled = true;
      api("hub_set_placement", {
        casino_id: casinoId, channel: WS.kanal, cta_url_override: wert
      }).then(function () {
        toast("Gespeichert", wert ? "Eigener Link gesetzt." : "Standardlink wird verwendet.");
        zu();
        return render();
      }).catch(function (err) {
        toast("Fehler", err.message, "error");
        byId("amkwsLinkOk").disabled = false;
      });
    });
  }

  /* --- Vorschau ------------------------------------------------------------ */
  function vorschau() {
    var box = byId("amkwsPreview");
    box.innerHTML = '<div class="amkws-empty">Lädt …</div>';
    api("hub_channel_preview", { channel: WS.kanal })
      .then(function (res) {
        var list = (res.casinos || []).filter(function (c) { return c.is_enabled && c.is_active; });
        if (!list.length) {
          box.innerHTML = '<div class="amkws-empty">Diese Seite bekommt aktuell kein einziges Casino. ' +
            "Auf der Hauptfront greift dann die eingebaute Notliste aus front.js.</div>";
          return;
        }
        box.innerHTML = '<div class="amkws-vorschau">' + list.map(function (c, i) {
          return '<div class="amkws-vorschau-item">' +
            '<span class="amkws-pos">' + (i + 1) + "</span>" +
            (c.logo ? '<img src="' + esc(c.logo) + '" alt="">' : '<span class="amkws-dot"></span>') +
            "<div><strong>" + esc(c.name) + "</strong>" +
            "<small>" + esc(c.bonus || "—") + "</small></div>" +
            (c.featured ? '<span class="amkws-pill on">hervorgehoben</span>' : "") +
            (c.cta
              ? '<a class="amkws-link" href="' + esc(c.cta) + '" target="_blank" rel="noopener">Link prüfen ↗</a>'
              : '<span class="amkws-pill warn">kein Link</span>') +
          "</div>";
        }).join("") + "</div>";
      })
      .catch(function (err) {
        box.innerHTML = '<div class="amkws-empty">⚠ ' + esc(err.message) + "</div>";
      });
  }


  /* ============================================================================
     START
     Kein Selbst-Einhaengen mehr: Navigationsknopf und Ansicht stehen fest im
     Markup, der Eintrag steht in VIEW_CONFIG. Es bleibt die Kette an
     loadView — dieselbe Form, die auch die uebrigen Bereiche verwenden.
  ============================================================================ */
  const zuvor = AMKZ.loadView;
  AMKZ.loadView = async function webseitenChain(view, options) {
    const ergebnis = await zuvor?.call(this, view, options);
    if (view === "webseiten") await render();
    return ergebnis;
  };

  // Wird im Casino-Hub etwas geändert, zeigt diese Ansicht sofort dasselbe.
  document.addEventListener("amkch:changed", function () {
    var view = AMKZ.state && AMKZ.state.currentView;
    if (view === "webseiten") render();
    else WS.geladen = false;
  });

  window.AMK_WEBSEITEN = { render: render, state: WS };
})();

/* =====================================================================
   AMK ZENTRALE — AMK SIGN: Arbeitsverträge digital unterschreiben
   ---------------------------------------------------------------------
   Ein Vertrag wird im Mitarbeiter-Profil (Team -> Profil -> Dokumente)
   hochgeladen. Ab diesem Moment gilt:

     * Unterschreiben MUSS  -> der Mitarbeiter, bei dem er hochgeladen wurde
                            -> Nouri als Firma
     * Einsicht (nur lesen) -> Nouri, Mateo und Alex. In deren Profilen
                               erscheinen ALLE Mitarbeiter-Verträge.

   Unterschrieben wird im Vollbild-Werkzeug (wie DocuSign): Dokument
   ansehen, Unterschrift zeichnen / tippen / hochladen, an die richtige
   Stelle im Vertrag ziehen, bestaetigen. Sobald beide Seiten fertig sind,
   baut die Zentrale eine finale PDF mit eingebrannten Unterschriften und
   einem Unterschriften-Zertifikat (Zeitpunkt, IP, SHA-256 des Originals).

   Tabellen: supabase-contracts.sql
   ===================================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__amkSign) return;
  AMKZ.__amkSign = true;

  const byId = (id) => document.getElementById(id);
  const sb = () => AMKZ.supabase;
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) ||
    ((v) => String(v ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m])));
  const me = () => AMKZ.state.member || null;
  const isAdmin = () => AMKZ.state.permissions?.isAdmin === true;

  const BUCKET = "amk-documents";
  const BUCKET_FALLBACK = "amk-chat-files";
  const PDFJS_SRC = "https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.min.js";
  const PDFJS_WORKER = "https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js";
  const PDFLIB_SRC = "https://cdn.jsdelivr.net/npm/pdf-lib@1.17.1/dist/pdf-lib.min.js";
  const MAMMOTH_SRC = "https://cdn.jsdelivr.net/npm/mammoth@1.8.0/mammoth.browser.min.js";
  const H2C_SRC = "https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js";

  /* ---------- Wer unterschreibt, wer hat Einsicht (eine Stelle) ---------- */
  const COMPANY_SIGNER = { key: "Nouri", names: ["nouri"], emails: [], roles: ["owner", "ceo", "admin_owner", "admin"] };
  const VIEWER_SPECS = [
    { key: "Nouri", names: ["nouri"], emails: [], roles: ["owner", "ceo", "admin_owner", "admin"] },
    { key: "Mateo", names: ["mateo"], emails: ["mateo@amk.com"], roles: [] },
    { key: "Alex",  names: ["alex"],  emails: [], roles: ["manager"] },
  ];

  /* =====================================================================
     Kleine Helfer
     ===================================================================== */
  const low = (v) => String(v || "").toLowerCase().trim();
  const firstName = (v) => String(v || "").trim().split(/[\s@]/)[0] || "—";
  const latin = (v) => String(v ?? "").replace(/[‐-―]/g, "-").replace(/[‘’]/g, "'").replace(/[“”]/g, '"').replace(/[^\x20-\x7E\xA0-\xFF]/g, "");
  function fmtDT(v) {
    if (!v) return "—";
    const d = new Date(v);
    if (isNaN(d)) return "—";
    return d.toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) + " Uhr";
  }
  function loadLib(src, check) {
    if (check()) return Promise.resolve(true);
    return new Promise((res) => {
      const s = document.createElement("script");
      s.src = src; s.onload = res; s.onerror = res;
      document.head.appendChild(s);
    }).then(() => check());
  }
  async function sha256(buf) {
    try {
      const h = await crypto.subtle.digest("SHA-256", buf);
      return Array.from(new Uint8Array(h)).map((b) => b.toString(16).padStart(2, "0")).join("");
    } catch (_) { return null; }
  }
  let _ip = null, _ipTried = false;
  async function clientIp() {
    if (_ipTried) return _ip;
    _ipTried = true;
    try {
      const ctl = new AbortController();
      const t = setTimeout(() => ctl.abort(), 2500);
      const r = await fetch("https://api.ipify.org?format=json", { signal: ctl.signal });
      clearTimeout(t);
      _ip = (await r.json()).ip || null;
    } catch (_) { _ip = null; }
    return _ip;
  }
  function dataUrlToBlob(dataUrl) {
    const [head, b64] = String(dataUrl).split(",");
    const mime = (head.match(/:(.*?);/) || [])[1] || "image/png";
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return new Blob([arr], { type: mime });
  }
  const isPdfFile = (c) => /pdf/.test(low(c.file_type)) || /\.pdf(\?|$)/i.test(c.file_url || "");
  const isImgFile = (c) => /^image\//.test(low(c.file_type)) || /\.(png|jpe?g|webp|gif)(\?|$)/i.test(c.file_url || "");
  const isDocxFile = (c) => /wordprocessingml/.test(low(c.file_type)) || /\.docx(\?|$)/i.test(c.file_url || "");

  /* =====================================================================
     Beteiligte auflösen (Nouri = Firma, Nouri/Mateo/Alex = Einsicht)
     ===================================================================== */
  let _parties = null, _partiesAt = 0;
  async function teamList() {
    let t = AMKZ.state.team || [];
    if (!t.length) {
      try {
        const { data } = await sb().from("team_members").select("id,name,email,role");
        t = data || [];
        if (t.length) AMKZ.state.team = t;
      } catch (_) {}
    }
    return t;
  }
  function pickMember(list, spec, taken) {
    let m = spec.emails.length ? list.find((t) => spec.emails.some((e) => low(t.email) === low(e))) : null;
    if (!m) m = list.find((t) => spec.names.some((n) => low(t.name).includes(n)));
    if (!m && spec.roles.length) m = list.find((t) => spec.roles.includes(low(t.role)) && !taken.has(t.id));
    return m || null;
  }
  async function parties(force) {
    if (_parties && !force && Date.now() - _partiesAt < 60000) return _parties;
    const list = await teamList();
    const taken = new Set();
    const company = pickMember(list, COMPANY_SIGNER, taken);
    if (company) taken.add(company.id);
    const viewers = [];
    VIEWER_SPECS.forEach((spec) => {
      const m = pickMember(list, spec, taken);
      if (m && !viewers.some((v) => String(v.id) === String(m.id))) { viewers.push(m); taken.add(m.id); }
    });
    _parties = { company, viewers, viewerIds: new Set(viewers.map((v) => String(v.id))) };
    _partiesAt = Date.now();
    return _parties;
  }
  AMKZ.signParties = parties;

  /* =====================================================================
     Datenschicht
     ===================================================================== */
  let SQL_MISSING = false;
  const missingTable = (err) => !!err && (err.code === "42P01" || /does not exist|could not find|schema cache/i.test(err.message || ""));

  async function fetchContracts(employeeId) {
    let q = sb().from("employee_contracts").select("*").order("created_at", { ascending: false });
    if (employeeId) q = q.eq("employee_id", employeeId);
    const { data, error } = await q;
    if (error) { if (missingTable(error)) SQL_MISSING = true; return null; }
    SQL_MISSING = false;
    return data || [];
  }
  async function fetchSigners(ids) {
    const map = {};
    if (!ids.length) return map;
    try {
      const { data } = await sb().from("contract_signers").select("*").in("contract_id", ids).order("order_no", { ascending: true });
      (data || []).forEach((s) => { (map[s.contract_id] = map[s.contract_id] || []).push(s); });
    } catch (_) {}
    return map;
  }
  async function fetchEvents(contractId) {
    try {
      const { data } = await sb().from("contract_events").select("*").eq("contract_id", contractId).order("created_at", { ascending: true });
      return data || [];
    } catch (_) { return []; }
  }
  async function logEvent(contractId, action, detail) {
    const m = me();
    try {
      await sb().from("contract_events").insert({
        contract_id: contractId, user_id: m?.id || null, actor: m?.name || m?.email || "System",
        action, detail: detail || null, ip: await clientIp(), user_agent: String(navigator.userAgent || "").slice(0, 240),
      });
    } catch (_) {}
  }
  /* Unterzeichner anlegen, falls noch keine da sind (auch fuer alte Dokumente) */
  async function ensureSigners(contract, existing) {
    if (existing && existing.length) return existing;
    if (String(contract.kind || "contract") !== "contract") return [];
    const p = await parties();
    const list = await teamList();
    const emp = list.find((t) => String(t.id) === String(contract.employee_id));
    const rows = [];
    if (emp) rows.push({ contract_id: contract.id, user_id: emp.id, party: "employee", name: emp.name || emp.email, email: emp.email || null, order_no: 1, pos_x: 8, pos_y: 78, pos_w: 26 });
    if (p.company && (!emp || String(p.company.id) !== String(emp.id))) {
      rows.push({ contract_id: contract.id, user_id: p.company.id, party: "company", name: p.company.name || p.company.email, email: p.company.email || null, order_no: 2, pos_x: 56, pos_y: 78, pos_w: 26 });
    }
    if (!rows.length) return [];
    try {
      const { data } = await sb().from("contract_signers").insert(rows).select("*");
      return data || [];
    } catch (_) { return []; }
  }
  async function ensureViewers(contract) {
    const p = await parties();
    if (!p.viewers.length) return;
    try {
      await sb().from("contract_viewers").upsert(
        p.viewers.map((v) => ({ contract_id: contract.id, user_id: v.id, name: v.name || v.email })),
        { onConflict: "contract_id,user_id", ignoreDuplicates: true }
      );
    } catch (_) {}
  }
  async function notify(userId, title, message) {
    const myId = me()?.id;
    if (!userId || String(userId) === String(myId)) return;
    try {
      if (myId) {
        const { data: conv } = await sb().rpc("amk_get_or_create_conversation", { p_user_a: myId, p_user_b: userId });
        const cid = conv?.id || (Array.isArray(conv) ? conv[0]?.id : null);
        if (cid) {
          await sb().rpc("amk_send_message", {
            p_conversation_id: cid, p_sender_id: myId, p_receiver_id: userId, p_message: message,
            p_client_temp_id: `sign_${Date.now()}_${Math.random().toString(36).slice(2)}`,
          });
        }
      }
    } catch (_) {}
    try { await sb().from("notifications").insert({ target_user_id: userId, created_for: userId, type: "team", title, message, is_read: false, created_at: new Date().toISOString(), payload: { from: myId, push: "false" } }); } catch (_) {}
    try { window.AMK_SEND_PUSH?.(userId, title, message, { from: myId }); } catch (_) {}
  }

  /* ---------- Status eines Vertrags ---------- */
  function statusOf(c, signers) {
    if (c.status === "declined") return { key: "declined", label: "Abgelehnt", cls: "bad" };
    if (c.status === "void") return { key: "void", label: "Zurückgezogen", cls: "off" };
    const req = signers || [];
    if (!req.length) return { key: "none", label: "Ablage", cls: "off" };
    const open = req.filter((s) => s.status !== "signed");
    if (!open.length) return { key: "done", label: "Vollständig unterzeichnet", cls: "good" };
    return { key: open.length < req.length ? "partial" : "pending", label: "Warten auf " + open.map((s) => firstName(s.name)).join(" & "), cls: "warn" };
  }

  /* =====================================================================
     Optik — Dark-Luxe wie der Rest der Zentrale
     ===================================================================== */
  function ensureStyle() {
    if (byId("amk-sign-style")) return;
    const st = document.createElement("style");
    st.id = "amk-sign-style";
    st.textContent = `
      /* ---- Liste im Mitarbeiter-Profil ---- */
      .amkzsg-sec{margin-bottom:18px}
      .amkzsg-sechead{display:flex;align-items:center;gap:10px;margin:0 0 9px;font-size:.78rem;font-weight:900;letter-spacing:.09em;text-transform:uppercase;color:#c8aa6e}
      .amkzsg-sechead .amkzsg-count{background:rgba(200,170,110,.16);border:1px solid rgba(200,170,110,.4);border-radius:999px;padding:1px 9px;font-size:.7rem}
      .amkzsg-sechead small{margin-left:auto;text-transform:none;letter-spacing:0;font-weight:600;opacity:.5;font-size:.72rem}
      .amkzsg-row{display:flex;align-items:center;gap:10px;flex-wrap:wrap;padding:11px 13px;border-radius:13px;margin-bottom:7px;
        background:linear-gradient(165deg,rgba(255,255,255,.045),rgba(255,255,255,.015));border:1px solid rgba(255,255,255,.09)}
      .amkzsg-row.needsme{border-color:rgba(200,170,110,.55);background:linear-gradient(165deg,rgba(200,170,110,.13),rgba(200,170,110,.03))}
      .amkzsg-row.done{border-color:rgba(52,211,153,.32)}
      .amkzsg-rowic{font-size:1.05rem;flex:0 0 auto;opacity:.9}
      .amkzsg-rowmain{flex:1;min-width:150px}
      .amkzsg-rowmain a,.amkzsg-rowmain strong{display:block;color:#e9c76a;font-weight:700;text-decoration:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .amkzsg-rowmain small{display:block;opacity:.55;font-size:.72rem;margin-top:2px}
      .amkzsg-pill{font-size:.68rem;font-weight:800;padding:3px 10px;border-radius:999px;white-space:nowrap}
      .amkzsg-pill.good{background:rgba(52,211,153,.16);color:#34d399}
      .amkzsg-pill.warn{background:rgba(230,184,92,.16);color:#f0d488}
      .amkzsg-pill.bad{background:rgba(248,113,113,.16);color:#f87171}
      .amkzsg-pill.off{background:rgba(255,255,255,.07);color:#999}
      .amkzsg-mini{border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.05);color:inherit;border-radius:10px;padding:6px 11px;font-size:.78rem;font-weight:700;cursor:pointer;white-space:nowrap}
      .amkzsg-mini:hover{border-color:rgba(200,170,110,.5);color:#f0d488}
      .amkzsg-mini.gold{background:linear-gradient(135deg,#f7df97,#c8902b);border-color:transparent;color:#0b0b0d;font-weight:900}
      .amkzsg-mini.danger:hover{border-color:rgba(248,113,113,.5);color:#f87171}
      .amkzsg-uprow{display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin-top:10px}
      .amkzsg-uprow select{max-width:250px}
      .amkzsg-note{margin-top:10px;padding:11px 13px;border-radius:12px;font-size:.78rem;line-height:1.55;
        background:rgba(248,113,113,.08);border:1px solid rgba(248,113,113,.3);color:#fca5a5}
      .amkzsg-note code{background:rgba(0,0,0,.35);padding:1px 6px;border-radius:5px}
      .amkzsg-tabdot{display:inline-block;margin-left:6px;min-width:17px;height:17px;line-height:17px;text-align:center;border-radius:999px;
        background:linear-gradient(135deg,#f7df97,#c8902b);color:#0b0b0d;font-size:.66rem;font-weight:900;padding:0 5px}

      /* ---- Vollbild-Werkzeug ---- */
      body.amkzsg-lock{overflow:hidden}
      .amkzsg-ov{position:fixed;inset:0;z-index:10600;display:none;background:rgba(6,7,9,.86);-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}
      .amkzsg-ov.on{display:block}
      .amkzsg-shell{position:absolute;inset:20px;display:flex;flex-direction:column;border-radius:24px;overflow:hidden;
        background:linear-gradient(180deg,#141419,#0a0a0c);border:1px solid rgba(200,170,110,.28);box-shadow:0 34px 90px rgba(0,0,0,.7);color:#f2f1ee}
      .amkzsg-head{display:flex;align-items:center;gap:14px;padding:15px 20px;border-bottom:1px solid rgba(255,255,255,.08);flex-wrap:wrap}
      .amkzsg-head h3{margin:0;font-size:1.05rem;color:#f0d488;display:flex;align-items:center;gap:8px}
      .amkzsg-head p{margin:2px 0 0;font-size:.78rem;opacity:.55}
      .amkzsg-headsp{flex:1}
      .amkzsg-ghost{background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.14);color:inherit;border-radius:11px;padding:8px 14px;font-weight:700;font-size:.82rem;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center;gap:7px}
      .amkzsg-ghost:hover{border-color:rgba(200,170,110,.5);color:#f0d488}
      .amkzsg-gold{background:linear-gradient(135deg,#f7df97,#c8902b);border:none;color:#0b0b0d;border-radius:12px;padding:11px 20px;font-weight:900;cursor:pointer;font-size:.88rem;display:inline-flex;align-items:center;gap:8px;justify-content:center}
      .amkzsg-gold:disabled{opacity:.45;cursor:not-allowed}
      .amkzsg-body{flex:1;display:flex;min-height:0}
      .amkzsg-doc{flex:1;overflow:auto;padding:20px;display:flex;flex-direction:column;align-items:center;gap:18px;background:#0f0f13}
      .amkzsg-doc.is-placing{cursor:crosshair}
      .amkzsg-doc.is-placing .amkzsg-page{outline:2px dashed rgba(200,170,110,.5);outline-offset:4px}
      .amkzsg-page{position:relative;flex:0 0 auto;width:100%;max-width:920px;border-radius:9px;overflow:hidden;box-shadow:0 12px 34px rgba(0,0,0,.55);background:#fff}
      .amkzsg-page canvas,.amkzsg-page img{display:block;width:100%;height:auto}
      .amkzsg-layer{position:absolute;inset:0;pointer-events:none}
      .amkzsg-mark{position:absolute;pointer-events:none}
      .amkzsg-mark img{width:100%;height:auto;display:block}
      .amkzsg-mark span{display:block;border-top:1px solid rgba(30,30,40,.55);font-size:9px;color:#3a3a45;padding-top:2px;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .amkzsg-drop{position:absolute;cursor:grab;touch-action:none;border:2px dashed rgba(200,144,43,.95);border-radius:6px;background:rgba(247,223,151,.16);padding:3px}
      .amkzsg-drop.dragging{cursor:grabbing}
      .amkzsg-drop img{width:100%;height:auto;display:block;pointer-events:none}
      .amkzsg-grip{position:absolute;right:-8px;bottom:-8px;width:18px;height:18px;border-radius:50%;background:#c8902b;border:2px solid #fff;cursor:nwse-resize;touch-action:none}
      /* Word-Vertrag als echte Seite */
      .amkzsg-word{background:#fff;color:#14141a}
      .amkzsg-wordbody{padding:54px 62px;font:13.5px/1.7 'Inter','Helvetica Neue',Arial,sans-serif;color:#14141a}
      .amkzsg-wordbody h1{font-size:1.35rem;margin:0 0 18px;text-align:center;letter-spacing:.02em}
      .amkzsg-wordbody h2{font-size:1.05rem;margin:22px 0 8px;color:#1a1a22}
      .amkzsg-wordbody h3{font-size:.98rem;margin:18px 0 6px}
      .amkzsg-wordbody p{margin:0 0 10px}
      .amkzsg-wordbody ul,.amkzsg-wordbody ol{margin:0 0 10px 20px}
      .amkzsg-wordbody table{border-collapse:collapse;width:100%;margin:0 0 12px}
      .amkzsg-wordbody td,.amkzsg-wordbody th{border:1px solid #d8d8de;padding:6px 8px;font-size:.9em}
      .amkzsg-wordbody img{max-width:100%;height:auto}
      .amkzsg-wordbody strong{color:#0b0b0f}

      /* Erkannte Felder */
      .amkzsg-field{position:absolute;pointer-events:auto;display:flex;align-items:center;justify-content:flex-start;border-radius:5px;overflow:hidden}
      .amkzsg-field img{max-width:100%;max-height:100%;width:auto;height:auto;display:block;object-fit:contain}
      .amkzsg-field .amkzsg-fieldval{font:600 clamp(9px,1.6vw,13px)/1.2 'Inter',Arial,sans-serif;color:#14141a;white-space:nowrap;padding-left:2px}
      .amkzsg-field .amkzsg-fieldtag{font:800 10px/1 'Inter',Arial,sans-serif;letter-spacing:.02em;padding:3px 6px;border-radius:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .amkzsg-field.mine{cursor:pointer;border:2px solid rgba(200,144,43,.95);background:rgba(247,223,151,.34);box-shadow:0 0 0 3px rgba(247,223,151,.18)}
      .amkzsg-field.mine .amkzsg-fieldtag{background:#c8902b;color:#14100a}
      .amkzsg-field.mine:hover{background:rgba(247,223,151,.55)}
      .amkzsg-field.other{border:1px dashed rgba(90,90,110,.5);background:rgba(120,120,140,.1)}
      .amkzsg-field.other .amkzsg-fieldtag{background:rgba(90,90,110,.22);color:#4a4a58}
      .amkzsg-field.free.mine{border-style:dashed}
      .amkzsg-field.filled{border:none;background:none;cursor:pointer}
      .amkzsg-field.flash{animation:amkzsgFlash 1.4s ease}
      @keyframes amkzsgFlash{0%,100%{box-shadow:0 0 0 3px rgba(247,223,151,.18)}35%{box-shadow:0 0 0 12px rgba(247,223,151,.5)}}
      .amkzsg-doc.printing .amkzsg-field:not(.filled){display:none}
      .amkzsg-doc.printing .amkzsg-field.filled{border:none;background:none}
      /* Eigenes Profil: Karte in der Seitenleiste ist anklickbar */
      .amkz-user-card[role="button"]{cursor:pointer;transition:border-color .2s,transform .12s}
      .amkz-user-card[role="button"]:hover{border-color:rgba(200,170,110,.55) !important;transform:translateY(-1px)}
      .amkz-user-card[role="button"]:focus-visible{outline:2px solid rgba(200,170,110,.7);outline-offset:3px}
      .amkzsg-ro{opacity:.72;cursor:default}
      .amkzsg-ro:focus{outline:none}
      .amkzsg-prog{height:7px;border-radius:99px;background:rgba(255,255,255,.09);overflow:hidden}
      .amkzsg-progbar{height:100%;background:linear-gradient(90deg,#c8902b,#f7df97);border-radius:99px;transition:width .3s}

      /* Initialen im Unterschriften-Fenster */
      .amkzsg-inibox{margin-top:13px;padding:11px 13px;border-radius:14px;background:rgba(255,255,255,.035);border:1px solid rgba(255,255,255,.1)}
      .amkzsg-inihead{display:flex;align-items:center;gap:10px;margin-bottom:8px;font-size:.82rem}
      .amkzsg-inihead b{color:#f0d488}
      .amkzsg-inisw{margin-left:auto;background:none;border:none;color:#c8aa6e;font-weight:800;font-size:.76rem;cursor:pointer}
      .amkzsg-iniprev{min-height:56px;border-radius:11px;background:#fdfdfb;display:grid;place-items:center;padding:6px}
      .amkzsg-iniprev img{max-height:46px;max-width:100%}
      .amkzsg-iniprev small{color:#8a8a93;font-size:.75rem}
      .amkzsg-inipad{height:96px}

      .amkzsg-fallback{max-width:640px;text-align:center;background:rgba(255,255,255,.03);border:1px dashed rgba(255,255,255,.16);border-radius:18px;padding:34px 26px}
      .amkzsg-fallback h4{margin:0 0 8px;color:#f0d488}
      .amkzsg-fallback p{margin:0 0 14px;opacity:.65;font-size:.85rem;line-height:1.6}
      .amkzsg-load{padding:40px;opacity:.6;font-weight:700;text-align:center}

      /* ---- Seitenleiste ---- */
      .amkzsg-side{width:330px;flex:0 0 330px;border-left:1px solid rgba(255,255,255,.08);overflow:auto;padding:18px;background:#0b0b0e}
      .amkzsg-sidesec{margin-bottom:20px}
      .amkzsg-sidesec h5{margin:0 0 9px;font-size:.72rem;letter-spacing:.09em;text-transform:uppercase;color:#c8aa6e;font-weight:900}
      /* position/overflow sind Pflicht: der zentrale Avatar-Helfer legt in jedes
         .amkz-has-photo ein <img position:absolute;inset:0>. Ohne eigenen
         Bezugsrahmen haengt sich das Bild an die naechste positionierte Box —
         das war die ganze Werkzeug-Flaeche, und das Profilbild lag als
         bildschirmgrosse Ellipse ueber dem Vertrag. */
      .amkzsg-signer{position:relative;overflow:hidden;display:flex;align-items:center;gap:10px;padding:10px 12px;border-radius:12px;margin-bottom:7px;background:rgba(255,255,255,.035);border:1px solid rgba(255,255,255,.08)}
      .amkzsg-signer.signed{border-color:rgba(52,211,153,.35)}
      .amkzsg-signer.isme{border-color:rgba(200,170,110,.55);background:rgba(200,170,110,.1)}
      .amkzsg-signer-av{position:relative;overflow:hidden;width:34px;height:34px;border-radius:50%;flex:0 0 34px;display:grid;place-items:center;font-weight:900;color:#0b0b0d;background:linear-gradient(135deg,#f7df97,#c8902b);background-size:cover;background-position:center;font-size:.85rem}
      .amkzsg-signer-av .amkz-ava-img{border-radius:50%}
      .amkzsg-signer-in{flex:1;min-width:0}
      .amkzsg-signer-in strong{display:block;font-size:.86rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .amkzsg-signer-in small{display:block;font-size:.7rem;opacity:.55}
      .amkzsg-signer-st{font-size:1rem}
      .amkzsg-evt{display:flex;gap:9px;font-size:.75rem;padding:6px 0;border-bottom:1px dashed rgba(255,255,255,.07)}
      .amkzsg-evt:last-child{border-bottom:none}
      .amkzsg-evt b{color:#f0d488;font-weight:800}
      .amkzsg-evt span{opacity:.55;margin-left:auto;white-space:nowrap;font-size:.68rem}
      .amkzsg-cta{position:sticky;bottom:0;padding:12px 0 2px;margin-top:4px;background:#0b0b0e;box-shadow:0 -16px 20px -10px #0b0b0e}
      .amkzsg-cta .amkzsg-gold{width:100%}
      .amkzsg-hint{font-size:.74rem;opacity:.6;line-height:1.55;margin:8px 0 0;text-align:center}

      /* ---- Aktionsleiste beim Platzieren ---- */
      .amkzsg-bar{position:absolute;left:0;right:0;bottom:0;display:flex;align-items:center;gap:12px;flex-wrap:wrap;justify-content:center;
        padding:13px 18px;background:linear-gradient(180deg,rgba(12,12,15,.6),rgba(12,12,15,.97));border-top:1px solid rgba(200,170,110,.3);z-index:4}
      .amkzsg-bar p{margin:0;font-size:.82rem;font-weight:700;color:#f0d488}

      /* ---- Unterschriften-Pad ---- */
      .amkzsg-pad{position:absolute;inset:0;z-index:9;display:grid;place-items:center;padding:18px;background:rgba(5,5,7,.8);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}
      .amkzsg-padcard{width:min(560px,100%);max-height:92%;overflow:auto;background:linear-gradient(180deg,#17171d,#0c0c0f);border:1px solid rgba(200,170,110,.35);border-radius:22px;padding:22px;box-shadow:0 26px 70px rgba(0,0,0,.6)}
      .amkzsg-padhead{display:flex;gap:12px;align-items:flex-start;margin-bottom:14px}
      .amkzsg-padhead h4{margin:0;color:#f0d488;font-size:1rem}
      .amkzsg-padhead p{margin:3px 0 0;font-size:.78rem;opacity:.55;line-height:1.5}
      .amkzsg-x{margin-left:auto;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.14);color:inherit;border-radius:10px;width:34px;height:34px;cursor:pointer;flex:0 0 34px}
      .amkzsg-padtabs{display:flex;gap:7px;margin-bottom:13px;flex-wrap:wrap}
      .amkzsg-padtab{flex:1;min-width:96px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.1);color:inherit;border-radius:11px;padding:9px 8px;font-weight:800;font-size:.8rem;cursor:pointer}
      .amkzsg-padtab.active{background:rgba(200,170,110,.14);border-color:rgba(200,170,110,.5);color:#f0d488}
      .amkzsg-canvas{width:100%;height:180px;border-radius:14px;background:#fdfdfb;border:1px solid rgba(255,255,255,.14);touch-action:none;cursor:crosshair;display:block}
      .amkzsg-padhint{font-size:.74rem;opacity:.5;text-align:center;margin-top:7px}
      .amkzsg-input{width:100%;border-radius:12px;border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.05);color:inherit;padding:11px 13px;font-size:.9rem}
      .amkzsg-fonts{display:flex;gap:7px;margin:11px 0;flex-wrap:wrap}
      .amkzsg-fontpick{flex:1;min-width:110px;background:#fdfdfb;color:#14141a;border:2px solid transparent;border-radius:11px;padding:9px 6px;font-size:1.15rem;cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}
      .amkzsg-fontpick.active{border-color:#c8902b}
      .amkzsg-typeprev{min-height:96px;border-radius:14px;background:#fdfdfb;border:1px solid rgba(255,255,255,.14);display:grid;place-items:center;padding:10px;overflow:hidden}
      .amkzsg-typeprev img{max-width:100%;max-height:120px}
      .amkzsg-typeprev small{color:#8a8a93;font-size:.78rem}
      .amkzsg-upl{display:inline-flex;align-items:center;gap:8px;cursor:pointer;background:rgba(200,170,110,.12);border:1px solid rgba(200,170,110,.4);border-radius:12px;padding:10px 16px;font-weight:800;color:#f0d488;margin-bottom:11px}
      .amkzsg-consent{display:flex;gap:9px;align-items:flex-start;font-size:.76rem;line-height:1.5;opacity:.8;margin:14px 0 4px}
      .amkzsg-consent input{margin-top:2px;flex:0 0 auto}
      .amkzsg-padact{display:flex;gap:9px;align-items:center;margin-top:14px;flex-wrap:wrap}
      .amkzsg-sp{flex:1}

      /* ---- Schwebender Hinweis: „dein Vertrag wartet" ---- */
      .amkzsg-nudge{position:fixed;left:22px;bottom:22px;z-index:10400;display:none;align-items:center;gap:12px;max-width:min(390px,calc(100vw - 44px));
        padding:13px 15px;border-radius:18px;color:#f2f1ee;cursor:pointer;text-align:left;
        background:linear-gradient(160deg,rgba(26,22,14,.98),rgba(10,10,12,.98));border:1px solid rgba(200,170,110,.5);box-shadow:0 20px 48px rgba(0,0,0,.55)}
      .amkzsg-nudge.on{display:flex}
      .amkzsg-nudge-ic{font-size:1.3rem;flex:0 0 auto}
      .amkzsg-nudge-in{flex:1;min-width:0}
      .amkzsg-nudge-in strong{display:block;font-size:.88rem;color:#f0d488}
      .amkzsg-nudge-in small{display:block;font-size:.74rem;opacity:.6;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
      .amkzsg-nudge-go{background:linear-gradient(135deg,#f7df97,#c8902b);border:none;color:#0b0b0d;border-radius:11px;padding:9px 14px;font-weight:900;font-size:.8rem;cursor:pointer;white-space:nowrap}
      .amkzsg-nudge-x{background:none;border:none;color:inherit;opacity:.45;cursor:pointer;font-size:1rem;padding:2px 4px}

      @media (max-width:900px){
        .amkzsg-nudge{left:12px;right:12px;bottom:86px;max-width:none}
        .amkzsg-shell{inset:0;border-radius:0;border:none}
        .amkzsg-body{flex-direction:column}
        .amkzsg-side{width:auto;flex:0 0 auto;border-left:none;border-top:1px solid rgba(255,255,255,.08);max-height:46%}
        .amkzsg-doc{padding:12px}
        .amkzsg-head{padding:12px 14px}
        .amkzsg-head h3{font-size:.95rem}
      }
    `;
    document.head.appendChild(st);
  }

  /* =====================================================================
     Mitarbeiter-Profil: Reiter „Dokumente" übernehmen
     ===================================================================== */
  function rowHtml(c, signers, opts) {
    const st = statusOf(c, signers);
    const myId = String(me()?.id || "");
    const mine = (signers || []).find((s) => String(s.user_id) === myId && s.status !== "signed");
    const openSigners = (signers || []).filter((s) => s.status !== "signed");
    const showSign = !!mine || (opts.companyAction && openSigners.some((s) => s.party === "company"));
    const url = c.signed_url || c.file_url;
    const sub = [];
    if (opts.withOwner && opts.ownerName) sub.push(opts.ownerName);
    sub.push(fmtDT(c.created_at));
    if (c.signed_url) sub.push("signierte PDF vorhanden");
    return `<div class="amkzsg-row ${mine ? "needsme" : ""} ${st.key === "done" ? "done" : ""}" data-sg-row="${esc(c.id)}">
      <span class="amkzsg-rowic">${st.key === "done" ? "📗" : (String(c.kind || "contract") === "contract" ? "📄" : "📎")}</span>
      <div class="amkzsg-rowmain">
        <a href="${esc(url || "#")}" target="_blank" rel="noopener">${esc(c.title || c.file_name || "Dokument")}</a>
        <small>${esc(sub.join(" · "))}</small>
      </div>
      <span class="amkzsg-pill ${st.cls}">${esc(st.label)}</span>
      ${showSign
        ? `<button type="button" class="amkzsg-mini gold" data-sg-open="${esc(c.id)}">✍️ Vertrag unterzeichnen</button>`
        : `<button type="button" class="amkzsg-mini" data-sg-open="${esc(c.id)}">👁 Ansehen</button>`}
      ${opts.canDelete ? `<button type="button" class="amkzsg-mini danger" data-sg-del="${esc(c.id)}">🗑</button>` : ""}
    </div>`;
  }

  async function renderDocsPanel(box, employeeId) {
    if (!box) return;
    box.innerHTML = `<div class="amkz-empty">Verträge werden geladen…</div>`;
    const p = await parties();
    const isViewerProfile = p.viewerIds.has(String(employeeId));
    const list = await teamList();
    const nameOf = (id) => { const t = list.find((x) => String(x.id) === String(id)); return t ? (t.name || t.email || "—") : "—"; };

    const all = await fetchContracts(isViewerProfile ? null : employeeId);
    if (all === null) {
      // Tabelle fehlt -> alte Ablage aus team_members.documents anzeigen
      const emp = list.find((x) => String(x.id) === String(employeeId));
      const legacy = Array.isArray(emp?.documents) ? emp.documents : [];
      box.innerHTML =
        (legacy.length
          ? legacy.map((d) => `<div class="amkzsg-row"><span class="amkzsg-rowic">📄</span><div class="amkzsg-rowmain"><a href="${esc(d.url)}" target="_blank" rel="noopener">${esc(d.name || "Dokument")}</a><small>${esc(fmtDT(d.uploaded_at))}</small></div><span class="amkzsg-pill off">Ablage</span></div>`).join("")
          : `<div class="amkz-empty">Keine Dokumente.</div>`) +
        `<div class="amkzsg-note"><b>Unterschreiben ist noch nicht aktiv.</b><br>Bitte einmal <code>zentrale/supabase-contracts.sql</code> im Supabase-SQL-Editor ausführen — danach erscheinen hier Vertragsstatus und die Unterschrift.</div>`;
      return;
    }

    // Unterzeichner laden und fehlende nachtragen
    let signerMap = await fetchSigners(all.map((c) => c.id));
    const missing = all.filter((c) => !(signerMap[c.id] || []).length && String(c.kind || "contract") === "contract");
    if (missing.length) {
      for (const c of missing) {
        const rows = await ensureSigners(c, null);
        if (rows.length) signerMap[c.id] = rows;
        ensureViewers(c);
      }
    }

    const own = all.filter((c) => String(c.employee_id) === String(employeeId));
    const others = isViewerProfile ? all.filter((c) => String(c.employee_id) !== String(employeeId)) : [];
    const canDelete = isAdmin();
    const openForMe = all.filter((c) => (signerMap[c.id] || []).some((s) => String(s.user_id) === String(me()?.id) && s.status !== "signed")).length;

    let html = "";
    html += `<div class="amkzsg-sec"><div class="amkzsg-sechead">📄 Eigene Dokumente & Verträge ${own.length ? `<span class="amkzsg-count">${own.length}</span>` : ""}</div>`;
    html += own.length
      ? own.map((c) => rowHtml(c, signerMap[c.id], { canDelete, companyAction: false })).join("")
      : `<div class="amkz-empty">Keine Dokumente.</div>`;
    html += `</div>`;

    if (isViewerProfile) {
      const isCompany = p.company && String(p.company.id) === String(employeeId);
      html += `<div class="amkzsg-sec"><div class="amkzsg-sechead">🗂 Mitarbeiter-Verträge — Einsicht ${others.length ? `<span class="amkzsg-count">${others.length}</span>` : ""}<small>${isCompany ? "Nouri unterschreibt für die Firma" : "nur Einsicht — unterschrieben wird von Nouri"}</small></div>`;
      html += others.length
        ? others.map((c) => rowHtml(c, signerMap[c.id], { canDelete, companyAction: !!isCompany, withOwner: true, ownerName: nameOf(c.employee_id) })).join("")
        : `<div class="amkz-empty">Noch keine Verträge von Mitarbeitern hochgeladen.</div>`;
      html += `</div>`;
    }
    box.innerHTML = html;

    // Zähler am Reiter „Dokumente"
    const tab = document.querySelector('#amkTpForm [data-hrtab="dokumente"]');
    if (tab) {
      tab.querySelector(".amkzsg-tabdot")?.remove();
      if (openForMe > 0) tab.insertAdjacentHTML("beforeend", `<span class="amkzsg-tabdot">${openForMe}</span>`);
    }
  }

  async function uploadContract(employeeId, file, kind) {
    const m = me();
    const buf = await file.arrayBuffer();
    const hash = await sha256(buf);
    const safe = String(file.name || "dokument").replace(/[^\w.\-]/g, "_");
    const path = `contracts/${employeeId}/${Date.now()}_${safe}`;
    let bucket = BUCKET;
    let up = await sb().storage.from(bucket).upload(path, file, { upsert: true });
    if (up.error) { bucket = BUCKET_FALLBACK; up = await sb().storage.from(bucket).upload(path, file, { upsert: true }); }
    if (up.error) throw up.error;
    const { data: pub } = sb().storage.from(bucket).getPublicUrl(path);
    const url = pub?.publicUrl || "";

    const guessed = /vertrag|contract|arbeits/i.test(file.name) ? "Arbeitsvertrag" : file.name;
    const row = {
      employee_id: employeeId, title: kind === "contract" ? guessed : file.name, kind,
      file_name: file.name, file_url: url, file_path: bucket + "/" + path,
      file_type: file.type || "", file_size: file.size || null, doc_hash: hash,
      status: "pending", uploaded_by: m?.id || null,
    };
    const { data: ins, error } = await sb().from("employee_contracts").insert(row).select("*").maybeSingle();
    if (error) throw error;

    // Alte Ablage weiterpflegen, damit nichts anderes bricht
    try {
      const list = await teamList();
      const emp = list.find((x) => String(x.id) === String(employeeId));
      const docs = Array.isArray(emp?.documents) ? emp.documents.slice() : [];
      docs.push({ name: file.name, url, uploaded_at: new Date().toISOString() });
      await sb().from("team_members").update({ documents: docs }).eq("id", employeeId);
      if (emp) emp.documents = docs;
    } catch (_) {}

    const signers = await ensureSigners(ins, null);
    ensureViewers(ins);
    await logEvent(ins.id, "uploaded", `${file.name} hochgeladen`);

    if (kind === "contract") {
      const empName = (await teamList()).find((x) => String(x.id) === String(employeeId));
      const label = ins.title || file.name;
      for (const s of signers) {
        await notify(s.user_id, "✍️ Vertrag zum Unterschreiben",
          `Für ${empName?.name || "einen Mitarbeiter"} wurde „${label}" hochgeladen. Bitte im Team-Bereich unter Profil › Dokumente unterzeichnen.`);
      }
      const p = await parties();
      for (const v of p.viewers) {
        if (signers.some((s) => String(s.user_id) === String(v.id))) continue;
        await notify(v.id, "📄 Neuer Vertrag", `„${label}" für ${empName?.name || "einen Mitarbeiter"} liegt zur Einsicht bereit.`);
      }
    }
    return ins;
  }

  async function deleteContract(id) {
    const { data: c } = await sb().from("employee_contracts").select("*").eq("id", id).maybeSingle();
    if (!c) return;
    if (!confirm(`„${c.title || c.file_name}" wirklich löschen? Unterschriften und Prüfpfad gehen mit verloren.`)) return false;
    for (const p of [c.file_path, c.signed_path]) {
      if (!p) continue;
      const i = p.indexOf("/");
      if (i < 0) continue;
      try { await sb().storage.from(p.slice(0, i)).remove([p.slice(i + 1)]); } catch (_) {}
    }
    try { await sb().from("employee_contracts").delete().eq("id", id); } catch (_) {}
    try {
      const list = await teamList();
      const emp = list.find((x) => String(x.id) === String(c.employee_id));
      if (emp && Array.isArray(emp.documents)) {
        const docs = emp.documents.filter((d) => d.url !== c.file_url);
        await sb().from("team_members").update({ documents: docs }).eq("id", emp.id);
        emp.documents = docs;
      }
    } catch (_) {}
    return true;
  }

  /* Der Reiter „Dokumente" im Profil-Popup wird übernommen, sobald er auftaucht */
  function wireProfile(form) {
    const empId = form.querySelector("[data-tp-del]")?.getAttribute("data-tp-del");
    if (!empId) return;
    ensureStyle();
    const panel = form.querySelector('[data-panel="dokumente"]');
    const box = byId("hrDocs");
    if (!panel || !box) return;

    // Original-Upload abklemmen (Listener über Klon entfernen) und eigene Leiste bauen
    const oldLabel = panel.querySelector(".amkz-hr-docup");
    if (oldLabel) {
      const bar = document.createElement("div");
      bar.className = "amkzsg-uprow";
      bar.innerHTML = `
        <label class="amkz-hr-docup" style="margin:0">📎 Dokument hochladen<input id="sgDocFile" type="file" hidden></label>
        <select id="sgDocKind" class="amkzsg-mini" style="padding:8px 11px">
          <option value="contract">Arbeitsvertrag — muss unterschrieben werden</option>
          <option value="document">Nur Ablage — ohne Unterschrift</option>
        </select>`;
      oldLabel.replaceWith(bar);
      byId("sgDocFile").addEventListener("change", async (e) => {
        const file = e.target.files && e.target.files[0];
        if (!file) return;
        const kind = byId("sgDocKind")?.value || "contract";
        e.target.value = "";
        toast("Upload", "Dokument wird hochgeladen…");
        try {
          const c = await uploadContract(empId, file, kind);
          toast("Fertig", kind === "contract"
            ? "Vertrag gespeichert — Mitarbeiter und Nouri wurden zum Unterschreiben benachrichtigt."
            : "Dokument in der Ablage gespeichert.");
          await renderDocsPanel(byId("hrDocs"), empId);
          if (kind === "contract" && c) openSign(c.id);
        } catch (err) {
          toast("Fehler", err.message || "Upload fehlgeschlagen", "error");
        }
      });
    }

    box.addEventListener("click", async (e) => {
      const open = e.target.closest("[data-sg-open]");
      if (open) { e.preventDefault(); openSign(open.getAttribute("data-sg-open")); return; }
      const del = e.target.closest("[data-sg-del]");
      if (del) {
        e.preventDefault();
        const ok = await deleteContract(del.getAttribute("data-sg-del"));
        if (ok) { toast("Gelöscht", "Dokument entfernt."); renderDocsPanel(byId("hrDocs"), empId); }
      }
    });

    form.__amkSignEmp = empId;
    // Kam der Klick vom eigenen Bild in der Seitenleiste? Dann abgespeckte Ansicht.
    if (SELF_AT && Date.now() - SELF_AT < 2500) {
      SELF_AT = 0;
      try { makeSelfView(form); } catch (err) { console.warn("[amk-sign] Mein Profil", err); }
    }
    renderDocsPanel(box, empId);
  }

  new MutationObserver(() => {
    const form = byId("amkTpForm");
    if (!form || form.dataset.amkSignWired) return;
    form.dataset.amkSignWired = "1";
    try { wireProfile(form); } catch (err) { console.warn("[amk-sign] Profil", err); }
  }).observe(document.body, { childList: true, subtree: true });


  /* =====================================================================
     Felderkennung — die Zentrale liest den Vertrag und findet selbst,
     wo unterschrieben, paraphiert, der Name eingetragen oder das Datum
     gesetzt werden muss. Funktioniert bei PDF und bei Word.
     ===================================================================== */
  const PARTY_WORDS = {
    company: ["auftraggeber", "arbeitgeber", "firma", "unternehmen", "management", "agentur", "company", "employer", "vertretungsberechtigt"],
    employee: ["creator", "auftragnehmer", "mitarbeiter", "arbeitnehmer", "streamer", "employee", "contractor", "angestellt", "influencer"],
  };
  const KIND_RULES = [
    { kind: "initials", re: /initial|kürzel|kuerzel|paraphe/i },
    { kind: "date", re: /\bdatum\b|\bdate\b|\bort\b/i },
    { kind: "name", re: /\bname\b|blockschrift|druckschrift|vor-?\s*und\s*nachname/i },
    { kind: "signature", re: /unterschrift|unterzeichn|signature|rechtsverbindlich/i },
  ];
  const KIND_LABEL = { signature: "Unterschreiben", initials: "Initialen", name: "Name eintragen", date: "Datum" };

  const nameTokens = (v) => String(v || "").toLowerCase().split(/[^a-zà-ÿäöüß]+/).filter((w) => w.length >= 4).map((w) => w.slice(0, 4));
  function partyFromText(t, ctx) {
    const s = low(t);
    if (!s) return null;
    for (const p of ["company", "employee"]) if (PARTY_WORDS[p].some((w) => s.includes(w))) return p;
    if (ctx.employeeTokens.some((w) => s.includes(w))) return "employee";
    if (ctx.companyTokens.some((w) => s.includes(w))) return "company";
    return null;
  }
  function kindFromLabel(label, runLen) {
    for (const r of KIND_RULES) if (r.re.test(label)) return r.kind;
    return runLen >= 18 ? "signature" : "initials";
  }

  /* Zeilen aus einer gerenderten PDF-Seite (Textebene von pdf.js) */
  function pdfLines(items, vpW, vpH, pageNo) {
    const rows = [];
    items.forEach((it) => {
      if (!it.str) return;
      const row = rows.find((r) => Math.abs(r.y - it.y) < Math.max(1.5, it.h * 0.6));
      if (row) { row.items.push(it); } else rows.push({ y: it.y, items: [it] });
    });
    rows.sort((a, b) => a.y - b.y);
    return rows.map((r) => {
      r.items.sort((a, b) => a.x - b.x);
      let text = "";
      const map = [];
      r.items.forEach((it, i) => {
        const prev = r.items[i - 1];
        if (prev && it.x - (prev.x + prev.w) > it.h * 0.22) { text += " "; map.push(null); }
        for (let ci = 0; ci < it.str.length; ci++) map.push({ it, ci, n: it.str.length });
        text += it.str;
      });
      const yTop = Math.min.apply(null, r.items.map((i2) => i2.y));
      const hMax = Math.max.apply(null, r.items.map((i2) => i2.h));
      const cols = r.items.map((it) => ({ str: it.str, x: (it.x / vpW) * 100, w: (it.w / vpW) * 100 }));
      return {
        page: pageNo, text,
        // Nur der Text, der waagerecht in diesem Bereich steht — bei zwei
        // Unterschriftsfeldern nebeneinander steht sonst beides in einer Zeile.
        segmentsIn(a, b) { return cols.filter((c) => c.x + c.w > a && c.x < b).map((c) => c.str).join(" "); },
        rectFor(a, b) {
          const A = map[a], B = map[Math.max(a, b - 1)];
          if (!A || !B) return null;
          const x0 = A.it.x + (A.it.w * A.ci) / Math.max(1, A.n);
          const x1 = B.it.x + (B.it.w * (B.ci + 1)) / Math.max(1, B.n);
          return { x: (x0 / vpW) * 100, y: (yTop / vpH) * 100, w: (Math.max(4, x1 - x0) / vpW) * 100, h: (hMax / vpH) * 100 };
        },
      };
    });
  }

  /* Zeilen aus einer gerenderten Word-Seite (echtes HTML im Browser) */
  function domLines(pageEl) {
    const out = [];
    const walker = document.createTreeWalker(pageEl, NodeFilter.SHOW_TEXT, null);
    let n;
    while ((n = walker.nextNode())) {
      if (n.parentElement && n.parentElement.closest(".amkzsg-layer")) continue;
      const node = n;                     // eigene Bindung je Zeile — sonst zeigen
      const t = node.nodeValue || "";     // alle Bereiche auf den letzten Knoten
      if (!t.trim()) continue;
      out.push({
        page: Number(pageEl.dataset.page || 1), text: t,
        segmentsIn() { return t; },
        rectFor(a, b) {
          try {
            const rg = document.createRange();
            rg.setStart(node, Math.max(0, Math.min(t.length, a)));
            rg.setEnd(node, Math.max(0, Math.min(t.length, b)));
            const rc = rg.getClientRects()[0] || rg.getBoundingClientRect();
            const pr = pageEl.getBoundingClientRect();
            if (!rc || !rc.width || !pr.width) return null;
            return { x: ((rc.left - pr.left) / pr.width) * 100, y: ((rc.top - pr.top) / pr.height) * 100, w: (rc.width / pr.width) * 100, h: (rc.height / pr.height) * 100 };
          } catch (_) { return null; }
        },
      });
    }
    return out;
  }

  /* Aus einem Treffer wird ein Feld in der richtigen Größe über der Linie */
  function shapeField(f, r) {
    const lineH = Math.max(0.2, r.h);
    // Das Feld sitzt AUF der Linie: Unterkante = Unterkante der Zeile.
    if (f.kind === "signature") { f.pos_w = Math.min(38, Math.max(16, r.w)); f.pos_h = lineH * 2.4; }
    else if (f.kind === "initials") { f.pos_w = Math.min(16, Math.max(6, r.w)); f.pos_h = lineH * 1.7; }
    else { f.pos_w = Math.min(42, Math.max(12, r.w)); f.pos_h = lineH * 1.35; }
    f.pos_x = r.x;
    f.pos_y = Math.max(0, r.y + lineH - f.pos_h);
    f.pos_x = Math.max(0, Math.min(100 - f.pos_w, f.pos_x));
    f.pos_y = Math.max(0, Math.min(100 - f.pos_h, f.pos_y));
    return f;
  }

  function detectOnLines(lines, ctx) {
    const found = [];
    lines.forEach((ln, i) => {
      const text = ln.text || "";
      const runs = Array.from(text.matchAll(/[_.·]{3,}/g)).filter((m) => /_/.test(m[0]) || m[0].length >= 8);
      if (runs.length) {
        let prevEnd = 0;
        runs.forEach((m) => {
          const label = text.slice(prevEnd, m.index).replace(/\s+/g, " ").trim().slice(-70);
          prevEnd = m.index + m[0].length;
          const r = ln.rectFor(m.index, m.index + m[0].length);
          if (!r) return;
          let party = partyFromText(label, ctx);
          if (!party) {
            // Bei nackten Linien steht die Zuordnung DARUNTER (Name + Rolle) —
            // und zwar genau unter dieser Linie, nicht irgendwo in der Zeile.
            const a = r.x - 3, b2 = r.x + r.w + 12;
            for (let k = 1; k <= 4 && i + k < lines.length; k++) {
              const nx = lines[i + k];
              const eng = nx.segmentsIn ? nx.segmentsIn(a, b2) : (nx.text || "");
              const p = partyFromText(eng, ctx);
              if (p) { party = p; break; }
              if (/_{3,}/.test(eng)) break;
            }
          }
          found.push(shapeField({
            kind: kindFromLabel(label, m[0].length), party, page: ln.page,
            label: label || null, anchor: m[0].slice(0, 40),
          }, r));
        });
        return;
      }
      const m2 = text.match(/unterschrift[^.;]{0,42}/i);
      if (m2 && !/unterschriften\s*$/i.test(text.trim())) {
        const r = ln.rectFor(m2.index, m2.index + m2[0].length);
        if (!r) return;
        found.push(shapeField({
          kind: "signature", party: partyFromText(m2[0], ctx) || partyFromText(text, ctx),
          page: ln.page, label: m2[0].trim(), anchor: m2[0].slice(0, 40),
        }, { x: r.x, y: Math.max(0, r.y - r.h * 0.2), w: Math.max(20, r.w), h: r.h }));
      }
    });
    // Doppelte Treffer (gleiche Stelle) zusammenfassen
    const seen = new Set(), out = [];
    found.forEach((f) => {
      const key = `${f.page}|${Math.round(f.pos_x)}|${Math.round(f.pos_y)}|${f.kind}`;
      if (seen.has(key)) return;
      seen.add(key);
      out.push(f);
    });
    out.sort((a, b) => a.page - b.page || a.pos_y - b.pos_y || a.pos_x - b.pos_x);
    out.forEach((f, i) => { f.sort_no = i; });
    return out;
  }

  /* Erkennung über das gerade gerenderte Dokument laufen lassen */
  function detectFieldsInDoc() {
    const host = byId("sgDoc");
    if (!host || !SG) return null;
    const pages = host.querySelectorAll(".amkzsg-page");
    // Nicht messbar (Ansicht noch nicht sichtbar/aufgebaut)? Dann NICHTS behaupten —
    // sonst würde der Vertrag fälschlich als "keine Felder" abgehakt.
    if (!pages.length) return null;
    let messbar = false;
    pages.forEach((pg) => { const r = pg.getBoundingClientRect(); if (r.width > 40 && r.height > 40) messbar = true; });
    if (!messbar) return null;
    const ctx = {
      employeeTokens: nameTokens(SG.employee?.name),
      companyTokens: nameTokens((SG.signers || []).find((s) => s.party === "company")?.name),
    };
    const all = [];
    pages.forEach((pg) => {
      const no = Number(pg.dataset.page || 1);
      const lines = pg.dataset.kind === "pdf" ? (SG.pdfLines || {})[no] || [] : domLines(pg);
      all.push(...detectOnLines(lines, ctx));
    });
    all.sort((a, b) => a.page - b.page || a.pos_y - b.pos_y || a.pos_x - b.pos_x);
    all.forEach((f, i) => { f.sort_no = i; });
    return all;
  }

  /* Gefundene Felder einmalig speichern und den Unterzeichnern zuordnen */
  async function ensureFields() {
    if (!SG) return [];
    let rows = [];
    try {
      const { data, error } = await sb().from("contract_fields").select("*").eq("contract_id", SG.contract.id).order("sort_no", { ascending: true });
      if (error) { if (missingTable(error)) SG.fieldsUnavailable = true; return []; }
      rows = data || [];
    } catch (_) { return []; }
    if (rows.length) return rows;
    if (SG.contract.fields_ready) return [];
    const found = detectFieldsInDoc();
    if (found === null) return [];        // Ansicht war nicht messbar -> später erneut versuchen
    if (!found.length) {
      try { await sb().from("employee_contracts").update({ fields_ready: true }).eq("id", SG.contract.id); } catch (_) {}
      SG.contract.fields_ready = true;
      return [];
    }
    const byParty = {};
    (SG.signers || []).forEach((s) => { byParty[s.party] = s; });
    const payload = found.map((f) => ({
      contract_id: SG.contract.id, signer_id: f.party && byParty[f.party] ? byParty[f.party].id : null,
      party: f.party || null, kind: f.kind, page: f.page,
      pos_x: Math.round(f.pos_x * 100) / 100, pos_y: Math.round(f.pos_y * 100) / 100,
      pos_w: Math.round(f.pos_w * 100) / 100, pos_h: Math.round(f.pos_h * 100) / 100,
      label: f.label, anchor: f.anchor, auto: true, sort_no: f.sort_no,
    }));
    try {
      const { data } = await sb().from("contract_fields").insert(payload).select("*");
      rows = data || [];
      await sb().from("employee_contracts").update({ fields_ready: true }).eq("id", SG.contract.id);
      SG.contract.fields_ready = true;
      await logEvent(SG.contract.id, "fields", `${rows.length} Felder automatisch erkannt`);
    } catch (_) {}
    return rows;
  }

  /* =====================================================================
     Vollbild-Werkzeug: ansehen, ausfüllen, unterschreiben, abschließen
     ===================================================================== */
  let SG = null;
  let OPEN_SEQ = 0;      // schützt vor zwei Öffnungen gleichzeitig

  const mySigner = () => (SG && (SG.signers || []).find((s) => String(s.user_id) === String(me()?.id))) || null;
  const myFields = () => (SG ? (SG.fields || []).filter((f) => !f.signer_id || String(f.signer_id) === String(mySigner()?.id)) : []);
  const myOpenFields = () => myFields().filter((f) => !f.value);

  function sgHost() {
    let ov = byId("amkzSignOv");
    if (!ov) {
      ov = document.createElement("div");
      ov.id = "amkzSignOv";
      ov.className = "amkzsg-ov";
      document.body.appendChild(ov);
      ov.addEventListener("click", onOverlayClick);
    }
    return ov;
  }
  function closeSign() {
    const ov = byId("amkzSignOv");
    if (ov) { ov.classList.remove("on"); ov.innerHTML = ""; }
    document.body.classList.remove("amkzsg-lock");
    const emp = byId("amkTpForm")?.__amkSignEmp;
    if (emp && byId("hrDocs")) renderDocsPanel(byId("hrDocs"), emp);
    SG = null;
  }

  async function openSign(contractId) {
    ensureStyle();
    const ov = sgHost();
    ov.classList.add("on");
    document.body.classList.add("amkzsg-lock");
    ov.innerHTML = `<div class="amkzsg-shell"><div class="amkzsg-load">Vertrag wird geladen…</div></div>`;
    const token = ++OPEN_SEQ;
    try {
      const { data: c } = await sb().from("employee_contracts").select("*").eq("id", contractId).maybeSingle();
      if (token !== OPEN_SEQ) return;
      if (!c) { toast("Vertrag", "Nicht gefunden.", "error"); closeSign(); return; }
      let signers = (await fetchSigners([c.id]))[c.id] || [];
      if (!signers.length) signers = await ensureSigners(c, null);
      const list = await teamList();
      if (token !== OPEN_SEQ) return;
      SG = {
        contract: c, signers, fields: [],
        employee: list.find((x) => String(x.id) === String(c.employee_id)) || null,
        events: await fetchEvents(c.id),
        bytes: null, pdfLines: {}, pending: null, adopted: null,
      };
      renderShell();
      await renderDoc();
      if (token !== OPEN_SEQ) return;
      SG.fields = await ensureFields();
      if (token !== OPEN_SEQ) return;
      paintDoc();
      refreshSide();
      logEvent(c.id, "viewed", "Dokument geöffnet");
    } catch (err) {
      console.warn("[amk-sign]", err);
      toast("Fehler", err.message || "Vertrag konnte nicht geladen werden", "error");
      closeSign();
    }
  }
  AMKZ.openContract = openSign;

  function renderShell() {
    const c = SG.contract, st = statusOf(c, SG.signers);
    sgHost().innerHTML = `
      <div class="amkzsg-shell">
        <div class="amkzsg-head">
          <div>
            <h3>✍️ ${esc(c.title || c.file_name || "Vertrag")} <span class="amkzsg-pill ${st.cls}">${esc(st.label)}</span></h3>
            <p>${esc(SG.employee?.name || "Mitarbeiter")} · hochgeladen ${esc(fmtDT(c.created_at))}</p>
          </div>
          <div class="amkzsg-headsp"></div>
          <a class="amkzsg-ghost" href="${esc(c.file_url || "#")}" target="_blank" rel="noopener">⬇ Original</a>
          ${c.signed_url ? `<a class="amkzsg-ghost" href="${esc(c.signed_url)}" target="_blank" rel="noopener">📗 Signierte PDF</a>` : ""}
          <button type="button" class="amkzsg-ghost" data-sg-close>✕ Schließen</button>
        </div>
        <div class="amkzsg-body">
          <div class="amkzsg-doc" id="sgDoc"><div class="amkzsg-load">Dokument wird geladen…</div></div>
          <aside class="amkzsg-side">${sideHtml()}</aside>
        </div>
      </div>`;
  }

  /* ---------- Dokument rendern: PDF · Word · Bild ---------- */
  async function renderDoc() {
    const host = byId("sgDoc");
    if (!host || !SG) return;
    const c = SG.contract;
    const url = c.file_url;
    host.innerHTML = `<div class="amkzsg-load">Dokument wird gerendert…</div>`;
    const fallback = (msg) => {
      host.innerHTML = `<div class="amkzsg-fallback"><h4>Keine Vorschau möglich</h4><p>${esc(msg)}</p>
        <a class="amkzsg-ghost" href="${esc(url || "#")}" target="_blank" rel="noopener">⬇ Datei öffnen</a></div>
        <div class="amkzsg-page" data-page="1" data-kind="none" style="max-width:920px;aspect-ratio:1/1.414;background:#fdfdfb"><div class="amkzsg-layer"></div></div>`;
    };
    try {
      if (!SG.bytes) SG.bytes = await (await fetch(url)).arrayBuffer();
    } catch (_) { /* weiter mit dem, was geht */ }

    try {
      if (isPdfFile(c) && SG.bytes) {
        const ok = await loadLib(PDFJS_SRC, () => !!window.pdfjsLib);
        if (!ok) return fallback("Die PDF-Anzeige konnte nicht geladen werden (offline?).");
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER;
        const pdf = await window.pdfjsLib.getDocument({ data: SG.bytes.slice(0) }).promise;
        host.innerHTML = "";
        const targetW = Math.min(920, Math.max(280, host.clientWidth - 28));
        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const base = page.getViewport({ scale: 1 });
          const vp = page.getViewport({ scale: (targetW / base.width) * (window.devicePixelRatio > 1 ? 2 : 1.5) });
          const wrap = document.createElement("div");
          wrap.className = "amkzsg-page";
          wrap.dataset.page = String(i);
          wrap.dataset.kind = "pdf";
          const cv = document.createElement("canvas");
          cv.width = Math.floor(vp.width); cv.height = Math.floor(vp.height);
          wrap.appendChild(cv);
          const layer = document.createElement("div");
          layer.className = "amkzsg-layer";
          wrap.appendChild(layer);
          host.appendChild(wrap);
          await page.render({ canvasContext: cv.getContext("2d"), viewport: vp }).promise;
          // Textebene für die Felderkennung
          try {
            const tc = await page.getTextContent();
            const items = tc.items.map((it) => {
              const t = window.pdfjsLib.Util.transform(base.transform, it.transform);
              const h = Math.hypot(t[2], t[3]) || Math.abs(t[3]) || 10;
              return { str: it.str, x: t[4], y: t[5] - h, w: it.width || 0, h };
            }).filter((it) => it.str);
            SG.pdfLines[i] = pdfLines(items, base.width, base.height, i);
          } catch (_) { SG.pdfLines[i] = []; }
        }
      } else if (isDocxFile(c) && SG.bytes) {
        const ok = await loadLib(MAMMOTH_SRC, () => !!window.mammoth);
        if (!ok) return fallback("Word-Dokumente brauchen die Anzeige-Bibliothek — sie konnte nicht geladen werden.");
        const res = await window.mammoth.convertToHtml({ arrayBuffer: SG.bytes.slice(0) });
        const html = String(res.value || "").replace(/<script[\s\S]*?<\/script>/gi, "").replace(/ on\w+="[^"]*"/gi, "");
        host.innerHTML = `<div class="amkzsg-page amkzsg-word" data-page="1" data-kind="word"><div class="amkzsg-wordbody">${html}</div><div class="amkzsg-layer"></div></div>`;
      } else if (isImgFile(c)) {
        host.innerHTML = `<div class="amkzsg-page" data-page="1" data-kind="img"><img src="${esc(url)}" alt=""><div class="amkzsg-layer"></div></div>`;
        await new Promise((r) => { const im = host.querySelector("img"); if (!im || im.complete) return r(); im.onload = r; im.onerror = r; });
      } else {
        fallback("Dieses Dateiformat lässt sich nicht anzeigen. Bitte den Vertrag als PDF oder Word-Datei hochladen.");
      }
    } catch (err) {
      console.warn("[amk-sign] render", err);
      fallback("Das Dokument konnte nicht geladen werden.");
    }
  }

  /* ---------- Felder + fertige Unterschriften ins Dokument malen ---------- */
  function fieldHtml(f) {
    const mineId = String(mySigner()?.id || "");
    const isMine = !f.signer_id || String(f.signer_id) === mineId;
    const owner = (SG.signers || []).find((s) => String(s.id) === String(f.signer_id));
    let cls = "amkzsg-field";
    if (f.value) cls += " filled";
    else if (isMine && mineId) cls += " mine";
    else cls += " other";
    if (!f.signer_id) cls += " free";
    let inner;
    if (f.value && (f.kind === "signature" || f.kind === "initials")) inner = `<img src="${esc(f.value)}" alt="">`;
    else if (f.value) inner = `<span class="amkzsg-fieldval">${esc(f.value)}</span>`;
    else inner = `<span class="amkzsg-fieldtag">${esc(KIND_LABEL[f.kind] || "Feld")}${!isMine && owner ? " · " + esc(firstName(owner.name)) : ""}</span>`;
    return `<div class="${cls}" data-fid="${esc(f.id)}" data-kind="${esc(f.kind)}" title="${esc(f.label || KIND_LABEL[f.kind] || "")}"
      style="left:${Number(f.pos_x || 0)}%;top:${Number(f.pos_y || 0)}%;width:${Number(f.pos_w || 20)}%;height:${Number(f.pos_h || 4)}%">${inner}</div>`;
  }
  function paintDoc() {
    const host = byId("sgDoc");
    if (!host || !SG) return;
    host.querySelectorAll(".amkzsg-layer").forEach((l) => { l.innerHTML = ""; });
    (SG.fields || []).forEach((f) => {
      const pg = host.querySelector(`.amkzsg-page[data-page="${Number(f.page || 1)}"]`) || host.querySelector(".amkzsg-page");
      const layer = pg && pg.querySelector(".amkzsg-layer");
      if (layer) layer.insertAdjacentHTML("beforeend", fieldHtml(f));
    });
    // Frei platzierte Unterschriften (Dokumente ohne erkannte Felder)
    (SG.signers || []).forEach((s) => {
      if (s.status !== "signed" || !s.signature_url) return;
      if ((SG.fields || []).some((f) => String(f.signer_id) === String(s.id) && f.kind === "signature" && f.value)) return;
      const pg = host.querySelector(`.amkzsg-page[data-page="${Number(s.page || 1)}"]`) || host.querySelector(".amkzsg-page");
      const layer = pg && pg.querySelector(".amkzsg-layer");
      if (!layer) return;
      layer.insertAdjacentHTML("beforeend",
        `<div class="amkzsg-mark" style="left:${Number(s.pos_x || 8)}%;top:${Number(s.pos_y || 78)}%;width:${Number(s.pos_w || 26)}%">
           <img src="${esc(s.signature_url)}" alt=""><span>${esc(s.name || "")} · ${esc(fmtDT(s.signed_at))}</span></div>`);
    });
  }

  /* ---------- Seitenleiste ---------- */
  function sideHtml() {
    const c = SG.contract, myId = String(me()?.id || "");
    const mine = mySigner();
    const open = (SG.signers || []).filter((s) => s.status !== "signed");
    const avatars = AMKZ.state.avatarById || {};
    const signerRows = (SG.signers || []).map((s) => {
      const av = avatars[s.user_id];
      const isMe = String(s.user_id) === myId;
      const total = (SG.fields || []).filter((f) => String(f.signer_id) === String(s.id)).length;
      const doneN = (SG.fields || []).filter((f) => String(f.signer_id) === String(s.id) && f.value).length;
      return `<div class="amkzsg-signer ${s.status === "signed" ? "signed" : ""} ${isMe && s.status !== "signed" ? "isme" : ""}">
        <div class="amkzsg-signer-av${av ? " amkz-has-photo" : ""}"${av ? ` style="background-image:url('${esc(av)}')"` : ""}>${av ? "" : esc(String(s.name || "?").charAt(0).toUpperCase())}</div>
        <div class="amkzsg-signer-in">
          <strong>${esc(s.name || "—")}${isMe ? " (du)" : ""}</strong>
          <small>${s.party === "company" ? "für die Firma" : "Mitarbeiter"} · ${s.status === "signed" ? esc(fmtDT(s.signed_at)) : (s.status === "declined" ? "abgelehnt" : (total ? doneN + "/" + total + " Felder" : "offen"))}</small>
        </div>
        <span class="amkzsg-signer-st">${s.status === "signed" ? "✅" : (s.status === "declined" ? "⛔" : "⏳")}</span>
      </div>`;
    }).join("") || `<div class="amkz-empty">Dieses Dokument liegt nur in der Ablage.</div>`;

    const evt = (SG.events || []).slice().reverse().slice(0, 30).map((e) => {
      const label = { uploaded: "hochgeladen", viewed: "angesehen", signed: "unterschrieben", declined: "abgelehnt", completed: "abgeschlossen", reminded: "erinnert", fields: "Felder erkannt" }[e.action] || e.action;
      return `<div class="amkzsg-evt"><b>${esc(e.actor || "—")}</b> ${esc(label)}<span>${esc(fmtDT(e.created_at))}</span></div>`;
    }).join("") || `<div class="amkzsg-evt"><b>—</b> noch keine Einträge</div>`;

    /* Meine Felder */
    let feldBox = "";
    const mf = mine ? myFields() : [];
    if (mine && mine.status !== "signed" && mf.length) {
      const offen = mf.filter((f) => !f.value).length;
      const kinds = {};
      mf.filter((f) => !f.value).forEach((f) => { kinds[f.kind] = (kinds[f.kind] || 0) + 1; });
      const liste = Object.keys(kinds).map((k) => `${kinds[k]}× ${KIND_LABEL[k] || k}`).join(" · ");
      feldBox = `<div class="amkzsg-sidesec"><h5>Deine Felder</h5>
        <div class="amkzsg-prog"><div class="amkzsg-progbar" style="width:${Math.round(((mf.length - offen) / mf.length) * 100)}%"></div></div>
        <p class="amkzsg-hint" style="text-align:left;margin:7px 0 9px">${mf.length - offen} von ${mf.length} ausgefüllt${offen ? " — offen: " + esc(liste) : ""}</p>
        ${offen ? `<button type="button" class="amkzsg-ghost" style="width:100%;justify-content:center;margin-bottom:7px" data-sg-next>➜ Zum nächsten Feld</button>
        <button type="button" class="amkzsg-ghost" style="width:100%;justify-content:center" data-sg-fillall>⚡ Alle ${offen} Felder auf einmal ausfüllen</button>` : ""}
      </div>`;
    }

    let cta;
    if (c.status === "declined") cta = `<p class="amkzsg-hint">Dieser Vertrag wurde abgelehnt.</p>`;
    else if (!open.length && SG.signers.length) cta = `<a class="amkzsg-gold" style="text-decoration:none" href="${esc(c.signed_url || c.file_url || "#")}" target="_blank" rel="noopener">📗 Unterschriebene PDF öffnen</a><p class="amkzsg-hint">Alle Parteien haben unterschrieben.</p>`;
    else if (mine && mine.status !== "signed") {
      const offen = myOpenFields().length;
      cta = `<button type="button" class="amkzsg-gold" data-sg-sign>${mf.length ? (offen ? `✍️ Ausfüllen & unterschreiben` : `✅ Fertig — jetzt abschließen`) : "✍️ Jetzt unterschreiben"}</button>
        <button type="button" class="amkzsg-ghost" style="width:100%;justify-content:center;margin-top:8px" data-sg-decline>Ablehnen</button>`;
    } else if (open.length) cta = `<button type="button" class="amkzsg-gold" data-sg-remind>🔔 ${esc(open.map((s) => firstName(s.name)).join(" & "))} erinnern</button><p class="amkzsg-hint">Du hast Einsicht. Unterschreiben muss ${esc(open.map((s) => firstName(s.name)).join(" & "))}.</p>`;
    else cta = "";

    return `
      <div class="amkzsg-sidesec"><h5>Unterzeichner</h5>${signerRows}</div>
      ${feldBox}
      <div class="amkzsg-sidesec"><h5>Dokument</h5>
        <div class="amkzsg-evt"><b>Datei</b><span>${esc(c.file_name || "—")}</span></div>
        <div class="amkzsg-evt"><b>Größe</b><span>${c.file_size ? Math.round(c.file_size / 1024) + " KB" : "—"}</span></div>
        <div class="amkzsg-evt"><b>Felder</b><span>${(SG.fields || []).length ? (SG.fields || []).length + " erkannt" : "keine erkannt"}</span></div>
        <div class="amkzsg-evt"><b>SHA-256</b><span style="font-family:monospace">${esc((c.doc_hash || "—").slice(0, 16))}…</span></div>
      </div>
      <div class="amkzsg-sidesec"><h5>Prüfpfad</h5>${evt}</div>
      <div class="amkzsg-cta">${cta}</div>`;
  }
  function refreshSide() {
    const side = document.querySelector("#amkzSignOv .amkzsg-side");
    if (side) side.innerHTML = sideHtml();
    const head = document.querySelector("#amkzSignOv .amkzsg-head h3 .amkzsg-pill");
    if (head) {
      const st = statusOf(SG.contract, SG.signers);
      head.className = "amkzsg-pill " + st.cls;
      head.textContent = st.label;
    }
  }

  /* ---------- Klicks im Werkzeug ---------- */
  function onOverlayClick(e) {
    if (e.target.closest("[data-sg-close]")) { e.preventDefault(); closeSign(); return; }
    if (e.target.closest("[data-sg-sign]")) { e.preventDefault(); startSigning(); return; }
    if (e.target.closest("[data-sg-decline]")) { e.preventDefault(); declineContract(); return; }
    if (e.target.closest("[data-sg-remind]")) { e.preventDefault(); remindOpen(); return; }
    if (e.target.closest("[data-sg-auto]")) { e.preventDefault(); autoPlace(); return; }
    if (e.target.closest("[data-sg-confirm]")) { e.preventDefault(); finishSignature(); return; }
    if (e.target.closest("[data-sg-cancelplace]")) { e.preventDefault(); cancelPlacing(); return; }
    if (e.target.closest("[data-sg-next]")) { e.preventDefault(); jumpToNextField(); return; }
    if (e.target.closest("[data-sg-fillall]")) { e.preventDefault(); fillAllMine(); return; }
    const fld = e.target.closest("[data-fid]");
    if (fld) { e.preventDefault(); onFieldClick(fld.getAttribute("data-fid")); return; }
    // Beim freien Platzieren: Klick auf eine Seite setzt die Unterschrift dorthin
    if (SG && SG.pending && !SG.pending.box) {
      const page = e.target.closest(".amkzsg-page");
      if (page) placeAtEvent(page, e);
    }
  }
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && byId("amkzSignOv")?.classList.contains("on") && !document.querySelector(".amkzsg-pad")) closeSign();
  });

  async function remindOpen() {
    const open = (SG.signers || []).filter((s) => s.status !== "signed");
    const label = SG.contract.title || SG.contract.file_name;
    for (const s of open) {
      await notify(s.user_id, "🔔 Erinnerung: Vertrag unterschreiben",
        `„${label}" für ${SG.employee?.name || "einen Mitarbeiter"} wartet noch auf deine Unterschrift.`);
    }
    await logEvent(SG.contract.id, "reminded", open.map((s) => s.name).join(", "));
    SG.events = await fetchEvents(SG.contract.id);
    refreshSide();
    toast("Erinnerung", open.length ? `${open.map((s) => firstName(s.name)).join(" & ")} wurde erinnert.` : "Niemand offen.");
  }

  async function declineContract() {
    const reason = prompt("Warum lehnst du ab? (wird im Prüfpfad festgehalten)");
    if (reason === null) return;
    const mine = mySigner();
    if (!mine) return;
    try {
      await sb().from("contract_signers").update({ status: "declined", decline_reason: reason || null }).eq("id", mine.id);
      await sb().from("employee_contracts").update({ status: "declined", updated_at: new Date().toISOString() }).eq("id", SG.contract.id);
      await logEvent(SG.contract.id, "declined", reason || null);
      SG.contract.status = "declined";
      mine.status = "declined";
      SG.events = await fetchEvents(SG.contract.id);
      refreshSide();
      const label = SG.contract.title || SG.contract.file_name;
      for (const s of SG.signers) await notify(s.user_id, "⛔ Vertrag abgelehnt", `„${label}" wurde von ${me()?.name || "einem Beteiligten"} abgelehnt.${reason ? " Grund: " + reason : ""}`);
      if (SG.contract.uploaded_by) await notify(SG.contract.uploaded_by, "⛔ Vertrag abgelehnt", `„${label}" wurde abgelehnt.${reason ? " Grund: " + reason : ""}`);
      toast("Abgelehnt", "Alle Beteiligten wurden informiert.");
    } catch (err) { toast("Fehler", err.message || "Konnte nicht abgelehnt werden", "error"); }
  }

  /* =====================================================================
     Unterschrift erfassen: zeichnen · tippen · Bild  (+ Initialen)
     ===================================================================== */
  const SIG_FONTS = [
    { label: "Signatur", css: "'Segoe Script','Brush Script MT','Snell Roundhand',cursive" },
    { label: "Kursiv", css: "'Palatino Linotype','Book Antiqua',Georgia,serif" },
    { label: "Klar", css: "'Inter','Helvetica Neue',Arial,sans-serif" },
  ];
  const initialsOf = (name) => String(name || "").trim().split(/\s+/).filter(Boolean).slice(0, 3).map((w) => w.charAt(0).toUpperCase()).join(".") + ".";

  function trimCanvas(cv) {
    const ctx = cv.getContext("2d");
    const { width: w, height: h } = cv;
    let d;
    try { d = ctx.getImageData(0, 0, w, h).data; } catch (_) { return cv; }
    let x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        if (d[(y * w + x) * 4 + 3] > 8) {
          if (x < x0) x0 = x; if (x > x1) x1 = x;
          if (y < y0) y0 = y; if (y > y1) y1 = y;
        }
      }
    }
    if (x1 < 0) return null;
    const pad = Math.round(Math.max(w, h) * 0.02) + 2;
    x0 = Math.max(0, x0 - pad); y0 = Math.max(0, y0 - pad);
    x1 = Math.min(w - 1, x1 + pad); y1 = Math.min(h - 1, y1 + pad);
    const out = document.createElement("canvas");
    out.width = x1 - x0 + 1; out.height = y1 - y0 + 1;
    out.getContext("2d").drawImage(cv, x0, y0, out.width, out.height, 0, 0, out.width, out.height);
    return out;
  }
  function textToSignature(text, fontCss) {
    const cv = document.createElement("canvas");
    cv.width = 1400; cv.height = 340;
    const ctx = cv.getContext("2d");
    ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.fillStyle = "#12121a";
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";
    let size = 150;
    do { ctx.font = `italic ${size}px ${fontCss}`; size -= 6; } while (ctx.measureText(text).width > cv.width - 90 && size > 30);
    ctx.fillText(text, cv.width / 2, cv.height / 2);
    return trimCanvas(cv);
  }
  function whiteToAlpha(cv) {
    const ctx = cv.getContext("2d");
    let img;
    try { img = ctx.getImageData(0, 0, cv.width, cv.height); } catch (_) { return cv; }
    const d = img.data;
    for (let i = 0; i < d.length; i += 4) {
      const l = (d[i] + d[i + 1] + d[i + 2]) / 3;
      if (l > 232) d[i + 3] = 0;
      else if (l > 170) d[i + 3] = Math.round(d[i + 3] * (232 - l) / 62);
    }
    ctx.putImageData(img, 0, 0);
    return cv;
  }
  function bindPad(cv, onDone) {
    const ctx = cv.getContext("2d");
    let fitted = false;
    function fit() {
      const dpr = Math.min(3, window.devicePixelRatio || 1);
      const r = cv.getBoundingClientRect();
      if (!r.width) return;
      cv.width = Math.round(r.width * dpr);
      cv.height = Math.round(r.height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.lineWidth = 2.6; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#12121a";
      fitted = true;
    }
    requestAnimationFrame(fit);
    let drawing = false, last = null;
    const pt = (e) => { const r = cv.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
    cv.addEventListener("pointerdown", (e) => { if (!fitted) fit(); drawing = true; last = pt(e); try { cv.setPointerCapture(e.pointerId); } catch (_) {} e.preventDefault(); });
    cv.addEventListener("pointermove", (e) => {
      if (!drawing) return;
      const p = pt(e);
      ctx.beginPath(); ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke();
      last = p; e.preventDefault();
    });
    const end = () => { if (!drawing) return; drawing = false; const t = trimCanvas(cv); onDone(t ? t.toDataURL("image/png") : null); };
    cv.addEventListener("pointerup", end);
    cv.addEventListener("pointerleave", end);
    cv.addEventListener("pointercancel", end);
    return { clear: () => { ctx.clearRect(0, 0, cv.width, cv.height); onDone(null); }, refit: fit };
  }

  /* onAdopt(adopted) wird aufgerufen, sobald Unterschrift + Initialen stehen */
  function openPad(signer, onAdopt) {
    const shell = document.querySelector("#amkzSignOv .amkzsg-shell");
    if (!shell) return;
    document.querySelector(".amkzsg-pad")?.remove();
    const braucheIni = (SG.fields || []).some((f) => f.kind === "initials" && (!f.signer_id || String(f.signer_id) === String(signer.id)) && !f.value);
    const pad = document.createElement("div");
    pad.className = "amkzsg-pad";
    pad.innerHTML = `
      <div class="amkzsg-padcard">
        <div class="amkzsg-padhead">
          <div>
            <h4>Unterschrift von ${esc(signer.name || "")}</h4>
            <p>Zeichnen, tippen oder ein Foto deiner Unterschrift hochladen.${braucheIni ? " Die Initialen setzt die Zentrale automatisch — du kannst sie auch selbst zeichnen." : ""}</p>
          </div>
          <button type="button" class="amkzsg-x" data-pad-x>✕</button>
        </div>
        <div class="amkzsg-padtabs">
          <button type="button" class="amkzsg-padtab active" data-pad="draw">✍️ Zeichnen</button>
          <button type="button" class="amkzsg-padtab" data-pad="type">⌨️ Tippen</button>
          <button type="button" class="amkzsg-padtab" data-pad="img">🖼 Bild</button>
        </div>
        <div>
          <div data-padpanel="draw"><canvas id="sgPad" class="amkzsg-canvas"></canvas><div class="amkzsg-padhint">Mit Maus oder Finger unterschreiben</div></div>
          <div data-padpanel="type" hidden>
            <input id="sgTypeVal" class="amkzsg-input" placeholder="Vollständiger Name" value="${esc(signer.name || "")}">
            <div class="amkzsg-fonts">${SIG_FONTS.map((f, i) => `<button type="button" class="amkzsg-fontpick ${i === 0 ? "active" : ""}" data-font="${i}" style="font-family:${f.css};font-style:italic">${esc(signer.name || f.label)}</button>`).join("")}</div>
            <div id="sgTypePrev" class="amkzsg-typeprev"><small>Vorschau</small></div>
          </div>
          <div data-padpanel="img" hidden>
            <label class="amkzsg-upl">🖼 Bild wählen<input id="sgSigImg" type="file" accept="image/*" hidden></label>
            <div id="sgImgPrev" class="amkzsg-typeprev"><small>Weißer Hintergrund wird automatisch entfernt</small></div>
          </div>
        </div>
        ${braucheIni ? `<div class="amkzsg-inibox">
          <div class="amkzsg-inihead"><b>Initialen</b><button type="button" class="amkzsg-inisw" data-ini-draw>✎ selbst zeichnen</button></div>
          <div id="sgIniAuto" class="amkzsg-iniprev"><small>werden gesetzt…</small></div>
          <canvas id="sgIniPad" class="amkzsg-canvas amkzsg-inipad" hidden></canvas>
        </div>` : ""}
        <label class="amkzsg-consent"><input type="checkbox" id="sgConsent"> Ich bestätige, dass diese elektronische Unterschrift für mich rechtlich verbindlich ist und meiner handschriftlichen Unterschrift entspricht.</label>
        <div class="amkzsg-padact">
          <button type="button" class="amkzsg-ghost" data-pad-clear>Zurücksetzen</button>
          <span class="amkzsg-sp"></span>
          <button type="button" class="amkzsg-ghost" data-pad-x>Abbrechen</button>
          <button type="button" class="amkzsg-gold" data-pad-ok disabled>Übernehmen</button>
        </div>
      </div>`;
    shell.appendChild(pad);

    const state = { tab: "draw", draw: null, type: null, img: null, font: 0, iniDraw: null, iniAuto: null };
    const okBtn = pad.querySelector("[data-pad-ok]");
    const consent = pad.querySelector("#sgConsent");
    const current = () => state[state.tab];
    const sync = () => { okBtn.disabled = !(current() && consent.checked); };

    const drawPad = bindPad(pad.querySelector("#sgPad"), (d) => { state.draw = d; sync(); });
    let iniPad = null;
    function refreshIni() {
      if (!braucheIni) return;
      const box = pad.querySelector("#sgIniAuto");
      const c2 = textToSignature(initialsOf(signer.name), SIG_FONTS[state.font].css);
      state.iniAuto = c2 ? c2.toDataURL("image/png") : null;
      if (box && !state.iniDraw) box.innerHTML = state.iniAuto ? `<img src="${state.iniAuto}" alt="">` : "<small>—</small>";
    }
    refreshIni();
    pad.querySelector("[data-ini-draw]")?.addEventListener("click", (e) => {
      const cv = pad.querySelector("#sgIniPad"), box = pad.querySelector("#sgIniAuto");
      const an = cv.hidden;
      cv.hidden = !an; box.hidden = an;
      e.target.textContent = an ? "↺ automatisch" : "✎ selbst zeichnen";
      if (an && !iniPad) iniPad = bindPad(cv, (d) => { state.iniDraw = d; });
      else if (an) iniPad.refit();
      if (!an) { state.iniDraw = null; refreshIni(); }
    });

    function renderTyped() {
      const v = pad.querySelector("#sgTypeVal").value.trim();
      const prev = pad.querySelector("#sgTypePrev");
      if (!v) { state.type = null; prev.innerHTML = "<small>Vorschau</small>"; sync(); return; }
      const c2 = textToSignature(v, SIG_FONTS[state.font].css);
      state.type = c2 ? c2.toDataURL("image/png") : null;
      prev.innerHTML = state.type ? `<img src="${state.type}" alt="">` : "<small>Vorschau</small>";
      pad.querySelectorAll(".amkzsg-fontpick").forEach((b) => { b.textContent = v; });
      sync();
    }
    pad.querySelector("#sgTypeVal").addEventListener("input", renderTyped);
    pad.querySelectorAll("[data-font]").forEach((b) => b.addEventListener("click", () => {
      state.font = Number(b.dataset.font);
      pad.querySelectorAll(".amkzsg-fontpick").forEach((x) => x.classList.toggle("active", x === b));
      renderTyped(); refreshIni();
    }));

    pad.querySelector("#sgSigImg").addEventListener("change", (e) => {
      const f = e.target.files && e.target.files[0];
      if (!f) return;
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, 1200 / img.width);
        const c2 = document.createElement("canvas");
        c2.width = Math.round(img.width * scale);
        c2.height = Math.round(img.height * scale);
        c2.getContext("2d").drawImage(img, 0, 0, c2.width, c2.height);
        const t = trimCanvas(whiteToAlpha(c2));
        state.img = (t || c2).toDataURL("image/png");
        pad.querySelector("#sgImgPrev").innerHTML = `<img src="${state.img}" alt="">`;
        sync();
      };
      img.onerror = () => toast("Fehler", "Bild konnte nicht gelesen werden", "error");
      img.src = URL.createObjectURL(f);
    });

    pad.querySelectorAll("[data-pad]").forEach((b) => b.addEventListener("click", () => {
      state.tab = b.dataset.pad;
      pad.querySelectorAll("[data-pad]").forEach((x) => x.classList.toggle("active", x === b));
      pad.querySelectorAll("[data-padpanel]").forEach((p) => { p.hidden = p.dataset.padpanel !== state.tab; });
      if (state.tab === "draw") drawPad.refit();
      sync();
    }));
    consent.addEventListener("change", sync);
    pad.querySelector("[data-pad-clear]").addEventListener("click", () => {
      if (state.tab === "draw") drawPad.clear();
      if (state.tab === "type") { pad.querySelector("#sgTypeVal").value = ""; renderTyped(); }
      if (state.tab === "img") { state.img = null; pad.querySelector("#sgImgPrev").innerHTML = "<small>Weißer Hintergrund wird automatisch entfernt</small>"; }
      sync();
    });
    pad.querySelectorAll("[data-pad-x]").forEach((b) => b.addEventListener("click", () => pad.remove()));
    okBtn.addEventListener("click", async () => {
      const sig = current();
      if (!sig) return;
      okBtn.disabled = true; okBtn.textContent = "Wird übernommen…";
      const adopted = { signature: sig, initials: state.iniDraw || state.iniAuto || sig, kind: state.tab === "img" ? "image" : state.tab };
      try {
        adopted.sigUrl = await uploadDataUrl(adopted.signature, `signatures/${SG.contract.id}/${signer.id}_sig_${Date.now()}.png`);
        adopted.iniUrl = braucheIni ? await uploadDataUrl(adopted.initials, `signatures/${SG.contract.id}/${signer.id}_ini_${Date.now()}.png`) : adopted.sigUrl;
        SG.adopted = adopted;
        try { await sb().from("contract_signers").update({ signature_url: adopted.sigUrl, initials_url: adopted.iniUrl, signature_kind: adopted.kind }).eq("id", signer.id); } catch (_) {}
        signer.signature_url = adopted.sigUrl; signer.initials_url = adopted.iniUrl; signer.signature_kind = adopted.kind;
        pad.remove();
        if (onAdopt) onAdopt(adopted);
      } catch (err) {
        toast("Fehler", err.message || "Unterschrift konnte nicht gespeichert werden", "error");
        okBtn.disabled = false; okBtn.textContent = "Übernehmen";
      }
    });
  }

  async function uploadDataUrl(dataUrl, path) {
    const blob = dataUrlToBlob(dataUrl);
    let bucket = BUCKET;
    let up = await sb().storage.from(bucket).upload(path, blob, { upsert: true, contentType: "image/png" });
    if (up.error) { bucket = BUCKET_FALLBACK; up = await sb().storage.from(bucket).upload(path, blob, { upsert: true, contentType: "image/png" }); }
    if (up.error) throw up.error;
    const { data } = sb().storage.from(bucket).getPublicUrl(path);
    return data?.publicUrl || "";
  }

  /* =====================================================================
     Felder ausfüllen
     ===================================================================== */
  const heute = () => new Date().toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
  function valueFor(f, mine) {
    if (f.kind === "signature") return SG.adopted?.sigUrl || mine.signature_url;
    if (f.kind === "initials") return SG.adopted?.iniUrl || mine.initials_url || mine.signature_url;
    if (f.kind === "name") return mine.name || "";
    if (f.kind === "date") return heute();
    return "";
  }
  async function applyFields(list) {
    const mine = mySigner();
    if (!mine || !list.length) return;
    for (const f of list) {
      const value = valueFor(f, mine);
      if (!value) continue;
      const patch = { value, filled_at: new Date().toISOString() };
      if (!f.signer_id) { patch.signer_id = mine.id; patch.party = mine.party; }
      try { await sb().from("contract_fields").update(patch).eq("id", f.id); } catch (_) {}
      Object.assign(f, patch);
    }
    paintDoc();
    refreshSide();
  }
  async function onFieldClick(fid) {
    const f = (SG.fields || []).find((x) => String(x.id) === String(fid));
    if (!f) return;
    const mine = mySigner();
    if (!mine || mine.status === "signed") { toast("Feld", "Für dich ist hier nichts auszufüllen.", "error"); return; }
    if (f.signer_id && String(f.signer_id) !== String(mine.id)) {
      const owner = (SG.signers || []).find((s) => String(s.id) === String(f.signer_id));
      toast("Feld", `Dieses Feld gehört ${owner?.name || "der anderen Partei"}.`, "error");
      return;
    }
    if (f.value) {
      if (!confirm("Feld wieder leeren?")) return;
      try { await sb().from("contract_fields").update({ value: null, filled_at: null }).eq("id", f.id); } catch (_) {}
      f.value = null; f.filled_at = null;
      paintDoc(); refreshSide();
      return;
    }
    if ((f.kind === "signature" || f.kind === "initials") && !SG.adopted && !mine.signature_url) {
      openPad(mine, () => applyFields([f]).then(afterFill));
      return;
    }
    await applyFields([f]);
    afterFill();
  }
  async function fillAllMine() {
    const mine = mySigner();
    if (!mine) return;
    const offen = myOpenFields();
    if (!offen.length) { afterFill(); return; }
    if (!SG.adopted && !mine.signature_url) { openPad(mine, () => fillAllMine()); return; }
    toast("Felder", `${offen.length} Felder werden ausgefüllt…`);
    await applyFields(offen);
    afterFill();
  }
  function afterFill() {
    const rest = myOpenFields().length;
    if (rest) { toast("Weiter", `Noch ${rest} Feld${rest > 1 ? "er" : ""} offen.`); jumpToNextField(); }
    else completeSigner();
  }
  function jumpToNextField() {
    const next = myOpenFields()[0];
    if (!next) return;
    const el = document.querySelector(`[data-fid="${next.id}"]`);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    el.classList.add("flash");
    setTimeout(() => el.classList.remove("flash"), 1400);
  }

  function startSigning() {
    const mine = mySigner();
    if (!mine || mine.status === "signed") { toast("Unterschrift", "Für dich ist hier nichts zu unterschreiben.", "error"); return; }
    if (myFields().length) { fillAllMine(); return; }
    // Kein Feld erkannt -> frei platzieren
    if (SG.adopted || mine.signature_url) { startPlacing(mine, SG.adopted?.signature || mine.signature_url, mine.signature_kind || "draw"); return; }
    openPad(mine, (ad) => startPlacing(mine, ad.signature, ad.kind));
  }

  /* =====================================================================
     Freies Platzieren — für Dokumente ohne erkennbare Felder
     ===================================================================== */
  function showBar(html) {
    const shell = document.querySelector("#amkzSignOv .amkzsg-shell");
    if (!shell) return;
    shell.querySelector(".amkzsg-bar")?.remove();
    const bar = document.createElement("div");
    bar.className = "amkzsg-bar";
    bar.innerHTML = html;
    shell.appendChild(bar);
  }
  function hideBar() { document.querySelector("#amkzSignOv .amkzsg-bar")?.remove(); }

  function startPlacing(signer, dataUrl, kind) {
    SG.pending = { signer, dataUrl, kind, box: null };
    byId("sgDoc")?.classList.add("is-placing");
    showBar(`<p>👆 Tippe im Vertrag auf die Stelle, an der deine Unterschrift stehen soll.</p>
      <button type="button" class="amkzsg-ghost" data-sg-auto>Automatisch platzieren</button>
      <button type="button" class="amkzsg-ghost" data-sg-cancelplace>Abbrechen</button>`);
    const first = byId("sgDoc")?.querySelector(".amkzsg-page");
    if (first) first.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  function cancelPlacing() {
    document.querySelectorAll("#sgDoc .amkzsg-drop").forEach((n) => n.remove());
    byId("sgDoc")?.classList.remove("is-placing");
    hideBar();
    if (SG) SG.pending = null;
  }
  function autoPlace() {
    const pages = byId("sgDoc")?.querySelectorAll(".amkzsg-page");
    if (!pages || !pages.length) { toast("Hinweis", "Keine Seite zum Platzieren gefunden.", "error"); return; }
    const page = pages[pages.length - 1];
    dropBox(page, SG.pending.signer.party === "company" ? 56 : 8, 76, 26);
  }
  function placeAtEvent(page, e) {
    const r = page.getBoundingClientRect();
    const w = 26;
    const x = Math.max(0, Math.min(100 - w, ((e.clientX - r.left) / r.width) * 100 - w / 2));
    const y = Math.max(0, Math.min(94, ((e.clientY - r.top) / r.height) * 100 - 3));
    dropBox(page, x, y, w);
  }
  function dropBox(page, x, y, w) {
    document.querySelectorAll("#sgDoc .amkzsg-drop").forEach((n) => n.remove());
    const layer = page.querySelector(".amkzsg-layer");
    if (!layer) return;
    const el = document.createElement("div");
    el.className = "amkzsg-drop";
    el.style.cssText = `left:${x}%;top:${y}%;width:${w}%;pointer-events:auto`;
    el.innerHTML = `<img src="${SG.pending.dataUrl}" alt=""><span class="amkzsg-grip"></span>`;
    layer.appendChild(el);
    SG.pending.box = el;
    SG.pending.page = Number(page.dataset.page || 1);
    makeDraggable(el, page);
    byId("sgDoc")?.classList.remove("is-placing");
    showBar(`<p>Passt es? Ziehen zum Verschieben, Ecke unten rechts zum Vergrößern.</p>
      <button type="button" class="amkzsg-ghost" data-sg-cancelplace>Abbrechen</button>
      <button type="button" class="amkzsg-gold" data-sg-confirm>✓ Rechtsverbindlich unterschreiben</button>`);
  }
  function makeDraggable(el, page) {
    let mode = null, sx = 0, sy = 0, ox = 0, oy = 0, ow = 0;
    const pct = () => ({ x: parseFloat(el.style.left) || 0, y: parseFloat(el.style.top) || 0, w: parseFloat(el.style.width) || 26 });
    el.addEventListener("pointerdown", (e) => {
      mode = e.target.closest(".amkzsg-grip") ? "size" : "move";
      const p = pct();
      sx = e.clientX; sy = e.clientY; ox = p.x; oy = p.y; ow = p.w;
      el.classList.add("dragging");
      try { el.setPointerCapture(e.pointerId); } catch (_) {}
      e.preventDefault(); e.stopPropagation();
    });
    el.addEventListener("pointermove", (e) => {
      if (!mode) return;
      const r = page.getBoundingClientRect();
      const dx = ((e.clientX - sx) / r.width) * 100;
      const dy = ((e.clientY - sy) / r.height) * 100;
      if (mode === "move") {
        el.style.left = Math.max(0, Math.min(100 - pct().w, ox + dx)) + "%";
        el.style.top = Math.max(0, Math.min(97, oy + dy)) + "%";
      } else el.style.width = Math.max(8, Math.min(70, ow + dx)) + "%";
      e.preventDefault();
    });
    const up = (e) => { mode = null; el.classList.remove("dragging"); try { el.releasePointerCapture(e.pointerId); } catch (_) {} };
    el.addEventListener("pointerup", up);
    el.addEventListener("pointercancel", up);
    el.addEventListener("click", (e) => e.stopPropagation());
  }

  async function finishSignature() {
    const pend = SG && SG.pending;
    if (!pend || !pend.box) return;
    const btn = document.querySelector("[data-sg-confirm]");
    if (btn) { btn.disabled = true; btn.textContent = "Wird gespeichert…"; }
    const s = pend.signer;
    const pos = {
      page: pend.page || 1,
      pos_x: Math.round((parseFloat(pend.box.style.left) || 0) * 100) / 100,
      pos_y: Math.round((parseFloat(pend.box.style.top) || 0) * 100) / 100,
      pos_w: Math.round((parseFloat(pend.box.style.width) || 26) * 100) / 100,
    };
    try {
      const url = SG.adopted?.sigUrl || s.signature_url || await uploadDataUrl(pend.dataUrl, `signatures/${SG.contract.id}/${s.id}_${Date.now()}.png`);
      Object.assign(s, pos, { signature_url: url, signature_kind: pend.kind });
      try { await sb().from("contract_signers").update({ ...pos, signature_url: url, signature_kind: pend.kind }).eq("id", s.id); } catch (_) {}
      cancelPlacing();
      await completeSigner();
    } catch (err) {
      console.warn("[amk-sign] sign", err);
      toast("Fehler", err.message || "Unterschrift konnte nicht gespeichert werden", "error");
      if (btn) { btn.disabled = false; btn.textContent = "✓ Rechtsverbindlich unterschreiben"; }
    }
  }

  /* =====================================================================
     Unterzeichner abschließen -> wenn alle fertig sind, PDF bauen
     ===================================================================== */
  async function completeSigner() {
    const s = mySigner();
    if (!s || s.status === "signed") return;
    const patch = {
      status: "signed",
      signature_url: SG.adopted?.sigUrl || s.signature_url || "",
      signature_kind: SG.adopted?.kind || s.signature_kind || "draw",
      signed_at: new Date().toISOString(),
      ip: await clientIp(),
      user_agent: String(navigator.userAgent || "").slice(0, 240),
    };
    try { await sb().from("contract_signers").update(patch).eq("id", s.id); } catch (err) { toast("Fehler", err.message || "Speichern fehlgeschlagen", "error"); return; }
    Object.assign(s, patch);
    await logEvent(SG.contract.id, "signed", `${s.name} (${s.party === "company" ? "Firma" : "Mitarbeiter"})`);
    refreshNudge();
    SG.events = await fetchEvents(SG.contract.id);
    paintDoc();
    refreshSide();

    const label = SG.contract.title || SG.contract.file_name;
    const open = (SG.signers || []).filter((x) => x.status !== "signed");
    if (!open.length) {
      toast("Unterschrieben", "Alle Parteien sind fertig — die signierte PDF wird erstellt…");
      await completeContract();
    } else {
      toast("Unterschrieben", `Gespeichert. Es fehlt noch ${open.map((x) => firstName(x.name)).join(" & ")}.`);
      for (const o of open) {
        await notify(o.user_id, "✍️ Du bist dran",
          `${me()?.name || "Jemand"} hat „${label}" unterschrieben. Jetzt fehlt nur noch deine Unterschrift.`);
      }
    }
  }

  async function completeContract() {
    const c = SG.contract, label = c.title || c.file_name;
    let signedUrl = null, signedPath = null;
    try {
      const built = await buildSignedPdf();
      if (built) { signedUrl = built.url; signedPath = built.path; }
    } catch (err) {
      console.warn("[amk-sign] pdf", err);
      toast("Hinweis", "Die Unterschriften sind gespeichert, die finale PDF konnte aber nicht erzeugt werden.", "error");
    }
    const patch = { status: "completed", completed_at: new Date().toISOString(), updated_at: new Date().toISOString() };
    if (signedUrl) { patch.signed_url = signedUrl; patch.signed_path = signedPath; }
    try { await sb().from("employee_contracts").update(patch).eq("id", c.id); } catch (_) {}
    Object.assign(SG.contract, patch);
    await logEvent(c.id, "completed", signedUrl ? "signierte PDF erstellt" : "ohne PDF abgeschlossen");
    SG.events = await fetchEvents(c.id);
    refreshSide();

    const seen = new Set();
    for (const s of SG.signers) {
      if (seen.has(String(s.user_id))) continue;
      seen.add(String(s.user_id));
      await notify(s.user_id, "✅ Vertrag vollständig unterzeichnet",
        `„${label}" ist von allen Parteien unterschrieben.${signedUrl ? " Signierte PDF: " + signedUrl : ""}`);
    }
    const p = await parties();
    for (const v of p.viewers) {
      if (seen.has(String(v.id))) continue;
      seen.add(String(v.id));
      await notify(v.id, "✅ Vertrag vollständig unterzeichnet", `„${label}" für ${SG.employee?.name || "einen Mitarbeiter"} ist unterschrieben.`);
    }
    if (c.uploaded_by && !seen.has(String(c.uploaded_by))) {
      await notify(c.uploaded_by, "✅ Vertrag vollständig unterzeichnet", `„${label}" ist unterschrieben.`);
    }
    toast("Fertig", "Vertrag vollständig unterzeichnet.");
  }

  /* =====================================================================
     Finale PDF: Original + eingebrannte Felder + Unterschriften-Zertifikat
     ===================================================================== */
  async function embedImg(pdf, url) {
    const buf = await (await fetch(url)).arrayBuffer();
    try { return await pdf.embedPng(buf); } catch (_) { return await pdf.embedJpg(buf); }
  }
  async function drawFieldsOn(pdf, pages, helv, rgb) {
    for (const f of (SG.fields || [])) {
      if (!f.value) continue;
      const pg = pages[Math.min(Math.max(1, Number(f.page || 1)), pages.length) - 1];
      if (!pg) continue;
      const { width: W, height: H } = pg.getSize();
      const x = (Number(f.pos_x || 0) / 100) * W;
      const w = (Number(f.pos_w || 20) / 100) * W;
      const boxH = (Number(f.pos_h || 4) / 100) * H;
      const yTop = (Number(f.pos_y || 0) / 100) * H;
      if (f.kind === "signature" || f.kind === "initials") {
        let img;
        try { img = await embedImg(pdf, f.value); } catch (_) { continue; }
        let iw = w, ih = iw * (img.height / img.width);
        if (ih > boxH) { ih = boxH; iw = ih * (img.width / img.height); }
        pg.drawImage(img, { x, y: H - yTop - ih, width: iw, height: ih });
      } else {
        const size = Math.max(7, Math.min(12, boxH * 0.62));
        pg.drawText(latin(String(f.value)), { x, y: H - yTop - boxH + size * 0.3, size, font: helv, color: rgb(0.06, 0.06, 0.1) });
      }
    }
  }
  /* Word-Seite so in die PDF bringen, wie sie beim Unterschreiben aussah */
  async function wordPagesToPdf(pdf) {
    const ok = await loadLib(H2C_SRC, () => !!window.html2canvas);
    const el = document.querySelector("#sgDoc .amkzsg-word");
    if (!ok || !el) return false;
    const doc = byId("sgDoc");
    doc.classList.add("printing");
    let big;
    try {
      big = await window.html2canvas(el, { backgroundColor: "#ffffff", scale: 2, useCORS: true, logging: false, scrollX: 0, scrollY: -window.scrollY });
    } catch (err) { console.warn("[amk-sign] html2canvas", err); doc.classList.remove("printing"); return false; }
    doc.classList.remove("printing");
    const A4W = 595.28, A4H = 841.89;
    const sliceH = Math.round(big.width * (A4H / A4W));
    for (let y = 0; y < big.height; y += sliceH) {
      const h = Math.min(sliceH, big.height - y);
      const cut = document.createElement("canvas");
      cut.width = big.width; cut.height = sliceH;
      const cx = cut.getContext("2d");
      cx.fillStyle = "#ffffff"; cx.fillRect(0, 0, cut.width, cut.height);
      cx.drawImage(big, 0, y, big.width, h, 0, 0, big.width, h);
      const img = await pdf.embedPng(cut.toDataURL("image/png"));
      const pg = pdf.addPage([A4W, A4H]);
      pg.drawImage(img, { x: 0, y: 0, width: A4W, height: A4H });
    }
    return true;
  }

  async function buildSignedPdf() {
    const ok = await loadLib(PDFLIB_SRC, () => !!window.PDFLib);
    if (!ok) return null;
    const { PDFDocument, StandardFonts, rgb } = window.PDFLib;
    const c = SG.contract;
    let src = SG.bytes;
    if (!src) { try { src = await (await fetch(c.file_url)).arrayBuffer(); } catch (_) {} }

    let pdf, wordCaptured = false;
    if (isPdfFile(c) && src) {
      pdf = await PDFDocument.load(src, { ignoreEncryption: true });
    } else {
      pdf = await PDFDocument.create();
      if (isDocxFile(c)) wordCaptured = await wordPagesToPdf(pdf);
      if (!wordCaptured && isImgFile(c) && src) {
        try {
          const img = /png/i.test(c.file_type || "") || /\.png(\?|$)/i.test(c.file_url || "") ? await pdf.embedPng(src) : await pdf.embedJpg(src);
          const pg = pdf.addPage([img.width, img.height]);
          pg.drawImage(img, { x: 0, y: 0, width: img.width, height: img.height });
          wordCaptured = true;
        } catch (_) {}
      }
      if (!pdf.getPageCount()) pdf.addPage([595.28, 841.89]);
    }

    const helv = await pdf.embedFont(StandardFonts.Helvetica);
    const bold = await pdf.embedFont(StandardFonts.HelveticaBold);
    const pages = pdf.getPages();

    // Bei Word ist alles schon im Bild drin; bei PDF/Bild werden die Felder eingebrannt
    if (!wordCaptured || isPdfFile(c)) await drawFieldsOn(pdf, pages, helv, rgb);

    // Frei platzierte Unterschriften (Dokumente ohne erkannte Felder)
    for (const s of SG.signers) {
      if (s.status !== "signed" || !s.signature_url) continue;
      if ((SG.fields || []).some((f) => String(f.signer_id) === String(s.id) && f.kind === "signature" && f.value)) continue;
      if (wordCaptured && !isPdfFile(c)) continue;
      let png;
      try { png = await embedImg(pdf, s.signature_url); } catch (_) { continue; }
      const pg = pages[Math.min(Math.max(1, Number(s.page || 1)), pages.length) - 1];
      const { width: W, height: H } = pg.getSize();
      const w = (Number(s.pos_w || 26) / 100) * W;
      const h = w * (png.height / png.width);
      const x = (Number(s.pos_x || 8) / 100) * W;
      const y = H - (Number(s.pos_y || 78) / 100) * H - h;
      pg.drawImage(png, { x, y, width: w, height: h });
      pg.drawLine({ start: { x, y: y - 3 }, end: { x: x + w, y: y - 3 }, thickness: 0.6, color: rgb(0.45, 0.45, 0.5) });
      pg.drawText(latin(`${s.name || ""} - ${fmtDT(s.signed_at)}`), { x, y: y - 12, size: 6.5, font: helv, color: rgb(0.3, 0.3, 0.35) });
    }

    /* ---- Unterschriften-Zertifikat ---- */
    const M = 48;
    let cp = pdf.addPage([595.28, 841.89]);
    cp.drawRectangle({ x: 0, y: 771, width: 595.28, height: 71, color: rgb(0.06, 0.06, 0.07) });
    cp.drawText("UNTERSCHRIFTEN-ZERTIFIKAT", { x: M, y: 806, size: 17, font: bold, color: rgb(0.94, 0.83, 0.53) });
    cp.drawText(latin("AMK Zentrale - AMK Sign"), { x: M, y: 788, size: 9, font: helv, color: rgb(0.75, 0.75, 0.78) });

    let y = 735;
    const put = (label, value) => {
      cp.drawText(latin(label), { x: M, y, size: 9, font: bold, color: rgb(0.35, 0.35, 0.4) });
      cp.drawText(latin(value), { x: M + 128, y, size: 9, font: helv, color: rgb(0.1, 0.1, 0.13) });
      y -= 16;
    };
    put("Dokument", c.title || c.file_name || "-");
    put("Datei", c.file_name || "-");
    put("Mitarbeiter", SG.employee?.name || "-");
    put("Hochgeladen", fmtDT(c.created_at));
    put("Vorgangs-ID", String(c.id || "-"));
    put("Felder", `${(SG.fields || []).filter((f) => f.value).length} von ${(SG.fields || []).length} ausgefuellt`);
    const hash = c.doc_hash || "";
    put("SHA-256", hash ? hash.slice(0, 32) : "-");
    if (hash.length > 32) { cp.drawText(latin(hash.slice(32)), { x: M + 128, y: y + 6, size: 9, font: helv, color: rgb(0.1, 0.1, 0.13) }); y -= 10; }

    y -= 12;
    cp.drawLine({ start: { x: M, y }, end: { x: 595.28 - M, y }, thickness: 0.8, color: rgb(0.8, 0.72, 0.5) });
    y -= 22;
    cp.drawText("UNTERZEICHNER", { x: M, y, size: 10, font: bold, color: rgb(0.55, 0.44, 0.2) });
    y -= 20;

    for (const s of SG.signers) {
      if (y < 140) { cp = pdf.addPage([595.28, 841.89]); y = 780; }
      const eigene = (SG.fields || []).filter((f) => String(f.signer_id) === String(s.id) && f.value);
      cp.drawRectangle({ x: M - 8, y: y - 66, width: 595.28 - 2 * M + 16, height: 78, color: rgb(0.97, 0.97, 0.98) });
      cp.drawText(latin(`${s.name || "-"}  (${s.party === "company" ? "für die Firma" : "Mitarbeiter"})`), { x: M, y, size: 11, font: bold, color: rgb(0.08, 0.08, 0.1) });
      y -= 14;
      cp.drawText(latin(`E-Mail: ${s.email || "-"}`), { x: M, y, size: 8.5, font: helv, color: rgb(0.3, 0.3, 0.35) });
      y -= 12;
      cp.drawText(latin(`Status: ${s.status === "signed" ? "unterschrieben am " + fmtDT(s.signed_at) : s.status}`), { x: M, y, size: 8.5, font: helv, color: rgb(0.3, 0.3, 0.35) });
      y -= 12;
      cp.drawText(latin(`IP: ${s.ip || "nicht erfasst"}   Art: ${s.signature_kind || "-"}   Felder: ${eigene.length}   Beleg-ID: ${String(s.id || "").slice(0, 8)}`), { x: M, y, size: 8.5, font: helv, color: rgb(0.3, 0.3, 0.35) });
      y -= 12;
      cp.drawText(latin(String(s.user_agent || "").slice(0, 96)), { x: M, y, size: 7, font: helv, color: rgb(0.5, 0.5, 0.55) });
      y -= 32;
    }

    y = Math.max(46, Math.min(y, 96));
    cp.drawLine({ start: { x: M, y: y + 22 }, end: { x: 595.28 - M, y: y + 22 }, thickness: 0.5, color: rgb(0.8, 0.8, 0.84) });
    cp.drawText(latin("Dieses Zertifikat wurde automatisch von der AMK Zentrale erstellt. Der SHA-256-Wert weist nach,"), { x: M, y: y + 8, size: 7.5, font: helv, color: rgb(0.45, 0.45, 0.5) });
    cp.drawText(latin("dass das unterzeichnete Dokument seit dem Hochladen nicht verändert wurde."), { x: M, y: y - 2, size: 7.5, font: helv, color: rgb(0.45, 0.45, 0.5) });

    const out = await pdf.save();
    const safe = String(c.file_name || "vertrag").replace(/\.[^.]+$/, "").replace(/[^\w.\-]/g, "_") || "vertrag";
    const path = `contracts/${c.id}/signiert_${Date.now()}_${safe}.pdf`;
    let bucket = BUCKET;
    const mk = () => new Blob([out], { type: "application/pdf" });
    let up = await sb().storage.from(bucket).upload(path, mk(), { upsert: true, contentType: "application/pdf" });
    if (up.error) { bucket = BUCKET_FALLBACK; up = await sb().storage.from(bucket).upload(path, mk(), { upsert: true, contentType: "application/pdf" }); }
    if (up.error) throw up.error;
    const { data: pub } = sb().storage.from(bucket).getPublicUrl(path);
    return { url: pub?.publicUrl || "", path: bucket + "/" + path };
  }

  /* =====================================================================
     „Mein Profil" — Klick auf das eigene Bild unten in der Seitenleiste
     ---------------------------------------------------------------------
     Öffnet dasselbe Mitarbeiter-Profil wie im Team-Bereich, aber als
     eigene Ansicht: OHNE „Zugang & Rechte", ohne Entfernen, ohne
     Änderungen an Rolle, Gehalt oder Urlaubsanspruch. Der Reiter
     „Dokumente" steht sofort offen — dort wird der Vertrag unterschrieben.
     ===================================================================== */
  let SELF_AT = 0;

  async function openMyProfile() {
    const m = me();
    if (!m || !m.id) { toast("Profil", "Du bist nicht angemeldet.", "error"); return; }
    // Vollen Datensatz sicherstellen — loadTeam liefert je nach RPC nicht alle Spalten
    try {
      const { data } = await sb().from("team_members").select(await AMKZ.spalten("team_members")).eq("id", m.id).maybeSingle();
      if (data) await AMKZ.mitGeheim([data], "amk_team_privat");
      const list = AMKZ.state.team || (AMKZ.state.team = []);
      const i = list.findIndex((x) => String(x.id) === String(m.id));
      if (data) { if (i >= 0) list[i] = Object.assign({}, list[i], data); else list.push(data); }
      else if (i < 0) list.push(m);
    } catch (_) {
      if (!(AMKZ.state.team || []).some((x) => String(x.id) === String(m.id))) (AMKZ.state.team = AMKZ.state.team || []).push(m);
    }
    SELF_AT = Date.now();
    const b = document.createElement("button");
    b.type = "button";
    b.setAttribute("data-tp", String(m.id));
    b.style.cssText = "position:fixed;left:-9999px;top:-9999px";
    document.body.appendChild(b);
    b.click();
    b.remove();
  }
  AMKZ.openMyProfile = openMyProfile;

  /* Aus dem vollen Profil wird die eigene, abgespeckte Ansicht */
  function makeSelfView(form) {
    form.dataset.selfOnly = "1";
    const modal = form.closest(".amkz-modal");
    const h3 = modal && modal.querySelector(".amkz-modal-header h3");
    const p = modal && modal.querySelector(".amkz-modal-header p");
    if (h3) h3.textContent = "Mein Profil";
    if (p) p.textContent = "Deine Daten, Aufgaben und Verträge — hier unterschreibst du deinen Vertrag";

    // Zugang & Rechte verschwindet. Der Bereich bleibt im Formular stehen
    // (versteckt), damit das ursprüngliche Speichern nicht ins Leere greift.
    form.querySelector('[data-hrtab="zugang"]')?.remove();
    const zug = form.querySelector('[data-panel="zugang"]');
    if (zug) { zug.classList.add("is-hidden"); zug.style.display = "none"; zug.setAttribute("aria-hidden", "true"); }

    // Was die Firma festlegt, kann man hier nur lesen
    ["tpName", "tpPosition", "tpDept", "tpBirthday", "tpStart", "tpGehalt", "tpGehaltNote", "tpVac", "tpPay"].forEach((id) => {
      const el = byId(id);
      if (!el) return;
      el.readOnly = true;
      el.classList.add("amkzsg-ro");
    });
    const rolle = byId("tpRole");
    if (rolle) { rolle.disabled = true; rolle.classList.add("amkzsg-ro"); }

    // Eigener Speichern-Knopf: nur Telefon, Adresse und Profilbild
    const bar = form.querySelector("[data-tp-del]")?.closest(".amkz-tp-actions");
    form.querySelector("[data-tp-del]")?.remove();
    const sub = bar && bar.querySelector('button[type="submit"]');
    if (sub) {
      const own = document.createElement("button");
      own.type = "button";
      own.className = sub.className;
      own.textContent = "Speichern";
      sub.replaceWith(own);
      own.addEventListener("click", async () => {
        const m = me();
        if (!m) return;
        own.disabled = true;
        const payload = {
          phone: (byId("tpPhone")?.value || "").trim(),
          address: (byId("tpAddress")?.value || "").trim(),
          updated_at: new Date().toISOString(),
        };
        const bg = byId("tpAvaPrev")?.style.backgroundImage || "";
        const mm = bg.match(/url\(["']?(.*?)["']?\)/);
        if (mm && mm[1]) payload.avatar_url = mm[1];
        try {
          const { error } = await sb().from("team_members").update(payload).eq("id", m.id);
          if (error) throw error;
          Object.assign(AMKZ.state.member, payload);
          AMKZ.modal.close();
          toast("Gespeichert", "Deine Angaben sind aktualisiert.");
        } catch (err) { toast("Fehler", err.message || "Speichern fehlgeschlagen", "error"); own.disabled = false; }
      });
    }

    // In der eigenen Ansicht wird nichts zum Unterschreiben hochgeladen
    const kind = byId("sgDocKind");
    if (kind) {
      kind.querySelector('option[value="contract"]')?.remove();
      kind.value = "document";
    }

    // Direkt dorthin, wofür man gekommen ist
    form.querySelector('[data-hrtab="dokumente"]')?.click();
  }

  // Enter im eigenen Profil darf nicht das große Speichern des Team-Bereichs auslösen
  document.addEventListener("submit", (e) => {
    const f = e.target;
    if (f && f.id === "amkTpForm" && f.dataset.selfOnly === "1") { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  // Das Bild in der Seitenleiste ist der Einstieg
  document.addEventListener("click", (e) => {
    if (!e.target.closest("#amkzUserAvatar, .amkz-user-card")) return;
    if (e.target.closest("#amkzLogoutButton")) return;
    e.preventDefault();
    openMyProfile();
  });
  (function markCard() {
    const card = document.querySelector(".amkz-user-card");
    if (card && !card.dataset.selfHint) {
      card.dataset.selfHint = "1";
      card.setAttribute("title", "Mein Profil öffnen");
      card.setAttribute("role", "button");
      card.setAttribute("tabindex", "0");
    }
    if (!card) setTimeout(markCard, 900);
  })();

  /* =====================================================================
     Sanfter Hinweis: offene Unterschriften beim Start
     ===================================================================== */
  /* Mitarbeiter ohne Team-Zugriff kämen sonst nie an ihren Vertrag: dieser
     Hinweis unten links öffnet das Unterschreiben direkt, egal wo man steht. */
  function nudgeEl() {
    let el = byId("amkzSignNudge");
    if (!el) {
      el = document.createElement("div");
      el.id = "amkzSignNudge";
      el.className = "amkzsg-nudge";
      document.body.appendChild(el);
      el.addEventListener("click", (e) => {
        if (e.target.closest("[data-nudge-x]")) { el.classList.remove("on"); AMKZ.__signNudgeHidden = true; return; }
        const id = el.dataset.contract;
        if (id) openSign(id);
      });
    }
    return el;
  }
  async function refreshNudge() {
    const myId = me()?.id;
    const el = nudgeEl();
    if (!myId || AMKZ.__signNudgeHidden) { el.classList.remove("on"); return; }
    try {
      const { data, error } = await sb().from("contract_signers").select("contract_id").eq("user_id", myId).eq("status", "pending");
      if (error || !data || !data.length) { el.classList.remove("on"); return; }
      const { data: cs } = await sb().from("employee_contracts").select("id,title,file_name,status").in("id", data.map((d) => d.contract_id));
      const open = (cs || []).filter((c) => c.status !== "declined" && c.status !== "void");
      if (!open.length) { el.classList.remove("on"); return; }
      el.dataset.contract = open[0].id;
      el.innerHTML = `<span class="amkzsg-nudge-ic">✍️</span>
        <div class="amkzsg-nudge-in">
          <strong>${open.length === 1 ? "Ein Vertrag wartet auf dich" : open.length + " Verträge warten auf dich"}</strong>
          <small>${esc(open[0].title || open[0].file_name || "Vertrag")}</small>
        </div>
        <button type="button" class="amkzsg-nudge-go">Unterschreiben</button>
        <button type="button" class="amkzsg-nudge-x" data-nudge-x aria-label="ausblenden">✕</button>`;
      el.classList.add("on");
    } catch (_) { el.classList.remove("on"); }
  }
  AMKZ.signRefreshNudge = refreshNudge;
  const prevLoadView = AMKZ.loadView;
  AMKZ.loadView = async function signChain(view, options) {
    const r = await prevLoadView?.call(this, view, options);
    if (me()?.id) setTimeout(refreshNudge, 1200);
    return r;
  };
  setTimeout(() => { if (me()?.id) refreshNudge(); }, 2600);

  ensureStyle();
  AMKZ.sign = { open: openSign, parties, refresh: renderDocsPanel, detect: detectFieldsInDoc };
})();

/* #####################################################################
   #####################################################################
   ##                                                                 ##
   ##   AB HIER: STREAM-ZENTRALE + GEWINNABHOLUNG                     ##
   ##                                                                 ##
   ##   Diese beiden Bausteine lagen kurzzeitig in eigenen Dateien     ##
   ##   (amk-stream-hub.js / amk-claims.js). Das war ein Fehler: wer   ##
   ##   nur amk-zentrale.js aktualisiert, bekam die halbe Zentrale —   ##
   ##   Leiste sichtbar, aber nichts schaltbar.                        ##
   ##                                                                 ##
   ##   Es bleibt bei DREI Dateien:                                    ##
   ##       amk-zentrale.js  ·  amk-zentrale.css  ·  amk-zentrale.liquid
   ##                                                                 ##
   #####################################################################
   ##################################################################### */

/* =====================================================================
   AMK ZENTRALE — STREAM-ZENTRALE (Hub)
   ---------------------------------------------------------------------
   Genau ein Umschalter besitzt alle Panels der Stream-Zentrale.

   Seit 22.10.2026 nur noch zwei Reiter: Sendeplan und Verwaltung.
   Bonushunt, Nouri vs Chat, Store und Gewinnabholung sind auf Marcels
   Wunsch raus (Module gelöscht, Sicherung in
   zentrale/_backup/2026-10-22-vor-ftd-bilanz/). Gecachtes altes Markup
   mit diesen Reitern wird hier beim Öffnen weggeräumt.
   ===================================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__streamHub) return;
  AMKZ.__streamHub = true;

  const byId = (id) => document.getElementById(id);
  const perm = (k) => AMKZ.state?.permissions?.[k] === true;
  const isAdmin = () => perm("isAdmin");

  const DARF = {
    plan:   () => false,   // Sendeplan entfernt (26.10.2026) — der Plan steht jetzt im Kalender
    manage: () => perm("manageStreaming") || isAdmin(),
  };
  const PANEL = { plan: "amkzStreamPlanPanel", manage: "amkzStreamManagePanel" };
  const TITEL = {
    plan:   ["Stream-Zentrale", "Sendeplan, Schichten und Openings"],
    manage: ["Stream-Zentrale", "Balance-Check, Casino-Zugänge und Kontostände"],
  };
  const WEG = ["bonushunt", "vs", "store"];

  const SPEICHER = "amkz_hub_tab";
  let aktiv = null;

  function panelsAus() {
    Object.values(PANEL).forEach((id) => byId(id)?.classList.add("is-hidden"));
  }

  function setzeTitel(tab) {
    const t = TITEL[tab] || TITEL.plan;
    const a = byId("amkzViewTitle"), b = byId("amkzViewSubtitle");
    if (a) a.textContent = t[0];
    if (b) b.textContent = t[1];
  }

  function ersterErlaubter() {
    return ["plan", "manage"].find((t) => DARF[t]());
  }

  function zeige(tab, opt = {}) {
    if (!DARF[tab] || !DARF[tab]()) tab = ersterErlaubter();
    if (!tab) return;
    aktiv = tab;
    try { localStorage.setItem(SPEICHER, tab); } catch (e) {}

    document.querySelectorAll("#amkzStreamHub .amkz-hub-tab").forEach((b) =>
      b.classList.toggle("is-on", b.dataset.hub === tab));

    panelsAus();
    byId(PANEL[tab])?.classList.remove("is-hidden");
    setzeTitel(tab);

    if (opt.laden === false) return;
    AMKZ.streaming?.refresh?.();
    // Das Streaming-Modul setzt beim Neuladen eigene is-hidden-Zustände und
    // rendert verzögert nach — deshalb mehrfach durchsetzen, was sichtbar sein soll.
    [60, 250, 600, 1200].forEach((ms) => setTimeout(() => {
      if (aktiv !== tab) return;
      panelsAus();
      byId(PANEL[tab])?.classList.remove("is-hidden");
    }, ms));
  }

  /* Altes, zwischengespeichertes Markup aufräumen. */
  function sorgeFuerMarkup() {
    const view = byId("amkzStreamingView");
    if (!view) return;
    WEG.forEach((k) => view.querySelector('.amkz-hub-tab[data-hub="' + k + '"]')?.remove());
    ["amkzStreamBonushuntPanel", "amkzStreamVsPanel", "amkzStreamStorePanel"].forEach((id) => byId(id)?.remove());
    view.querySelectorAll(".amkz-stream-tabs").forEach((el) => el.remove());
    const hub = byId("amkzStreamHub"); if (hub) hub.hidden = true;   // nur noch eine Ansicht: keine Reiter
    byId("amkzStreamPlanPanel")?.classList.add("is-hidden");
    if (!DARF.manage() && !byId("amkszKeinRecht")) view.insertAdjacentHTML("beforeend", '<div id="amkszKeinRecht" class="amkz-empty" style="margin-top:20px">Die Stream-Zentrale (Konten &amp; Balance) ist für dich nicht freigegeben. Den Sendeplan findest du jetzt im Kalender.</div>');
    document.querySelector('.amkz-nav-item[data-view="bonushunt"]')?.remove();
    const streamBtn = document.querySelector('.amkz-nav-item[data-view="streaming"] label');
    if (streamBtn && streamBtn.textContent.trim() === "Streaming") streamBtn.textContent = "Stream-Zentrale";
  }

  function tabsPruefen() {
    document.querySelectorAll("#amkzStreamHub .amkz-hub-tab").forEach((b) => {
      const t = b.dataset.hub;
      b.hidden = !(DARF[t] && DARF[t]());
    });
  }

  if (!document.body.dataset.amkHubBound) {
    document.body.dataset.amkHubBound = "1";
    document.addEventListener("click", (e) => {
      const b = e.target.closest("#amkzStreamHub .amkz-hub-tab");
      if (b) zeige(b.dataset.hub);
    });
  }

  if (AMKZ.views && AMKZ.views.streaming) {
    AMKZ.views.streaming.title = "Stream-Zentrale";
    AMKZ.views.streaming.subtitle = "Balance-Check, Casino-Zugänge und Kontostände";
  }

  /* Wer nur die Verwaltung freigegeben hat, kommt über die normale
     Rechteprüfung (fragt `streaming`) nicht rein — dann schaltet der Hub selbst. */
  function hubOeffnen(tab) {
    sorgeFuerMarkup();
    AMKZ.state.currentView = "streaming";
    document.querySelectorAll(".amkz-nav-item").forEach((i) =>
      i.classList.toggle("active", i.dataset.view === "streaming"));
    document.querySelectorAll(".amkz-view").forEach((v) => v.classList.add("is-hidden"));
    byId("amkzStreamingView")?.classList.remove("is-hidden");
    tabsPruefen();
    zeige(tab || ersterErlaubter());
  }

  const prevSwitch = AMKZ.switchView;
  AMKZ.switchView = function (view) {
    // alte Links / Push-Nachrichten auf „bonushunt" landen in der Stream-Zentrale
    if (view === "bonushunt") view = "streaming";
    if (view === "streaming" && !perm("streaming") && !isAdmin()) {
      if (!ersterErlaubter()) { AMKZ.toast?.("Keine Freigabe", "Dieser Bereich ist nicht freigegeben.", "error"); return; }
      return hubOeffnen();
    }
    return prevSwitch ? prevSwitch.call(this, view) : undefined;
  };

  const prevLoad = AMKZ.loadView;
  AMKZ.loadView = async function (view, options) {
    const r = await (prevLoad ? prevLoad.call(this, view, options) : undefined);
    if (view === "streaming") {
      sorgeFuerMarkup();
      tabsPruefen();
      let start = null;
      try { start = localStorage.getItem(SPEICHER); } catch (e) {}
      if (!start || !DARF[start] || !DARF[start]()) start = ersterErlaubter();
      setTimeout(() => zeige(start), 120);
    }
    return r;
  };

  AMKZ.streamHub = { show: zeige, tabs: tabsPruefen };
})();



/* =====================================================================
   AMK ZENTRALE — AFFILIATE-DASHBOARDS  (saubere Auflistung)

   Was dieser Bereich ist: die Liste aller Partnerprogramm-Dashboards.
   Ein Eintrag = ein Dashboard (z. B. Royal Partners) und dazu gehoeren
   beliebig viele Casinos — bei Royal Partners eben alle sechs, sieben.

   Warum getrennt vom Punkt "Affiliates": dort steckt der interne Browser,
   der ein Dashboard einbettet. Hier steht die Uebersicht: was laeuft, was
   nicht, welcher Zugang gehoert dazu. Beide arbeiten auf derselben Tabelle
   `affiliate_dashboards` — einmal eintragen, an beiden Stellen da.

   Sortierung: online zuerst, nicht online darunter. Das passiert beim
   Umschalten sofort, ohne Neuladen.

   SQL: supabase-affiliate-dashboards.sql
   ===================================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__dashboards) return;
  AMKZ.__dashboards = true;

  const sb = () => AMKZ.supabase;
  const byId = (id) => document.getElementById(id);

  function esc(v) {
    return String(v == null ? "" : v).replace(/[&<>"']/g, (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[c]));
  }
  function toast(t, m, ty) { (AMKZ.toast || console.log)(t, m || "", ty || "success"); }

  /* ---------------------------------------------------------- Zustand */
  const DB = {
    list: [],
    casinos: [],      // aus der Tabelle `casinos`
    partners: [],     // aus `partner_groups`
    filter: "all",    // all | on | off
    suche: "",
    zeigePw: false,   // globaler Schalter "Passwoerter zeigen"
    offen: new Set(), // aufgeklappte Karten
    geladen: false,
    fehler: "",
    brauchtSql: false,   // Tabelle noch nicht erweitert
    buehne: null,        // ID des Dashboards, das gerade eingebettet laeuft
  };

  /* ---------------------------------------------------------- Helfer */

  // Name eines Casinos aus der Zentrale-Tabelle
  function casinoName(id) {
    const c = DB.casinos.find((x) => x.id === id);
    return c ? c.name : null;
  }

  // Alle Casinos eines Dashboards als reine Namensliste:
  // verknuepfte (aus der Tabelle) + zusaetzlich frei eingetragene.
  function casinoListe(d) {
    const aus = (d.casino_ids || []).map(casinoName).filter(Boolean);
    const frei = (d.casino_names || []).map((n) => String(n || "").trim()).filter(Boolean);
    return aus.concat(frei);
  }

  function partnerName(id) {
    const p = DB.partners.find((x) => x.id === id);
    return p ? p.name : null;
  }

  function host(url) {
    try { return new URL(/^https?:\/\//i.test(url) ? url : "https://" + url).host.replace(/^www\./, ""); }
    catch (_) { return String(url || "").replace(/^https?:\/\//i, "").split("/")[0]; }
  }

  function volleUrl(u) {
    const s = String(u || "").trim();
    if (!s) return "";
    return /^https?:\/\//i.test(s) ? s : "https://" + s;
  }

  function datumDe(d) {
    if (!d) return "";
    try { return new Date(d + "T00:00:00").toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" }); }
    catch (_) { return String(d); }
  }

  function heute() {
    const d = new Date();
    return [d.getFullYear(), String(d.getMonth() + 1).padStart(2, "0"), String(d.getDate()).padStart(2, "0")].join("-");
  }

  async function kopiere(text, was) {
    const s = String(text || "");
    if (!s) return;
    try {
      await navigator.clipboard.writeText(s);
    } catch (_) {
      // Aeltere Browser / kein HTTPS: ueber ein verstecktes Feld
      const ta = document.createElement("textarea");
      ta.value = s; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select();
      try { document.execCommand("copy"); } catch (e) {}
      ta.remove();
    }
    toast("Kopiert", was || "In die Zwischenablage gelegt.");
  }

  /* ---------------------------------------------------------- Laden */

  async function ladeAlles(force) {
    DB.fehler = "";
    if (!sb()) { DB.fehler = "Keine Verbindung zu Supabase."; return; }

    // Casinos + Partnergruppen kommen aus der Zentrale — dieselben Daten
    // wie im Bereich "Casinos". Faellt das aus, laeuft der Rest trotzdem.
    try {
      await AMKZ.data?.loadCasinos?.(!!force);
      await AMKZ.data?.loadPartners?.(!!force);
      DB.casinos = (AMKZ.state?.casinos || []).slice();
      DB.partners = (AMKZ.state?.partners || []).slice();
    } catch (_) { /* ohne Casino-Liste geht es mit freiem Text weiter */ }

    // Kurzer Test, ob die neuen Spalten schon da sind. Fehlt das SQL, laeuft
    // der Bereich trotzdem — er sagt dann nur oben Bescheid, was noch fehlt.
    try {
      const probe = await sb().from("affiliate_dashboards")
        .select("id,is_active,casino_ids,login_user").limit(1);
      DB.brauchtSql = !!probe.error;
    } catch (_) { DB.brauchtSql = true; }

    try {
      const { data, error } = await sb()
        .from("affiliate_dashboards")
        .select(await AMKZ.spalten("affiliate_dashboards"))
        .order("sort_order", { ascending: true })
        .order("name", { ascending: true });
      if (error) throw error;
      DB.list = data || [];
      await AMKZ.mitGeheim(DB.list, "amk_dashboards_geheim");   // Passwort/2FA nur mit Recht
      DB.geladen = true;
    } catch (e) {
      DB.fehler = /relation .* does not exist|schema cache/i.test(e.message || "")
        ? "Die Tabelle affiliate_dashboards fehlt noch — bitte supabase-affiliate-dashboards.sql im Supabase SQL-Editor ausführen."
        : (e.message || "Konnte die Dashboards nicht laden.");
    }
  }

  /* ---------------------------------------------------------- Sortierung
     Online zuerst, darunter die nicht aktiven. Innerhalb der Gruppe gilt
     die eigene Reihenfolge (sort_order), sonst der Name.               */
  function sortiert(rows) {
    return rows.slice().sort((a, b) => {
      const sa = (a.sort_order == null ? 9999 : a.sort_order);
      const sb2 = (b.sort_order == null ? 9999 : b.sort_order);
      if (sa !== sb2) return sa - sb2;
      return String(a.name || "").localeCompare(String(b.name || ""), "de");
    });
  }

  function passtZurSuche(d) {
    const q = DB.suche.trim().toLowerCase();
    if (!q) return true;
    const heu = [
      d.name, d.url, d.login_url, d.login_user, d.login_email,
      d.manager_name, d.manager_contact, d.note, d.payout_note,
      partnerName(d.partner_group_id),
    ].concat(casinoListe(d)).filter(Boolean).join(" ").toLowerCase();
    return heu.indexOf(q) >= 0;
  }

  /* ---------------------------------------------------------- Zeichnen */

  // Eine Zugangszeile. Der Wert selbst steht NICHT im HTML-Attribut —
  // kopiert wird ueber id + Feldname, damit nichts im Markup mitlaeuft.
  function pwFeld(id, label, feld, wert, art) {
    if (!wert) return "";
    const versteckt = art === "pw" && !DB.zeigePw;
    return `
      <div class="amkdb-cred">
        <span class="amkdb-cred-lbl">${esc(label)}</span>
        <span class="amkdb-cred-val${versteckt ? " is-masked" : ""}">${versteckt ? "••••••••••" : esc(wert)}</span>
        <button type="button" class="amkdb-mini" data-db-copy-id="${esc(id)}" data-db-copy-field="${esc(feld)}" data-db-copy-what="${esc(label)}" title="${esc(label)} kopieren">Kopieren</button>
      </div>`;
  }

  function karte(d) {
    const an = d.is_active !== false;
    const casinos = casinoListe(d);
    const pg = partnerName(d.partner_group_id);
    const offen = DB.offen.has(d.id);
    const link = volleUrl(d.login_url || d.url);

    const chips = casinos.length
      ? casinos.map((n) => `<span class="amkdb-chip">${esc(n)}</span>`).join("")
      : `<span class="amkdb-chip is-empty">kein Casino zugeordnet</span>`;

    const zugang = [
      pwFeld(d.id, "Benutzer", "login_user", d.login_user, "text"),
      pwFeld(d.id, "E-Mail", "login_email", d.login_email, "text"),
      pwFeld(d.id, "Passwort", "login_password", d.login_password, "pw"),
      pwFeld(d.id, "2FA / Code", "twofa", d.twofa, "pw"),
    ].join("");

    const infos = [
      d.manager_name ? `<div class="amkdb-info"><span>Manager</span><strong>${esc(d.manager_name)}${d.manager_contact ? " · " + esc(d.manager_contact) : ""}</strong></div>` : "",
      d.payout_note ? `<div class="amkdb-info"><span>Auszahlung</span><strong>${esc(d.payout_note)}</strong></div>` : "",
      d.note ? `<div class="amkdb-info"><span>Notiz</span><strong>${esc(d.note)}</strong></div>` : "",
    ].join("");

    return `
      <article class="amkdb-card${an ? " is-on" : " is-off"}${offen ? " is-open" : ""}" data-db-card="${esc(d.id)}">
        <div class="amkdb-head">
          <button type="button" class="amkdb-led" data-db-toggle="${esc(d.id)}" title="${an ? "Auf: nicht online stellen" : "Auf: online stellen"}" aria-label="Status umschalten"></button>

          <div class="amkdb-title">
            <strong>${esc(d.name || "Dashboard")}</strong>
            <div class="amkdb-sub">
              <span class="amkdb-state">${an ? "Online" : "Nicht online"}</span>
              ${pg ? `<span class="amkdb-dot"></span><span>${esc(pg)}</span>` : ""}
              ${link ? `<span class="amkdb-dot"></span><span class="amkdb-host">${esc(host(link))}</span>` : ""}
              <span class="amkdb-dot"></span><span>${casinos.length} Casino${casinos.length === 1 ? "" : "s"}</span>
              ${d.last_check ? `<span class="amkdb-dot"></span><span>geprüft ${esc(datumDe(d.last_check))}</span>` : ""}
            </div>
          </div>

          <div class="amkdb-head-actions">
            ${link ? `<button type="button" class="amkdb-btn is-primary" data-db-open="${esc(d.id)}">Öffnen</button>` : ""}
            ${link ? `<a class="amkdb-btn" href="${esc(link)}" target="_blank" rel="noopener" title="In neuem Tab öffnen">↗</a>` : ""}
            <button type="button" class="amkdb-btn" data-db-expand="${esc(d.id)}" title="Zugang anzeigen">${offen ? "Zu" : "Zugang"}</button>
          </div>
        </div>

        <div class="amkdb-chips">${chips}</div>

        <div class="amkdb-body"><div class="amkdb-body-in">
          <div class="amkdb-creds">
            ${zugang || `<div class="amkdb-cred is-none">Kein Zugang hinterlegt — auf „Bearbeiten“ und eintragen.</div>`}
          </div>
          ${infos ? `<div class="amkdb-infos">${infos}</div>` : ""}
          <div class="amkdb-row-actions">
            ${zugang ? `<button type="button" class="amkdb-btn" data-db-copyall="${esc(d.id)}">Zugang komplett kopieren</button>` : ""}
            <button type="button" class="amkdb-btn" data-db-check="${esc(d.id)}" title="Vermerken: heute geprüft">✓ Geprüft abhaken</button>
            <button type="button" class="amkdb-btn" data-db-up="${esc(d.id)}" title="Nach oben">▲</button>
            <button type="button" class="amkdb-btn" data-db-down="${esc(d.id)}" title="Nach unten">▼</button>
            <span class="amkdb-spacer"></span>
            <button type="button" class="amkdb-btn" data-db-edit="${esc(d.id)}">Bearbeiten</button>
            <button type="button" class="amkdb-btn is-danger" data-db-del="${esc(d.id)}">Löschen</button>
          </div>
        </div></div>
      </article>`;
  }

  function gruppe(titel, rows, klasse, leer) {
    return `
      <section class="amkdb-group ${klasse}">
        <header class="amkdb-group-head">
          <h3>${esc(titel)}</h3>
          <span class="amkdb-count">${rows.length}</span>
        </header>
        <div class="amkdb-list">
          ${rows.length ? rows.map(karte).join("") : `<div class="amkdb-empty">${esc(leer)}</div>`}
        </div>
      </section>`;
  }

  /* ---------------------------------------------------------- Buehne
     Frueher lag der eingebettete Browser in einem eigenen Bereich
     ("Affiliates"). Er steckt jetzt hier drin: "Oeffnen" legt das
     Dashboard als iframe ueber die Liste — mitsamt Zugangsdaten
     griffbereit, damit das Einloggen nicht zum Suchspiel wird.     */
  function buehneHtml(d) {
    const link = volleUrl(d.login_url || d.url);
    const casinos = casinoListe(d);

    const knopf = (feld, label) => d[feld]
      ? `<button type="button" class="amkdb-btn" data-db-copy-id="${esc(d.id)}" data-db-copy-field="${esc(feld)}" data-db-copy-what="${esc(label)}">${esc(label)}</button>`
      : "";

    return `
      <div class="amkdb-stage">
        <div class="amkdb-stage-bar">
          <button type="button" class="amkdb-btn" data-db-stage-close>‹ Zurück zur Liste</button>

          <div class="amkdb-stage-title">
            <strong>${esc(d.name || "Dashboard")}</strong>
            <span>${esc(host(link))}${casinos.length ? " · " + esc(casinos.join(", ")) : ""}</span>
          </div>

          <div class="amkdb-stage-creds">
            ${knopf("login_user", "Benutzer")}
            ${knopf("login_email", "E-Mail")}
            ${knopf("login_password", "Passwort")}
            ${knopf("twofa", "2FA")}
          </div>

          <div class="amkdb-stage-actions">
            <button type="button" class="amkdb-btn" data-db-stage-reload title="Neu laden">⟳</button>
            <a class="amkdb-btn" href="${esc(link)}" target="_blank" rel="noopener" title="In neuem Tab öffnen">↗</a>
          </div>
        </div>

        <iframe id="amkdbFrame" class="amkdb-frame" src="${esc(link)}"
          referrerpolicy="no-referrer-when-downgrade"
          sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-modals allow-downloads allow-storage-access-by-user-activation"></iframe>

        <div class="amkdb-stage-hint">Blockt die Seite das Einbetten, hilft „↗" — dann öffnet sie in einem eigenen Tab.</div>
      </div>`;
  }

  function render() {
    const root = byId("amkdbRoot");
    if (!root) return;

    // Bühne hat Vorrang: solange ein Dashboard läuft, tritt die Liste zurück.
    if (DB.buehne) {
      const d = finde(DB.buehne);
      if (d) { root.innerHTML = buehneHtml(d); return; }
      DB.buehne = null;
    }

    if (DB.fehler) {
      root.innerHTML = `
        <div class="amkdb-panel amkdb-alert">
          <strong>Der Bereich kann nicht laden</strong>
          <p>${esc(DB.fehler)}</p>
          <button type="button" class="amkdb-btn is-primary" data-db-reload>Nochmal versuchen</button>
        </div>`;
      return;
    }

    if (!DB.geladen) {
      root.innerHTML = `<div class="amkdb-panel"><div class="amkdb-empty">Dashboards werden geladen…</div></div>`;
      return;
    }

    const gefiltert = DB.list.filter(passtZurSuche);
    const on = sortiert(gefiltert.filter((d) => d.is_active !== false));
    const off = sortiert(gefiltert.filter((d) => d.is_active === false));

    const alleOn = DB.list.filter((d) => d.is_active !== false).length;
    const alleOff = DB.list.length - alleOn;
    const casinoSumme = DB.list.reduce((n, d) => n + casinoListe(d).length, 0);

    const zeigOn = DB.filter !== "off";
    const zeigOff = DB.filter !== "on";

    const sqlHinweis = DB.brauchtSql
      ? `<div class="amkdb-panel amkdb-alert amkdb-sqlnote">
           <strong>Ein Schritt fehlt noch</strong>
           <p>Die Tabelle hat die neuen Felder noch nicht — Status, Casinos und Zugänge lassen sich deshalb nicht speichern. Führe einmal <code>supabase-affiliate-dashboards.sql</code> im Supabase SQL-Editor aus, dann läuft alles.</p>
         </div>`
      : "";

    root.innerHTML = `
      ${sqlHinweis}
      <div class="amkdb-bar">
        <div class="amkdb-stats">
          <div class="amkdb-stat is-on"><strong>${alleOn}</strong><span>online</span></div>
          <div class="amkdb-stat is-off"><strong>${alleOff}</strong><span>nicht online</span></div>
          <div class="amkdb-stat"><strong>${casinoSumme}</strong><span>Casinos</span></div>
        </div>

        <div class="amkdb-tools">
          <input id="amkdbSuche" class="amkdb-search" type="search" placeholder="Suchen: Dashboard, Casino, Manager…" value="${esc(DB.suche)}" autocomplete="off">
          <div class="amkdb-filters">
            <button type="button" class="amkdb-fil${DB.filter === "all" ? " active" : ""}" data-db-filter="all">Alle</button>
            <button type="button" class="amkdb-fil${DB.filter === "on" ? " active" : ""}" data-db-filter="on">Online</button>
            <button type="button" class="amkdb-fil${DB.filter === "off" ? " active" : ""}" data-db-filter="off">Nicht online</button>
          </div>
          <button type="button" class="amkdb-btn${DB.zeigePw ? " is-primary" : ""}" data-db-pw>${DB.zeigePw ? "Passwörter verbergen" : "Passwörter zeigen"}</button>
          <button type="button" class="amkdb-btn is-primary" data-db-new>+ Dashboard</button>
        </div>
      </div>

      ${DB.list.length === 0
        ? `<div class="amkdb-panel amkdb-first">
             <strong>Noch kein Dashboard eingetragen</strong>
             <p>Trage hier jedes Partnerprogramm einmal ein — mit Link, Zugang und allen Casinos, die dazugehören. Danach siehst du auf einen Blick, wo du reinschauen musst und wo nicht.</p>
             <button type="button" class="amkdb-btn is-primary" data-db-new>Erstes Dashboard anlegen</button>
           </div>`
        : `${zeigOn ? gruppe("Online", on, "is-on", DB.suche ? "Nichts gefunden." : "Kein Dashboard online.") : ""}
           ${zeigOff ? gruppe("Nicht online", off, "is-off", DB.suche ? "Nichts gefunden." : "Alles läuft — hier ist nichts abgeschaltet.") : ""}`}
    `;

    // Der Suchfokus soll beim Tippen nicht wegspringen
    const feld = byId("amkdbSuche");
    if (feld && DB.__fokusSuche) {
      feld.focus();
      try { feld.setSelectionRange(feld.value.length, feld.value.length); } catch (_) {}
    }
  }

  /* ---------------------------------------------------------- Formular */

  function casinoAuswahl(d) {
    const gewaehlt = new Set(d && d.casino_ids ? d.casino_ids : []);
    if (!DB.casinos.length) {
      return `<div class="amkdb-hint">Keine Casinos in der Zentrale gefunden — trage sie unten als freien Text ein.</div>`;
    }
    return `
      <div class="amkdb-pick">
        <input class="amkdb-pick-search" type="search" placeholder="Casino suchen…" data-db-pick-search autocomplete="off">
        <div class="amkdb-pick-list">
          ${DB.casinos.map((c) => `
            <label class="amkdb-pick-item" data-db-pick-name="${esc(String(c.name || "").toLowerCase())}">
              <input type="checkbox" name="casino_ids" value="${esc(c.id)}"${gewaehlt.has(c.id) ? " checked" : ""}>
              <span>${esc(c.name || "Casino")}</span>
            </label>`).join("")}
        </div>
      </div>`;
  }

  function openForm(d) {
    const neu = !d;
    d = d || {};
    const partnerOpts = ['<option value="">— keine —</option>']
      .concat(DB.partners.map((p) => `<option value="${esc(p.id)}"${d.partner_group_id === p.id ? " selected" : ""}>${esc(p.name)}</option>`))
      .join("");

    AMKZ.modal.open(`
      <div class="amkz-modal amkdb-modal">
        <div class="amkz-modal-header">
          <div>
            <h3>${neu ? "Dashboard anlegen" : "Dashboard bearbeiten"}</h3>
            <p>Ein Eintrag für ein Partnerprogramm — mit allen Casinos, die dazugehören.</p>
          </div>
          <button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button>
        </div>

        <form id="amkdbForm" class="amkdb-form" autocomplete="off">
          <input type="hidden" name="id" value="${esc(d.id || "")}">

          <div class="amkdb-fset">
            <h4>Dashboard</h4>
            <div class="amkdb-grid2">
              <label class="amkdb-f"><span>Name *</span><input name="name" required placeholder="z. B. Royal Partners" value="${esc(d.name || "")}"></label>
              <label class="amkdb-f"><span>Partnergruppe</span><select name="partner_group_id">${partnerOpts}</select></label>
            </div>
            <div class="amkdb-grid2">
              <label class="amkdb-f"><span>Dashboard-Link *</span><input name="url" required placeholder="https://partners.example.com" value="${esc(d.url || "")}"></label>
              <label class="amkdb-f"><span>Login-Link (falls anders)</span><input name="login_url" placeholder="https://partners.example.com/login" value="${esc(d.login_url || "")}"></label>
            </div>
            <label class="amkdb-check">
              <input type="checkbox" name="is_active"${d.is_active === false ? "" : " checked"}>
              <span>Online — steht in der Liste ganz oben</span>
            </label>
          </div>

          <div class="amkdb-fset">
            <h4>Casinos</h4>
            <p class="amkdb-hint">Mehrere möglich. Bei Royal Partners hakst du einfach alle sechs, sieben an.</p>
            ${casinoAuswahl(d)}
            <label class="amkdb-f"><span>Weitere Casinos (mit Komma trennen)</span><input name="casino_names" placeholder="Casino A, Casino B" value="${esc((d.casino_names || []).join(", "))}"></label>
          </div>

          <div class="amkdb-fset">
            <h4>Zugang</h4>
            <div class="amkdb-grid2">
              <label class="amkdb-f"><span>Benutzername</span><input name="login_user" value="${esc(d.login_user || "")}"></label>
              <label class="amkdb-f"><span>E-Mail</span><input name="login_email" value="${esc(d.login_email || "")}"></label>
            </div>
            <div class="amkdb-grid2">
              <label class="amkdb-f"><span>Passwort</span><input name="login_password" value="${esc(d.login_password || "")}"></label>
              <label class="amkdb-f"><span>2FA / Sicherheitscode</span><input name="twofa" value="${esc(d.twofa || "")}"></label>
            </div>
          </div>

          <div class="amkdb-fset">
            <h4>Sonstiges</h4>
            <div class="amkdb-grid2">
              <label class="amkdb-f"><span>Affiliate-Manager</span><input name="manager_name" value="${esc(d.manager_name || "")}"></label>
              <label class="amkdb-f"><span>Kontakt (Telegram / Skype / Mail)</span><input name="manager_contact" value="${esc(d.manager_contact || "")}"></label>
            </div>
            <label class="amkdb-f"><span>Auszahlung</span><input name="payout_note" placeholder="z. B. monatlich, ab 500 €, USDT" value="${esc(d.payout_note || "")}"></label>
            <label class="amkdb-f"><span>Notiz</span><textarea name="note" rows="2">${esc(d.note || "")}</textarea></label>
          </div>

          <div class="amkz-modal-actions amkdb-form-actions">
            <button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button>
            <button class="amkz-primary-btn" type="submit">${neu ? "Anlegen" : "Speichern"}</button>
          </div>
        </form>
      </div>`);

    setTimeout(() => { try { document.querySelector('#amkdbForm [name="name"]').focus(); } catch (_) {} }, 40);
  }

  async function speichere(form) {
    const f = new FormData(form);
    const id = String(f.get("id") || "");
    const name = String(f.get("name") || "").trim();
    const url = volleUrl(f.get("url"));
    if (!name || !url) { toast("Fehlt noch was", "Name und Dashboard-Link sind Pflicht.", "error"); return; }

    const ids = Array.from(form.querySelectorAll('input[name="casino_ids"]:checked')).map((i) => i.value);
    const frei = String(f.get("casino_names") || "")
      .split(",").map((s) => s.trim()).filter(Boolean);

    const daten = {
      name,
      url,
      login_url: volleUrl(f.get("login_url")) || null,
      is_active: form.querySelector('input[name="is_active"]').checked,
      partner_group_id: String(f.get("partner_group_id") || "") || null,
      casino_ids: ids,
      casino_names: frei,
      login_user: String(f.get("login_user") || "").trim() || null,
      login_email: String(f.get("login_email") || "").trim() || null,
      login_password: String(f.get("login_password") || "").trim() || null,
      twofa: String(f.get("twofa") || "").trim() || null,
      manager_name: String(f.get("manager_name") || "").trim() || null,
      manager_contact: String(f.get("manager_contact") || "").trim() || null,
      payout_note: String(f.get("payout_note") || "").trim() || null,
      note: String(f.get("note") || "").trim() || null,
    };

    /* Passwort/2FA kommen nur über amk_dashboards_geheim. Wurden sie für
       diesen Eintrag nicht geladen und ist das Feld leer, bleibt der Wert in
       der Datenbank unangetastet (sonst würde Speichern ihn löschen). */
    const alt = id ? DB.list.find((x) => String(x.id) === id) : null;
    if (alt) ["login_password", "twofa"].forEach((k) => {
      if (!Object.prototype.hasOwnProperty.call(alt, k) && daten[k] == null) delete daten[k];
    });

    const btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = "Speichert …"; }

    try {
      if (id) {
        const { error } = await sb().from("affiliate_dashboards").update(daten).eq("id", id);
        if (error) throw error;
        toast("Gespeichert", name + " ist aktualisiert.");
      } else {
        daten.sort_order = DB.list.length;
        const { error } = await sb().from("affiliate_dashboards").insert(daten);
        if (error) throw error;
        toast("Angelegt", name + " steht jetzt in der Liste.");
      }
      AMKZ.modal.close();
      await ladeAlles(false);
      render();
    } catch (e) {
      if (btn) { btn.disabled = false; btn.textContent = id ? "Speichern" : "Anlegen"; }
      toast("Fehler", e.message || "Konnte nicht speichern.", "error");
    }
  }

  /* ---------------------------------------------------------- Aktionen */

  function finde(id) { return DB.list.find((d) => d.id === id); }

  // Online / nicht online. Die Karte springt sofort in die andere Gruppe:
  // auf online -> ganz nach oben, auf nicht online -> ganz nach unten.
  // Gespeichert wird direkt danach; klemmt Supabase, dreht sich alles zurueck.
  async function umschalten(id) {
    const d = finde(id);
    if (!d) return;

    const neu = !(d.is_active !== false);
    const altAktiv = d.is_active;
    const altOrder = d.sort_order;

    // Platz in der Zielgruppe bestimmen, bevor umgeschaltet wird
    const ziel = DB.list.filter((x) => x.id !== id && (x.is_active !== false) === neu)
      .map((x) => (x.sort_order == null ? 0 : x.sort_order));
    const order = neu
      ? Math.min.apply(null, ziel.concat(0)) - 1      // online: an die Spitze
      : Math.max.apply(null, ziel.concat(0)) + 1;     // nicht online: ans Ende

    d.is_active = neu;
    d.sort_order = order;
    render();

    try {
      const { error } = await sb().from("affiliate_dashboards")
        .update({ is_active: neu, sort_order: order }).eq("id", id);
      if (error) throw error;
      toast(neu ? "Online" : "Nicht online",
        d.name + (neu ? " steht jetzt ganz oben." : " ist nach unten gerutscht."));
    } catch (e) {
      d.is_active = altAktiv;
      d.sort_order = altOrder;
      render();
      toast("Fehler", e.message || "Konnte den Status nicht speichern.", "error");
    }
  }

  async function loesche(id) {
    const d = finde(id);
    if (!d) return;
    if (!window.confirm("„" + (d.name || "Dashboard") + "“ mitsamt Zugang löschen?")) return;
    try {
      const { error } = await sb().from("affiliate_dashboards").delete().eq("id", id);
      if (error) throw error;
      DB.list = DB.list.filter((x) => x.id !== id);
      render();
      toast("Gelöscht", (d.name || "Dashboard") + " ist raus.");
    } catch (e) {
      toast("Fehler", e.message || "Konnte nicht löschen.", "error");
    }
  }

  async function geprueft(id) {
    const d = finde(id);
    if (!d) return;
    const tag = heute();
    d.last_check = tag;
    render();
    try { await sb().from("affiliate_dashboards").update({ last_check: tag }).eq("id", id); } catch (_) {}
    toast("Notiert", (d.name || "Dashboard") + " als heute geprüft eingetragen.");
  }

  // Innerhalb der eigenen Gruppe verschieben. Die Gruppen selbst bleiben
  // wie sie sind — online bleibt oben, egal wie hier sortiert wird.
  async function verschiebe(id, richtung) {
    const d = finde(id);
    if (!d) return;
    const gruppeRows = sortiert(DB.list.filter((x) => (x.is_active !== false) === (d.is_active !== false)));
    const i = gruppeRows.findIndex((x) => x.id === id);
    const j = i + richtung;
    if (i < 0 || j < 0 || j >= gruppeRows.length) return;

    gruppeRows.splice(j, 0, gruppeRows.splice(i, 1)[0]);
    gruppeRows.forEach((x, n) => { x.sort_order = n; });
    render();

    try {
      await Promise.all(gruppeRows.map((x) =>
        sb().from("affiliate_dashboards").update({ sort_order: x.sort_order }).eq("id", x.id)));
    } catch (e) {
      toast("Fehler", "Reihenfolge konnte nicht gespeichert werden.", "error");
    }
  }

  function kopiereAlles(id) {
    const d = finde(id);
    if (!d) return;
    const zeilen = [
      d.name,
      volleUrl(d.login_url || d.url),
      d.login_user ? "Benutzer: " + d.login_user : "",
      d.login_email ? "E-Mail: " + d.login_email : "",
      d.login_password ? "Passwort: " + d.login_password : "",
      d.twofa ? "2FA: " + d.twofa : "",
    ].filter(Boolean);
    kopiere(zeilen.join("\n"), "Kompletter Zugang für " + (d.name || "Dashboard"));
  }

  // "Oeffnen" blendet das Dashboard hier ein — kein Bereichswechsel mehr.
  function oeffneIntern(id) {
    const d = finde(id);
    if (!d) return;
    if (!volleUrl(d.login_url || d.url)) {
      toast("Kein Link", "Für dieses Dashboard ist kein Link hinterlegt.", "error");
      return;
    }
    DB.buehne = id;
    render();
  }

  /* ---------------------------------------------------------- Ereignisse */

  if (!document.body.dataset.amkdbBound) {
    document.body.dataset.amkdbBound = "1";

    document.addEventListener("click", (e) => {
      const t = e.target;

      const copy = t.closest && t.closest("[data-db-copy-id]");
      if (copy) {
        const d = finde(copy.getAttribute("data-db-copy-id"));
        const feld = copy.getAttribute("data-db-copy-field");
        if (d) kopiere(d[feld], copy.getAttribute("data-db-copy-what") + " kopiert.");
        return;
      }

      const inRoot = t.closest && t.closest("#amkdbRoot, .amkdb-modal");
      if (!inRoot) return;

      const g = (sel) => t.closest(sel);

      if (g("[data-db-stage-close]")) { DB.buehne = null; render(); return; }
      if (g("[data-db-stage-reload]")) { const fr = byId("amkdbFrame"); if (fr) fr.src = fr.src; return; }

      if (g("[data-db-new]")) { openForm(null); return; }
      if (g("[data-db-reload]")) { DB.geladen = false; render(); ladeAlles(true).then(render); return; }
      if (g("[data-db-pw]")) { DB.zeigePw = !DB.zeigePw; DB.__fokusSuche = false; render(); return; }

      const fil = g("[data-db-filter]");
      if (fil) { DB.filter = fil.getAttribute("data-db-filter"); DB.__fokusSuche = false; render(); return; }

      const tog = g("[data-db-toggle]");
      if (tog) { umschalten(tog.getAttribute("data-db-toggle")); return; }

      const exp = g("[data-db-expand]");
      if (exp) {
        const id = exp.getAttribute("data-db-expand");
        if (DB.offen.has(id)) DB.offen.delete(id); else DB.offen.add(id);
        DB.__fokusSuche = false;
        render();
        return;
      }

      const op = g("[data-db-open]");
      if (op) { oeffneIntern(op.getAttribute("data-db-open")); return; }

      const ed = g("[data-db-edit]");
      if (ed) { openForm(finde(ed.getAttribute("data-db-edit"))); return; }

      const del = g("[data-db-del]");
      if (del) { loesche(del.getAttribute("data-db-del")); return; }

      const chk = g("[data-db-check]");
      if (chk) { geprueft(chk.getAttribute("data-db-check")); return; }

      const ca = g("[data-db-copyall]");
      if (ca) { kopiereAlles(ca.getAttribute("data-db-copyall")); return; }

      const up = g("[data-db-up]");
      if (up) { verschiebe(up.getAttribute("data-db-up"), -1); return; }

      const dn = g("[data-db-down]");
      if (dn) { verschiebe(dn.getAttribute("data-db-down"), 1); return; }
    });

    document.addEventListener("input", (e) => {
      if (e.target && e.target.id === "amkdbSuche") {
        DB.suche = e.target.value;
        DB.__fokusSuche = true;
        render();
        DB.__fokusSuche = false;
        return;
      }
      // Casino-Suche im Formular: blendet nur aus, Haken bleiben gesetzt
      if (e.target && e.target.hasAttribute && e.target.hasAttribute("data-db-pick-search")) {
        const q = e.target.value.trim().toLowerCase();
        e.target.closest(".amkdb-pick").querySelectorAll("[data-db-pick-name]").forEach((el) => {
          el.style.display = !q || el.getAttribute("data-db-pick-name").indexOf(q) >= 0 ? "" : "none";
        });
      }
    });

    document.addEventListener("submit", (e) => {
      if (e.target && e.target.id === "amkdbForm") { e.preventDefault(); speichere(e.target); }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && DB.buehne) { DB.buehne = null; render(); }
    });
  }

  /* ---------------------------------------------------------- Einstieg */

  async function mount(force) {
    if (!byId("amkdbRoot")) return;
    if (!DB.geladen) render();          // "wird geladen"
    await ladeAlles(force);
    render();
  }

  AMKZ.dashboards = { mount, refresh: () => mount(true) };

  const prev = AMKZ.loadView;
  AMKZ.loadView = async function (view, options) {
    const r = await (prev ? prev.call(this, view, options) : undefined);
    if (view === "dashboards") setTimeout(() => mount(!!(options && options.force)), 60);
    return r;
  };
})();

/* ============================================================================
   SEITENLEISTE — EIGENE REIHENFOLGE (langes Druecken, dann ziehen)
   ---------------------------------------------------------------------------
   Jeder Mitarbeiter arbeitet anders. Wer nie ins Dashboard schaut, aber
   zehnmal am Tag ins Giveaway, soll sich die Leiste danach legen koennen.

   Bedienung: einen Punkt gedrueckt halten (halbe Sekunde) -> Sortiermodus.
   Danach laesst sich jeder Punkt ziehen, bis "Fertig" gedrueckt wird.
   "Standard" stellt die urspruengliche Reihenfolge wieder her.

   Umgesetzt ueber die CSS-Eigenschaft `order`. Die Knoepfe bleiben also an
   ihrer Stelle im HTML — jeder andere Teil des Programms, der die Leiste
   ueber querySelector sucht, findet sie unveraendert. Nur die Anzeige
   verschiebt sich.

   Seit 09.09.2026 gilt die eigene Reihenfolge UEBER ALLE BEREICHE: Sobald
   jemand sortiert, loesen sich die sechs Gruppen (Uebersicht, Geld, Partner …)
   auf und die Leiste ist eine flache Liste in seiner Reihenfolge. Vorher war
   das Ziehen auf die eigene Gruppe beschraenkt — Marcel: "die Spalte muss
   eigenstaendig anpassbar sein, nicht auf die Bereiche". "Standard" stellt
   die Gruppen wieder her. Ein Knopf "Leiste anpassen" unten in der Leiste
   schaltet den Sortiermodus auch ohne langes Druecken ein.

   Gespeichert wird je Mitarbeiter im Browser (amkz_nav_order_<id>). Bewusst
   keine Datenbank: es ist eine reine Anzeige-Vorliebe, sie soll ohne
   Netz und ohne Wartezeit sitzen.
============================================================================ */
(function () {
  "use strict";

  var LANGES_DRUECKEN = 500;   // ms bis der Sortiermodus angeht
  var WACKEL_TOLERANZ = 9;     // px, die der Finger dabei wandern darf

  function nav() { return document.querySelector(".amkz-nav"); }
  function punkte() { return [].slice.call(document.querySelectorAll(".amkz-nav-item")); }

  /* ---------- Speicher je Mitarbeiter ---------- */
  function schluessel() {
    var id = "";
    try {
      var m = (window.AMKZ && AMKZ.state && AMKZ.state.member) ||
        JSON.parse(localStorage.getItem("amkz_team_session") || "null");
      id = (m && (m.id || m.email)) || "";
    } catch (_) {}
    return "amkz_nav_order_" + (id || "gast");
  }
  function gespeicherteReihenfolge() {
    try {
      var r = JSON.parse(localStorage.getItem(schluessel()) || "null");
      return Array.isArray(r) ? r : null;
    } catch (_) { return null; }
  }
  function merken(liste) {
    try { localStorage.setItem(schluessel(), JSON.stringify(liste)); } catch (_) {}
  }
  function vergessen() {
    try { localStorage.removeItem(schluessel()); } catch (_) {}
  }

  /* ---------- Reihenfolge anwenden ----------
     Punkte, die in der gespeicherten Liste fehlen (neuer Bereich seit dem
     letzten Mal), haengen sich hinten an — sie verschwinden nicht. */
  function anwenden(liste) {
    var alle = punkte();
    if (!alle.length) return;
    var G = window.AMKZ_NAV_GRUPPEN;
    if (!liste) {
      alle.forEach(function (b) { b.style.order = ""; });
      if (G && G.wiederherstellen) G.wiederherstellen();   // zurueck in die Gruppen
      return;
    }
    // Eigene Reihenfolge = flache Leiste ueber alle Bereiche hinweg.
    if (G && G.aufloesen) G.aufloesen();
    var platz = 0;
    liste.forEach(function (view) {
      var b = alle.filter(function (x) { return x.dataset.view === view; })[0];
      if (b) b.style.order = ++platz;
    });
    alle.forEach(function (b) { if (!b.style.order) b.style.order = ++platz + 100; });
  }
  function aktuelleReihenfolge() {
    // Nach dem, was WIRKLICH untereinander steht — bei Gruppen ist die
    // CSS-Eigenschaft order nur innerhalb der jeweiligen Gruppe aussagekraeftig.
    return punkte()
      .slice()
      .sort(function (a, b) { return a.getBoundingClientRect().top - b.getBoundingClientRect().top; })
      .map(function (b) { return b.dataset.view; });
  }

  /* ---------- Aussehen ---------- */
  function stil() {
    if (document.getElementById("amkzNavSortStyle")) return;
    var s = document.createElement("style");
    s.id = "amkzNavSortStyle";
    s.textContent = [
      ".amkz-nav-item{ touch-action:manipulation; }",
      // Im Sortiermodus darf der Finger die Leiste nicht scrollen, sonst wird aus dem Ziehen ein Wischen.
      "body.amkz-nav-sortiert .amkz-nav-item{ touch-action:none; }",
      "body.amkz-nav-sortiert .amkz-nav-item{ transition:transform .18s cubic-bezier(.2,.8,.3,1), opacity .18s ease; cursor:grab; }",
      // Knopf "Leiste anpassen" am Ende der Leiste (kein .amkz-nav-item — Tab-Leiste und Rechte lassen ihn in Ruhe)
      ".amkz-nav-anpassen{ display:flex; align-items:center; justify-content:center; gap:8px; width:100%; margin-top:6px;",
      "  padding:8px 10px; border-radius:12px; border:1px dashed rgba(212,175,55,.35); background:transparent;",
      "  color:inherit; opacity:.55; font:inherit; font-size:.72rem; font-weight:700; letter-spacing:.06em; cursor:pointer; }",
      ".amkz-nav-anpassen:hover{ opacity:1; background:rgba(212,175,55,.08); }",
      "@media (min-width:781px){ .amkz-main-app .amkz-nav-anpassen{ flex-direction:column; gap:2px; font-size:.58rem; letter-spacing:.03em; padding:6px 2px; } }",
      "body.amkz-nav-sortiert .amkz-nav-anpassen{ display:none; }",
      "body.amkz-nav-sortiert .amkz-nav-item::after{ content:'⠿'; margin-left:auto; opacity:.45; font-size:15px; letter-spacing:-2px; }",
      "body.amkz-nav-sortiert .amkz-nav-item{ animation:amkzWackel 2.4s ease-in-out infinite; }",
      "body.amkz-nav-sortiert .amkz-nav-item:nth-child(2n){ animation-delay:-1.2s; }",
      "@keyframes amkzWackel{ 0%,100%{ transform:rotate(-.35deg) } 50%{ transform:rotate(.35deg) } }",
      "@media (prefers-reduced-motion: reduce){ body.amkz-nav-sortiert .amkz-nav-item{ animation:none } }",
      ".amkz-nav-item.amkz-zieht{ opacity:.28; animation:none; }",
      ".amkz-nav-geist{ position:fixed; z-index:99999; pointer-events:none; margin:0;",
      "  border-radius:var(--amk-radius-pill,999px); box-shadow:0 18px 44px -14px rgba(0,0,0,.65);",
      "  background:var(--amk-surface,#14161c); border:1px solid rgba(212,175,55,.55);",
      "  color:#f0d488; display:flex; align-items:center; gap:12px; padding:0 14px;",
      "  font:inherit; transform:scale(1.03); }",
      ".amkz-nav-geist span{ width:28px; display:inline-flex; justify-content:center; }",
      // Die Leiste sitzt in einer schmalen Seitenleiste. Deshalb umbrechend:
      // Text oben, Knoepfe darunter, sobald es eng wird.
      ".amkz-nav-leiste{ display:flex; align-items:center; flex-wrap:wrap; gap:6px; margin:0 0 10px;",
      "  padding:8px 10px; border-radius:14px; background:rgba(212,175,55,.10);",
      "  border:1px solid rgba(212,175,55,.30); font-size:12px; color:#e8cf94; }",
      ".amkz-nav-leiste .txt{ flex:1 1 100%; }",
      ".amkz-nav-leiste button{ flex:1 1 auto; }",
      ".amkz-nav-leiste b{ font-weight:700; }",
      ".amkz-nav-leiste small{ display:block; opacity:.75; font-size:11px; line-height:1.35; }",
      ".amkz-nav-leiste button{ border:0; cursor:pointer; border-radius:10px; padding:6px 10px;",
      "  font-size:12px; font-weight:700; background:rgba(212,175,55,.9); color:#1a1206; }",
      ".amkz-nav-leiste button.geist{ background:transparent; color:#e8cf94;",
      "  border:1px solid rgba(212,175,55,.35); font-weight:600; }",

      /* ---- Handy-Feinschliff -------------------------------------------
         Vier Stellen legen zwei gleich breite Spalten nebeneinander. Auf
         einem 375-Pixel-Bildschirm bleiben damit je 170 Pixel — Eingabe-
         felder, in die niemand etwas tippen moechte. Untereinander ist auf
         dem Handy immer richtig.
         Der body-Vorsatz ist noetig, weil diese Regeln aus eingebetteten
         Stilbloecken kommen, die spaeter im Dokument stehen als eine reine
         Klassenregel — ohne ihn gaebe es keinen Zuschlag. */
      "@media (max-width: 640px){",
      "  body .amkz-crm-detail, body .amkz-ads-form-row,",
      "  body .amkz-sc-row, body .amkz-stream-form{ grid-template-columns:1fr; }",
      "}"
    ].join("\n");
    document.head.appendChild(s);
  }

  /* ---------- Sortiermodus ---------- */
  var sortiert = false;
  var klickSperre = false;

  function leiste() {
    var n = nav();
    if (!n || document.getElementById("amkzNavLeiste")) return;
    var d = document.createElement("div");
    d.id = "amkzNavLeiste";
    d.className = "amkz-nav-leiste";
    d.innerHTML =
      '<div class="txt"><b>Leiste anpassen</b>' +
      "<small>Punkte ziehen – über alle Bereiche hinweg · gilt nur für dich</small></div>" +
      '<button type="button" class="geist" id="amkzNavStandard">Standard</button>' +
      '<button type="button" id="amkzNavFertig">Fertig</button>';
    n.parentNode.insertBefore(d, n);
    d.querySelector("#amkzNavFertig").addEventListener("click", function (e) {
      e.stopPropagation(); ausschalten();
    });
    d.querySelector("#amkzNavStandard").addEventListener("click", function (e) {
      e.stopPropagation();
      vergessen(); anwenden(null);
      if (window.AMKZ && AMKZ.toast) AMKZ.toast("Seitenleiste", "Standard mit Gruppen wiederhergestellt.");
    });
  }

  function einschalten() {
    if (sortiert) return;
    sortiert = true;
    // Gruppen aufloesen: sortiert wird ueber die ganze Leiste, nicht je Bereich.
    if (window.AMKZ_NAV_GRUPPEN && AMKZ_NAV_GRUPPEN.aufloesen) AMKZ_NAV_GRUPPEN.aufloesen();
    document.body.classList.add("amkz-nav-sortiert");
    leiste();
    try { if (navigator.vibrate) navigator.vibrate(14); } catch (_) {}
  }
  function ausschalten() {
    if (!sortiert) return;
    sortiert = false;
    document.body.classList.remove("amkz-nav-sortiert");
    var l = document.getElementById("amkzNavLeiste");
    if (l) l.remove();
    zieht = null;
    aufraeumen();
  }

  /* ---------- Ziehen ---------- */
  var zieht = null;

  /* Sicherheitsnetz: verwaiste Schwebe-Kopien einsammeln. Sie entstehen, wenn
     der Browser das Loslassen verschluckt — Fenster verliert den Fokus, das
     mobile Menue klappt mitten im Ziehen zu. Ohne das klebt eine Kopie fuer
     immer auf dem Bildschirm. */
  function aufraeumen() {
    [].slice.call(document.querySelectorAll(".amkz-nav-geist"))
      .forEach(function (g) { g.remove(); });
    [].slice.call(document.querySelectorAll(".amkz-nav-item.amkz-zieht"))
      .forEach(function (b) { b.classList.remove("amkz-zieht"); });
    document.body.style.userSelect = "";
  }

  function starteZiehen(btn, ev) {
    aufraeumen();
    // Ueber die ganze Leiste schieben: beim Einschalten sind die Gruppen
    // aufgeloest, der Behaelter ist die Leiste selbst.
    var behaelter = btn.closest(".amkz-nav") || btn.parentNode;
    var sichtbar = [].slice.call(behaelter.querySelectorAll(".amkz-nav-item"))
      .filter(function (b) { return b.offsetParent !== null; })
      .sort(function (a, b) { return a.getBoundingClientRect().top - b.getBoundingClientRect().top; });
    var r = btn.getBoundingClientRect();
    var geist = btn.cloneNode(true);
    geist.className = "amkz-nav-geist";
    geist.style.width = r.width + "px";
    geist.style.height = r.height + "px";
    geist.style.left = r.left + "px";
    geist.style.top = r.top + "px";
    document.body.appendChild(geist);
    btn.classList.add("amkz-zieht");

    zieht = {
      btn: btn, geist: geist, liste: sichtbar,
      griffY: ev.clientY - r.top, links: r.left,
      index: sichtbar.indexOf(btn)
    };
    document.body.style.userSelect = "none";
  }

  function beimZiehen(ev) {
    if (!zieht) return;
    ev.preventDefault();
    zieht.geist.style.top = (ev.clientY - zieht.griffY) + "px";

    // Welcher Platz liegt gerade unter dem Finger?
    var mitte = ev.clientY;
    var ziel = zieht.index;
    zieht.liste.forEach(function (b, i) {
      if (b === zieht.btn) return;
      var r = b.getBoundingClientRect();
      if (mitte > r.top && mitte < r.bottom) ziel = i;
    });
    if (ziel !== zieht.index) {
      var neu = zieht.liste.slice();
      neu.splice(zieht.index, 1);
      neu.splice(ziel, 0, zieht.btn);
      zieht.liste = neu;
      zieht.index = ziel;
      neu.forEach(function (b, i) { b.style.order = i + 1; });
    }
  }

  function endeZiehen() {
    if (!zieht) return;
    zieht = null;
    aufraeumen();
    merken(aktuelleReihenfolge());
  }

  /* ---------- Knopf "Leiste anpassen" ---------- */
  function knopf() {
    var n = nav();
    if (!n || document.getElementById("amkzNavAnpassen")) return;
    var b = document.createElement("button");
    b.type = "button"; b.id = "amkzNavAnpassen"; b.className = "amkz-nav-anpassen";
    b.title = "Reihenfolge der Leiste ändern – nur für dich";
    b.innerHTML = "<span>⇅</span><label>Leiste anpassen</label>";
    b.addEventListener("click", function (e) { e.stopPropagation(); einschalten(); });
    n.appendChild(b);
  }
  // Der Knopf muss immer ganz unten stehen — auch nachdem Gruppen gebaut oder aufgeloest wurden.
  function knopfNachUnten() {
    var n = nav(), b = document.getElementById("amkzNavAnpassen");
    if (n && b && n.lastElementChild !== b) n.appendChild(b);
  }

  /* Gespeicherte Reihenfolge nachziehen: beim Start ist die Mitglieds-ID oft
     noch nicht da (Schluessel "gast"); nach der Anmeldung stimmt der Schluessel. */
  var zuletztAngewandt = "";
  function nachladen() {
    var r = gespeicherteReihenfolge();
    var k = schluessel() + ":" + (r ? r.join(",") : "");
    if (k === zuletztAngewandt) { knopfNachUnten(); return; }
    zuletztAngewandt = k;
    if (r) anwenden(r);
    knopfNachUnten();
  }

  /* ---------- Ereignisse ---------- */
  function verdrahten() {
    stil();
    anwenden(gespeicherteReihenfolge());
    knopf();

    var timer = null, start = null, kandidat = null;

    document.addEventListener("pointerdown", function (ev) {
      var btn = ev.target.closest && ev.target.closest(".amkz-nav-item");
      if (!btn) return;
      kandidat = btn;
      start = { x: ev.clientX, y: ev.clientY };

      if (sortiert) {                     // im Sortiermodus sofort ziehen
        starteZiehen(btn, ev);
        try { btn.setPointerCapture(ev.pointerId); } catch (_) {}
        return;
      }
      timer = setTimeout(function () {
        timer = null;
        klickSperre = true;               // den Klick danach schlucken
        einschalten();
        starteZiehen(btn, ev);
        try { btn.setPointerCapture(ev.pointerId); } catch (_) {}
      }, LANGES_DRUECKEN);
    }, true);

    document.addEventListener("pointermove", function (ev) {
      if (timer && start) {               // vor dem Umschalten: Wackeln erlaubt
        var weit = Math.abs(ev.clientX - start.x) > WACKEL_TOLERANZ ||
                   Math.abs(ev.clientY - start.y) > WACKEL_TOLERANZ;
        if (weit) { clearTimeout(timer); timer = null; }
      }
      if (zieht) beimZiehen(ev);
    }, { passive: false, capture: true });

    ["pointerup", "pointercancel"].forEach(function (typ) {
      document.addEventListener(typ, function () {
        if (timer) { clearTimeout(timer); timer = null; }
        endeZiehen();
        kandidat = null;
      }, true);
    });

    // Der Klick direkt nach dem langen Druecken darf die Ansicht nicht wechseln.
    document.addEventListener("click", function (ev) {
      if (!ev.target.closest || !ev.target.closest(".amkz-nav-item")) return;
      if (klickSperre) { klickSperre = false; ev.preventDefault(); ev.stopImmediatePropagation(); return; }
      if (sortiert) { ev.preventDefault(); ev.stopImmediatePropagation(); }
    }, true);

    // Klick neben die Leiste beendet den Sortiermodus.
    document.addEventListener("click", function (ev) {
      if (!sortiert) return;
      if (ev.target.closest && (ev.target.closest(".amkz-sidebar") || ev.target.closest(".amkz-nav-leiste"))) return;
      ausschalten();
    });

    document.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape" && sortiert) ausschalten();
    });

    // Fenster weg oder Reiter gewechselt -> laufendes Ziehen sauber beenden.
    window.addEventListener("blur", endeZiehen);
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) endeZiehen();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", verdrahten);
  } else {
    verdrahten();
  }

  window.AMKZ_NAV_ORDER = {
    anwenden: anwenden,
    reihenfolge: aktuelleReihenfolge,
    gespeichert: gespeicherteReihenfolge,
    nachladen: nachladen,
    einschalten: einschalten,
    zuruecksetzen: function () { vergessen(); anwenden(null); },
    modus: function () { return sortiert; }
  };
})();

/* ============================================================================
   SEITENLEISTE — SECHS GRUPPEN STATT ZWANZIG PUNKTE
   ---------------------------------------------------------------------------
   Einundzwanzig Bereiche untereinander sind eine Liste, kein Menue: auf dem
   Handy scrollt man an der Haelfte vorbei, am Schreibtisch sucht man.
   Deshalb gebuendelt — sechs Gruppen, die man auf- und zuklappt.

   WICHTIG: die RECHTE bleiben einzeln. Eine Gruppe ist reine Anzeige. Wer im
   Team-Bereich nur "Giveaway" freigegeben bekommt, sieht die Gruppe
   "Community" mit genau einem Punkt darin. Gruppen ohne einen einzigen
   erlaubten Punkt verschwinden ganz.

   Umgesetzt als Umbau zur Laufzeit: die Knoepfe aus dem Markup werden in
   Gruppen einsortiert, nicht ersetzt. Damit bleibt jeder andere Teil des
   Programms, der .amkz-nav-item sucht, unveraendert lauffaehig — und die
   Shopify-Section muss nicht angefasst werden.

   Welche Gruppe offen ist, merkt sich der Browser je Mitarbeiter.

   Seit 09.09.2026: Hat jemand eine EIGENE Reihenfolge (Sortiermodul oben),
   werden gar keine Gruppen gebaut — die Leiste ist dann flach, in seiner
   Ordnung, ueber alle Bereiche hinweg (aufloesen). "Standard" holt die
   Gruppen zurueck (wiederherstellen).
============================================================================ */
(function () {
  "use strict";

  // kurz = fuer die schmale Cockpit-Leiste am Schreibtisch (106 px),
  // titel = fuer die breite Leiste auf dem Handy und im Klappmenue.
  var GRUPPEN = [
    { id: "ueberblick", titel: "Überblick", kurz: "Übersicht", icon: "◱", views: ["dashboard", "ftdbilanz", "daily"] },
    { id: "geld",       titel: "Geld",      kurz: "Geld",      icon: "€", views: ["entries", "finance"] },
    { id: "markt",      titel: "Partner & Casinos", kurz: "Partner", icon: "◆",
      views: ["partners", "webseiten", "dashboards"] },
    { id: "community",  titel: "Community", kurz: "Community", icon: "◎", views: ["metaspins", "halloween", "giveaway", "postfach", "support", "connect"] },
    { id: "stream",     titel: "Stream",    kurz: "Stream",    icon: "▶", views: ["streaming", "bonushunt"] },
    { id: "team",       titel: "Team",      kurz: "Team",      icon: "◇", views: ["team", "calendar"] },
  ];

  function schluessel() {
    var id = "";
    try {
      var m = (window.AMKZ && AMKZ.state && AMKZ.state.member) ||
        JSON.parse(localStorage.getItem("amkz_team_session") || "null");
      id = (m && (m.id || m.email)) || "";
    } catch (_) {}
    return "amkz_nav_gruppen_" + (id || "gast");
  }
  function offeneGruppen() {
    try {
      var r = JSON.parse(localStorage.getItem(schluessel()) || "null");
      return Array.isArray(r) ? r : null;
    } catch (_) { return null; }
  }
  function merkeOffen(liste) {
    try { localStorage.setItem(schluessel(), JSON.stringify(liste)); } catch (_) {}
  }

  function stil() {
    if (document.getElementById("amkzNavGruppenStil")) return;
    var s = document.createElement("style");
    s.id = "amkzNavGruppenStil";
    s.textContent = [
      ".amkz-navgrp{ margin-bottom:6px; }",
      ".amkz-navgrp-kopf{ width:100%; display:flex; align-items:center; gap:10px; cursor:pointer;",
      "  background:transparent; border:0; color:inherit; font:inherit; font-weight:800;",
      "  font-size:.74rem; letter-spacing:.08em; text-transform:uppercase; opacity:.62;",
      "  padding:9px 12px 7px; border-radius:12px; }",
      ".amkz-navgrp-kopf:hover{ opacity:1; background:rgba(212,175,55,.07); }",
      ".amkz-navgrp-kopf .pfeil{ margin-left:auto; transition:transform .18s ease; font-size:.7rem; opacity:.7; }",
      ".amkz-navgrp-kopf .kurz{ display:none; }",
      /* Schreibtisch: die Leiste ist nur 106 px breit und stellt Symbol ueber
         Beschriftung. Dann passt weder ein langer Gruppentitel noch ein
         Pfeil daneben — also mittig, kurzer Name, kein Pfeil. */
      "@media (min-width:781px){",   /* die Cockpit-Leiste (106 px) beginnt bei 781 — vorher stand hier 901 und die Gruppenkoepfe wurden zwischen 781 und 900 abgeschnitten */
      "  .amkz-main-app .amkz-navgrp{ border-top:1px solid rgba(128,128,128,.16); padding-top:6px; margin-top:8px; }",
      "  .amkz-main-app .amkz-navgrp:first-child{ border-top:0; margin-top:0; }",
      "  .amkz-main-app .amkz-navgrp-kopf{ flex-direction:column; gap:2px; padding:6px 2px; text-align:center; }",
      "  .amkz-main-app .amkz-navgrp-kopf .lang{ display:none; }",
      "  .amkz-main-app .amkz-navgrp-kopf .kurz{ display:block; font-size:.58rem; letter-spacing:.04em; }",
      "  .amkz-main-app .amkz-navgrp-kopf .pfeil{ display:none; }",
      "  .amkz-main-app .amkz-navgrp-kopf .amkz-navgrp-zahl{ position:absolute; margin-top:-4px; margin-left:26px; }",
      "  .amkz-main-app .amkz-navgrp-kopf{ position:relative; }",
      "}",
      ".amkz-navgrp.zu .amkz-navgrp-kopf .pfeil{ transform:rotate(-90deg); }",
      ".amkz-navgrp-punkte{ display:grid; gap:8px; overflow:hidden;",
      "  transition:max-height .22s ease, opacity .18s ease; }",
      ".amkz-navgrp.zu .amkz-navgrp-punkte{ max-height:0 !important; opacity:0; pointer-events:none; }",
      // Zahl der zugeklappten Gruppe: ungelesene Anfragen dürfen nicht
      // verschwinden, nur weil die Gruppe zu ist.
      ".amkz-navgrp-zahl{ min-width:18px; height:18px; padding:0 5px; border-radius:9px;",
      "  background:#e05555; color:#fff; font-size:.62rem; font-weight:800;",
      "  display:none; place-items:center; letter-spacing:0; }",
      ".amkz-navgrp.zu .amkz-navgrp-zahl.hat{ display:grid; }",
      "@media (prefers-reduced-motion: reduce){ .amkz-navgrp-punkte{ transition:none } }"
    ].join("\n");
    document.head.appendChild(s);
  }

  function nav() { return document.querySelector(".amkz-nav"); }

  function bauen() {
    var n = nav();
    if (!n || n.dataset.gruppiert === "1") return;
    var punkte = [].slice.call(n.querySelectorAll(".amkz-nav-item"));
    if (!punkte.length) return;
    if (!n._standard) n._standard = punkte.slice();   // Reihenfolge aus dem Markup, fuer "Standard"

    // Eigene Reihenfolge vorhanden -> keine Gruppen, flache Leiste.
    var O = window.AMKZ_NAV_ORDER;
    if (n.dataset.flach === "1" || (O && O.gespeichert && O.gespeichert())) { aufloesen(); return; }

    stil();
    var offen = offeneGruppen();
    var nachView = {};
    punkte.forEach(function (b) { nachView[b.dataset.view] = b; });

    var rest = punkte.slice();
    GRUPPEN.forEach(function (g) {
      var eigene = g.views.map(function (v) { return nachView[v]; }).filter(Boolean);
      if (!eigene.length) return;

      var box = document.createElement("div");
      box.className = "amkz-navgrp";
      box.dataset.grp = g.id;
      var zu = offen ? offen.indexOf(g.id) === -1 : false;   // beim ersten Mal alles offen
      if (zu) box.classList.add("zu");

      var kopf = document.createElement("button");
      kopf.type = "button";
      kopf.className = "amkz-navgrp-kopf";
      kopf.innerHTML = '<span class="sym">' + g.icon + '</span>' +
        '<span class="lang">' + g.titel + '</span>' +
        '<span class="kurz">' + (g.kurz || g.titel) + '</span>' +
        '<span class="amkz-navgrp-zahl"></span><span class="pfeil">▾</span>';

      var liste = document.createElement("div");
      liste.className = "amkz-navgrp-punkte";
      eigene.forEach(function (b) {
        liste.appendChild(b);
        rest.splice(rest.indexOf(b), 1);
      });

      kopf.addEventListener("click", function () {
        box.classList.toggle("zu");
        merkeOffen([].slice.call(n.querySelectorAll(".amkz-navgrp"))
          .filter(function (x) { return !x.classList.contains("zu"); })
          .map(function (x) { return x.dataset.grp; }));
        hoehen();
        zahlen();
      });

      box.appendChild(kopf);
      box.appendChild(liste);
      n.appendChild(box);
    });

    // Was in keine Gruppe passt (neuer Bereich seit dem letzten Umbau),
    // bleibt einfach unten stehen — verschwinden darf nichts.
    rest.forEach(function (b) { n.appendChild(b); });

    n.dataset.gruppiert = "1";
    hoehen();
    zahlen();
    aufklappenFuerAktive();
  }

  /* Hoehe je Gruppe setzen, damit das Zuklappen weich laeuft. Erlaubte Punkte
     stehen auf display:flex, gesperrte auf none — gerechnet wird mit dem, was
     wirklich sichtbar ist. */
  function hoehen() {
    [].slice.call(document.querySelectorAll(".amkz-navgrp")).forEach(function (box) {
      var liste = box.querySelector(".amkz-navgrp-punkte");
      if (!liste) return;
      var sichtbar = [].slice.call(liste.querySelectorAll(".amkz-nav-item"))
        .filter(function (b) { return b.style.display !== "none"; });
      box.style.display = sichtbar.length ? "" : "none";   // leere Gruppe ganz weg
      liste.style.maxHeight = box.classList.contains("zu") ? "0px" : Math.max(sichtbar.length * 84 + 20, liste.scrollHeight + 8) + "px";   // Nachtschicht 31.10.: Punkte sind seit dem rem-Fix 63–76 px hoch, 56 schnitt Beschriftungen ab
    });
  }

  /* Zahlen aus den Punkten (z. B. ungelesene Anfragen) auf die zugeklappte
     Gruppe hochziehen. */
  function zahlen() {
    [].slice.call(document.querySelectorAll(".amkz-navgrp")).forEach(function (box) {
      var summe = 0;
      [].slice.call(box.querySelectorAll(".amkz-nav-item .amkz-nav-badge")).forEach(function (b) {
        if (b.style.display !== "none") summe += parseInt(b.textContent, 10) || 0;
      });
      var z = box.querySelector(".amkz-navgrp-zahl");
      if (!z) return;
      z.textContent = summe > 9 ? "9+" : String(summe);
      z.classList.toggle("hat", summe > 0);
    });
  }

  /* Gruppen aufloesen: alle Punkte zurueck in die Leiste, Gruppenkoepfe weg.
     Ab dann gilt nur die CSS-Reihenfolge des Sortiermoduls. */
  function aufloesen() {
    var n = nav(); if (!n) return;
    var alle = [].slice.call(n.querySelectorAll(".amkz-nav-item"));
    if (!n._standard) n._standard = alle.slice();
    if (n.dataset.flach === "1") return;
    alle.forEach(function (b) { n.appendChild(b); });
    [].slice.call(n.querySelectorAll(".amkz-navgrp")).forEach(function (g) { g.remove(); });
    n.dataset.flach = "1";
    n.dataset.gruppiert = "1";
    if (window.AMKZ_NAV_ORDER && AMKZ_NAV_ORDER.nachladen) AMKZ_NAV_ORDER.nachladen();   // Knopf wieder ans Ende
  }

  /* Zurueck zum Standard: Markup-Reihenfolge, dann die Gruppen neu bauen. */
  function wiederherstellen() {
    var n = nav(); if (!n || n.dataset.flach !== "1") return;
    var alle = n._standard || [].slice.call(n.querySelectorAll(".amkz-nav-item"));
    alle.forEach(function (b) { b.style.order = ""; n.appendChild(b); });
    delete n.dataset.flach;
    delete n.dataset.gruppiert;
    bauen();
    if (window.AMKZ_NAV_ORDER && AMKZ_NAV_ORDER.nachladen) AMKZ_NAV_ORDER.nachladen();
  }

  function aufklappenFuerAktive() {
    var aktiv = document.querySelector(".amkz-nav-item.active");
    if (!aktiv) return;
    var box = aktiv.closest(".amkz-navgrp");
    if (box && box.classList.contains("zu")) { box.classList.remove("zu"); hoehen(); }
  }

  function start() {
    bauen();
    // Rechte kommen erst nach der Anmeldung -> danach nochmal messen.
    var zaehler = 0;
    var takt = setInterval(function () {
      bauen(); hoehen(); zahlen();
      // Eigene Reihenfolge greift erst, wenn die Mitglieds-ID da ist -> hier nachziehen.
      if (window.AMKZ_NAV_ORDER && AMKZ_NAV_ORDER.nachladen) AMKZ_NAV_ORDER.nachladen();
      if (++zaehler > 20) clearInterval(takt);
    }, 700);
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest(".amkz-nav-item")) setTimeout(aufklappenFuerAktive, 60);
    }, true);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  window.AMKZ_NAV_GRUPPEN = { bauen: bauen, hoehen: hoehen, zahlen: zahlen, gruppen: GRUPPEN, aufloesen: aufloesen, wiederherstellen: wiederherstellen };
})();

/* ============================================================================
   DESIGN V9 — HELLE FASSUNG UND BEWEGTER HINTERGRUND
   ---------------------------------------------------------------------------
   Zwei Dinge, ein Modul:

     1. Der bewegte Hintergrund wird einmal eingehaengt und pausiert, sobald
        der Reiter im Hintergrund liegt. Auf dem Handy ist das der
        Unterschied zwischen "sieht teuer aus" und "Akku leer".

     2. Ein Schalter oben rechts stellt zwischen der dunklen und der hellen
        Fassung um. Beide liegen nebeneinander im CSS — die helle haengt an
        der Klasse .amkz-hell am <html>. So laesst sich der Umbau Stueck fuer
        Stueck ansehen und jederzeit zurueckdrehen, ohne dass zwischendurch
        etwas kaputt ist.

   Die Wahl merkt sich der Browser je Mitarbeiter.
============================================================================ */
(function () {
  "use strict";

  function schluessel() {
    var id = "";
    try {
      var m = (window.AMKZ && AMKZ.state && AMKZ.state.member) ||
        JSON.parse(localStorage.getItem("amkz_team_session") || "null");
      id = (m && (m.id || m.email)) || "";
    } catch (_) {}
    // _v2: am 10.10.2026 neu – damit alle einmal mit der Fassung „Gold" (Roadtrip-Look) starten
    return "amkz_design_v2_" + (id || "gast");
  }

  // Die getroffene Wahl steht auch im Arbeitsspeicher. Sonst koennte der
  // Nachfass-Takt sie ueberschreiben, wenn der Browser das Speichern
  // verweigert (privates Fenster, blockierte Seitendaten).
  var aktuellerModus = null;
  function gewaehlt() {
    if (aktuellerModus) return aktuellerModus;
    try {
      var g = localStorage.getItem(schluessel()) || "gold";
      return g === "dunkel" ? "onyx" : g;      // alte Bezeichnung von vorher
    } catch (_) { return "gold"; }
  }
  // Drei Fassungen, im Kreis: Nachtblau -> Hell -> Onyx -> Nachtblau
  /* Nachtblau ist die Grundfassung — sie steht in den Tokens ohne Klasse.
     Hell und Onyx sind Abweichungen davon und haengen an einer Klasse. */
  var FASSUNGEN = [
    { id: "gold",   name: "Gold",      zeichen: "✦", klasse: "amkz-gold" },
    { id: "nacht",  name: "Nachtblau", zeichen: "◉", klasse: null },
    { id: "hell",   name: "Hell",      zeichen: "◑", klasse: "amkz-hell" },
    { id: "onyx",   name: "Onyx",      zeichen: "◐", klasse: "amkz-onyx" },
  ];
  function naechste(modus) {
    var i = FASSUNGEN.findIndex(function (f) { return f.id === modus; });
    return FASSUNGEN[(i + 1) % FASSUNGEN.length].id;
  }
  function setze(modus, merken) {
    if (!FASSUNGEN.some(function (f) { return f.id === modus; })) modus = "nacht";
    aktuellerModus = modus;
    var w = document.documentElement;
    FASSUNGEN.forEach(function (f) { if (f.klasse) w.classList.toggle(f.klasse, f.id === modus); });
    if (merken !== false) { try { localStorage.setItem(schluessel(), modus); } catch (_) {} }
    var knopf = document.getElementById("amkzDesignSchalter");
    if (knopf) {
      var n = FASSUNGEN[(FASSUNGEN.findIndex(function (f) { return f.id === modus; }) + 1) % FASSUNGEN.length];
      knopf.textContent = n.zeichen + " " + n.name;
      knopf.title = "Zur Fassung „" + n.name + "“ wechseln";
    }
  }

  function hintergrund() {
    if (document.querySelector(".amkz-bgfx")) return;
    var wurzel = document.querySelector(".amkz-root") || document.body;
    var d = document.createElement("div");
    d.className = "amkz-bgfx";
    d.setAttribute("aria-hidden", "true");
    d.innerHTML = "<i></i><i></i><i></i>" +
      // Leuchtende Route (nur in der Fassung „Gold" sichtbar)
      '<svg class="rt-route" viewBox="0 0 1200 800" preserveAspectRatio="none"><defs><linearGradient id="rtG" x1="0" x2="1"><stop offset="0" stop-color="#ffc73a" stop-opacity="0"/><stop offset=".3" stop-color="#ffc73a"/><stop offset=".7" stop-color="#38e1ff"/><stop offset="1" stop-color="#38e1ff" stop-opacity="0"/></linearGradient></defs>' +
      '<path d="M-40 720 C 160 640, 220 420, 420 470 S 700 700, 820 470 S 980 120, 1240 160" fill="none" stroke="url(#rtG)" stroke-width="1.5" stroke-dasharray="5 12" opacity=".6"/>' +
      '<path class="rt-strich" d="M-40 720 C 160 640, 220 420, 420 470 S 700 700, 820 470 S 980 120, 1240 160" fill="none" stroke="url(#rtG)" stroke-width="2.5"/></svg>';
    wurzel.insertBefore(d, wurzel.firstChild);

    // Alles, was ueber dem Hintergrund liegt, braucht eine Ebene darueber.
    // Nur setzen, wo noch nichts steht — sonst zerschiesst es bestehende
    // Stapelreihenfolgen (Modale, Seitenleiste).
    // Als KLASSE, nicht als Inline-Stil: ein Inline-z-index:1 schlug am Handy die
    // 999999 der Schublade — das Menue fuhr hinter dem Inhalt aus (Team-Rueckmeldung 11.09.).
    [".amkz-sidebar", ".amkz-content"].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && !el.style.zIndex) el.classList.add("amkz-ueber-bgfx");
    });

    document.addEventListener("visibilitychange", function () {
      document.body.classList.toggle("amkz-bgfx-pause", document.hidden);
    });
  }

  function schalter() {
    if (document.getElementById("amkzDesignSchalter")) return;
    var leiste = document.querySelector(".amkz-topbar-actions");
    if (!leiste) return;
    var b = document.createElement("button");
    b.id = "amkzDesignSchalter";
    b.type = "button";
    b.className = "amkz-secondary-btn";
    leiste.insertBefore(b, leiste.firstChild);
    b.addEventListener("click", function () { setze(naechste(gewaehlt())); });
    setze(gewaehlt(), false);
  }

  function start() {
    setze(gewaehlt(), false);
    hintergrund();
    schalter();
    // Kopfzeile und Wurzel stehen erst nach der Anmeldung — kurz nachfassen.
    var n = 0;
    var takt = setInterval(function () {
      hintergrund(); schalter();
      if (++n > 20 || document.getElementById("amkzDesignSchalter")) clearInterval(takt);
    }, 600);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  window.AMKZ_DESIGN = { setze: setze, aktuell: gewaehlt };
})();

/* ============================================================================
   STARTSEITE — "WAS AUF MICH WARTET"
   ---------------------------------------------------------------------------
   Das Dashboard zeigt heute alles gleichzeitig: FTDs, ReDepos, Soll- und
   Ist-Gewinn. Zahlen, die man liest — aber keine, die einem sagen, was zu
   TUN ist. Diese Karte steht ganz oben und beantwortet genau eine Frage:
   was liegt gerade auf meinem Tisch?

   Jede Kachel hat eine Zahl, eine Zeile Erklaerung und springt per Klick in
   den zustaendigen Bereich. Was der Mitarbeiter nicht sehen darf, erscheint
   gar nicht erst — die Kacheln fragen dieselben Rechte ab wie die
   Seitenleiste.

   Die Zahlen kommen live: beim Oeffnen des Dashboards und danach jede Minute,
   solange es sichtbar ist. Im Hintergrund-Reiter ruht die Abfrage.
============================================================================ */
(function () {
  "use strict";
  // Heutiges Datum in deutscher Zeit (nicht UTC) — sonst stimmt "überfällig" und "heute" nachts nicht.
  function lokalerTag() { var d = new Date(); return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0"); }
  var AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__wartetModul) return;
  AMKZ.__wartetModul = true;

  var GV_TOKEN = "amk_gv_aMU3heSihudfeuz8Tf7Smgw0w2DW1o";  // wie GV_ADMIN_TOKEN
  var takt = null;
  var laeuft = false;
  var nachholen = false;   // Anfrage, die waehrend eines Laufs kam

  function darf(recht) {
    var p = (AMKZ.state && AMKZ.state.permissions) || {};
    return p[recht] === true;
  }
  // Sind die Rechte ueberhaupt schon da? Vor der Anmeldung ist das Objekt
  // leer — dann darf die Karte nicht behaupten, es sei nichts freigegeben.
  function rechteDa() {
    var p = (AMKZ.state && AMKZ.state.permissions) || {};
    return Object.keys(p).length > 0;
  }
  function zahl(n) { return new Intl.NumberFormat("de-DE").format(Number(n || 0)); }
  function geld(n) {
    return new Intl.NumberFormat("de-DE", { minimumFractionDigits: 0, maximumFractionDigits: 0 })
      .format(Number(n || 0)) + " €";
  }

  /* ---------- Die einzelnen Quellen ----------
     Jede fuer sich abgesichert: faellt eine aus (SQL noch nicht eingespielt,
     Netz weg), zeigt ihre Kachel einen Strich statt einer falschen Null.
     Eine kaputte Quelle darf nie die ganze Karte leer machen. */

  /* FTD-Bilanz (22.10.): Depo-Deckung des laufenden Monats — rechnet der Bereich selbst. */
  async function ftdBilanz() {
    if (!darf("ftdbilanz") || !AMKZ.ftdBilanz) return null;
    return AMKZ.ftdBilanz.kachel();
  }

  async function anfragen() {
    if (!darf("support")) return null;
    try {
      var n = AMKZ.support && AMKZ.support.ungelesenFrisch
        ? await AMKZ.support.ungelesenFrisch()
        : (AMKZ.support && AMKZ.support.ungelesen ? AMKZ.support.ungelesen() : null);
      if (n == null) return null;
      // Nachtschicht 31.10.: Kachel zeigte „ungelesen“ (meist 0) mit Text „warten auf Antwort“ – jetzt wie die Anfragen-Seite
      var u = AMKZ.support.unbeantwortet ? AMKZ.support.unbeantwortet() : null;
      if (u === null) return { zahl: zahl(n), roh: n, unter: n === 1 ? "Gespräch ungelesen" : "Gespräche ungelesen" };
      return { zahl: zahl(u), roh: u, unter: (u === 1 ? "Gespräch wartet auf Antwort" : "Gespräche warten auf Antwort") + (n > 0 ? " · " + n + " ungelesen" : "") };
    } catch (_) { return { zahl: "—", roh: 0, unter: "nicht erreichbar" }; }
  }

  async function tickets() {
    if (!darf("giveaway")) return null;
    try {
      var r = await AMKZ.supabase.rpc("amk_giveaway_admin",
        { p_token: GV_TOKEN, p_action: "stats", p_payload: {} });
      var st = r && r.data && r.data.stats;
      if (!st) return null;
      if (st.open == null) {
        // Alte Fassung der Datenbankfunktion: die Zahl gibt es dort noch nicht.
        return { zahl: "—", roh: 0, unter: "supabase-giveaway-edit.sql fehlt noch" };
      }
      return {
        zahl: zahl(st.open), roh: Number(st.open) || 0,
        unter: st.open === 0 ? "alles geprüft" : "Einzahlungen ungeprüft · " + zahl(st.open_tickets) + " Tickets",
      };
    } catch (_) { return { zahl: "—", roh: 0, unter: "nicht erreichbar" }; }
  }

  async function rechnungen() {
    if (!darf("finance")) return null;
    try {
      var r = await AMKZ.invoice.rpc("list", { status: "issued", limit: 500 });
      var liste = (r && r.invoices) || [];
      var summe = liste.reduce(function (a, x) { return a + (Number(x.gross_amount) || 0); }, 0);
      var faellig = liste.filter(function (x) {
        return x.due_date && String(x.due_date) < lokalerTag();
      }).length;
      return {
        zahl: zahl(liste.length), roh: liste.length,
        unter: liste.length
          ? geld(summe) + " offen" + (faellig ? " · " + faellig + " überfällig" : "")
          : "nichts offen",
        warnung: faellig > 0,
      };
    } catch (_) { return { zahl: "—", roh: 0, unter: "supabase-rechnungen.sql fehlt noch" }; }
  }

  async function termine() {
    if (!darf("calendar")) return null;
    // Systemscan 02.11.2026: zählt jetzt auch die Specials/Ausflüge aus dem Wochenplan (Function wochenplan) mit
    var heute = lokalerTag(), liste = [], geklappt = false;
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
    try {
      var r = await AMKZ.supabase.from("planning_calendar")
        .select("id, title, starts_at")
        .gte("starts_at", new Date(heute + "T00:00:00").toISOString())
        .lte("starts_at", new Date(heute + "T23:59:59").toISOString());
      ((r && r.data) || []).forEach(function (x) {
        var d = new Date(x.starts_at);
        liste.push({ zeit: ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2), titel: x.title || "Termin" });
      });
      geklappt = true;
    } catch (_) {}
    try {
      var root = document.getElementById("amkzApp");
      var url = String((root && root.dataset.supabaseUrl) || "https://cbwxgikndyyzdslmfpmo.supabase.co").replace(/\/$/, "") + "/functions/v1/wochenplan";
      var anon = (root && root.dataset.supabaseKey) || "";
      var w = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + anon, apikey: anon,
          "x-amk-sitzung": (AMKZ.state.member && AMKZ.state.member.session) || "" },
        body: JSON.stringify({ action: "laden" }),
      }).then(function (x) { return x.json(); });
      if (w && w.ok) {
        geklappt = true;
        (w.specials || []).forEach(function (s) {
          if (s.datum <= heute && heute <= (s.bis_datum || s.datum)) liste.push({ zeit: s.von || "", titel: s.titel || "Special" });
        });
      }
    } catch (_) {}
    if (!geklappt) return null;
    liste.sort(function (a, b) { return (a.zeit || "99") < (b.zeit || "99") ? -1 : 1; });
    return {
      zahl: zahl(liste.length), roh: liste.length,
      unter: liste.length ? esc((liste[0].zeit ? liste[0].zeit + " " : "") + liste[0].titel) + (liste.length > 1 ? " +" + (liste.length - 1) : "") : "keine Termine",
    };
  }

  var KACHELN = [
    { id: "ftdbilanz", view: "ftdbilanz", titel: "FTD-Bilanz", quelle: ftdBilanz },
    { id: "support",  view: "support",  titel: "Anfragen",   quelle: anfragen },
    { id: "giveaway", view: "giveaway", titel: "Giveaway",   quelle: tickets },
    { id: "finance",  view: "finance",  titel: "Rechnungen", quelle: rechnungen },
    { id: "calendar", view: "calendar", titel: "Termine heute",      quelle: termine },
  ];

  function stil() {
    if (document.getElementById("amkzWartetStil")) return;
    var s = document.createElement("style");
    s.id = "amkzWartetStil";
    s.textContent = [
      ".amkz-wartet{ margin-bottom:18px; }",
      ".amkz-wartet-kopf{ display:flex; align-items:baseline; gap:10px; margin:0 2px 10px; }",
      ".amkz-wartet-kopf h3{ margin:0; font-size:1.02rem; font-weight:800; }",
      ".amkz-wartet-kopf small{ opacity:.55; font-size:.78rem; }",
      ".amkz-wartet-grid{ display:grid; gap:12px; grid-template-columns:repeat(auto-fit,minmax(190px,1fr)); }",
      ".amkz-wartet-k{ text-align:left; font:inherit; color:inherit; cursor:pointer;",
      "  background:var(--lx-surface,#16181c); border:1px solid var(--lx-line,rgba(255,255,255,.08));",
      "  border-radius:var(--amk-radius-lg,20px); padding:16px 18px; position:relative; overflow:hidden;",
      "  transition:transform .16s cubic-bezier(.2,.8,.3,1), box-shadow .16s ease, border-color .16s ease; }",
      ".amkz-wartet-k:hover{ transform:translateY(-2px); border-color:var(--lx-ring,rgba(206,170,108,.5));",
      "  box-shadow:var(--lx-sh-md,0 12px 30px -14px rgba(0,0,0,.6)); }",
      ".amkz-wartet-k small{ display:block; font-size:.72rem; letter-spacing:.07em; text-transform:uppercase;",
      "  opacity:.6; font-weight:800; margin-bottom:6px; }",
      ".amkz-wartet-k b{ display:block; font-size:2.1rem; font-weight:800; line-height:1;",
      "  font-variant-numeric:tabular-nums; }",
      ".amkz-wartet-k span{ display:block; margin-top:6px; font-size:.8rem; opacity:.62; }",
      ".amkz-wartet-k.ruhig b{ opacity:.35; font-weight:700; }",
      ".amkz-wartet-k.dran{ border-color:var(--lx-ring,rgba(206,170,108,.5)); }",
      ".amkz-wartet-k.dran b{ color:var(--gold-2,#cfae74); }",
      ".amkz-wartet-k.warn{ border-color:rgba(209,59,59,.45); }",
      ".amkz-wartet-k.warn b{ color:var(--lx-neg,#e8695f); }",
      // Ein feiner Lichtstreif wandert einmal durch, wenn sich eine Zahl
      // aendert — so sieht man Bewegung, ohne dass etwas blinkt.
      ".amkz-wartet-k.neu::after{ content:''; position:absolute; inset:0;",
      "  background:linear-gradient(105deg,transparent 30%,rgba(206,170,108,.18) 50%,transparent 70%);",
      "  animation:amkzWartetGlanz .9s ease-out 1; }",
      "@keyframes amkzWartetGlanz{ from{ transform:translateX(-100%) } to{ transform:translateX(100%) } }",
      "@media (prefers-reduced-motion: reduce){ .amkz-wartet-k.neu::after{ animation:none } }"
    ].join("\n");
    document.head.appendChild(s);
  }

  function karte() {
    var view = document.getElementById("amkzDashboardView");
    if (!view) return null;
    var k = document.getElementById("amkzWartet");
    if (k) return k;
    stil();
    k = document.createElement("div");
    k.id = "amkzWartet";
    k.className = "amkz-wartet";
    k.innerHTML =
      '<div class="amkz-wartet-kopf"><h3>Was auf mich wartet</h3>' +
      '<small id="amkzWartetStand">wird geladen…</small></div>' +
      '<div class="amkz-wartet-grid" id="amkzWartetGrid"></div>';
    view.insertBefore(k, view.firstChild);
    k.addEventListener("click", function (e) {
      var b = e.target.closest("[data-wartet-view]");
      if (!b) return;
      var ziel = document.querySelector('.amkz-nav-item[data-view="' + b.dataset.wartetView + '"]');
      if (ziel) ziel.click();
    });
    return k;
  }

  var letzte = {};

  async function laden() {
    // Kommt eine zweite Anfrage waehrend des Ladens, wird sie nicht
    // verworfen, sondern einmal nachgeholt. Sonst zeigt die Karte nach
    // einem Klick auf "Aktualisieren" weiter den alten Stand, obwohl sich
    // etwas geaendert hat.
    if (laeuft) { nachholen = true; return; }
    var k = karte();
    if (!k) return;
    laeuft = true;
    try {
      var werte = await Promise.all(KACHELN.map(function (t) {
        return t.quelle().catch(function () { return null; });
      }));
      var gitter = document.getElementById("amkzWartetGrid");
      if (!gitter) return;

      var html = "";
      KACHELN.forEach(function (t, i) {
        var w = werte[i];
        if (!w) return;
        var klassen = ["amkz-wartet-k"];
        if (w.warnung) klassen.push("warn");
        else if (w.roh > 0) klassen.push("dran");
        else klassen.push("ruhig");
        if (letzte[t.id] != null && letzte[t.id] !== w.zahl) klassen.push("neu");
        letzte[t.id] = w.zahl;
        html += '<button type="button" class="' + klassen.join(" ") + '" data-wartet-view="' + t.view + '">' +
          "<small>" + t.titel + "</small><b>" + w.zahl + "</b><span>" + w.unter + "</span></button>";
      });
      gitter.innerHTML = html || (rechteDa()
        ? '<div class="amkz-sup-empty">Für dich ist gerade nichts freigegeben.</div>'
        : '<div class="amkz-sup-empty">Lädt …</div>');
      // Die ReDepo-Kachel hängt ein anderes Modul hier ein — nach dem Neuzeichnen wieder anbringen.
      if (AMKZ.redepo && AMKZ.redepo.kachel) AMKZ.redepo.kachel();

      var stand = document.getElementById("amkzWartetStand");
      if (stand) {
        stand.textContent = "Stand " + new Date().toLocaleTimeString("de-DE",
          { hour: "2-digit", minute: "2-digit" });
      }
    } finally {
      laeuft = false;
      if (nachholen) { nachholen = false; laden(); }
    }
  }

  function anschalten() {
    laden();
    /* Beim ersten Aufbau sind die Rechte oft noch nicht da (die Anmeldung
       läuft parallel). Deshalb kurz nachfassen, sobald sie eingetroffen sind —
       sonst stünde bis zur nächsten Minute "wird geladen" in der Karte. */
    var versuche = 0;
    var warten = setInterval(function () {
      if (rechteDa()) { clearInterval(warten); laden(); }
      else if (++versuche > 20) clearInterval(warten);
    }, 500);
    clearInterval(takt);
    takt = setInterval(function () {
      if (document.hidden) return;                       // im Hintergrund ruht es
      if (AMKZ.state && AMKZ.state.currentView !== "dashboard") return;
      laden();
    }, 60000);
  }

  var zuvor = AMKZ.loadView;
  AMKZ.loadView = async function wartetChain(view, options) {
    var ergebnis = await (zuvor ? zuvor.call(this, view, options) : undefined);
    if (view === "dashboard") anschalten();
    return ergebnis;
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", anschalten);
  else setTimeout(anschalten, 800);

  window.AMKZ_WARTET = { laden: laden, kacheln: KACHELN };
})();

/* ============================================================================
   REDEPO-ERINNERUNG — 48 STUNDEN NACH EINEM FTD
   ---------------------------------------------------------------------------
   Wer einen FTD einträgt, weiss nach zwei Tagen nicht mehr, ob eine zweite
   Einzahlung kam. Deshalb meldet sich die Zentrale von selbst: 48 Stunden
   nach jedem FTD bekommt jeder mit dem Recht "Einträge" eine Nachricht.
   Ein Klick darauf zeigt dieselben Angaben wie im Bereich Entries — und
   zwei Knöpfe: bestätigen oder ablehnen.

   Die Erinnerung selbst entsteht in der Datenbank (Ausloeser am Eintrag,
   siehe supabase-redepo-erinnerung.sql). Hier wird nur abgeholt, angezeigt
   und entschieden. Entschieden wird ebenfalls serverseitig: der ReDepo-
   Eintrag entsteht in der Funktion, nicht im Browser — sonst koennten zwei
   Mitarbeiter gleichzeitig bestaetigen und es gaebe zwei Eintraege.
============================================================================ */
(function () {
  "use strict";
  var AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__redepoModul) return;
  AMKZ.__redepoModul = true;

  /* >>> MUSS mit v_secret in supabase-redepo-erinnerung.sql uebereinstimmen <<< */
  var RD_ADMIN_TOKEN = "amk_rd_5Tn8Wq2Lp6Vx";

  var byId = function (id) { return document.getElementById(id); };
  var esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || function (v) { return String(v == null ? "" : v); };
  var toast = function (t, m, ty) { (AMKZ.toast || console.log)(t, m, ty); };
  var geld = function (n, w) {
    return new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .format(Number(n || 0)) + " " + (w && w !== "EUR" ? w : "€");
  };
  var wann = function (v) {
    if (!v) return "—";
    var d = new Date(v);
    return isNaN(d) ? String(v) : d.toLocaleString("de-DE",
      { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  };

  async function rpc(action, payload) {
    var m = AMKZ.state.member || {};
    var r = await AMKZ.supabase.rpc("amk_redepo_admin", {
      p_token: RD_ADMIN_TOKEN,
      p_action: action,
      p_payload: Object.assign({ by: m.name || m.email || "", by_id: m.id || null }, payload || {}),
    });
    if (r.error) throw new Error(r.error.message);
    var d = r.data;
    if (d && d.error) {
      throw new Error(d.error === "unauthorized"
        ? "ReDepo-Token stimmt nicht mit der Datenbank überein (supabase-redepo-erinnerung.sql einspielen)."
        : d.error);
    }
    return d;
  }

  function darfEintragen() {
    var p = (AMKZ.state && AMKZ.state.permissions) || {};
    return p.entries === true || p.isAdmin === true;
  }

  /* ---------- Das Fenster zur Entscheidung ---------- */
  async function oeffne(id) {
    var a;
    try { a = await rpc("get", { id: id }); }
    catch (err) { return toast("ReDepo", err.message, "error"); }
    var r = a.reminder || {};
    if (r.status !== "open") {
      return toast("Schon erledigt", r.status === "confirmed"
        ? "Diese Nachfrage wurde bereits bestätigt."
        : "Diese Nachfrage wurde bereits abgelehnt.", "info");
    }

    AMKZ.modal.open(
      '<div class="amkz-modal amkz-rd-modal">' +
        '<div class="amkz-modal-header"><div><h3>Kam eine zweite Einzahlung?</h3>' +
        "<p>48 Stunden nach dem FTD · bestätigen legt den ReDepo an</p></div>" +
        '<button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>' +

        '<div class="amkz-rd-karte">' +
          '<div class="amkz-rd-zeile"><span>Spieler</span><b>' + esc(r.customer_name || "—") + "</b></div>" +
          '<div class="amkz-rd-zeile"><span>E-Mail</span><b>' + esc(r.customer_email || "—") + "</b></div>" +
          '<div class="amkz-rd-zeile"><span>Casino</span><b>' + esc(a.casino || "—") + "</b></div>" +
          '<div class="amkz-rd-zeile"><span>Erste Einzahlung</span><b>' + geld(r.amount, r.currency) + "</b></div>" +
          '<div class="amkz-rd-zeile"><span>FTD eingetragen</span><b>' + esc(wann(r.ftd_at)) + "</b></div>" +
        "</div>" +

        '<div class="amkz-input-group"><label>Betrag der zweiten Einzahlung</label>' +
          '<input id="rdBetrag" type="number" step="0.01" min="0" placeholder="0,00" ' +
          'value="' + (Number(r.amount) || "") + '">' +
          "<small>Vorbelegt mit der ersten Einzahlung — bitte auf den echten Betrag ändern.</small></div>" +

        '<div class="amkz-input-group amkz-rd-ablehnen is-hidden" id="rdGrundFeld">' +
          "<label>Grund der Ablehnung (optional)</label>" +
          '<input id="rdGrund" placeholder="z. B. keine zweite Einzahlung erfolgt"></div>' +

        '<div class="amkz-modal-actions">' +
          '<button class="amkz-secondary-btn" type="button" id="rdAblehnen">Keine zweite Einzahlung</button>' +
          '<button class="amkz-primary-btn" type="button" id="rdBestaetigen">ReDepo bestätigen</button>' +
        "</div>" +
      "</div>");

    var sperre = false;
    var knoepfe = function (an) {
      ["rdBestaetigen", "rdAblehnen"].forEach(function (k) {
        var b = byId(k); if (b) b.disabled = !an;
      });
    };

    byId("rdBestaetigen").addEventListener("click", async function () {
      if (sperre) return;
      var betrag = Number(String(byId("rdBetrag").value).replace(",", "."));
      if (!betrag || betrag <= 0) return toast("Hinweis", "Bitte den Betrag der zweiten Einzahlung eintragen.", "error");
      sperre = true; knoepfe(false);
      this.textContent = "Wird gebucht…";
      try {
        var res = await rpc("confirm", { id: id, amount: betrag });
        AMKZ.modal.close();
        toast("ReDepo gebucht", geld(res.amount, r.currency) + " als ReDepo eingetragen.");
        pruefen();
        if (AMKZ.state && AMKZ.state.currentView === "entries" && AMKZ.loadView) {
          try { await AMKZ.loadView("entries", { force: true }); } catch (_) {}
        }
      } catch (err) {
        toast("Fehler", err.message, "error");
        sperre = false; knoepfe(true);
        this.textContent = "ReDepo bestätigen";
      }
    });

    byId("rdAblehnen").addEventListener("click", async function () {
      var feld = byId("rdGrundFeld");
      // Erster Klick blendet das Grundfeld ein, zweiter lehnt ab.
      if (feld && feld.classList.contains("is-hidden")) {
        feld.classList.remove("is-hidden");
        this.textContent = "Ablehnen bestätigen";
        byId("rdGrund").focus();
        return;
      }
      if (sperre) return;
      sperre = true; knoepfe(false);
      try {
        await rpc("decline", { id: id, reason: byId("rdGrund") ? byId("rdGrund").value : "" });
        AMKZ.modal.close();
        toast("Notiert", "Kein ReDepo — die Nachfrage ist abgehakt.");
        pruefen();
      } catch (err) {
        toast("Fehler", err.message, "error");
        sperre = false; knoepfe(true);
      }
    });
  }

  /* ---------- Fällige Erinnerungen holen ---------- */
  var laeuft = false, letzteOffen = [], gewarnt = false;
  async function pruefen() {
    if (laeuft || !darfEintragen() || !AMKZ.supabase) return;
    if (!(AMKZ.state && AMKZ.state.member && AMKZ.state.member.id)) return;
    laeuft = true;
    try {
      var a = await rpc("due", {});
      letzteOffen = (a && a.reminders) || [];
      zeichneKachel(letzteOffen);
    } catch (err) {
      // Noch nicht eingespielt oder kein Netz — still bleiben, nicht nerven. Einmal in die Konsole, damit es auffällt.
      if (!gewarnt) { gewarnt = true; console.warn("[redepo] Erinnerungen nicht abrufbar (supabase-redepo-erinnerung.sql eingespielt?):", err && err.message); }
    } finally { laeuft = false; }
  }
  // Wartet-Karte zeichnet ihr Gitter jede Minute neu — dann die Kachel aus dem letzten Stand wieder einhängen.
  function kachel() { if (letzteOffen.length) zeichneKachel(letzteOffen); }

  /* ---------- Kachel auf der Startseite ----------
     Die Glocke zeigt die Nachricht; hier steht zusätzlich eine Kachel bei
     "Was auf mich wartet", damit man die offenen Nachfragen sieht, ohne die
     Glocke zu öffnen. */
  function zeichneKachel(offen) {
    var ziel = byId("amkzWartetGrid");
    if (!ziel) return;
    var alt = byId("amkzRdKachel");
    if (!offen.length) { if (alt) alt.remove(); return; }
    var html =
      '<button type="button" class="amkz-wartet-k dran" id="amkzRdKachel" data-rd-erste="' + esc(offen[0].id) + '">' +
      "<small>ReDepo-Nachfrage</small><b>" + (offen.length >= 100 ? "100+" : offen.length) + "</b>" +   /* Nachtschicht 31.10.: genau 100 sieht nach Abfrage-Grenze aus */
      "<span>" + (offen.length === 1 ? "Zahlung wartet auf Prüfung" : "Zahlungen warten auf Prüfung") + "</span></button>";
    if (alt) alt.outerHTML = html; else ziel.insertAdjacentHTML("afterbegin", html);
  }

  /* ---------- Stil ---------- */
  (function stil() {
    if (byId("amkzRdStil")) return;
    var s = document.createElement("style");
    s.id = "amkzRdStil";
    s.textContent = [
      ".amkz-rd-modal{max-width:520px;width:96vw}",
      ".amkz-rd-karte{border:1px solid var(--lx-line,rgba(255,255,255,.1));border-radius:14px;",
      "  padding:12px 14px;margin-bottom:14px;background:var(--lx-surface-2,rgba(255,255,255,.03))}",
      ".amkz-rd-zeile{display:flex;justify-content:space-between;gap:14px;padding:5px 0;font-size:.9rem}",
      ".amkz-rd-zeile span{opacity:.6}",
      ".amkz-rd-zeile b{text-align:right;font-variant-numeric:tabular-nums}",
      ".amkz-rd-ablehnen.is-hidden{display:none}",
      ".amkz-notif-tap{cursor:pointer;border-color:rgba(200,170,110,.4)}",
      ".amkz-notif-tap:hover{background:rgba(200,170,110,.08)}",
      ".amkz-notif-cta{margin-top:6px;font-size:.78rem;font-weight:800;color:var(--gold-2,#cfae74)}"
    ].join("\n");
    document.head.appendChild(s);
  })();

  /* ---------- Klick auf die Nachricht ---------- */
  document.addEventListener("click", function (e) {
    var k = e.target.closest && e.target.closest("[data-rd-erste]");
    if (k) { e.preventDefault(); oeffne(k.getAttribute("data-rd-erste")); return; }
    var n = e.target.closest && e.target.closest("[data-rd-id]");
    if (n) { e.preventDefault(); oeffne(n.getAttribute("data-rd-id")); }
  }, true);

  /* ---------- Anlauf ----------
     Beim Start, nach der Anmeldung und danach alle zehn Minuten. Im
     Hintergrund-Reiter ruht die Abfrage. */
  function start() {
    var versuche = 0;
    var warten = setInterval(function () {
      if (AMKZ.state && AMKZ.state.member && AMKZ.state.member.id) { clearInterval(warten); pruefen(); }
      else if (++versuche > 40) clearInterval(warten);
    }, 500);
    setInterval(function () { if (!document.hidden) pruefen(); }, 600000);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  AMKZ.redepo = { pruefen: pruefen, oeffne: oeffne, rpc: rpc, kachel: kachel };
})();

/* ============================================================================
   LICHT — Scheinwerfer, der der Maus folgt
   ---------------------------------------------------------------------------
   Der Lichtstrahl am Rahmen steckt im Stylesheet und braucht kein
   JavaScript. Dieser Teil macht nur eines: er sagt der Karte, WO die Maus
   gerade ist, damit der Schein ihr folgen kann.

   Bewusst sparsam gebaut:
     · ein einziger Zuhoerer fuer das ganze Dokument, nicht einer je Karte
     · gerechnet wird erst im naechsten Bild (requestAnimationFrame), sonst
       laeuft der Rechner bei jeder Mausbewegung heiss
     · auf Geraeten ohne echten Zeiger (Handy) passiert gar nichts
============================================================================ */
(function () {
  "use strict";
  if (window.__amkzLicht) return;
  window.__amkzLicht = true;

  var FLAECHEN = ".amkz-card, .amkz-kpi-card, .amkz-wartet-k, .amkz-gv-card";
  var feiner = window.matchMedia && window.matchMedia("(pointer: fine)").matches;
  var ruhig = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!feiner || ruhig) return;

  var wartet = false;
  var letzte = null;

  document.addEventListener("pointermove", function (ev) {
    var karte = ev.target.closest && ev.target.closest(FLAECHEN);
    if (!karte) {
      if (letzte) { letzte.classList.remove("amkz-hat-licht"); letzte = null; }
      return;
    }
    if (letzte && letzte !== karte) letzte.classList.remove("amkz-hat-licht");
    letzte = karte;
    if (wartet) return;
    wartet = true;
    requestAnimationFrame(function () {
      wartet = false;
      if (!letzte) return;
      var r = letzte.getBoundingClientRect();
      letzte.style.setProperty("--mx", Math.round(ev.clientX - r.left) + "px");
      letzte.style.setProperty("--my", Math.round(ev.clientY - r.top) + "px");
      letzte.classList.add("amkz-hat-licht");
    });
  }, { passive: true });

  document.addEventListener("pointerleave", function () {
    if (letzte) { letzte.classList.remove("amkz-hat-licht"); letzte = null; }
  }, true);
})();

/* ============================================================================
   HANDY — UNTERE LEISTE STATT BURGER
   ---------------------------------------------------------------------------
   Auf dem Handy lag die gesamte Navigation hinter einem Burger-Knopf oben
   links. Das ist der Unterschied zwischen "Webseite" und "App": in einer App
   liegen die wichtigsten Bereiche unten am Daumen, nicht hinter einem Menue.

   Diese Leiste wird aus den vorhandenen Navigationspunkten gebaut — kein
   zweites Markup, keine zweite Wahrheit. Welche fuenf unten stehen, richtet
   sich nach dem, was der Mitarbeiter darf; der Rest steckt hinter "Mehr",
   das die bestehende Schublade oeffnet.
============================================================================ */
(function () {
  "use strict";
  var AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__tableiste) return;
  AMKZ.__tableiste = true;

  // Reihenfolge nach taeglicher Nutzung, nicht nach Menuereihenfolge.
  var WUNSCH = ["dashboard", "ftdbilanz", "entries", "giveaway", "support", "finance",
                "daily", "partners", "team"];

  function stil() {
    if (document.getElementById("amkzTabStil")) return;
    var s = document.createElement("style");
    s.id = "amkzTabStil";
    s.textContent = [
      ".amkz-tabbar{ display:none; }",
      "@media (max-width:780px){",
      "  .amkz-tabbar{",
      "    display:grid; grid-auto-flow:column; grid-auto-columns:1fr;",
      "    position:fixed; left:0; right:0; bottom:0; z-index:999990;",
      "    padding:6px 6px calc(6px + env(safe-area-inset-bottom));",
      "    background:color-mix(in srgb, var(--amk-bg-1) 86%, transparent);",
      "    backdrop-filter:blur(18px) saturate(1.3);",
      "    -webkit-backdrop-filter:blur(18px) saturate(1.3);",
      "    border-top:1px solid var(--amk-line);",
      "  }",
      "  .amkz-tabbar button{",
      "    background:none; border:0; color:var(--amk-muted); font:inherit; cursor:pointer;",
      "    display:flex; flex-direction:column; align-items:center; gap:3px;",
      "    padding:8px 2px 6px; border-radius:14px; font-size:10px; font-weight:700;",
      "    letter-spacing:.01em; position:relative;",
      "    transition:color var(--amk-fast) var(--amk-ease), background var(--amk-fast) var(--amk-ease);",
      "  }",
      "  .amkz-tabbar button .amkz-tab-ico{ width:22px; height:22px; display:grid; place-items:center; }",
      "  .amkz-tabbar button .amkz-tab-ico svg{ width:21px; height:21px; }",
      "  .amkz-tabbar button.active{ color:var(--amk-text); background:color-mix(in srgb, var(--amk-accent) 16%, transparent); }",
      // Der leuchtende Strich ueber dem aktiven Punkt — das kleine Detail,
      // an dem man eine App von einer Webseite unterscheidet.
      "  .amkz-tabbar button.active::before{",
      "    content:''; position:absolute; top:0; left:22%; right:22%; height:2px; border-radius:2px;",
      "    background:linear-gradient(90deg, var(--amk-accent), var(--amk-info));",
      "    box-shadow:0 0 12px color-mix(in srgb, var(--amk-accent) 70%, transparent);",
      "  }",
      "  .amkz-tabbar .amkz-tab-zahl{",
      "    position:absolute; top:4px; right:calc(50% - 20px); min-width:16px; height:16px;",
      "    padding:0 4px; border-radius:8px; background:var(--amk-neg); color:#fff;",
      "    font-size:9.5px; font-weight:800; display:none; place-items:center;",
      "  }",
      "  .amkz-tabbar .amkz-tab-zahl.hat{ display:grid; }",
      // Platz schaffen, damit die Leiste nichts verdeckt
      "  .amkz-content{ padding-bottom:calc(82px + env(safe-area-inset-bottom)) !important; }",
      "  .amkz-loc-hinweis{ bottom:calc(78px + env(safe-area-inset-bottom)); }",
      // Der Burger oben links wird ueberfluessig, sobald unten eine Leiste
      // steht — "Mehr" oeffnet dieselbe Schublade. Zwei Wege zum selben Ziel
      // sind auf einem kleinen Bildschirm einer zu viel.
      "  body:has(#amkzTabbar) .amkz-mobile-menu-btn{ display:none !important; }",
      "  body:has(#amkzTabbar) .amkz-topbar{ padding-top:4px !important; }",
      "}",
      "@media (prefers-reduced-motion: reduce){ .amkz-tabbar button{ transition:none; } }"
    ].join("\n");
    document.head.appendChild(s);
  }

  function punkte() {
    return [].slice.call(document.querySelectorAll(".amkz-nav-item"));
  }

  function bauen() {
    var alle = punkte();
    if (!alle.length) return;
    var erlaubt = alle.filter(function (b) { return b.style.display !== "none"; });
    if (!erlaubt.length) return;

    var nachView = {};
    erlaubt.forEach(function (b) { nachView[b.dataset.view] = b; });
    var gewaehlt = [];
    WUNSCH.forEach(function (v) { if (nachView[v] && gewaehlt.length < 4) gewaehlt.push(nachView[v]); });
    erlaubt.forEach(function (b) { if (gewaehlt.length < 4 && gewaehlt.indexOf(b) < 0) gewaehlt.push(b); });

    var leiste = document.getElementById("amkzTabbar");
    if (!leiste) {
      leiste = document.createElement("nav");
      leiste.id = "amkzTabbar";
      leiste.className = "amkz-tabbar";
      leiste.setAttribute("aria-label", "Schnellzugriff");
      document.body.appendChild(leiste);
    }

    var html = gewaehlt.map(function (b) {
      var ico = b.querySelector("span");
      var name = (b.querySelector("label") || {}).textContent || b.dataset.view;
      return '<button type="button" data-tab="' + b.dataset.view + '">' +
        '<span class="amkz-tab-ico">' + (ico ? ico.innerHTML : "") + "</span>" +
        '<span class="amkz-tab-zahl"></span>' +
        "<span>" + name.replace("Stream-Zentrale", "Stream").replace("Tagesanalyse", "Tag") + "</span></button>";
    }).join("");
    html += '<button type="button" data-tab="__mehr"><span class="amkz-tab-ico">☰</span><span>Mehr</span></button>';

    if (leiste.dataset.stand !== html) { leiste.innerHTML = html; leiste.dataset.stand = html; }
    aktiv();
    zahlen();
  }

  function aktiv() {
    var v = (AMKZ.state && AMKZ.state.currentView) || "dashboard";
    [].slice.call(document.querySelectorAll("#amkzTabbar button")).forEach(function (b) {
      b.classList.toggle("active", b.dataset.tab === v);
    });
  }

  // Ungelesene Anfragen auch unten zeigen.
  function zahlen() {
    var quelle = document.querySelector('.amkz-nav-item[data-view="support"] .amkz-nav-badge');
    var ziel = document.querySelector('#amkzTabbar button[data-tab="support"] .amkz-tab-zahl');
    if (!ziel) return;
    var n = quelle && quelle.style.display !== "none" ? quelle.textContent : "";
    ziel.textContent = n;
    ziel.classList.toggle("hat", !!n);
  }

  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("#amkzTabbar button");
    if (!b) return;
    e.preventDefault();
    if (b.dataset.tab === "__mehr") {
      document.body.classList.add("amkz-mobile-menu-open");
      return;
    }
    var ziel = document.querySelector('.amkz-nav-item[data-view="' + b.dataset.tab + '"]');
    if (ziel) ziel.click();
    setTimeout(aktiv, 60);
  });

  function start() {
    stil();
    bauen();
    var n = 0;
    var takt = setInterval(function () { bauen(); if (++n > 30) clearInterval(takt); }, 800);
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest(".amkz-nav-item")) setTimeout(aktiv, 80);
    }, true);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  AMKZ.tableiste = { bauen: bauen };
})();

/* ============================================================================
   HANDY — SCHUBLADE  (11.09.2026)
   ---------------------------------------------------------------------------
   Rueckmeldung aus dem Team: „Das Menue faehrt hinter der Webseite aus, auf dem
   Handy geht nichts." Die Ursache steckte im Hintergrund-Modul (Inline-z-index,
   dort behoben). Hier kommt dazu, was eine Schublade auf dem Handy braucht:
   ein Schliessen-Knopf ganz oben (nur am Handy sichtbar), Escape schliesst,
   beim Oeffnen steht die Liste oben, und der Reiter „Mehr" unten zeigt als
   rote Zahl, was in den versteckten Bereichen wartet (Verlosung, Anfragen …).
============================================================================ */
(function () {
  "use strict";
  var AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__schublade) return;
  AMKZ.__schublade = true;

  function zu() { document.body.classList.remove("amkz-mobile-menu-open"); }

  function knopf() {
    var sb = document.querySelector(".amkz-sidebar");
    if (!sb || document.getElementById("amkzSchubladeZu")) return;
    var b = document.createElement("button");
    b.type = "button"; b.id = "amkzSchubladeZu"; b.className = "amkz-schublade-zu";
    b.setAttribute("aria-label", "Menü schließen");
    b.innerHTML = "<span>Alle Bereiche</span><i aria-hidden=\"true\">✕</i>";
    b.addEventListener("click", zu);
    sb.insertBefore(b, sb.firstChild);
  }

  document.addEventListener("keydown", function (e) { if (e.key === "Escape") zu(); });

  // Beim Oeffnen nach oben, damit der Schliessen-Knopf und die ersten Punkte da sind.
  var mo = new MutationObserver(function () {
    if (!document.body.classList.contains("amkz-mobile-menu-open")) return;
    var sb = document.querySelector(".amkz-sidebar"); if (sb) sb.scrollTop = 0;
  });
  mo.observe(document.body, { attributes: true, attributeFilter: ["class"] });

  // „Mehr": Summe aller Zaehler, die unten nicht als eigener Reiter stehen.
  function mehrZahl() {
    var leiste = document.getElementById("amkzTabbar"); if (!leiste) return;
    var unten = {};
    leiste.querySelectorAll("button[data-tab]").forEach(function (b) { unten[b.dataset.tab] = true; });
    var n = 0;
    document.querySelectorAll(".amkz-nav-item").forEach(function (item) {
      if (unten[item.dataset.view] || item.style.display === "none") return;
      var b = item.querySelector(".amkz-nav-badge");
      if (b && b.style.display !== "none" && b.textContent.trim()) n += parseInt(b.textContent, 10) || 1;
    });
    var mehr = leiste.querySelector('button[data-tab="__mehr"]'); if (!mehr) return;
    var z = mehr.querySelector(".amkz-tab-zahl");
    if (!z) { z = document.createElement("span"); z.className = "amkz-tab-zahl"; mehr.insertBefore(z, mehr.lastChild); }
    z.textContent = n > 9 ? "9+" : String(n);
    z.classList.toggle("hat", n > 0);
  }
  setInterval(mehrZahl, 2500);

  function start() { knopf(); mehrZahl(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  AMKZ.schublade = { zu: zu, mehrZahl: mehrZahl };
})();

/* ============================================================================
   MITTEILUNGEN — EINE STELLE FÜR ALLES  (11.09.2026)
   ---------------------------------------------------------------------------
   Befund aus dem Team: „bei nichts mehr Benachrichtigungen". Die Ursachen:
   viele Ereignisse schrieben nur eine Zeile in `notifications` (ReDepo aus
   der Datenbank, Kalender, Team, Urlaub) und schickten nie einen Push; die
   Zeile sah man nur, wenn die Zentrale gerade offen war. Abos wurden seit
   Wochen nicht erneuert, und niemand konnte sehen, ob Push auf dem eigenen
   Gerät überhaupt läuft.

   Hier ist die eine Stelle:
     AMKZ.melden({ an, typ, titel, text, url, payload })
       schreibt die Zeile(n) in notifications UND schickt den Push — mit dem
       Marker payload.push = "false", damit der Datenbank-Auslöser
       (supabase-mitteilungen.sql, pusht alles Übrige) nicht doppelt schickt.
     Glocke in der Kopfzeile: Posteingang (letzte 40 Meldungen, ungelesen
       hervorgehoben, Tipp öffnet den passenden Bereich), Push-Status für
       dieses Gerät mit „Aktivieren" und „Test-Push an mich" (zeigt, wie viele
       Geräte gefunden und beliefert wurden — die Diagnose, die bisher fehlte),
       „Alle gelesen".
   Zähler an der Glocke: alle ungelesenen Meldungen; wird alle 45 s und bei
   jeder Realtime-Meldung erneuert.
============================================================================ */
(function () {
  "use strict";
  var AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__mitteilungen) return;
  AMKZ.__mitteilungen = true;

  var byId = function (id) { return document.getElementById(id); };
  var esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || function (v) { return String(v == null ? "" : v).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[c]; }); };
  var toast = function (t, m, ty) { (AMKZ.toast || console.log)(t, m || "", ty || "success"); };
  var meinId = function () { return (AMKZ.state && AMKZ.state.member && AMKZ.state.member.id) || null; };
  var sb = function () { return AMKZ.supabase && AMKZ.supabase.from ? AMKZ.supabase : null; };
  var wurzel = function () { return byId("amkzApp"); };

  /* ---------- Empfaenger aufloesen ---------- */
  var ROLLEN_CHEF = ["owner", "admin", "admin_owner", "ceo", "management", "manager", "geschaeftsfuehrung", "leitung"];
  async function team() {
    var s = sb(); if (!s) return [];
    try { var r = await s.from("team_members").select(await AMKZ.spalten("team_members")); return (r.data || []).filter(function (m) { return m.is_approved !== false && m.is_active !== false && String(m.role || "").toLowerCase() !== "bot"; }); } catch (_) { return []; }
  }
  function istChef(m) { return ROLLEN_CHEF.indexOf(String(m.role || "").toLowerCase()) >= 0 || m.can_manage_team === true; }
  /* an: Array von IDs | eine ID | "alle" | "admins" | "finanzen" | "giveaway" | "entries" | "support" | "streaming" */
  async function empfaenger(an) {
    if (Array.isArray(an)) return an.filter(Boolean);
    if (typeof an === "string" && /^[0-9a-f-]{20,}$/i.test(an)) return [an];
    var alle = await team();
    var filter = {
      alle: function () { return true; },
      admins: istChef,
      finanzen: function (m) { return istChef(m) || m.can_view_finance === true; },
      giveaway: function (m) { return istChef(m) || m.can_view_giveaway === true || m.can_view_finance === true; },
      entries: function (m) { return istChef(m) || m.can_view_entries === true; },
      support: function (m) { return istChef(m) || m.can_view_support === true || m.can_support_de === true || m.can_support_cz === true; },
      streaming: function (m) { return istChef(m) || m.can_view_streaming === true || m.can_manage_streaming === true; },
    }[String(an || "alle")] || function () { return true; };
    return alle.filter(filter).map(function (m) { return m.id; }).filter(Boolean);
  }

  /* ---------- Push ---------- */
  async function push(userId, titel, text, extra) {
    var root = wurzel(); var url = (root && root.dataset.supabaseUrl || "").replace(/\/$/, ""); var anon = root && root.dataset.supabaseKey || "";
    if (!url || !anon || !userId) return null;
    try {
      var r = await fetch(url + "/functions/v1/send-push", { method: "POST", headers: { "Content-Type": "application/json", Authorization: "Bearer " + anon, apikey: anon },
        body: JSON.stringify(Object.assign({ user_id: userId, title: titel || "AMK Zentrale", body: text || "", url: "/pages/zentrale" }, extra || {})) });
      return await r.json().catch(function () { return { ok: r.ok }; });
    } catch (e) { return { ok: false, error: String(e && e.message || e) }; }
  }

  /* ---------- Die eine Melde-Funktion ---------- */
  async function melden(o) {
    o = o || {};
    var s = sb(); if (!s) return 0;
    var ids = await empfaenger(o.an);
    var ich = meinId();
    if (o.auchMich !== true) ids = ids.filter(function (id) { return id !== ich; });
    ids = ids.filter(function (id, i, a) { return a.indexOf(id) === i; });
    if (!ids.length) return 0;
    var jetzt = new Date().toISOString();
    var payload = Object.assign({}, o.payload || {}, { url: o.url || (o.payload && o.payload.url) || "/pages/zentrale", push: "false" });
    if (ich && !payload.from && o.vonMir !== false) payload.from = ich;
    var zeilen = ids.map(function (id) { return { target_user_id: id, created_for: id, type: o.typ || "info", title: o.titel || "AMK Zentrale", message: o.text || "", is_read: false, created_at: jetzt, payload: payload }; });
    try { var r = await s.from("notifications").insert(zeilen); if (r.error) { zeilen.forEach(function (z) { delete z.created_for; }); await s.from("notifications").insert(zeilen); } } catch (_) {}
    var extra = { url: payload.url, tag: o.typ || "amk", type: o.typ || "msg" };
    if (payload.from) extra.from = payload.from;
    await Promise.all(ids.map(function (id) { return push(id, o.titel, o.text, extra); }));
    return ids.length;
  }

  /* ---------- Glocke + Posteingang ---------- */
  /* Wohin ein Tipp auf die Meldung fuehrt — immer direkt zur Sache, nicht nur in den Bereich:
     ReDepo -> Entries + Nachfrage-Dialog mit allen Spielerdaten vorbelegt (nur noch bestaetigen),
     Chat/Anruf -> das Gespraech mit dem Absender, Verlosung -> die Akte des Gewinners. */
  function absender(n) { var p = n.payload || {}; return p.sender_id || p.from || null; }
  var ZIEL = {
    verlosung: function (n) { if (AMKZ.verlosung && AMKZ.verlosung.akte && n.payload && n.payload.email) AMKZ.verlosung.akte(n.payload.email); else oeffne("verlosung"); },
    chat: function (n) { var von = absender(n); if (von && window.AMK_OPEN_CHAT) window.AMK_OPEN_CHAT(von); else oeffne("connect"); },
    call: function (n) { var von = absender(n); if (von && window.AMK_OPEN_CHAT) window.AMK_OPEN_CHAT(von); else oeffne("connect"); },
    calendar: function () { oeffne("calendar"); },
    redepo: function (n) {
      var rid = n.payload && (n.payload.reminder_id || n.payload.reminderId);
      oeffne("entries");
      if (rid && AMKZ.redepo && AMKZ.redepo.oeffne) setTimeout(function () { AMKZ.redepo.oeffne(rid); }, 450);
    },
    support: function () { oeffne("support"); },
    mail: function (n) { if (AMKZ.postfach) AMKZ.postfach.oeffnen(n.payload && n.payload.faden_id); else oeffne("postfach"); },
    topup: function (n) { var von = absender(n); if (von && window.AMK_OPEN_CHAT) window.AMK_OPEN_CHAT(von); else oeffne("streaming"); },
    team: function (n) { var von = absender(n); if (von && window.AMK_OPEN_CHAT) window.AMK_OPEN_CHAT(von); else oeffne("team"); },
    crm_note: function () { oeffne("entries"); },
    test: function () {},
    tagesplan: function () { if (AMKZ.tagesplan) AMKZ.tagesplan.oeffnen(); else oeffne("tagesplan"); },
  };
  function oeffne(view) { var b = document.querySelector('.amkz-nav-item[data-view="' + view + '"]'); if (b && b.style.display !== "none") b.click(); else toast("Mitteilungen", "Dieser Bereich ist für dich nicht freigegeben.", "error"); }

  var S = { offen: false, liste: [], ungelesen: 0, laeuft: false };

  function zeit(v) { var d = new Date(v); if (isNaN(d)) return ""; var diff = (Date.now() - d) / 60000; if (diff < 1) return "gerade eben"; if (diff < 60) return Math.round(diff) + " min"; if (diff < 36 * 60) { var hm = d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" }); var tage = Math.round((new Date().setHours(0, 0, 0, 0) - new Date(d).setHours(0, 0, 0, 0)) / 864e5); return tage === 0 ? hm : (tage === 1 ? "gestern " : "vorgestern ") + hm; } return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" }); }
  /* Nachtschicht 31.10.: Symbol steht schon links → Emoji vorn im Titel weg; „51.16 EUR“ → „51,16 €“ */
  function mtTitel(t) { return String(t || "").replace(/^\s*(?:\p{Extended_Pictographic}\uFE0F?\s*)+/u, ""); }
  function mtBetrag(t) { return String(t).replace(/(\d+(?:\.\d{1,2})?)\s?EUR\b/g, function (_, z) { return Number(z).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €"; }); }
  var SYMBOL = { tagesplan: "🗓️", verlosung: "🏆", chat: "💬", call: "📞", calendar: "📅", redepo: "💶", support: "🎧", mail: "✉️", topup: "🎬", team: "👥", crm_note: "📝", info: "ℹ️" };

  function knopf() {
    if (byId("amkzGlocke")) return;
    var actions = document.querySelector(".amkz-topbar-actions"); if (!actions) return;
    var b = document.createElement("button");
    b.type = "button"; b.id = "amkzGlocke"; b.className = "amkz-secondary-btn amkz-glocke"; b.title = "Mitteilungen";
    b.setAttribute("aria-label", "Mitteilungen");
    b.innerHTML = '<span class="amkz-glocke-ico" aria-hidden="true">🔔</span><span class="amkz-glocke-zahl" hidden></span>';
    var push = byId("amkzEnablePushButton");
    if (push && push.parentElement === actions) actions.insertBefore(b, push); else actions.insertBefore(b, actions.firstChild);
    b.addEventListener("click", function () { S.offen ? schliessen() : oeffnen(); });
  }
  function fenster() {
    var f = byId("amkzMitteilungen"); if (f) return f;
    f = document.createElement("div"); f.id = "amkzMitteilungen"; f.className = "amkz-mitteilungen"; f.hidden = true;
    f.innerHTML = '<div class="amkz-mt-kopf"><b>🔔 Mitteilungen</b><span id="amkzMtStand"></span><button type="button" class="amkz-mt-x" id="amkzMtZu" aria-label="Schließen">✕</button></div>' +
      '<div class="amkz-mt-push" id="amkzMtPush"></div>' +
      '<div class="amkz-mt-werkzeug"><button type="button" class="amkz-secondary-btn amkz-mt-mini" id="amkzMtAlle">Alle gelesen</button><button type="button" class="amkz-secondary-btn amkz-mt-mini" id="amkzMtNeu">↻</button></div>' +
      '<div class="amkz-mt-liste" id="amkzMtListe"><div class="amkz-empty">Lädt …</div></div>';
    document.body.appendChild(f);
    byId("amkzMtZu").addEventListener("click", schliessen);
    byId("amkzMtAlle").addEventListener("click", alleGelesen);
    byId("amkzMtNeu").addEventListener("click", function () { laden(true); });
    f.addEventListener("click", async function (e) {
      var akt = e.target.closest("[data-mt-aktion]");
      if (akt) { e.preventDefault(); await aktion(akt.getAttribute("data-mt-aktion")); return; }
      var z = e.target.closest("[data-mt-id]"); if (!z) return;
      var n = S.liste.filter(function (x) { return String(x.id) === z.getAttribute("data-mt-id"); })[0]; if (!n) return;
      if (!n.is_read) { n.is_read = true; try { await sb().from("notifications").update({ is_read: true }).eq("id", n.id); } catch (_) {} zaehlen(); zeichneListe(); }
      schliessen();
      (ZIEL[n.type] || function () { oeffne("dashboard"); })(n);
    });
    document.addEventListener("click", function (e) { if (S.offen && !e.target.closest("#amkzMitteilungen") && !e.target.closest("#amkzGlocke")) schliessen(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && S.offen) schliessen(); });
    return f;
  }
  function oeffnen() { var f = fenster(); f.hidden = false; S.offen = true; document.body.classList.add("amkz-mitteilungen-offen"); laden(true); pushStatus(); }
  function schliessen() { var f = byId("amkzMitteilungen"); if (f) f.hidden = true; S.offen = false; document.body.classList.remove("amkz-mitteilungen-offen"); }

  async function laden(anzeigen) {
    var s = sb(), me = meinId(); if (!s || !me || S.laeuft) return;
    S.laeuft = true;
    try {
      var r = await s.from("notifications").select("id, type, title, message, is_read, created_at, payload").eq("target_user_id", me).order("created_at", { ascending: false }).limit(40);
      if (!r.error) S.liste = r.data || [];
    } catch (_) {}
    S.laeuft = false;
    zaehlen();
    if (anzeigen || S.offen) zeichneListe();
  }
  async function zaehlen() {
    var s = sb(), me = meinId(); if (!s || !me) return;
    try {
      var r = await s.from("notifications").select("id", { count: "exact", head: true }).eq("target_user_id", me).eq("is_read", false);
      if (!r.error) S.ungelesen = Number(r.count) || 0;
    } catch (_) {}
    var z = document.querySelector("#amkzGlocke .amkz-glocke-zahl"); if (!z) return;
    z.textContent = S.ungelesen > 99 ? "99+" : String(S.ungelesen); z.hidden = !S.ungelesen;
    var g = byId("amkzGlocke"); if (g) g.classList.toggle("hat", S.ungelesen > 0);
    var st = byId("amkzMtStand"); if (st) st.textContent = S.ungelesen ? S.ungelesen + " ungelesen" : "alles gelesen";
    try { if (navigator.setAppBadge) { S.ungelesen ? navigator.setAppBadge(S.ungelesen) : navigator.clearAppBadge && navigator.clearAppBadge(); } } catch (_) {}
  }
  function zeichneListe() {
    var box = byId("amkzMtListe"); if (!box) return;
    if (!S.liste.length) { box.innerHTML = '<div class="amkz-empty">Noch keine Mitteilungen.</div>'; return; }
    box.innerHTML = S.liste.map(function (n) {
      return '<button type="button" class="amkz-mt-zeile' + (n.is_read ? "" : " neu") + '" data-mt-id="' + esc(n.id) + '"><span class="amkz-mt-sym">' + (SYMBOL[n.type] || "🔔") + '</span><span class="amkz-mt-text"><b>' + esc(mtTitel(n.title) || "Mitteilung") + "</b><small>" + esc(mtBetrag(n.message || "")) + '</small></span><span class="amkz-mt-zeit">' + esc(zeit(n.created_at)) + "</span></button>";
    }).join("");
  }
  async function alleGelesen() {
    var s = sb(), me = meinId(); if (!s || !me) return;
    try { await s.from("notifications").update({ is_read: true }).eq("target_user_id", me).eq("is_read", false); } catch (_) {}
    S.liste.forEach(function (n) { n.is_read = true; }); zaehlen(); zeichneListe();
    if (AMKZ.verlosung && AMKZ.verlosung.badge) AMKZ.verlosung.badge();
    if (window.AMKZ_WARTET && window.AMKZ_WARTET.laden) { try { window.AMKZ_WARTET.laden(); } catch (_) {} }
  }

  /* ---------- Push-Status dieses Geraets ---------- */
  async function pushStatus() {
    var box = byId("amkzMtPush"); if (!box) return;
    var isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    var standalone = window.navigator.standalone === true || (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches);
    var kann = "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
    var erlaubnis = kann && window.Notification ? Notification.permission : "n/a";
    var abo = null;
    try { if (kann) { var reg = window.AMK_SW_REG || (window.AMK_SW_PATH && await navigator.serviceWorker.getRegistration(window.AMK_SW_PATH.scope)); abo = reg ? await reg.pushManager.getSubscription() : null; } } catch (_) {}
    var inDb = null, geraete = 0;
    try { var s = sb(), me = meinId(); if (s && me) { var r = await s.from("push_subscriptions").select("endpoint, updated_at").eq("user_id", me); if (!r.error) { geraete = (r.data || []).length; inDb = !!abo && (r.data || []).some(function (x) { return x.endpoint === abo.endpoint; }); } } } catch (_) {}
    var zustand, klasse;
    if (!kann) { zustand = "Dieses Gerät/Browser kann keine Web-Push-Mitteilungen."; klasse = "aus"; }
    else if (isIOS && !standalone) { zustand = "iPhone: erst „Zum Home-Bildschirm“ hinzufügen und die Zentrale von dort öffnen — nur so gibt es Push."; klasse = "aus"; }
    else if (erlaubnis === "denied") { zustand = "Mitteilungen sind für diese Seite blockiert. In den Browser-Einstellungen erlauben, dann „Aktivieren“."; klasse = "aus"; }
    else if (abo && inDb) { zustand = "Push auf diesem Gerät aktiv ✓ · " + geraete + " Gerät" + (geraete === 1 ? "" : "e") + " gespeichert."; klasse = "an"; }
    else if (abo && inDb === false) { zustand = "Dieses Gerät hat ein Abo, das nicht (mehr) in der Datenbank steht — bitte „Aktivieren“."; klasse = "halb"; }
    else { zustand = "Push auf diesem Gerät noch nicht aktiviert." + (geraete ? " (" + geraete + " andere Geräte gespeichert)" : ""); klasse = "halb"; }
    box.innerHTML = '<div class="amkz-mt-pushzeile ' + klasse + '"><span class="amkz-mt-pushpunkt"></span><span>' + esc(zustand) + "</span></div>" +
      '<div class="amkz-mt-pushknoepfe"><button type="button" class="amkz-primary-btn amkz-mt-mini" data-mt-aktion="aktivieren">' + (klasse === "an" ? "Neu verbinden" : "Aktivieren") + '</button><button type="button" class="amkz-secondary-btn amkz-mt-mini" data-mt-aktion="test">Test-Push an mich</button></div><div class="amkz-mt-pushergebnis" id="amkzMtPushErgebnis"></div>';
  }
  async function aktion(was) {
    if (was === "aktivieren") { var b = byId("amkzEnablePushButton"); if (b) { b.click(); setTimeout(pushStatus, 4000); setTimeout(pushStatus, 9000); } return; }
    if (was === "test") {
      var out = byId("amkzMtPushErgebnis"); if (out) out.textContent = "Schicke Test-Push…";
      var r = await push(meinId(), "🔔 Test-Push", "Wenn du das siehst, kommen Mitteilungen auf diesem Gerät an.", { tag: "test", type: "test" });
      if (!out) return;
      if (!r) out.textContent = "Keine Verbindung zur Function.";
      else if (r.ok === false) out.textContent = "Fehler: " + (r.error || "unbekannt");
      else out.textContent = (r.subsFound ? r.subsFound : 0) + " Gerät(e) gefunden · " + (r.sent || 0) + " beliefert" + (r.removed ? " · " + r.removed + " abgelaufene Abos entfernt" : "") + (r.results && r.results.some(function (x) { return x.status === "error"; }) ? " · Fehler: " + r.results.filter(function (x) { return x.status === "error"; }).map(function (x) { return x.host + " " + (x.code || "") + " " + (x.msg || ""); }).join("; ").slice(0, 200) : "") + (r.subsFound === 0 ? " → erst „Aktivieren“ drücken." : "");
    }
  }

  /* ---------- Stil ---------- */
  (function stil() {
    if (byId("amkzMtStil")) return;
    var s = document.createElement("style"); s.id = "amkzMtStil";
    s.textContent = [
      ".amkz-glocke{position:relative !important;width:38px !important;min-width:38px !important;padding:0 !important;display:inline-grid !important;place-items:center;font-size:16px !important;overflow:visible !important}",
      "html body .amkz-topbar #amkzGlocke{overflow:visible !important}",
      ".amkz-glocke .amkz-glocke-zahl{position:absolute;top:-7px;right:-9px;min-width:20px;height:20px;padding:0 5px;border-radius:10px;background:var(--amk-neg,#e8695f);color:#fff;font-size:10px;font-weight:800;display:grid;place-items:center;line-height:1;box-shadow:0 0 0 2px var(--amk-bg-2,#0a1230);z-index:2;white-space:nowrap}",
      ".amkz-glocke .amkz-glocke-zahl[hidden]{display:none !important}",
      ".amkz-glocke.hat .amkz-glocke-ico{animation:amkzGlockeWackel 1.2s ease-in-out 1}",
      "@keyframes amkzGlockeWackel{0%,100%{transform:rotate(0)}20%{transform:rotate(14deg)}40%{transform:rotate(-12deg)}60%{transform:rotate(8deg)}80%{transform:rotate(-4deg)}}",
      "#amkzEnablePushButton{display:none !important}",   /* Aktivieren steckt jetzt im Glocken-Fenster */
      ".amkz-mitteilungen{position:fixed;top:64px;right:16px;width:min(440px,calc(100vw - 24px));max-height:min(80vh,760px);z-index:999997;display:flex;flex-direction:column;border-radius:20px;border:1px solid var(--amk-line);background:var(--amk-bg-2,#0a1230);box-shadow:0 30px 80px -24px rgba(0,0,0,.85),0 0 0 1px rgba(255,255,255,.04) inset;overflow:hidden;color:var(--amk-text)}",
      "html.amkz-hell .amkz-mitteilungen{background:#ffffff;box-shadow:0 30px 80px -30px rgba(16,24,40,.35)}",
      ".amkz-mitteilungen[hidden]{display:none}",
      ".amkz-mt-kopf{display:flex;align-items:center;gap:10px;padding:14px 16px;border-bottom:1px solid var(--amk-line);background:var(--amk-bg-1,#060b1f)}.amkz-mt-kopf b{font-size:1rem}.amkz-mt-kopf span{margin-left:auto;font-size:.76rem;opacity:.65;white-space:nowrap}",
      ".amkz-mt-x{border:0;background:transparent;color:inherit;font-size:1.1rem;cursor:pointer;width:34px;height:34px;border-radius:10px}.amkz-mt-x:hover{background:var(--amk-surface-2,rgba(255,255,255,.06))}",
      ".amkz-mt-push{margin:10px 12px 0;padding:10px 12px;border:1px solid var(--amk-line);border-radius:14px;background:var(--amk-bg-1,#060b1f);display:grid;gap:8px;font-size:.8rem}",
      ".amkz-mt-pushzeile{display:flex;gap:10px;align-items:flex-start;line-height:1.4}.amkz-mt-pushpunkt{flex:none;width:10px;height:10px;border-radius:50%;margin-top:5px;background:var(--amk-muted)}.amkz-mt-pushzeile.an .amkz-mt-pushpunkt{background:var(--amk-pos,#3ddc97);box-shadow:0 0 10px var(--amk-pos,#3ddc97)}.amkz-mt-pushzeile.halb .amkz-mt-pushpunkt{background:var(--amk-pend,#f5b84a)}.amkz-mt-pushzeile.aus .amkz-mt-pushpunkt{background:var(--amk-neg,#e8695f)}",
      ".amkz-mt-pushknoepfe{display:flex;gap:8px;flex-wrap:wrap}.amkz-mt-pushergebnis{font-size:.76rem;opacity:.8;min-height:0}",
      ".amkz-mt-mini{min-height:34px !important;padding:6px 12px !important;font-size:.78rem !important;height:auto !important;border-radius:999px !important}",
      ".amkz-mt-werkzeug{display:flex;gap:8px;align-items:center;padding:10px 12px 6px}.amkz-mt-werkzeug #amkzMtNeu{width:36px;padding:0 !important;margin-left:auto}",
      ".amkz-mt-liste{overflow-y:auto;-webkit-overflow-scrolling:touch;padding:4px 8px 10px;display:grid;gap:2px;align-content:start}",
      ".amkz-mt-zeile{display:grid;grid-template-columns:34px 1fr auto;gap:10px;align-items:start;width:100%;text-align:left;padding:10px 10px;border:1px solid transparent;border-radius:14px;background:transparent;color:inherit;font:inherit;cursor:pointer;transition:background .14s,border-color .14s}.amkz-mt-zeile:hover{background:var(--amk-bg-1,#060b1f);border-color:var(--amk-line)}",
      ".amkz-mt-zeile.neu{background:var(--amk-bg-1,#060b1f);border-color:var(--amk-line)}.amkz-mt-zeile.neu b::after{content:'';display:inline-block;width:7px;height:7px;border-radius:50%;background:var(--amk-neg,#e8695f);margin-left:7px;vertical-align:middle}",
      ".amkz-mt-sym{width:34px;height:34px;border-radius:11px;display:grid;place-items:center;background:var(--amk-surface-2,rgba(255,255,255,.06));font-size:16px}",
      ".amkz-mt-text{min-width:0}.amkz-mt-text b{display:block;font-size:.86rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.amkz-mt-text small{display:block;font-size:.76rem;opacity:.7;line-height:1.35;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}",
      ".amkz-mt-zeit{font-size:.7rem;opacity:.55;white-space:nowrap;padding-top:2px}",
      "@media (max-width:780px){.amkz-mitteilungen{top:auto;bottom:calc(72px + env(safe-area-inset-bottom));right:8px;left:8px;width:auto;max-height:72vh;border-radius:20px}body:not(:has(#amkzTabbar)) .amkz-mitteilungen{bottom:8px}}",
    ].join("\n");
    document.head.appendChild(s);
  })();

  /* ---------- Start ---------- */
  function start() {
    knopf();
    var n = 0, t = setInterval(function () { knopf(); if (meinId()) { clearInterval(t); laden(false); } else if (++n > 240) clearInterval(t); }, 500);
    setInterval(function () { if (!document.hidden && meinId()) laden(false); }, 45000);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();

  AMKZ.melden = melden;
  AMKZ.mitteilungen = { laden: laden, oeffnen: oeffnen, schliessen: schliessen, zaehlen: zaehlen, push: push, empfaenger: empfaenger };
})();

/* ============================================================================
   HANDY — KOPFLEISTE NEU GEORDNET  (11.09.2026)
   ---------------------------------------------------------------------------
   Marcels Screenshot: die sieben Bedienelemente liefen als Bandwurm durch
   zwei Zeilen, ein Datumsfeld hing am Ende der ersten, das zweite füllte
   allein die zweite. Hier bekommt die Leiste am Handy zwei feste Zeilen:
     Zeile 1  Titel links · rechts die runden Knöpfe (REC, Fassung, Glocke,
              Aktualisieren)
     Zeile 2  Zeitraum: [von] → [bis] [Heute]  — gleich breit, eine Zeile
   Die Elemente werden nur umgehängt (gleiche IDs, gleiche Logik), keine
   zweite Wahrheit. Am Desktop (> 780 px) bleibt alles, wie es war.
============================================================================ */
(function () {
  "use strict";
  var AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__kopfleiste) return;
  AMKZ.__kopfleiste = true;

  var mq = window.matchMedia("(max-width:780px)");
  var byId = function (id) { return document.getElementById(id); };

  function ordnen() {
    var actions = document.querySelector(".amkz-topbar-actions"); if (!actions) return;
    var topbar = actions.closest(".amkz-topbar"); if (!topbar) return;
    if (!mq.matches) { zurueck(actions, topbar); return; }
    if (actions.dataset.handy === "1") { nachziehen(); return; }
    var chips = document.createElement("div"); chips.className = "amkz-tb-chips"; chips.id = "amkzTbChips";
    var zeit = document.createElement("div"); zeit.className = "amkz-tb-zeitraum"; zeit.id = "amkzTbZeitraum";
    actions.dataset.handy = "1";
    actions.appendChild(chips); actions.appendChild(zeit);
    // Titelzeile: Titel links, Chips rechts daneben
    var title = topbar.querySelector(".amkz-topbar-title");
    if (title) { var kopf = document.createElement("div"); kopf.className = "amkz-tb-kopfzeile"; kopf.id = "amkzTbKopf"; topbar.insertBefore(kopf, title); kopf.appendChild(title); kopf.appendChild(chips); }
    nachziehen();
  }
  // Elemente werden von anderen Modulen teils spaeter erzeugt (REC-Knopf, Fassung, Glocke) -> immer wieder einsammeln.
  function nachziehen() {
    var chips = byId("amkzTbChips"), zeit = byId("amkzTbZeitraum"); if (!chips || !zeit) return;
    var pfeil = byId("amkzApplyDateRangeFinal");
    // Der Zeitraum (ensureDateRange) haengt sich VOR den Aktualisieren-Knopf ein und erwartet ihn in
    // .amkz-topbar-actions — deshalb wandert der Knopf erst, wenn die Datumsfelder da sind.
    var reihe = { chips: ["amkzRecTopBtn", "amkzDesignSchalter", "amkzGlocke", "amkzEnablePushButton"].concat(byId("amkzDateFromFinal") ? ["amkzRefreshButton"] : []), zeit: ["amkzDateFromFinal", "amkzApplyDateRangeFinal", "amkzDateToFinal", "amkzTodayBtnFinal"] };
    reihe.chips.forEach(function (id) { var el = byId(id); if (el && el.parentElement !== chips) chips.appendChild(el); });
    reihe.zeit.forEach(function (id) { var el = byId(id); if (el && el.parentElement !== zeit) zeit.appendChild(el); });
    if (pfeil && !pfeil.dataset.tbPfeil) { pfeil.dataset.tbPfeil = "1"; pfeil.title = "Zeitraum laden"; }
  }
  function zurueck(actions, topbar) {
    if (actions.dataset.handy !== "1") return;
    var chips = byId("amkzTbChips"), zeit = byId("amkzTbZeitraum"), kopf = byId("amkzTbKopf");
    var range = actions.querySelector(".amkz-final-date-range");
    ["amkzRecTopBtn", "amkzDesignSchalter", "amkzGlocke", "amkzEnablePushButton"].forEach(function (id) { var el = byId(id); if (el) actions.appendChild(el); });
    if (range) { ["amkzDateFromFinal", "amkzDateToFinal", "amkzTodayBtnFinal", "amkzApplyDateRangeFinal"].forEach(function (id) { var el = byId(id); if (el) range.appendChild(el); }); }
    var refresh = byId("amkzRefreshButton"); if (refresh) actions.appendChild(refresh);
    if (kopf) { var title = kopf.querySelector(".amkz-topbar-title"); if (title) topbar.insertBefore(title, kopf); kopf.remove(); }
    if (chips) chips.remove(); if (zeit) zeit.remove();
    delete actions.dataset.handy;
  }

  function start() { ordnen(); setInterval(ordnen, 1500); }
  (mq.addEventListener ? mq.addEventListener("change", ordnen) : mq.addListener(ordnen));
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  AMKZ.kopfleiste = { ordnen: ordnen };
})();

/* ============================================================================
   VORFÜHR-MODUS  ·  Aufruf mit  ?vorschau  am Ende der Adresse
   ---------------------------------------------------------------------------
   Zum Ansehen und Beurteilen des Designs braucht man Daten. Ohne Anmeldung
   steht aber nur ein leeres Gerüst da — deshalb hiess es zu Recht "die
   Funktionen sind nicht da zum Testen".

   Dieser Modus füllt die Zentrale mit erfundenen, aber realistischen Daten
   und macht ALLE Bereiche zugänglich. Er ändert nichts an der Datenbank:
   jeder Zugriff nach draussen wird abgefangen und beantwortet.

   Sicherungen, damit das nie im Betrieb angeht:
     · nur wenn ?vorschau in der Adresse steht
     · nur auf localhost oder einer .test-Adresse
     · ein dauerhaftes Band oben zeigt, dass nichts davon echt ist
============================================================================ */
(function () {
  "use strict";
  var an = /[?&]vorschau/.test(location.search);
  var lokal = /^(localhost|127\.0\.0\.1|\[::1\])$/.test(location.hostname) || /\.test$/.test(location.hostname);
  if (!an || !lokal) return;

  var AMKZ = window.AMKZ;
  if (!AMKZ) return;

  /* Verlosung in der Vorschau: nachgestellte Antworten der Edge Function
     (Ziehung, Gewinner, Akten, Flughaefen) — damit der Bereich am Handy und am
     Desktop mit Daten geprueft werden kann. */
  var VL_DEMO = (function () {
    var jetzt = Date.now(), min = 60000;
    var std = function () { return (window.AMKZ_FLUGHAEFEN && window.AMKZ_FLUGHAEFEN.standard) || []; };
    var cfg = { id: 1, title: "300.000 € Giveaway · Live-Ziehung", rule: "nicht_gesperrt", one_per_person: true, is_live: true, show_email: true, test_mode: false,
      prizes: [{ key: "platz1", label: "Hauptpreis 10.000 € + Privatjet", count: 1 }, { key: "platz2", label: "Hauptpreis 7.500 € + Privatjet", count: 1 }, { key: "platz3", label: "Hauptpreis 5.000 € + Privatjet", count: 1 }, { key: "boeing", label: "Boeing-Platz · Albanien-Reise", count: 147 }],
      embed_key: "vorschau00000000000000000000000", embed_url: "https://nouri-amk.com/pages/verlosung-live", portal_url: "https://nouri-amk.com/pages/gewinner", airports: null, hinflug_datum: "Fr 25.09.", rueckflug_datum: "So 27.09." };
    // [E-Mail, Nick, Vorname, Nachname, PLZ, Ort, Land, Flughafen, Name, Quelle, Status, Ausweis, Unterlagen]
    var leute = [
      ["meier.tatjana1994@gmail.com", "Meier", "Tatjana", "Meier", "50667", "Köln", "Deutschland", "DTM", "Dortmund", "plz", "abgewickelt", true, 0, "DTM · 08:55 → 11:15 Wizz Air", "CGN · 12:20 → 14:55 Wizz Air", "w", "Lindenweg 8"],
      ["kevin.schulz98@web.de", "Kevin_98", "Kevin", "Schulz", "80331", "München", "Deutschland", "MUC", "München", "gps", "daten_da", false, 0, "MUC · 09:15 → 11:00 Lufthansa", "MUC · 06:00 → 07:50 Lufthansa", "m", "Sonnenallee 4"],
      ["lara.x@gmail.com", "LaraX", "Lara", "Xander", "10115", "Berlin", "Deutschland", "BER", "Berlin", "plz", "abgewickelt", true, 2, "BER · 08:45 → 11:00 Wizz Air", "BER · 09:10 → 11:30 Wizz Air", "w", "Torstraße 140"],
      ["deniz.yilmaz@outlook.de", "Deniz", "", "", "", "", "", null, null, null, "ausweis_da", true, 0],
      ["tobias.cmcp@gmail.com", "Tobicmcp", "", "", "", "", "", null, null, null, "offen", false, 0],
      ["sven.h@gmx.de", "SvenH", "Sven", "Hansen", "20095", "Hamburg", "Deutschland", "HAM", "Hamburg", "plz", "abgewickelt", true, 2, "", "", "m", "Elbchaussee 20"],
      ["nina.k@web.de", "NinaK", "Nina", "Krüger", "70173", "Stuttgart", "Deutschland", "STR", "Stuttgart", "team", "daten_da", false, 0, "", "", "w", "Königstraße 2"],
      ["ali.m@gmail.com", "AliM", "Ali", "Mahmoud", "80995", "München", "Deutschland", "MUC", "München", "plz", "abgewickelt", true, 0, "MUC · 09:15 → 11:00 Lufthansa", "MUC · 11:50 → 13:40 Lufthansa", "m", "Blumenstr. 7"],
      ["jana.b@web.de", "JanaB", "Jana", "Berger", "85354", "Freising", "Deutschland", "MUC", "München", "plz", "daten_da", false, 0, "MUC · 21:40 → 23:25 Lufthansa", "", "w", "Blumenstr. 7"],
      ["marco.r@gmail.com", "MarcoR", "Marco", "Reiter", "70173", "Stuttgart", "Deutschland", "STR", "Stuttgart", "manuell", "abgewickelt", true, 0, "STR · 18:15 → 20:20 Wizz Air", "FKB · 07:15 → 09:25 Ryanair", "m", "Königstraße 2"]
    ];
    var draws = leute.map(function (l, i) { return { id: "d" + (i + 1), prize_key: i < 3 ? "platz" + (i + 1) : "boeing", prize_label: i < 3 ? cfg.prizes[i].label : "Boeing-Platz · Albanien-Reise", position: i + 1, email: l[0], username: l[1], name: l[1], ticket_no: 1000 + i * 917, total_tickets: 1899979, total_accounts: 333, status: "bestaetigt", is_test: false, drawn_at: new Date(jetzt - (90 - i * 6) * min).toISOString(), confirmed_at: new Date(jetzt - (88 - i * 6) * min).toISOString(), confirmed_by: "Marcel", drawn_by: "Marcel" }; });
    draws.push({ id: "d99", prize_key: "boeing", prize_label: "Boeing-Platz · Albanien-Reise", position: leute.length + 1, email: "neu.gezogen@gmail.com", username: "NeuGezogen", ticket_no: 48213, total_tickets: 1899979, total_accounts: 333, status: "gezogen", is_test: false, drawn_at: new Date(jetzt - 1 * min).toISOString(), drawn_by: "Marcel" });
    var profile = {};
    leute.forEach(function (l) {
      profile[l[0]] = { email: l[0], vorname: l[2] || null, nachname: l[3] || null, geburtsdatum: l[2] ? "1994-04-12" : null, geschlecht: l[15] || null, strasse: l[2] ? (l[16] || "Hauptstraße 12") : null, plz: l[4] || null, ort: l[5] || null, land: l[6] || null, telefon: l[2] ? "+49 170 1234567" : null,
        flughafen: l[7], flughafen_name: l[8], flughafen_auto: l[7], standort_quelle: l[9], flughafen_km: l[7] ? 18 + (l[0].length % 40) : null, status: l[10], hat_ausweis: l[11], unterlagen: l[12],
        daten_gemeldet_at: l[2] ? new Date(jetzt - 30 * min).toISOString() : null, ausweis_gemeldet_at: l[11] ? new Date(jetzt - 20 * min).toISOString() : null, updated_at: new Date(jetzt - 12 * min).toISOString(), team_notiz: "", hinflug: l[13] || null, rueckflug: l[14] || null };
    });
    var nick = function (mail) { return (leute.filter(function (l) { return l[0] === mail; })[0] || [])[1] || ""; };
    var airports = function () { return cfg.airports || std(); };
    var winners = function () {
      return leute.map(function (l) {
        var p = profile[l[0]]; var d = draws.filter(function (x) { return x.email === l[0]; });
        return Object.assign({ email: l[0], username: l[1], name: l[1], prizes: d.map(function (x) { return { label: x.prize_label, position: x.position, drawn_at: x.drawn_at, confirmed_at: x.confirmed_at, id: x.id }; }), first_drawn_at: d[0] && d[0].drawn_at, is_test: false }, p);
      });
    };
    var bild = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    /* Hotel (22.09.2026): 3 Einzelzimmer und 68 Doppelzimmer wie in Tirana.
       Zwei Leute liegen schon, damit der Reiter etwas zu zeigen hat. */
    var hotelCfg = { id: 1, hotel_name: "Hotel Tirana", zimmer_gesamt: 71, jet_plaetze: 3, anreise: "Fr 25.09.", abreise: "So 27.09.", notiz: "Check-in ab 14 Uhr" };
    var hotelRooms = (function () {
      var r = [], i;
      for (i = 0; i < 3; i++) r.push({ id: "e" + i, nummer: String(101 + i), art: "einzel", plaetze: 1, sort: i + 1 });
      for (i = 0; i < 68; i++) r.push({ id: "d" + i, nummer: String(201 + i), art: "doppel", plaetze: 2, sort: 4 + i });
      return r;
    })();
    var hotelBel = [{ email: "lara.x@gmail.com", room_id: "e0" }, { email: "sven.h@gmx.de", room_id: "d0" }];
    /* Gleiche Wohnadresse — dieselbe Rechnung wie in der Function, nur fürs Vorführen. */
    var adressGruppenDemo = function () {
      var nach = {}, raus = [];
      winners().forEach(function (w) {
        var t = function (v) { return String(v == null ? "" : v).toLowerCase().replace(/str(\.|asse|aße)\b/g, "str").replace(/[^a-z0-9äöüß]/g, ""); };
        if (!t(w.strasse) || (!t(w.plz) && !t(w.ort))) return;
        var k = t(w.strasse) + "|" + (t(w.plz) || t(w.ort));
        (nach[k] = nach[k] || []).push(w);
      });
      Object.keys(nach).forEach(function (k) {
        if (nach[k].length < 2) return;
        raus.push({ key: k, adresse: [nach[k][0].strasse, [nach[k][0].plz, nach[k][0].ort].filter(Boolean).join(" ")].filter(Boolean).join(", "), emails: nach[k].map(function (w) { return w.email; }), anzahl: nach[k].length });
      });
      return raus.sort(function (a, b) { return b.anzahl - a.anzahl; });
    };
    var hotelRechnungDemo = function () {
      var w = winners(), fertig = w.filter(function (x) { return x.status === "abgewickelt"; });
      var einzel = hotelRooms.filter(function (r) { return r.plaetze <= 1; }), betten = hotelRooms.reduce(function (a, r) { return a + r.plaetze; }, 0);
      var rest = Math.max(0, w.length - einzel.length);
      return { gewinner: w.length, rest: rest, fertig: fertig.length, offen_abwicklung: w.length - fertig.length,
        zimmer: hotelRooms.length, betten: betten, einzelzimmer: einzel.length, doppelzimmer: hotelRooms.length - einzel.length,
        einzel_belegt: einzel.filter(function (r) { return hotelBel.some(function (b) { return b.room_id === r.id; }); }).length,
        doppel_noetig: Math.ceil(rest / 2), zimmer_noetig: einzel.length + Math.ceil(rest / 2), zimmer_frei: Math.max(0, hotelRooms.length - (einzel.length + Math.ceil(rest / 2))),
        verteilt: hotelBel.length, offen: w.length - hotelBel.length, betten_frei: betten - hotelBel.length,
        fehlende_betten: Math.max(0, w.length - betten), passt: w.length <= betten };
    };
    /* Zusatzgewinner (17.09.2026): Bewerbungen nachgestellt — sonst bliebe der neue
       Reiter in der Vorschau leer und liesse sich am Handy nicht pruefen. */
    var zusatz = [
      { email: "sandra.k@web.de", name: "Sandra Köhler", instagram: "sandra.k", telefon: "+49 171 2233445", status: "offen", dateien: 2, vollstaendig: true, created_at: new Date(jetzt - 300 * min).toISOString() },
      { email: "murat.d@gmail.com", name: "Murat Demir", instagram: "@murat_d", telefon: "+49 176 9988776", status: "offen", dateien: 1, vollstaendig: false, created_at: new Date(jetzt - 120 * min).toISOString() },
      { email: "eva.p@gmx.de", name: "Eva Pfeiffer", instagram: "eva.pfeiffer", telefon: "+49 160 5544332", status: "freigegeben", dateien: 2, vollstaendig: true, created_at: new Date(jetzt - 900 * min).toISOString(), entschieden_am: new Date(jetzt - 400 * min).toISOString() },
      { email: "kai.l@web.de", name: "Kai Lorenz", instagram: "", telefon: "", status: "abgelehnt", dateien: 0, vollstaendig: false, created_at: new Date(jetzt - 1200 * min).toISOString(), entschieden_am: new Date(jetzt - 1000 * min).toISOString() }
    ];
    return function (body) {
      var a = body.action;
      var state = function () { return { ok: true, config: Object.assign({}, cfg, { airports: airports() }), draws: draws.slice().reverse(), pot: { tickets: 1064629, accounts: 333, raus_accounts: leute.length, raus_tickets: 835350 }, admin: { name: "Vorschau", schreiben: true } }; };
      switch (a) {
        case "admin_state": return state();
        case "config_save": Object.assign(cfg, body.config || {}); return { ok: true, config: state().config };
        case "embed_key_new": return { ok: true, config: state().config };
        case "winners": return { ok: true, winners: winners() };
        case "winner_detail": {
          var p = profile[body.email] || { email: body.email, status: "offen" };
          var files = p.hat_ausweis ? [{ id: "f1", kind: "ausweis_vorne", filename: "vorne.jpg", mime: "image/jpeg", uploaded_by: "gewinner", created_at: new Date().toISOString(), url: bild }, { id: "f2", kind: "ausweis_hinten", filename: "hinten.jpg", mime: "image/jpeg", uploaded_by: "gewinner", created_at: new Date().toISOString(), url: bild }] : [];
          if (p.unterlagen) files.push({ id: "f3", kind: "ticket", filename: "Flug-Tirana.pdf", mime: "application/pdf", uploaded_by: "Marcel", created_at: new Date().toISOString(), url: "#" });
          return { ok: true, email: body.email, konto: { username: nick(body.email) }, profile: p, files: files, draws: draws.filter(function (x) { return x.email === body.email; }) };
        }
        case "winner_save": {
          var q = profile[body.email];
          if (q) {
            if (body.team_notiz !== undefined) q.team_notiz = body.team_notiz;
            if (body.flughafen !== undefined) { var f = airports().filter(function (x) { return x.code === String(body.flughafen || "").toUpperCase(); })[0]; q.flughafen = f ? f.code : null; q.flughafen_name = f ? f.name : null; q.standort_quelle = f ? "team" : null; q.flughafen_km = null; }
            if (body.status === "abgewickelt") q.status = "abgewickelt";
            if (body.hinflug !== undefined) q.hinflug = body.hinflug || null;
            if (body.rueckflug !== undefined) q.rueckflug = body.rueckflug || null;
          }
          return { ok: true, status: q ? q.status : "offen" };
        }
        case "attend": { var d = draws.filter(function (x) { return x.id === body.id; })[0]; if (d) d.status = body.present ? "bestaetigt" : (body.raus ? "abwesend_raus" : "abwesend"); return { ok: true, status: d && d.status }; }
        case "pool": { var d2 = draws.filter(function (x) { return x.id === body.id; })[0]; if (d2) d2.status = body.raus ? "abwesend_raus" : "abwesend"; return { ok: true }; }
        case "void": { var d3 = draws.filter(function (x) { return x.id === body.id; })[0]; if (d3) { d3.status = "ungueltig"; d3.void_reason = body.reason; } return { ok: true }; }
        case "rangliste": return { ok: true, items: [{ email: "tobias.cmcp@gmail.com", name: "Tobicmcp", tickets: 12480 }, { email: "mutten@web.de", name: "Mutten", tickets: 9310 }, { email: "kevin98@gmx.de", name: "Kevin_98", tickets: 7720 }], tickets: 1899979, accounts: 333 };
        case "draw": {
          var n = { id: "d" + (draws.length + 1), prize_key: body.prize_key, prize_label: (cfg.prizes.filter(function (p2) { return p2.key === body.prize_key; })[0] || {}).label || "Preis", position: draws.length + 1, email: "neu" + draws.length + "@x.de", username: "Neu" + draws.length, ticket_no: 555 + draws.length, total_tickets: 1899979, status: "gezogen", is_test: !!cfg.test_mode, drawn_at: new Date().toISOString(), drawn_by: "Vorschau" };
          draws.push(n); return { ok: true, draw: n };
        }
        case "test_clear": return { ok: true, geloescht: 0, akten: 0 };
        case "hotel_state": return { ok: true, config: hotelCfg, rooms: hotelRooms, belegung: hotelBel, winners: winners(), rechnung: hotelRechnungDemo(), adressen: adressGruppenDemo() };
        case "hotel_gast": { if (profile[body.email]) profile[body.email].geschlecht = body.geschlecht || null; return { ok: true, winners: winners(), rechnung: hotelRechnungDemo() }; }
        case "hotel_assign": {
          var zi = hotelRooms.filter(function (x) { return x.id === body.room_id; })[0] || {};
          var mails = (body.emails || []).map(function (m) { return String(m).toLowerCase(); });
          if (mails.length > (zi.plaetze || 0)) return { ok: false, error: "Zimmer " + zi.nummer + " hat nur " + zi.plaetze + " Plätze." };
          hotelBel = hotelBel.filter(function (b) { return mails.indexOf(b.email) < 0; });
          mails.forEach(function (m) { hotelBel.push({ email: m, room_id: zi.id }); });
          return { ok: true, belegung: hotelBel, rechnung: hotelRechnungDemo() };
        }
        case "hotel_unassign": {
          if (body.alles) hotelBel = [];
          else if (body.room_id) hotelBel = hotelBel.filter(function (b) { return b.room_id !== body.room_id; });
          else hotelBel = hotelBel.filter(function (b) { return b.email !== body.email; });
          return { ok: true, belegung: hotelBel, rechnung: hotelRechnungDemo() };
        }
        case "hotel_auto": {
          var drin = {}; hotelBel.forEach(function (b) { drin[b.email] = 1; });
          var offen = winners().filter(function (w) { return !drin[w.email] && w.status === "abgewickelt"; });
          var freiD = hotelRooms.filter(function (r) { return r.plaetze > 1 && hotelBel.filter(function (b) { return b.room_id === r.id; }).length < 2; });
          var plan = [], rest = offen.slice();
          rest.sort(function (a, b) { return String(a.hinflug || a.flughafen).localeCompare(String(b.hinflug || b.flughafen)); });
          while (rest.length) { var zd = freiD.shift(); if (!zd) break; plan.push({ room_id: zd.id, nummer: zd.nummer, emails: rest.splice(0, 2).map(function (w) { return w.email; }) }); }
          if (body.anwenden !== true) return { ok: true, vorschlag: plan, uebrig: rest.map(function (w) { return w.email; }) };
          plan.forEach(function (pl) { pl.emails.forEach(function (m) { hotelBel.push({ email: m, room_id: pl.room_id }); }); });
          return { ok: true, gesetzt: plan.reduce(function (a, pl) { return a + pl.emails.length; }, 0), uebrig: rest.map(function (w) { return w.email; }), belegung: hotelBel, rechnung: hotelRechnungDemo() };
        }
        case "hotel_config_save": { Object.assign(hotelCfg, body.config || {}); return { ok: true, config: hotelCfg }; }
        case "hotel_rooms_save": {
          hotelRooms = (body.rooms || []).map(function (r, i) { return { id: r.id || "neu" + i, nummer: r.nummer, etage: r.etage, art: r.art, plaetze: r.art === "einzel" ? 1 : 2, notiz: r.notiz, sort: i + 1 }; });
          return { ok: true, rooms: hotelRooms, rechnung: hotelRechnungDemo() };
        }
        case "zusatz_liste": return { ok: true, items: zusatz };
        case "zusatz_detail": {
          var z = zusatz.filter(function (x) { return x.email === body.email; })[0] || { email: body.email, status: "offen", dateien: 0 };
          var teile = String(z.name || "").split(" ");
          var zf = [];
          if (z.dateien > 0) zf.push({ id: "zf1", kind: "ausweis_vorne", filename: "ausweis-vorne.jpg", mime: "image/jpeg", url: bild, created_at: z.created_at });
          if (z.dateien > 1) zf.push({ id: "zf2", kind: "ausweis_hinten", filename: "ausweis-hinten.jpg", mime: "image/jpeg", url: bild, created_at: z.created_at });
          return { ok: true, email: z.email, name: z.name,
            profile: { vorname: teile[0] || "", nachname: teile.slice(1).join(" "), geburtsdatum: "1993-07-04", strasse: "Lindenweg 8", plz: "44137", ort: "Dortmund", land: "Deutschland", telefon: z.telefon, instagram: z.instagram, hinweis: "Ich war bei der Ziehung dabei und hoffe auf einen Zusatzplatz." },
            files: zf, bewerbung: { status: z.status, entschieden_am: z.entschieden_am || null, notiz: z.notiz || "", created_at: z.created_at, vollstaendig: z.vollstaendig }, draws: [] };
        }
        case "zusatz_entscheiden": {
          var zz = zusatz.filter(function (x) { return x.email === body.email; })[0];
          if (zz) { zz.status = body.entscheidung === "freigeben" ? "freigegeben" : "abgelehnt"; zz.entschieden_am = new Date().toISOString(); zz.notiz = body.notiz || ""; }
          return { ok: true, status: zz ? zz.status : "offen", draw_id: "zd1" };
        }
        default: return { ok: true };
      }
    };
  })();

  /* Tagesplaner in der Vorschau: Marcels Beispiel als fertiger Plan, Antworten ohne KI. */
  var TP_DEMO = (function () {
    var jetzt = Date.now(), min = 60000, n = 0;
    var mk = function (titel, kat, zeit, status, details) { return { id: "tp" + (++n), titel: titel, kategorie: kat, zeit: zeit || null, status: status || "offen", details: details || null, reihenfolge: n }; };
    var aufgaben = [
      mk("Küche machen", "privat", null, "erledigt"), mk("Wäsche einschalten", "privat", null, "offen"),
      mk("WhatsApp-Post rausschicken (Opening)", "arbeit", null, "offen", "Vorbereitung fürs Opening läuft"),
      mk("Mit Frank telefonieren (Tickets)", "termin", "14:00"), mk("Mit Nouri & Crank telefonieren (neues Gewinnspiel)", "termin", "15:00"),
      mk("Mit Oecher besprechen: FTDs — Umsetzung & Voraussetzungen", "termin", null), mk("Mit Nouri einzeln: Tschechien / Schwager", "termin", null),
      mk("Tankstelle — was zu trinken holen", "privat", null), mk("Kinderzimmer aufräumen und umstellen", "privat", null, "offen", "heute Nachmittag oder Abend")
    ];
    var verlauf = [
      { rolle: "bot", text: "Guten Morgen Marcel! Was steht heute an? Schreib oder sprich es mir einfach.", created_at: new Date(jetzt - 200 * min).toISOString() },
      { rolle: "user", text: "Ich werde jetzt die Küche machen, dann die Wäsche einschalten. Vorbereitungen fürs Opening laufen, ich muss noch den WhatsApp-Post rausschicken. Um 14 Uhr mit Frank wegen der Tickets telefonieren, um 15 mit Nouri und Crank wegen des neuen Gewinnspiels, mit Oecher besprechen wie er die FTDs umsetzt. Danach mit Nouri einzeln wegen Tschechien. Dann Tankstelle und heute Abend das Kinderzimmer umstellen.", created_at: new Date(jetzt - 190 * min).toISOString() },
      { rolle: "bot", text: "Alles klar, dein Plan für heute steht — 9 Aufgaben:\n☐ 14:00 · Mit Frank telefonieren (Tickets)\n☐ 15:00 · Mit Nouri & Crank telefonieren (neues Gewinnspiel)\n☐ Mit Oecher besprechen: FTDs\n☐ Mit Nouri einzeln: Tschechien\n☐ WhatsApp-Post rausschicken\n☐ Küche machen\n☐ Wäsche einschalten\n☐ Tankstelle\n☐ Kinderzimmer umstellen\nIch erinnere dich um 14 und 15 Uhr.", created_at: new Date(jetzt - 189 * min).toISOString() },
      { rolle: "user", text: "Küche ist fertig", created_at: new Date(jetzt - 40 * min).toISOString() },
      { rolle: "bot", text: "Super, Küche abgehakt ✅ — noch 8 offen. Als Nächstes: Wäsche einschalten, dann um 14:00 Frank.", created_at: new Date(jetzt - 39 * min).toISOString() }
    ];
    var teile = function () { var d = new Date(); return { datum: d.toISOString().slice(0, 10), wochentag: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"][d.getDay()], uhr: d.toTimeString().slice(0, 5) }; };
    return function (body) {
      var t = teile(); var a = body.action;
      if (a === "heute") return { ok: true, datum: t.datum, wochentag: t.wochentag, uhr: t.uhr, aufgaben: aufgaben, verlauf: verlauf, einstellungen: { morgen_uhr: 8, mittag_uhr: 13, abend_uhr: 18 }, bot_id: "a0000000-0000-4000-8000-000000000001", name: "Vorschau" };
      if (a === "nachricht") {
        var txt = String(body.text || ""); verlauf.push({ rolle: "user", text: txt, created_at: new Date().toISOString() });
        var offen = aufgaben.filter(function (x) { return x.status !== "erledigt"; });
        var antwort = /steht|offen|anst/i.test(txt) ? "Offen sind noch " + offen.length + ": " + offen.map(function (x) { return (x.zeit ? x.zeit + " " : "") + x.titel; }).join(" · ") : (aufgaben.push(mk(txt.slice(0, 80), "arbeit", null)), "Aufgenommen: " + txt.slice(0, 80));
        var z = { rolle: "bot", text: antwort, created_at: new Date().toISOString() }; verlauf.push(z);
        return { ok: true, antwort: antwort, zeile: z, aufgaben: aufgaben, neu: /steht|offen|anst/i.test(txt) ? 0 : 1 };
      }
      if (a === "aufgabe") {
        if (body.op === "neu") aufgaben.push(mk(body.titel, body.kategorie, body.zeit));
        var x = aufgaben.filter(function (q) { return q.id === body.id; })[0];
        if (x && body.op === "status") x.status = body.status;
        if (x && body.op === "aendern" && body.zeit !== undefined) x.zeit = body.zeit || null;
        if (body.op === "loeschen") aufgaben = aufgaben.filter(function (q) { return q.id !== body.id; });
        return { ok: true, aufgaben: aufgaben };
      }
      if (a === "einstellungen") return { ok: true, einstellungen: Object.assign({ morgen_uhr: 8, mittag_uhr: 13, abend_uhr: 18 }, body.save || {}) };
      return { ok: true };
    };
  })();
  var CASINOS = ["MetaSpins", "IZZI", "IRIS", "FUGU", "IRWIN", "MARTIN", "FLAGMAN", "Hype"];
  var PARTNER = ["WOW Partners", "UNO Affiliate", "Slotsport", "247", "Electric", "Mio Media"];
  var NAMEN = ["Erik", "Manu", "Ostojic", "Simplyjay", "Crank", "Slotbro", "Bening", "Johanni", "Larsii", "Maxk"];

  var zufall = (a) => a[Math.floor(Math.random() * a.length)];
  var betrag = (min, max) => Math.round((min + Math.random() * (max - min)) * 100) / 100;
  /* LOKALES Datum, nicht toISOString: das rechnet nach UTC und verschiebt in
     unserer Zeitzone abends um einen Tag. Genau deshalb standen die
     Vorschau-Eintraege auf gestern, waehrend die Kopfzeile heute zeigte —
     im Quelltext steht an anderer Stelle schon eine Warnung davor. */
  var tag = (vorTagen) => {
    var d = new Date(); d.setDate(d.getDate() - vorTagen);
    var z = (n) => String(n).padStart(2, "0");
    return d.getFullYear() + "-" + z(d.getMonth() + 1) + "-" + z(d.getDate());
  };

  function eintraege(n) {
    var raus = [];
    for (var i = 0; i < n; i++) {
      var typ = ["FTD", "FTD", "FTD", "REDEPO", "OPERATING_EXPENSE", "INCOME"][i % 6];
      raus.push({
        id: "demo-e" + i,
        entry_date: tag(i % 3 === 0 ? 0 : (i % 21)),   // jeder dritte ist von heute
        entry_type: typ,
        amount: typ === "OPERATING_EXPENSE" ? betrag(80, 900) : betrag(20, 400),
        currency: "EUR",
        payment_status: i % 5 === 0 ? "open" : "paid",
        casino_name: zufall(CASINOS),
        partner_name: zufall(PARTNER),
        customer_name: zufall(NAMEN) + i,
        created_at: new Date(Date.now() - i * 3600e3).toISOString(),
        metadata: {},
      });
    }
    return raus;
  }

  var DATEN = {
    entries: eintraege(60),
    partners: PARTNER.map(function (n, i) { return { id: "demo-p" + i, name: n, status: "active" }; }),
    casinos: CASINOS.map(function (n, i) {
      return { id: "demo-c" + i, name: n, partner_group_id: "demo-p" + (i % PARTNER.length),
               deal_type: ["cpa", "revshare", "hybrid", "fixed"][i % 4],
               cpa_amount: 250, revshare_percent: 35, baseline_amount: 0, status: "active" };
    }),
    deals: CASINOS.slice(0, 5).map(function (n, i) {
      return { id: "demo-d" + i, title: n + " Deal", casino_id: "demo-c" + i,
               deal_type: ["cpa", "revshare", "hybrid", "fixed"][i % 4],
               cpa_amount: 250, revshare_percent: 35, fixed_fee: i === 3 ? 175000 : 0,
               start_date: tag(30), end_date: i === 3 ? tag(0) : null, status: "active" };
    }),
    team: NAMEN.slice(0, 6).map(function (n, i) {
      return { id: "demo-t" + i, name: n, email: n.toLowerCase() + "@amk.de",
               role: i === 0 ? "admin" : "employee", position: ["Inhaber","Support","Streaming","Buchhaltung","Marketing","Technik"][i],
               is_active: true, is_approved: true, gehalt: 0,
               can_view_dashboard: true, can_view_entries: true, can_view_finance: i < 2 };
    }),
    notifications: [
      { id: "demo-n1", title: "ReDepo prüfen", type: "redepo", is_read: false,
        message: "Vor 48 Stunden: Erik · 100,00 EUR. Kam eine zweite Einzahlung?",
        payload: { reminder_id: "demo-r1" }, created_at: new Date().toISOString() },
      { id: "demo-n2", title: "Neue Anfrage", type: "chat", is_read: false,
        message: "Manu: Meine Einzahlung fehlt noch als Ticket.", created_at: new Date().toISOString() },
    ],
  };

  /* Die Module fragen die Tabellen unter ihren echten Namen ab — die
     Vorschau muss dieselben Namen kennen, sonst bleiben Team und Partner
     leer (genau das war beim ersten Durchlauf so). */
  DATEN.team_members = DATEN.team;
  DATEN.amk_deals = DATEN.deals;
  DATEN.partner_groups = DATEN.partners;
  DATEN.amk_partner_billing = [];
  DATEN.amk_finance_documents = DATEN.partners.map(function (p, i) {
    return { id: "demo-i" + i, document_type: "invoice", title: "Rechnung AMK-2026-000" + (i + 1),
             partner_group_id: p.id, partner_name: p.name,
             document_date: tag(i * 3), amount: betrag(4000, 40000),
             status: i % 3 === 0 ? "paid" : "open" };
  });
  DATEN.giveaway_users = [];
  DATEN.notifications = DATEN.notifications;

  /* FTD-Bilanz: zwölf Monate FTDs/ReDepos mit Casino, dazu Royal-artige
     Konditionen (180 € CPA ab 20 €) und ein paar eingetragene Zahlungen. */
  (function () {
    var cas = DATEN.casinos;
    cas.forEach(function (c, i) { c.cpa_amount = [180, 0, 180, 0, 150, 0, 200, 120][i]; c.cpa_min_deposit = i % 2 === 0 ? 20 : 0; c.baseline_ftds = 0; });
    var z = (n) => String(n).padStart(2, "0"), heute = new Date(), nr = 0, vorher = {};
    for (var m = 11; m >= 0; m--) {
      var d0 = new Date(heute.getFullYear(), heute.getMonth() - m, 1);
      var tage = m === 0 ? heute.getDate() : new Date(d0.getFullYear(), d0.getMonth() + 1, 0).getDate();
      var anzahl = 18 + ((11 - m) * 3) + (m % 3) * 4;
      for (var k = 0; k < anzahl; k++) {
        var c = cas[[0, 2, 2, 4, 6, 7, 0, 1][k % 8]];
        var datum = d0.getFullYear() + "-" + z(d0.getMonth() + 1) + "-" + z(1 + (k * 7) % tage);
        var ftd = k % 3 !== 2;
        var spieler = ftd ? zufall(NAMEN) + "-" + m + "-" + k : (k % 4 === 0 ? "vormonat-" + k : vorher[c.id + m] || ("ohne-" + k));
        if (ftd) vorher[c.id + m] = spieler;
        DATEN.entries.push({ id: "demo-fb" + (nr++), entry_date: datum, entry_type: ftd ? "FTD" : "REDEPO",
          amount: ftd ? [15, 25, 40, 60, 80, 120, 150, 220, 300, 550, 1200][(k * 5 + m) % 11] : betrag(50, 400),
          currency: "EUR", payment_status: "paid", casino_id: c.id, partner_group_id: c.partner_group_id,
          casino_name: c.name, customer_name: spieler, metadata: {} });
      }
    }
    var erster = (m) => { var d = new Date(heute.getFullYear(), heute.getMonth() - m, 1); return d.getFullYear() + "-" + z(d.getMonth() + 1) + "-01"; };
    DATEN.amk_ftd_bilanz_erhalten = [1, 2, 3, 4].map(function (m) {
      return { id: "demo-er" + m, monat: erster(m), bezug: "partner:" + cas[0].partner_group_id, betrag: 3000 + m * 900, notiz: "Demo", eingetragen_von: "Vorschau" };
    });
    DATEN.amk_ftd_bilanz_vorgaben = [{ bezug: "alle", ziel_faktor: 1, min_avg_ftd: 100, redepos_je_ftd: 0.5, fd_von: 20, fd_bis: 500, notiz: "Demo-Vorgabe" }];
  })();

  /* ---- Alles nach draussen abfangen ---- */
  function kette(daten) {
    var p = Promise.resolve({ data: daten, error: null });
    var handler = { get: function (z, name) {
      if (name === "then") return p.then.bind(p);
      if (name === "catch") return p.catch.bind(p);
      if (name === "finally") return p.finally.bind(p);
      if (name === "maybeSingle" || name === "single")
        return function () { return Promise.resolve({ data: daten && daten[0] ? daten[0] : null, error: null }); };
      return function () { return new Proxy({}, handler); };
    } };
    return new Proxy({}, handler);
  }

  /* FTD-Bilanz: upsert/delete wirken im Speicher, damit sich Eintragen in der Vorschau pruefen laesst. */
  function bilanzKette(tabelle) {
    var liste = DATEN[tabelle] = DATEN[tabelle] || [];
    var schluessel = tabelle === "amk_ftd_bilanz_vorgaben" ? ["bezug"] : ["monat", "bezug"];
    return {
      select: function () { return kette(liste); },
      upsert: function (zeile) {
        var alt = liste.filter(function (x) { return schluessel.every(function (k) { return x[k] === zeile[k]; }); })[0];
        if (alt) Object.assign(alt, zeile); else liste.push(Object.assign({ id: "demo-neu" + liste.length }, zeile));
        return Promise.resolve({ data: null, error: null });
      },
      delete: function () { return { eq: function (k, v) {
        DATEN[tabelle] = liste.filter(function (x) { return x[k] !== v; });
        return Promise.resolve({ data: null, error: null });
      } }; },
    };
  }

  function anschalten() {
    AMKZ.state = AMKZ.state || {};
    AMKZ.state.member = { id: "demo-t0", name: "Vorschau", email: "vorschau@amk.de", session: "00000000-0000-4000-8000-000000000000",
                          role: "admin", is_active: true, is_approved: true };
    AMKZ.state.permissions = new Proxy(
      { isAdmin: true, supportCountries: ["DE", "CZ"] },
      { get: function (z, k) { return k in z ? z[k] : true; } });
    ["entries","partners","casinos","deals","team"].forEach(function (k) { AMKZ.state[k] = DATEN[k]; });
    /* Tagesanalyse: die alte Fassung liest Ist-Werte aus dem Zustand (null -> Fehler
       "reading 'length'"), die V11-Fassung aus der Sicht v_amk_entry_profit_clean.
       Beides bekommt erfundene, aber stimmige Werte aus den Eintraegen. */
    AMKZ.state.actualDailyData = [];
    if (AMKZ.data) AMKZ.data.loadActualDailyData = function () { AMKZ.state.actualDailyData = []; return Promise.resolve([]); };
    DATEN.amk_actual_daily_data = [];
    DATEN.v_amk_entry_profit_clean = DATEN.entries.map(function (e, i) {
      var c = DATEN.casinos.find(function (x) { return x.name === e.casino_name; }) || DATEN.casinos[i % DATEN.casinos.length];
      var ftd = e.entry_type === "FTD", rd = e.entry_type === "REDEPO", aus = e.entry_type === "OPERATING_EXPENSE";
      var einnahme = ftd ? (c.deal_type === "revshare" ? e.amount * 0.35 : 250) : (rd ? e.amount * 0.35 : (e.entry_type === "INCOME" ? e.amount : 0));
      return { id: e.id, entry_date: e.entry_date, entry_type: e.entry_type, entry_amount: e.amount,
               casino_id: c.id, casino_name: c.name, partner_group_id: c.partner_group_id, partner_name: e.partner_name,
               deal_type: c.deal_type, cpa_amount: c.cpa_amount, revshare_percent: c.revshare_percent,
               ftd_amount: ftd ? e.amount : 0, ftd_count: ftd ? 1 : 0, redepo_amount: rd ? e.amount : 0,
               expected_income: Math.round(einnahme * 100) / 100, expected_cost: aus ? e.amount : 0,
               expected_profit: Math.round((einnahme - (aus ? e.amount : 0)) * 100) / 100 };
    });

    if (AMKZ.supabase) {
      AMKZ.supabase.from = function (tabelle) {
        if (/^amk_ftd_bilanz_/.test(tabelle)) return bilanzKette(tabelle);
        return kette(DATEN[tabelle] || []);
      };
      /* Auch die Datenbankfunktionen beantworten — sonst stehen die Kacheln
         auf der Startseite auf 0 und die Vorschau wirkt leer. */
      AMKZ.supabase.rpc = function (name, args) {
        var a = (args && args.p_action) || "";
        if (name === "amk_invoice_admin" && a === "list") {
          return Promise.resolve({ data: { ok: true, invoices: DATEN.amk_finance_documents
            .filter(function (r) { return r.status !== "paid"; })
            .map(function (r) { return { gross_amount: r.amount, due_date: r.document_date }; }) }, error: null });
        }
        if (name === "amk_giveaway_admin" && a === "stats") {
          return Promise.resolve({ data: { ok: true, stats: { open: 7, open_tickets: 940,
            checked: 128, blocked: 3, participants: 812, total_tickets: 18420 } }, error: null });
        }
        if (name === "amk_redepo_admin" && a === "due") {
          return Promise.resolve({ data: { ok: true, verteilt: 0, reminders: [
            { id: "demo-r1", customer_name: "Erik", customer_email: "erik@example.com",
              amount: 100, currency: "EUR", casino_name: "MetaSpins",
              ftd_at: new Date(Date.now() - 48 * 3600e3).toISOString(),
              due_at: new Date().toISOString(), status: "open" } ] }, error: null });
        }
        if (name === "amk_standort") {
          return Promise.resolve({ data: { ok: true, sharing: false, darf_karte: true,
            map_key: null, map_style: "satellite", people: [] }, error: null });
        }
        // Ist-Werte der Tagesanalyse: leere Liste statt null — die alte Fassung
        // ruft rows.length auf und brach mit "reading 'length'" ab, danach kam
        // die V11-Fassung (und damit jede Zahl) gar nicht mehr zum Zug.
        if (name === "amk_get_actual_daily_data" || name === "amk_get_entries_limited") {
          return Promise.resolve({ data: [], error: null });
        }
        return Promise.resolve({ data: null, error: null });
      };
      AMKZ.supabase.channel = function () {
        var ch = { on: function () { return ch; }, subscribe: function () { return ch; } };
        return ch;
      };
    }
    /* Die Ansichten holen ihre Daten ueber die eigenen Lader, nicht direkt
       ueber supabase. Deshalb werden auch die abgefangen — sonst steht in der
       Vorschau ueberall "keine Eintraege". */
    AMKZ.data = AMKZ.data || {};
    AMKZ.data.loadEntries = function (o) {
      var d = (o && o.date) || null;
      var raus = d ? DATEN.entries.filter(function (e) { return e.entry_date === d; }) : DATEN.entries;
      AMKZ.state.entries = raus;
      return Promise.resolve(raus);
    };
    AMKZ.data.loadBaseData = function () { return Promise.resolve(true); };
    AMKZ.data.loadPartners = function () { return Promise.resolve(DATEN.partners); };
    AMKZ.data.loadCasinos = function () { return Promise.resolve(DATEN.casinos); };
    AMKZ.data.loadDeals = function () { return Promise.resolve(DATEN.deals); };

    var echtesFetch = window.fetch;
    window.fetch = function (url, opt) {
      if (/functions\/v1\/giveaway/.test(String(url))) {
        var gb = {}; try { gb = JSON.parse((opt && opt.body) || "{}"); } catch (_) {}
        if (gb.action === "password_reset") return Promise.resolve(new Response(JSON.stringify({ status: "success", email: gb.email, name: "Frank", username: "Johanni", password: gb.password || "Vorschau7Kq2" }), { status: 200, headers: { "Content-Type": "application/json" } }));
      }
      if (/functions\/v1\/tagesplan/.test(String(url))) {
        var tb = {}; try { tb = JSON.parse((opt && opt.body) || "{}"); } catch (_) {}
        return Promise.resolve(new Response(JSON.stringify(TP_DEMO(tb)), { status: 200, headers: { "Content-Type": "application/json" } }));
      }
      if (/functions\/v1\/verlosung/.test(String(url))) {
        var vb = {}; try { vb = JSON.parse((opt && opt.body) || "{}"); } catch (_) {}
        return Promise.resolve(new Response(JSON.stringify(VL_DEMO(vb)), { status: 200, headers: { "Content-Type": "application/json" } }));
      }
      if (/supabase|functions\/v1/.test(String(url))) {
        return Promise.resolve(new Response('{"ok":true,"requests":[],"casinos":[]}',
          { status: 200, headers: { "Content-Type": "application/json" } }));
      }
      return echtesFetch.apply(this, arguments);
    };

    var app = document.querySelector(".amkz-main-app");
    if (app) app.classList.remove("is-hidden");
    document.querySelectorAll(".amkz-login-card").forEach(function (el) {
      var s = el.closest("section,div[id]"); if (s) s.classList.add("is-hidden");
    });
    var anruf = document.getElementById("amkCallScreenFinal");
    if (anruf) anruf.remove();

    if (!document.getElementById("amkzVorschauBand")) {
      var b = document.createElement("div");
      b.id = "amkzVorschauBand";
      b.textContent = "VORSCHAU — erfundene Daten, nichts wird gespeichert";
      b.style.cssText = "position:fixed;top:0;left:0;right:0;z-index:1000000;text-align:center;" +
        "font:700 11px/22px system-ui;letter-spacing:.08em;color:#04231a;" +
        "background:linear-gradient(90deg,#3ddc97,#4dd0e1);pointer-events:none";
      document.body.appendChild(b);
      document.documentElement.style.setProperty("scroll-padding-top", "22px");
    }
    try { AMKZ.loadView && AMKZ.loadView("dashboard", { force: true }); } catch (_) {}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { setTimeout(anschalten, 500); });
  else setTimeout(anschalten, 500);

  window.AMKZ_VORSCHAU = { daten: DATEN, anschalten: anschalten };
})();

/* ============================================================================
   HANDY-TABELLEN BESCHRIFTEN
   Die Karten-Darstellung am Handy (CSS, Abschnitt 18) braucht an jeder Zelle
   den Spaltenkopf als data-label. Bisher hatte das nur die Eintraege-Tabelle;
   Dashboard, Casinos, Tagesanalyse, Ads und Finanzen standen 620–760 Pixel
   breit in 343 Pixel — teils ohne Scrollen, also abgeschnitten.
   Regel: <= 8 Spalten und keine Eingabefelder in den Zeilen -> Karten
   (data-karten). Sonst bleibt es eine Tabelle, die sichtbar scrollt
   (data-scroll). Laeuft nach jedem Ansichtswechsel und nach Klicks, weil
   viele Bereiche ihre Tabellen per innerHTML neu schreiben.
============================================================================ */
(function () {
  "use strict";
  function beschriften() {
    document.querySelectorAll(".amkz-view table").forEach(function (t) {
      var ths = [].slice.call(t.querySelectorAll("thead th"));
      if (!ths.length) return;
      var labels = ths.map(function (th) { return (th.textContent || "").trim(); });
      var eingaben = t.querySelector("tbody input, tbody select, tbody textarea");
      if (labels.length > 8 || eingaben) { t.removeAttribute("data-karten"); t.setAttribute("data-scroll", ""); return; }
      t.removeAttribute("data-scroll");
      t.setAttribute("data-karten", "");
      t.querySelectorAll("tbody tr").forEach(function (tr) {
        var i = 0;
        [].slice.call(tr.children).forEach(function (td) {
          var span = td.colSpan || 1;
          if (span === 1 && !td.hasAttribute("data-label") && labels[i]) td.setAttribute("data-label", labels[i]);
          i += span;
        });
      });
    });
  }
  var prev = AMKZ.loadView;
  AMKZ.loadView = async function tabellenChain(view, options) {
    var r = await (prev ? prev.call(this, view, options) : undefined);
    // Mehrere Anlaeufe: einige Bereiche (Tagesanalyse V11) schreiben ihre Tabelle erst nach 1–2 s.
    setTimeout(beschriften, 150); setTimeout(beschriften, 900); setTimeout(beschriften, 2200); setTimeout(beschriften, 4000);
    return r;
  };
  document.addEventListener("click", function () { setTimeout(beschriften, 450); }, true);
  window.addEventListener("resize", beschriften);
  setTimeout(beschriften, 1500);
  window.AMKZ_TABELLEN_BESCHRIFTEN = beschriften;
})();

/* ============================================================================
   HINTERGRUND-ELEMENTE
   Marcels Entscheidung 3: volles Programm. Die drei Farbschleier (.amkz-bgfx)
   bekommen ein Canvas mit Staub, schwebenden Ringen, Rauten und Scherben und
   alle 14 s einem Lichtschimmer. Dasselbe Modul laeuft in der neuen Zentrale
   (Z.fx.partikel); hier die Fassung fuer die laufende.
     · Farben aus den Tokens der Fassung — nie aus dem JS
     · Stufen: >= 1181 px alles · 781–1180 weniger Formen · <= 780 nur Staub
     · ruht bei verstecktem Tab, bei body.amkz-bgfx-pause und "Bewegung reduzieren"
============================================================================ */
(function () {
  "use strict";
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  var html = document.documentElement;
  var laeuft = false;

  function stufe() {
    var n = navigator;
    if ((n.connection && n.connection.saveData) || (n.deviceMemory && n.deviceMemory <= 2)) return 0;
    if (innerWidth <= 780) return 1;
    if (innerWidth <= 1180) return 2;
    return 3;
  }

  function start() {
    var bgfx = document.querySelector(".amkz-bgfx");
    if (!bgfx) return false;
    if (bgfx.querySelector("canvas.amkz-elemente")) return true;
    var c = document.createElement("canvas");
    c.className = "amkz-elemente";
    c.setAttribute("aria-hidden", "true");
    bgfx.appendChild(c);
    var ctx = c.getContext("2d");
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var w, h, farben = { a: "#8b7bff", b: "#4dd0e1", gold: "#e9c76a" };
    var staub = [], formen = [], schimmer = performance.now() + 4000;
    function groesse() { w = c.width = innerWidth * dpr; h = c.height = innerHeight * dpr; }
    function lesen() {
      var cs = getComputedStyle(html);
      farben = {
        a: cs.getPropertyValue("--amk-accent-2").trim() || cs.getPropertyValue("--amk-accent").trim() || farben.a,
        b: cs.getPropertyValue("--amk-info").trim() || farben.b,
        gold: cs.getPropertyValue("--amk-gold").trim() || farben.gold,
      };
    }
    groesse(); lesen();
    addEventListener("resize", groesse);
    // Fassungswechsel: die Klasse an <html> aendert sich -> Farben neu lesen
    new MutationObserver(lesen).observe(html, { attributes: true, attributeFilter: ["class"] });

    var zufall = function (a, b) { return a + Math.random() * (b - a); };
    for (var i = 0; i < 90; i++) staub.push({ x: Math.random(), y: Math.random(), r: zufall(.6, 2.2), vx: zufall(-.00006, .00006), vy: -zufall(.00004, .00016), a: zufall(.3, .8), t: Math.random() * 6.28 });
    var ARTEN = ["ring", "ring", "scherbe", "raute", "ring", "scherbe", "raute"];
    for (var j = 0; j < 11; j++) formen.push({ art: ARTEN[j % ARTEN.length], x: Math.random(), y: Math.random(), g: zufall(70, 210), rot: Math.random() * 6.28, vr: zufall(-.0014, .0014), vx: zufall(-.00004, .00004), vy: -zufall(.00002, .00006), a: zufall(.26, .48), f: j % 3 });

    function form(o, jetzt) {
      ctx.save();
      ctx.translate(o.x * w, o.y * h); ctx.rotate(o.rot);
      var s = o.g * dpr, farbe = o.f === 0 ? farben.a : o.f === 1 ? farben.b : farben.gold;
      ctx.lineWidth = 1.2 * dpr; ctx.strokeStyle = farbe; ctx.fillStyle = farbe;
      ctx.globalAlpha = o.a * (0.75 + 0.25 * Math.sin(jetzt / 1900 + o.g));
      ctx.beginPath();
      if (o.art === "ring") { ctx.arc(0, 0, s / 2, 0, Math.PI * 2); }
      else if (o.art === "raute") { ctx.moveTo(0, -s / 2); ctx.lineTo(s / 2.6, 0); ctx.lineTo(0, s / 2); ctx.lineTo(-s / 2.6, 0); ctx.closePath(); }
      else { ctx.moveTo(-s / 2, s / 3); ctx.lineTo(s / 2, -s / 3); ctx.lineTo(s / 2.4, -s / 5); ctx.lineTo(-s / 2.4, s / 5); ctx.closePath(); }
      ctx.stroke();
      ctx.globalAlpha *= .12; ctx.fill();   // hauchduenne Fuellung, damit die Form Koerper hat
      ctx.restore();
    }

    function zeichnen(jetzt) {
      if (!laeuft) return;
      var st = stufe();
      if (document.hidden || document.body.classList.contains("amkz-bgfx-pause") || st === 0) { ctx.clearRect(0, 0, w, h); requestAnimationFrame(zeichnen); return; }
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = farben.a;
      staub.forEach(function (p) {
        p.x += p.vx; p.y += p.vy; p.t += .01;
        if (p.y < -.02) { p.y = 1.02; p.x = Math.random(); }
        if (p.x < -.02) p.x = 1.02; if (p.x > 1.02) p.x = -.02;
        ctx.globalAlpha = p.a * (0.6 + 0.4 * Math.sin(p.t));
        ctx.beginPath(); ctx.arc(p.x * w, p.y * h, p.r * dpr, 0, Math.PI * 2); ctx.fill();
      });
      if (st >= 2) {
        var anzahl = st === 3 ? formen.length : 6;
        for (var k = 0; k < anzahl; k++) {
          var o = formen[k];
          o.x += o.vx; o.y += o.vy; o.rot += o.vr;
          if (o.y < -.15) { o.y = 1.15; o.x = Math.random(); }
          if (o.x < -.15) o.x = 1.15; if (o.x > 1.15) o.x = -.15;
          form(o, jetzt);
        }
      }
      if (st === 3) {
        var dt = jetzt - schimmer;
        if (dt >= 0 && dt < 2600) {
          var p = dt / 2600, x = (p * 1.6 - .3) * w;
          var g = ctx.createLinearGradient(x - .18 * w, 0, x + .18 * w, 0);
          g.addColorStop(0, "transparent"); g.addColorStop(.5, farben.a); g.addColorStop(1, "transparent");
          ctx.save(); ctx.globalAlpha = .12 * Math.sin(Math.PI * p); ctx.fillStyle = g;
          ctx.transform(1, 0, -.35, 1, 0, 0); ctx.fillRect(x - .2 * w, 0, .4 * w, h); ctx.restore();
        } else if (dt >= 2600) schimmer = jetzt + 14000;
      }
      ctx.globalAlpha = 1;
      requestAnimationFrame(zeichnen);
    }
    laeuft = true;
    requestAnimationFrame(zeichnen);
    return true;
  }
  // Die Schleier-Ebene wird vom Hintergrund-Modul erzeugt — kurz darauf warten.
  var versuche = 0;
  var t = setInterval(function () { if (start() || ++versuche > 20) clearInterval(t); }, 400);
})();


/* ============================================================================
   HALLOWEEN-GIVEAWAYS (30.09.2026)
   ----------------------------------------------------------------------------
   Zwei Giveaways nebeneinander — MetaSpins und Royal Partners — je 10 Plätze.
   Alles läuft über die Edge Function `halloween` mit der Casino-Hub-Sitzung
   (x-amk-admin), wie die Verlosung: Einstellungen, Casinos je Giveaway,
   Preise, Tickets prüfen/sperren, Live-Ziehung mit OBS-Quelle.
   SQL: zentrale/supabase-halloween-giveaways.sql
============================================================================ */
(function () {
  "use strict";
  var AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__halloween) return;
  AMKZ.__halloween = true;

  var API = window.AMK_HALLOWEEN_API || "https://cbwxgikndyyzdslmfpmo.supabase.co/functions/v1/halloween";
  var HUB_API = window.AMK_HUB_API || "https://cbwxgikndyyzdslmfpmo.supabase.co/functions/v1/vertrieb";
  var OBS_BASIS = "https://nouri-amk.com/pages/halloween-live";
  var byId = function (id) { return document.getElementById(id); };
  var esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || function (v) { return String(v == null ? "" : v).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[c]; }); };
  var toast = function (t, m, ty) { (AMKZ.toast || console.log)(t, m, ty); };
  var nf = function (v) { return (Number(v) || 0).toLocaleString("de-DE"); };
  var zeit = function (v) { if (!v) return "—"; var d = new Date(v); return isNaN(d) ? "—" : d.toLocaleString("de-DE", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }).replace(", ", " "); };
  var lokal = function (v) { if (!v) return ""; var d = new Date(v); if (isNaN(d)) return ""; var p = function (n) { return String(n).padStart(2, "0"); }; return d.getFullYear() + "-" + p(d.getMonth() + 1) + "-" + p(d.getDate()) + "T" + p(d.getHours()) + ":" + p(d.getMinutes()); };

  var cur = function (c) { return " " + esc((c && c.currency) || "€"); };
  var S = { state: null, slug: null, tab: "uebersicht", anmelden: false, deps: null, suche: "", testmodus: false, modus: null, laeuft: false, abgl: null, abglFilter: "alle" };

  function token() { return localStorage.getItem("amkch_token") || ""; }
  async function api(action, payload) {
    var res = await fetch(API, { method: "POST", headers: { "Content-Type": "application/json", "x-amk-admin": token() }, body: JSON.stringify(Object.assign({ action: action }, payload || {})) });
    var d = await res.json().catch(function () { return {}; });
    if (res.status === 401 || d.code === "UNAUTHORIZED") { S.anmelden = true; zeichne(); throw new Error("Bitte mit dem Zentrale-Passwort bestätigen."); }
    if (!res.ok || d.ok === false) { var f = new Error(d.error || ("Fehler " + res.status)); f.code = d.code || ""; throw f; }
    return d;
  }
  async function hubLogin(email, password) {
    var res = await fetch(HUB_API, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ action: "hub_login", email: email, password: password }) });
    var d = await res.json().catch(function () { return {}; });
    if (!res.ok || d.ok === false || !d.token) throw new Error(d.error || "Anmeldung fehlgeschlagen");
    localStorage.setItem("amkch_token", d.token);
    S.anmelden = false;
  }
  function k() { return (S.state && S.state.campaigns || []).find(function (c) { return c.slug === S.slug; }) || null; }
  function darf() { return !!(S.state && S.state.admin && S.state.admin.schreiben); }

  async function laden() {
    var root = byId("amkzHalloweenRoot"); if (!root) return;
    if (!S.state) root.innerHTML = '<div class="amkz-hw-leer">🎃 Lädt die Giveaways …</div>';
    try {
      S.state = await api("admin_state", {});
      S.anmelden = false;
      if (!S.slug || !k()) S.slug = S.state.campaigns[0] ? S.state.campaigns[0].slug : null;
      if (S.tab === "abgleich" && !(k() && k().api_casino)) S.tab = "uebersicht";
      if (S.tab === "tickets") await ladeTickets();
      if (S.tab === "abgleich") await ladeAbgleich();
    } catch (e) {
      if (!S.anmelden) {
        var hinweis = /giveaway_campaigns|Failed to fetch|404/.test(e.message)
          ? "<small>Einmalig nötig: <code>zentrale/supabase-halloween-giveaways.sql</code> in Supabase ausführen und die Edge Function <code>halloween</code> deployen (Verify JWT aus).</small>" : "";
        root.innerHTML = '<div class="amkz-hw-leer">' + esc(e.message) + "<br>" + hinweis + "</div>";
        return;
      }
    }
    zeichne();
  }
  async function ladeTickets() { S.deps = null; var d = await api("deposits", { campaign: S.slug, q: S.suche }); S.deps = d; }
  async function ladeAbgleich() { S.abgl = null; try { S.abgl = await api("api_abgleich", { campaign: S.slug }); } catch (e) { S.abgl = { fehler: e.message }; } }

  /* ---------------------------------------------------------------- Zeichnen */
  function zeichne() {
    var root = byId("amkzHalloweenRoot"); if (!root) return;
    if (S.anmelden) {
      var mail = (AMKZ.state && AMKZ.state.member && AMKZ.state.member.email) || "";
      root.innerHTML = '<div class="amkz-hw-karte amkz-hw-login"><h3>🔒 Kurz bestätigen</h3><p>Die Giveaways zeigen Teilnehmer und Einzahlungen. Dafür braucht es die Team-Anmeldung wie beim Casino-Hub — einmal dein Zentrale-Passwort, dann bleibt es 30 Tage.</p>' +
        '<div class="amkz-hw-reihe"><input id="amkzHwMail" type="email" placeholder="E-Mail" value="' + esc(mail) + '"><input id="amkzHwPass" type="password" placeholder="Zentrale-Passwort" autocomplete="current-password"><button type="button" class="amkz-hw-btn gold" data-hw="login">Bestätigen</button></div></div>';
      return;
    }
    var st = S.state; if (!st) return;
    if (!st.campaigns.length) { root.innerHTML = '<div class="amkz-hw-leer">Noch kein Giveaway angelegt — SQL <code>supabase-halloween-giveaways.sql</code> ausführen.</div>'; return; }
    var c = k();
    var kopf = '<div class="amkz-hw-kopf"><div class="amkz-hw-kopf-l"><span class="amkz-hw-kuerbis">🎃</span><div><h2>Giveaway-Aktionen</h2><p>' +
      (darf() ? "Einstellungen, Tickets und Live-Ziehung — alles, was auf der Front steht, kommt von hier." : "Nur Einsicht — Ziehen und Ändern dürfen Leitung, Finanzen und Team-Verwaltung.") + "</p></div></div>" +
      '<button type="button" class="amkz-hw-btn" data-hw="neu">↻ Aktualisieren</button></div>';
    var wahl = '<div class="amkz-hw-giveaways">' + st.campaigns.map(function (x) {
      var e = x.entries || {};
      return '<button type="button" class="amkz-hw-gw' + (x.slug === S.slug ? " on" : "") + '" data-hw-slug="' + esc(x.slug) + '">' +
        '<b>' + esc(x.title) + "</b><span>" + esc((x.casinos || []).join(" · ")) + "</span>" +
        '<em><i class="amkz-hw-led ' + (e.offen ? "gruen" : "rot") + '"></i>' + (e.offen ? "Eingabe offen" : esc(e.grund || "geschlossen")) + "</em>" +
        '<strong>' + nf(x.stats.tickets) + " Tickets · " + nf(x.stats.participants) + " Teilnehmer</strong></button>";
    }).join("") + "</div>";
    var tabs = '<div class="amkz-hw-tabs">' + [["uebersicht", "📊 Übersicht"], ["einstellungen", "⚙️ Einstellungen"], ["tickets", "🎟 Tickets"]].concat(c && c.api_casino ? [["abgleich", "🔎 " + c.api_casino + "-Abgleich"]] : [], [["ziehung", "🎲 Live-Ziehung"]]).map(function (t) {
      return '<button type="button" class="amkz-hw-tab' + (S.tab === t[0] ? " on" : "") + '" data-hw-tab="' + t[0] + '">' + t[1] + "</button>";
    }).join("") + "</div>";
    var inhalt = S.tab === "einstellungen" ? einstellungen(c) : S.tab === "tickets" ? tickets(c) : S.tab === "abgleich" ? abgleichAnsicht(c) : S.tab === "ziehung" ? ziehung(c) : uebersicht(c);
    root.innerHTML = kopf + wahl + tabs + '<div class="amkz-hw-inhalt">' + inhalt + "</div>";
  }

  function kachel(t, w, sub) { return '<div class="amkz-hw-kachel"><span>' + t + "</span><b>" + w + "</b>" + (sub ? "<small>" + sub + "</small>" : "") + "</div>"; }
  function uebersicht(c) {
    var s = c.stats, summe = (c.prizes || []).reduce(function (a, p) { return a + (Number(p.amount) || 0); }, 0);
    return '<div class="amkz-hw-kacheln">' +
      kachel("Tickets", nf(s.tickets)) + kachel("Teilnehmer", nf(s.participants)) + kachel("Einzahlungen", nf(s.amount) + cur(c), nf(s.deposits) + " Einträge") +
      kachel("Prüfstand", nf(s.geprueft) + " / " + nf(s.deposits), nf(s.gesperrt) + " gesperrt") + kachel("Preise", nf(summe) + " " + esc(c.currency || "€"), (c.prizes || []).length + " Plätze") +
      kachel("Ende", zeit(c.ends_at), "Ziehung " + zeit(c.draw_at)) + "</div>" +
      '<div class="amkz-hw-zwei"><div class="amkz-hw-karte"><h3>🏁 Aktuelle Top 15 <small>Zufall, gewichtet</small></h3>' +
      (c.top && c.top.length ? '<table class="amkz-hw-tab-l"><thead><tr><th>#</th><th>Name</th><th>E-Mail</th><th class="r">Tickets</th><th class="r" title="Goldene Plakette = Preis für diesen Platz. Die Ziehung selbst ist zufällig, gewichtet nach Tickets.">Einzahlung · Preis</th></tr></thead><tbody>' + c.top.map(function (r, i) {
        var p = (c.prizes || []).find(function (x) { return Number(x.place) === i + 1; });
        return "<tr" + (p ? ' class="preis"' : "") + "><td>" + (i + 1) + "</td><td>" + esc(r.name || "—") + "</td><td>" + esc(r.email) + '</td><td class="r"><b>' + nf(r.tickets) + '</b></td><td class="r">' + nf(r.amount) + cur(c) + (p ? ' <span class="amkz-hw-pill gold">' + nf(p.amount) + cur(c) + "</span>" : "") + "</td></tr>";
      }).join("") + "</tbody></table>" : '<p class="amkz-hw-fein">Noch keine Tickets.</p>') + "</div>" +
      '<div class="amkz-hw-karte"><h3>💰 Preise</h3><ol class="amkz-hw-preise">' + (c.prizes || []).map(function (p) { return "<li><span>Platz " + p.place + "</span><b>" + nf(p.amount) + " " + esc(c.currency || "€") + "</b></li>"; }).join("") + "</ol>" +
      '<p class="amkz-hw-fein">Casinos: <b>' + esc((c.casinos || []).join(", ")) + "</b><br>Mindesteinzahlung " + nf(c.min_deposit) + cur(c) + " · Sonntags-Boost " + (c.boost ? "an" : "aus") + " · Seite " + (c.is_active ? "sichtbar" : "versteckt") + "</p></div></div>";
  }

  function einstellungen(c) {
    var hub = (S.state.hub_casinos || []).slice(); (c.casinos || []).forEach(function (n) { if (hub.indexOf(n) < 0) hub.push(n); });
    var ro = darf() ? "" : " disabled";
    var feld = function (lab, html, breit) { return '<label class="amkz-hw-feld' + (breit ? " breit" : "") + '"><span>' + lab + "</span>" + html + "</label>"; };
    var schalter = function (id, an, text) { return '<label class="amkz-hw-schalter"><input type="checkbox" id="' + id + '"' + (an ? " checked" : "") + ro + "><i></i><span>" + text + "</span></label>"; };
    return '<div class="amkz-hw-karte"><h3>⚙️ ' + esc(c.title) + ' <small>Kennung: ' + esc(c.slug) + "</small></h3>" +
      '<div class="amkz-hw-schalterreihe">' + schalter("hwAktiv", c.is_active, "Auf der Webseite sichtbar") + schalter("hwOffen", c.entries_open, "Ticketeingabe offen") + schalter("hwBoost", c.boost, "Sonntags-Boost gilt") + "</div>" +
      '<div class="amkz-hw-form">' +
      feld("Titel", '<input id="hwTitel" value="' + esc(c.title) + '"' + ro + ">", true) +
      feld("Untertitel", '<input id="hwUnter" value="' + esc(c.subtitle || "") + '"' + ro + ">", true) +
      feld("Start", '<input id="hwStart" type="datetime-local" value="' + lokal(c.starts_at) + '"' + ro + ">") +
      feld("Ende der Eingabe", '<input id="hwEnde" type="datetime-local" value="' + lokal(c.ends_at) + '"' + ro + ">") +
      feld("Live-Ziehung", '<input id="hwZiehung" type="datetime-local" value="' + lokal(c.draw_at) + '"' + ro + ">") +
      feld("Verfahren", '<select id="hwModus" disabled><option value="zufall" selected>Zufall — jedes Ticket ein Los, Platz 1 wird zuerst gezogen</option></select>') +
      feld("Mindesteinzahlung", '<input id="hwMin" type="number" min="1" value="' + esc(c.min_deposit) + '"' + ro + ">") +
      feld("Währung", '<input id="hwWaehrung" value="' + esc(c.currency || "€") + '"' + ro + ">") +
      feld("Hinweis, wenn geschlossen", '<input id="hwNotiz" value="' + esc(c.entries_note || "") + '" placeholder="z. B. Eingabe pausiert bis 18 Uhr"' + ro + ">", true) +
      feld("Banner-Bild (URL)", '<input id="hwBanner" value="' + esc(c.banner_url || "") + '"' + ro + ">", true) +
      feld("Teilnahmebedingungen (Zeilen = Punkte)", '<textarea id="hwRegeln" rows="4"' + ro + ">" + esc(c.rules || "") + "</textarea>", true) +
      "</div>" +
      '<h4>🎰 Casinos, die für dieses Giveaway zählen</h4><div class="amkz-hw-casinos">' + hub.map(function (n) {
        var an = (c.casinos || []).some(function (x) { return x.toLowerCase() === n.toLowerCase(); });
        return '<label class="amkz-hw-chip' + (an ? " on" : "") + '"><input type="checkbox" class="hwCasino" value="' + esc(n) + '"' + (an ? " checked" : "") + ro + ">" + esc(n) + "</label>";
      }).join("") + "</div>" +
      '<h4>💰 Preise</h4><div class="amkz-hw-preisedit" id="hwPreise">' + (c.prizes || []).map(preisZeile).join("") + "</div>" +
      (darf() ? '<div class="amkz-hw-reihe"><button type="button" class="amkz-hw-btn" data-hw="preis+">+ Platz</button><span class="amkz-hw-fein" id="hwSumme"></span><span class="amkz-hw-platz"></span><button type="button" class="amkz-hw-btn gold" data-hw="speichern">💾 Speichern</button></div>' : "") + "</div>";
  }
  function preisZeile(p) { return '<div class="amkz-hw-preis"><span>Platz</span><input type="number" class="hwPlatz" min="1" value="' + esc(p.place) + '"><input type="number" class="hwBetrag" min="0" value="' + esc(p.amount) + '"><button type="button" class="amkz-hw-x" data-hw="preis-">✕</button></div>'; }
  function summeZeigen() { var s = 0; document.querySelectorAll("#hwPreise .hwBetrag").forEach(function (i) { s += Number(i.value) || 0; }); var el = byId("hwSumme"); if (el) el.textContent = "Summe: " + nf(s) + cur(k()); }

  async function speichern() {
    var c = k(), val = function (id) { var e = byId(id); return e ? e.value : ""; }, an = function (id) { var e = byId(id); return !!(e && e.checked); };
    var casinos = []; document.querySelectorAll(".hwCasino:checked").forEach(function (i) { casinos.push(i.value); });
    if (!casinos.length) { toast("Giveaway", "Mindestens ein Casino auswählen.", "error"); return; }
    var prizes = []; document.querySelectorAll("#hwPreise .amkz-hw-preis").forEach(function (z) { var pl = Number(z.querySelector(".hwPlatz").value), b = Number(z.querySelector(".hwBetrag").value); if (pl > 0) prizes.push({ place: pl, amount: b }); });
    var iso = function (id) { var v = val(id); return v ? new Date(v).toISOString() : null; };
    try {
      await api("campaign_save", { campaign: { slug: c.slug, title: val("hwTitel"), subtitle: val("hwUnter"), starts_at: iso("hwStart"), ends_at: iso("hwEnde"), draw_at: iso("hwZiehung"),
        draw_mode: "zufall", min_deposit: Number(val("hwMin")), currency: val("hwWaehrung"), entries_note: val("hwNotiz"), banner_url: val("hwBanner"), rules: val("hwRegeln"),
        is_active: an("hwAktiv"), entries_open: an("hwOffen"), boost: an("hwBoost"), casinos: casinos, prizes: prizes } });
      toast("Giveaway", "Gespeichert — die Webseite zeigt es in spätestens 20 Sekunden.");
      await laden();
    } catch (e) { toast("Giveaway", e.message, "error"); }
  }

  var STATUS_NAECHST = { OFFEN: "GEPRUEFT", GEPRUEFT: "GESPERRT", GESPERRT: "OFFEN" };
  var STATUS_TEXT = { OFFEN: "Offen", GEPRUEFT: "Geprüft", GESPERRT: "Gesperrt" };
  function tickets(c) {
    var d = S.deps;
    var kopf = '<div class="amkz-hw-reihe"><input id="hwSuche" type="search" placeholder="Suche: E-Mail, Name, Casino" value="' + esc(S.suche) + '"><button type="button" class="amkz-hw-btn" data-hw="suchen">Suchen</button><span class="amkz-hw-platz"></span>' +
      (d ? '<span class="amkz-hw-fein">' + nf(d.total) + " Einträge</span>" : "") + '<button type="button" class="amkz-hw-btn" data-hw="csv">⬇ CSV</button></div>';
    if (!d) return '<div class="amkz-hw-karte">' + kopf + '<p class="amkz-hw-fein">Lädt …</p></div>';
    return '<div class="amkz-hw-karte">' + kopf + '<p class="amkz-hw-fein">Status antippen schaltet Offen → Geprüft → Gesperrt. Gesperrte Einzahlungen zählen nicht für die Ziehung.</p>' +
      (d.deposits.length ? '<div class="amkz-hw-scroll"><table class="amkz-hw-tab-l"><thead><tr><th>Datum</th><th>Name</th><th>E-Mail</th><th>Casino</th><th class="r">Betrag</th><th class="r">Tickets</th><th>Status</th><th></th></tr></thead><tbody>' +
        d.deposits.map(function (r) {
          return "<tr><td>" + zeit(r.created_at) + "</td><td>" + esc(r.name || "—") + "</td><td>" + esc(r.email) + "</td><td>" + esc(r.casino) + '</td><td class="r">' + nf(r.amount) + cur(c) + '</td><td class="r"><b>' + nf(r.tickets) + "</b>" + (Number(r.boost_mult) > 1 ? ' <span class="amkz-hw-pill">' + r.boost_mult + "×</span>" : "") + "</td>" +
            '<td><button type="button" class="amkz-hw-status ' + r.status.toLowerCase() + '" data-hw-status="' + esc(r.id) + '" data-st="' + r.status + '"' + (darf() ? "" : " disabled") + ">" + STATUS_TEXT[r.status] + "</button></td>" +
            "<td>" + (darf() ? '<button type="button" class="amkz-hw-x" data-hw-del="' + esc(r.id) + '" title="Löschen">🗑</button>' : "") + "</td></tr>";
        }).join("") + "</tbody></table></div>" : '<p class="amkz-hw-fein">Keine Einträge.</p>') + "</div>";
  }

  /* Abgleich mit der crossfade-API: eingetragen vs. wirklich eingezahlt (je verbundenem Namen). */
  var LAGE = { zu_viel: ["rot", "⚠ zu viel", "mehr eingetragen als eingezahlt"], ohne_name: ["gelb", "ohne Name", "kein Casino-Name verbunden"], ok: ["gruen", "passt", "eingetragen ≤ eingezahlt"], nicht_verbunden: ["grau", "nicht verbunden", "eingezahlt, aber kein Giveaway-Konto verbunden"] };
  function abgleichAnsicht(c) {
    var a = S.abgl, cs = cur(c);
    if (!a) return '<div class="amkz-hw-karte"><p class="amkz-hw-fein">Hole die Zahlen von ' + esc(c.api_casino) + "…</p></div>";
    if (a.fehler) return '<div class="amkz-hw-karte"><p class="amkz-hw-fein">' + esc(a.fehler) + '</p><button type="button" class="amkz-hw-btn" data-hw="abgleich">↻ Nochmal</button></div>';
    var s = a.summen, zeilen = a.zeilen.filter(function (z) { return S.abglFilter === "alle" || z.lage === S.abglFilter; });
    var filter = [["alle", "Alle"], ["zu_viel", "Zu viel (" + s.zu_viel + ")"], ["ohne_name", "Ohne Namen"], ["nicht_verbunden", "Nicht verbunden (" + s.nicht_verbunden + ")"], ["ok", "Passt"]].map(function (f) {
      return '<button type="button" class="amkz-hw-btn' + (S.abglFilter === f[0] ? " gold" : "") + '" data-hw-filter="' + f[0] + '">' + f[1] + "</button>";
    }).join("");
    return '<div class="amkz-hw-kacheln">' +
      kachel("Eingezahlt laut " + esc(c.api_casino), nf(Math.round(s.gemeldet)) + cs, nf(s.spieler) + " Spieler · " + zeit(a.von) + " – " + zeit(a.bis)) +
      kachel("Umsatz", nf(Math.round(s.umsatz)) + cs) +
      kachel("Verbundene Konten", nf(s.verbunden)) +
      kachel("Zu viel eingetragen", nf(s.zu_viel), nf(Math.round(s.zu_viel_betrag)) + cs + " über den echten Einzahlungen") +
      kachel("Nicht verbunden", nf(s.nicht_verbunden), nf(Math.round(s.nicht_verbunden_betrag)) + cs + " ohne Tickets") + "</div>" +
      '<div class="amkz-hw-karte"><div class="amkz-hw-reihe">' + filter + '<span class="amkz-hw-platz"></span><button type="button" class="amkz-hw-btn" data-hw="abgleich">↻ Neu holen</button><button type="button" class="amkz-hw-btn" data-hw="abgleich-csv">⬇ CSV</button></div>' +
      '<p class="amkz-hw-fein">Seit 14.10. lässt die Front nur noch so viel eintragen, wie ' + esc(c.api_casino) + " meldet. „Zu viel“ stammt also aus der Zeit davor oder aus gelösten/fremden Namen — dort im Reiter 🎟 Tickets sperren. „Nicht verbunden“ = hat bei uns eingezahlt, aber keine Tickets: gute Leute zum Anschreiben.</p>" +
      (darf() ? '<div class="amkz-hw-reihe"><input id="hwLinkMail" type="email" placeholder="E-Mail des Giveaway-Kontos"><input id="hwLinkName" placeholder="' + esc(c.api_casino) + '-Name"><button type="button" class="amkz-hw-btn" data-hw="verbinden">🔗 Für Konto verbinden</button></div>' : "") +
      (zeilen.length ? '<div class="amkz-hw-scroll"><table class="amkz-hw-tab-l"><thead><tr><th>Lage</th><th>Konto</th><th>' + esc(c.api_casino) + '-Name</th><th class="r">Eingetragen</th><th class="r">Eingezahlt</th><th class="r">Differenz</th><th class="r">Umsatz</th><th class="r">Tickets</th><th></th></tr></thead><tbody>' +
        zeilen.map(function (z) {
          var l = LAGE[z.lage] || ["grau", z.lage, z.lage];
          return '<tr><td><span class="amkz-hw-pill ' + l[0] + '" title="' + esc(l[2]) + '" style="white-space:nowrap">' + esc(l[1]) + "</span></td><td>" + (z.email ? esc(z.name || "—") + "<br><small>" + esc(z.email) + "</small>" : "—") + "</td><td>" + esc(z.username || "—") + "</td>" +
            '<td class="r">' + nf(z.eingetragen) + cs + '</td><td class="r">' + nf(z.gemeldet) + cs + '</td><td class="r"><b>' + (z.differenz > 0 ? "+" : "") + nf(z.differenz) + cs + '</b></td><td class="r">' + nf(Math.round(z.umsatz)) + cs + '</td><td class="r">' + nf(z.tickets) + "</td>" +
            "<td>" + (darf() && z.email && z.username ? '<button type="button" class="amkz-hw-x" data-hw-unlink="' + esc(z.email) + '" title="Verbindung lösen">⛓️‍💥</button>' : "") + "</td></tr>";
        }).join("") + "</tbody></table></div>" : '<p class="amkz-hw-fein">Keine Einträge in dieser Auswahl.</p>') + "</div>";
  }

  function ziehung(c) {
    var draws = (c.draws || []).filter(function (d) { return !!d.is_test === S.testmodus; });
    var offen = draws.some(function (d) { return d.status === "gezogen"; });
    var belegt = {}; draws.forEach(function (d) { if (d.status === "gezogen" || d.status === "bestaetigt") belegt[d.place] = d; });
    var frei = (c.prizes || []).filter(function (p) { return !belegt[p.place]; });
    var naechster = frei.length ? Math.min.apply(null, frei.map(function (p) { return p.place; })) : null;   // Platz 1 zuerst
    var obs = OBS_BASIS + "?key=" + encodeURIComponent(c.embed_key || "");
    return '<div class="amkz-hw-zwei"><div class="amkz-hw-karte amkz-hw-pult"><h3>🎲 Steuerpult</h3>' +
      '<div class="amkz-hw-schalterreihe"><label class="amkz-hw-schalter"><input type="checkbox" id="hwTest"' + (S.testmodus ? " checked" : "") + '><i></i><span>Testlauf (zählt nicht)</span></label>' +
      '<label class="amkz-hw-schalter"><input type="checkbox" id="hwObsLive"' + (c.obs_live ? " checked" : "") + (darf() ? "" : " disabled") + '><i></i><span>OBS zeigt die Ziehung</span></label><small class="amkz-hw-obs-hinweis">schaltet sich beim Ziehen automatisch ein</small></div>' +
      '<div class="amkz-hw-verfahren"><b>🎲 Zufall</b><span>Jedes Ticket ist ein Los · Platz 1 wird zuerst gezogen, dann 2, 3 … bis ' + ((c.prizes || []).length || 10) + "</span></div>" +
      '<div class="amkz-hw-gross">' + (naechster ? "Als Nächstes gezogen<b>Platz " + naechster + " · " + nf((c.prizes.find(function (p) { return p.place === naechster; }) || {}).amount) + " " + esc(c.currency || "€") + "</b>" : "Alle Plätze vergeben 🎉") + "</div>" +
      (darf() ? '<button type="button" class="amkz-hw-btn gold riesig" data-hw="ziehen"' + (!naechster || offen || S.laeuft ? " disabled" : "") + ">" + (offen ? "Erst Anwesenheit klären" : "🎲 Platz " + (naechster || "–") + " ziehen") + "</button>" : "") +
      '<p class="amkz-hw-fein">Gezogen wird per Zufall, angefangen mit Platz 1 (Hauptpreis), danach Platz 2 bis ' + ((c.prizes || []).length || 10) + ". Jedes Ticket ist ein Los, wer schon gezogen wurde, ist raus. Wer abwesend ist, gibt den Platz frei — dann wird er neu gezogen.</p>" +
      '<h4>📺 OBS-Browserquelle</h4><div class="amkz-hw-reihe"><input readonly value="' + esc(obs) + '" id="hwObsUrl"><button type="button" class="amkz-hw-btn" data-hw="kopieren">Kopieren</button></div>' +
      '<p class="amkz-hw-fein">Größe frei wählbar (z. B. 1920×1080), Hintergrund transparent. ' + (darf() ? '<a href="#" data-hw="key">Neuen Schlüssel erzeugen</a>' : "") + "</p>" +
      (S.testmodus && darf() ? '<button type="button" class="amkz-hw-btn" data-hw="testweg">🧹 Testziehungen löschen</button>' : "") + "</div>" +
      '<div class="amkz-hw-karte"><h3>🏆 Plätze ' + (S.testmodus ? '<span class="amkz-hw-pill">TEST</span>' : "") + "</h3><ol class=\"amkz-hw-plaetze\">" +
      (c.prizes || []).map(function (p) {
        var d = belegt[p.place];
        var weg = draws.filter(function (x) { return x.place === p.place && (x.status === "abwesend" || x.status === "ungueltig"); });
        return '<li class="' + (d ? d.status : "frei") + '"><span class="pl">#' + p.place + '</span><span class="betrag">' + nf(p.amount) + " " + esc(c.currency || "€") + "</span>" +
          (d ? '<span class="wer"><b>' + esc(d.username || d.name || d.email) + "</b><small>" + esc(d.email) + " · " + nf(d.tickets) + " Tickets" + (d.ticket_no ? " · Los #" + nf(d.ticket_no) : "") + "</small></span>" +
            (darf() ? (d.status === "gezogen" ? '<span class="akt"><button type="button" class="amkz-hw-btn gruen" data-hw-draw="' + d.id + '" data-st="bestaetigt">✓ Anwesend</button><button type="button" class="amkz-hw-btn" data-hw-draw="' + d.id + '" data-st="abwesend">Abwesend</button></span>'
              : '<span class="akt"><span class="amkz-hw-pill gruen">bestätigt</span><button type="button" class="amkz-hw-x" data-hw-draw="' + d.id + '" data-st="ungueltig" title="Ungültig">✕</button></span>') : "")
            : '<span class="wer frei">— frei —</span>') +
          (weg.length ? '<small class="weg">' + weg.map(function (w) { return esc(w.username || w.name || w.email) + " (" + (w.status === "abwesend" ? "abwesend" : "ungültig") + ")"; }).join(", ") + "</small>" : "") + "</li>";
      }).join("") + "</ol></div></div>";
  }

  /* ---------------------------------------------------------------- Aktionen */
  document.addEventListener("click", async function (e) {
    var root = byId("amkzHalloweenRoot"); if (!root || !root.contains(e.target)) return;
    var el = e.target.closest("[data-hw],[data-hw-slug],[data-hw-tab],[data-hw-status],[data-hw-del],[data-hw-draw],[data-hw-filter],[data-hw-unlink]"); if (!el) return;
    var c = k();
    try {
      if (el.dataset.hwSlug) { S.slug = el.dataset.hwSlug; S.modus = null; if (S.tab === "abgleich" && !(k() && k().api_casino)) S.tab = "uebersicht"; if (S.tab === "tickets") { S.deps = null; zeichne(); await ladeTickets(); } if (S.tab === "abgleich") { S.abgl = null; zeichne(); await ladeAbgleich(); } zeichne(); return; }
      if (el.dataset.hwTab) { S.tab = el.dataset.hwTab; if (S.tab === "tickets") { S.deps = null; zeichne(); await ladeTickets(); } if (S.tab === "abgleich") { S.abgl = null; zeichne(); await ladeAbgleich(); } zeichne(); if (S.tab === "einstellungen") summeZeigen(); return; }
      if (el.dataset.hwFilter) { S.abglFilter = el.dataset.hwFilter; zeichne(); return; }
      if (el.dataset.hwUnlink) { if (!confirm("Verbindung von " + el.dataset.hwUnlink + " lösen? Die Person kann danach einen anderen Namen verbinden.")) return; await api("casino_unlink", { email: el.dataset.hwUnlink, casino: c.api_casino }); toast("Abgleich", "Verbindung gelöst."); await ladeAbgleich(); zeichne(); return; }
      if (el.dataset.hwStatus) { var neu = STATUS_NAECHST[el.dataset.st] || "OFFEN"; el.disabled = true; await api("deposit_status", { id: el.dataset.hwStatus, status: neu }); var r = S.deps.deposits.find(function (x) { return x.id === el.dataset.hwStatus; }); if (r) r.status = neu; zeichne(); return; }
      if (el.dataset.hwDel) { if (!confirm("Diesen Eintrag wirklich löschen? (Wird im Protokoll gesichert.)")) return; await api("deposit_delete", { id: el.dataset.hwDel }); await ladeTickets(); zeichne(); return; }
      if (el.dataset.hwDraw) { var st = el.dataset.st; if (st === "ungueltig" && !confirm("Ziehung ungültig setzen? Der Platz wird wieder frei.")) return; await api("draw_status", { id: el.dataset.hwDraw, status: st }); await laden(); return; }
      var a = el.dataset.hw;
      if (a === "login") { e.preventDefault(); await hubLogin(byId("amkzHwMail").value.trim(), byId("amkzHwPass").value); await laden(); return; }
      if (a === "neu") { await laden(); return; }
      if (a === "speichern") { await speichern(); return; }
      if (a === "preis+") { var box = byId("hwPreise"), n = box.querySelectorAll(".amkz-hw-preis").length + 1; box.insertAdjacentHTML("beforeend", preisZeile({ place: n, amount: 0 })); summeZeigen(); return; }
      if (a === "preis-") { el.closest(".amkz-hw-preis").remove(); summeZeigen(); return; }
      if (a === "suchen") { S.suche = byId("hwSuche").value.trim(); await ladeTickets(); zeichne(); return; }
      if (a === "csv") { csv(); return; }
      if (a === "abgleich") { S.abgl = null; zeichne(); await ladeAbgleich(); zeichne(); return; }
      if (a === "abgleich-csv") { abgleichCsv(c); return; }
      if (a === "verbinden") { var r2 = await api("casino_link_admin", { campaign: c.slug, email: byId("hwLinkMail").value.trim(), username: byId("hwLinkName").value.trim() }); if (!r2.ok) throw new Error(r2.error); toast("Abgleich", "Verbunden mit " + r2.username + "."); await ladeAbgleich(); zeichne(); return; }
      if (a === "kopieren") { var i = byId("hwObsUrl"); i.select(); try { await navigator.clipboard.writeText(i.value); } catch (_) { document.execCommand("copy"); } toast("OBS", "Link kopiert."); return; }
      if (a === "key") { e.preventDefault(); if (!confirm("Neuen Schlüssel erzeugen? Der alte OBS-Link hört dann auf zu funktionieren.")) return; await api("embed_key_new", { campaign: c.slug }); await laden(); return; }
      if (a === "testweg") { var t = await api("test_clear", { campaign: c.slug }); toast("Test", t.deleted + " Testziehungen gelöscht."); await laden(); return; }
      if (a === "ziehen") {
        S.laeuft = true; el.disabled = true; el.textContent = "🎲 Ziehe…";
        // OBS automatisch einschalten, sonst bleibt die Show auf „Die Ziehung“ stehen und es läuft keine Animation
        if (!c.obs_live) { try { await api("campaign_save", { campaign: { slug: c.slug, obs_live: true } }); c.obs_live = true; } catch (_) {} }
        var d = await api("draw", { campaign: c.slug, mode: "zufall", order: "auf", test: S.testmodus });
        toast("Gezogen", "Platz " + d.draw.place + ": " + (d.draw.username || d.draw.name || d.draw.email) + " (" + nf(d.draw.tickets) + " Tickets)");
        S.laeuft = false; await laden(); return;
      }
    } catch (err) { S.laeuft = false; toast("Halloween-Giveaways", err.message, "error"); zeichne(); }
  });
  document.addEventListener("change", async function (e) {
    var root = byId("amkzHalloweenRoot"); if (!root || !root.contains(e.target)) return;
    if (e.target.id === "hwTest") { S.testmodus = e.target.checked; zeichne(); }
    if (e.target.id === "hwZugModus") S.modus = e.target.value;
    if (e.target.classList.contains("hwCasino")) e.target.closest(".amkz-hw-chip").classList.toggle("on", e.target.checked);
    if (e.target.id === "hwObsLive") { try { await api("campaign_save", { campaign: { slug: S.slug, obs_live: e.target.checked } }); await laden(); } catch (err) { toast("OBS", err.message, "error"); } }
  });
  document.addEventListener("input", function (e) { if (e.target.classList && e.target.classList.contains("hwBetrag")) summeZeigen(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Enter" && e.target.id === "hwSuche") { var b = document.querySelector('[data-hw="suchen"]'); if (b) b.click(); } });

  function csv() {
    var rows = (S.deps && S.deps.deposits) || [];
    var q = function (v) { return '"' + String(v == null ? "" : v).replace(/"/g, '""') + '"'; };
    var txt = ["Datum;Name;E-Mail;Casino;Betrag;Tickets;Status"].concat(rows.map(function (r) { return [zeit(r.created_at), r.name, r.email, r.casino, r.amount, r.tickets, r.status].map(q).join(";"); })).join("\n");
    var a = document.createElement("a"); a.href = URL.createObjectURL(new Blob(["﻿" + txt], { type: "text/csv" })); a.download = "halloween-" + S.slug + ".csv"; a.click();
  }

  function abgleichCsv(c) {
    var rows = (S.abgl && S.abgl.zeilen) || [];
    var q = function (v) { return '"' + String(v == null ? "" : v).replace(/"/g, '""') + '"'; };
    var txt = ["Lage;Name;E-Mail;" + c.api_casino + "-Name;Eingetragen;Eingezahlt;Differenz;Umsatz;Tickets"].concat(rows.map(function (z) { return [(LAGE[z.lage] || [0, 0, z.lage])[2], z.name, z.email, z.username, z.eingetragen, z.gemeldet, z.differenz, z.umsatz, z.tickets].map(q).join(";"); })).join("\n");
    var a = document.createElement("a"); a.href = URL.createObjectURL(new Blob(["\ufeff" + txt], { type: "text/csv" })); a.download = "abgleich-" + S.slug + ".csv"; a.click();
  }

  var zuvor = AMKZ.loadView;
  AMKZ.loadView = async function hwChain(view, options) {
    var r = await (zuvor ? zuvor.call(this, view, options) : undefined);
    if (view === "halloween") await laden();
    return r;
  };
  AMKZ.halloween = { laden: laden, api: api };
})();


/* ============================================================================
   SCHUBLADE-FIX (11.10.2026, iPhone)
   Ohne Schleier-Element braucht „daneben tippen = schließen" einen eigenen Weg.
   Fängt den Tipp außerhalb der offenen Schublade ab, damit dahinter nichts
   ausgelöst wird, und schließt sie.
   ========================================================================== */
(function () {
  "use strict";
  if (window.__amkzSchubladeFix) return; window.__amkzSchubladeFix = true;
  function zu(e) {
    if (!document.body.classList.contains("amkz-mobile-menu-open")) return;
    var t = e.target;
    if (t.closest && (t.closest(".amkz-sidebar") || t.closest('[data-tab="__mehr"]') || t.closest(".amkz-mobile-menu-btn"))) return;
    e.preventDefault(); e.stopPropagation();
    document.body.classList.remove("amkz-mobile-menu-open");
  }
  document.addEventListener("click", zu, true);
})();

/* ============================================================================
   FTD-BILANZ — FTDs, ReDepos und Depo-Volumen je Monat        (22.10.2026)
   ----------------------------------------------------------------------------
   Marcel: „Wir brauchen eine Struktur mit FTD und ReDepo pro Monat, was
   wurde gepusht — Gesamtdepo, FTD-Zahl, Depo-Anzahl, First-Deposit-Range.
   Wenn ich z. B. Royal Partners bekomme, muss ich die First Deposits so
   halten, dass es gleichwertig zum Deal ist." Dazu: „Ich will die Summe,
   die wir erhalten haben, selbst eintragen können."

   Rechnung je Monat und Bezug (alle / Partnergruppe / Casino). Stand
   22.10. abends, nach Marcels Klarstellung: „Die Summe, die wir erhalten
   haben, muss mindestens wieder eingespielt werden an FTD. Ist ein FTD
   5.000 €, haben wir eine Einspielung von 5.000 €." und „Ein ReDepo auf
   eine Person, die sich letzten Monat registriert hat, zählt dort nicht."
     Erhalten     = von Hand eingetragen (amk_ftd_bilanz_erhalten)
     Soll         = Erhalten × Faktor aus der Vorgabe (Standard 1,00)
     Eingespielt  = First Deposits des Monats + ReDepos auf GENAU DIESE
                    FTDs. Zuordnung: FTD-Verknüpfung der ReDepo-Erinnerung
                    (metadata.ftd_entry_id), sonst gleiches Casino + gleiche
                    E-Mail / Wallet / Name wie ein FTD dieses Monats.
     Noch offen   = Soll − Eingespielt
     Übrig        = Erhalten − alle Depos des Monats
   Ein aus CPA/Hybrid hochgerechneter „Deal-Wert" war vorher die Messlatte
   und hat verwirrt — er ist raus.

   Vorgaben (amk_ftd_bilanz_vorgaben) gelten für Casino -> sonst seine
   Partnergruppe -> sonst „alle". So reicht eine Vorgabe für Royal Partners
   für alle sechs Casinos, einzelne lassen sich trotzdem abweichend setzen.

   Daten: entries (FTD/REDEPO) der letzten 12 Monate, seitenweise geladen —
   PostgREST liefert sonst höchstens 1.000 Zeilen und der Monat wäre
   stillschweigend zu klein.
============================================================================ */
(function () {
  "use strict";

  var MONATE_ZURUECK = 12;
  var RANGES = [0, 20, 50, 100, 250, 500, 1000];      // Untergrenzen der First-Deposit-Stufen

  var S = {
    monat: monatVon(new Date()),   // "2026-10"
    bezug: "alle",
    rows: [], erhalten: [], vorgaben: {},
    geladen: false, laedt: false, fehlt: null,
  };

  try { var gemerkt = localStorage.getItem("amkz_fb_bezug"); if (gemerkt) S.bezug = gemerkt; } catch (_) {}

  /* ---------- kleine Helfer ---------- */
  function sb() { return AMKZ.supabase; }
  function num(v) { var n = Number(v); return Number.isFinite(n) ? n : 0; }
  function esc(v) { return String(v == null ? "" : v).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  var EUR0 = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
  var EUR2 = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var ZAHL = new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 });
  var ZAHL2 = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function eur(v) { return Math.abs(v) >= 100 ? EUR0.format(v) : EUR2.format(v); }
  function pad(n) { return (n < 10 ? "0" : "") + n; }
  function monatVon(d) { return d.getFullYear() + "-" + pad(d.getMonth() + 1); }
  function monatPlus(m, delta) { var p = m.split("-"); var d = new Date(+p[0], +p[1] - 1 + delta, 1); return monatVon(d); }
  function monatErster(m) { return m + "-01"; }
  function monatLetzter(m) { var p = m.split("-"); var d = new Date(+p[0], +p[1], 0); return m + "-" + pad(d.getDate()); }
  function monatTage(m) { var p = m.split("-"); return new Date(+p[0], +p[1], 0).getDate(); }
  function monatName(m, kurz) {
    var p = m.split("-");
    return new Date(+p[0], +p[1] - 1, 1).toLocaleDateString("de-DE", kurz ? { month: "short", year: "2-digit" } : { month: "long", year: "numeric" });
  }
  function toast(t, m, typ) { if (AMKZ.toast) AMKZ.toast(t, m || "", typ || "success"); }
  function wer() { var m = AMKZ.state && AMKZ.state.member; return (m && (m.name || m.email)) || "AMK"; }
  function darf() { return !!(AMKZ.state && AMKZ.state.permissions && AMKZ.state.permissions.ftdbilanz); }

  function casinos() { return (AMKZ.state && AMKZ.state.casinos) || []; }
  function partner() { return (AMKZ.state && AMKZ.state.partners) || []; }
  function casinoById(id) { return casinos().filter(function (c) { return c.id === id; })[0] || null; }
  function partnerById(id) { return partner().filter(function (p) { return p.id === id; })[0] || null; }
  function partnerVonEntry(e) {
    if (e.partner_group_id) return e.partner_group_id;
    var c = casinoById(e.casino_id); return c ? c.partner_group_id : null;
  }
  function bezugName(b) {
    if (!b || b === "alle") return "Alle Partner";
    var p = b.split(":");
    if (p[0] === "partner") { var g = partnerById(p[1]); return g ? g.name : "Partnergruppe"; }
    var c = casinoById(p[1]); return c ? c.name : "Casino";
  }
  function passt(e, b) {
    if (b === "alle") return true;
    var p = b.split(":");
    if (p[0] === "casino") return e.casino_id === p[1];
    return partnerVonEntry(e) === p[1];
  }
  function typ(e) { return String(e.entry_type || "").toUpperCase(); }

  /* ---------- Laden ---------- */
  async function alleSeiten(bauen) {
    var aus = [], von = 0, SEITE = 1000;
    for (var i = 0; i < 50; i++) {
      var r = await bauen().range(von, von + SEITE - 1);
      if (r.error) throw r.error;
      aus = aus.concat(r.data || []);
      if (!r.data || r.data.length < SEITE) break;
      von += SEITE;
    }
    return aus;
  }

  async function laden() {
    if (S.laedt) { S.nochmal = true; return; }
    S.laedt = true; S.nochmal = false; render();
    try {
      if (AMKZ.data) {
        await Promise.all([
          AMKZ.data.loadCasinos && AMKZ.data.loadCasinos(false),
          AMKZ.data.loadPartners && AMKZ.data.loadPartners(false),
        ]);
      }
      var von = monatErster(monatPlus(S.monat, -(MONATE_ZURUECK - 1)));
      var bis = monatLetzter(S.monat);
      var rows = await alleSeiten(function () {
        return sb().from("entries")
          .select("id,entry_date,entry_type,amount,casino_id,partner_group_id,payment_status,customer_email,customer_name,wallet_address,metadata")
          .in("entry_type", ["FTD", "REDEPO", "ftd", "redepo"])
          .gte("entry_date", von).lte("entry_date", bis)
          .order("entry_date", { ascending: true }).order("id", { ascending: true });
      });
      S.rows = rows.filter(function (e) { return !/^(cancel|storn|void)/i.test(String(e.payment_status || "")); });

      S.fehlt = null;
      var er = await sb().from("amk_ftd_bilanz_erhalten").select("*").gte("monat", von).lte("monat", bis);
      if (er.error) { S.fehlt = "erhalten"; S.erhalten = []; } else S.erhalten = er.data || [];
      var vg = await sb().from("amk_ftd_bilanz_vorgaben").select("*");
      if (vg.error) { S.fehlt = S.fehlt || "vorgaben"; S.vorgaben = {}; }
      else { S.vorgaben = {}; (vg.data || []).forEach(function (v) { S.vorgaben[v.bezug] = v; }); }
      S.geladen = true;
    } catch (e) {
      console.error("FTD-Bilanz laden", e);
      toast("FTD-Bilanz", "Daten konnten nicht geladen werden: " + (e.message || e), "error");
    } finally {
      S.laedt = false; render();
      if (S.nochmal) laden();
    }
  }

  /* ---------- ReDepo -> FTD desselben Monats ---------- */
  function idSchluessel(e) {
    var c = e.casino_id || "", l = [];
    var mail = String(e.customer_email || "").trim().toLowerCase();
    var wal = String(e.wallet_address || "").trim().toLowerCase();
    var nam = String(e.customer_name || "").trim().toLowerCase();
    if (mail) l.push(c + "|m|" + mail);
    if (wal) l.push(c + "|w|" + wal);
    if (nam) l.push(c + "|n|" + nam);
    return l;
  }
  // alle FTDs des Monats, unabhängig vom gewählten Bezug — gezählt wird je Casino
  function ftdSchluessel(von, bis) {
    var ids = {}, keys = {};
    S.rows.forEach(function (e) {
      if (typ(e) !== "FTD") return;
      var d = String(e.entry_date || "").slice(0, 10); if (d < von || d > bis) return;
      ids[e.id] = 1;
      idSchluessel(e).forEach(function (k) { keys[k] = 1; });
    });
    return { ids: ids, keys: keys };
  }
  function gehoertZuFtd(e, z) {
    var link = e.metadata && (e.metadata.ftd_entry_id || e.metadata.ftdEntryId);
    if (link) return !!z.ids[link];
    return idSchluessel(e).some(function (k) { return z.keys[k]; });
  }

  /* ---------- Monatsrechnung ---------- */
  function rechne(m, b) {
    var von = monatErster(m), bis = monatLetzter(m);
    var drin = S.rows.filter(function (e) { var d = String(e.entry_date || "").slice(0, 10); return d >= von && d <= bis && passt(e, b); });
    var ftd = drin.filter(function (e) { return typ(e) === "FTD"; });
    var red = drin.filter(function (e) { return typ(e) === "REDEPO"; });
    var zuordnung = ftdSchluessel(von, bis);
    var vg = vorgabeFuer(b), v = vg ? vg.v : {};
    var r = {
      monat: m, bezug: b, ftds: ftd, casinos: {}, unter: 0,
      ftdZahl: ftd.length, ftdSumme: 0,
      redZahl: red.length, redSumme: 0, redNeuZahl: 0, redNeuSumme: 0,
      faktor: v.ziel_faktor != null ? num(v.ziel_faktor) : 1,
    };
    ftd.forEach(function (e) { r.ftdSumme += num(e.amount); });
    red.forEach(function (e) {
      e.__neu = gehoertZuFtd(e, zuordnung);
      r.redSumme += num(e.amount);
      if (e.__neu) { r.redNeuZahl++; r.redNeuSumme += num(e.amount); }
    });
    r.depoSumme = r.ftdSumme + r.redSumme;
    r.avgFtd = r.ftdZahl ? r.ftdSumme / r.ftdZahl : 0;
    r.redJeFtd = r.ftdZahl ? r.redNeuZahl / r.ftdZahl : 0;
    r.eingespielt = r.ftdSumme + r.redNeuSumme;

    drin.forEach(function (e) {
      var cid = e.casino_id || "—";
      var c = r.casinos[cid] || (r.casinos[cid] = { id: cid, ftd: [], ftdSumme: 0, redZahl: 0, redNeuZahl: 0, redNeuSumme: 0 });
      if (typ(e) === "FTD") { c.ftd.push(e); c.ftdSumme += num(e.amount); return; }
      c.redZahl++;
      if (e.__neu) { c.redNeuZahl++; c.redNeuSumme += num(e.amount); }
    });
    Object.keys(r.casinos).forEach(function (cid) {
      var c = r.casinos[cid], cas = casinoById(cid);
      c.minDep = cas ? num(cas.cpa_min_deposit) : 0;   // Baseline: darunter zahlt der Partner keinen CPA
      c.unter = c.minDep ? c.ftd.filter(function (e) { return num(e.amount) < c.minDep; }).length : 0;
      c.eingespielt = c.ftdSumme + c.redNeuSumme;
      r.unter += c.unter;
    });

    r.erhalten = erhaltenFuer(m, b);
    r.hatErhalten = r.erhalten.zeilen.length > 0;
    r.soll = r.erhalten.summe * r.faktor;
    /* Nachtschicht 31.10.: bei „Alle“ zählt gegen das Soll nur, was bei Partnern/Casinos mit eingetragenem Erhalten eingespielt wurde */
    r.einErhalten = r.eingespielt;
    if (b === "alle" && r.hatErhalten) {
      var bz = {};
      r.erhalten.zeilen.forEach(function (x) { if (x.bezug) bz[x.bezug] = true; });
      r.einErhalten = Object.keys(bz).reduce(function (s, k) {
        var q = k.split(":");
        if (q[0] === "casino") { var c = casinoById(q[1]); if (c && bz["partner:" + c.partner_group_id]) return s; }
        return s + rechne(m, k).eingespielt;
      }, 0);
    }
    r.offen = Math.max(0, r.soll - r.einErhalten);
    r.quote = r.soll > 0 ? r.einErhalten / r.soll : null;
    r.uebrig = r.erhalten.summe - r.depoSumme;
    return r;
  }

  function erhaltenFuer(m, b) {
    var erster = monatErster(m);
    var l = S.erhalten.filter(function (x) { return String(x.monat).slice(0, 10) === erster; });
    var treffer;
    if (b === "alle") treffer = l;
    else {
      var p = b.split(":");
      if (p[0] === "casino") treffer = l.filter(function (x) { return x.bezug === b; });
      else treffer = l.filter(function (x) {
        if (x.bezug === b) return true;
        var q = x.bezug.split(":"); if (q[0] !== "casino") return false;
        var c = casinoById(q[1]); return !!c && c.partner_group_id === p[1];
      });
    }
    var summe = 0; treffer.forEach(function (x) { summe += num(x.betrag); });
    var eigen = l.filter(function (x) { return x.bezug === b; })[0] || null;
    return { summe: summe, zeilen: treffer, eigen: eigen };
  }

  function vorgabeFuer(b) {
    if (S.vorgaben[b]) return { v: S.vorgaben[b], von: b };
    var p = (b || "").split(":");
    if (p[0] === "casino") {
      var c = casinoById(p[1]);
      if (c && c.partner_group_id && S.vorgaben["partner:" + c.partner_group_id]) return { v: S.vorgaben["partner:" + c.partner_group_id], von: "partner:" + c.partner_group_id };
    }
    if (b !== "alle" && S.vorgaben.alle) return { v: S.vorgaben.alle, von: "alle" };
    return null;
  }

  /* ---------- Prüfung gegen die Vorgabe ---------- */
  function pruefe(r, vg) {
    var v = vg ? vg.v : {}, l = [];
    if (r.hatErhalten) {
      l.push({ titel: "Erhaltenes wieder eingespielt", ist: eur(r.einErhalten), soll: eur(r.soll) + (r.faktor !== 1 ? " (" + ZAHL2.format(r.faktor) + "× Erhalten)" : ""),
        anteil: r.soll ? r.einErhalten / r.soll : 1, ok: r.offen <= 0.005,
        rest: r.offen > 0.005 ? "noch " + eur(r.offen) + " einspielen" : "eingespielt" });
    }
    if (v.min_avg_ftd != null && num(v.min_avg_ftd) > 0) {
      var sa = num(v.min_avg_ftd), feh = Math.max(0, sa * r.ftdZahl - r.ftdSumme);
      l.push({ titel: "Ø First Deposit", ist: eur(r.avgFtd), soll: "≥ " + eur(sa),
        anteil: sa ? r.avgFtd / sa : 1, ok: r.ftdZahl > 0 && r.avgFtd >= sa,
        rest: !r.ftdZahl ? "noch keine FTDs" : feh > 0 ? "es fehlen " + eur(feh) + " FTD-Volumen" : "gehalten" });
    }
    if (v.redepos_je_ftd != null && num(v.redepos_je_ftd) > 0) {
      var sr = num(v.redepos_je_ftd), braucht = Math.ceil(sr * r.ftdZahl - 1e-9), fr = Math.max(0, braucht - r.redNeuZahl);
      l.push({ titel: "ReDepos je FTD (dieser Monat)", ist: ZAHL2.format(r.redJeFtd), soll: "≥ " + ZAHL2.format(sr),
        anteil: sr ? r.redJeFtd / sr : 1, ok: fr === 0,
        rest: fr > 0 ? "noch " + fr + " ReDepo" + (fr === 1 ? "" : "s") : "gehalten" });
    }
    if ((v.fd_von != null && v.fd_von !== "") || (v.fd_bis != null && v.fd_bis !== "")) {
      var a = v.fd_von != null ? num(v.fd_von) : 0, z = v.fd_bis != null && v.fd_bis !== "" ? num(v.fd_bis) : Infinity;
      var inn = r.ftds.filter(function (e) { var x = num(e.amount); return x >= a && x <= z; }).length;
      l.push({ titel: "First Deposits in der Spanne", ist: inn + " von " + r.ftdZahl, soll: eur(a) + " – " + (z === Infinity ? "offen" : eur(z)),
        anteil: r.ftdZahl ? inn / r.ftdZahl : 0, ok: r.ftdZahl > 0 && inn === r.ftdZahl,
        rest: !r.ftdZahl ? "noch keine FTDs" : inn === r.ftdZahl ? "alle drin" : (r.ftdZahl - inn) + " außerhalb" });
    }
    return l;
  }

  /* ---------- Darstellung ---------- */
  function root() { return document.getElementById("amkzFtdbilanzRoot"); }

  function bezugOptionen() {
    var h = '<option value="alle"' + (S.bezug === "alle" ? " selected" : "") + ">Alle Partner</option>";
    var p = partner().filter(function (g) { return g.status !== "inactive" || S.bezug === "partner:" + g.id; }).sort(function (a, b) { return String(a.name).localeCompare(String(b.name), "de"); });   // Nachtschicht 31.10.: inaktive Dubletten ausblenden
    if (p.length) {
      h += '<optgroup label="Partnergruppen">';
      p.forEach(function (g) { var k = "partner:" + g.id; h += '<option value="' + k + '"' + (S.bezug === k ? " selected" : "") + ">" + esc(g.name) + "</option>"; });
      h += "</optgroup>";
    }
    var c = casinos().filter(function (x) { return x.status !== "inactive" || S.bezug === "casino:" + x.id; }).sort(function (a, b) { return String(a.name).localeCompare(String(b.name), "de"); });
    if (c.length) {
      h += '<optgroup label="Casinos">';
      c.forEach(function (x) { var k = "casino:" + x.id; h += '<option value="' + k + '"' + (S.bezug === k ? " selected" : "") + ">" + esc(x.name) + "</option>"; });
      h += "</optgroup>";
    }
    return h;
  }

  function ring(r) {
    var U = 2 * Math.PI * 52;
    var anteil = r.quote == null ? 0 : r.quote;
    var zeig = Math.max(0, Math.min(anteil, 1));
    var klasse = r.quote == null ? "leer" : anteil >= 1 ? "ok" : anteil >= 0.8 ? "knapp" : "unter";
    var zahl = r.quote == null ? "—" : Math.round(anteil * 100) + "%";
    var satz = !r.hatErhalten
      ? "Trag ein, was ihr für " + esc(monatName(S.monat)) + " erhalten habt — dann siehst du, wie viel davon noch eingespielt werden muss."
      : r.offen <= 0.005 ? "Das Erhaltene ist komplett wieder eingespielt."
      : "Noch <b>" + eur(r.offen) + "</b> einspielen — als FTD oder ReDepo auf FTDs dieses Monats.";
    return '<div class="amkz-fb-ring ' + klasse + '">' +
      '<svg viewBox="0 0 120 120" aria-hidden="true"><circle class="bahn" cx="60" cy="60" r="52"/>' +
      '<circle class="wert" cx="60" cy="60" r="52" stroke-dasharray="' + (U * zeig).toFixed(1) + " " + U.toFixed(1) + '" transform="rotate(-90 60 60)"/></svg>' +
      '<div class="mitte"><b>' + zahl + "</b><small>eingespielt</small></div></div>" +
      '<div class="amkz-fb-ringtext"><small>' + esc(monatName(S.monat)) + " · " + esc(bezugName(S.bezug)) + "</small>" +
      "<p>" + satz + "</p>" +
      '<div class="amkz-fb-ringzahlen"><span>Erhalten <b>' + (r.hatErhalten ? eur(r.erhalten.summe) : "—") + "</b></span>" +
      "<span>Eingespielt <b>" + eur(r.eingespielt) + "</b></span>" +
      (Math.abs(r.einErhalten - r.eingespielt) > 0.005 ? "<span>davon mit Erhalten <b>" + eur(r.einErhalten) + "</b></span>" : "") +
      (r.faktor !== 1 ? "<span>Soll <b>" + eur(r.soll) + "</b></span>" : "") + "</div></div>";
  }

  function kpi(titel, wert, unter, extra) {
    return '<div class="amkz-kpi-card amkz-fb-kpi' + (extra ? " " + extra : "") + '"><small>' + titel + "</small><strong>" + wert + "</strong><span>" + unter + "</span></div>";
  }

  function kpis(r) {
    var vorher = rechne(monatPlus(S.monat, -1), S.bezug);
    function trend(a, b) {
      if (!b) return "";
      var d = (a - b) / b * 100;
      return ' <i class="' + (d >= 0 ? "auf" : "ab") + '">' + (d >= 0 ? "▲ " : "▼ ") + Math.abs(Math.round(d)) + "%</i>";
    }
    var alt = r.redZahl - r.redNeuZahl;
    return '<div class="amkz-kpi-grid amkz-fb-kpis">' +
      '<button type="button" class="amkz-kpi-card amkz-fb-kpi amkz-fb-erhalten gold" data-fb="erhalten"><small>Erhalten ✎</small><strong>' + (r.hatErhalten ? eur(r.erhalten.summe) : "—") + "</strong><span>" +
        (r.hatErhalten ? "muss wieder eingespielt werden" : gruppenHinweis() || "tippen zum Eintragen") + "</span></button>" +
      kpi("Eingespielt", eur(r.eingespielt), "FTD " + eur(r.ftdSumme) + " + ReDepo " + eur(r.redNeuSumme) + trend(r.eingespielt, vorher.eingespielt)) +
      kpi("Noch einspielen", r.hatErhalten ? eur(r.offen) : "—", r.hatErhalten ? (r.offen > 0.005 ? "bis das Erhaltene drin ist" : "✓ erledigt") : "erst mit Erhalten", r.hatErhalten ? (r.offen > 0.005 ? "minus" : "plus") : "") +
      kpi("Übrig", r.hatErhalten ? eur(r.uebrig) : "—", "Erhalten − alle Depos", r.hatErhalten ? (r.uebrig >= 0 ? "plus" : "minus") : "") +
      kpi("FTDs", ZAHL.format(r.ftdZahl), eur(r.ftdSumme) + trend(r.ftdZahl, vorher.ftdZahl)) +
      kpi("ReDepos", ZAHL.format(r.redNeuZahl), "auf FTDs dieses Monats" + (alt > 0 ? " · " + alt + " ältere zählen nicht" : "")) +
      kpi("Ø First Deposit", eur(r.avgFtd), r.unter ? r.unter + " unter Baseline" : "Gesamtdepo " + eur(r.depoSumme)) +
      kpi("Depo-Anzahl", ZAHL.format(r.ftdZahl + r.redNeuZahl), ZAHL2.format(r.ftdZahl ? (r.ftdZahl + r.redNeuZahl) / r.ftdZahl : 0) + " Depos je FTD") +
      "</div>";
  }

  // Casino-Ansicht ohne eigenen Eintrag: zeigen, dass die Zahlung auf Gruppenebene steht.
  function gruppenHinweis() {
    if (S.bezug.indexOf("casino:") !== 0) return "";
    var c = casinoById(S.bezug.slice(7)); if (!c || !c.partner_group_id) return "";
    var g = erhaltenFuer(S.monat, "partner:" + c.partner_group_id).eigen;
    return g ? esc(bezugName("partner:" + c.partner_group_id)) + " gesamt: " + eur(num(g.betrag)) : "";
  }

  function checkKarte(r) {
    var vg = vorgabeFuer(S.bezug), l = pruefe(r, vg);
    var quelle = vg ? (vg.von === S.bezug ? "eigene Vorgabe" : "Vorgabe von " + esc(bezugName(vg.von))) : "noch keine Vorgabe — Soll ist 1:1 das Erhaltene";
    var h = '<div class="amkz-card amkz-fb-check"><div class="amkz-card-header"><h3>Vorgabe halten</h3>' +
      '<button type="button" class="amkz-secondary-btn" data-fb="vorgabe">Vorgabe ' + (vg && vg.von === S.bezug ? "ändern" : "setzen") + "</button></div>" +
      '<p class="amkz-fb-fein">' + quelle + (vg && vg.v.notiz ? " · " + esc(vg.v.notiz) : "") + "</p>";
    if (!l.length) h += '<div class="amkz-empty">Für diesen Monat ist noch nichts erhalten eingetragen.</div>';
    l.forEach(function (x) {
      var p = Math.max(0, Math.min(1, x.anteil || 0));
      h += '<div class="amkz-fb-ziel ' + (x.ok ? "ok" : "offen") + '"><div class="kopf"><b>' + x.titel + "</b><span>" + x.ist + " <em>/ " + x.soll + "</em></span></div>" +
        '<div class="balken"><i style="width:' + (p * 100).toFixed(1) + '%"></i></div><small>' + (x.ok ? "✓ " : "") + x.rest + "</small></div>";
    });
    return h + "</div>";
  }

  function rangeKarte(r) {
    var vg = vorgabeFuer(S.bezug), v = vg ? vg.v : {};
    var a = v.fd_von != null && v.fd_von !== "" ? num(v.fd_von) : null, z = v.fd_bis != null && v.fd_bis !== "" ? num(v.fd_bis) : null;
    var minDeps = {};
    Object.keys(r.casinos).forEach(function (k) { if (r.casinos[k].minDep) minDeps[r.casinos[k].minDep] = 1; });
    var stufen = RANGES.map(function (u, i) { var o = RANGES[i + 1]; return { u: u, o: o, zahl: 0, summe: 0 }; });
    r.ftds.forEach(function (e) {
      var x = num(e.amount);
      for (var i = stufen.length - 1; i >= 0; i--) if (x >= stufen[i].u) { stufen[i].zahl++; stufen[i].summe += x; break; }
    });
    var max = Math.max.apply(null, stufen.map(function (s) { return s.zahl; }).concat([1]));
    var h = '<div class="amkz-card amkz-fb-range"><div class="amkz-card-header"><h3>First Deposit Range</h3><span class="amkz-fb-fein">' + r.ftdZahl + " FTDs · Ø " + eur(r.avgFtd) + "</span></div>";
    stufen.forEach(function (s) {
      var label = s.o == null ? "ab " + ZAHL.format(s.u) + " €" : ZAHL.format(s.u) + "–" + ZAHL.format(s.o - 1) + " €";
      if (s.u === 0) label = "unter " + ZAHL.format(s.o) + " €";
      // grün nur, wenn die ganze Stufe in der Soll-Spanne liegt
      var inSoll = (a != null || z != null) && s.u >= (a || 0) && (z == null || (s.o != null && s.o - 1 <= z));
      var unterBase = Object.keys(minDeps).some(function (m) { return s.o != null && s.o <= num(m); });
      h += '<div class="amkz-fb-stufe' + (inSoll ? " soll" : "") + (unterBase ? " unter" : "") + '"><span class="lab">' + label + "</span>" +
        '<div class="balken"><i style="width:' + (s.zahl / max * 100).toFixed(1) + '%"></i></div>' +
        '<span class="zahl"><b>' + s.zahl + "</b> · " + eur(s.summe) + "</span></div>";
    });
    var legende = [];
    if (a != null || z != null) legende.push('<span class="soll">Soll-Spanne ' + (a != null ? eur(a) : "0 €") + " – " + (z != null ? eur(z) : "offen") + "</span>");
    if (Object.keys(minDeps).length) legende.push('<span class="unter">unter Baseline (' + Object.keys(minDeps).map(function (m) { return eur(num(m)); }).join(", ") + ") = kein CPA</span>");
    if (legende.length) h += '<div class="amkz-fb-legende">' + legende.join("") + "</div>";
    return h + "</div>";
  }

  function schmal() { return window.matchMedia && window.matchMedia("(max-width:640px)").matches; }

  function verlaufKarte() {
    var monate = [];
    for (var i = MONATE_ZURUECK - 1; i >= 0; i--) monate.push(rechne(monatPlus(S.monat, -i), S.bezug));
    // Am Handy nur die letzten sechs Monate im Diagramm, in Originalgröße — zwölf
    // Säulen auf 343 px machen die Beschriftung unlesbar. Die Tabelle zeigt alle zwölf.
    var bild = schmal() ? monate.slice(-6) : monate;
    var max = Math.max.apply(null, bild.map(function (m) { return Math.max(m.ftdSumme + m.redNeuSumme, m.soll); }).concat([1]));
    var W = schmal() ? 340 : 720, H = 220, P = 34, bw = (W - P) / bild.length;
    var svg = '<svg class="amkz-fb-chart" viewBox="0 0 ' + W + " " + (H + 26) + '" preserveAspectRatio="none" role="img" aria-label="Depo-Volumen je Monat">';
    [0.25, 0.5, 0.75, 1].forEach(function (t) {
      var y = H - t * (H - 10);
      svg += '<line class="gitter" x1="' + P + '" x2="' + W + '" y1="' + y + '" y2="' + y + '"/><text class="achse" x="' + (P - 4) + '" y="' + (y + 3) + '" text-anchor="end">' + kurzEur(max * t) + "</text>";
    });
    var punkte = "";
    bild.forEach(function (m, i) {
      var x = P + i * bw + bw * 0.18, w = bw * 0.64;
      var hF = m.ftdSumme / max * (H - 10), hR = m.redNeuSumme / max * (H - 10);
      var aktiv = m.monat === S.monat ? " aktiv" : "";
      svg += '<g class="monat' + aktiv + '" data-fb-monat="' + m.monat + '"><rect class="treffer" x="' + (P + i * bw) + '" y="0" width="' + bw + '" height="' + (H + 26) + '"/>' +
        '<rect class="ftd" x="' + x + '" y="' + (H - hF) + '" width="' + w + '" height="' + Math.max(0, hF) + '" rx="3"/>' +
        '<rect class="red" x="' + x + '" y="' + (H - hF - hR) + '" width="' + w + '" height="' + Math.max(0, hR) + '" rx="3"/>' +
        '<text class="achse" x="' + (x + w / 2) + '" y="' + (H + 16) + '" text-anchor="middle">' + esc(monatName(m.monat, true)) + "</text>" +
        "<title>" + esc(monatName(m.monat)) + ": eingespielt " + eur(m.eingespielt) + (m.hatErhalten ? " · erhalten " + eur(m.erhalten.summe) : "") + "</title></g>";
      // Erhalten als Soll-Strich: liegt die Säule darunter, fehlt Einspielung
      if (m.hatErhalten) {
        var ys = (H - m.soll / max * (H - 10)).toFixed(1);
        punkte += '<line class="soll" x1="' + (x - 3).toFixed(1) + '" x2="' + (x + w + 3).toFixed(1) + '" y1="' + ys + '" y2="' + ys + '"/>';
      }
    });
    svg += punkte + "</svg>";

    var t = '<div class="amkz-table-wrap"><table class="amkz-table amkz-fb-tabelle"><thead><tr><th>Monat</th><th>FTDs</th><th>FTD-Volumen</th><th>ReDepos (Monat)</th><th>ReDepo-Volumen</th><th>Ø FD</th><th>Erhalten</th><th>Eingespielt</th><th>Noch offen</th></tr></thead><tbody>';
    monate.slice().reverse().forEach(function (m) {
      var alt = m.redZahl - m.redNeuZahl;
      t += '<tr class="' + (m.monat === S.monat ? "aktiv" : "") + '" data-fb-monat="' + m.monat + '">' +
        '<td data-label="Monat"><b>' + esc(monatName(m.monat)) + "</b></td>" +
        '<td data-label="FTDs">' + m.ftdZahl + "</td>" +
        '<td data-label="FTD-Volumen">' + eur(m.ftdSumme) + "</td>" +
        '<td data-label="ReDepos (Monat)">' + m.redNeuZahl + (alt > 0 ? " <small>+" + alt + " ältere</small>" : "") + "</td>" +
        '<td data-label="ReDepo-Volumen">' + eur(m.redNeuSumme) + "</td>" +
        '<td data-label="Ø FD">' + eur(m.avgFtd) + "</td>" +
        '<td data-label="Erhalten"><button type="button" class="amkz-fb-edit" data-fb="erhalten" data-monat="' + m.monat + '">' + (m.hatErhalten ? eur(m.erhalten.summe) : "+ eintragen") + "</button></td>" +
        '<td data-label="Eingespielt" class="' + (m.quote == null ? "" : m.quote >= 1 ? "pos" : "neg") + '"><b>' + eur(m.eingespielt) + "</b>" + (m.quote == null ? "" : " <small>" + Math.round(m.quote * 100) + " %</small>") + "</td>" +
        '<td data-label="Noch offen" class="' + (m.hatErhalten ? (m.offen > 0.005 ? "neg" : "pos") : "") + '">' + (m.hatErhalten ? (m.offen > 0.005 ? eur(m.offen) : "✓") : "—") + "</td></tr>";
    });
    t += "</tbody></table></div>";

    return '<div class="amkz-card amkz-fb-verlauf"><div class="amkz-card-header"><h3>Erhalten und eingespielt — je Monat</h3>' +
      '<div class="amkz-fb-legende"><span class="ftd">FTD</span><span class="red">ReDepo auf FTDs des Monats</span><span class="deal">Erhalten (Soll)</span></div></div>' +
      '<div class="amkz-fb-chartwrap">' + svg + "</div>" + t + "</div>";
  }

  function kurzEur(v) { return v >= 1000 ? ZAHL.format(Math.round(v / 100) / 10) + "k" : ZAHL.format(v); }

  function casinoKarte(r) {
    var l = Object.keys(r.casinos).map(function (k) { return r.casinos[k]; }).sort(function (a, b) { return b.eingespielt - a.eingespielt; });
    var h = '<div class="amkz-card amkz-fb-casinos"><div class="amkz-card-header"><h3>Je Casino · ' + esc(monatName(S.monat)) + "</h3></div>";
    if (!l.length) return h + '<div class="amkz-empty">In diesem Monat noch nichts eingespielt.</div></div>';
    h += '<div class="amkz-table-wrap"><table class="amkz-table"><thead><tr><th>Casino</th><th>FTDs</th><th>FTD-Volumen</th><th>Ø FD</th><th>ReDepos (Monat)</th><th>Eingespielt</th><th>Anteil</th></tr></thead><tbody>';
    l.forEach(function (c) {
      var cas = casinoById(c.id), g = cas && partnerById(cas.partner_group_id);
      var ant = r.eingespielt ? c.eingespielt / r.eingespielt : 0, alt = c.redZahl - c.redNeuZahl;
      h += '<tr><td data-label="Casino"><button type="button" class="amkz-fb-link" data-fb-bezug="casino:' + esc(c.id) + '"><b>' + esc(cas ? cas.name : "ohne Casino") + "</b></button>" + (g ? "<small>" + esc(g.name) + "</small>" : "") + "</td>" +
        '<td data-label="FTDs">' + c.ftd.length + (c.unter ? ' <small class="neg">' + c.unter + " unter Baseline " + eur(c.minDep) + "</small>" : "") + "</td>" +
        '<td data-label="FTD-Volumen">' + eur(c.ftdSumme) + "</td>" +
        '<td data-label="Ø FD">' + eur(c.ftd.length ? c.ftdSumme / c.ftd.length : 0) + "</td>" +
        '<td data-label="ReDepos (Monat)">' + c.redNeuZahl + " · " + eur(c.redNeuSumme) + (alt > 0 ? "<small>" + alt + " ältere zählen nicht</small>" : "") + "</td>" +
        '<td data-label="Eingespielt"><b>' + eur(c.eingespielt) + "</b></td>" +
        '<td data-label="Anteil">' + Math.round(ant * 100) + " %</td></tr>";
    });
    return h + "</tbody></table></div></div>";
  }

  function render() {
    var el = root(); if (!el) return;
    stil();
    var kopf = '<div class="amkz-card amkz-fb-filter">' +
      '<div class="amkz-fb-monat"><button type="button" class="amkz-secondary-btn" data-fb="zurueck" aria-label="Monat zurück">‹</button>' +
      '<input type="month" id="amkzFbMonat" aria-label="Monat" value="' + S.monat + '" max="' + monatVon(new Date()) + '">' +
      '<button type="button" class="amkz-secondary-btn" data-fb="vor" aria-label="Monat vor"' + (S.monat >= monatVon(new Date()) ? " disabled" : "") + ">›</button></div>" +
      '<select id="amkzFbBezug" class="amkz-fb-bezug" aria-label="Partner oder Casino">' + bezugOptionen() + "</select>" +
      '<div class="amkz-fb-aktionen"><button type="button" class="amkz-secondary-btn" data-fb="vorgabe">Vorgabe</button>' +
      '<button type="button" class="amkz-primary-btn" data-fb="erhalten">+ Erhalten eintragen</button></div></div>';

    if (!S.geladen) { el.innerHTML = kopf + '<div class="amkz-card"><div class="amkz-empty">' + (S.laedt ? "FTD-Bilanz wird geladen …" : "Noch nicht geladen.") + "</div></div>"; return; }

    var r = rechne(S.monat, S.bezug);
    var hinweis = S.fehlt ? '<div class="amkz-card amkz-fb-hinweis"><b>Datenbank fehlt noch:</b> bitte <code>zentrale/supabase-ftd-bilanz.sql</code> einmal im Supabase SQL-Editor ausführen — bis dahin lassen sich „Erhalten" und Vorgaben nicht speichern. Die FTD-Zahlen unten stimmen trotzdem.</div>' : "";
    el.innerHTML = kopf + hinweis +
      '<div class="amkz-card amkz-fb-hero">' + ring(r) + "</div>" +
      kpis(r) +
      '<div class="amkz-fb-zwei">' + checkKarte(r) + rangeKarte(r) + "</div>" +
      verlaufKarte() + casinoKarte(r);
  }

  /* ---------- Eingaben ---------- */
  function bezugAuswahl(id, wert) {
    var alt = S.bezug; S.bezug = wert;
    var h = '<select id="' + id + '">' + bezugOptionen() + "</select>";
    S.bezug = alt; return h;
  }

  function oeffneErhalten(monat) {
    var m = monat || S.monat, b = S.bezug;
    var eigen = erhaltenFuer(m, b).eigen;
    AMKZ.modal.open(
      '<div class="amkz-modal amkz-fb-modal"><div class="amkz-modal-header"><div><h3>Erhalten eintragen</h3><p>Was ihr für diesen Monat bekommen habt — das muss wieder eingespielt werden</p></div>' +
      '<button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>' +
      '<form id="amkzFbErhForm" class="amkz-form-grid">' +
      '<div class="amkz-form-row"><div class="amkz-input-group"><label>Monat</label><input id="fbErhMonat" type="month" value="' + m + '" required></div>' +
      '<div class="amkz-input-group"><label>Für</label>' + bezugAuswahl("fbErhBezug", b) + "</div></div>" +
      '<div class="amkz-input-group"><label>Erhaltene Summe (€)</label><input id="fbErhBetrag" type="number" step="0.01" min="0" inputmode="decimal" placeholder="z. B. 21600" value="' + (eigen ? num(eigen.betrag) : "") + '" required></div>' +
      '<div class="amkz-input-group"><label>Notiz</label><input id="fbErhNotiz" type="text" maxlength="300" placeholder="z. B. Rechnung RP-2026-09, BTC am 05.10." value="' + esc(eigen ? eigen.notiz || "" : "") + '"></div>' +
      '<div id="fbErhInfo" class="amkz-fb-fein"></div>' +
      '<div class="amkz-modal-actions">' + (eigen ? '<button type="button" class="amkz-secondary-btn amkz-fb-loeschen" id="fbErhLoeschen">Eintrag löschen</button>' : "") +
      '<button type="button" class="amkz-secondary-btn" data-amkz-close-modal>Abbrechen</button><button type="submit" class="amkz-primary-btn">Speichern</button></div></form></div>'
    );
    var f = document.getElementById("amkzFbErhForm"); if (!f) return;
    var info = document.getElementById("fbErhInfo");
    function aktualisieren() {
      var mm = f.querySelector("#fbErhMonat").value, bb = f.querySelector("#fbErhBezug").value;
      var vorhanden = mm ? erhaltenFuer(mm, bb).eigen : null;
      if (vorhanden && document.activeElement !== f.querySelector("#fbErhBetrag")) {
        f.querySelector("#fbErhBetrag").value = num(vorhanden.betrag);
        f.querySelector("#fbErhNotiz").value = vorhanden.notiz || "";
      }
      var r = mm ? rechne(mm, bb) : null;
      var t = r ? "Bisher eingespielt: " + eur(r.eingespielt) + " (FTDs + ReDepos auf FTDs dieses Monats)" : "";
      var w = doppelt(mm, bb);
      info.innerHTML = t + (w ? '<div class="amkz-fb-warn">⚠ ' + w + "</div>" : "") + (vorhanden ? "<div>Für diesen Monat steht schon " + eur(num(vorhanden.betrag)) + " — Speichern ersetzt den Betrag.</div>" : "");
    }
    f.querySelector("#fbErhMonat").addEventListener("change", aktualisieren);
    f.querySelector("#fbErhBezug").addEventListener("change", aktualisieren);
    aktualisieren();
    var lo = document.getElementById("fbErhLoeschen");
    if (lo) lo.addEventListener("click", async function () {
      if (!confirm("Eintrag für " + monatName(m) + " · " + bezugName(b) + " wirklich löschen?")) return;
      var r = await sb().from("amk_ftd_bilanz_erhalten").delete().eq("id", eigen.id);
      if (r.error) { toast("Fehler", r.error.message, "error"); return; }
      AMKZ.modal.close(); toast("Gelöscht", "Erhalten-Eintrag entfernt."); await laden();
    });
    f.addEventListener("submit", async function (ev) {
      ev.preventDefault();
      var mm = f.querySelector("#fbErhMonat").value, bb = f.querySelector("#fbErhBezug").value;
      var betrag = Number(String(f.querySelector("#fbErhBetrag").value).replace(",", "."));
      if (!/^\d{4}-\d{2}$/.test(mm)) { toast("Monat fehlt", "Bitte einen Monat wählen.", "error"); return; }
      if (!Number.isFinite(betrag) || betrag < 0) { toast("Betrag prüfen", "Bitte eine Summe ab 0 € eintragen.", "error"); return; }
      var knopf = f.querySelector('button[type="submit"]'); knopf.disabled = true;
      var r = await sb().from("amk_ftd_bilanz_erhalten").upsert({
        monat: monatErster(mm), bezug: bb, betrag: Math.round(betrag * 100) / 100,
        notiz: f.querySelector("#fbErhNotiz").value.trim() || null, eingetragen_von: wer(),
      }, { onConflict: "monat,bezug" });
      knopf.disabled = false;
      if (r.error) { toast("Nicht gespeichert", tabelleFehlt(r.error) || r.error.message, "error"); return; }
      AMKZ.modal.close();
      toast("Gespeichert", eur(betrag) + " für " + monatName(mm) + " · " + bezugName(bb));
      S.monat = mm; await laden();
    });
  }

  // Wird dieselbe Zahlung auf Partner- UND Casino-Ebene eingetragen, zählt sie doppelt.
  function doppelt(m, b) {
    if (!m || b === "alle") return "";
    var erster = monatErster(m), l = S.erhalten.filter(function (x) { return String(x.monat).slice(0, 10) === erster && x.bezug !== b; });
    var p = b.split(":");
    if (p[0] === "partner") {
      var c = l.filter(function (x) { var q = x.bezug.split(":"); var ca = q[0] === "casino" && casinoById(q[1]); return ca && ca.partner_group_id === p[1]; });
      if (c.length) return "Für Casinos dieser Gruppe ist schon " + eur(c.reduce(function (s, x) { return s + num(x.betrag); }, 0)) + " eingetragen — die Summe käme dazu. Nur eintragen, was dort noch nicht drin ist.";
    } else {
      var ca = casinoById(p[1]);
      var g = ca && ca.partner_group_id && l.filter(function (x) { return x.bezug === "partner:" + ca.partner_group_id; })[0];
      if (g) return "Für " + esc(bezugName("partner:" + ca.partner_group_id)) + " ist schon " + eur(num(g.betrag)) + " auf Gruppenebene eingetragen — nicht doppelt erfassen.";
    }
    return "";
  }

  function tabelleFehlt(err) {
    var m = String((err && (err.message || err.code)) || "");
    return /does not exist|schema cache|42P01|PGRST205/i.test(m) ? "Tabelle fehlt — bitte supabase-ftd-bilanz.sql einmal in Supabase ausführen." : "";
  }

  function oeffneVorgabe() {
    var b = S.bezug, v = S.vorgaben[b] || {}, geerbt = !S.vorgaben[b] && vorgabeFuer(b);
    var c = b.indexOf("casino:") === 0 ? casinoById(b.slice(7)) : null;
    var baseline = c && num(c.cpa_min_deposit) ? num(c.cpa_min_deposit) : null;
    function feld(id, label, wert, ph, hilfe) {
      return '<div class="amkz-input-group"><label>' + label + '</label><input id="' + id + '" type="number" step="0.01" min="0" inputmode="decimal" value="' + (wert == null ? "" : esc(wert)) + '" placeholder="' + esc(ph) + '"><small class="amkz-fb-fein">' + hilfe + "</small></div>";
    }
    AMKZ.modal.open(
      '<div class="amkz-modal amkz-fb-modal"><div class="amkz-modal-header"><div><h3>Vorgabe · ' + esc(bezugName(b)) + "</h3><p>Wie viel vom Erhaltenen wieder eingespielt werden muss — und in welcher Qualität</p></div>" +
      '<button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>' +
      '<form id="amkzFbVgForm" class="amkz-form-grid">' +
      (geerbt ? '<div class="amkz-fb-fein">Gilt bisher über ' + esc(bezugName(geerbt.von)) + ". Hier speichern = eigene Vorgabe nur für " + esc(bezugName(b)) + ".</div>" : "") +
      '<div class="amkz-form-row">' +
      feld("fbVgFaktor", "Einspielen mindestens (× Erhalten)", v.ziel_faktor, "1,00", "1,00 = das Erhaltene 1:1 wieder einspielen. 1,20 = 20 % mehr.") +
      feld("fbVgAvg", "Ø First Deposit mindestens (€)", v.min_avg_ftd, "z. B. 100", "Durchschnitt aller First Deposits im Monat.") + "</div>" +
      '<div class="amkz-form-row">' +
      feld("fbVgRed", "ReDepos je FTD mindestens", v.redepos_je_ftd, "z. B. 1", "Nur ReDepos auf FTDs desselben Monats. 1 = jeder FTD hat einen ReDepo.") +
      '<div class="amkz-input-group"><label>First-Deposit-Spanne (€)</label><div class="amkz-fb-spanne"><input id="fbVgVon" type="number" step="0.01" min="0" placeholder="' + (baseline ? ZAHL.format(baseline) : "von") + '" value="' + (v.fd_von == null ? "" : esc(v.fd_von)) + '"><span>–</span><input id="fbVgBis" type="number" step="0.01" min="0" placeholder="bis" value="' + (v.fd_bis == null ? "" : esc(v.fd_bis)) + '"></div>' +
      '<small class="amkz-fb-fein">In welchem Bereich die First Deposits liegen sollen' + (baseline ? " (Baseline des Casinos: " + eur(baseline) + ")" : "") + ".</small></div></div>" +
      '<div class="amkz-input-group"><label>Notiz</label><input id="fbVgNotiz" type="text" maxlength="300" placeholder="z. B. Royal: 180 € CPA, Manager will Ø 150 € sehen" value="' + esc(v.notiz || "") + '"></div>' +
      '<div class="amkz-modal-actions">' + (S.vorgaben[b] ? '<button type="button" class="amkz-secondary-btn amkz-fb-loeschen" id="fbVgLoeschen">Vorgabe entfernen</button>' : "") +
      '<button type="button" class="amkz-secondary-btn" data-amkz-close-modal>Abbrechen</button><button type="submit" class="amkz-primary-btn">Speichern</button></div></form></div>'
    );
    var f = document.getElementById("amkzFbVgForm"); if (!f) return;
    var lo = document.getElementById("fbVgLoeschen");
    if (lo) lo.addEventListener("click", async function () {
      var r = await sb().from("amk_ftd_bilanz_vorgaben").delete().eq("bezug", b);
      if (r.error) { toast("Fehler", r.error.message, "error"); return; }
      AMKZ.modal.close(); toast("Entfernt", "Vorgabe für " + bezugName(b) + " gelöscht."); await laden();
    });
    f.addEventListener("submit", async function (ev) {
      ev.preventDefault();
      function wert(id) { var s = String(f.querySelector("#" + id).value).trim().replace(",", "."); if (s === "") return null; var n = Number(s); return Number.isFinite(n) && n >= 0 ? Math.round(n * 100) / 100 : NaN; }
      var row = { bezug: b, ziel_faktor: wert("fbVgFaktor"), min_avg_ftd: wert("fbVgAvg"), redepos_je_ftd: wert("fbVgRed"), fd_von: wert("fbVgVon"), fd_bis: wert("fbVgBis"),
        notiz: f.querySelector("#fbVgNotiz").value.trim() || null, updated_by: wer() };
      if ([row.ziel_faktor, row.min_avg_ftd, row.redepos_je_ftd, row.fd_von, row.fd_bis].some(function (x) { return Number.isNaN(x); })) { toast("Eingabe prüfen", "Nur Zahlen ab 0.", "error"); return; }
      if (row.fd_von != null && row.fd_bis != null && row.fd_bis < row.fd_von) { toast("Spanne prüfen", "„bis“ liegt unter „von“.", "error"); return; }
      var r = await sb().from("amk_ftd_bilanz_vorgaben").upsert(row, { onConflict: "bezug" });
      if (r.error) { toast("Nicht gespeichert", tabelleFehlt(r.error) || r.error.message, "error"); return; }
      AMKZ.modal.close(); toast("Gespeichert", "Vorgabe für " + bezugName(b)); await laden();
    });
  }

  /* ---------- Bedienung ---------- */
  document.addEventListener("click", function (e) {
    var root_ = root(); if (!root_ || !root_.contains(e.target)) return;
    var k = e.target.closest("[data-fb]");
    if (k) {
      var a = k.getAttribute("data-fb");
      if (a === "zurueck") { S.monat = monatPlus(S.monat, -1); laden(); }
      else if (a === "vor") { S.monat = monatPlus(S.monat, 1); laden(); }
      else if (a === "erhalten") oeffneErhalten(k.getAttribute("data-monat"));
      else if (a === "vorgabe") oeffneVorgabe();
      return;
    }
    var bz = e.target.closest("[data-fb-bezug]");
    if (bz) { setzeBezug(bz.getAttribute("data-fb-bezug")); return; }
    var mo = e.target.closest("[data-fb-monat]");
    if (mo && mo.getAttribute("data-fb-monat") !== S.monat) { S.monat = mo.getAttribute("data-fb-monat"); render(); }
  });
  document.addEventListener("change", function (e) {
    if (e.target && e.target.id === "amkzFbBezug") setzeBezug(e.target.value);
    if (e.target && e.target.id === "amkzFbMonat" && /^\d{4}-\d{2}$/.test(e.target.value)) { S.monat = e.target.value; laden(); }
  });
  var warSchmal = null;
  window.addEventListener("resize", function () {
    var jetzt = schmal(); if (warSchmal === null) { warSchmal = jetzt; return; }
    if (jetzt !== warSchmal) { warSchmal = jetzt; if (S.geladen && AMKZ.state && AMKZ.state.currentView === "ftdbilanz") render(); }
  });

  function setzeBezug(b) {
    S.bezug = b || "alle";
    try { localStorage.setItem("amkz_fb_bezug", S.bezug); } catch (_) {}
    render();
  }

  /* ---------- Aussehen ---------- */
  function stil() {
    if (document.getElementById("amkzFbStil")) return;
    var s = document.createElement("style"); s.id = "amkzFbStil";
    s.textContent = [
      ".amkz-fb{ display:grid; gap:16px; min-width:0; }",
      ".amkz-fb .amkz-card{ margin:0; min-width:0; }",
      ".amkz-fb-fein{ color:var(--amk-muted,#8d99a5); font-size:.8rem; line-height:1.45; margin:0; }",
      ".amkz-fb-filter{ display:flex; flex-wrap:wrap; align-items:center; gap:10px; padding:12px 14px !important; }",
      ".amkz-fb-monat{ display:flex; align-items:center; gap:6px; }",
      ".amkz-fb-monat .amkz-secondary-btn{ min-width:38px; padding:8px 0; font-size:1.1rem; line-height:1; }",
      ".amkz-fb-monat input, .amkz-fb-bezug{ height:40px; border-radius:12px; border:1px solid var(--amk-line,rgba(255,255,255,.1)); background:var(--amk-surface,rgba(255,255,255,.05)); color:inherit; padding:0 12px; font:inherit; }",
      ".amkz-fb-bezug{ min-width:200px; flex:1 1 200px; max-width:340px; }",
      ".amkz-fb-aktionen{ display:flex; gap:8px; margin-left:auto; flex-wrap:wrap; }",
      ".amkz-fb-hinweis{ border-color:rgba(255,92,114,.45) !important; padding:12px 16px !important; font-size:.88rem; }",
      ".amkz-fb-hinweis code{ background:rgba(255,255,255,.08); padding:1px 6px; border-radius:6px; }",
      /* Ring */
      ".amkz-fb-hero{ display:flex; align-items:center; gap:28px; padding:22px 26px !important; }",
      ".amkz-fb-ring{ position:relative; width:170px; height:170px; flex:0 0 170px; }",
      ".amkz-fb-ring svg{ width:100%; height:100%; }",
      ".amkz-fb-ring circle{ fill:none; stroke-width:10; stroke-linecap:round; }",
      ".amkz-fb-ring .bahn{ stroke:rgba(255,255,255,.08); }",
      ".amkz-fb-ring .wert{ stroke:var(--amk-accent,#ffc73a); transition:stroke-dasharray .8s cubic-bezier(.2,.8,.3,1); filter:drop-shadow(0 0 8px rgba(255,199,58,.45)); }",
      ".amkz-fb-ring.ok .wert{ stroke:var(--amk-pos,#3ddc84); filter:drop-shadow(0 0 8px rgba(61,220,132,.45)); }",
      ".amkz-fb-ring.unter .wert{ stroke:var(--amk-neg,#ff5c72); filter:drop-shadow(0 0 8px rgba(255,92,114,.45)); }",
      ".amkz-fb-ring .mitte{ position:absolute; inset:0; display:flex; flex-direction:column; align-items:center; justify-content:center; text-align:center; }",
      ".amkz-fb-ring .mitte b{ font-family:var(--rt-titel,inherit); font-style:italic; font-weight:900; font-size:2.6rem; line-height:1; font-variant-numeric:tabular-nums; }",
      ".amkz-fb-ring.ok .mitte b{ color:var(--amk-pos,#3ddc84); } .amkz-fb-ring.unter .mitte b{ color:var(--amk-neg,#ff5c72); } .amkz-fb-ring.knapp .mitte b{ color:var(--amk-accent,#ffc73a); }",
      ".amkz-fb-ring .mitte small{ font-size:.7rem; letter-spacing:.16em; text-transform:uppercase; font-weight:800; color:var(--amk-muted,#8d99a5); margin-top:6px; }",
      ".amkz-fb-ringtext{ min-width:0; flex:1; }",
      ".amkz-fb-ringtext > small{ font-size:.7rem; letter-spacing:.14em; text-transform:uppercase; font-weight:800; color:var(--amk-muted,#8d99a5); }",
      ".amkz-fb-ringtext p{ font-size:1.25rem; margin:6px 0 14px; line-height:1.35; }",
      ".amkz-fb-ringtext p b{ color:var(--amk-accent,#ffc73a); }",
      ".amkz-fb-ringzahlen{ display:flex; flex-wrap:wrap; gap:8px; }",
      ".amkz-fb-ringzahlen span{ padding:6px 12px; border-radius:999px; background:rgba(255,255,255,.05); border:1px solid var(--amk-line,rgba(255,255,255,.09)); font-size:.82rem; color:var(--amk-muted,#8d99a5); }",
      ".amkz-fb-ringzahlen b{ color:var(--amk-text,#eef2f5); margin-left:4px; }",
      /* KPIs */
      ".amkz-fb-kpis{ grid-template-columns:repeat(4,minmax(0,1fr)) !important; margin:0 !important; }",
      ".amkz-fb-kpi{ text-align:left; font:inherit; color:inherit; min-width:0; }",
      ".amkz-fb-kpi strong{ white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }",
      ".amkz-fb-kpi span i{ font-style:normal; font-weight:800; font-size:.75rem; }",
      ".amkz-fb-kpi span i.auf{ color:var(--amk-pos,#3ddc84); } .amkz-fb-kpi span i.ab{ color:var(--amk-neg,#ff5c72); }",
      ".amkz-fb-kpi.gold strong{ color:var(--amk-accent,#ffc73a) !important; }",
      ".amkz-fb-kpi.plus strong{ color:var(--amk-pos,#3ddc84) !important; } .amkz-fb-kpi.minus strong{ color:var(--amk-neg,#ff5c72) !important; }",
      ".amkz-fb-erhalten{ cursor:pointer; border:1px dashed rgba(255,199,58,.45) !important; }",
      ".amkz-fb-erhalten:hover{ border-style:solid !important; }",
      /* Ziele */
      ".amkz-fb-zwei{ display:grid; grid-template-columns:1fr 1fr; gap:16px; min-width:0; }",
      ".amkz-fb-check .amkz-fb-fein{ margin:-4px 0 12px; }",
      ".amkz-fb-ziel{ padding:10px 0; border-top:1px solid var(--amk-line-soft,rgba(255,255,255,.05)); }",
      ".amkz-fb-ziel .kopf{ display:flex; justify-content:space-between; gap:10px; align-items:baseline; flex-wrap:wrap; }",
      ".amkz-fb-ziel .kopf span{ font-variant-numeric:tabular-nums; font-weight:700; } .amkz-fb-ziel .kopf em{ font-style:normal; color:var(--amk-muted,#8d99a5); font-weight:500; }",
      ".amkz-fb-ziel .balken, .amkz-fb-stufe .balken{ height:8px; border-radius:99px; background:rgba(255,255,255,.07); overflow:hidden; margin:7px 0 5px; }",
      ".amkz-fb-ziel .balken i, .amkz-fb-stufe .balken i{ display:block; height:100%; border-radius:99px; background:var(--amk-accent,#ffc73a); transition:width .6s cubic-bezier(.2,.8,.3,1); }",
      ".amkz-fb-ziel.ok .balken i{ background:var(--amk-pos,#3ddc84); } .amkz-fb-ziel.offen .balken i{ background:linear-gradient(90deg,var(--amk-neg,#ff5c72),var(--amk-accent,#ffc73a)); }",
      ".amkz-fb-ziel small{ color:var(--amk-muted,#8d99a5); } .amkz-fb-ziel.ok small{ color:var(--amk-pos,#3ddc84); } .amkz-fb-ziel.offen small{ color:#ffb0bc; }",
      /* Range */
      ".amkz-fb-stufe{ display:grid; grid-template-columns:110px 1fr auto; align-items:center; gap:12px; padding:6px 8px; border-radius:10px; }",
      ".amkz-fb-stufe .balken{ margin:0; height:12px; }",
      ".amkz-fb-stufe .lab{ font-size:.85rem; color:var(--amk-text-2,#c9d1d8); white-space:nowrap; }",
      ".amkz-fb-stufe .zahl{ font-size:.82rem; color:var(--amk-muted,#8d99a5); white-space:nowrap; font-variant-numeric:tabular-nums; } .amkz-fb-stufe .zahl b{ color:var(--amk-text,#fff); }",
      ".amkz-fb-stufe.soll{ background:rgba(61,220,132,.07); } .amkz-fb-stufe.soll .balken i{ background:var(--amk-pos,#3ddc84); }",
      ".amkz-fb-stufe.unter .balken i{ background:var(--amk-neg,#ff5c72); }",
      ".amkz-fb-legende{ display:flex; flex-wrap:wrap; gap:12px; font-size:.75rem; color:var(--amk-muted,#8d99a5); margin-top:10px; }",
      ".amkz-card-header .amkz-fb-legende{ margin:0; }",
      ".amkz-fb-legende span::before{ content:''; display:inline-block; width:10px; height:10px; border-radius:3px; margin-right:6px; vertical-align:-1px; background:currentColor; }",
      ".amkz-fb-legende .ftd::before{ background:var(--amk-accent,#ffc73a); } .amkz-fb-legende .red::before{ background:var(--amk-info,#38e1ff); }",
      ".amkz-fb-legende .deal::before{ height:3px; vertical-align:3px; background:#fff; } .amkz-fb-legende .erh::before{ border-radius:50%; background:var(--amk-pos,#3ddc84); }",
      ".amkz-fb-legende .soll::before{ background:var(--amk-pos,#3ddc84); } .amkz-fb-legende .unter::before{ background:var(--amk-neg,#ff5c72); }",
      /* Verlauf */
      ".amkz-fb-chartwrap{ width:100%; overflow:hidden; margin-bottom:14px; }",
      ".amkz-fb-chart{ width:100%; height:240px; display:block; }",
      ".amkz-fb-chart .gitter{ stroke:rgba(255,255,255,.06); stroke-width:1; }",
      ".amkz-fb-chart .achse{ fill:var(--amk-muted,#8d99a5); font-size:10px; }",
      ".amkz-fb-chart .ftd{ fill:var(--amk-accent,#ffc73a); opacity:.75; } .amkz-fb-chart .red{ fill:var(--amk-info,#38e1ff); opacity:.7; }",
      ".amkz-fb-chart .monat{ cursor:pointer; } .amkz-fb-chart .treffer{ fill:transparent; }",
      ".amkz-fb-chart .monat:hover .treffer{ fill:rgba(255,255,255,.03); } .amkz-fb-chart .monat.aktiv .treffer{ fill:rgba(255,199,58,.07); }",
      ".amkz-fb-chart .monat.aktiv .ftd, .amkz-fb-chart .monat.aktiv .red{ opacity:1; } .amkz-fb-chart .monat.aktiv .achse{ fill:var(--amk-accent,#ffc73a); font-weight:800; }",
      ".amkz-fb-chart .soll{ stroke:#fff; stroke-width:3; stroke-linecap:round; vector-effect:non-scaling-stroke; }",
      "html.amkz-hell .amkz-fb-chart .soll{ stroke:#222; }",
      ".amkz-fb-tabelle td small{ color:inherit; opacity:.75; margin-left:4px; }",
      ".amkz-fb-tabelle tr.aktiv td{ background:rgba(255,199,58,.07); } .amkz-fb-tabelle tr{ cursor:pointer; }",
      ".amkz-fb td.pos{ color:var(--amk-pos,#3ddc84); font-weight:700; } .amkz-fb td.neg, .amkz-fb small.neg{ color:var(--amk-neg,#ff5c72); font-weight:700; }",
      ".amkz-fb-edit{ background:transparent; border:1px dashed rgba(255,199,58,.4); color:var(--amk-accent,#ffc73a); border-radius:8px; padding:4px 10px; font:inherit; font-weight:700; cursor:pointer; white-space:nowrap; }",
      ".amkz-fb-edit:hover{ border-style:solid; background:rgba(255,199,58,.08); }",
      ".amkz-fb-link{ background:none; border:0; padding:0; color:inherit; font:inherit; cursor:pointer; text-align:left; } .amkz-fb-link:hover b{ color:var(--amk-accent,#ffc73a); }",
      ".amkz-fb-casinos td small{ display:block; color:var(--amk-muted,#8d99a5); font-size:.75rem; }",
      // Die Zentrale setzt Tabellen global auf table-layout:fixed + nowrap — bei elf Spalten
      // schieben sich die Zahlen dann ineinander. Hier: Breite nach Inhalt, sonst seitlich scrollen.
      "@media (min-width:641px){ .amkz-fb .amkz-table{ table-layout:auto !important; } .amkz-fb-casinos .amkz-table{ min-width:860px !important; } }",
      // Monatstabelle (11 Spalten) bleibt auch am Handy eine Tabelle zum Wischen — dort griff vorher das feste Layout.
      ".amkz-fb .amkz-fb-tabelle{ table-layout:auto !important; min-width:1040px !important; width:auto !important; }",
      ".amkz-fb .amkz-fb-tabelle td, .amkz-fb .amkz-fb-tabelle th{ white-space:nowrap; width:auto !important; }",
      ".amkz-fb .amkz-table td, .amkz-fb .amkz-table th{ padding-left:10px; padding-right:10px; }",
      /* Formulare */
      ".amkz-fb-modal .amkz-form-grid{ display:grid; gap:12px; }",
      ".amkz-fb-modal .amkz-input-group small{ display:block; margin-top:4px; }",
      ".amkz-fb-spanne{ display:flex; align-items:center; gap:8px; } .amkz-fb-spanne input{ flex:1; min-width:0; }",
      ".amkz-fb-warn{ margin-top:6px; padding:8px 10px; border-radius:10px; background:rgba(255,92,114,.1); border:1px solid rgba(255,92,114,.35); color:#ffc2cb; }",
      ".amkz-fb-modal .amkz-modal-actions{ display:flex; gap:8px; justify-content:flex-end; flex-wrap:wrap; margin-top:4px; }",
      ".amkz-fb-loeschen{ margin-right:auto; color:var(--amk-neg,#ff5c72) !important; }",
      /* Hell-Fassung */
      "html.amkz-hell .amkz-fb-ring .bahn{ stroke:rgba(0,0,0,.08); } html.amkz-hell .amkz-fb-chart .deal{ stroke:#222; } html.amkz-hell .amkz-fb-legende .deal::before{ background:#222; }",
      "html.amkz-hell .amkz-fb-ziel .balken, html.amkz-hell .amkz-fb-stufe .balken{ background:rgba(0,0,0,.07); }",
      /* Handy */
      "@media (max-width:1100px){ .amkz-fb-kpis{ grid-template-columns:repeat(2,minmax(0,1fr)) !important; } .amkz-fb-zwei{ grid-template-columns:1fr; } }",
      "@media (max-width:640px){",
      "  .amkz-fb-hero{ flex-direction:column; text-align:center; gap:14px; padding:18px !important; }",
      "  .amkz-fb-ringzahlen{ justify-content:center; } .amkz-fb-ringtext p{ font-size:1.05rem; }",
      "  .amkz-fb-filter{ display:grid; grid-template-columns:1fr; } .amkz-fb-monat{ width:100%; } .amkz-fb-monat input{ flex:1; min-width:0; }",
      "  .amkz-fb-bezug{ max-width:none; width:100%; } .amkz-fb-aktionen{ margin:0; display:grid; grid-template-columns:1fr 1fr; }",
      "  .amkz-fb-kpi strong{ font-size:1.6rem !important; }",
      "  .amkz-fb-stufe{ grid-template-columns:84px 1fr; } .amkz-fb-stufe .zahl{ grid-column:1 / -1; text-align:right; margin-top:-4px; }",
      "  .amkz-fb-chart{ height:auto; }",
      "  .amkz-fb-chart .achse{ font-size:11px; }",
      "  .amkz-fb-edit{ min-height:36px; padding:6px 12px; }",
      "  .amkz-fb-link{ min-height:36px; min-width:44px; display:inline-flex; align-items:center; }",
      "}",
    ].join("\n");
    document.head.appendChild(s);
  }

  /* ---------- Kachel auf der Startseite ---------- */
  async function kachel() {
    if (!darf()) return null;
    try {
      var jetzt = monatVon(new Date());
      if (!S.geladen) await laden();
      // Die geladenen Daten reichen von S.monat-11 bis S.monat. Hat jemand in der
      // Bilanz weit zurückgeblättert, fehlt der laufende Monat — dann nicht raten.
      if (!S.geladen || jetzt > S.monat || jetzt < monatPlus(S.monat, -(MONATE_ZURUECK - 1))) return { zahl: "…", roh: 0, unter: "FTD-Bilanz öffnen" };
      var r = rechne(jetzt, "alle");
      if (!r.hatErhalten) return { zahl: ZAHL.format(r.ftdZahl), roh: 0, unter: "FTDs · " + eur(r.eingespielt) + " eingespielt — Erhalten eintragen" };
      var p = Math.round(r.quote * 100);
      return { zahl: p + "%", roh: r.offen > 0.005 ? 1 : 0, unter: r.offen > 0.005 ? "noch " + eur(r.offen) + " einspielen" : "Erhaltenes komplett eingespielt" };
    } catch (_) { return { zahl: "—", roh: 0, unter: "nicht erreichbar" }; }
  }

  /* ---------- Einhängen in die Ansicht ---------- */
  var zuvorFb = AMKZ.loadView;
  AMKZ.loadView = async function fbChain(view, options) {
    var r = await (zuvorFb ? zuvorFb.call(this, view, options) : undefined);
    if (view === "ftdbilanz") { render(); await laden(); }
    return r;
  };

  AMKZ.ftdBilanz = { laden: laden, render: render, rechne: rechne, kachel: kachel, state: S };
})();

/* ============================================================================
   PARTNER & CASINOS — ein Bereich statt zwei                  (22.10.2026)
   ----------------------------------------------------------------------------
   Marcel: „Partner und Casinos zusammenlegen, dass man weiß, wie die
   Reihenfolge ist." Hier steht deshalb die Hierarchie selbst:
     Partnergruppe  ->  ihre Casinos (mit Deal-Konditionen)  ->  ihre Deals
   Casinos ohne Gruppe stehen am Ende.

   Bearbeiten/Löschen laufen über die vorhandenen Formulare — die Klicks
   hängen an den Datenattributen, die die CRUD-Blöcke schon auswerten:
   data-partner-id, data-casino-id, data-deal-edit, data-deal-del.
   Die alten Listen (#amkzPartnersList, #amkzCasinosTableBody, #amkzDealsList)
   gibt es nur noch unsichtbar; ändern sie sich nach dem Speichern, zeichnet
   sich diese Ansicht neu.
============================================================================ */
(function () {
  "use strict";
  if (!window.AMKZ) return;

  var such = "";
  var TYP = { cpa: "CPA", hybrid: "Hybrid", revshare: "RevShare", fixed: "Fix" };

  function esc(v) { return String(v == null ? "" : v).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function num(v) { var n = Number(v); return Number.isFinite(n) ? n : 0; }
  var EUR = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 2, minimumFractionDigits: 0 });
  function eur(v) { return EUR.format(num(v)); }
  function root() { return document.getElementById("amkzPartnerCasinoRoot"); }
  function st() { return AMKZ.state || {}; }
  function name(x) { return String((x && x.name) || ""); }
  function sortName(a, b) { return name(a).localeCompare(name(b), "de"); }

  function statusPille(s) {
    s = String(s || "active").toLowerCase();
    var t = s === "active" ? "aktiv" : s === "paused" ? "pausiert" : s === "inactive" ? "inaktiv" : s;
    return '<span class="amkz-pc-status s-' + esc(s) + '">' + esc(t) + "</span>";
  }

  function konditionen(c) {
    var typ = String(c.deal_type || "").toLowerCase(), teile = [];
    if (typ === "cpa" || typ === "hybrid") teile.push("CPA " + eur(c.cpa_amount));
    if (num(c.cpa_min_deposit) > 0) teile.push("Baseline ab " + eur(c.cpa_min_deposit));
    if (typ === "hybrid" && num(c.baseline_amount) > 0) teile.push("Pauschale " + eur(c.baseline_amount) + (num(c.baseline_ftds) ? " für " + num(c.baseline_ftds) + " FTDs" : ""));
    if (num(c.revshare_percent) > 0) teile.push(num(c.revshare_percent) + " % RevShare");
    return teile.join(" · ");
  }

  function dealZeile(d, casinoName) {
    var typ = String(d.deal_type || "").toLowerCase(), werte = [];
    if (num(d.cpa_amount)) werte.push("CPA " + eur(d.cpa_amount));
    if (num(d.revshare_percent)) werte.push(num(d.revshare_percent) + " %");
    if (num(d.fixed_fee)) werte.push("Fix " + eur(d.fixed_fee));
    var deD = function (x) { var m = String(x || "").match(/^(\d{4})-(\d{2})-(\d{2})/); return m ? m[3] + "." + m[2] + "." + m[1] : x; };   // Nachtschicht 31.10.: deutsches Datum
      var zeit = (d.start_date || d.end_date) ? " · " + (d.start_date ? deD(d.start_date) : "…") + " – " + (d.end_date ? deD(d.end_date) : "offen") : "";
    return '<div class="amkz-pc-deal" data-deal-card="' + esc(d.id) + '" title="Zum Bearbeiten klicken">' +
      "<div><b>" + esc(d.title || "Deal") + "</b><small>" + esc((TYP[typ] || typ || "—") + (werte.length ? " · " + werte.join(" · ") : "") + zeit) +
      (casinoName ? " · " + esc(casinoName) : "") + "</small></div>" +
      '<div class="amkz-pc-aktion">' + (String(d.status || "active").toLowerCase() === "active" && d.end_date && String(d.end_date).slice(0, 10) < new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10) ? '<span class="amkz-pc-status s-inactive" title="Enddatum ist vorbei – in den Daten steht der Deal noch auf aktiv">beendet</span>' : statusPille(d.status)) /* Nachtschicht 31.10.: abgelaufene Deals nicht als aktiv zeigen */ +
      '<button type="button" class="amk-crud-edit" data-deal-edit="' + esc(d.id) + '" title="Bearbeiten" aria-label="Deal bearbeiten">✎</button>' +
      '<button type="button" class="amk-crud-del" data-deal-del="' + esc(d.id) + '" title="Löschen" aria-label="Deal löschen">🗑</button></div></div>';
  }

  function casinoZeile(c, deals) {
    var eigene = deals.filter(function (d) { return d.casino_id === c.id; });
    return '<div class="amkz-pc-casino">' +
      '<button type="button" class="amkz-pc-casino-kopf" data-casino-id="' + esc(c.id) + '" title="Casino bearbeiten">' +
        '<span class="amkz-pc-name">' + esc(c.name || "Casino") + "</span>" +
        '<span class="amkz-pc-typ">' + esc(TYP[String(c.deal_type || "").toLowerCase()] || "—") + "</span>" +
        '<span class="amkz-pc-kond">' + esc(konditionen(c) || "keine Konditionen hinterlegt") + "</span>" +
        statusPille(c.status) + '<span class="amkz-pc-stift">✎</span>' +
      "</button>" +
      (eigene.length ? '<div class="amkz-pc-deals innen">' + eigene.map(function (d) { return dealZeile(d, ""); }).join("") + "</div>" : "") +
      "</div>";
  }

  function trifft(text) { return !such || String(text || "").toLowerCase().indexOf(such) >= 0; }

  function render() {
    var el = root(); if (!el) return;
    stil();
    var partner = (st().partners || []).slice().sort(function (x, y) { var ax = String(x.status || "active").toLowerCase() === "active" ? 0 : 1, ay = String(y.status || "active").toLowerCase() === "active" ? 0 : 1; return ax - ay || sortName(x, y); }); // Nachtschicht 31.10.: aktive Partnergruppen zuerst
    var casinos = (st().casinos || []).slice().sort(sortName);
    var deals = st().deals || [];
    var casinoName = {}; casinos.forEach(function (c) { casinoName[c.id] = c.name; });

    var gruppen = partner.map(function (p) {
      return { p: p, casinos: casinos.filter(function (c) { return c.partner_group_id === p.id; }) };
    });
    var ohne = casinos.filter(function (c) { return !c.partner_group_id || !partner.some(function (p) { return p.id === c.partner_group_id; }); });
    if (ohne.length) gruppen.push({ p: null, casinos: ohne });

    var html = "", sichtbar = 0;
    gruppen.forEach(function (g) {
      var gruppeTrifft = g.p && trifft(g.p.name);
      var cs = gruppeTrifft ? g.casinos : g.casinos.filter(function (c) { return trifft(c.name); });
      if (such && !gruppeTrifft && !cs.length) return;
      sichtbar++;
      // Deals der Gruppe, die keinem ihrer Casinos zugeordnet sind (Gruppen-Deals)
      var gDeals = g.p ? deals.filter(function (d) {
        return d.partner_group_id === g.p.id && !g.casinos.some(function (c) { return c.id === d.casino_id; });
      }) : [];
      html += '<section class="amkz-card amkz-pc-gruppe' + (g.p ? "" : " ohne") + '">' +
        (g.p
          ? '<button type="button" class="amkz-pc-gruppe-kopf" data-partner-id="' + esc(g.p.id) + '" title="Partnergruppe bearbeiten">' +
              '<span class="amkz-pc-gname">' + esc(g.p.name || "Partner") + "</span>" +
              '<span class="amkz-pc-zahl">' + g.casinos.length + (g.casinos.length === 1 ? " Casino" : " Casinos") + "</span>" +
              statusPille(g.p.status) + '<span class="amkz-pc-stift">✎</span></button>' +
            (g.p.note ? '<p class="amkz-pc-notiz">' + esc(g.p.note) + "</p>" : "")
          : '<div class="amkz-pc-gruppe-kopf statisch"><span class="amkz-pc-gname">Ohne Partnergruppe</span><span class="amkz-pc-zahl">' + cs.length + " Casinos</span></div>") +
        (cs.length ? '<div class="amkz-pc-liste">' + cs.map(function (c) { return casinoZeile(c, deals); }).join("") + "</div>"
          : '<div class="amkz-pc-leer">Noch kein Casino in dieser Gruppe.</div>') +
        (gDeals.length ? '<div class="amkz-pc-deals"><small class="amkz-pc-zwischen">Deals der Gruppe</small>' + gDeals.map(function (d) { return dealZeile(d, casinoName[d.casino_id]); }).join("") + "</div>" : "") +
        "</section>";
    });
    // Deals ohne Partner und ohne bekanntes Casino nicht verlieren
    var lose = deals.filter(function (d) {
      return !partner.some(function (p) { return p.id === d.partner_group_id; }) && !casinos.some(function (c) { return c.id === d.casino_id; });
    });
    if (lose.length && !such) {
      html += '<section class="amkz-card amkz-pc-gruppe ohne"><div class="amkz-pc-gruppe-kopf statisch"><span class="amkz-pc-gname">Deals ohne Zuordnung</span><span class="amkz-pc-zahl">' + lose.length + "</span></div>" +
        '<div class="amkz-pc-deals">' + lose.map(function (d) { return dealZeile(d, ""); }).join("") + "</div></section>";
    }
    if (!sichtbar && !lose.length) html = '<div class="amkz-card"><div class="amkz-empty">' + (such ? "Nichts gefunden." : "Noch keine Partner oder Casinos angelegt.") + "</div></div>";
    el.innerHTML = html;
  }

  async function laden() {
    render();
    try {
      if (AMKZ.data) await Promise.all([
        AMKZ.data.loadCasinos && AMKZ.data.loadCasinos(true),
        AMKZ.data.loadPartners && AMKZ.data.loadPartners(true),
        AMKZ.data.loadDeals && AMKZ.data.loadDeals(true),
      ]);
    } catch (e) { console.warn("Partner & Casinos laden", e); }
    render();
  }

  // Nach dem Speichern füllen die alten Module ihre (unsichtbaren) Listen neu — dann nachziehen.
  var wartet = null;
  function beobachten() {
    ["amkzPartnersList", "amkzCasinosTableBody", "amkzDealsList"].forEach(function (id) {
      var n = document.getElementById(id); if (!n || n.dataset.pcBeobachtet) return;
      n.dataset.pcBeobachtet = "1";
      new MutationObserver(function () {
        clearTimeout(wartet);
        wartet = setTimeout(function () { if (AMKZ.state && AMKZ.state.currentView === "partners") laden(); }, 250);
      }).observe(n, { childList: true });
    });
  }

  document.addEventListener("input", function (e) {
    if (e.target && e.target.id === "amkzPcSuche") { such = String(e.target.value || "").trim().toLowerCase(); render(); }
  });

  function stil() {
    if (document.getElementById("amkzPcStil")) return;
    var s = document.createElement("style"); s.id = "amkzPcStil";
    s.textContent = [
      ".amkz-pc{ display:grid; gap:14px; min-width:0; }",
      ".amkz-pc-kopf{ margin-bottom:14px; }",
      ".amkz-pc-kopf .amkz-card-actions{ display:flex; gap:8px; flex-wrap:wrap; }",
      ".amkz-pc-suche{ width:100%; height:42px; margin-top:4px; border-radius:12px; border:1px solid var(--amk-line,rgba(255,255,255,.1)); background:var(--amk-surface,rgba(255,255,255,.05)); color:inherit; padding:0 14px; font:inherit; font-size:16px; }",
      ".amkz-pc-gruppe{ margin:0 !important; padding:0 !important; overflow:hidden; }",
      ".amkz-pc-gruppe-kopf{ display:flex; align-items:center; gap:12px; width:100%; padding:16px 18px; background:none; border:0; border-bottom:1px solid var(--amk-line-soft,rgba(255,255,255,.06)); color:inherit; font:inherit; text-align:left; cursor:pointer; }",
      ".amkz-pc-gruppe-kopf.statisch{ cursor:default; }",
      ".amkz-pc-gruppe-kopf:not(.statisch):hover{ background:rgba(255,199,58,.06); }",
      ".amkz-pc-gname{ font-family:var(--rt-titel,inherit); font-style:italic; font-weight:900; font-size:1.25rem; text-transform:uppercase; letter-spacing:.02em; }",
      ".amkz-pc-gruppe.ohne .amkz-pc-gname{ color:var(--amk-muted,#8d99a5); }",
      ".amkz-pc-zahl{ color:var(--amk-muted,#8d99a5); font-size:.82rem; margin-right:auto; }",
      ".amkz-pc-stift{ opacity:.45; font-size:.9rem; } button:hover > .amkz-pc-stift{ opacity:1; color:var(--amk-accent,#ffc73a); }",
      ".amkz-pc-notiz{ margin:0; padding:10px 18px 0; color:var(--amk-muted,#8d99a5); font-size:.85rem; }",
      ".amkz-pc-liste{ display:grid; padding:6px 10px 10px; }",
      ".amkz-pc-casino{ border-radius:12px; }",
      ".amkz-pc-casino + .amkz-pc-casino{ border-top:1px solid var(--amk-line-soft,rgba(255,255,255,.05)); }",
      ".amkz-pc-casino-kopf{ display:grid; grid-template-columns:minmax(120px,1.1fr) 84px minmax(0,2.4fr) auto 18px; align-items:center; gap:12px; width:100%; min-height:48px; padding:8px 10px 8px 22px; background:none; border:0; color:inherit; font:inherit; text-align:left; cursor:pointer; border-radius:10px; position:relative; }",
      ".amkz-pc-casino-kopf::before{ content:''; position:absolute; left:9px; top:50%; width:6px; height:6px; margin-top:-3px; border-radius:50%; background:var(--amk-accent,#ffc73a); opacity:.7; }",
      ".amkz-pc-casino-kopf:hover{ background:rgba(255,255,255,.04); }",
      ".amkz-pc-name{ font-weight:800; }",
      ".amkz-pc-typ{ font-size:.75rem; font-weight:800; letter-spacing:.08em; text-transform:uppercase; color:var(--amk-accent,#ffc73a); }",
      ".amkz-pc-kond{ color:var(--amk-text-2,#c9d1d8); font-size:.86rem; font-variant-numeric:tabular-nums; min-width:0; }",
      ".amkz-pc-status{ font-size:.7rem; font-weight:800; letter-spacing:.06em; text-transform:uppercase; padding:3px 9px; border-radius:999px; background:rgba(61,220,132,.12); color:var(--amk-pos,#3ddc84); white-space:nowrap; }",
      ".amkz-pc-status.s-paused{ background:rgba(255,199,58,.12); color:var(--amk-accent,#ffc73a); } .amkz-pc-status.s-inactive{ background:rgba(255,92,114,.12); color:var(--amk-neg,#ff5c72); }",
      ".amkz-pc-deals{ display:grid; gap:6px; padding:4px 14px 14px; }",
      ".amkz-pc-deals.innen{ padding:0 10px 10px 40px; }",
      ".amkz-pc-zwischen{ font-size:.68rem; letter-spacing:.14em; text-transform:uppercase; font-weight:800; color:var(--amk-muted,#8d99a5); margin-top:4px; }",
      ".amkz-pc-deal{ display:flex; align-items:center; justify-content:space-between; gap:10px; padding:8px 12px; border-radius:10px; background:rgba(255,255,255,.035); border:1px solid var(--amk-line-soft,rgba(255,255,255,.05)); cursor:pointer; }",
      ".amkz-pc-deal:hover{ border-color:rgba(255,199,58,.35); }",
      ".amkz-pc-deal b{ display:block; font-size:.88rem; } .amkz-pc-deal small{ color:var(--amk-muted,#8d99a5); font-size:.78rem; }",
      ".amkz-pc-aktion{ display:flex; align-items:center; gap:6px; flex:0 0 auto; }",
      ".amkz-pc-aktion button{ min-width:36px; min-height:36px; border-radius:10px; }",
      ".amkz-pc-leer{ padding:14px 18px; color:var(--amk-muted,#8d99a5); font-size:.88rem; }",
      "html.amkz-hell .amkz-pc-casino-kopf:hover, html.amkz-hell .amkz-pc-deal{ background:rgba(0,0,0,.035); }",
      "@media (max-width:760px){",
      "  .amkz-pc-casino-kopf{ grid-template-columns:1fr auto 18px; grid-template-areas:'n s p' 't t t' 'k k k'; row-gap:4px; }",
      "  .amkz-pc-name{ grid-area:n; } .amkz-pc-casino-kopf .amkz-pc-status{ grid-area:s; } .amkz-pc-casino-kopf .amkz-pc-stift{ grid-area:p; }",
      "  .amkz-pc-typ{ grid-area:t; } .amkz-pc-kond{ grid-area:k; }",
      "  .amkz-pc-deals.innen{ padding-left:22px; }",
      "  .amkz-pc-deal{ flex-wrap:wrap; }",
      "  .amkz-pc-kopf .amkz-card-header{ flex-wrap:wrap; gap:10px; }",
      "}",
    ].join("\n");
    document.head.appendChild(s);
  }

  var zuvorPc = AMKZ.loadView;
  AMKZ.loadView = async function pcChain(view, options) {
    var r = await (zuvorPc ? zuvorPc.call(this, view, options) : undefined);
    if (view === "partners" || view === "casinos") { beobachten(); await laden(); }
    return r;
  };

  AMKZ.partnerCasinos = { render: render, laden: laden };
})();

/* =====================================================
   SUPPORT-POSTFACH (26.10.2026) — support@nouri-amk.com mit Tickets
   Nachbau des Slotivox-Postfachs. Daten nur ueber die Edge Function `postfach`
   (Sitzungs-Token x-amk-sitzung), Tabellen in supabase-postfach.sql.
   Jede Mail = Ticket AMK-1001, Kunde sieht den Status auf /pages/ticket.
   Klassen mit Praefix amkpf-: am Handy darf nichts mit der Leiste kollidieren
   (bei Slotivox hatte .leiste die Senden-Knoepfe aus dem Bild geschoben).
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ; if (!AMKZ || AMKZ.__postfach) return; AMKZ.__postfach = true;
  const byId = (id) => document.getElementById(id);
  const esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || ((v) => String(v ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m])));
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.prototype.slice.call((r || document).querySelectorAll(s));

  const ORDNER = [["eingang", "Eingang"], ["beantwortet", "Beantwortet"], ["erledigt", "Erledigt"], ["spam", "Spam"], ["papierkorb", "Papierkorb"], ["alle", "Alle"]];
  const KAT = { wichtig: "Wichtig", antwort: "Antwort nötig", giveaway: "Giveaway", auszahlung: "Auszahlung", partner: "Partner / Casino", sonstiges: "Sonstiges" };
  const ST = { neu: ["Neu · Eingegangen", "neu"], offen: ["In Bearbeitung", "offen"], beantwortet: ["Beantwortet", "ok"], erledigt: ["Erledigt", "ok"], spam: ["Spam", "rot"], papierkorb: ["Papierkorb", "rot"] };
  const S = { ordner: "eingang", suche: "", mein: false, D: null, F: null, fadenId: null, bilder: {}, anhaenge: [], entwurf: {}, timer: null, aktiv: false };

  /* ---------- API ---------- */
  function fnUrl() {
    if (window.AMKZ_POSTFACH_URL) return window.AMKZ_POSTFACH_URL;
    const root = byId("amkzApp");
    return String(root?.dataset?.supabaseUrl || "https://cbwxgikndyyzdslmfpmo.supabase.co").replace(/\/$/, "") + "/functions/v1/postfach";
  }
  async function api(action, params) {
    const root = byId("amkzApp"), anon = root?.dataset?.supabaseKey || "";
    const sitzung = window.AMKZ_POSTFACH_TOKEN || (AMKZ.state.member && AMKZ.state.member.session) || "";   // AMKZ_POSTFACH_TOKEN nur in tools/postfach-lokal.mjs
    try {
      const r = await fetch(fnUrl(), { method: "POST", headers: { "Content-Type": "application/json", Authorization: "Bearer " + anon, apikey: anon, "x-amk-sitzung": sitzung },
        body: JSON.stringify(Object.assign({ action }, params || {})) });
      if (r.status === 404 && !/json/.test(r.headers.get("content-type") || "")) return { ok: false, fehler: "fehlt", text: "Die Function „postfach“ ist noch nicht eingespielt." };
      return await r.json();
    } catch (e) { return { ok: false, text: "Keine Verbindung. Bitte nochmal versuchen." }; }
  }
  const gut = (r) => { if (r && r.ok) return true; toast("Postfach", (r && r.text) || "Fehler", "error"); return false; };

  /* ---------- Hilfen ---------- */
  function wann(iso) {
    const d = new Date(iso), j = new Date();
    if (d.toDateString() === j.toDateString()) return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
    if (j - d < 6 * 864e5) return d.toLocaleDateString("de-DE", { weekday: "short" }) + " " + d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
    return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "2-digit" });
  }
  const voll = (iso) => new Date(iso).toLocaleString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  const groesse = (b) => !b ? "" : b < 1e6 ? Math.max(1, Math.round(b / 1e3)) + " KB" : (b / 1e6).toLocaleString("de-DE", { maximumFractionDigits: 1 }) + " MB";
  const kuerzel = (name, mail) => { const s = String(name || mail || "?").replace(/[^\p{L}\p{N} ]/gu, " ").trim().split(/\s+/); return ((s[0] || "?")[0] + (s[1] ? s[1][0] : "")).toUpperCase(); };
  const pille = (st) => { const p = ST[st] || [st, ""]; return '<span class="amkpf-pille ' + p[1] + '">' + esc(p[0]) + "</span>"; };

  // Fremdes HTML: Sandbox ohne Skripte; fremde Bilder erst nach Klick (sonst sieht der Absender, dass wir die Mail geoeffnet haben)
  function rahmenHtml(html, bilder) {
    const csp = "default-src 'none'; style-src 'unsafe-inline'; font-src data:; img-src data: https://*.supabase.co" + (bilder ? " https: http:" : "") + ";";
    return '<!doctype html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="' + csp + '"><base target="_blank">' +
      "<style>html,body{margin:0;padding:14px;font:14px/1.55 -apple-system,Segoe UI,Roboto,Arial,sans-serif;color:#111;background:#fff;word-break:break-word}img{max-width:100%;height:auto}table{max-width:100%}</style></head><body>" + html + "</body></html>";
  }
  const hatFremdeBilder = (html) => /<img[^>]+src=["']?https?:\/\/(?![^"'>]*supabase\.co)/i.test(html || "") || /url\(\s*["']?https?:/i.test(html || "");
  function rahmenEinsetzen(box, html, bilder) {
    const f = document.createElement("iframe");
    f.className = "amkpf-rahmen";
    f.setAttribute("sandbox", "allow-same-origin allow-popups allow-popups-to-escape-sandbox");
    f.setAttribute("referrerpolicy", "no-referrer");
    f.srcdoc = rahmenHtml(html, bilder);
    f.addEventListener("load", () => { try { f.style.height = Math.min(Math.max(f.contentDocument.documentElement.scrollHeight, 80), 2400) + "px"; } catch (_) { f.style.height = "480px"; } });
    box.innerHTML = ""; box.appendChild(f);
  }
  const dateiLesen = (file) => new Promise((ok, nein) => { const r = new FileReader(); r.onload = () => ok({ name: file.name, typ: file.type || "application/octet-stream", daten: String(r.result), groesse: file.size }); r.onerror = nein; r.readAsDataURL(file); });

  /* ---------- CSS ---------- */
  function stil() {
    if (byId("amkpf-css")) return;
    const s = document.createElement("style"); s.id = "amkpf-css";
    s.textContent = `
      .amkpf{display:flex;flex-direction:column;gap:12px}
      .amkpf-setup{border:1px solid var(--amk-pend,#ffc46b);background:rgba(255,196,107,.08);border-radius:14px;padding:12px 14px;display:flex;gap:12px;align-items:center;flex-wrap:wrap}
      .amkpf-setup b{color:var(--amk-pend,#ffc46b)}
      .amkpf-kopf{display:flex;gap:10px;flex-wrap:wrap;align-items:center}
      .amkpf-kopf input[type=search]{flex:1 1 220px;max-width:360px;min-width:0}
      .amkpf-inp{background:rgba(255,255,255,.04);border:1px solid var(--amk-line,rgba(255,255,255,.14));color:inherit;border-radius:10px;padding:9px 12px;font:inherit;font-size:16px;width:100%}
      .amkpf-inp:focus{outline:2px solid var(--amk-gold,#e9c76a);outline-offset:1px}
      select.amkpf-inp{width:auto;padding:7px 10px;font-size:14px}
      .amkpf-haken{display:inline-flex;gap:8px;align-items:center;font-size:.85rem;cursor:pointer;color:var(--amk-text-2)}
      .amkpf-grid{display:grid;grid-template-columns:minmax(290px,370px) minmax(0,1fr);gap:14px;min-height:calc(100dvh - 230px)}
      .amkpf-links{display:flex;flex-direction:column;gap:8px;min-width:0}
      .amkpf-reiter{display:flex;gap:6px;flex-wrap:wrap}
      .amkpf-reiter button{border:1px solid var(--amk-line,rgba(255,255,255,.14));background:rgba(255,255,255,.04);color:var(--amk-text-2);border-radius:999px;padding:7px 12px;font:700 .8rem var(--amk-font);cursor:pointer}
      .amkpf-reiter button.an{background:var(--amk-gold-soft,rgba(233,199,106,.14));border-color:var(--amk-gold,#e9c76a);color:var(--amk-text)}
      .amkpf-reiter b{margin-left:6px;color:var(--amk-gold,#e9c76a)}
      .amkpf-liste{display:flex;flex-direction:column;gap:6px}
      .amkpf-eintrag{display:block;width:100%;text-align:left;border:1px solid var(--amk-line,rgba(255,255,255,.1));background:var(--amk-surface,rgba(255,255,255,.03));border-radius:12px;padding:11px 13px;color:var(--amk-text);cursor:pointer;font:inherit}
      .amkpf-eintrag:hover{border-color:var(--amk-line-strong,rgba(255,255,255,.25))}
      .amkpf-eintrag.an{border-color:var(--amk-gold,#e9c76a);box-shadow:inset 3px 0 0 var(--amk-gold,#e9c76a)}
      .amkpf-z1{display:flex;align-items:center;gap:8px}
      .amkpf-wer{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:700}
      .amkpf-eintrag.neu .amkpf-wer::before{content:"";display:inline-block;width:8px;height:8px;border-radius:50%;background:var(--amk-gold,#e9c76a);margin-right:7px;box-shadow:0 0 10px var(--amk-gold,#e9c76a);vertical-align:1px}
      .amkpf-wann{font-size:.75rem;color:var(--amk-muted);white-space:nowrap}
      .amkpf-betr{margin-top:4px;font-size:.9rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
      .amkpf-eintrag.neu .amkpf-betr{font-weight:800}
      .amkpf-vor{margin-top:3px;font-size:.8rem;color:var(--amk-muted);overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}
      .amkpf-chips{display:flex;gap:5px;flex-wrap:wrap;margin-top:8px}
      .amkpf-chip{font:700 .68rem/1 var(--amk-mono);padding:4px 7px;border-radius:6px;border:1px solid var(--amk-line-strong,rgba(255,255,255,.2));color:var(--amk-text-2)}
      .amkpf-chip.gold{color:var(--amk-gold,#e9c76a);border-color:var(--amk-gold,#e9c76a)}
      .amkpf-pille{display:inline-flex;align-items:center;font:700 .72rem/1 var(--amk-font);padding:5px 9px;border-radius:999px;border:1px solid var(--amk-line-strong);color:var(--amk-text-2);white-space:nowrap}
      .amkpf-pille.neu{color:var(--amk-gold,#e9c76a);border-color:var(--amk-gold,#e9c76a)}
      .amkpf-pille.offen{color:var(--amk-pend,#ffc46b);border-color:var(--amk-pend,#ffc46b)}
      .amkpf-pille.ok{color:var(--amk-pos,#3ddc97);border-color:var(--amk-pos,#3ddc97)}
      .amkpf-pille.rot{color:var(--amk-neg,#ff6b81);border-color:var(--amk-neg,#ff6b81)}
      .amkpf-detail{min-width:0;border:1px solid var(--amk-line);background:var(--amk-surface);border-radius:18px;display:flex;flex-direction:column}
      .amkpf-dkopf{padding:16px 18px;border-bottom:1px solid var(--amk-line);display:flex;flex-direction:column;gap:12px}
      .amkpf-dkopf h2{margin:0;font:800 1.15rem/1.3 var(--amk-font);overflow-wrap:anywhere}
      .amkpf-titelzeile{display:flex;gap:10px;align-items:flex-start;flex-wrap:wrap}
      .amkpf-titelzeile>div{flex:1 1 200px;min-width:0}
      .amkpf-zurueck{display:none;background:rgba(255,255,255,.06);border:1px solid var(--amk-line-strong);color:inherit;border-radius:10px;width:36px;height:36px;font-size:20px;line-height:1;cursor:pointer;flex:none}
      .amkpf-werk{display:flex;gap:8px;flex-wrap:wrap;align-items:center}
      .amkpf-link{display:flex;gap:8px;align-items:center;font-size:.8rem;color:var(--amk-muted);flex-wrap:wrap}
      .amkpf-link code{font:.75rem var(--amk-mono);color:var(--amk-text-2);word-break:break-all}
      .amkpf-verlauf{padding:16px 18px;display:flex;flex-direction:column;gap:14px}
      .amkpf-mail{border:1px solid var(--amk-line);border-radius:12px;background:rgba(0,0,0,.18);overflow:hidden}
      .amkpf-mail.aus{border-color:rgba(233,199,106,.4);background:rgba(233,199,106,.05)}
      .amkpf-mail.klein{opacity:.82}
      .amkpf-mkopf{display:flex;gap:10px;align-items:flex-start;padding:11px 13px;border-bottom:1px solid var(--amk-line)}
      .amkpf-ava{width:34px;height:34px;border-radius:10px;display:grid;place-items:center;font:800 .8rem var(--amk-font);background:rgba(255,255,255,.08);flex:none}
      .amkpf-mail.aus .amkpf-ava{background:var(--amk-gold,#e9c76a);color:#1a1405}
      .amkpf-mwer{flex:1;min-width:0}
      .amkpf-mwer b{display:block}
      .amkpf-mwer small{color:var(--amk-muted);word-break:break-all}
      .amkpf-mzeit{font-size:.75rem;color:var(--amk-muted);text-align:right}
      .amkpf-text{padding:13px;white-space:pre-wrap;word-break:break-word;font-size:.92rem;line-height:1.6;color:var(--amk-text-2)}
      .amkpf-rahmen{width:100%;border:0;display:block;background:#fff;min-height:80px}
      .amkpf-anh{display:flex;gap:8px;flex-wrap:wrap;padding:0 13px 13px}
      .amkpf-anh a,.amkpf-anh span{display:inline-flex;gap:6px;align-items:center;padding:7px 10px;border:1px solid var(--amk-line-strong);border-radius:8px;color:var(--amk-text-2);font-size:.8rem;text-decoration:none}
      .amkpf-hinweis{display:flex;gap:10px;align-items:center;padding:8px 13px;font-size:.78rem;color:var(--amk-muted);border-bottom:1px solid var(--amk-line);flex-wrap:wrap}
      .amkpf-antwort{border-top:1px solid var(--amk-line);padding:14px 18px 18px;background:rgba(0,0,0,.15);border-radius:0 0 18px 18px}
      .amkpf-antwort textarea{min-height:130px;resize:vertical;line-height:1.5}
      .amkpf-knoepfe{display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-top:10px}
      .amkpf-knoepfe .amkpf-luecke{flex:1}
      .amkpf-dateien{display:flex;gap:6px;flex-wrap:wrap;margin-top:8px}
      .amkpf-leer{display:grid;place-items:center;text-align:center;color:var(--amk-muted);padding:40px 20px;gap:8px;flex:1}
      .amkpf-leer .gross{font-size:40px;opacity:.7}
      .amkpf-btn{display:inline-flex;align-items:center;gap:6px;border:1px solid var(--amk-line-strong);background:rgba(255,255,255,.05);color:var(--amk-text);border-radius:10px;padding:9px 13px;font:700 .82rem var(--amk-font);cursor:pointer;text-decoration:none}
      .amkpf-btn:disabled{opacity:.5;cursor:wait}
      .amkpf-btn.prim{background:linear-gradient(135deg,#ffe39a,#e9c76a 55%,#c8a34b);border-color:transparent;color:#1a1405}
      .amkpf-btn.rot{color:var(--amk-neg,#ff6b81)}
      .amkpf-vorschau{width:100%;height:520px;border:1px solid var(--amk-line);border-radius:12px;background:#0a0907}
      .amkpf-adr{display:grid;grid-template-columns:1fr 150px 1.4fr auto;gap:8px;align-items:center}
      .amkpf-karte{border:1px solid var(--amk-line);border-radius:14px;padding:12px 14px;display:flex;flex-direction:column;gap:8px}
      .amkpf-feld{display:flex;flex-direction:column;gap:5px;font-size:.8rem;color:var(--amk-text-2)}
      .amkpf-zwei{display:grid;grid-template-columns:1fr 1fr;gap:10px}
      #amkzModalOverlay .amkpf-modal{max-width:760px;width:100%}
      .amkz-nav-item .amkpf-zahl{min-width:18px;height:18px;padding:0 5px;border-radius:9px;background:var(--amk-gold,#e9c76a);color:#1a1405;font:800 11px/18px var(--amk-font);text-align:center;margin-left:6px}
      @media (max-width:900px){
        .amkpf-grid{grid-template-columns:1fr;min-height:0}
        .amkpf-grid.mit-detail .amkpf-links{display:none}
        .amkpf-grid:not(.mit-detail) .amkpf-detail{display:none}
        .amkpf-zurueck{display:grid;place-items:center}
        .amkpf-dkopf{padding:12px 13px}
        .amkpf-verlauf{padding:12px 13px}
        .amkpf-mkopf .amkpf-mzeit{max-width:84px}
        .amkpf-antwort{padding:12px 13px calc(90px + env(safe-area-inset-bottom,0px))}
        .amkpf-knoepfe .amkpf-btn{flex:1 1 auto;justify-content:center}
        .amkpf-knoepfe .amkpf-luecke{display:none}
        .amkpf-adr,.amkpf-zwei{grid-template-columns:1fr}
      }`;
    document.head.appendChild(s);
  }

  /* ---------- Ansicht ---------- */
  function wurzel() { return byId("amkzPostfachRoot"); }
  function geruest() {
    const el = wurzel(); if (!el) return;
    el.innerHTML = '<div class="amkpf"><div data-pf-setup></div>' +
      '<div class="amkpf-kopf"><input type="search" class="amkpf-inp" id="amkpfSuche" placeholder="Suchen: Name, Adresse, Betreff, AMK-Nummer …" value="' + esc(S.suche) + '">' +
        '<label class="amkpf-haken"><input type="checkbox" id="amkpfMein"' + (S.mein ? " checked" : "") + "> Nur meine</label>" +
        '<span style="flex:1"></span><span data-pf-einst></span>' +
        '<button type="button" class="amkpf-btn prim" data-pf-neu>✏️ Neue Mail</button></div>' +
      '<div class="amkpf-grid' + (S.fadenId ? " mit-detail" : "") + '" data-pf-grid><div class="amkpf-links"><div class="amkpf-reiter" data-pf-reiter></div><div class="amkpf-liste" data-pf-liste><div class="amkpf-leer">Lädt …</div></div></div>' +
      '<div class="amkpf-detail" data-pf-detail></div></div></div>';
    const sf = byId("amkpfSuche"); let tm = null;
    sf.addEventListener("input", () => { clearTimeout(tm); tm = setTimeout(() => { S.suche = sf.value.trim(); laden(true); }, 280); });
    byId("amkpfMein").addEventListener("change", (e) => { S.mein = e.target.checked; laden(true); });
    $("[data-pf-neu]", el).addEventListener("click", () => neueMail());
    zeichneDetail();
  }
  async function laden(still) {
    const r = await api("liste", { ordner: S.ordner, suche: S.suche, mein: S.mein });
    if (!wurzel() || !S.aktiv) return;
    if (!r.ok || !Array.isArray(r.liste)) { if (!still) zeigeFehler(r.ok ? { text: "Antwort ohne Liste (Vorschau-Modus?)" } : r); return; }
    S.D = r; zeichneListe();
    if (!still && S.fadenId) fadenLaden(S.fadenId);
  }
  function zeigeFehler(r) {
    const l = $("[data-pf-liste]", wurzel());
    if (l) l.innerHTML = '<div class="amkpf-setup"><div style="flex:1;min-width:200px"><b>Postfach nicht erreichbar</b><div style="font-size:.85rem;opacity:.8">' + esc(r.text || "Fehler") + "</div></div></div>";
  }
  function zeichneListe() {
    const el = wurzel(), D = S.D, e = D.eingerichtet;
    $("[data-pf-setup]", el).innerHTML = e.senden && e.empfang ? "" : '<div class="amkpf-setup">✉️<div style="flex:1;min-width:220px"><b>Postfach noch nicht fertig eingerichtet</b><div style="font-size:.85rem;opacity:.85">' +
      (!e.senden ? "Es fehlt das Secret AMK_RESEND_KEY (Senden). " : "") + (!e.empfang ? "Es fehlt das Secret AMK_RESEND_WEBHOOK_SECRET (Empfang). " : "") + "Die Schritte stehen in zentrale/ANLEITUNG-POSTFACH.md.</div></div></div>";
    $("[data-pf-einst]", el).innerHTML = D.admin ? '<button type="button" class="amkpf-btn" data-pf-einstellungen>⚙️ Einstellungen</button>' : "";
    const eb = $("[data-pf-einstellungen]", el); if (eb) eb.addEventListener("click", einstellungen);
    const rt = $("[data-pf-reiter]", el);
    rt.innerHTML = ORDNER.map((o) => '<button type="button" data-pf-ordner="' + o[0] + '"' + (o[0] === S.ordner ? ' class="an"' : "") + ">" + o[1] + (o[0] === "eingang" && D.zahlen.eingang ? "<b>" + D.zahlen.eingang + "</b>" : "") + "</button>").join("");
    $$("[data-pf-ordner]", rt).forEach((b) => b.addEventListener("click", () => { S.ordner = b.dataset.pfOrdner; laden(true); }));
    const tn = (id) => (D.team.find((n) => n.id === id) || {}).name || "";
    const l = $("[data-pf-liste]", el);
    l.innerHTML = D.liste.length ? D.liste.map((f) =>
      '<button type="button" class="amkpf-eintrag' + (f.ungelesen ? " neu" : "") + (f.id === S.fadenId ? " an" : "") + '" data-pf-faden="' + f.id + '">' +
        '<div class="amkpf-z1"><span class="amkpf-wer">' + esc(f.kontakt_name || f.kontakt_email) + '</span><span class="amkpf-wann">' + wann(f.letzte) + "</span></div>" +
        '<div class="amkpf-betr">' + esc(f.betreff || "(ohne Betreff)") + "</div>" +
        (f.vorschau ? '<div class="amkpf-vor">' + esc(String(f.vorschau).replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ").replace(/&#(x[0-9a-f]+|\d+);/gi, function (m, n) { var c = /^x/i.test(n) ? parseInt(n.slice(1), 16) : Number(n); return c > 0 && c <= 1114111 ? String.fromCodePoint(c) : " "; }).replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/[͏­​-‍ ⁠﻿]/g, "").replace(/&#?[0-9a-z]*$/i, "").replace(/\s+/g, " ").trim()) /* Nachtschicht 31.10.: HTML-Zeichen + unsichtbare Füllzeichen raus */ + "</div>" : "") +
        '<div class="amkpf-chips"><span class="amkpf-chip gold">AMK-' + f.nr + "</span>" + pille(f.status) + (f.anzahl > 1 ? '<span class="amkpf-chip">' + f.anzahl + " Mails</span>" : "") +
        (f.weiterleitung ? '<span class="amkpf-chip">↪ ' + esc(f.postfach.split("@")[0]) + "@</span>" : "") + (f.kategorie && KAT[f.kategorie] ? '<span class="amkpf-chip">' + esc(KAT[f.kategorie]) + "</span>" : "") +
        (f.zustaendig ? '<span class="amkpf-chip">👤 ' + esc(tn(f.zustaendig)) + "</span>" : "") + "</div></button>").join("")
      : '<div class="amkpf-leer"><div class="gross">✉️</div><div>' + (S.suche ? "Nichts gefunden." : S.ordner === "eingang" ? "Posteingang leer — alles erledigt." : "Hier liegt nichts.") + "</div></div>";
    $$("[data-pf-faden]", l).forEach((b) => b.addEventListener("click", () => oeffneFaden(b.dataset.pfFaden)));
    zahlSetzen(D.zahlen.ungelesen);
  }
  function oeffneFaden(id) {
    S.fadenId = id; S.anhaenge = [];
    const g = $("[data-pf-grid]", wurzel()); if (g) g.classList.add("mit-detail");
    $$(".amkpf-eintrag", wurzel()).forEach((x) => x.classList.toggle("an", x.dataset.pfFaden === id));
    const d = $("[data-pf-detail]", wurzel()); if (d) d.innerHTML = '<div class="amkpf-leer">Lädt …</div>';
    fadenLaden(id);
    if (window.innerWidth <= 900) window.scrollTo({ top: 0 });
  }
  function schliesseFaden() {
    S.fadenId = null; S.F = null;
    const g = $("[data-pf-grid]", wurzel()); if (g) g.classList.remove("mit-detail");
    zeichneDetail(); laden(true);
  }
  async function fadenLaden(id) {
    const r = await api("faden", { id });
    if (S.fadenId !== id) return;
    if (!r.ok) { toast("Postfach", r.text || "Diese Mail gibt es nicht (mehr).", "error"); schliesseFaden(); return; }
    S.F = r; zeichneDetail();
    const item = $('[data-pf-faden="' + id + '"]', wurzel()); if (item) item.classList.remove("neu");
  }
  function zeichneDetail() {
    const d = $("[data-pf-detail]", wurzel()); if (!d) return;
    if (!S.F || !S.fadenId) { d.innerHTML = '<div class="amkpf-leer"><div class="gross">✉️</div><div><b style="color:var(--amk-text)">' + esc(S.D ? S.D.adresse : "support@nouri-amk.com") + "</b><br>Wähle links eine Mail aus.</div></div>"; return; }
    const f = S.F.faden, D = S.D || { team: [] };
    const tOpt = '<option value="">Niemand zuständig</option>' + D.team.map((n) => '<option value="' + n.id + '"' + (n.id === f.zustaendig ? " selected" : "") + ">" + esc(n.name) + "</option>").join("");
    const kOpt = '<option value="">Keine Kategorie</option>' + Object.keys(KAT).map((k) => '<option value="' + k + '"' + (k === f.kategorie ? " selected" : "") + ">" + esc(KAT[k]) + "</option>").join("");
    d.innerHTML = '<div class="amkpf-dkopf">' +
        '<div class="amkpf-titelzeile"><button type="button" class="amkpf-zurueck" data-pf-zurueck title="Zurück">‹</button>' +
        "<div><h2>" + esc(f.betreff || "(ohne Betreff)") + '</h2><div style="font-size:.8rem;color:var(--amk-muted);margin-top:4px;word-break:break-all">' + esc(f.kontakt_name ? f.kontakt_name + " · " : "") + esc(f.kontakt_email) + " → " + esc(f.postfach) + "</div></div>" +
        '<span class="amkpf-chip gold">AMK-' + f.nr + "</span> " + pille(f.status) + "</div>" +
        (f.link ? '<div class="amkpf-link">Status für den Kunden: <code>' + esc(f.link) + '</code> <button type="button" class="amkpf-btn" data-pf-kopie style="padding:5px 9px">Kopieren</button></div>' : "") +
        '<div class="amkpf-werk">' +
          (f.status !== "erledigt" ? '<button type="button" class="amkpf-btn" data-pf-st="erledigt">✓ Erledigt</button>' : '<button type="button" class="amkpf-btn" data-pf-st="offen">Wieder öffnen</button>') +
          '<button type="button" class="amkpf-btn" data-pf-st="ungelesen">Ungelesen</button>' +
          (f.status !== "spam" ? '<button type="button" class="amkpf-btn" data-pf-st="spam">Spam</button>' : "") +
          (f.status !== "papierkorb" ? '<button type="button" class="amkpf-btn rot" data-pf-st="papierkorb">🗑 Papierkorb</button>' : "") +
          '<select class="amkpf-inp" data-pf-zust>' + tOpt + '</select><select class="amkpf-inp" data-pf-kat>' + kOpt + "</select></div></div>" +
      '<div class="amkpf-verlauf">' + S.F.mails.map(mailHtml).join("") + "</div>" +
      (f.weiterleitung ? '<div class="amkpf-antwort" style="font-size:.85rem;color:var(--amk-muted)">Diese Adresse leitet nur weiter. Antworten bitte direkt aus dem Ziel-Postfach.</div>' :
      '<form class="amkpf-antwort" data-pf-antwort><textarea class="amkpf-inp" name="text" id="amkpfAntwortText" placeholder="Antwort an ' + esc(f.kontakt_name || f.kontakt_email) + ' …">' + esc(S.entwurf[f.id] || "") + "</textarea>" +
        '<div class="amkpf-dateien" data-pf-dateien></div>' +
        '<div class="amkpf-knoepfe"><label class="amkpf-btn" style="cursor:pointer">📎 Anhang<input type="file" multiple hidden data-pf-datei></label>' +
        '<select class="amkpf-inp" name="sprache"><option value="de"' + (f.sprache !== "en" ? " selected" : "") + '>Deutsch</option><option value="en"' + (f.sprache === "en" ? " selected" : "") + ">English</option></select>" +
        '<span class="amkpf-luecke"></span><button type="button" class="amkpf-btn" data-pf-senden-erledigt>Senden &amp; erledigt</button><button type="submit" class="amkpf-btn prim">➤ Senden</button></div></form>');
    $("[data-pf-zurueck]", d).addEventListener("click", schliesseFaden);
    const kb = $("[data-pf-kopie]", d);
    if (kb) kb.addEventListener("click", () => { navigator.clipboard && navigator.clipboard.writeText(f.link).then(() => toast("Postfach", "Status-Link kopiert."), () => {}); });
    $$("[data-pf-st]", d).forEach((b) => b.addEventListener("click", async () => {
      const st = b.dataset.pfSt, daten = st === "ungelesen" ? { ungelesen: true } : { status: st };
      const r = await api("setzen", Object.assign({ id: f.id }, daten)); if (!gut(r)) return;
      if (st === "offen") { Object.assign(S.F.faden, r.faden); zeichneDetail(); laden(true); } else schliesseFaden();
    }));
    $("[data-pf-zust]", d).addEventListener("change", async (e) => { const r = await api("setzen", { id: f.id, zustaendig: e.target.value }); if (gut(r)) { f.zustaendig = e.target.value || null; toast("Postfach", "Gespeichert."); laden(true); } });
    $("[data-pf-kat]", d).addEventListener("change", async (e) => { const r = await api("setzen", { id: f.id, kategorie: e.target.value }); if (gut(r)) { f.kategorie = e.target.value || null; laden(true); } });
    S.F.mails.forEach((m) => { const box = $('[data-pf-html="' + m.id + '"]', d); if (box) rahmenEinsetzen(box, m.html, !!S.bilder[m.id]); });
    $$("[data-pf-bilder]", d).forEach((b) => b.addEventListener("click", () => { S.bilder[b.dataset.pfBilder] = true; zeichneDetail(); }));
    $$("[data-pf-design]", d).forEach((b) => b.addEventListener("click", () => {
      const m = S.F.mails.find((x) => x.id === b.dataset.pfDesign); if (!m) return;
      AMKZ.modal.open('<div class="amkz-modal amkpf-modal"><div class="amkz-modal-header"><div><h3>So sieht die Mail beim Kunden aus</h3></div><button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div><iframe class="amkpf-vorschau" sandbox="allow-popups" id="amkpfDesign"></iframe></div>');
      byId("amkpfDesign").srcdoc = m.html;
    }));
    const form = $("[data-pf-antwort]", d); if (!form) return;
    const ta = form.text;
    ta.addEventListener("input", () => { S.entwurf[f.id] = ta.value; });
    // Strg/Cmd + Enter sendet; Enter allein macht eine neue Zeile (Handy-Tastaturen haben kein Shift-Enter)
    ta.addEventListener("keydown", (e) => { if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) { e.preventDefault(); senden(false); } });
    $("[data-pf-datei]", form).addEventListener("change", (e) => { dateienDazu(e.target.files, () => zeichneDateien($("[data-pf-dateien]", form))); e.target.value = ""; });
    zeichneDateien($("[data-pf-dateien]", form));
    form.addEventListener("submit", (e) => { e.preventDefault(); senden(false); });
    $("[data-pf-senden-erledigt]", form).addEventListener("click", () => senden(true));
    async function senden(erledigt) {
      if (!ta.value.trim()) { toast("Postfach", "Bitte einen Text schreiben.", "error"); ta.focus(); return; }
      const knoepfe = $$("button", form); knoepfe.forEach((x) => { x.disabled = true; });
      const r = await api("senden", { faden_id: f.id, text: ta.value, sprache: form.sprache.value, erledigt, anhaenge: S.anhaenge.map((a) => ({ name: a.name, typ: a.typ, daten: a.daten })) });
      knoepfe.forEach((x) => { x.disabled = false; });
      if (!gut(r)) return;
      toast("Postfach", "Gesendet an " + f.kontakt_email);
      delete S.entwurf[f.id]; S.anhaenge = [];
      if (erledigt) schliesseFaden(); else { fadenLaden(f.id); laden(true); }
    }
  }
  function mailHtml(m) {
    const aus = m.richtung === "aus", name = aus ? (m.gesendet_von || (m.art === "auto" ? "Automatische Bestätigung" : m.art === "weiterleitung" ? "Weiterleitung" : "AMK Support")) : (m.von_name || m.von);
    const info = (m.art === "auto" ? ' <span class="amkpf-pille">Eingangsbestätigung</span>' : "") + (m.art === "weiterleitung" ? ' <span class="amkpf-pille">↪ ' + esc((m.an || [])[0] || "") + "</span>" : "") +
      (m.status === "fehler" ? ' <span class="amkpf-pille rot" title="' + esc(m.fehler || "") + '">Fehler</span>' : "") + (m.status === "sendet" ? ' <span class="amkpf-pille offen">wird gesendet</span>' : "") +
      (m.status === "zugestellt" ? ' <span class="amkpf-pille ok">zugestellt</span>' : "") + (m.status === "unzustellbar" ? ' <span class="amkpf-pille rot">unzustellbar</span>' : "") +
      (m.status === "beschwerde" ? ' <span class="amkpf-pille rot">als Spam markiert</span>' : "");
    let inhalt;
    if (!aus && m.html) {
      inhalt = (hatFremdeBilder(m.html) && !S.bilder[m.id] ? '<div class="amkpf-hinweis">🖼 <span style="flex:1">Bilder von fremden Servern sind blockiert (Schutz vor Lesebestätigung).</span><button type="button" class="amkpf-btn" data-pf-bilder="' + m.id + '">Bilder anzeigen</button></div>' : "") +
        '<div data-pf-html="' + m.id + '"></div>';
    } else inhalt = '<div class="amkpf-text">' + esc(aus && m.art === "mail" ? String(m.text || "").split(/\n\n— /)[0] : m.text || "") + "</div>";
    const anh = (m.anhaenge || []).filter((a) => !a.inline || !a.cid);
    return '<article class="amkpf-mail' + (aus ? " aus" : "") + (m.art !== "mail" ? " klein" : "") + '"><div class="amkpf-mkopf"><div class="amkpf-ava">' + (aus ? "A" : esc(kuerzel(m.von_name, m.von))) + "</div>" +
      '<div class="amkpf-mwer"><b>' + esc(name) + info + "</b><small>" + (aus ? "an " + esc((m.an || []).join(", ")) : esc(m.von) + (m.cc && m.cc.length ? " · CC " + esc(m.cc.join(", ")) : "")) + "</small></div>" +
      '<div class="amkpf-mzeit">' + voll(m.erstellt) + "</div>" + (aus && m.html && m.art !== "weiterleitung" ? '<button type="button" class="amkpf-btn" data-pf-design="' + m.id + '" title="Design ansehen" style="padding:5px 8px">👁</button>' : "") + "</div>" +
      inhalt +
      (anh.length ? '<div class="amkpf-anh">' + anh.map((a) => a.url ? '<a href="' + esc(a.url) + '" target="_blank" rel="noopener" download="' + esc(a.name) + '">📎 ' + esc(a.name) + " <small>" + groesse(a.groesse) + "</small></a>"
        : '<span title="' + (a.zu_gross ? "Zu groß (über 20 MB)" : "Nicht gespeichert") + '">📎 ' + esc(a.name) + " <small>" + (a.zu_gross ? "zu groß" : "—") + "</small></span>").join("") + "</div>" : "") + "</article>";
  }
  function dateienDazu(liste, fertig) {
    const neu = Array.prototype.slice.call(liste || []);
    if (S.anhaenge.length + neu.length > 5) { toast("Postfach", "Höchstens 5 Anhänge.", "error"); return; }
    const summe = S.anhaenge.concat(neu).reduce((s, a) => s + (a.groesse || a.size || 0), 0);
    if (summe > 7e6) { toast("Postfach", "Anhänge zusammen höchstens 7 MB.", "error"); return; }
    Promise.all(neu.map(dateiLesen)).then((l) => { S.anhaenge = S.anhaenge.concat(l); fertig(); });
  }
  function zeichneDateien(box) {
    if (!box) return;
    box.innerHTML = S.anhaenge.map((a, i) => '<span class="amkpf-chip">' + esc(a.name) + " · " + groesse(a.groesse) + ' <a href="#" data-pf-weg="' + i + '" style="color:var(--amk-neg);margin-left:4px">✕</a></span>').join("");
    $$("[data-pf-weg]", box).forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); S.anhaenge.splice(Number(b.dataset.pfWeg), 1); zeichneDateien(box); }));
  }
  function neueMail() {
    S.anhaenge = [];
    AMKZ.modal.open('<div class="amkz-modal amkpf-modal"><div class="amkz-modal-header"><div><h3>Neue Mail</h3><p>Von ' + esc(S.D ? S.D.adresse : "support@") + '</p></div><button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>' +
      '<form id="amkpfNeu" style="display:flex;flex-direction:column;gap:10px">' +
      '<label class="amkpf-feld">An<input class="amkpf-inp" name="an" type="email" required placeholder="name@beispiel.de"></label>' +
      '<label class="amkpf-feld">Betreff<input class="amkpf-inp" name="betreff" required maxlength="280"></label>' +
      '<label class="amkpf-feld">Nachricht<textarea class="amkpf-inp" name="text" rows="9" required placeholder="Hallo …"></textarea></label>' +
      '<div class="amkpf-dateien" data-pf-dateien></div>' +
      '<div class="amkpf-knoepfe"><label class="amkpf-btn" style="cursor:pointer">📎 Anhang<input type="file" multiple hidden data-pf-datei></label>' +
      '<select class="amkpf-inp" name="sprache"><option value="de">Deutsch</option><option value="en">English</option></select><span class="amkpf-luecke"></span>' +
      '<button type="submit" class="amkpf-btn prim">➤ Senden</button></div></form></div>');
    const f = byId("amkpfNeu");
    $("[data-pf-datei]", f).addEventListener("change", (e) => { dateienDazu(e.target.files, () => zeichneDateien($("[data-pf-dateien]", f))); e.target.value = ""; });
    f.addEventListener("submit", async (e) => {
      e.preventDefault();
      const k = $("button.prim", f); k.disabled = true;
      const r = await api("senden", { an: f.an.value, betreff: f.betreff.value, text: f.text.value, sprache: f.sprache.value, anhaenge: S.anhaenge.map((a) => ({ name: a.name, typ: a.typ, daten: a.daten })) });
      k.disabled = false;
      if (!gut(r)) return;
      S.anhaenge = []; AMKZ.modal.close();
      toast("Postfach", "Gesendet an " + f.an.value);
      S.ordner = "beantwortet"; laden(true).then(() => oeffneFaden(r.faden.id));
    });
  }
  /* ---------- Einstellungen (nur Admins) ---------- */
  async function einstellungen() {
    const r = await api("einst"); if (!gut(r)) return;
    const e = r.einst, adr = (e.adressen || []).slice(); let vArt = "eingang", vSpr = "de";
    AMKZ.modal.open('<div class="amkz-modal amkpf-modal"><div class="amkz-modal-header"><div><h3>Postfach einrichten</h3><p>' + esc(e.absender) + "@" + esc(r.domain) + '</p></div><button class="amkz-modal-close" type="button" data-amkz-close-modal aria-label="Schließen" title="Schließen">×</button></div>' +
      '<form id="amkpfEinst" style="display:flex;flex-direction:column;gap:12px">' +
      '<div class="amkpf-karte"><b>Stand der Einrichtung</b>' +
        '<div style="font-size:.85rem">' + (r.eingerichtet.senden ? "✅ " : "⬜ ") + "Senden: Secret AMK_RESEND_KEY</div>" +
        '<div style="font-size:.85rem">' + (r.eingerichtet.empfang ? "✅ " : "⬜ ") + "Empfang: Secret AMK_RESEND_WEBHOOK_SECRET</div>" +
        '<div style="font-size:.85rem">' + (r.eingerichtet.zuletzt ? "✅ Letzte Mail empfangen: " + voll(r.eingerichtet.zuletzt) : "⬜ Noch keine Mail empfangen") + "</div>" +
        '<div style="font-size:.8rem;color:var(--amk-muted)">Webhook-Adresse für Resend: <code style="word-break:break-all">' + esc(r.webhook) + "</code></div>" +
        '<div style="font-size:.8rem;color:var(--amk-muted)">Statusseite für Kunden: <code style="word-break:break-all">' + esc(r.ticket_url) + "</code></div></div>" +
      '<div class="amkpf-zwei"><label class="amkpf-feld">Absender-Name<input class="amkpf-inp" name="absender_name" maxlength="80" value="' + esc(e.absender_name) + '"></label>' +
        '<label class="amkpf-feld">Absender-Adresse<span style="display:flex;gap:6px;align-items:center"><input class="amkpf-inp" name="absender" maxlength="64" value="' + esc(e.absender) + '" style="max-width:170px"><span>@' + esc(r.domain) + "</span></span></label></div>" +
      '<label class="amkpf-feld">Unterschrift unter jeder Antwort (optional)<textarea class="amkpf-inp" name="signatur" rows="3" maxlength="1000" placeholder="z. B. Discord, Instagram, Support-Zeiten">' + esc(e.signatur) + "</textarea></label>" +
      '<div class="amkpf-karte"><label class="amkpf-haken" style="color:var(--amk-text)"><input type="checkbox" name="auto_an"' + (e.auto_an ? " checked" : "") + "> <b>Automatische Eingangsbestätigung mit Ticketnummer</b></label>" +
        '<label class="amkpf-feld">Antwort in der Regel innerhalb von<input class="amkpf-inp" name="antwortzeit" maxlength="40" value="' + esc(e.antwortzeit) + '"></label>' +
        '<label class="amkpf-feld">Zusatztext in der Bestätigung (optional)<textarea class="amkpf-inp" name="auto_text" rows="2" maxlength="1000" placeholder="z. B. Am Wochenende antworten wir montags.">' + esc(e.auto_text) + "</textarea></label></div>" +
      '<div class="amkpf-karte"><b>Adressen @' + esc(r.domain) + '</b><div style="font-size:.8rem;color:var(--amk-muted)">„Postfach“ landet hier. „Weiterleitung“ schickt die Mail zusätzlich an eine andere Adresse. Alle anderen Adressen landen ebenfalls im Postfach.</div>' +
        '<div data-pf-adr style="display:flex;flex-direction:column;gap:8px"></div><button type="button" class="amkpf-btn" data-pf-adrneu style="align-self:flex-start">+ Adresse</button></div>' +
      '<div class="amkpf-karte"><div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center"><b style="flex:1">Vorschau</b>' +
        '<div class="amkpf-reiter" data-pf-vart><button type="button" data-v="eingang" class="an">Eingangsbestätigung</button><button type="button" data-v="antwort">Antwort</button></div>' +
        '<div class="amkpf-reiter" data-pf-vspr><button type="button" data-s="de" class="an">DE</button><button type="button" data-s="en">EN</button></div></div>' +
        '<iframe class="amkpf-vorschau" id="amkpfVorschau" sandbox="allow-popups"></iframe>' +
        '<div style="display:flex;gap:8px;flex-wrap:wrap"><input class="amkpf-inp" type="email" id="amkpfTestAn" placeholder="Testmail an …" style="max-width:280px"><button type="button" class="amkpf-btn" data-pf-test>➤ Beide Designs als Test senden</button></div></div>' +
      '<div class="amkpf-knoepfe"><span class="amkpf-luecke"></span><button type="button" class="amkpf-btn" data-amkz-close-modal>Schließen</button><button type="submit" class="amkpf-btn prim">Speichern</button></div></form></div>');
    const f = byId("amkpfEinst");
    $$("[data-amkz-close-modal]", f).forEach((b) => b.addEventListener("click", () => AMKZ.modal.close()));
    const werte = () => ({ absender_name: f.absender_name.value, absender: f.absender.value, signatur: f.signatur.value, auto_an: f.auto_an.checked, antwortzeit: f.antwortzeit.value, auto_text: f.auto_text.value });
    function zeichneAdr() {
      const box = $("[data-pf-adr]", f);
      box.innerHTML = adr.map((a, i) => '<div class="amkpf-adr"><span style="display:flex;gap:6px;align-items:center"><input class="amkpf-inp" style="flex:1;min-width:0" data-ai="' + i + '" data-af="adresse" value="' + esc(a.adresse) + '"><span>@</span></span>' +
        '<select class="amkpf-inp" data-ai="' + i + '" data-af="art"><option value="postfach"' + (a.art !== "weiterleitung" ? " selected" : "") + '>Postfach</option><option value="weiterleitung"' + (a.art === "weiterleitung" ? " selected" : "") + ">Weiterleitung</option></select>" +
        (a.art === "weiterleitung" ? '<input class="amkpf-inp" type="email" data-ai="' + i + '" data-af="an" value="' + esc(a.an || "") + '" placeholder="Ziel-Adresse">'
          : '<label class="amkpf-haken"><input type="checkbox" data-ai="' + i + '" data-af="auto"' + (a.auto !== false ? " checked" : "") + "> Bestätigung senden</label>") +
        '<button type="button" class="amkpf-btn rot" data-aweg="' + i + '" title="Entfernen">🗑</button></div>').join("");
      $$("[data-ai]", box).forEach((x) => x.addEventListener("change", () => { const a = adr[Number(x.dataset.ai)]; a[x.dataset.af] = x.type === "checkbox" ? x.checked : x.value.trim(); if (x.dataset.af === "art") zeichneAdr(); }));
      $$("[data-aweg]", box).forEach((b) => b.addEventListener("click", () => { adr.splice(Number(b.dataset.aweg), 1); zeichneAdr(); }));
    }
    zeichneAdr();
    $("[data-pf-adrneu]", f).addEventListener("click", () => { adr.push({ adresse: "", art: "postfach", auto: true }); zeichneAdr(); });
    const vorschau = async () => { const x = await api("vorschau", { art: vArt, sprache: vSpr, einst: werte() }); if (x.ok && byId("amkpfVorschau")) byId("amkpfVorschau").srcdoc = x.html; };
    $$("[data-v]", f).forEach((b) => b.addEventListener("click", () => { vArt = b.dataset.v; $$("[data-v]", f).forEach((y) => y.classList.toggle("an", y === b)); vorschau(); }));
    $$("[data-s]", f).forEach((b) => b.addEventListener("click", () => { vSpr = b.dataset.s; $$("[data-s]", f).forEach((y) => y.classList.toggle("an", y === b)); vorschau(); }));
    ["signatur", "auto_text", "antwortzeit", "absender_name"].forEach((n) => { let tm = null; f[n].addEventListener("input", () => { clearTimeout(tm); tm = setTimeout(vorschau, 400); }); });
    vorschau();
    $("[data-pf-test]", f).addEventListener("click", async () => {
      const s = await api("einst_speichern", Object.assign(werte(), { adressen: adr })); if (!gut(s)) return;
      const x = await api("test", { an: byId("amkpfTestAn").value, sprache: vSpr }); if (gut(x)) toast("Postfach", "Zwei Testmails gesendet an " + x.an);
    });
    f.addEventListener("submit", async (ev) => {
      ev.preventDefault();
      const s = await api("einst_speichern", Object.assign(werte(), { adressen: adr })); if (!gut(s)) return;
      toast("Postfach", "Gespeichert."); AMKZ.modal.close(); laden(true);
    });
  }

  /* ---------- Zahl ungelesener Tickets an der Leiste ---------- */
  function zahlSetzen(n) {
    const b = document.querySelector('.amkz-nav-item[data-view="postfach"]'); if (!b) return;
    let z = b.querySelector(".amkpf-zahl");
    if (!n) { if (z) z.remove(); return; }
    if (!z) { z = document.createElement("span"); z.className = "amkpf-zahl"; z.title = "Ungelesene Tickets (Ordner „Eingang“ zählt alle offenen)"; (b.querySelector("label") || b).appendChild(z); }
    z.textContent = n > 99 ? "99+" : String(n);
  }
  async function zahlHolen() {
    if (document.hidden || AMKZ.state?.permissions?.postfach !== true) return;
    const r = await api("zahl"); if (r && r.ok) zahlSetzen(r.zahl);
  }

  /* ---------- Einhaengen ---------- */
  AMKZ.postfach = { oeffnen: function (id) { const b = document.querySelector('.amkz-nav-item[data-view="postfach"]'); if (b) b.click(); if (id) setTimeout(() => oeffneFaden(id), 400); } };
  const prevLV = AMKZ.loadView;
  AMKZ.loadView = async function postfachChain(v, o) {
    const r = await prevLV?.call(this, v, o);
    if (v === "postfach") {
      if (!wurzel()) return r;
      stil(); S.aktiv = true;
      if (!wurzel().firstChild || !S.D) geruest();
      laden();
      clearInterval(S.timer);
      S.timer = setInterval(() => { if (!document.hidden && S.aktiv) laden(true); }, 30000);
    } else { S.aktiv = false; clearInterval(S.timer); }
    return r;
  };
  setTimeout(zahlHolen, 4000);
  setInterval(zahlHolen, 60000);
})();

/* =====================================================
   KALENDER = WOCHENPLAN (26.10.2026)
   Ersetzt den alten Kalender. Fester Wochenplan je Person (Schichten mit einer oder mehreren
   Personen), feste Termine, „Beschlossen & Stand“ und datierte Specials/Ausflüge/Urlaub.
   Daten nur über die Edge Function `wochenplan` (Sitzung), Tabellen in supabase-wochenplan.sql.
   Plan ändern: „Team verwalten“ oder Admin. Specials und Ausflüge: alle.
   Klassen-Präfix amkwp- (nichts darf mit der Leiste oder anderen Modulen kollidieren).
===================================================== */
(function () {
  "use strict";
  const AMKZ = window.AMKZ; if (!AMKZ || AMKZ.__wochenplan) return; AMKZ.__wochenplan = true;
  const byId = (id) => document.getElementById(id);
  const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]));
  const toast = (t, m, ty) => (AMKZ.toast || console.log)(t, m, ty);
  const WT = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"], WTL = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"];
  const STATUS = { ok: "Entschieden", live: "Live", bau: "Wird gebaut", auf: "Aufgabe", offen: "Offen" };
  const ART = { launch: "Casino-Launch", giveaway: "Giveaway", turnier: "Turnier", event: "Event", ausflug: "Ausflug", urlaub: "Urlaub", sonstiges: "Sonstiges" };
  const ART_ICON = { launch: "🎰", giveaway: "🎁", turnier: "🏆", event: "★", ausflug: "🚐", urlaub: "🌴", sonstiges: "•" };

  /* ---------- Zustand ---------- */
  const S = { plan: null, stand: null, specials: [], darfPlan: false, edit: false, woche: null, tag: 0, root: null, timer: null, laedt: false, loeschFrage: null, rahmen: { A: 480, E: 1350 } };

  /* ---------- Hilfen ---------- */
  const min = (t) => { const [h, m] = String(t).split(":").map(Number); return h * 60 + (m || 0); };
  const hhmm = (n) => String(Math.floor(n / 60) % 24).padStart(2, "0") + ":" + String(n % 60).padStart(2, "0");
  const iso = (d) => d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
  const wochentag = (d) => (d.getDay() + 6) % 7;
  const montag = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); x.setDate(x.getDate() - wochentag(x)); return x; };
  const kw = (d) => { const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())); const n = t.getUTCDay() || 7; t.setUTCDate(t.getUTCDate() + 4 - n); const j = new Date(Date.UTC(t.getUTCFullYear(), 0, 1)); return Math.ceil(((t - j) / 864e5 + 1) / 7); };
  const tm = (d) => d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" });
  const neueId = (v) => v + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  const rest = (ms) => { const s = Math.max(0, Math.floor(ms / 1000)), t = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60); return (t ? t + " T " : "") + String(h).padStart(2, "0") + " Std " + String(m).padStart(2, "0") + " Min"; };
  const merk = { get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  const $ = (s) => S.root && S.root.querySelector(s);
  const $$ = (s, r) => Array.prototype.slice.call((r || S.root || document).querySelectorAll(s));
  const P = () => (S.plan && S.plan.personen) || [];
  const person = (id) => P().find((p) => p.id === id);
  const farbe = (id) => (person(id) || {}).farbe || "#f2c14e";
  const name = (id) => id === "alle" ? "Alle" : (person(id) || {}).name || "?";
  const kuerzel = (id) => id === "alle" ? "★" : name(id).slice(0, 2).toUpperCase();
  const ava = (id) => `<span class="amkwp-ava" style="--c:${esc(farbe(id))}">${esc(kuerzel(id))}</span>`;
  const chip = (id, t) => `<span class="amkwp-chip" style="--c:${esc(farbe(id))}">${ava(id)}${esc(t ?? name(id))}</span>`;
  const chips = (ids) => (ids && ids.length ? ids : ["alle"]).map((id) => chip(id)).join("");
  const label = (x) => x.t.map((k) => (S.plan.aufgaben || {})[k] || k).join(" + ");
  const tagDatum = (i) => { const d = new Date(S.woche); d.setDate(d.getDate() + i); return d; };
  // Specials an einem Tag — Ausflüge/Urlaub über mehrere Tage zählen an jedem Tag dazwischen
  const specialsAm = (datum) => S.specials.filter((s) => s.datum <= datum && datum <= (s.bis_datum || s.datum)).sort((a, b) => (a.von ? min(a.von) : -1) - (b.von ? min(b.von) : -1));
  const zeitText = (s) => s.von ? esc(s.von) + (s.bis ? "–" + esc(s.bis) : "") : "ganztägig";
  const datumText = (s) => { const a = new Date(s.datum + "T00:00"), b = s.bis_datum ? new Date(s.bis_datum + "T00:00") : null; return b ? tm(a) + "–" + tm(b) : tm(a); };

  /* ---------- Server ---------- */
  async function api(action, daten) {
    const root = byId("amkzApp");
    const url = String(root?.dataset?.supabaseUrl || "https://cbwxgikndyyzdslmfpmo.supabase.co").replace(/\/$/, "") + "/functions/v1/wochenplan";
    const anon = root?.dataset?.supabaseKey || "";
    let r;
    try {
      r = await fetch(window.AMKZ_WOCHENPLAN_URL || url, { method: "POST", headers: { "Content-Type": "application/json", Authorization: "Bearer " + anon, apikey: anon, "x-amk-sitzung": window.AMKZ_WOCHENPLAN_TOKEN || (AMKZ.state.member && AMKZ.state.member.session) || "" },
        body: JSON.stringify(Object.assign({ action }, daten || {})) });
    } catch (_) { return { ok: false, text: "Keine Verbindung. Bitte nochmal versuchen." }; }
    return r.json().catch(() => ({ ok: false, text: "Der Kalender antwortet gerade nicht." }));
  }
  async function laden(still) {
    if (S.laedt) return; S.laedt = true;
    const r = await api("laden"); S.laedt = false;
    if (!r.ok) { if (!still) fehlerAnzeigen(r.text); return; }
    if (!r.plan) { if (!still) fehlerAnzeigen("Noch kein Plan in der Datenbank. supabase-wochenplan.sql einspielen."); return; }
    const offen = byId("amkwpEditor") && !byId("amkwpEditor").hidden;
    S.plan = r.plan; S.stand = r.stand; S.specials = r.specials || []; S.darfPlan = !!r.darf_plan;
    if (!offen || !$("#amkwpTl")) alles(); else { zeichneTage(); zeichneTag(); zeichneSpecials(); live(); }
  }
  async function planSpeichern() {
    status("Speichert …");
    const r = await api("plan_speichern", { plan: S.plan, stand: S.stand });
    if (r.ok) { S.plan = r.plan; S.stand = r.stand; status("Gespeichert ✓"); alles(); return true; }
    if (r.fehler === "konflikt" && r.plan) { S.plan = r.plan; S.stand = r.stand; alles(); }
    status(""); toast("Kalender", r.text || "Speichern hat nicht geklappt.", "error"); return false;
  }
  function status(t) { const s = $("#amkwpStatus"); if (s) s.textContent = t; }
  function fehlerAnzeigen(t) { if (S.root) S.root.innerHTML = '<div class="amkwp"><div class="amkwp-leer" style="padding:30px">' + esc(t || "Fehler") + "</div></div>"; }

  /* ---------- Gerüst ---------- */
  function geruest() {
    S.root.innerHTML = `<div class="amkwp">
      <header class="amkwp-hero">
        <div class="amkwp-hero-text">
          <div class="amkwp-eyebrow">AMK · Teamplan</div>
          <h2 class="amkwp-titel"><span class="g">Kalender</span> &amp; Wochenplan</h2>
          <p>Wer macht wann was, dazu Specials, Ausflüge und Urlaub. Specials und Ausflüge kann jeder eintragen, den Wochenplan ändert, wer „Team verwalten“ hat.</p>
          <div class="amkwp-knoepfe"><button type="button" class="amkwp-btn gold" id="amkwpSpNeu">+ Special / Ausflug</button><button type="button" class="amkwp-btn" id="amkwpEdit" aria-pressed="false" hidden>✎ Plan bearbeiten</button><span class="amkwp-hinweis" id="amkwpStatus"></span></div>
        </div>
        <aside class="amkwp-live" aria-live="polite"><div class="amkwp-live-kopf"><span class="amkwp-puls"></span>Jetzt im Team<span class="amkwp-uhr" id="amkwpUhr">--:--</span></div><div class="amkwp-jetzt" id="amkwpJetzt"></div><div class="amkwp-naechstes" id="amkwpNaechstes"></div></aside>
      </header>
      <section class="amkwp-fix" id="amkwpFix" aria-label="Feste Termine"></section>
      <section><div class="amkwp-kopfzeile"><div><div class="amkwp-eyebrow">Tagesablauf</div><h3>Die Woche</h3></div>
        <div class="amkwp-nav"><button type="button" id="amkwpZurueck" aria-label="Vorige Woche">‹</button><span id="amkwpKw">KW</span><button type="button" id="amkwpVor" aria-label="Nächste Woche">›</button><button type="button" class="heute" id="amkwpHeute">Heute</button></div></div>
        <div class="amkwp-tage" id="amkwpTage" role="group" aria-label="Tag wählen"></div>
        <div class="amkwp-scroll"><div class="amkwp-tl" id="amkwpTl"></div></div>
        <div class="amkwp-leg" id="amkwpLeg"></div></section>
      <section><div class="amkwp-kopfzeile"><div><div class="amkwp-eyebrow">Gold im Zeitstrahl</div><h3>Specials &amp; Ausflüge</h3></div></div><div class="amkwp-sp-grid" id="amkwpSpListe"></div></section>
      <section><div class="amkwp-kopfzeile"><div><div class="amkwp-eyebrow">Gewählte Woche</div><h3>Auf einen Blick</h3></div></div><div class="amkwp-scroll"><table class="amkwp-mx" id="amkwpMx"></table></div></section>
      <section><div class="amkwp-kopfzeile"><div><div class="amkwp-eyebrow">Pro Woche</div><h3>Stunden je Person</h3></div><button type="button" class="amkwp-btn nur-edit" data-wp-neu="person">+ Person</button></div><div class="amkwp-people" id="amkwpPeople"></div></section>
      <section><div class="amkwp-kopfzeile"><div><div class="amkwp-eyebrow">Beschlossen</div><h3>Stand</h3></div><button type="button" class="amkwp-btn nur-edit" data-wp-neu="stand">+ Eintrag</button></div><div class="amkwp-stand" id="amkwpStand"></div></section>
    </div>
    ${byId("amkwpEditor") ? "" : '<div class="amkwp-editor" id="amkwpEditor" hidden></div>'}`;
    $("#amkwpTage").addEventListener("click", (e) => { const x = e.target.closest("button"); if (!x) return; S.tag = +x.dataset.d; merk.set("amkwp-tag", S.tag); zeichneTage(); zeichneTag(); });
    $("#amkwpZurueck").onclick = () => { S.woche.setDate(S.woche.getDate() - 7); alles(); };
    $("#amkwpVor").onclick = () => { S.woche.setDate(S.woche.getDate() + 7); alles(); };
    $("#amkwpHeute").onclick = () => { S.woche = montag(new Date()); S.tag = wochentag(new Date()); alles(); };
    $("#amkwpSpNeu").onclick = () => editorSpecial(null);
    $("#amkwpEdit").onclick = () => { S.edit = !S.edit; S.root.classList.toggle("amkwp-bearbeiten", S.edit); $("#amkwpEdit").setAttribute("aria-pressed", S.edit); $("#amkwpEdit").textContent = S.edit ? "✓ Fertig" : "✎ Plan bearbeiten"; status(S.edit ? "Schicht anklicken = ändern · leere Stelle = neue Schicht · Name = Person" : ""); zeichneTag(); };
    $("#amkwpTl").addEventListener("click", klickZeitstrahl);
    $("#amkwpTl").addEventListener("keydown", (e) => { const x = e.target.closest("[data-sp]"); if (x && e.key === "Enter") editorSpecial(S.specials.find((s) => s.id === x.dataset.sp)); });
    $("#amkwpSpListe").addEventListener("click", klickSpecials);
    S.root.addEventListener("click", (e) => {
      const x = e.target.closest("button"); if (!x) return;
      if (x.dataset.wpBearbFix) editorFix(S.plan.fix.find((f) => f.id === x.dataset.wpBearbFix));
      else if (x.dataset.wpBearbStand) editorStand(S.plan.stand.find((f) => f.id === x.dataset.wpBearbStand));
      else if (x.dataset.wpBearbPerson) editorPerson(person(x.dataset.wpBearbPerson));
      else if (x.dataset.wpNeu === "fix") editorFix(null);
      else if (x.dataset.wpNeu === "stand") editorStand(null);
      else if (x.dataset.wpNeu === "person") editorPerson(null);
    });
  }

  /* ---------- Zeitstrahl ---------- */
  function zeichneTage() {
    const heute = iso(new Date());
    $("#amkwpKw").textContent = `KW ${kw(S.woche)} · ${tm(tagDatum(0))}–${tm(tagDatum(6))}`;
    $("#amkwpTage").innerHTML = WT.map((w, i) => { const d = tagDatum(i), di = iso(d), n = specialsAm(di).length; return `<button type="button" class="amkwp-tag${di === heute ? " heute" : ""}" data-d="${i}" aria-pressed="${i === S.tag}"><span class="wt">${w}</span><span class="dt">${tm(d)}</span>${n ? `<span class="stern" aria-label="${n} Specials">★</span>` : ""}</button>`; }).join("");
  }
  function zeichneTag() {
    const di = iso(tagDatum(S.tag)), sp = specialsAm(di), bl = S.plan.bloecke.filter((x) => x.d === S.tag);
    let A = 480, E = 1350;
    bl.forEach((x) => { A = Math.min(A, Math.floor(min(x.s) / 60) * 60); E = Math.max(E, Math.ceil(min(x.e) / 60) * 60); });
    sp.forEach((s) => { if (!s.von || s.bis_datum) return; A = Math.min(A, Math.floor(min(s.von) / 60) * 60); E = Math.max(E, Math.ceil((s.bis ? min(s.bis) : min(s.von) + 30) / 60) * 60); });
    S.rahmen = { A, E };
    const SPAN = E - A, pos = (t) => (t - A) / SPAN * 100, stunde = 60 / SPAN * 100;
    const ticks = []; for (let h = Math.ceil(A / 60); h * 60 <= E; h++) ticks.push(h);
    let html = `<div class="amkwp-axis"><div></div><div class="ticks">${ticks.map((h) => `<span style="left:${pos(h * 60)}%">${String(h % 24).padStart(2, "0")}</span>`).join("")}</div></div>`;
    if (sp.length || S.edit) {
      html += `<div class="amkwp-lane spezial"><div class="who"><span class="amkwp-ava" style="--c:#f2c14e">★</span><div>Specials<small>${sp.length ? sp.length + " am " + WTL[S.tag] : "Klick: neues Special"}</small></div></div><div class="track" data-spur="special" style="--stunde:${stunde}%"><div class="grid"></div>${
        sp.map((s) => {
          const ganz = !s.von || !!s.bis_datum, v = ganz ? A : min(s.von), e = ganz ? E : (s.bis ? min(s.bis) : v + 20);
          return `<div class="blk sp${ganz ? " ganz" : s.bis ? "" : " punkt"} art-${esc(s.art)}" data-sp="${esc(s.id)}" role="button" tabindex="0" style="left:${pos(v)}%;width:${Math.max(pos(e) - pos(v), 1.2)}%" title="${esc(s.titel)} · ${zeitText(s)}">${ART_ICON[s.art] || "★"} ${esc(s.titel)}<small>${s.bis_datum ? datumText(s) + " · " : ""}${zeitText(s)} · ${esc((s.wer || ["alle"]).map(name).join(", "))}</small></div>`;
        }).join("")}</div></div>`;
    }
    for (const p of P()) {
      const meine = bl.filter((x) => x.ps.includes(p.id));
      html += `<div class="amkwp-lane"><div class="who" data-person="${esc(p.id)}">${ava(p.id)}<div>${esc(p.name)}<small>${esc(p.rolle)}</small></div></div><div class="track" data-spur="${esc(p.id)}" style="--stunde:${stunde}%"><div class="grid"></div>${
        meine.map((x) => { const mit = x.ps.filter((y) => y !== p.id).map(name); return `<div class="blk${mit.length ? " mehr" : ""}" data-blk="${esc(x.id)}" style="--c:${esc(p.farbe)};left:${pos(min(x.s))}%;width:${pos(min(x.e)) - pos(min(x.s))}%" title="${esc(label(x))} ${x.s}–${x.e}${mit.length ? " · mit " + esc(mit.join(", ")) : ""}">${esc(label(x))}<small>${x.s}–${x.e}${mit.length ? " · mit " + esc(mit.join(", ")) : ""}</small></div>`; }).join("")
      }${meine.length || S.edit ? "" : '<div class="blk frei" style="left:0;width:100%">frei</div>'}</div></div>`;
    }
    const jetzt = new Date();
    if (iso(jetzt) === di) { const n = jetzt.getHours() * 60 + jetzt.getMinutes(); if (n >= A && n <= E) html += `<div class="amkwp-jetztlinie" data-zeit="${hhmm(n)}" style="left:calc(134px + (100% - 148px) * ${(pos(n) / 100).toFixed(4)})"></div>`; }
    $("#amkwpTl").innerHTML = html;
  }
  function klickZeitstrahl(e) {
    const sp = e.target.closest("[data-sp]"); if (sp) { editorSpecial(S.specials.find((s) => s.id === sp.dataset.sp)); return; }
    if (!S.edit) return;
    const blk = e.target.closest("[data-blk]"); if (blk) { editorBlock(S.plan.bloecke.find((x) => x.id === blk.dataset.blk)); return; }
    const wer = e.target.closest("[data-person]"); if (wer) { editorPerson(person(wer.dataset.person)); return; }
    const spur = e.target.closest(".track"); if (!spur) return;
    const r = spur.getBoundingClientRect(), t = Math.round((S.rahmen.A + (e.clientX - r.left) / r.width * (S.rahmen.E - S.rahmen.A)) / 30) * 30;
    if (spur.dataset.spur === "special") editorSpecial(null, { von: hhmm(t) });
    else editorBlock(null, { ps: [spur.dataset.spur], s: hhmm(t), e: hhmm(Math.min(t + 60, 1439)) });
  }

  /* ---------- Jetzt im Team ---------- */
  function live() {
    if (!S.root || !S.plan) return;
    const j = new Date(), n = j.getHours() * 60 + j.getMinutes(), d = wochentag(j), di = iso(j);
    $("#amkwpUhr").textContent = hhmm(n) + " · " + WT[d];
    const laeuft = S.plan.bloecke.filter((x) => x.d === d && min(x.s) <= n && n < min(x.e));
    const spJetzt = specialsAm(di).filter((s) => !s.von || s.bis_datum || (min(s.von) <= n && n < (s.bis ? min(s.bis) : min(s.von) + 30)));
    $("#amkwpJetzt").innerHTML = (spJetzt.map((s) => `<div class="zeile">${chip((s.wer || [])[0] || "alle", (ART_ICON[s.art] || "★") + " " + (ART[s.art] || "Special"))}<span class="was">${esc(s.titel)}</span><span class="zeit">${zeitText(s)}</span></div>`).join("") +
      laeuft.map((x) => `<div class="zeile"><span class="mehrere">${x.ps.map((p) => chip(p)).join("")}</span><span class="was">${esc(label(x))}</span><span class="zeit">bis ${x.e}</span></div>`).join("")) || '<div class="amkwp-leer">Gerade ist nichts eingeplant.</div>';
    const kommend = S.plan.bloecke.filter((x) => x.d === d && min(x.s) > n).sort((a, b) => min(a.s) - min(b.s))[0];
    const nsp = S.specials.map((s) => ({ s, t: new Date(s.datum + "T" + (s.von || "00:00")) })).filter((x) => x.t > j).sort((a, b) => a.t - b.t)[0];
    $("#amkwpNaechstes").innerHTML = (kommend ? `Als Nächstes: <b>${kommend.s}</b> ${esc(label(kommend))} · ${esc(kommend.ps.map(name).join(", "))}` : "Heute steht im Plan nichts mehr an.") +
      (nsp ? `<br>Nächstes Special: <b>${esc(nsp.s.titel)}</b> · <span class="amkwp-countdown">in ${rest(nsp.t - j)}</span>` : "");
  }

  /* ---------- Termine, Stand, Legende, Personen, Matrix ---------- */
  const mini = (art, id) => `<span class="amkwp-mini nur-edit"><button type="button" class="amkwp-btn klein" data-wp-bearb-${art}="${esc(id)}">Ändern</button></span>`;
  function zeichneFix() { $("#amkwpFix").innerHTML = S.plan.fix.map((f) => `<div class="karte">${mini("fix", f.id)}<b>${esc(f.titel)}</b><small>${esc(f.text)}</small></div>`).join("") + '<button type="button" class="karte neu nur-edit" data-wp-neu="fix">+ Termin</button>'; }
  function zeichneStand() { $("#amkwpStand").innerHTML = S.plan.stand.map((s) => `<div class="eintrag"><span class="tag ${esc(s.status)}">${esc(STATUS[s.status] || s.status)}</span><p><b>${esc(s.titel)}</b>${esc(s.text)}</p>${mini("stand", s.id)}</div>`).join("") || '<div class="amkwp-leer">Noch keine Einträge.</div>'; }
  function zeichneLegende() { $("#amkwpLeg").innerHTML = P().map((p) => chip(p.id)).join("") + chip("alle", "★ Special"); }
  function zeichnePersonen() {
    const daten = P().map((p) => { const bl = S.plan.bloecke.filter((x) => x.ps.includes(p.id)); const agg = {}; bl.forEach((x) => x.t.forEach((k) => (agg[k] = (agg[k] || 0) + min(x.e) - min(x.s)))); return { p, m: bl.reduce((s, x) => s + min(x.e) - min(x.s), 0), tage: new Set(bl.map((x) => x.d)).size, agg }; });
    const max = Math.max(1, ...daten.map((x) => x.m));
    $("#amkwpPeople").innerHTML = daten.map((x) => `<div class="pc" style="--c:${esc(x.p.farbe)}">${mini("person", x.p.id)}<div class="n">${ava(x.p.id)}${esc(x.p.name)}</div><div class="h">${(x.m / 60).toLocaleString("de-DE")} Std. · ${x.tage} ${x.tage === 1 ? "Tag" : "Tage"}</div><div class="bar"><i style="width:${(x.m / max * 100).toFixed(1)}%"></i></div><ul>${Object.entries(x.agg).sort((a, b) => b[1] - a[1]).map(([k, v]) => `<li>${esc(S.plan.aufgaben[k] || k)}: ${(v / 60).toLocaleString("de-DE")} Std.</li>`).join("")}</ul></div>`).join("");
  }
  function zeichneMatrix() {
    const heute = iso(new Date());
    let h = `<thead><tr><th>Aufgabe</th>${WT.map((w, i) => `<th class="${iso(tagDatum(i)) === heute ? "heute" : ""}">${w} ${tm(tagDatum(i))}</th>`).join("")}</tr></thead><tbody>`;
    h += `<tr class="sp"><th>★ Specials</th>${WT.map((w, i) => { const sp = specialsAm(iso(tagDatum(i))); return sp.length ? `<td>${sp.map((s) => `${chip((s.wer || [])[0] || "alle", (ART_ICON[s.art] || "★") + " " + s.titel)}<span class="t">${zeitText(s)}</span>`).join("")}</td>` : '<td class="strich">–</td>'; }).join("")}</tr>`;
    for (const k of Object.keys(S.plan.aufgaben)) {
      if (!S.plan.bloecke.some((x) => x.t.includes(k))) continue;
      h += `<tr><th>${esc(S.plan.aufgaben[k])}</th>`;
      for (let d = 0; d < 7; d++) {
        const bl = S.plan.bloecke.filter((x) => x.d === d && x.t.includes(k));
        h += bl.length ? `<td>${bl.map((x) => `<span class="mehrere">${x.ps.map((p) => chip(p)).join("")}</span><span class="t">${x.s}–${x.e}</span>`).join("")}</td>` : '<td class="strich">–</td>';
      }
      h += "</tr>";
    }
    $("#amkwpMx").innerHTML = h + "</tbody>";
  }

  /* ---------- Specials-Liste ---------- */
  function zeichneSpecials() {
    const heute = iso(new Date()), j = new Date();
    const liste = [...S.specials].sort((a, b) => (a.datum + (a.von || "")).localeCompare(b.datum + (b.von || "")));
    const kommend = liste.filter((s) => (s.bis_datum || s.datum) >= heute), vorbei = liste.filter((s) => (s.bis_datum || s.datum) < heute).slice(-3).reverse();
    const karte = (s, alt) => { const d = new Date(s.datum + "T00:00"), t = new Date(s.datum + "T" + (s.von || "00:00"));
      return `<article class="sp-karte art-${esc(s.art)}${alt ? " vorbei" : ""}"><div class="datum"><span class="tg">${String(d.getDate()).padStart(2, "0")}</span><span class="mon">${WTL[wochentag(d)]}<br>${s.bis_datum ? "bis " + datumText(s).split("–")[1] : d.toLocaleDateString("de-DE", { month: "long", year: "numeric" })}</span><span class="uhr">${zeitText(s)}</span></div>
        <h4>${ART_ICON[s.art] || "★"} ${esc(s.titel)}</h4>${s.notiz ? `<p>${esc(s.notiz)}</p>` : ""}
        <div class="fuss"><span class="art">${esc(ART[s.art] || "Special")}</span><span class="mehrere">${chips(s.wer)}</span>${!alt && t > j ? `<span class="amkwp-countdown">in ${rest(t - j)}</span>` : ""}
        <span class="werkzeug">${S.loeschFrage === s.id ? `<button type="button" class="amkwp-btn klein rot" data-weg-ja="${esc(s.id)}">Wirklich löschen</button><button type="button" class="amkwp-btn klein" data-weg-nein>Nein</button>` : `<button type="button" class="amkwp-btn klein" data-bearb-sp="${esc(s.id)}">Ändern</button><button type="button" class="amkwp-btn klein rot" data-weg="${esc(s.id)}">Löschen</button>`}</span></div></article>`; };
    $("#amkwpSpListe").innerHTML = kommend.map((s) => karte(s, false)).join("") + vorbei.map((s) => karte(s, true)).join("") || '<div class="amkwp-leer">Noch keine Specials. Trag oben eins ein, zum Beispiel einen Casino-Launch oder einen Ausflug.</div>';
  }
  async function klickSpecials(e) {
    const x = e.target.closest("button"); if (!x) return;
    if (x.dataset.bearbSp) { editorSpecial(S.specials.find((s) => s.id === x.dataset.bearbSp)); return; }
    if (x.dataset.weg) { S.loeschFrage = x.dataset.weg; zeichneSpecials(); return; }
    if (x.hasAttribute("data-weg-nein")) { S.loeschFrage = null; zeichneSpecials(); return; }
    if (x.dataset.wegJa) { x.disabled = true; const r = await api("special_loeschen", { id: x.dataset.wegJa }); if (!r.ok) { toast("Kalender", r.text, "error"); x.disabled = false; return; } S.loeschFrage = null; S.specials = S.specials.filter((s) => s.id !== x.dataset.wegJa); alles(); }
  }

  function alles() { if (!S.plan || !S.root) return; if (!$("#amkwpTl")) geruest(); const eb = $("#amkwpEdit"); if (eb) eb.hidden = !S.darfPlan; zeichneTage(); zeichneTag(); zeichneMatrix(); zeichneSpecials(); zeichneFix(); zeichneStand(); zeichnePersonen(); zeichneLegende(); live(); }

  /* ================= Editor (Fenster in der Mitte) ================= */
  function editorAuf(titel, felder, beiSpeichern, beiLoeschen, loeschText) {
    const ed = byId("amkwpEditor");
    // direkt an <body>: in der Zentrale bezieht ein Eltern-Rahmen (transform/filter) „position:fixed“ sonst auf den Bereich
    if (ed.parentNode !== document.body) document.body.appendChild(ed);
    ed.innerHTML = `<form class="amkwp-ed" id="amkwpEdF" role="dialog" aria-modal="true" novalidate><div class="amkwp-ed-kopf"><h3>${titel}</h3><button type="button" class="amkwp-ed-zu" data-ed-zu aria-label="Schließen">✕</button></div>${felder}<div class="amkwp-fehler" id="amkwpEdFehler" role="alert"></div>
      <div class="amkwp-ed-knoepfe">${beiLoeschen ? '<button type="button" class="amkwp-btn rot links" id="amkwpEdWeg">Löschen</button>' : ""}<button type="button" class="amkwp-btn" data-ed-zu>Abbrechen</button><button type="submit" class="amkwp-btn gold" id="amkwpEdOk">Speichern</button></div></form>`;
    ed.hidden = false;
    const f = byId("amkwpEdF");
    $$("[data-ed-zu]", ed).forEach((b) => (b.onclick = editorZu));
    ed.onclick = (e) => { if (e.target === ed) editorZu(); };
    if (beiLoeschen) { let frage = false; byId("amkwpEdWeg").onclick = async () => { if (!frage) { frage = true; byId("amkwpEdWeg").textContent = loeschText || "Wirklich löschen?"; return; } await beiLoeschen(); editorZu(); }; }
    f.addEventListener("submit", async (e) => { e.preventDefault(); byId("amkwpEdOk").disabled = true; const fehler = await beiSpeichern(f); byId("amkwpEdOk").disabled = false; if (fehler) { byId("amkwpEdFehler").textContent = fehler; return; } editorZu(); });
    const erstes = f.querySelector("input:not([type=checkbox]),select,textarea"); if (erstes) erstes.focus({ preventScroll: true });
  }
  function editorZu() { const ed = byId("amkwpEditor"); if (!ed) return; ed.hidden = true; ed.innerHTML = ""; }
  document.addEventListener("keydown", (e) => { const ed = byId("amkwpEditor"); if (e.key === "Escape" && ed && !ed.hidden) editorZu(); });
  const haken = (name, liste, gewaehlt) => `<div class="amkwp-haken">${liste.map(([v, l]) => `<label><input type="checkbox" name="${name}" value="${esc(v)}"${gewaehlt.includes(v) ? " checked" : ""}>${esc(l)}</label>`).join("")}</div>`;
  const werte = (f, name) => $$(`input[name=${name}]:checked`, f).map((i) => i.value);
  const personenListe = () => P().map((p) => [p.id, p.name]);
  const zeitOk = (v, b) => /^\d{2}:\d{2}$/.test(v) && /^\d{2}:\d{2}$/.test(b) && min(b) > min(v);

  function editorBlock(x, vor) {
    if (!S.darfPlan) return;
    const v = x || Object.assign({ d: S.tag, ps: [], s: "10:00", e: "11:00", t: [] }, vor);
    editorAuf(x ? "Schicht ändern" : "Neue Schicht", `<div class="amkwp-felder">
      <div class="amkwp-feld ganz">Wer (mehrere möglich)${haken("ps", personenListe(), v.ps)}</div>
      <label class="amkwp-feld">Von<input name="s" type="time" value="${esc(v.s)}" required></label>
      <label class="amkwp-feld">Bis<input name="e" type="time" value="${esc(v.e)}" required></label>
      <div class="amkwp-feld ganz">Tage${x ? " · weitere Tage anhaken = Kopie" : ""}${haken("tage", WT.map((w, i) => [String(i), w]), [String(v.d)])}</div>
      <div class="amkwp-feld ganz">Aufgaben${haken("t", Object.entries(S.plan.aufgaben), v.t)}</div>
      <label class="amkwp-feld ganz">Neue Aufgabe dazu (optional)<input name="neu" maxlength="50" placeholder="z. B. Turnier-Moderation"></label></div>`,
      async (f) => {
        const ps = werte(f, "ps"), tage = werte(f, "tage").map(Number), t = werte(f, "t"), neu = f.neu.value.trim();
        if (!ps.length) return "Bitte mindestens eine Person wählen.";
        if (!tage.length) return "Bitte mindestens einen Tag wählen.";
        if (neu) { const k = neueId("a"); S.plan.aufgaben[k] = neu; t.push(k); }
        if (!t.length) return "Bitte mindestens eine Aufgabe wählen.";
        if (!zeitOk(f.s.value, f.e.value)) return "„Bis“ muss nach „Von“ liegen.";
        const d = { ps, s: f.s.value, e: f.e.value, t };
        if (x) { Object.assign(x, d, { d: tage[0] }); tage.slice(1).forEach((tg) => S.plan.bloecke.push(Object.assign({ id: neueId("b"), d: tg }, d))); }
        else tage.forEach((tg) => S.plan.bloecke.push(Object.assign({ id: neueId("b"), d: tg }, d)));
        return (await planSpeichern()) ? "" : "Nicht gespeichert.";
      },
      x && (async () => { S.plan.bloecke = S.plan.bloecke.filter((y) => y !== x); await planSpeichern(); }));
  }
  function editorPerson(p) {
    if (!S.darfPlan) return;
    const v = p || { name: "", rolle: "", farbe: "#7fb3ff" };
    const anzahl = p ? S.plan.bloecke.filter((x) => x.ps.includes(p.id)).length : 0;
    editorAuf(p ? "Person ändern" : "Neue Person", `<div class="amkwp-felder">
      <label class="amkwp-feld">Name<input name="name" maxlength="30" value="${esc(v.name)}" required></label>
      <label class="amkwp-feld">Farbe<input name="farbe" type="color" value="${esc(v.farbe)}"></label>
      <label class="amkwp-feld ganz">Rolle / Kurzbeschreibung<input name="rolle" maxlength="60" value="${esc(v.rolle)}" placeholder="z. B. Stream Di–Fr"></label></div>`,
      async (f) => {
        const n = f.name.value.trim(); if (!n) return "Bitte einen Namen eintragen.";
        if (p) Object.assign(p, { name: n, rolle: f.rolle.value.trim(), farbe: f.farbe.value });
        else S.plan.personen.push({ id: neueId("p"), name: n, rolle: f.rolle.value.trim(), farbe: f.farbe.value });
        return (await planSpeichern()) ? "" : "Nicht gespeichert.";
      },
      p && (async () => { S.plan.personen = S.plan.personen.filter((y) => y !== p); S.plan.bloecke = S.plan.bloecke.map((x) => Object.assign({}, x, { ps: x.ps.filter((y) => y !== p.id) })).filter((x) => x.ps.length); await planSpeichern(); }),
      anzahl ? `Wirklich löschen? Betrifft ${anzahl} Schichten` : "Wirklich löschen?");
  }
  function editorFix(x) {
    if (!S.darfPlan) return;
    const v = x || { titel: "", text: "" };
    editorAuf(x ? "Termin ändern" : "Neuer fester Termin", `<div class="amkwp-felder"><label class="amkwp-feld">Wann<input name="titel" maxlength="30" value="${esc(v.titel)}" placeholder="z. B. Mo 10:00" required></label><label class="amkwp-feld">Was<input name="text" maxlength="80" value="${esc(v.text)}" placeholder="z. B. Mitarbeiter-Meeting"></label></div>`,
      async (f) => { const t = f.titel.value.trim(); if (!t) return "Bitte eintragen, wann."; if (x) Object.assign(x, { titel: t, text: f.text.value.trim() }); else S.plan.fix.push({ id: neueId("f"), titel: t, text: f.text.value.trim() }); return (await planSpeichern()) ? "" : "Nicht gespeichert."; },
      x && (async () => { S.plan.fix = S.plan.fix.filter((y) => y !== x); await planSpeichern(); }));
  }
  function editorStand(x) {
    if (!S.darfPlan) return;
    const v = x || { status: "ok", titel: "", text: "" };
    editorAuf(x ? "Eintrag ändern" : "Neuer Eintrag", `<div class="amkwp-felder"><label class="amkwp-feld">Status<select name="status">${Object.entries(STATUS).map(([k, l]) => `<option value="${k}"${k === v.status ? " selected" : ""}>${l}</option>`).join("")}</select></label><label class="amkwp-feld">Überschrift<input name="titel" maxlength="90" value="${esc(v.titel)}" required></label><label class="amkwp-feld ganz">Text<textarea name="text" maxlength="600">${esc(v.text)}</textarea></label></div>`,
      async (f) => { const t = f.titel.value.trim(); if (!t) return "Bitte eine Überschrift eintragen."; const d = { status: f.status.value, titel: t, text: f.text.value.trim() }; if (x) Object.assign(x, d); else S.plan.stand.push(Object.assign({ id: neueId("s") }, d)); return (await planSpeichern()) ? "" : "Nicht gespeichert."; },
      x && (async () => { S.plan.stand = S.plan.stand.filter((y) => y !== x); await planSpeichern(); }));
  }
  function editorSpecial(s, vor) {
    const v = s || Object.assign({ datum: iso(tagDatum(S.tag)), bis_datum: "", von: "18:00", bis: "", titel: "", art: "event", wer: ["alle"], notiz: "" }, vor);
    editorAuf(s ? "Eintrag ändern" : "Neues Special / Ausflug", `<div class="amkwp-felder">
      <label class="amkwp-feld ganz">Titel<input name="titel" maxlength="80" value="${esc(v.titel)}" placeholder="z. B. Teamausflug Gardasee" required></label>
      <div class="amkwp-feld ganz">Art${`<div class="amkwp-haken eins">${Object.entries(ART).map(([k, l]) => `<label><input type="radio" name="art" value="${k}"${k === v.art ? " checked" : ""}>${ART_ICON[k]} ${l}</label>`).join("")}</div>`}</div>
      <div class="amkwp-feld ganz">Wer (mehrere möglich)${haken("wer", [["alle", "Alle"]].concat(personenListe()), v.wer || ["alle"])}</div>
      <label class="amkwp-feld">Datum<input name="datum" type="date" value="${esc(v.datum)}" required></label>
      <label class="amkwp-feld">Bis Datum (mehrere Tage)<input name="bis_datum" type="date" value="${esc(v.bis_datum || "")}"></label>
      <label class="amkwp-feld">Von (leer = ganztägig)<input name="von" type="time" value="${esc(v.von || "")}"></label>
      <label class="amkwp-feld">Bis<input name="bis" type="time" value="${esc(v.bis || "")}"></label>
      <label class="amkwp-feld ganz">Notiz (optional)<textarea name="notiz" maxlength="400" placeholder="Was passiert genau, was muss vorbereitet werden?">${esc(v.notiz || "")}</textarea></label></div>`,
      async (f) => {
        let wer = werte(f, "wer"); if (wer.includes("alle") && wer.length > 1) wer = wer.filter((x) => x !== "alle");
        const art = (f.querySelector("input[name=art]:checked") || {}).value || "event";
        const r = await api("special_speichern", { id: s ? s.id : undefined, titel: f.titel.value, art, wer, datum: f.datum.value, bis_datum: f.bis_datum.value, von: f.von.value, bis: f.bis.value, notiz: f.notiz.value });
        if (!r.ok) return r.text || "Speichern hat nicht geklappt.";
        S.specials = S.specials.filter((x) => x.id !== r.special.id).concat([r.special]);
        const d = new Date(r.special.datum + "T00:00"); S.woche = montag(d); S.tag = wochentag(d); alles(); return "";
      },
      s && (async () => { const r = await api("special_loeschen", { id: s.id }); if (!r.ok) { toast("Kalender", r.text, "error"); return; } S.specials = S.specials.filter((x) => x.id !== s.id); alles(); }));
  }

  /* ---------- Stil ---------- */
  function stil() {
    if (byId("amkwp-css")) return;
    const st = document.createElement("style"); st.id = "amkwp-css";
    st.textContent = `
#amkzCalendarView>:not(#amkwpRoot){display:none!important}
#amkzStreamingView .amksz-kopf{display:flex;justify-content:space-between;align-items:end;gap:18px;flex-wrap:wrap;margin:4px 0 18px}
#amkzStreamingView .amksz-eyebrow{font:700 10.5px "JetBrains Mono",ui-monospace,monospace;letter-spacing:.18em;text-transform:uppercase;color:var(--amk-gold,#f2c14e)}
#amkzStreamingView .amksz-titel{margin:6px 0 0;font-family:"Anton","Barlow Condensed","Impact",sans-serif;font-weight:400;font-size:clamp(34px,5vw,56px);line-height:.95;text-transform:uppercase;background:linear-gradient(180deg,#ffe39a,var(--amk-gold,#f2c14e) 45%,#b8862a);-webkit-background-clip:text;background-clip:text;color:transparent}
#amkzStreamingView .amksz-kopf p{margin:8px 0 0;color:var(--amk-text-2);font-size:14px;max-width:56ch}
#amkzStreamingView .amksz-kennzahlen{display:flex;gap:10px}
#amkzStreamingView .amksz-kennzahlen div{min-width:86px;padding:12px 14px;border-radius:16px;background:var(--rt-glas,rgba(255,255,255,.04));border:1px solid var(--rt-kante,rgba(255,255,255,.1));text-align:center}
#amkzStreamingView .amksz-kennzahlen b{display:block;font:800 26px/1 "JetBrains Mono",ui-monospace,monospace;color:var(--amk-pos,#3ddc97)}
#amkzStreamingView .amksz-kennzahlen .leer b{color:var(--amk-neg,#ff5c72)}
#amkzStreamingView .amksz-kennzahlen div:last-child b{color:var(--amk-gold,#f2c14e)}
#amkzStreamingView .amksz-kennzahlen small{display:block;margin-top:5px;font:700 10px "JetBrains Mono",monospace;letter-spacing:.14em;text-transform:uppercase;color:var(--amk-muted)}
#amkzStreamingView .amksz-grid{grid-template-columns:minmax(0,1.05fr) minmax(0,1fr);gap:18px;align-items:start}
#amkzStreamingView .amksz-grid .amkz-stream-card{border-radius:20px;padding:18px;background:var(--rt-glas,var(--amk-surface));border:1px solid var(--rt-kante,var(--amk-line));backdrop-filter:blur(14px)}
#amkzStreamingView .amksz-grid .amkz-stream-card h3{font-family:"Barlow Condensed","Anton",sans-serif;font-style:italic;font-weight:900;text-transform:uppercase;letter-spacing:.02em;font-size:22px;margin:0 0 4px}
#amkzStreamingView #amkzStreamHub{display:none!important}
@media (max-width:900px){#amkzStreamingView .amksz-grid{grid-template-columns:1fr}#amkzStreamingView .amksz-kennzahlen{width:100%}#amkzStreamingView .amksz-kennzahlen div{flex:1;min-width:0}}
.amkwp,.amkwp-editor{--wp-bg2:#100e0c;--wp-panel:#15120e;--wp-panel2:#1c1813;--wp-line:#2a2419;--wp-line2:#3a3123;--wp-fg:#f4ecdc;--wp-fg2:#c9bea8;--wp-mute:#8a8070;--wp-gold:#f2c14e;--wp-gold2:#b8862a;--wp-hell:#ffe39a;--wp-rot:#ff6b6b;--wp-gruen:#3ddc97;
  --wp-disp:"Anton","Bebas Neue","Impact","Arial Narrow",sans-serif;--wp-mono:"JetBrains Mono",ui-monospace,Menlo,monospace;
  color:var(--wp-fg);display:grid;grid-template-columns:minmax(0,1fr);gap:36px;padding-bottom:40px;min-width:0}
.amkwp>*{min-width:0}
#amkwpRoot{min-width:0;max-width:100%}
.amkwp h2,.amkwp h3,.amkwp h4{margin:0;text-wrap:balance}
.amkwp h3{font-family:var(--wp-disp);font-weight:400;font-size:clamp(24px,3vw,32px);letter-spacing:.03em;text-transform:uppercase;line-height:1}
.amkwp-eyebrow{font:700 10.5px var(--wp-mono);letter-spacing:.18em;text-transform:uppercase;color:var(--wp-gold)}
.amkwp-kopfzeile{display:flex;justify-content:space-between;align-items:end;gap:12px;flex-wrap:wrap;margin-bottom:14px}
.amkwp button{font:inherit;color:inherit}
.amkwp-hero{display:grid;grid-template-columns:minmax(0,1.2fr) minmax(0,1fr);gap:22px;align-items:end}
.amkwp-titel{font-family:var(--wp-disp);font-weight:400;font-size:clamp(38px,6vw,72px);line-height:.92;text-transform:uppercase;letter-spacing:.01em;margin-top:8px}
.amkwp-titel .g{background:linear-gradient(180deg,var(--wp-hell),var(--wp-gold) 45%,var(--wp-gold2));-webkit-background-clip:text;background-clip:text;color:transparent}
.amkwp-hero p{color:var(--wp-fg2);max-width:60ch;margin:12px 0 0;font-size:14px}
.amkwp-knoepfe{display:flex;gap:10px;align-items:center;flex-wrap:wrap;margin-top:16px}
.amkwp-hinweis{font-size:12.5px;color:var(--wp-mute)}
.amkwp-btn{display:inline-flex;align-items:center;gap:8px;border-radius:12px;padding:10px 15px;font-weight:800 !important;font-size:13.5px !important;cursor:pointer;border:1px solid var(--wp-line2);background:var(--wp-panel2);color:var(--wp-fg)}
.amkwp-btn:hover{border-color:var(--wp-gold)}
.amkwp-btn.gold{background:linear-gradient(135deg,var(--wp-hell),var(--wp-gold) 55%,var(--wp-gold2));color:#130f08;border-color:transparent;box-shadow:0 10px 30px -12px rgba(242,193,78,.8)}
.amkwp-btn[aria-pressed="true"]{background:var(--wp-rot);color:#fff;border-color:transparent}
.amkwp-btn.klein{padding:5px 9px;font-size:12px !important;border-radius:9px}
.amkwp-btn.rot{color:var(--wp-rot)}
.amkwp-btn:disabled{opacity:.45;cursor:not-allowed}
.amkwp-live{background:linear-gradient(160deg,rgba(242,193,78,.12),rgba(21,18,14,.92) 40%);border:1px solid var(--wp-line2);border-radius:20px;padding:18px;display:grid;gap:12px;position:relative;overflow:hidden;min-width:0}
.amkwp-live::before{content:"";position:absolute;inset:0 0 auto;height:2px;background:linear-gradient(90deg,transparent,var(--wp-gold),transparent)}
.amkwp-live-kopf{display:flex;align-items:center;gap:10px;font:700 11.5px var(--wp-mono);letter-spacing:.14em;text-transform:uppercase;color:var(--wp-fg2)}
.amkwp-puls{width:9px;height:9px;border-radius:50%;background:var(--wp-rot);animation:amkwpPuls 1.8s infinite}
@keyframes amkwpPuls{0%{box-shadow:0 0 0 0 rgba(255,107,107,.6)}70%{box-shadow:0 0 0 10px rgba(255,107,107,0)}100%{box-shadow:0 0 0 0 rgba(255,107,107,0)}}
.amkwp-uhr{margin-left:auto;color:var(--wp-gold);font-variant-numeric:tabular-nums}
.amkwp-jetzt{display:grid;gap:8px}
.amkwp-jetzt .zeile{display:flex;gap:10px;align-items:center;min-width:0}
.amkwp-jetzt .was{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:13.5px}
.amkwp-jetzt .zeit{font:500 11.5px var(--wp-mono);color:var(--wp-mute);white-space:nowrap}
.amkwp-naechstes{border-top:1px solid var(--wp-line);padding-top:10px;font-size:12.5px;color:var(--wp-fg2)}
.amkwp-naechstes b{color:var(--wp-gold)}
.amkwp-leer{color:var(--wp-mute);font-size:13.5px}
.amkwp-ava{--c:#f2c14e;width:24px;height:24px;flex:none;border-radius:8px;display:grid;place-items:center;font:800 10.5px/1 system-ui;color:#130f08;background:var(--c);box-shadow:0 0 0 1px rgba(0,0,0,.4),0 4px 14px -4px var(--c)}
.amkwp-chip{--c:#f2c14e;display:inline-flex;align-items:center;gap:6px;border-radius:999px;padding:3px 10px 3px 3px;background:color-mix(in srgb,var(--c) 14%,transparent);border:1px solid color-mix(in srgb,var(--c) 40%,transparent);font-size:11.5px;font-weight:700;white-space:nowrap;max-width:100%;overflow:hidden;text-overflow:ellipsis}
.amkwp-chip .amkwp-ava{width:19px;height:19px;border-radius:999px;font-size:8.5px}
.amkwp .mehrere{display:inline-flex;flex-wrap:wrap;gap:4px}
.amkwp-fix{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px}
.amkwp-fix .karte{position:relative;background:var(--wp-panel);border:1px solid var(--wp-line);border-radius:16px;padding:13px 15px;display:grid;gap:3px;text-align:left}
.amkwp-fix b{font-family:var(--wp-disp);font-weight:400;font-size:20px;letter-spacing:.03em;color:var(--wp-hell)}
.amkwp-fix small{color:var(--wp-fg2);font-size:12.5px}
.amkwp-fix .neu{border-style:dashed;place-items:center;color:var(--wp-mute);font-weight:800;cursor:pointer;background:transparent}
.amkwp-nav{display:flex;align-items:center;gap:8px}
.amkwp-nav button{background:var(--wp-panel);border:1px solid var(--wp-line2);border-radius:10px;width:36px;height:36px;cursor:pointer;font-size:18px}
.amkwp-nav button:hover{border-color:var(--wp-gold)}
.amkwp-nav span{font:700 12.5px var(--wp-mono);letter-spacing:.06em;min-width:180px;text-align:center}
.amkwp-nav .heute{width:auto;padding:0 12px;font-size:12.5px;font-weight:700}
.amkwp-tage{display:grid;grid-template-columns:repeat(7,minmax(0,1fr));gap:6px;margin-bottom:12px;padding-top:8px}
.amkwp-tag{background:var(--wp-panel);border:1px solid var(--wp-line);border-radius:14px;padding:9px 6px;cursor:pointer;display:grid;gap:2px;justify-items:center;position:relative}
.amkwp-tag .wt{font-weight:800;font-size:13px}
.amkwp-tag .dt{font:500 10.5px var(--wp-mono);color:var(--wp-mute)}
.amkwp-tag.heute .wt{color:var(--wp-gold)}
.amkwp-tag.heute::after{content:"HEUTE";position:absolute;top:-8px;font:800 8px var(--wp-mono);letter-spacing:.12em;background:var(--wp-gold);color:#130f08;padding:2px 6px;border-radius:999px}
.amkwp-tag[aria-pressed="true"]{background:linear-gradient(180deg,rgba(242,193,78,.2),rgba(242,193,78,.05));border-color:var(--wp-gold)}
.amkwp-tag .stern{position:absolute;bottom:4px;right:6px;font-size:10px;color:var(--wp-gold);text-shadow:0 0 8px var(--wp-gold)}
.amkwp-scroll{overflow-x:auto;border:1px solid var(--wp-line);border-radius:18px;background:linear-gradient(180deg,var(--wp-panel),var(--wp-bg2))}
.amkwp-tl{min-width:860px;padding:12px 14px 16px;position:relative}
.amkwp-axis,.amkwp-lane{display:grid;grid-template-columns:120px 1fr;align-items:center}
.amkwp-axis .ticks{position:relative;height:22px;grid-column:2}
.amkwp-axis .ticks span{position:absolute;font:500 10.5px var(--wp-mono);color:var(--wp-mute);transform:translateX(-50%)}
.amkwp-lane{min-height:48px;border-top:1px solid var(--wp-line)}
.amkwp-lane .who{display:flex;gap:9px;align-items:center;font-weight:800;font-size:13.5px;min-width:0}
.amkwp-lane .who small{display:block;color:var(--wp-mute);font-weight:500;font-size:10.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.amkwp-lane.spezial{background:linear-gradient(90deg,rgba(242,193,78,.08),transparent 60%);border-top:0;border-radius:12px;margin-bottom:4px}
.amkwp .track{position:relative;height:48px}
.amkwp .track .grid{position:absolute;inset:0;background-image:repeating-linear-gradient(90deg,var(--wp-line) 0 1px,transparent 1px var(--stunde,6.6%));opacity:.6}
.amkwp .blk{--c:#f2c14e;position:absolute;top:7px;bottom:7px;border-radius:9px;padding:4px 8px;font-size:11px;line-height:1.2;color:#130f08;font-weight:800;overflow:hidden;background:var(--c);box-shadow:0 6px 18px -8px var(--c),inset 0 1px 0 rgba(255,255,255,.35);white-space:nowrap;text-overflow:ellipsis}
.amkwp .blk small{display:block;font:600 9.5px var(--wp-mono);opacity:.72;overflow:hidden;text-overflow:ellipsis}
.amkwp .blk.mehr{background:repeating-linear-gradient(135deg,var(--c) 0 10px,color-mix(in srgb,var(--c) 82%,#fff) 10px 20px)}
.amkwp .blk.sp{background:linear-gradient(135deg,var(--wp-hell),var(--wp-gold) 50%,var(--wp-gold2));box-shadow:0 0 0 1px rgba(255,227,154,.6),0 0 22px -2px rgba(242,193,78,.7);cursor:pointer;min-width:14px}
.amkwp .blk.sp.ganz{top:5px;bottom:auto;height:20px;padding:3px 8px;opacity:.95}
.amkwp .blk.sp.ganz small{display:none}
.amkwp .blk.sp.art-ausflug{background:linear-gradient(135deg,#bff3dd,#3ddc97 55%,#1f9a69)}
.amkwp .blk.sp.art-urlaub{background:linear-gradient(135deg,#d6f1ff,#5fc3ec 55%,#2b88b5)}
.amkwp .blk.sp.punkt{padding:4px 6px;overflow:visible}
.amkwp .blk.frei{background:transparent;border:1px dashed var(--wp-line2);color:var(--wp-mute);box-shadow:none}
.amkwp-jetztlinie{position:absolute;top:28px;bottom:12px;width:2px;margin-left:-1px;background:var(--wp-rot);box-shadow:0 0 12px var(--wp-rot);pointer-events:none;z-index:3}
.amkwp-jetztlinie::before{content:attr(data-zeit);position:absolute;top:-20px;left:50%;transform:translateX(-50%);font:700 10px var(--wp-mono);background:var(--wp-rot);color:#fff;padding:2px 6px;border-radius:999px}
.amkwp-leg{display:flex;flex-wrap:wrap;gap:8px;margin-top:12px}
.amkwp-sp-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:12px}
.amkwp .sp-karte{position:relative;background:linear-gradient(160deg,rgba(242,193,78,.1),var(--wp-panel) 45%);border:1px solid var(--wp-line2);border-radius:18px;padding:15px;display:grid;gap:8px;min-width:0;align-content:start}
.amkwp .sp-karte.art-ausflug{background:linear-gradient(160deg,rgba(61,220,151,.12),var(--wp-panel) 45%)}
.amkwp .sp-karte.art-urlaub{background:linear-gradient(160deg,rgba(95,195,236,.12),var(--wp-panel) 45%)}
.amkwp .sp-karte.vorbei{opacity:.5}
.amkwp .sp-karte .datum{display:flex;align-items:baseline;gap:10px}
.amkwp .sp-karte .tg{font-family:var(--wp-disp);font-size:36px;line-height:.9;color:var(--wp-hell)}
.amkwp .sp-karte .mon{font:700 10.5px var(--wp-mono);letter-spacing:.12em;text-transform:uppercase;color:var(--wp-fg2)}
.amkwp .sp-karte .uhr{margin-left:auto;font:700 12.5px var(--wp-mono);color:var(--wp-gold)}
.amkwp .sp-karte h4{font-size:16px;font-weight:800;overflow-wrap:anywhere}
.amkwp .sp-karte p{margin:0;color:var(--wp-fg2);font-size:12.5px;overflow-wrap:anywhere}
.amkwp .sp-karte .fuss{display:flex;gap:8px;align-items:center;flex-wrap:wrap}
.amkwp .sp-karte .werkzeug{margin-left:auto;display:flex;gap:6px}
.amkwp .art{display:inline-block;font:800 9.5px var(--wp-mono);letter-spacing:.1em;text-transform:uppercase;padding:3px 8px;border-radius:999px;border:1px solid var(--wp-line2);color:var(--wp-fg2)}
.amkwp-countdown{font:700 11.5px var(--wp-mono);color:var(--wp-hell);font-variant-numeric:tabular-nums}
.amkwp-mx{border-collapse:collapse;width:100%;min-width:940px;font-size:12.5px}
.amkwp-mx th,.amkwp-mx td{border-bottom:1px solid var(--wp-line);padding:8px;text-align:left;vertical-align:top}
.amkwp-mx thead th{font:700 10.5px var(--wp-mono);letter-spacing:.1em;text-transform:uppercase;color:var(--wp-mute)}
.amkwp-mx thead th.heute{color:var(--wp-gold)}
.amkwp-mx tbody th{font-weight:800;white-space:nowrap;color:var(--wp-fg2)}
.amkwp-mx tr.sp th{color:var(--wp-gold)}
.amkwp-mx td .amkwp-chip{margin:0 4px 4px 0}
.amkwp-mx .t{display:block;font:500 10.5px var(--wp-mono);color:var(--wp-mute);margin:-2px 0 6px 2px}
.amkwp-mx .strich{color:var(--wp-line2)}
.amkwp-people{display:grid;grid-template-columns:repeat(auto-fill,minmax(190px,1fr));gap:12px}
.amkwp .pc{--c:#f2c14e;background:var(--wp-panel);border:1px solid var(--wp-line);border-radius:18px;padding:15px;position:relative;overflow:hidden}
.amkwp .pc::after{content:"";position:absolute;right:-30px;top:-30px;width:110px;height:110px;border-radius:50%;background:radial-gradient(circle,color-mix(in srgb,var(--c) 30%,transparent),transparent 70%);pointer-events:none}
.amkwp .pc .n{display:flex;align-items:center;gap:10px;font-family:var(--wp-disp);font-size:24px;letter-spacing:.03em;text-transform:uppercase}
.amkwp .pc .amkwp-ava{width:32px;height:32px;font-size:12px;border-radius:10px}
.amkwp .pc .h{font:700 12.5px var(--wp-mono);color:var(--wp-gold);margin-top:8px}
.amkwp .pc .bar{height:6px;border-radius:999px;background:var(--wp-line);margin:8px 0 10px;overflow:hidden}
.amkwp .pc .bar i{display:block;height:100%;background:var(--c)}
.amkwp .pc ul{margin:0;padding-left:16px;color:var(--wp-fg2);font-size:12px;display:grid;gap:2px}
.amkwp-stand{display:grid;gap:10px}
.amkwp-stand .eintrag{position:relative;display:grid;grid-template-columns:auto 1fr;gap:14px;align-items:start;background:var(--wp-panel);border:1px solid var(--wp-line);border-radius:16px;padding:13px 15px}
.amkwp-stand .tag{font:800 9.5px var(--wp-mono);text-transform:uppercase;letter-spacing:.1em;padding:4px 8px;border-radius:999px;white-space:nowrap;justify-self:start}
.amkwp-stand .tag.ok{background:var(--wp-gold);color:#130f08}.amkwp-stand .tag.live{background:var(--wp-gruen);color:#06210f}
.amkwp-stand .tag.bau{border:1px solid var(--wp-gold);color:var(--wp-gold)}.amkwp-stand .tag.auf,.amkwp-stand .tag.offen{border:1px solid var(--wp-line2);color:var(--wp-fg2)}
.amkwp-stand p{margin:0;color:var(--wp-fg2);max-width:80ch;font-size:13.5px}
.amkwp-stand p b{display:block;color:var(--wp-fg);margin-bottom:2px}
.amkwp .nur-edit{display:none}
.amkwp-bearbeiten .nur-edit{display:inline-flex}
.amkwp-bearbeiten .amkwp-fix .nur-edit{display:grid}
.amkwp-mini{position:absolute;top:8px;right:8px}
.amkwp-bearbeiten .blk:not(.frei):not(.sp){cursor:pointer;outline:1px dashed rgba(255,255,255,.35);outline-offset:-1px}
.amkwp-bearbeiten .track{cursor:copy}
.amkwp-bearbeiten .amkwp-lane .who{cursor:pointer}
.amkwp-editor{position:fixed;inset:0;z-index:100000;display:grid;place-items:center;padding:16px;background:rgba(5,4,6,.72);backdrop-filter:blur(6px)}
.amkwp-editor[hidden]{display:none}
.amkwp-ed{width:min(580px,100%);max-height:calc(100dvh - 32px);overflow:auto;background:linear-gradient(170deg,#1d1810,#15120e 40%);border:1px solid #b8862a;border-radius:22px;padding:18px;display:grid;gap:12px;color:#f4ecdc;box-shadow:0 40px 120px -30px rgba(0,0,0,.95)}
.amkwp-ed-kopf{display:flex;align-items:center;gap:10px}
.amkwp-ed-kopf h3{flex:1;margin:0;font-family:"Anton","Bebas Neue","Impact",sans-serif;font-weight:400;font-size:22px;letter-spacing:.03em;text-transform:uppercase}
.amkwp-ed-zu{width:36px;height:36px;border-radius:10px;border:1px solid #3a3123;background:#100e0c;cursor:pointer;font-size:18px;color:#f4ecdc}
.amkwp-felder{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}
.amkwp-feld{display:grid;gap:5px;font-size:12px;font-weight:700;color:#c9bea8;min-width:0}
.amkwp-feld.ganz{grid-column:1/-1}
.amkwp-feld input,.amkwp-feld select,.amkwp-feld textarea{width:100%;min-width:0;background:#100e0c;border:1px solid #3a3123;border-radius:10px;padding:9px 11px;color:#f4ecdc;font:500 16px system-ui,-apple-system,sans-serif}
.amkwp-feld input:focus,.amkwp-feld select:focus,.amkwp-feld textarea:focus{outline:none;border-color:#f2c14e}
.amkwp-feld input[type=color]{padding:2px;height:42px}
.amkwp-feld textarea{resize:vertical;min-height:64px}
.amkwp-haken{display:flex;flex-wrap:wrap;gap:6px}
.amkwp-haken label{display:inline-flex;align-items:center;white-space:nowrap;padding:5px 10px;border:1px solid #3a3123;border-radius:999px;font-size:12px;font-weight:700;cursor:pointer;background:#100e0c;color:#c9bea8;user-select:none}
.amkwp-haken label:has(input:checked){border-color:#f2c14e;background:rgba(242,193,78,.15);color:#ffe39a}
.amkwp-haken input{position:absolute;opacity:0;width:1px;height:1px;pointer-events:none}
.amkwp-haken label:has(input:focus-visible){outline:2px solid #f2c14e;outline-offset:2px}
.amkwp-ed-knoepfe{display:flex;gap:8px;justify-content:flex-end;flex-wrap:wrap}
.amkwp-ed-knoepfe .links{margin-right:auto}
.amkwp-fehler{color:#ff6b6b;font-size:13px}
@media (max-width:900px){.amkwp-hero{grid-template-columns:1fr}.amkwp-nav{width:100%}.amkwp-nav span{min-width:0;flex:1}}
@media (max-width:560px){.amkwp-tage{grid-template-columns:repeat(7,minmax(44px,1fr));overflow-x:auto}.amkwp-felder{grid-template-columns:1fr}.amkwp-stand .eintrag{grid-template-columns:1fr}.amkwp .sp-karte .werkzeug{margin-left:0}}
@media (prefers-reduced-motion:reduce){.amkwp-puls{animation:none}}`;
    document.head.appendChild(st);
  }

  /* ---------- Einhängen: ersetzt den alten Kalender ---------- */
  function wurzel() {
    const view = byId("amkzCalendarView"); if (!view) return null;
    let r = byId("amkwpRoot");
    if (!r) { r = document.createElement("div"); r.id = "amkwpRoot"; view.prepend(r); }
    // Alles Alte im Kalender-Bereich ausblenden (Monatsraster, Einladungen, Urlaub-Knopf)
    Array.prototype.forEach.call(view.children, (k) => { if (k !== r) k.style.display = "none"; });
    return r;
  }
  stil();   // sofort: enthält auch die Stile der aufgeräumten Stream-Zentrale
  AMKZ.wochenplan = { neuLaden: () => laden(true) };
  const prevLV = AMKZ.loadView;
  AMKZ.loadView = async function wochenplanChain(v, o) {
    const r = await prevLV?.call(this, v, o);
    if (v === "calendar") {
      S.root = wurzel(); if (!S.root) return r;
      stil();
      if (!S.woche) { S.woche = montag(new Date()); S.tag = wochentag(new Date()); /* Nachtschicht 31.10.: öffnet immer auf heute (gemerkter Wochentag war tagealt) */ }
      if (!S.root.querySelector("#amkwpTl")) { S.root.innerHTML = '<div class="amkwp"><div class="amkwp-leer" style="padding:30px">Kalender lädt …</div></div>'; await laden(); }
      else laden(true);
      clearInterval(S.timer);
      S.timer = setInterval(() => { if (document.hidden) return; live(); laden(true); }, 45000);
    } else clearInterval(S.timer);
    return r;
  };
})();
;(function(){if(window.__amkDeFmt)return;window.__amkDeFmt=1;var ST={paid:"bezahlt",pending:"offen",open:"offen",sent:"versendet",issued:"gestellt",draft:"Entwurf",cancelled:"storniert",received:"erhalten",completed:"erledigt",confirmed:"bestätigt",rejected:"abgelehnt"};function kopf(e){var tb=e.closest("table");var h=tb&&tb.tHead&&tb.tHead.rows[0]&&tb.tHead.rows[0].cells[e.cellIndex];return h?h.textContent:""}function fix(root){if(!root||!root.querySelectorAll)return;var els=root.matches&&root.matches("td,.amkz-status-pill")?[root]:root.querySelectorAll("td,.amkz-status-pill");for(var i=0;i<els.length;i++){var e=els[i];if(e.children.length||e.isContentEditable)continue;var t=e.textContent.trim();var m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(t);if(m){e.textContent=m[3]+"."+m[2]+"."+m[1];continue}var k=t.toLowerCase();if(ST[k]&&(e.classList.contains("amkz-status-pill")||(e.tagName==="TD"&&/status/i.test(kopf(e)))))e.textContent=ST[k]}}function start(){fix(document.body);new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){var mu=ms[i];if(mu.type==="characterData"){fix(mu.target.parentElement);continue}for(var j=0;j<mu.addedNodes.length;j++){var n=mu.addedNodes[j];fix(n.nodeType===1?n:n.parentElement)}}}).observe(document.body,{childList:true,subtree:true,characterData:true})}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",start):start()})();
/* NACHTSCHICHT-AMK 31.10.2026 (Arbeiter gjj): deutsche Namen für Bereiche und Rollen in Online-Listen */
;(function(){var N={dashboard:"Dashboard",ftdbilanz:"FTD-Bilanz",daily:"Tagesanalyse",entries:"Einträge",finance:"Finanzen",partners:"Partner & Casinos",webseiten:"Webseiten",dashboards:"Affiliate-Dashboards",metaspins:"Meta Spins Auslosung",halloween:"Halloween",giveaway:"Giveaway",postfach:"Postfach",support:"Anfragen",connect:"Connect",streaming:"Stream-Zentrale",team:"Team",calendar:"Kalender",verlosung:"Verlosung",bonushunt:"Bonushunt",casinos:"Casinos",admin:"Admin",manager:"Manager",employee:"Mitarbeiter",ftd:"FTD-Mitarbeiter",moderator:"Moderator"};window.__amkDeName=function(x){var k=String(x==null?"":x);return N[k.toLowerCase()]||k;};})();

/* NACHTSCHICHT-AMK 31.10.2026 (Arbeiter gjj): boot() rendert die erste Ansicht, bevor die späteren Module AMKZ.loadView einhängen.
   Folge: nach frischem Laden waren Quick Actions und die "+ …"-Knöpfe ohne Funktion, bis man einmal den Bereich gewechselt hat.
   Hier einmal nachladen, wenn noch nichts gebunden ist. */
;(function(){function nachbinden(){try{if(document.body.dataset.amkzActionBound)return;var A=window.AMKZ;if(!A||!A.state||!A.state.booted||!A.state.member||!A.state.currentView||typeof A.loadView!=="function")return;var app=document.getElementById("amkzApp");if(!app||getComputedStyle(app).display==="none")return;A.loadView(A.state.currentView,{force:false}).catch(function(e){console.error("AMK NACHBINDEN",e);});}catch(e){}}setTimeout(nachbinden,1200);setTimeout(nachbinden,4000);setTimeout(nachbinden,10000);})();
/* NACHTSCHICHT-AMK 31.10.2026 (Arbeiter gjj): Quick Actions „+ Eingang“ und „+ Termin“ hatten keinen Handler (taten nichts) */
;(function(){document.addEventListener("click",function(e){var b=e.target.closest&&e.target.closest("[data-amkz-action]");if(!b)return;var a=b.getAttribute("data-amkz-action"),M=(window.AMKZ&&AMKZ.modules)||{};try{if(a==="finance-inflow"&&M.inflows&&M.inflows.openInflowModal)M.inflows.openInflowModal();if(a==="calendar"&&M.calendar&&M.calendar.openCalendarModal)M.calendar.openCalendarModal();}catch(err){console.error("AMK QUICK ACTION",a,err);}});})();

/* NACHTSCHICHT-AMK 31.10.2026 (Arbeiter gjj): Eingänge-/Ausgänge-Listen folgten dem Zeitraum oben nicht (Rechnungen schon) – Zeilen außerhalb des Monats ausblenden, Hinweis „X von Y“. */
;(function(){function f(){var A=window.AMKZ;var sm=document.getElementById("amkzFinanceMonthTop");var m=(A&&A.state&&A.state.financeMonth)||(sm&&sm.value);["amkzInflowsTableBody","amkzExpensesTableBody"].forEach(function(id){var b=document.getElementById(id);if(!b)return;var n=0,t=0;[].forEach.call(b.rows,function(r){var c=r.cells[0];var x=c&&/^(\d{2})\.(\d{2})\.(\d{4})/.exec(c.textContent.trim());if(!x){if(r.style.display)r.style.display="";return}t++;var ok=!m||m==="all"||(x[3]+"-"+x[2])===m;var d=ok?"":"none";if(r.style.display!==d)r.style.display=d;if(ok)n++});var h=b.closest("table");if(!h||!h.parentElement)return;var note=h.parentElement.querySelector(".amkz-ns-monat");if(!note){note=document.createElement("div");note.className="amkz-ns-monat";note.style.cssText="font-size:12px;opacity:.75;margin:6px 2px";h.parentElement.insertBefore(note,h)}var txt=(m&&m!=="all"&&t)?(n+" von "+t+" Einträgen im gewählten Zeitraum"+(n===0?" – oben „Alle Zeiträume“ wählen, um alle zu sehen":"")):"";if(note.textContent!==txt)note.textContent=txt})}var q=0;function plan(){if(q)return;q=1;setTimeout(function(){q=0;try{f()}catch(_){}},80)}new MutationObserver(plan).observe(document.body,{childList:true,subtree:true});document.addEventListener("change",function(e){if(e.target&&(e.target.id==="amkzFinanceMonthTop"||e.target.id==="amkzInvoiceMonthSelect"))setTimeout(plan,200)});document.addEventListener("click",function(){setTimeout(plan,300)},true)})();
/* Nachtschicht 31.10. (#90): Browser-Tab heißt wie die App („AMK Zentrale“) statt „zentrale – nouri-amk.com“ */
(function(){if(/\/pages\/zentrale/.test(location.pathname))document.title="AMK Zentrale";})();

;/* ENTRY-BEARBEITEN 01.11.2026 (Jarvis-Arbeiter A1101-2302-jcd): Mitarbeiter bearbeiten eigene Einträge, Admin alle.
   Server: RPC amk_entry_bearbeiten / amk_entry_verlauf (Sitzung), direkte UPDATEs auf entries sind gesperrt (nur metadata).
   Rückweg: diesen Block bis Dateiende löschen und "AMKZ.__entryUpd(id, {" wieder zu "updRow(["entries"], id, {" machen (Ausgabe bearbeiten). */
(function(){"use strict";var AMKZ2=window.AMKZ;if(!AMKZ2||AMKZ2.__entryBearbeiten)return;AMKZ2.__entryBearbeiten=!0;
var ADMIN_ROLLEN=["admin","owner","admin_owner","ceo","management","manager"];
var TYPEN={FTD:"FTD",REDEPO:"ReDepo",INCOME:"Einnahme",OPERATING_EXPENSE:"Ausgabe"};
var FELD={entry_date:"Datum",entry_type:"Typ",amount:"Betrag",casino_id:"Casino",partner_group_id:"Partner",note:"Notiz",customer_name:"Kundenname",customer_email:"Kunden-E-Mail",wallet_address:"Wallet",payment_status:"Status",casino_name:"Casino-Name",deal_id:"Deal",geo:"Geo"};
var besitzer={};
function sb(){return AMKZ2.supabase}
function ich(){return AMKZ2.state&&AMKZ2.state.member||null}
function istAdmin(){var m=ich();return!!(m&&ADMIN_ROLLEN.indexOf(String(m.role||"").toLowerCase())>=0)}
function esc(v){return String(v==null?"":v).replace(/[&<>"']/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]})}
function $(id){return document.getElementById(id)}
function wert(id){var e=$(id);return e?String(e.value||"").trim():""}
function toast(t,m,a){try{AMKZ2.toast(t,m,a)}catch(e){}}
function liste(n){return AMKZ2.state&&Array.isArray(AMKZ2.state[n])?AMKZ2.state[n]:[]}
function nameVon(n,id){if(!id)return"";var r=liste(n).find(function(x){return String(x.id)===String(id)});return r?(r.name||r.title||""):""}
function inaktiv(x){var s=String(x.status||"").toLowerCase();return x.is_active===!1||s==="inactive"||s==="inaktiv"||s==="ended"}
/* 02.11.2026: Casinos nur aktiv (wie auf der Webseite) – inaktive nur, wenn ein alter Eintrag sie schon trägt */
function optionen(rows,leer,gewaehlt,nurAktiv){var a=rows.filter(function(x){return!inaktiv(x)||String(x.id)===String(gewaehlt)}),b=rows.filter(function(x){return inaktiv(x)&&String(x.id)!==String(gewaehlt)});function o(x){return'<option value="'+esc(x.id)+'"'+(String(x.id)===String(gewaehlt||"")?" selected":"")+">"+esc(x.name||x.title||"—")+"</option>"}var s=function(x,y){return String(x.name||x.title||"").localeCompare(String(y.name||y.title||""),"de")};return'<option value="">'+esc(leer)+"</option>"+a.slice().sort(s).map(o).join("")+(b.length&&!nurAktiv?'<optgroup label="Inaktiv / alt">'+b.slice().sort(s).map(o).join("")+"</optgroup>":"")}
function geld(n){return Number(n||0).toLocaleString("de-DE",{style:"currency",currency:"EUR"})}
function darf(e){if(!e||!ich())return!1;if(istAdmin())return!0;var t=String(e.entry_type||"").toUpperCase();return String(e.created_by_id||"")===String(ich().id)&&(t==="FTD"||t==="REDEPO")}
async function rpcFehler(name,args){var r=await sb().rpc(name,args);if(r.error)throw new Error(r.error.message||"Das hat nicht geklappt.");return r.data}
function sitzung(){var m=ich();if(!m||!m.session)throw new Error("Bitte einmal ab- und wieder anmelden (Sitzung fehlt).");return m.session}

/* Knopf an jeder Zeile */
function stil(){if($("amk-entry-edit-style"))return;var s=document.createElement("style");s.id="amk-entry-edit-style";s.textContent=".amk-entry-edit-btn{display:inline-flex;align-items:center;gap:5px;margin-top:6px;padding:5px 11px;min-height:32px;border-radius:999px;border:1px solid rgba(200,170,110,.45);background:rgba(200,170,110,.12);color:inherit;font-weight:700;font-size:12.5px;cursor:pointer}.amk-entry-edit-btn:hover{background:rgba(200,170,110,.24)}.amk-ee-verlauf{margin-top:14px;border-top:1px solid rgba(255,255,255,.12);padding-top:12px}.amk-ee-verlauf h4{margin:0 0 8px;font-size:14px}.amk-ee-zeile{font-size:12.5px;line-height:1.5;padding:7px 0;border-bottom:1px solid rgba(255,255,255,.07)}.amk-ee-zeile b{font-weight:800}.amk-ee-alt{text-decoration:line-through;opacity:.65}.amk-ee-warn{display:none;margin:4px 0 10px;padding:10px 12px;border-radius:10px;border:1px solid rgba(239,68,68,.5);background:rgba(239,68,68,.12);color:#fca5a5;font-weight:700;font-size:13px}.amk-ee-warn.active{display:block}.amk-ee-warn label{display:flex;gap:8px;align-items:center;margin-top:8px;cursor:pointer}.amk-ee-warn input{width:18px;height:18px}";document.head.appendChild(s)}
var laeuft=0;
async function knoepfe(){var rows=[].slice.call(document.querySelectorAll("tr[data-entry-id]")).filter(function(r){return!r.querySelector(".amk-entry-edit-btn")&&r.getAttribute("data-entry-id")});if(!rows.length||!ich()||!sb())return;var fehlt=rows.map(function(r){return r.getAttribute("data-entry-id")}).filter(function(id){return!(id in besitzer)});
liste("entries").forEach(function(e){e&&e.id&&e.created_by_id!==undefined&&(besitzer[e.id]=e)});fehlt=fehlt.filter(function(id){return!(id in besitzer)});
if(fehlt.length){try{for(var i=0;i<fehlt.length;i+=150){var r=await sb().from("entries").select("id,created_by_id,entry_type").in("id",fehlt.slice(i,i+150));(r.data||[]).forEach(function(e){besitzer[e.id]=e})}}catch(e){}}
stil();rows.forEach(function(r){var e=besitzer[r.getAttribute("data-entry-id")];if(!darf(e)||r.querySelector(".amk-entry-edit-btn"))return;var td=r.querySelector("td:last-child");if(!td)return;var b=document.createElement("button");b.type="button";b.className="amk-entry-edit-btn";b.setAttribute("data-entry-edit",e.id);b.title="Eintrag korrigieren (z. B. Missklick)";b.textContent="✎ Bearbeiten";td.appendChild(b)})}
function plan(){laeuft||(laeuft=1,setTimeout(function(){laeuft=0;knoepfe().catch(function(){})},250))}
new MutationObserver(plan).observe(document.body,{childList:!0,subtree:!0});
document.addEventListener("click",function(ev){var b=ev.target&&ev.target.closest&&ev.target.closest("[data-entry-edit]");if(!b)return;ev.preventDefault();ev.stopPropagation();oeffne(b.getAttribute("data-entry-edit"))},!0);

/* Bearbeiten-Fenster */
async function oeffne(id){var r;try{r=await sb().from("entries").select("*").eq("id",id).maybeSingle()}catch(e){}var e=r&&r.data;if(!e)return toast("Fehler","Eintrag nicht gefunden.","error");if(!darf(e))return toast("Nicht erlaubt","Du kannst nur deine eigenen FTD-/ReDepo-Einträge bearbeiten.","error");
try{AMKZ2.data&&AMKZ2.data.loadBaseData&&await AMKZ2.data.loadBaseData(!1)}catch(x){}
var admin=istAdmin(),typ=String(e.entry_type||"").toUpperCase(),meta=e.metadata||{},typen=admin?Object.keys(TYPEN):["FTD","REDEPO"];if(typen.indexOf(typ)<0)typen.push(typ);
AMKZ2.modal.open('<div class="amkz-modal"><div class="amkz-modal-header"><div><h3>Eintrag bearbeiten</h3><p>'+esc(TYPEN[typ]||typ)+" · "+esc(e.entry_date||"")+" · angelegt von "+esc(e.created_by_name||e.created_by||"—")+'</p></div><button class="amkz-modal-close" type="button" data-amkz-close-modal>×</button></div>'+
'<form id="amkEeForm" class="amkz-form-grid">'+
'<div class="amkz-form-row"><div class="amkz-input-group"><label>Datum</label><input id="amkEeDate" type="date" value="'+esc(e.entry_date||"")+'" required></div>'+
'<div class="amkz-input-group"><label>Typ</label><select id="amkEeType">'+typen.map(function(t){return'<option value="'+t+'"'+(t===typ?" selected":"")+">"+esc(TYPEN[t]||t)+"</option>"}).join("")+"</select></div></div>"+
'<div class="amkz-form-row"><div class="amkz-input-group"><label>Partner</label><select id="amkEePartner">'+optionen(liste("partners"),"Kein Partner",e.partner_group_id)+'</select></div>'+
'<div class="amkz-input-group"><label>Casino</label><select id="amkEeCasino">'+optionen(liste("casinos"),"Kein Casino",e.casino_id,!0)+"</select></div></div>"+
'<div class="amkz-input-group"><label>Deal</label><select id="amkEeDeal">'+optionen(liste("deals"),"Kein Deal",meta.deal_id)+"</select></div>"+
'<div class="amkz-form-row"><div class="amkz-input-group"><label>Betrag</label><input id="amkEeAmount" type="number" step="0.01" min="0" required value="'+esc(e.amount!=null?e.amount:"")+'"></div>'+
(admin?'<div class="amkz-input-group"><label>Status</label><select id="amkEeStatus">'+["paid","open","pending"].concat(["paid","open","pending"].indexOf(e.payment_status)<0&&e.payment_status?[e.payment_status]:[]).map(function(s){return'<option value="'+esc(s)+'"'+(s===(e.payment_status||"paid")?" selected":"")+">"+esc({paid:"Bezahlt",open:"Offen",pending:"Ausstehend"}[s]||s)+"</option>"}).join("")+"</select></div>":"")+"</div>"+
'<div class="amkz-input-group"><label>Notiz</label><textarea id="amkEeNote">'+esc(e.note||"")+"</textarea></div>"+
'<div class="amkz-form-row"><div class="amkz-input-group"><label>Kundenname</label><input id="amkEeCName" type="text" value="'+esc(e.customer_name||"")+'"></div>'+
'<div class="amkz-input-group"><label>Kunden-E-Mail</label><input id="amkEeCMail" type="email" value="'+esc(e.customer_email||"")+'"></div></div>'+
'<div class="amkz-input-group"><label>Wallet-Adresse</label><input id="amkEeWallet" type="text" value="'+esc(e.wallet_address||"")+'"></div>'+
'<div class="amkz-input-group"><label>Geo / Land</label><input id="amkEeGeo" type="text" value="'+esc(meta.geo||"")+'" placeholder="z. B. CZ, DE"></div>'+
'<div id="amkEeWarn" class="amk-ee-warn"><div id="amkEeWarnText"></div><label><input type="checkbox" id="amkEeOverride"><span>Ich habe das geprüft – trotzdem speichern</span></label></div>'+
'<div class="amkz-modal-actions"><button class="amkz-secondary-btn" type="button" data-amkz-close-modal>Abbrechen</button><button class="amkz-primary-btn" type="submit">Änderung speichern</button></div>'+
'</form><div class="amk-ee-verlauf"><h4>Änderungsverlauf</h4><div id="amkEeVerlauf">Lädt …</div></div></div>');
stil();binden(e);verlauf(e.id)}
function binden(e){var p=$("amkEePartner"),c=$("amkEeCasino"),d=$("amkEeDeal");
p&&p.addEventListener("change",function(){var pid=p.value,cs=pid?liste("casinos").filter(function(x){return x.partner_group_id===pid}):liste("casinos"),ds=pid?liste("deals").filter(function(x){return x.partner_group_id===pid}):liste("deals");c.innerHTML=optionen(cs,"Kein Casino",c.value,!0);d.innerHTML=optionen(ds,"Kein Deal","");pruefen(e)});
c&&c.addEventListener("change",function(){var cas=liste("casinos").find(function(x){return String(x.id)===c.value});cas&&cas.partner_group_id&&p&&(p.value=cas.partner_group_id);var ds=c.value?liste("deals").filter(function(x){return x.casino_id===c.value}):liste("deals");d.innerHTML=optionen(ds,"Kein Deal","");pruefen(e)});
["amkEeType","amkEeWallet","amkEeCMail"].forEach(function(id){var x=$(id);x&&x.addEventListener("change",function(){pruefen(e)})});
$("amkEeOverride")&&$("amkEeOverride").addEventListener("change",sperre);
$("amkEeForm").addEventListener("submit",function(ev){ev.preventDefault();speichern(e)});pruefen(e)}
var doppelt=!1;
function sperre(){var f=$("amkEeForm"),k=f&&f.querySelector('button[type="submit"]'),ok=!doppelt||$("amkEeOverride")&&$("amkEeOverride").checked;k&&(k.disabled=!ok,k.style.opacity=ok?"":".5")}
async function pruefen(e){doppelt=!1;var w=$("amkEeWarn"),t=$("amkEeWarnText");if(!w)return;var typ=wert("amkEeType").toUpperCase(),wallet=wert("amkEeWallet"),mail=wert("amkEeCMail").toLowerCase(),cas=wert("amkEeCasino"),txt="";
if(typ==="FTD"){try{var sel="id,customer_name,customer_email,entry_date,amount";if(wallet){var r=await sb().from("entries").select(sel).eq("entry_type","FTD").eq("wallet_address",wallet).neq("id",e.id).limit(1);r.data&&r.data.length&&(txt="⛔ Diese Wallet-Adresse wurde bereits für einen anderen FTD verwendet ("+esc(r.data[0].customer_name||r.data[0].customer_email||"")+" · "+esc(r.data[0].entry_date||"")+").")}if(!txt&&mail&&cas){var r2=await sb().from("entries").select(sel).eq("entry_type","FTD").eq("casino_id",cas).ilike("customer_email",mail).neq("id",e.id).limit(1);r2.data&&r2.data.length&&(txt="⛔ Diese E-Mail wurde für dieses Casino bereits als FTD genutzt ("+esc(r2.data[0].customer_name||"")+" · "+esc(r2.data[0].entry_date||"")+").")}}catch(x){}}
doppelt=!!txt;t.innerHTML=txt;w.classList.toggle("active",doppelt);$("amkEeOverride")&&($("amkEeOverride").checked=!1);sperre()}
async function speichern(e){var f=$("amkEeForm"),k=f.querySelector('button[type="submit"]');if(f.dataset.speichert==="1")return;
var typ=wert("amkEeType").toUpperCase(),betrag=Number(String(wert("amkEeAmount")).replace(",","."));
try{if(!wert("amkEeDate"))throw new Error("Datum fehlt.");if(!Number.isFinite(betrag))throw new Error("Betrag ist keine Zahl.");if(betrag<0)throw new Error("Ein negativer Betrag ergibt hier keinen Sinn — bitte den Typ ändern statt ein Minus zu setzen.");if(betrag===0&&(typ==="FTD"||typ==="REDEPO"))throw new Error("Ein FTD oder ReDepo über 0 € wäre keine Buchung — bitte den Betrag eintragen.");if((typ==="FTD"||typ==="REDEPO")&&!wert("amkEeCasino")&&!wert("amkEeDeal"))throw new Error("Für FTD/ReDepo muss ein Casino gewählt werden.");if(doppelt&&!($("amkEeOverride")&&$("amkEeOverride").checked))throw new Error("Doppelter FTD – bitte prüfen und bestätigen.")}catch(x){return toast("Fehler",x.message,"error")}
var daten={entry_date:wert("amkEeDate"),entry_type:typ,partner_group_id:wert("amkEePartner"),casino_id:wert("amkEeCasino"),deal_id:wert("amkEeDeal"),amount:betrag,note:$("amkEeNote")?$("amkEeNote").value:"",customer_name:wert("amkEeCName"),customer_email:wert("amkEeCMail"),wallet_address:wert("amkEeWallet"),geo:wert("amkEeGeo")};$("amkEeStatus")&&(daten.payment_status=wert("amkEeStatus"));
f.dataset.speichert="1";k&&(k.disabled=!0,k.textContent="Speichert …");
try{var neu=await rpcFehler("amk_entry_bearbeiten",{p_session:sitzung(),p_id:e.id,p_daten:daten});neu&&neu.id&&(besitzer[neu.id]=neu);AMKZ2.modal.close();toast("Gespeichert","Eintrag wurde korrigiert.");await neuLaden()}catch(x){toast("Fehler",x.message,"error")}finally{f.dataset.speichert="";k&&(k.disabled=!1,k.textContent="Änderung speichern")}}
async function neuLaden(){try{AMKZ2.data&&AMKZ2.data.loadBaseData&&await AMKZ2.data.loadBaseData(!0)}catch(x){}try{AMKZ2.loadView&&await AMKZ2.loadView(AMKZ2.state.currentView,{force:!0})}catch(x){}}
function zeigWert(k,v){if(v==null||v==="")return"—";if(k==="casino_id")return nameVon("casinos",v)||String(v).slice(0,8);if(k==="partner_group_id")return nameVon("partners",v)||String(v).slice(0,8);if(k==="deal_id")return nameVon("deals",v)||String(v).slice(0,8);if(k==="amount")return geld(v);if(k==="entry_type")return TYPEN[v]||v;if(typeof v==="object")return JSON.stringify(v);return String(v)}
function teile(a){var aus=[],alt=a.alt||{},neu=a.neu||{};(a.felder||[]).forEach(function(k){if(k==="metadata"){var ma=alt.metadata||{},mn=neu.metadata||{};Object.keys(Object.assign({},ma,mn)).forEach(function(s){JSON.stringify(ma[s])!==JSON.stringify(mn[s])&&["deal_id","geo"].indexOf(s)>=0&&aus.push([s,ma[s],mn[s]])});return}if(k==="casino_name"||k==="updated_at")return;aus.push([k,alt[k],neu[k]])});return aus.filter(function(x){return zeigWert(x[0],x[1])!==zeigWert(x[0],x[2])})}
async function verlauf(id){var box=$("amkEeVerlauf");if(!box)return;try{var rows=await rpcFehler("amk_entry_verlauf",{p_session:sitzung(),p_entry_id:id,p_limit:50})||[];box.innerHTML=rows.length?rows.map(function(a){var t=teile(a);return'<div class="amk-ee-zeile"><b>'+esc(new Date(a.created_at).toLocaleString("de-DE",{dateStyle:"short",timeStyle:"short"}))+" · "+esc(a.geaendert_von_name||(a.quelle==="direkt"?"direkt (ohne Anmeldung)":"—"))+"</b><br>"+(t.length?t.map(function(x){return esc(FELD[x[0]]||x[0])+': <span class="amk-ee-alt">'+esc(zeigWert(x[0],x[1]))+"</span> → "+esc(zeigWert(x[0],x[2]))}).join("<br>"):"Zusatzdaten geändert")+"</div>"}).join(""):'<div class="amk-ee-zeile">Noch nie geändert.</div>'}catch(x){box.textContent=x.message}}

/* Ausgaben-Bearbeiten (Finanzen) läuft jetzt auch über den Server */
AMKZ2.__entryUpd=async function(id,payload){try{var d=Object.assign({},payload);d.partner_group_id==null&&(d.partner_group_id="");d.casino_id==null&&(d.casino_id="");await rpcFehler("amk_entry_bearbeiten",{p_session:sitzung(),p_id:id,p_daten:d});return!0}catch(x){toast("Fehler",x.message,"error");return!1}};
AMKZ2.entryBearbeiten={oeffne:oeffne,verlauf:verlauf};
setTimeout(plan,800)})();


/* ============================================================================
   META SPINS AUSLOSUNG (03.11.2026)
   ----------------------------------------------------------------------------
   Neue Ziehung für das MetaSpins-Giveaway: feste Teilnehmerliste aus dem
   MetaSpins-Abgleich (nur eingetragen UND eingezahlt), eigene Ziehungen,
   eigene OBS-Quelle (halloween-live?quelle=ms). Im Overlay stehen nur
   MetaSpins-Namen; die Teilnehmerzahl dort ist in den Einstellungen festgelegt.
   Edge Function `metaspins-auslosung`, SQL zentrale/supabase-metaspins-auslosung.sql
============================================================================ */
(function () {
  "use strict";
  var AMKZ = window.AMKZ;
  if (!AMKZ || AMKZ.__metaspinsAuslosung) return;
  AMKZ.__metaspinsAuslosung = true;

  var API = window.AMK_MS_AUSLOSUNG_API || "https://cbwxgikndyyzdslmfpmo.supabase.co/functions/v1/metaspins-auslosung";
  var HUB_API = window.AMK_HUB_API || "https://cbwxgikndyyzdslmfpmo.supabase.co/functions/v1/vertrieb";
  var OBS_BASIS = "https://nouri-amk.com/pages/halloween-live";
  var byId = function (id) { return document.getElementById(id); };
  var esc = (AMKZ.utils && AMKZ.utils.escapeHtml) || function (v) { return String(v == null ? "" : v).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" }[c]; }); };
  var toast = function (t, m, ty) { (AMKZ.toast || console.log)(t, m, ty); };
  var nf = function (v) { return (Number(v) || 0).toLocaleString("de-DE"); };
  var proz = function (v) { return v.toLocaleString("de-DE", { maximumFractionDigits: v < 1 ? 2 : 1 }) + " %"; };

  var S = { st: null, tab: "teilnehmer", anmelden: false, testmodus: false, laeuft: false, edit: null };
  function token() { return localStorage.getItem("amkch_token") || ""; }
  function root() { return byId("amkzMetaspinsRoot"); }
  async function api(action, payload) {
    var res = await fetch(API, { method: "POST", headers: { "Content-Type": "application/json", "x-amk-admin": token() }, body: JSON.stringify(Object.assign({ action: action }, payload || {})) });
    var d = await res.json().catch(function () { return {}; });
    if (res.status === 401 || d.code === "UNAUTHORIZED") { S.anmelden = true; zeichne(); throw new Error("Bitte mit dem Zentrale-Passwort bestätigen."); }
    if (!res.ok || d.ok === false) throw new Error(d.error || ("Fehler " + res.status));
    return d;
  }
  async function hubLogin(email, password) {
    var res = await fetch(HUB_API, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ action: "hub_login", email: email, password: password }) });
    var d = await res.json().catch(function () { return {}; });
    if (!res.ok || d.ok === false || !d.token) throw new Error(d.error || "Anmeldung fehlgeschlagen");
    localStorage.setItem("amkch_token", d.token);
    S.anmelden = false;
  }
  function darf() { return !!(S.st && S.st.admin && S.st.admin.schreiben); }
  function cur() { return " " + esc((S.st && S.st.config.waehrung) || "$"); }

  async function laden() {
    var r = root(); if (!r) return;
    if (!S.st) r.innerHTML = '<div class="amkz-hw-leer">🎰 Lädt die Meta Spins Auslosung …</div>';
    try { S.st = await api("state", {}); S.anmelden = false; }
    catch (e) {
      if (!S.anmelden) {
        var hinweis = /ms_auslosung|Failed to fetch|404/.test(e.message)
          ? "<small>Einmalig nötig: <code>zentrale/supabase-metaspins-auslosung.sql</code> in Supabase ausführen und die Edge Function <code>metaspins-auslosung</code> deployen (Verify JWT aus).</small>" : "";
        r.innerHTML = '<div class="amkz-hw-leer">' + esc(e.message) + "<br>" + hinweis + "</div>";
        return;
      }
    }
    zeichne();
  }

  /* ---------------------------------------------------------------- Zeichnen */
  function zeichne() {
    var r = root(); if (!r) return;
    if (S.anmelden) {
      var mail = (AMKZ.state && AMKZ.state.member && AMKZ.state.member.email) || "";
      r.innerHTML = '<div class="amkz-hw-karte amkz-hw-login"><h3>🔒 Kurz bestätigen</h3><p>Die Auslosung zeigt Teilnehmer mit E-Mail. Dafür braucht es die Team-Anmeldung wie beim Casino-Hub — einmal dein Zentrale-Passwort, dann bleibt es 30 Tage.</p>' +
        '<div class="amkz-hw-reihe"><input id="amkzMsMail" type="email" placeholder="E-Mail" value="' + esc(mail) + '"><input id="amkzMsPass" type="password" placeholder="Zentrale-Passwort" autocomplete="current-password"><button type="button" class="amkz-hw-btn gold" data-ms="login">Bestätigen</button></div></div>';
      return;
    }
    var st = S.st; if (!st) return;
    var c = st.config, s = st.stats, summe = c.prizes.reduce(function (a, p) { return a + (Number(p.amount) || 0); }, 0);
    var kopf = '<div class="amkz-hw-kopf"><div class="amkz-hw-kopf-l"><span class="amkz-hw-kuerbis">🎰</span><div><h2>Meta Spins Auslosung</h2><p>' +
      (darf() ? "Nur Spieler, die eingetragen und bei MetaSpins wirklich eingezahlt haben. Im Overlay stehen nur die MetaSpins-Namen." : "Nur Einsicht — Ziehen und Ändern dürfen Leitung, Finanzen und Team-Verwaltung.") + "</p></div></div>" +
      '<button type="button" class="amkz-hw-btn" data-ms="neu">↻ Aktualisieren</button></div>';
    var kacheln = '<div class="amkz-hw-kacheln">' +
      kachel("Tickets im Topf", nf(s.tickets), "nur aktive Teilnehmer") +
      kachel("Teilnehmer (echt)", nf(s.teilnehmer), nf(s.gesamt) + " in der Liste") +
      kachel("Teilnehmer im Overlay", nf(c.anzeige_teilnehmer || s.teilnehmer), c.anzeige_teilnehmer ? "fest eingestellt" : "= echte Zahl") +
      kachel("Preise", nf(summe) + cur(), c.prizes.length + " Plätze") + "</div>";
    var tabs = '<div class="amkz-hw-tabs">' + [["teilnehmer", "👥 Teilnehmer"], ["ziehung", "🎲 Live-Ziehung"], ["einstellungen", "⚙️ Einstellungen"]].map(function (t) {
      return '<button type="button" class="amkz-hw-tab' + (S.tab === t[0] ? " on" : "") + '" data-ms-tab="' + t[0] + '">' + t[1] + "</button>";
    }).join("") + "</div>";
    var inhalt = S.tab === "einstellungen" ? einstellungen(c) : S.tab === "ziehung" ? ziehung(c) : teilnehmer(c);
    r.innerHTML = kopf + kacheln + tabs + '<div class="amkz-hw-inhalt">' + inhalt + "</div>";
    if (S.tab === "einstellungen") summeZeigen();
  }
  function kachel(t, w, sub) { return '<div class="amkz-hw-kachel"><span>' + t + "</span><b>" + w + "</b>" + (sub ? "<small>" + sub + "</small>" : "") + "</div>"; }

  function gezogenIds() {
    var m = {};
    (S.st.draws || []).forEach(function (d) { if (!!d.is_test === S.testmodus && d.status !== "ungueltig") m[d.teilnehmer_id] = d; });
    return m;
  }
  function teilnehmer(c) {
    var tn = S.st.teilnehmer || [], total = S.st.stats.tickets || 0, ro = darf() ? "" : " disabled", gez = gezogenIds();
    var form = "";
    if (S.edit && darf()) {
      var t = S.edit === "neu" ? { id: "", email: "", name: "", metaspins_name: "", tickets: 0, notiz: "" } : tn.find(function (x) { return x.id === S.edit; });
      if (t) form = '<div class="amkz-hw-karte"><h3>' + (t.id ? "✎ Teilnehmer bearbeiten" : "+ Teilnehmer hinzufügen") + "</h3><div class=\"amkz-hw-form\">" +
        feld("MetaSpins-Name (steht im Overlay)", '<input id="msTnMs" value="' + esc(t.metaspins_name) + '">') +
        feld("Name (nur Zentrale)", '<input id="msTnName" value="' + esc(t.name || "") + '">') +
        feld("E-Mail (nur Zentrale)", '<input id="msTnMail" type="email" value="' + esc(t.email) + '">') +
        feld("Tickets", '<input id="msTnTickets" type="number" min="0" value="' + esc(t.tickets) + '">') +
        feld("Notiz", '<input id="msTnNotiz" value="' + esc(t.notiz || "") + '">', true) +
        '</div><div class="amkz-hw-reihe"><button type="button" class="amkz-hw-btn" data-ms="abbrechen">Abbrechen</button><span class="amkz-hw-platz"></span><button type="button" class="amkz-hw-btn gold" data-ms="tn-speichern" data-id="' + esc(t.id) + '">💾 Speichern</button></div></div>';
    }
    return form + '<div class="amkz-hw-karte"><div class="amkz-hw-reihe"><h3 style="margin:0">👥 Teilnehmer <small>' + nf(S.st.stats.teilnehmer) + " aktiv · " + nf(total) + " Tickets</small></h3><span class=\"amkz-hw-platz\"></span>" +
      (darf() ? '<button type="button" class="amkz-hw-btn" data-ms="tn-neu">+ Teilnehmer</button>' : "") + '<button type="button" class="amkz-hw-btn" data-ms="csv">⬇ CSV</button></div>' +
      '<p class="amkz-hw-fein">Grundlage: MetaSpins-Abgleich vom 03.11. Tickets = eingetragen, höchstens so viel wie wirklich eingezahlt. Haken raus = nimmt nicht an der Ziehung teil. Die E-Mail sieht nur die Zentrale.</p>' +
      '<div class="amkz-hw-scroll"><table class="amkz-hw-tab-l"><thead><tr><th>Dabei</th><th>MetaSpins-Name</th><th>Name</th><th>E-Mail</th><th class="r">Eingetragen</th><th class="r">Eingezahlt</th><th class="r">Tickets</th><th class="r">Chance</th><th></th></tr></thead><tbody>' +
      tn.map(function (t) {
        var an = t.aktiv !== false && Number(t.tickets) > 0, d = gez[t.id];
        return "<tr" + (an ? "" : ' style="opacity:.45"') + '><td><label class="amkz-hw-schalter"><input type="checkbox" data-ms-aktiv="' + esc(t.id) + '"' + (t.aktiv !== false ? " checked" : "") + ro + "><i></i></label></td>" +
          "<td><b>" + esc(t.metaspins_name) + "</b>" + (d ? ' <span class="amkz-hw-pill ' + (d.status === "bestaetigt" ? "gruen" : "gold") + '">Platz ' + d.place + (d.status === "abwesend" ? " · abwesend" : "") + "</span>" : "") + "</td>" +
          "<td>" + esc(t.name || "—") + "</td><td>" + esc(t.email) + (t.notiz ? '<br><small class="amkz-hw-fein">' + esc(t.notiz) + "</small>" : "") + "</td>" +
          '<td class="r">' + nf(t.eingetragen) + cur() + '</td><td class="r">' + nf(t.eingezahlt) + cur() + '</td><td class="r"><b>' + nf(t.tickets) + '</b></td><td class="r">' + (an && total ? proz(t.tickets / total * 100) : "—") + "</td>" +
          "<td>" + (darf() ? '<button type="button" class="amkz-hw-x" data-ms-edit="' + esc(t.id) + '" title="Bearbeiten">✎</button>' : "") + "</td></tr>";
      }).join("") + "</tbody></table></div></div>";
  }
  function feld(lab, html, breit) { return '<label class="amkz-hw-feld' + (breit ? " breit" : "") + '"><span>' + lab + "</span>" + html + "</label>"; }

  function einstellungen(c) {
    var ro = darf() ? "" : " disabled";
    return '<div class="amkz-hw-karte"><h3>⚙️ Einstellungen</h3><div class="amkz-hw-form">' +
      feld("Titel im Overlay", '<input id="msTitel" value="' + esc(c.titel) + '"' + ro + ">", true) +
      feld("Währung", '<input id="msWaehrung" value="' + esc(c.waehrung) + '"' + ro + ">") +
      feld("Teilnehmer im Overlay", '<input id="msAnzeige" type="number" min="0" value="' + esc(c.anzeige_teilnehmer || "") + '" placeholder="leer = echte Zahl"' + ro + ">") +
      "</div><p class=\"amkz-hw-fein\">„Teilnehmer im Overlay“ ist nur die Zahl unten in der OBS-Quelle. Gezogen wird immer aus den echten Teilnehmern im Reiter 👥.</p>" +
      '<h4>💰 Preise</h4><div class="amkz-hw-preisedit" id="msPreise">' + c.prizes.map(preisZeile).join("") + "</div>" +
      (darf() ? '<div class="amkz-hw-reihe"><button type="button" class="amkz-hw-btn" data-ms="preis+">+ Platz</button><span class="amkz-hw-fein" id="msSumme"></span><span class="amkz-hw-platz"></span><button type="button" class="amkz-hw-btn gold" data-ms="speichern">💾 Speichern</button></div>' : "") + "</div>";
  }
  function preisZeile(p) { return '<div class="amkz-hw-preis"><span>Platz</span><input type="number" class="msPlatz" min="1" value="' + esc(p.place) + '"><input type="number" class="msBetrag" min="0" value="' + esc(p.amount) + '"><button type="button" class="amkz-hw-x" data-ms="preis-">✕</button></div>'; }
  function summeZeigen() { var s = 0; document.querySelectorAll("#msPreise .msBetrag").forEach(function (i) { s += Number(i.value) || 0; }); var el = byId("msSumme"); if (el) el.textContent = "Summe: " + nf(s) + cur(); }

  function ziehung(c) {
    var draws = (S.st.draws || []).filter(function (d) { return !!d.is_test === S.testmodus; });
    var offen = draws.some(function (d) { return d.status === "gezogen"; });
    var belegt = {}; draws.forEach(function (d) { if (d.status === "gezogen" || d.status === "bestaetigt") belegt[d.place] = d; });
    var frei = c.prizes.filter(function (p) { return !belegt[p.place]; });
    var naechster = frei.length ? frei[0] : null;
    var obs = OBS_BASIS + "?key=" + encodeURIComponent(c.embed_key || "") + "&quelle=ms";
    return '<div class="amkz-hw-zwei"><div class="amkz-hw-karte amkz-hw-pult"><h3>🎲 Steuerpult</h3>' +
      '<div class="amkz-hw-schalterreihe"><label class="amkz-hw-schalter"><input type="checkbox" id="msTest"' + (S.testmodus ? " checked" : "") + '><i></i><span>Testlauf (zählt nicht)</span></label>' +
      '<label class="amkz-hw-schalter"><input type="checkbox" id="msObsLive"' + (c.obs_live ? " checked" : "") + (darf() ? "" : " disabled") + '><i></i><span>OBS zeigt die Ziehung</span></label><small class="amkz-hw-obs-hinweis">schaltet sich beim Ziehen automatisch ein</small></div>' +
      '<div class="amkz-hw-verfahren"><b>🎲 Zufall</b><span>Jedes Ticket ist ein Los · ' + nf(S.st.stats.tickets) + " Tickets von " + nf(S.st.stats.teilnehmer) + " echten Teilnehmern · Platz 1 zuerst</span></div>" +
      '<div class="amkz-hw-gross">' + (naechster ? "Als Nächstes gezogen<b>Platz " + naechster.place + " · " + nf(naechster.amount) + cur() + "</b>" : "Alle Plätze vergeben 🎉") + "</div>" +
      (darf() ? '<button type="button" class="amkz-hw-btn gold riesig" data-ms="ziehen"' + (!naechster || offen || S.laeuft ? " disabled" : "") + ">" + (offen ? "Erst Anwesenheit klären" : "🎲 Platz " + (naechster ? naechster.place : "–") + " ziehen") + "</button>" : "") +
      '<p class="amkz-hw-fein">Wer gezogen wurde, ist mit allen Tickets raus. Abwesend gibt den Platz frei, dann wird er neu gezogen.</p>' +
      '<h4>📺 OBS-Browserquelle</h4><div class="amkz-hw-reihe"><input readonly value="' + esc(obs) + '" id="msObsUrl"><button type="button" class="amkz-hw-btn" data-ms="kopieren">Kopieren</button></div>' +
      '<p class="amkz-hw-fein">Eigene Quelle, nicht die alte Halloween-Quelle. 1920×1080, Hintergrund transparent. ' + (darf() ? '<a href="#" data-ms="key">Neuen Schlüssel erzeugen</a>' : "") + "</p>" +
      (S.testmodus && darf() ? '<button type="button" class="amkz-hw-btn" data-ms="testweg">🧹 Testziehungen löschen</button>' : "") + "</div>" +
      '<div class="amkz-hw-karte"><h3>🏆 Plätze ' + (S.testmodus ? '<span class="amkz-hw-pill">TEST</span>' : "") + '</h3><ol class="amkz-hw-plaetze">' +
      c.prizes.map(function (p) {
        var d = belegt[p.place];
        var weg = draws.filter(function (x) { return x.place === p.place && (x.status === "abwesend" || x.status === "ungueltig"); });
        return '<li class="' + (d ? d.status : "frei") + '"><span class="pl">#' + p.place + '</span><span class="betrag">' + nf(p.amount) + cur() + "</span>" +
          (d ? '<span class="wer"><b>' + esc(d.metaspins_name) + "</b><small>" + esc(d.email) + " · " + nf(d.tickets) + " Tickets" + (d.ticket_no ? " · Los #" + nf(d.ticket_no) + " von " + nf(d.total_tickets) : "") + "</small></span>" +
            (darf() ? (d.status === "gezogen" ? '<span class="akt"><button type="button" class="amkz-hw-btn gruen" data-ms-draw="' + d.id + '" data-st="bestaetigt">✓ Anwesend</button><button type="button" class="amkz-hw-btn" data-ms-draw="' + d.id + '" data-st="abwesend">Abwesend</button></span>'
              : '<span class="akt"><span class="amkz-hw-pill gruen">bestätigt</span><button type="button" class="amkz-hw-x" data-ms-draw="' + d.id + '" data-st="ungueltig" title="Ungültig">✕</button></span>') : "")
            : '<span class="wer frei">— frei —</span>') +
          (weg.length ? '<small class="weg">' + weg.map(function (w) { return esc(w.metaspins_name) + " (" + (w.status === "abwesend" ? "abwesend" : "ungültig") + ")"; }).join(", ") + "</small>" : "") + "</li>";
      }).join("") + "</ol></div></div>";
  }

  /* ---------------------------------------------------------------- Aktionen */
  document.addEventListener("click", async function (e) {
    var r = root(); if (!r || !r.contains(e.target)) return;
    var el = e.target.closest("[data-ms],[data-ms-tab],[data-ms-draw],[data-ms-edit]"); if (!el) return;
    try {
      if (el.dataset.msTab) { S.tab = el.dataset.msTab; S.edit = null; zeichne(); return; }
      if (el.dataset.msEdit) { S.edit = el.dataset.msEdit; zeichne(); r.scrollIntoView({ behavior: "smooth" }); return; }
      if (el.dataset.msDraw) {
        var st = el.dataset.st;
        if (st === "ungueltig" && !confirm("Ziehung ungültig setzen? Der Platz wird wieder frei und die Person kommt zurück in den Topf.")) return;
        el.disabled = true; await api("draw_status", { id: el.dataset.msDraw, status: st }); await laden(); return;
      }
      var a = el.dataset.ms, c = S.st && S.st.config;
      if (a === "login") { e.preventDefault(); await hubLogin(byId("amkzMsMail").value.trim(), byId("amkzMsPass").value); await laden(); return; }
      if (a === "neu") { await laden(); return; }
      if (a === "tn-neu") { S.edit = "neu"; zeichne(); return; }
      if (a === "abbrechen") { S.edit = null; zeichne(); return; }
      if (a === "tn-speichern") {
        var v = function (id) { return byId(id).value; };
        await api("teilnehmer_save", { teilnehmer: { id: el.dataset.id || "", metaspins_name: v("msTnMs"), name: v("msTnName"), email: v("msTnMail"), tickets: Number(v("msTnTickets")), notiz: v("msTnNotiz") } });
        toast("Meta Spins Auslosung", "Teilnehmer gespeichert."); S.edit = null; await laden(); return;
      }
      if (a === "csv") { csv(); return; }
      if (a === "speichern") {
        var prizes = []; document.querySelectorAll("#msPreise .amkz-hw-preis").forEach(function (z) { var pl = Number(z.querySelector(".msPlatz").value), b = Number(z.querySelector(".msBetrag").value); if (pl > 0) prizes.push({ place: pl, amount: b }); });
        await api("config_save", { config: { titel: byId("msTitel").value, waehrung: byId("msWaehrung").value, anzeige_teilnehmer: Number(byId("msAnzeige").value) || 0, prizes: prizes } });
        toast("Meta Spins Auslosung", "Gespeichert."); await laden(); return;
      }
      if (a === "preis+") { var box = byId("msPreise"), n = box.querySelectorAll(".amkz-hw-preis").length + 1; box.insertAdjacentHTML("beforeend", preisZeile({ place: n, amount: 0 })); summeZeigen(); return; }
      if (a === "preis-") { el.closest(".amkz-hw-preis").remove(); summeZeigen(); return; }
      if (a === "kopieren") { var i = byId("msObsUrl"); i.select(); try { await navigator.clipboard.writeText(i.value); } catch (_) { document.execCommand("copy"); } toast("OBS", "Link kopiert."); return; }
      if (a === "key") { e.preventDefault(); if (!confirm("Neuen Schlüssel erzeugen? Der alte OBS-Link hört dann auf zu funktionieren.")) return; await api("embed_key_new", {}); await laden(); return; }
      if (a === "testweg") { var t = await api("test_clear", {}); toast("Test", t.deleted + " Testziehungen gelöscht."); await laden(); return; }
      if (a === "ziehen") {
        S.laeuft = true; el.disabled = true; el.textContent = "🎲 Ziehe…";
        var d = await api("draw", { test: S.testmodus });
        toast("Gezogen", "Platz " + d.draw.place + ": " + d.draw.metaspins_name + " (" + nf(d.draw.tickets) + " Tickets)");
        S.laeuft = false; await laden(); return;
      }
    } catch (err) { S.laeuft = false; toast("Meta Spins Auslosung", err.message, "error"); if (S.st) zeichne(); }
  });
  document.addEventListener("change", async function (e) {
    var r = root(); if (!r || !r.contains(e.target)) return;
    var t = e.target;
    try {
      if (t.id === "msTest") { S.testmodus = t.checked; zeichne(); return; }
      if (t.id === "msObsLive") { await api("config_save", { config: { obs_live: t.checked } }); await laden(); return; }
      if (t.dataset && t.dataset.msAktiv) {
        if (!t.checked && !confirm("Diese Person aus der Ziehung nehmen? Ihre Tickets zählen dann nicht mehr.")) { t.checked = true; return; }
        await api("teilnehmer_save", { teilnehmer: { id: t.dataset.msAktiv, aktiv: t.checked } }); await laden(); return;
      }
    } catch (err) { toast("Meta Spins Auslosung", err.message, "error"); await laden(); }
  });
  document.addEventListener("input", function (e) { if (e.target.classList && e.target.classList.contains("msBetrag")) summeZeigen(); });

  function csv() {
    var rows = (S.st && S.st.teilnehmer) || [];
    var q = function (v) { return '"' + String(v == null ? "" : v).replace(/"/g, '""') + '"'; };
    var txt = ["Dabei;MetaSpins-Name;Name;E-Mail;Eingetragen;Eingezahlt;Tickets;Notiz"].concat(rows.map(function (t) { return [t.aktiv !== false ? "ja" : "nein", t.metaspins_name, t.name, t.email, t.eingetragen, t.eingezahlt, t.tickets, t.notiz].map(q).join(";"); })).join("\n");
    var a = document.createElement("a"); a.href = URL.createObjectURL(new Blob(["﻿" + txt], { type: "text/csv" })); a.download = "metaspins-auslosung.csv"; a.click();
  }

  var zuvor = AMKZ.loadView;
  AMKZ.loadView = async function msChain(view, options) {
    var r = await (zuvor ? zuvor.call(this, view, options) : undefined);
    if (view === "metaspins") await laden();
    return r;
  };
  AMKZ.metaspinsAuslosung = { laden: laden, api: api };
})();
